(() => {

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2482"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2482"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6r9FW", function(module, exports) {

$parcel$export(module.exports, "compile", () => $4afcc509618f7136$export$ef7acd7185315e22);
/**
* vue v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ parcelRequire("jH5uA");
var $xo6Zx = parcelRequire("xo6Zx");
var $jH5uA = parcelRequire("jH5uA");
function $4afcc509618f7136$var$initDev() {
    (0, $xo6Zx.initCustomFormatter)();
}
const $4afcc509618f7136$export$ef7acd7185315e22 = ()=>{};
$parcel$exportWildcard(module.exports, $jH5uA);

});
parcelRegister("jH5uA", function(module, exports) {

$parcel$export(module.exports, "nodeOps", () => $e5664b200d123f27$export$de4fb7f5030605d3);
$parcel$export(module.exports, "Transition", () => $e5664b200d123f27$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $e5664b200d123f27$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "useCssVars", () => $e5664b200d123f27$export$ef28b76f07940108);
$parcel$export(module.exports, "patchProp", () => $e5664b200d123f27$export$cd4aa0842d13df8b);
$parcel$export(module.exports, "defineCustomElement", () => $e5664b200d123f27$export$a00e2346eabbdbef);
$parcel$export(module.exports, "VueElement", () => $e5664b200d123f27$export$b337c1a55163dbe3);
$parcel$export(module.exports, "defineSSRCustomElement", () => $e5664b200d123f27$export$6debb2e68f212638);
$parcel$export(module.exports, "createSSRApp", () => $e5664b200d123f27$export$35800275c0037383);
$parcel$export(module.exports, "createApp", () => $e5664b200d123f27$export$4e373c34abfa8c68);
$parcel$export(module.exports, "render", () => $e5664b200d123f27$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "useHost", () => $e5664b200d123f27$export$da5acfe93a94e37d);
$parcel$export(module.exports, "useShadowRoot", () => $e5664b200d123f27$export$64d45095031fa749);
$parcel$export(module.exports, "useCssModule", () => $e5664b200d123f27$export$9300d5b90d56e3d1);
$parcel$export(module.exports, "TransitionGroup", () => $e5664b200d123f27$export$19ffa8f511f7bc2e);
$parcel$export(module.exports, "vModelText", () => $e5664b200d123f27$export$f1f88689f5728478);
$parcel$export(module.exports, "vModelCheckbox", () => $e5664b200d123f27$export$8847c2e532b35714);
$parcel$export(module.exports, "vModelRadio", () => $e5664b200d123f27$export$b4356c59b38b7aa9);
$parcel$export(module.exports, "vModelSelect", () => $e5664b200d123f27$export$87d227567b51ca39);
$parcel$export(module.exports, "vModelDynamic", () => $e5664b200d123f27$export$5ad5c0e01ff62c5);
$parcel$export(module.exports, "withModifiers", () => $e5664b200d123f27$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $e5664b200d123f27$export$f691a8759658f782);
$parcel$export(module.exports, "hydrate", () => $e5664b200d123f27$export$fa8d919ba61d84db);
$parcel$export(module.exports, "initDirectivesForSSR", () => $e5664b200d123f27$export$800b28255aa678d9);
/**
* @vue/runtime-dom v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
var $gIp2w = parcelRequire("gIp2w");

var $d8ZDz = parcelRequire("d8ZDz");
let $e5664b200d123f27$var$policy = void 0;
const $e5664b200d123f27$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($e5664b200d123f27$var$tt) try {
    $e5664b200d123f27$var$policy = /* @__PURE__ */ $e5664b200d123f27$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $e5664b200d123f27$var$unsafeToTrustedHTML = $e5664b200d123f27$var$policy ? (val)=>$e5664b200d123f27$var$policy.createHTML(val) : (val)=>val;
const $e5664b200d123f27$var$svgNS = "http://www.w3.org/2000/svg";
const $e5664b200d123f27$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $e5664b200d123f27$var$doc = typeof document !== "undefined" ? document : null;
const $e5664b200d123f27$var$templateContainer = $e5664b200d123f27$var$doc && /* @__PURE__ */ $e5664b200d123f27$var$doc.createElement("template");
const $e5664b200d123f27$export$de4fb7f5030605d3 = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $e5664b200d123f27$var$doc.createElementNS($e5664b200d123f27$var$svgNS, tag) : namespace === "mathml" ? $e5664b200d123f27$var$doc.createElementNS($e5664b200d123f27$var$mathmlNS, tag) : is ? $e5664b200d123f27$var$doc.createElement(tag, {
            is: is
        }) : $e5664b200d123f27$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$e5664b200d123f27$var$doc.createTextNode(text),
    createComment: (text)=>$e5664b200d123f27$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$e5664b200d123f27$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $e5664b200d123f27$var$templateContainer.innerHTML = $e5664b200d123f27$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $e5664b200d123f27$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $e5664b200d123f27$var$TRANSITION = "transition";
const $e5664b200d123f27$var$ANIMATION = "animation";
const $e5664b200d123f27$var$vtcKey = /* @__PURE__ */ Symbol("_vtc");
const $e5664b200d123f27$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $e5664b200d123f27$var$TransitionPropsValidators = /* @__PURE__ */ (0, $d8ZDz.extend)({}, (0, $xo6Zx.BaseTransitionPropsValidators), $e5664b200d123f27$var$DOMTransitionPropsValidators);
const $e5664b200d123f27$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $e5664b200d123f27$var$TransitionPropsValidators;
    return t;
};
const $e5664b200d123f27$export$be58926105124dd4 = /* @__PURE__ */ $e5664b200d123f27$var$decorate$1((props, { slots: slots })=>(0, $xo6Zx.h)((0, $xo6Zx.BaseTransition), $e5664b200d123f27$var$resolveTransitionProps(props), slots));
const $e5664b200d123f27$var$callHook = (hook, args = [])=>{
    if ((0, $d8ZDz.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $e5664b200d123f27$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $d8ZDz.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $e5664b200d123f27$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $e5664b200d123f27$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $e5664b200d123f27$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $e5664b200d123f27$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $e5664b200d123f27$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $e5664b200d123f27$var$removeTransitionClass(el, leaveFromClass);
        $e5664b200d123f27$var$removeTransitionClass(el, leaveToClass);
        $e5664b200d123f27$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $e5664b200d123f27$var$callHook(hook, [
                el,
                resolve
            ]);
            $e5664b200d123f27$var$nextFrame(()=>{
                $e5664b200d123f27$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $e5664b200d123f27$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$e5664b200d123f27$var$hasExplicitCallback(hook)) $e5664b200d123f27$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $d8ZDz.extend)(baseProps, {
        onBeforeEnter (el) {
            $e5664b200d123f27$var$callHook(onBeforeEnter, [
                el
            ]);
            $e5664b200d123f27$var$addTransitionClass(el, enterFromClass);
            $e5664b200d123f27$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $e5664b200d123f27$var$callHook(onBeforeAppear, [
                el
            ]);
            $e5664b200d123f27$var$addTransitionClass(el, appearFromClass);
            $e5664b200d123f27$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $e5664b200d123f27$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $e5664b200d123f27$var$forceReflow(el);
                $e5664b200d123f27$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $e5664b200d123f27$var$addTransitionClass(el, leaveActiveClass);
                $e5664b200d123f27$var$forceReflow(el);
            }
            $e5664b200d123f27$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $e5664b200d123f27$var$removeTransitionClass(el, leaveFromClass);
                $e5664b200d123f27$var$addTransitionClass(el, leaveToClass);
                if (!$e5664b200d123f27$var$hasExplicitCallback(onLeave)) $e5664b200d123f27$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $e5664b200d123f27$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $e5664b200d123f27$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $e5664b200d123f27$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $e5664b200d123f27$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $e5664b200d123f27$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $d8ZDz.isObject)(duration)) return [
        $e5664b200d123f27$var$NumberOf(duration.enter),
        $e5664b200d123f27$var$NumberOf(duration.leave)
    ];
    else {
        const n = $e5664b200d123f27$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $e5664b200d123f27$var$NumberOf(val) {
    const res = (0, $d8ZDz.toNumber)(val);
    return res;
}
function $e5664b200d123f27$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$e5664b200d123f27$var$vtcKey] || (el[$e5664b200d123f27$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $e5664b200d123f27$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$e5664b200d123f27$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$e5664b200d123f27$var$vtcKey] = void 0;
    }
}
function $e5664b200d123f27$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $e5664b200d123f27$var$endId = 0;
function $e5664b200d123f27$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$e5664b200d123f27$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $e5664b200d123f27$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $e5664b200d123f27$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$e5664b200d123f27$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$e5664b200d123f27$var$TRANSITION}Duration`);
    const transitionTimeout = $e5664b200d123f27$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$e5664b200d123f27$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$e5664b200d123f27$var$ANIMATION}Duration`);
    const animationTimeout = $e5664b200d123f27$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $e5664b200d123f27$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $e5664b200d123f27$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $e5664b200d123f27$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $e5664b200d123f27$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $e5664b200d123f27$var$TRANSITION : $e5664b200d123f27$var$ANIMATION : null;
        propCount = type ? type === $e5664b200d123f27$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $e5664b200d123f27$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties(`${$e5664b200d123f27$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $e5664b200d123f27$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$e5664b200d123f27$var$toMs(d) + $e5664b200d123f27$var$toMs(delays[i])));
}
function $e5664b200d123f27$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $e5664b200d123f27$var$forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
}
function $e5664b200d123f27$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$e5664b200d123f27$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $e5664b200d123f27$var$vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
const $e5664b200d123f27$var$vShowHidden = /* @__PURE__ */ Symbol("_vsh");
const $e5664b200d123f27$export$5cb4fcdc6937d7e1 = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$e5664b200d123f27$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $e5664b200d123f27$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $e5664b200d123f27$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $e5664b200d123f27$var$setDisplay(el, false);
            });
        } else $e5664b200d123f27$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $e5664b200d123f27$var$setDisplay(el, value);
    }
};
function $e5664b200d123f27$var$setDisplay(el, value) {
    el.style.display = value ? el[$e5664b200d123f27$var$vShowOriginalDisplay] : "none";
    el[$e5664b200d123f27$var$vShowHidden] = !value;
}
function $e5664b200d123f27$var$initVShowForSSR() {
    $e5664b200d123f27$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $e5664b200d123f27$var$CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
function $e5664b200d123f27$export$ef28b76f07940108(getter) {
    const instance = (0, $xo6Zx.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$e5664b200d123f27$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $e5664b200d123f27$var$setVarsOnNode(instance.ce, vars);
        else $e5664b200d123f27$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $xo6Zx.onBeforeUpdate)(()=>{
        (0, $xo6Zx.queuePostFlushCb)(setVars);
    });
    (0, $xo6Zx.onMounted)(()=>{
        (0, $xo6Zx.watch)(setVars, (0, $d8ZDz.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $xo6Zx.onUnmounted)(()=>ob.disconnect());
    });
}
function $e5664b200d123f27$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $e5664b200d123f27$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $e5664b200d123f27$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $xo6Zx.Fragment)) vnode.children.forEach((c)=>$e5664b200d123f27$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $xo6Zx.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $e5664b200d123f27$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $e5664b200d123f27$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $d8ZDz.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$e5664b200d123f27$var$CSS_VAR_TEXT] = cssText;
    }
}
const $e5664b200d123f27$var$displayRE = /(?:^|;)\s*display\s*:/;
function $e5664b200d123f27$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $d8ZDz.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $d8ZDz.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $e5664b200d123f27$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $e5664b200d123f27$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            const value = next[key];
            if (value != null) {
                if (!$e5664b200d123f27$var$shouldPreserveTextareaResizeStyle(el, key, !(0, $d8ZDz.isString)(prev) && prev ? prev[key] : void 0, value)) $e5664b200d123f27$var$setStyle(style, key, value);
            } else $e5664b200d123f27$var$setStyle(style, key, "");
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$e5664b200d123f27$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $e5664b200d123f27$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($e5664b200d123f27$var$vShowOriginalDisplay in el) {
        if (!isCssString || prev !== next) el[$e5664b200d123f27$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$e5664b200d123f27$var$vShowHidden]) style.display = "none";
    }
}
const $e5664b200d123f27$var$semicolonRE = /[^\\];\s*$/;
const $e5664b200d123f27$var$importantRE = /\s*!important$/;
function $e5664b200d123f27$var$setStyle(style, name, val) {
    if ((0, $d8ZDz.isArray)(val)) val.forEach((v)=>$e5664b200d123f27$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) {
            if ($e5664b200d123f27$var$importantRE.test(val)) style.setProperty(name, val.replace($e5664b200d123f27$var$importantRE, ""), "important");
            else style.setProperty(name, val);
        } else {
            const prefixed = $e5664b200d123f27$var$autoPrefix(style, name);
            if ($e5664b200d123f27$var$importantRE.test(val)) style.setProperty((0, $d8ZDz.hyphenate)(prefixed), val.replace($e5664b200d123f27$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $e5664b200d123f27$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $e5664b200d123f27$var$prefixCache = {};
function $e5664b200d123f27$var$autoPrefix(style, rawName) {
    const cached = $e5664b200d123f27$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $d8ZDz.camelize)(rawName);
    if (name !== "filter" && name in style) return $e5664b200d123f27$var$prefixCache[rawName] = name;
    name = (0, $d8ZDz.capitalize)(name);
    for(let i = 0; i < $e5664b200d123f27$var$prefixes.length; i++){
        const prefixed = $e5664b200d123f27$var$prefixes[i] + name;
        if (prefixed in style) return $e5664b200d123f27$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
function $e5664b200d123f27$var$shouldPreserveTextareaResizeStyle(el, key, prev, next) {
    return el.tagName === "TEXTAREA" && (key === "width" || key === "height") && (0, $d8ZDz.isString)(next) && prev === next;
}
const $e5664b200d123f27$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $e5664b200d123f27$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $d8ZDz.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($e5664b200d123f27$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($e5664b200d123f27$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $d8ZDz.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $d8ZDz.isSymbol)(value) ? String(value) : value);
}
function $e5664b200d123f27$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $e5664b200d123f27$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $d8ZDz.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $e5664b200d123f27$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $e5664b200d123f27$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $e5664b200d123f27$var$veiKey = /* @__PURE__ */ Symbol("_vei");
function $e5664b200d123f27$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$e5664b200d123f27$var$veiKey] || (el[$e5664b200d123f27$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $e5664b200d123f27$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $e5664b200d123f27$var$createInvoker(nextValue, instance);
            $e5664b200d123f27$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $e5664b200d123f27$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $e5664b200d123f27$var$optionsModifierRE = /(Once|Passive|Capture)$/;
const $e5664b200d123f27$var$optionsModifierEventRE = /^on:?(?:Once|Passive|Capture)$/;
function $e5664b200d123f27$var$parseName(name) {
    let options;
    let m;
    while((m = name.match($e5664b200d123f27$var$optionsModifierRE)) && !$e5664b200d123f27$var$optionsModifierEventRE.test(name)){
        if (!options) options = {};
        name = name.slice(0, name.length - m[1].length);
        options[m[1].toLowerCase()] = true;
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $d8ZDz.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $e5664b200d123f27$var$cachedNow = 0;
const $e5664b200d123f27$var$p = /* @__PURE__ */ Promise.resolve();
const $e5664b200d123f27$var$getNow = ()=>$e5664b200d123f27$var$cachedNow || ($e5664b200d123f27$var$p.then(()=>$e5664b200d123f27$var$cachedNow = 0), $e5664b200d123f27$var$cachedNow = Date.now());
function $e5664b200d123f27$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        const value = invoker.value;
        if ((0, $d8ZDz.isArray)(value)) {
            const originalStop = e.stopImmediatePropagation;
            e.stopImmediatePropagation = ()=>{
                originalStop.call(e);
                e._stopped = true;
            };
            const handlers = value.slice();
            const args = [
                e
            ];
            for(let i = 0; i < handlers.length; i++){
                if (e._stopped) break;
                const handler = handlers[i];
                if (handler) (0, $xo6Zx.callWithAsyncErrorHandling)(handler, instance, 5, args);
            }
        } else (0, $xo6Zx.callWithAsyncErrorHandling)(value, instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $e5664b200d123f27$var$getNow();
    return invoker;
}
function $e5664b200d123f27$var$sanitizeEventValue(value, propName) {
    if ((0, $d8ZDz.isFunction)(value) || (0, $d8ZDz.isArray)(value)) return value;
    (0, $xo6Zx.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $d8ZDz.NOOP;
}
const $e5664b200d123f27$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $e5664b200d123f27$export$cd4aa0842d13df8b = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $e5664b200d123f27$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $e5664b200d123f27$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $d8ZDz.isOn)(key)) {
        if (!(0, $d8ZDz.isModelListener)(key)) $e5664b200d123f27$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $e5664b200d123f27$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $e5664b200d123f27$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $e5664b200d123f27$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && // #12408 check if it's declared prop or it's async custom element
    ($e5664b200d123f27$var$shouldSetAsPropForVueCE(el, key) || // @ts-expect-error _def is private
    el._def.__asyncLoader && (/[A-Z]/.test(key) || !(0, $d8ZDz.isString)(nextValue)))) $e5664b200d123f27$var$patchDOMProp(el, (0, $d8ZDz.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $e5664b200d123f27$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $e5664b200d123f27$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $e5664b200d123f27$var$isNativeOn(key) && (0, $d8ZDz.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "sandbox" && el.tagName === "IFRAME") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($e5664b200d123f27$var$isNativeOn(key) && (0, $d8ZDz.isString)(value)) return false;
    return key in el;
}
function $e5664b200d123f27$var$shouldSetAsPropForVueCE(el, key) {
    const props = // @ts-expect-error _def is private
    el._def.props;
    if (!props) return false;
    const camelKey = (0, $d8ZDz.camelize)(key);
    return Array.isArray(props) ? props.some((prop)=>(0, $d8ZDz.camelize)(prop) === camelKey) : Object.keys(props).some((prop)=>(0, $d8ZDz.camelize)(prop) === camelKey);
}
const $e5664b200d123f27$var$REMOVAL = {};
// @__NO_SIDE_EFFECTS__
function $e5664b200d123f27$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    let Comp = (0, $xo6Zx.defineComponent)(options, extraOptions);
    if ((0, $d8ZDz.isPlainObject)(Comp)) Comp = (0, $d8ZDz.extend)({}, Comp, extraOptions);
    class VueCustomElement extends $e5664b200d123f27$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $e5664b200d123f27$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $e5664b200d123f27$export$a00e2346eabbdbef(options, extraOptions, $e5664b200d123f27$export$35800275c0037383);
};
const $e5664b200d123f27$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $e5664b200d123f27$export$b337c1a55163dbe3 extends $e5664b200d123f27$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $e5664b200d123f27$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._patching = false;
        this._dirty = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._styleAnchors = /* @__PURE__ */ new WeakMap();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $e5664b200d123f27$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow((0, $d8ZDz.extend)({}, _def.shadowRootOptions, {
                mode: "open"
            }));
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && // #12479 should check assignedSlot first to get correct parent
        (parent.assignedSlot || parent.parentNode || parent.host))if (parent instanceof $e5664b200d123f27$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                if (this.isConnected) return this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $xo6Zx.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
                if (this._teleportTargets) {
                    this._teleportTargets.clear();
                    this._teleportTargets = void 0;
                }
            }
        });
    }
    _processMutations(mutations) {
        for (const m of mutations)this._setAttr(m.attributeName);
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return this._pendingResolve;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver(this._processMutations.bind(this));
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $d8ZDz.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $d8ZDz.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $d8ZDz.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            if (this._connected) this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) {
            this._pendingResolve = asyncDef().then((def)=>{
                def.configureApp = this._def.configureApp;
                resolve(this._def = def, true);
            });
            return this._pendingResolve;
        } else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $d8ZDz.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $gIp2w.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $d8ZDz.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $d8ZDz.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, !this._patching);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $e5664b200d123f27$var$REMOVAL;
        const camelKey = (0, $d8ZDz.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $d8ZDz.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            this._dirty = true;
            if (val === $e5664b200d123f27$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                if (ob) {
                    this._processMutations(ob.takeRecords());
                    ob.disconnect();
                }
                if (val === true) this.setAttribute((0, $d8ZDz.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $d8ZDz.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $d8ZDz.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $e5664b200d123f27$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $xo6Zx.createVNode)(this._def, (0, $d8ZDz.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $d8ZDz.isPlainObject)(args[0]) ? (0, $d8ZDz.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $d8ZDz.hyphenate)(event) !== event) dispatch((0, $d8ZDz.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner, parentComp) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        const root = this.shadowRoot;
        const insertionAnchor = parentComp ? this._getStyleAnchor(parentComp) || this._getStyleAnchor(this._def) : this._getRootStyleInsertionAnchor(root);
        let last = null;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            root.insertBefore(s, last || insertionAnchor);
            last = s;
            if (i === 0) {
                if (!parentComp) this._styleAnchors.set(this._def, s);
                if (owner) this._styleAnchors.set(owner, s);
            }
        }
    }
    _getStyleAnchor(comp) {
        if (!comp) return null;
        const anchor = this._styleAnchors.get(comp);
        if (anchor && anchor.parentNode === this.shadowRoot) return anchor;
        if (anchor) this._styleAnchors.delete(comp);
        return null;
    }
    _getRootStyleInsertionAnchor(root) {
        for(let i = 0; i < root.childNodes.length; i++){
            const node = root.childNodes[i];
            if (!(node instanceof HTMLStyleElement)) return node;
        }
        return null;
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = this._getSlots();
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _getSlots() {
        const roots = [
            this
        ];
        if (this._teleportTargets) roots.push(...this._teleportTargets);
        const slots = /* @__PURE__ */ new Set();
        for (const root of roots){
            const found = root.querySelectorAll("slot");
            for(let i = 0; i < found.length; i++)slots.add(found[i]);
        }
        return Array.from(slots);
    }
    /**
   * @internal
   */ _injectChildStyle(comp, parentComp) {
        this._applyStyles(comp.styles, comp, parentComp);
    }
    /**
   * @internal
   */ _beginPatch() {
        this._patching = true;
        this._dirty = false;
    }
    /**
   * @internal
   */ _endPatch() {
        this._patching = false;
        if (this._dirty && this._instance) this._update();
    }
    /**
   * @internal
   */ _hasShadowRoot() {
        return this._def.shadowRoot !== false;
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $e5664b200d123f27$export$da5acfe93a94e37d(caller) {
    const instance = (0, $xo6Zx.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $xo6Zx.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $xo6Zx.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $e5664b200d123f27$export$64d45095031fa749() {
    const el = $e5664b200d123f27$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $e5664b200d123f27$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $xo6Zx.getCurrentInstance)();
        if (!instance) return 0, $d8ZDz.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $d8ZDz.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $d8ZDz.EMPTY_OBJ;
        return mod;
    }
}
const $e5664b200d123f27$var$positionMap = /* @__PURE__ */ new WeakMap();
const $e5664b200d123f27$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $e5664b200d123f27$var$moveCbKey = /* @__PURE__ */ Symbol("_moveCb");
const $e5664b200d123f27$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
const $e5664b200d123f27$var$pendingGroups = /* @__PURE__ */ new WeakMap();
const $e5664b200d123f27$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $e5664b200d123f27$var$TransitionGroupImpl = /* @__PURE__ */ $e5664b200d123f27$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $d8ZDz.extend)({}, $e5664b200d123f27$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $xo6Zx.getCurrentInstance)();
        const state = (0, $xo6Zx.useTransitionState)();
        let prevChildren;
        let children;
        let origins;
        let moves;
        const willMove = ()=>{
            if (moves === void 0) moves = prevChildren.length > 0 && $e5664b200d123f27$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, $e5664b200d123f27$var$resolveMoveClass(props));
            return moves;
        };
        (0, $xo6Zx.onUpdated)(()=>{
            $e5664b200d123f27$var$pendingGroups.delete(instance);
            if (!willMove()) {
                prevChildren = [];
                origins = void 0;
                return;
            }
            const moveClass = $e5664b200d123f27$var$resolveMoveClass(props);
            prevChildren.forEach($e5664b200d123f27$var$callPendingCbs);
            const shift = origins && $e5664b200d123f27$var$getOriginShift(origins, instance.vnode.el);
            origins = void 0;
            prevChildren.forEach((c)=>$e5664b200d123f27$var$recordPosition(c, shift));
            const movedChildren = prevChildren.filter($e5664b200d123f27$var$applyTranslation);
            $e5664b200d123f27$var$forceReflow(instance.vnode.el);
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $e5664b200d123f27$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$e5664b200d123f27$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || e.propertyName.endsWith("transform")) {
                        el.removeEventListener("transitionend", cb);
                        el[$e5664b200d123f27$var$moveCbKey] = null;
                        $e5664b200d123f27$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $gIp2w.toRaw)(props);
            const cssTransitionProps = $e5664b200d123f27$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $xo6Zx.Fragment);
            prevChildren = [];
            moves = void 0;
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element && // Hidden v-show nodes have no previous layout box to animate from.
                !child.el[$e5664b200d123f27$var$vShowHidden]) {
                    prevChildren.push(child);
                    (0, $xo6Zx.setTransitionHooks)(child, (0, $xo6Zx.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $e5664b200d123f27$var$positionMap.set(child, $e5664b200d123f27$var$getPosition(child.el));
                }
            }
            children = slots.default ? (0, $xo6Zx.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $xo6Zx.setTransitionHooks)(child, (0, $xo6Zx.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren.length) {
                origins = $e5664b200d123f27$var$getOrigins(instance);
                $e5664b200d123f27$var$pendingGroups.set(instance, willMove);
            }
            return (0, $xo6Zx.createVNode)(tag, null, children);
        };
    }
});
const $e5664b200d123f27$export$19ffa8f511f7bc2e = $e5664b200d123f27$var$TransitionGroupImpl;
function $e5664b200d123f27$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$e5664b200d123f27$var$moveCbKey]) el[$e5664b200d123f27$var$moveCbKey]();
    if (el[$e5664b200d123f27$var$enterCbKey]) el[$e5664b200d123f27$var$enterCbKey]();
}
function $e5664b200d123f27$var$resolveMoveClass(props) {
    return props.moveClass || `${props.name || "v"}-move`;
}
function $e5664b200d123f27$var$recordPosition(c, shift) {
    $e5664b200d123f27$var$newPositionMap.set(c, $e5664b200d123f27$var$getPosition(c.el, shift));
}
function $e5664b200d123f27$var$applyTranslation(c) {
    const oldPos = $e5664b200d123f27$var$positionMap.get(c);
    const newPos = $e5664b200d123f27$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const el = c.el;
        const s = el.style;
        const rect = el.getBoundingClientRect();
        let scaleX = 1;
        let scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < 0.01) scaleX = 1;
        if (Math.abs(scaleY - 1) < 0.01) scaleY = 1;
        s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $e5664b200d123f27$var$getPosition(el, shift) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left - (shift ? shift.left : 0),
        top: rect.top - (shift ? shift.top : 0)
    };
}
function $e5664b200d123f27$var$getOrigins(instance) {
    let origins;
    for(let group = instance.parent; group; group = group.parent){
        const willMove = $e5664b200d123f27$var$pendingGroups.get(group);
        if (willMove) {
            const item = $e5664b200d123f27$var$findItem(group.vnode.el, instance.vnode.el);
            if (item) (origins || (origins = [])).push((0, $d8ZDz.extend)($e5664b200d123f27$var$getPosition(item), {
                item: item,
                willMove: willMove
            }));
        }
    }
    return origins;
}
function $e5664b200d123f27$var$findItem(root, node) {
    const container = root.nodeType === 1 ? root : root.parentNode;
    while(node && node.parentNode !== container)node = node.parentNode;
    if (node && node.nodeType === 1) return node;
}
function $e5664b200d123f27$var$getOriginShift(origins, root) {
    const origin = origins.find((o)=>o.willMove() && o.item.contains(root));
    return origin && $e5664b200d123f27$var$getPosition(origin.item, origin);
}
function $e5664b200d123f27$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$e5664b200d123f27$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $e5664b200d123f27$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $e5664b200d123f27$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $d8ZDz.isArray)(fn) ? (value)=>(0, $d8ZDz.invokeArrayFns)(fn, value) : fn;
};
function $e5664b200d123f27$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $e5664b200d123f27$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $e5664b200d123f27$var$assignKey = /* @__PURE__ */ Symbol("_assign");
const $e5664b200d123f27$var$initialValueKey = /* @__PURE__ */ Symbol("_initialValue");
function $e5664b200d123f27$var$castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, $d8ZDz.looseToNumber)(value);
    return value;
}
const $e5664b200d123f27$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        if (el.parentNode) {
            if (el.type === "text") el[$e5664b200d123f27$var$initialValueKey] = el.defaultValue.replace(/[\r\n]/g, "");
            else if (el.type === "textarea") el[$e5664b200d123f27$var$initialValueKey] = el.defaultValue.replace(/\r\n?/g, "\n");
        }
        el[$e5664b200d123f27$var$assignKey] = $e5664b200d123f27$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $e5664b200d123f27$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            el[$e5664b200d123f27$var$assignKey]($e5664b200d123f27$var$castValue(el.value, trim, castToNumber));
        });
        if (trim || castToNumber) $e5664b200d123f27$var$addEventListener(el, "change", ()=>{
            el.value = $e5664b200d123f27$var$castValue(el.value, trim, castToNumber);
        });
        if (!lazy) {
            $e5664b200d123f27$var$addEventListener(el, "compositionstart", $e5664b200d123f27$var$onCompositionStart);
            $e5664b200d123f27$var$addEventListener(el, "compositionend", $e5664b200d123f27$var$onCompositionEnd);
            $e5664b200d123f27$var$addEventListener(el, "change", $e5664b200d123f27$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value, modifiers: { trim: trim, number: number } }) {
        const newValue = value == null ? "" : value;
        const initialValue = el[$e5664b200d123f27$var$initialValueKey];
        delete el[$e5664b200d123f27$var$initialValueKey];
        if (initialValue !== void 0 && (el.type === "text" || el.type === "textarea") && el.value !== initialValue) el[$e5664b200d123f27$var$assignKey]($e5664b200d123f27$var$castValue(el.value, trim, number));
        else el.value = newValue;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$e5664b200d123f27$var$assignKey] = $e5664b200d123f27$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $d8ZDz.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        const rootNode = el.getRootNode();
        if ((rootNode instanceof Document || rootNode instanceof ShadowRoot) && rootNode.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $e5664b200d123f27$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$e5664b200d123f27$var$assignKey] = $e5664b200d123f27$var$getModelAssigner(vnode);
        $e5664b200d123f27$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $e5664b200d123f27$var$getValue(el);
            const checked = el.checked;
            const assign = el[$e5664b200d123f27$var$assignKey];
            if ((0, $d8ZDz.isArray)(modelValue)) {
                const index = (0, $d8ZDz.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $d8ZDz.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($e5664b200d123f27$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $e5664b200d123f27$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$e5664b200d123f27$var$assignKey] = $e5664b200d123f27$var$getModelAssigner(vnode);
        $e5664b200d123f27$var$setChecked(el, binding, vnode);
    }
};
function $e5664b200d123f27$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $d8ZDz.isArray)(value)) checked = (0, $d8ZDz.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $d8ZDz.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $d8ZDz.looseEqual)(value, $e5664b200d123f27$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $e5664b200d123f27$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $d8ZDz.looseEqual)(value, vnode.props.value);
        el[$e5664b200d123f27$var$assignKey] = $e5664b200d123f27$var$getModelAssigner(vnode);
        $e5664b200d123f27$var$addEventListener(el, "change", ()=>{
            el[$e5664b200d123f27$var$assignKey]($e5664b200d123f27$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$e5664b200d123f27$var$assignKey] = $e5664b200d123f27$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $d8ZDz.looseEqual)(value, vnode.props.value);
    }
};
const $e5664b200d123f27$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        el._modelValue = value;
        $e5664b200d123f27$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $d8ZDz.looseToNumber)($e5664b200d123f27$var$getValue(o)) : $e5664b200d123f27$var$getValue(o));
            const multiple = el.multiple;
            const assignedValue = multiple ? (0, $d8ZDz.isSet)(el._modelValue) ? new Set(selectedVal) : selectedVal : selectedVal[0];
            const pending = el._pendingValue = [
                multiple,
                multiple ? (0, $d8ZDz.isArray)(assignedValue) ? selectedVal.slice() : selectedVal : assignedValue
            ];
            try {
                el[$e5664b200d123f27$var$assignKey](assignedValue);
            } finally{
                (0, $xo6Zx.nextTick)(()=>{
                    if (el._pendingValue === pending) el._pendingValue = void 0;
                });
            }
        });
        el[$e5664b200d123f27$var$assignKey] = $e5664b200d123f27$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $e5664b200d123f27$var$setSelected(el, value);
    },
    beforeUpdate (el, { value: value }, vnode) {
        el._modelValue = value;
        el[$e5664b200d123f27$var$assignKey] = $e5664b200d123f27$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        const pending = el._pendingValue;
        el._pendingValue = void 0;
        if (!pending || pending[0] !== el.multiple || !$e5664b200d123f27$var$isSameSelectValue(value, pending[1], pending[0])) $e5664b200d123f27$var$setSelected(el, value);
    }
};
function $e5664b200d123f27$var$isSameSelectValue(value, assignedValue, multiple) {
    if (!multiple) return (0, $d8ZDz.looseEqual)(value, assignedValue);
    if ((0, $d8ZDz.isArray)(value)) return (0, $d8ZDz.looseEqual)(value, assignedValue);
    if ((0, $d8ZDz.isSet)(value)) {
        if (value.size !== assignedValue.length) return false;
        for (const item of assignedValue){
            if (!value.has(item)) return false;
        }
        return true;
    }
    return false;
}
function $e5664b200d123f27$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $d8ZDz.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $d8ZDz.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $e5664b200d123f27$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $d8ZDz.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $d8ZDz.looseEqual)($e5664b200d123f27$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $e5664b200d123f27$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $e5664b200d123f27$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $e5664b200d123f27$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $e5664b200d123f27$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $e5664b200d123f27$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $e5664b200d123f27$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $e5664b200d123f27$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $e5664b200d123f27$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $e5664b200d123f27$export$87d227567b51ca39;
        case "TEXTAREA":
            return $e5664b200d123f27$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $e5664b200d123f27$export$8847c2e532b35714;
                case "radio":
                    return $e5664b200d123f27$export$b4356c59b38b7aa9;
                default:
                    return $e5664b200d123f27$export$f1f88689f5728478;
            }
    }
}
function $e5664b200d123f27$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $e5664b200d123f27$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $e5664b200d123f27$var$initVModelForSSR() {
    $e5664b200d123f27$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $e5664b200d123f27$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $d8ZDz.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $e5664b200d123f27$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $d8ZDz.isArray)(value)) {
            if (vnode.props && (0, $d8ZDz.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $d8ZDz.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $e5664b200d123f27$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $e5664b200d123f27$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $e5664b200d123f27$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $e5664b200d123f27$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$e5664b200d123f27$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $e5664b200d123f27$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $e5664b200d123f27$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $e5664b200d123f27$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $e5664b200d123f27$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $d8ZDz.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $e5664b200d123f27$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $e5664b200d123f27$var$rendererOptions = /* @__PURE__ */ (0, $d8ZDz.extend)({
    patchProp: $e5664b200d123f27$export$cd4aa0842d13df8b
}, $e5664b200d123f27$export$de4fb7f5030605d3);
let $e5664b200d123f27$var$renderer;
let $e5664b200d123f27$var$enabledHydration = false;
function $e5664b200d123f27$var$ensureRenderer() {
    return $e5664b200d123f27$var$renderer || ($e5664b200d123f27$var$renderer = (0, $xo6Zx.createRenderer)($e5664b200d123f27$var$rendererOptions));
}
function $e5664b200d123f27$var$ensureHydrationRenderer() {
    $e5664b200d123f27$var$renderer = $e5664b200d123f27$var$enabledHydration ? $e5664b200d123f27$var$renderer : (0, $xo6Zx.createHydrationRenderer)($e5664b200d123f27$var$rendererOptions);
    $e5664b200d123f27$var$enabledHydration = true;
    return $e5664b200d123f27$var$renderer;
}
const $e5664b200d123f27$export$b3890eb0ae9dca99 = (...args)=>{
    $e5664b200d123f27$var$ensureRenderer().render(...args);
};
const $e5664b200d123f27$export$fa8d919ba61d84db = (...args)=>{
    $e5664b200d123f27$var$ensureHydrationRenderer().hydrate(...args);
};
const $e5664b200d123f27$export$4e373c34abfa8c68 = (...args)=>{
    const app = $e5664b200d123f27$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $e5664b200d123f27$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $d8ZDz.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $e5664b200d123f27$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $e5664b200d123f27$export$35800275c0037383 = (...args)=>{
    const app = $e5664b200d123f27$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $e5664b200d123f27$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $e5664b200d123f27$var$resolveRootNamespace(container));
    };
    return app;
};
function $e5664b200d123f27$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $e5664b200d123f27$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $d8ZDz.isHTMLTag)(tag) || (0, $d8ZDz.isSVGTag)(tag) || (0, $d8ZDz.isMathMLTag)(tag),
        writable: false
    });
}
function $e5664b200d123f27$var$injectCompilerOptionsCheck(app) {
    if ((0, $xo6Zx.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $xo6Zx.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $xo6Zx.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $xo6Zx.warn)(msg);
            }
        });
    }
}
function $e5664b200d123f27$var$normalizeContainer(container) {
    if ((0, $d8ZDz.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $e5664b200d123f27$var$ssrDirectiveInitialized = false;
const $e5664b200d123f27$export$800b28255aa678d9 = ()=>{
    if (!$e5664b200d123f27$var$ssrDirectiveInitialized) {
        $e5664b200d123f27$var$ssrDirectiveInitialized = true;
        $e5664b200d123f27$var$initVModelForSSR();
        $e5664b200d123f27$var$initVShowForSSR();
    }
};
$parcel$exportWildcard(module.exports, $xo6Zx);

});
parcelRegister("xo6Zx", function(module, exports) {

$parcel$export(module.exports, "callWithErrorHandling", () => $0645c946e5db1562$export$b22fcaf88446e9bf);
$parcel$export(module.exports, "assertNumber", () => $0645c946e5db1562$export$dfbcecb440255e4a);
$parcel$export(module.exports, "ErrorCodes", () => $0645c946e5db1562$export$10e8e1cf990558d7);
$parcel$export(module.exports, "handleError", () => $0645c946e5db1562$export$d3da1ecaf1206c58);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0645c946e5db1562$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0645c946e5db1562$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $0645c946e5db1562$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $0645c946e5db1562$export$ffb0004e005737fa);
$parcel$export(module.exports, "Text", () => $0645c946e5db1562$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Comment", () => $0645c946e5db1562$export$4d299b491347818a);
$parcel$export(module.exports, "Static", () => $0645c946e5db1562$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "pushScopeId", () => $0645c946e5db1562$export$ac020265ca2cc4cd);
$parcel$export(module.exports, "popScopeId", () => $0645c946e5db1562$export$f2dc6805dc11834e);
$parcel$export(module.exports, "withScopeId", () => $0645c946e5db1562$export$15ba313e13f3dd04);
$parcel$export(module.exports, "withCtx", () => $0645c946e5db1562$export$694b237e827a3d23);
$parcel$export(module.exports, "setBlockTracking", () => $0645c946e5db1562$export$c20bee82f26f1e27);
$parcel$export(module.exports, "withDirectives", () => $0645c946e5db1562$export$49729353e7c1e6c5);
$parcel$export(module.exports, "provide", () => $0645c946e5db1562$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $0645c946e5db1562$export$a976684a0efeb93f);
$parcel$export(module.exports, "getCurrentInstance", () => $0645c946e5db1562$export$f13e630aa3915748);
$parcel$export(module.exports, "hasInjectionContext", () => $0645c946e5db1562$export$caf6761f24fc571a);
$parcel$export(module.exports, "ssrContextKey", () => $0645c946e5db1562$export$f2549a27e18acf2d);
$parcel$export(module.exports, "useSSRContext", () => $0645c946e5db1562$export$6b1c54dc4befcda);
$parcel$export(module.exports, "watchEffect", () => $0645c946e5db1562$export$ede35fc0e5500309);
$parcel$export(module.exports, "watchPostEffect", () => $0645c946e5db1562$export$b7f27ea67102d543);
$parcel$export(module.exports, "watchSyncEffect", () => $0645c946e5db1562$export$2035654f31b0e555);
$parcel$export(module.exports, "watch", () => $0645c946e5db1562$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "Teleport", () => $0645c946e5db1562$export$76d55a0304a371f4);
$parcel$export(module.exports, "useTransitionState", () => $0645c946e5db1562$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0645c946e5db1562$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $0645c946e5db1562$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0645c946e5db1562$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0645c946e5db1562$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "createCommentVNode", () => $0645c946e5db1562$export$49553837c7236d3c);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0645c946e5db1562$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0645c946e5db1562$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0645c946e5db1562$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "cloneVNode", () => $0645c946e5db1562$export$ee4f9e12c0a92a1a);
$parcel$export(module.exports, "defineComponent", () => $0645c946e5db1562$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "useId", () => $0645c946e5db1562$export$f680877a34711e37);
$parcel$export(module.exports, "useTemplateRef", () => $0645c946e5db1562$export$83a5dbc1f35517ca);
$parcel$export(module.exports, "createVNode", () => $0645c946e5db1562$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $0645c946e5db1562$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "hydrateOnIdle", () => $0645c946e5db1562$export$8bfca283fd254627);
$parcel$export(module.exports, "hydrateOnVisible", () => $0645c946e5db1562$export$2b04cd335e660930);
$parcel$export(module.exports, "hydrateOnMediaQuery", () => $0645c946e5db1562$export$804dbb6002787b74);
$parcel$export(module.exports, "hydrateOnInteraction", () => $0645c946e5db1562$export$288f5a9b4248e114);
$parcel$export(module.exports, "defineAsyncComponent", () => $0645c946e5db1562$export$d75d499b4c16cf21);
$parcel$export(module.exports, "onUnmounted", () => $0645c946e5db1562$export$13348a43ccacfe58);
$parcel$export(module.exports, "onUpdated", () => $0645c946e5db1562$export$5876c47052fb88b1);
$parcel$export(module.exports, "isVNode", () => $0645c946e5db1562$export$3868d13f8734ae81);
$parcel$export(module.exports, "KeepAlive", () => $0645c946e5db1562$export$70eb8a58709972df);
$parcel$export(module.exports, "onActivated", () => $0645c946e5db1562$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $0645c946e5db1562$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onBeforeMount", () => $0645c946e5db1562$export$23b7aeb0d671f804);
$parcel$export(module.exports, "onBeforeUpdate", () => $0645c946e5db1562$export$ab91988a13872e4c);
$parcel$export(module.exports, "onServerPrefetch", () => $0645c946e5db1562$export$ebf0c601f267bceb);
$parcel$export(module.exports, "onRenderTriggered", () => $0645c946e5db1562$export$898295a813d662eb);
$parcel$export(module.exports, "onRenderTracked", () => $0645c946e5db1562$export$2b41f4235363e921);
$parcel$export(module.exports, "onErrorCaptured", () => $0645c946e5db1562$export$6a3a15856e50ad19);
$parcel$export(module.exports, "resolveComponent", () => $0645c946e5db1562$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $0645c946e5db1562$export$b44c564a05ca975);
$parcel$export(module.exports, "resolveDirective", () => $0645c946e5db1562$export$a1989e995cd481be);
$parcel$export(module.exports, "renderList", () => $0645c946e5db1562$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "createSlots", () => $0645c946e5db1562$export$85738f8fcd0a5430);
$parcel$export(module.exports, "renderSlot", () => $0645c946e5db1562$export$4abee4c34694ada1);
$parcel$export(module.exports, "openBlock", () => $0645c946e5db1562$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $0645c946e5db1562$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "toHandlers", () => $0645c946e5db1562$export$2fb94ff667a6a1a);
$parcel$export(module.exports, "defineProps", () => $0645c946e5db1562$export$80b33eababae110e);
$parcel$export(module.exports, "defineEmits", () => $0645c946e5db1562$export$51ecece22fc17ddc);
$parcel$export(module.exports, "defineExpose", () => $0645c946e5db1562$export$da25b65ca24b518a);
$parcel$export(module.exports, "defineOptions", () => $0645c946e5db1562$export$77e79129327f3d0d);
$parcel$export(module.exports, "defineSlots", () => $0645c946e5db1562$export$1b3acd4bb805b712);
$parcel$export(module.exports, "defineModel", () => $0645c946e5db1562$export$acd55aa037e791bb);
$parcel$export(module.exports, "withDefaults", () => $0645c946e5db1562$export$4df9c0969a9e0160);
$parcel$export(module.exports, "useSlots", () => $0645c946e5db1562$export$9203a8e84125433c);
$parcel$export(module.exports, "useAttrs", () => $0645c946e5db1562$export$75e29435042cd2ea);
$parcel$export(module.exports, "mergeDefaults", () => $0645c946e5db1562$export$ec60f47d4a8a2e7f);
$parcel$export(module.exports, "mergeModels", () => $0645c946e5db1562$export$ad4f724f587e6828);
$parcel$export(module.exports, "createPropsRestProxy", () => $0645c946e5db1562$export$7c343e855c563faa);
$parcel$export(module.exports, "withAsyncContext", () => $0645c946e5db1562$export$d6d6f7369f1fb104);
$parcel$export(module.exports, "computed", () => $0645c946e5db1562$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "version", () => $0645c946e5db1562$export$83d89fbfd8236492);
$parcel$export(module.exports, "useModel", () => $0645c946e5db1562$export$fb78bd113157f1a1);
$parcel$export(module.exports, "createRenderer", () => $0645c946e5db1562$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0645c946e5db1562$export$200524cf0d997ff0);
$parcel$export(module.exports, "Suspense", () => $0645c946e5db1562$export$74bf444e3cd11ea5);
$parcel$export(module.exports, "createElementBlock", () => $0645c946e5db1562$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0645c946e5db1562$export$42098e0eaa15c48e);
$parcel$export(module.exports, "transformVNodeArgs", () => $0645c946e5db1562$export$83beccd3afeeb809);
$parcel$export(module.exports, "guardReactiveProps", () => $0645c946e5db1562$export$1f1be0e0e384d7d2);
$parcel$export(module.exports, "mergeProps", () => $0645c946e5db1562$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createStaticVNode", () => $0645c946e5db1562$export$33a9f6dd2840e6bb);
$parcel$export(module.exports, "registerRuntimeCompiler", () => $0645c946e5db1562$export$667bb5a67822b941);
$parcel$export(module.exports, "isRuntimeOnly", () => $0645c946e5db1562$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0645c946e5db1562$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0645c946e5db1562$export$aed4979be6a60047);
$parcel$export(module.exports, "withMemo", () => $0645c946e5db1562$export$2a6d714a4d738ae);
$parcel$export(module.exports, "isMemoSame", () => $0645c946e5db1562$export$bf525184d622787c);
$parcel$export(module.exports, "warn", () => $0645c946e5db1562$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "ErrorTypeStrings", () => $0645c946e5db1562$export$795e0ad4a0e2ed30);
$parcel$export(module.exports, "devtools", () => $0645c946e5db1562$export$6922d3b3a607469e);
$parcel$export(module.exports, "setDevtoolsHook", () => $0645c946e5db1562$export$b0c258b32c26c785);
$parcel$export(module.exports, "ssrUtils", () => $0645c946e5db1562$export$a9679033567b336d);
$parcel$export(module.exports, "resolveFilter", () => $0645c946e5db1562$export$83cf26e06ea620e1);
$parcel$export(module.exports, "compatUtils", () => $0645c946e5db1562$export$dc678eddf276286e);
$parcel$export(module.exports, "DeprecationTypes", () => $0645c946e5db1562$export$22072a82865312f6);
$parcel$export(module.exports, "EffectScope", () => (parcelRequire("gIp2w")).EffectScope);
$parcel$export(module.exports, "ReactiveEffect", () => (parcelRequire("gIp2w")).ReactiveEffect);
$parcel$export(module.exports, "TrackOpTypes", () => (parcelRequire("gIp2w")).TrackOpTypes);
$parcel$export(module.exports, "TriggerOpTypes", () => (parcelRequire("gIp2w")).TriggerOpTypes);
$parcel$export(module.exports, "customRef", () => (parcelRequire("gIp2w")).customRef);
$parcel$export(module.exports, "effect", () => (parcelRequire("gIp2w")).effect);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("gIp2w")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("gIp2w")).getCurrentScope);
$parcel$export(module.exports, "getCurrentWatcher", () => (parcelRequire("gIp2w")).getCurrentWatcher);
$parcel$export(module.exports, "isProxy", () => (parcelRequire("gIp2w")).isProxy);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("gIp2w")).isReactive);
$parcel$export(module.exports, "isReadonly", () => (parcelRequire("gIp2w")).isReadonly);
$parcel$export(module.exports, "isRef", () => (parcelRequire("gIp2w")).isRef);
$parcel$export(module.exports, "isShallow", () => (parcelRequire("gIp2w")).isShallow);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("gIp2w")).markRaw);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("gIp2w")).onScopeDispose);
$parcel$export(module.exports, "onWatcherCleanup", () => (parcelRequire("gIp2w")).onWatcherCleanup);
$parcel$export(module.exports, "proxyRefs", () => (parcelRequire("gIp2w")).proxyRefs);
$parcel$export(module.exports, "reactive", () => (parcelRequire("gIp2w")).reactive);
$parcel$export(module.exports, "readonly", () => (parcelRequire("gIp2w")).readonly);
$parcel$export(module.exports, "ref", () => (parcelRequire("gIp2w")).ref);
$parcel$export(module.exports, "shallowReactive", () => (parcelRequire("gIp2w")).shallowReactive);
$parcel$export(module.exports, "shallowReadonly", () => (parcelRequire("gIp2w")).shallowReadonly);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("gIp2w")).shallowRef);
$parcel$export(module.exports, "stop", () => (parcelRequire("gIp2w")).stop);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("gIp2w")).toRaw);
$parcel$export(module.exports, "toRef", () => (parcelRequire("gIp2w")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("gIp2w")).toRefs);
$parcel$export(module.exports, "toValue", () => (parcelRequire("gIp2w")).toValue);
$parcel$export(module.exports, "triggerRef", () => (parcelRequire("gIp2w")).triggerRef);
$parcel$export(module.exports, "unref", () => (parcelRequire("gIp2w")).unref);
$parcel$export(module.exports, "camelize", () => (parcelRequire("d8ZDz")).camelize);
$parcel$export(module.exports, "capitalize", () => (parcelRequire("d8ZDz")).capitalize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("d8ZDz")).normalizeClass);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("d8ZDz")).normalizeProps);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("d8ZDz")).normalizeStyle);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("d8ZDz")).toDisplayString);
$parcel$export(module.exports, "toHandlerKey", () => (parcelRequire("d8ZDz")).toHandlerKey);
/**
* @vue/runtime-core v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $gIp2w = parcelRequire("gIp2w");

var $d8ZDz = parcelRequire("d8ZDz");
const $0645c946e5db1562$var$stack = [];
function $0645c946e5db1562$var$pushWarningContext(vnode) {
    $0645c946e5db1562$var$stack.push(vnode);
}
function $0645c946e5db1562$var$popWarningContext() {
    $0645c946e5db1562$var$stack.pop();
}
let $0645c946e5db1562$var$isWarning = false;
function $0645c946e5db1562$var$warn$1(msg, ...args) {
    if ($0645c946e5db1562$var$isWarning) return;
    $0645c946e5db1562$var$isWarning = true;
    (0, $gIp2w.pauseTracking)();
    const instance = $0645c946e5db1562$var$stack.length ? $0645c946e5db1562$var$stack[$0645c946e5db1562$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0645c946e5db1562$var$getComponentTrace();
    if (appWarnHandler) $0645c946e5db1562$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0645c946e5db1562$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0645c946e5db1562$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $gIp2w.resetTracking)();
    $0645c946e5db1562$var$isWarning = false;
}
function $0645c946e5db1562$var$getComponentTrace() {
    let currentVNode = $0645c946e5db1562$var$stack[$0645c946e5db1562$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0645c946e5db1562$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0645c946e5db1562$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0645c946e5db1562$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0645c946e5db1562$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0645c946e5db1562$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0645c946e5db1562$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0645c946e5db1562$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0645c946e5db1562$var$formatProp(key, value, raw) {
    if ((0, $d8ZDz.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $gIp2w.isRef)(value)) {
        value = $0645c946e5db1562$var$formatProp(key, (0, $gIp2w.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $d8ZDz.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $gIp2w.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0645c946e5db1562$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0645c946e5db1562$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $0645c946e5db1562$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $0645c946e5db1562$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0645c946e5db1562$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0645c946e5db1562$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $d8ZDz.isFunction)(fn)) {
        const res = $0645c946e5db1562$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $d8ZDz.isPromise)(res)) res.catch((err)=>{
            $0645c946e5db1562$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $d8ZDz.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0645c946e5db1562$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $0645c946e5db1562$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $d8ZDz.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $gIp2w.pauseTracking)();
            $0645c946e5db1562$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $gIp2w.resetTracking)();
            return;
        }
    }
    $0645c946e5db1562$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $0645c946e5db1562$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $0645c946e5db1562$var$queue = [];
let $0645c946e5db1562$var$flushIndex = -1;
const $0645c946e5db1562$var$pendingPostFlushCbs = [];
let $0645c946e5db1562$var$activePostFlushCbs = null;
let $0645c946e5db1562$var$postFlushIndex = 0;
const $0645c946e5db1562$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0645c946e5db1562$var$currentFlushPromise = null;
const $0645c946e5db1562$var$RECURSION_LIMIT = 100;
function $0645c946e5db1562$export$bdd553fddd433dcb(fn) {
    const p = $0645c946e5db1562$var$currentFlushPromise || $0645c946e5db1562$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0645c946e5db1562$var$findInsertionIndex(id) {
    let start = $0645c946e5db1562$var$flushIndex + 1;
    let end = $0645c946e5db1562$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0645c946e5db1562$var$queue[middle];
        const middleJobId = $0645c946e5db1562$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0645c946e5db1562$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $0645c946e5db1562$var$getId(job);
        const lastJob = $0645c946e5db1562$var$queue[$0645c946e5db1562$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $0645c946e5db1562$var$getId(lastJob)) $0645c946e5db1562$var$queue.push(job);
        else $0645c946e5db1562$var$queue.splice($0645c946e5db1562$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $0645c946e5db1562$var$queueFlush();
    }
}
function $0645c946e5db1562$var$queueFlush() {
    if (!$0645c946e5db1562$var$currentFlushPromise) $0645c946e5db1562$var$currentFlushPromise = $0645c946e5db1562$var$resolvedPromise.then($0645c946e5db1562$var$flushJobs);
}
function $0645c946e5db1562$export$59536a0199721cab(cb) {
    if (!(0, $d8ZDz.isArray)(cb)) {
        if ($0645c946e5db1562$var$activePostFlushCbs && cb.id === -1) $0645c946e5db1562$var$activePostFlushCbs.splice($0645c946e5db1562$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $0645c946e5db1562$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else for(let i = 0; i < cb.length; i++)$0645c946e5db1562$var$pendingPostFlushCbs.push(cb[i]);
    $0645c946e5db1562$var$queueFlush();
}
function $0645c946e5db1562$var$flushPreFlushCbs(instance, minUid, seen, i = $0645c946e5db1562$var$flushIndex + 1) {
    for(; i < $0645c946e5db1562$var$queue.length; i++){
        const cb = $0645c946e5db1562$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid || minUid !== void 0 && !(cb.id >= minUid)) continue;
            $0645c946e5db1562$var$queue.splice(i, 1);
            i = instance ? i - 1 : $0645c946e5db1562$var$flushIndex;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $0645c946e5db1562$var$flushPostFlushCbs(seen, skip, minUid = 0) {
    if ($0645c946e5db1562$var$pendingPostFlushCbs.length) {
        let cbs = $0645c946e5db1562$var$pendingPostFlushCbs;
        let kept = 0;
        if (skip) {
            cbs = [];
            for(let i = 0; i < $0645c946e5db1562$var$pendingPostFlushCbs.length; i++){
                const cb = $0645c946e5db1562$var$pendingPostFlushCbs[i];
                if (cb.i !== void 0 ? !cb.i || cb.i.uid < minUid : skip.has(cb)) $0645c946e5db1562$var$pendingPostFlushCbs[kept++] = cb;
                else cbs.push(cb);
            }
        }
        const deduped = [
            ...new Set(cbs)
        ].sort((a, b)=>$0645c946e5db1562$var$getId(a) - $0645c946e5db1562$var$getId(b));
        $0645c946e5db1562$var$pendingPostFlushCbs.length = kept;
        if ($0645c946e5db1562$var$activePostFlushCbs) {
            for(let i = 0; i < deduped.length; i++)$0645c946e5db1562$var$activePostFlushCbs.push(deduped[i]);
            return;
        }
        $0645c946e5db1562$var$activePostFlushCbs = deduped;
        for($0645c946e5db1562$var$postFlushIndex = 0; $0645c946e5db1562$var$postFlushIndex < $0645c946e5db1562$var$activePostFlushCbs.length; $0645c946e5db1562$var$postFlushIndex++){
            const cb = $0645c946e5db1562$var$activePostFlushCbs[$0645c946e5db1562$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $0645c946e5db1562$var$activePostFlushCbs = null;
        $0645c946e5db1562$var$postFlushIndex = 0;
    }
}
let $0645c946e5db1562$var$isFlushing = false;
function $0645c946e5db1562$var$flushOnAppMount(fn, minUid) {
    if ($0645c946e5db1562$var$isFlushing) {
        fn();
        return;
    }
    const queued = minUid === void 0 ? void 0 : new Set($0645c946e5db1562$var$pendingPostFlushCbs);
    fn();
    $0645c946e5db1562$var$isFlushing = true;
    try {
        $0645c946e5db1562$var$flushPreFlushCbs(void 0, minUid);
        $0645c946e5db1562$var$flushPostFlushCbs(void 0, queued, minUid);
    } finally{
        $0645c946e5db1562$var$isFlushing = false;
    }
}
const $0645c946e5db1562$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $0645c946e5db1562$var$flushJobs(seen) {
    const check = (0, $d8ZDz.NOOP);
    try {
        for($0645c946e5db1562$var$flushIndex = 0; $0645c946e5db1562$var$flushIndex < $0645c946e5db1562$var$queue.length; $0645c946e5db1562$var$flushIndex++){
            const job = $0645c946e5db1562$var$queue[$0645c946e5db1562$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $0645c946e5db1562$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $0645c946e5db1562$var$flushIndex < $0645c946e5db1562$var$queue.length; $0645c946e5db1562$var$flushIndex++){
            const job = $0645c946e5db1562$var$queue[$0645c946e5db1562$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $0645c946e5db1562$var$flushIndex = -1;
        $0645c946e5db1562$var$queue.length = 0;
        $0645c946e5db1562$var$flushPostFlushCbs(seen);
        $0645c946e5db1562$var$currentFlushPromise = null;
        if ($0645c946e5db1562$var$queue.length || $0645c946e5db1562$var$pendingPostFlushCbs.length) $0645c946e5db1562$var$flushJobs(seen);
    }
}
function $0645c946e5db1562$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $0645c946e5db1562$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $0645c946e5db1562$var$getComponentName(instance.type);
        $0645c946e5db1562$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $0645c946e5db1562$var$isHmrUpdating = false;
const $0645c946e5db1562$var$setHmrUpdating = (v1)=>{
    try {
        return $0645c946e5db1562$var$isHmrUpdating;
    } finally{
        $0645c946e5db1562$var$isHmrUpdating = v1;
    }
};
const $0645c946e5db1562$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $0645c946e5db1562$var$map = /* @__PURE__ */ new Map();
function $0645c946e5db1562$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0645c946e5db1562$var$map.get(id);
    if (!record) {
        $0645c946e5db1562$var$createRecord(id, instance.type);
        record = $0645c946e5db1562$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0645c946e5db1562$var$unregisterHMR(instance) {
    $0645c946e5db1562$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0645c946e5db1562$var$createRecord(id, initialDef) {
    if ($0645c946e5db1562$var$map.has(id)) return false;
    $0645c946e5db1562$var$map.set(id, {
        initialDef: $0645c946e5db1562$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0645c946e5db1562$var$normalizeClassComponent(component) {
    return $0645c946e5db1562$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0645c946e5db1562$var$rerender(id, newRender) {
    const record = $0645c946e5db1562$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0645c946e5db1562$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0645c946e5db1562$var$isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        $0645c946e5db1562$var$isHmrUpdating = false;
    });
}
function $0645c946e5db1562$var$reload(id, newComp) {
    const record = $0645c946e5db1562$var$map.get(id);
    if (!record) return;
    newComp = $0645c946e5db1562$var$normalizeClassComponent(newComp);
    $0645c946e5db1562$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $0645c946e5db1562$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $0645c946e5db1562$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $0645c946e5db1562$var$updateComponentDef(oldComp, newComp);
            $0645c946e5db1562$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $0645c946e5db1562$var$queueJob(()=>{
            if (!(instance.job.flags & 8)) {
                $0645c946e5db1562$var$isHmrUpdating = true;
                instance.parent.update();
                $0645c946e5db1562$var$isHmrUpdating = false;
                dirtyInstances.delete(instance);
            }
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $0645c946e5db1562$export$59536a0199721cab(()=>{
        $0645c946e5db1562$var$hmrDirtyComponents.clear();
    });
}
function $0645c946e5db1562$var$updateComponentDef(oldComp, newComp) {
    (0, $d8ZDz.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0645c946e5db1562$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0645c946e5db1562$var$devtools$1;
let $0645c946e5db1562$var$buffer = [];
let $0645c946e5db1562$var$devtoolsNotInstalled = false;
function $0645c946e5db1562$var$emit$1(event, ...args) {
    if ($0645c946e5db1562$var$devtools$1) $0645c946e5db1562$var$devtools$1.emit(event, ...args);
    else if (!$0645c946e5db1562$var$devtoolsNotInstalled) $0645c946e5db1562$var$buffer.push({
        event: event,
        args: args
    });
}
function $0645c946e5db1562$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0645c946e5db1562$var$devtools$1 = hook;
    if ($0645c946e5db1562$var$devtools$1) {
        $0645c946e5db1562$var$devtools$1.enabled = true;
        $0645c946e5db1562$var$buffer.forEach(({ event: event, args: args })=>$0645c946e5db1562$var$devtools$1.emit(event, ...args));
        $0645c946e5db1562$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0645c946e5db1562$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0645c946e5db1562$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0645c946e5db1562$var$devtoolsNotInstalled = true;
                $0645c946e5db1562$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0645c946e5db1562$var$devtoolsNotInstalled = true;
        $0645c946e5db1562$var$buffer = [];
    }
}
function $0645c946e5db1562$var$devtoolsInitApp(app, version) {
    $0645c946e5db1562$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0645c946e5db1562$export$ffb0004e005737fa,
        Text: $0645c946e5db1562$export$5f1af8db9871e1d6,
        Comment: $0645c946e5db1562$export$4d299b491347818a,
        Static: $0645c946e5db1562$export$c1b9a1d3af45b7b6
    });
}
function $0645c946e5db1562$var$devtoolsUnmountApp(app) {
    $0645c946e5db1562$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0645c946e5db1562$var$devtoolsComponentAdded = /* @__PURE__ */ $0645c946e5db1562$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0645c946e5db1562$var$devtoolsComponentUpdated = /* @__PURE__ */ $0645c946e5db1562$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0645c946e5db1562$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0645c946e5db1562$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0645c946e5db1562$var$devtoolsComponentRemoved = (component)=>{
    if ($0645c946e5db1562$var$devtools$1 && typeof $0645c946e5db1562$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0645c946e5db1562$var$devtools$1.cleanupBuffer(component)) $0645c946e5db1562$var$_devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function $0645c946e5db1562$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0645c946e5db1562$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0645c946e5db1562$var$devtoolsPerfStart = /* @__PURE__ */ $0645c946e5db1562$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0645c946e5db1562$var$devtoolsPerfEnd = /* @__PURE__ */ $0645c946e5db1562$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0645c946e5db1562$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0645c946e5db1562$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0645c946e5db1562$var$devtoolsComponentEmit(component, event, params) {
    $0645c946e5db1562$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $0645c946e5db1562$var$currentRenderingInstance = null;
let $0645c946e5db1562$var$currentScopeId = null;
function $0645c946e5db1562$var$setCurrentRenderingInstance(instance) {
    const prev = $0645c946e5db1562$var$currentRenderingInstance;
    $0645c946e5db1562$var$currentRenderingInstance = instance;
    $0645c946e5db1562$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0645c946e5db1562$export$ac020265ca2cc4cd(id) {
    $0645c946e5db1562$var$currentScopeId = id;
}
function $0645c946e5db1562$export$f2dc6805dc11834e() {
    $0645c946e5db1562$var$currentScopeId = null;
}
const $0645c946e5db1562$export$15ba313e13f3dd04 = (_id)=>$0645c946e5db1562$export$694b237e827a3d23;
function $0645c946e5db1562$export$694b237e827a3d23(fn, ctx = $0645c946e5db1562$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0645c946e5db1562$export$c20bee82f26f1e27(-1);
        const prevInstance = $0645c946e5db1562$var$setCurrentRenderingInstance(ctx);
        const prevStackSize = $0645c946e5db1562$var$blockStack.length;
        let res;
        try {
            res = fn(...args);
        } finally{
            for(let i = $0645c946e5db1562$var$blockStack.length; i > prevStackSize; i--)$0645c946e5db1562$var$closeBlock();
            $0645c946e5db1562$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0645c946e5db1562$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0645c946e5db1562$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $0645c946e5db1562$var$validateDirectiveName(name) {
    if ((0, $d8ZDz.isBuiltInDirective)(name)) $0645c946e5db1562$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0645c946e5db1562$export$49729353e7c1e6c5(vnode, directives) {
    if ($0645c946e5db1562$var$currentRenderingInstance === null) return vnode;
    const instance = $0645c946e5db1562$var$getComponentPublicInstance($0645c946e5db1562$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $d8ZDz.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $d8ZDz.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $gIp2w.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0645c946e5db1562$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $gIp2w.pauseTracking)();
            $0645c946e5db1562$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $gIp2w.resetTracking)();
        }
    }
}
function $0645c946e5db1562$export$abe1e183e22e10ad(key, value) {
    if ($0645c946e5db1562$var$currentInstance) {
        let provides = $0645c946e5db1562$var$currentInstance.provides;
        const parentProvides = $0645c946e5db1562$var$currentInstance.parent && $0645c946e5db1562$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0645c946e5db1562$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0645c946e5db1562$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0645c946e5db1562$export$f13e630aa3915748();
    if (instance || $0645c946e5db1562$var$currentApp) {
        let provides = $0645c946e5db1562$var$currentApp ? $0645c946e5db1562$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $d8ZDz.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0645c946e5db1562$export$caf6761f24fc571a() {
    return !!($0645c946e5db1562$export$f13e630aa3915748() || $0645c946e5db1562$var$currentApp);
}
const $0645c946e5db1562$export$f2549a27e18acf2d = /* @__PURE__ */ Symbol.for("v-scx");
const $0645c946e5db1562$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0645c946e5db1562$export$a976684a0efeb93f($0645c946e5db1562$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0645c946e5db1562$export$ede35fc0e5500309(effect, options) {
    return $0645c946e5db1562$var$doWatch(effect, null, options);
}
function $0645c946e5db1562$export$b7f27ea67102d543(effect, options) {
    return $0645c946e5db1562$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0645c946e5db1562$export$2035654f31b0e555(effect, options) {
    return $0645c946e5db1562$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $0645c946e5db1562$export$3db5d71bdb2d5499(source, cb, options) {
    return $0645c946e5db1562$var$doWatch(source, cb, options);
}
function $0645c946e5db1562$var$doWatch(source, cb, options = (0, $d8ZDz.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $d8ZDz.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($0645c946e5db1562$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $0645c946e5db1562$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $d8ZDz.NOOP);
            watchStopHandle.resume = (0, $d8ZDz.NOOP);
            watchStopHandle.pause = (0, $d8ZDz.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $0645c946e5db1562$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$0645c946e5db1562$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        job.i = instance;
        $0645c946e5db1562$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $0645c946e5db1562$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $gIp2w.watch)(source, cb, baseWatchOptions);
    if ($0645c946e5db1562$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $0645c946e5db1562$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $d8ZDz.isString)(source) ? source.includes(".") ? $0645c946e5db1562$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $d8ZDz.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0645c946e5db1562$var$setCurrentInstance(this);
    const res = $0645c946e5db1562$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0645c946e5db1562$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
const $0645c946e5db1562$var$pendingMounts = /* @__PURE__ */ new WeakMap();
const $0645c946e5db1562$var$TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
const $0645c946e5db1562$var$isTeleport = (type)=>type.__isTeleport;
const $0645c946e5db1562$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0645c946e5db1562$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $0645c946e5db1562$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0645c946e5db1562$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0645c946e5db1562$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $d8ZDz.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $0645c946e5db1562$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment, parentNode: parentNode } } = internals;
        const disabled = $0645c946e5db1562$var$isTeleportDisabled(n2.props);
        let { dynamicChildren: dynamicChildren } = n2;
        const mount = (vnode, container2, anchor2)=>{
            if (vnode.shapeFlag & 16) mountChildren(vnode.children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        };
        const mountToTarget = (vnode = n2)=>{
            const disabled2 = $0645c946e5db1562$var$isTeleportDisabled(vnode.props);
            const target = vnode.target = $0645c946e5db1562$var$resolveTarget(vnode.props, querySelector);
            const targetAnchor = $0645c946e5db1562$var$prepareAnchor(target, vnode, createText, insert);
            if (target) {
                if (namespace !== "svg" && $0645c946e5db1562$var$isTargetSVG(target)) namespace = "svg";
                else if (namespace !== "mathml" && $0645c946e5db1562$var$isTargetMathML(target)) namespace = "mathml";
                if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                if (!disabled2) {
                    mount(vnode, target, targetAnchor);
                    $0645c946e5db1562$var$updateCssVars(vnode, false);
                }
            }
        };
        const queuePendingMount = (vnode)=>{
            const mountJob = ()=>{
                if ($0645c946e5db1562$var$pendingMounts.get(vnode) !== mountJob) return;
                $0645c946e5db1562$var$pendingMounts.delete(vnode);
                if ($0645c946e5db1562$var$isTeleportDisabled(vnode.props)) {
                    const mountContainer = parentNode(vnode.el) || container;
                    mount(vnode, mountContainer, vnode.anchor);
                    $0645c946e5db1562$var$updateCssVars(vnode, true);
                }
                mountToTarget(vnode);
            };
            $0645c946e5db1562$var$pendingMounts.set(vnode, mountJob);
            $0645c946e5db1562$var$queuePostRenderEffect(mountJob, parentSuspense);
        };
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            if ($0645c946e5db1562$var$isTeleportDeferred(n2.props) || parentSuspense && parentSuspense.pendingBranch) {
                queuePendingMount(n2);
                return;
            }
            if (disabled) {
                mount(n2, container, mainAnchor);
                $0645c946e5db1562$var$updateCssVars(n2, true);
            }
            mountToTarget();
        } else {
            n2.el = n1.el;
            const mainAnchor = n2.anchor = n1.anchor;
            const pendingMount = $0645c946e5db1562$var$pendingMounts.get(n1);
            if (pendingMount) {
                pendingMount.flags |= 8;
                $0645c946e5db1562$var$pendingMounts.delete(n1);
                queuePendingMount(n2);
                return;
            }
            n2.targetStart = n1.targetStart;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0645c946e5db1562$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0645c946e5db1562$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0645c946e5db1562$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0645c946e5db1562$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0645c946e5db1562$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = $0645c946e5db1562$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) {
                        n2.target = nextTarget;
                        $0645c946e5db1562$var$moveTeleport(n2, nextTarget, null, internals, 0);
                    }
                } else if (wasDisabled) $0645c946e5db1562$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $0645c946e5db1562$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        const disabled = $0645c946e5db1562$var$isTeleportDisabled(props);
        const shouldRemove = doRemove || !disabled;
        const pendingMount = $0645c946e5db1562$var$pendingMounts.get(vnode);
        if (pendingMount) {
            pendingMount.flags |= 8;
            $0645c946e5db1562$var$pendingMounts.delete(vnode);
        }
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (!pendingMount && (disabled || target) && shapeFlag & 16) for(let i = 0; i < children.length; i++){
            const child = children[i];
            unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
        }
    },
    move: $0645c946e5db1562$var$moveTeleport,
    hydrate: $0645c946e5db1562$var$hydrateTeleport
};
function $0645c946e5db1562$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) {
        if (vnode.targetStart) insert(vnode.targetStart, container, parentAnchor);
        insert(vnode.targetAnchor, container, parentAnchor);
        parentAnchor = vnode.targetAnchor;
    }
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!$0645c946e5db1562$var$pendingMounts.has(vnode) && (!isReorder || $0645c946e5db1562$var$isTeleportDisabled(props))) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0645c946e5db1562$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
        vnode2.anchor = hydrateChildren(nextSibling(node2), vnode2, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    const target = vnode.target = $0645c946e5db1562$var$resolveTarget(vnode.props, querySelector);
    const disabled = $0645c946e5db1562$var$isTeleportDisabled(vnode.props);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $0645c946e5db1562$var$prepareAnchor(target, vnode, createText, insert, // if target is the same as the main view, insert anchors before current node
                // to avoid hydrating mismatch
                parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $0645c946e5db1562$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0645c946e5db1562$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0645c946e5db1562$export$76d55a0304a371f4 = $0645c946e5db1562$var$TeleportImpl;
function $0645c946e5db1562$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $0645c946e5db1562$var$prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$0645c946e5db1562$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
const $0645c946e5db1562$var$leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
const $0645c946e5db1562$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
function $0645c946e5db1562$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0645c946e5db1562$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0645c946e5db1562$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0645c946e5db1562$var$TransitionHookValidator = [
    Function,
    Array
];
const $0645c946e5db1562$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0645c946e5db1562$var$TransitionHookValidator,
    onEnter: $0645c946e5db1562$var$TransitionHookValidator,
    onAfterEnter: $0645c946e5db1562$var$TransitionHookValidator,
    onEnterCancelled: $0645c946e5db1562$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0645c946e5db1562$var$TransitionHookValidator,
    onLeave: $0645c946e5db1562$var$TransitionHookValidator,
    onAfterLeave: $0645c946e5db1562$var$TransitionHookValidator,
    onLeaveCancelled: $0645c946e5db1562$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0645c946e5db1562$var$TransitionHookValidator,
    onAppear: $0645c946e5db1562$var$TransitionHookValidator,
    onAfterAppear: $0645c946e5db1562$var$TransitionHookValidator,
    onAppearCancelled: $0645c946e5db1562$var$TransitionHookValidator
};
const $0645c946e5db1562$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0645c946e5db1562$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0645c946e5db1562$export$f13e630aa3915748();
        const state = $0645c946e5db1562$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0645c946e5db1562$export$a67f9b1229c7c97a(slots.default(), true);
            const child = children && children.length ? $0645c946e5db1562$var$findNonCommentChild(children) : // Keep explicit default-slot conditionals on the same transition path
            // as regular v-if branches, which render a comment placeholder.
            instance.subTree ? $0645c946e5db1562$export$49553837c7236d3c() : void 0;
            if (!child) return;
            const rawProps = (0, $gIp2w.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0645c946e5db1562$var$emptyPlaceholder(child);
            const innerChild = $0645c946e5db1562$var$getInnerChild$1(child);
            if (!innerChild) return $0645c946e5db1562$var$emptyPlaceholder(child);
            let enterHooks = $0645c946e5db1562$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $0645c946e5db1562$export$4d299b491347818a) $0645c946e5db1562$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $0645c946e5db1562$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $0645c946e5db1562$export$4d299b491347818a && !$0645c946e5db1562$var$isSameVNodeType(oldInnerChild, innerChild) && $0645c946e5db1562$var$getTransitionRoot(instance.subTree)) {
                let leavingHooks = $0645c946e5db1562$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0645c946e5db1562$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0645c946e5db1562$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $0645c946e5db1562$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0645c946e5db1562$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0645c946e5db1562$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0645c946e5db1562$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0645c946e5db1562$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $0645c946e5db1562$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $0645c946e5db1562$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $0645c946e5db1562$export$abd95b5f5e8a8837 = $0645c946e5db1562$var$BaseTransitionImpl;
function $0645c946e5db1562$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0645c946e5db1562$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0645c946e5db1562$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0645c946e5db1562$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $d8ZDz.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0645c946e5db1562$var$leaveCbKey]) el[$0645c946e5db1562$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0645c946e5db1562$var$isSameVNodeType(vnode, leavingVNode)) {
                let leavingCb = leavingVNode.el[$0645c946e5db1562$var$leaveCbKey];
                if (!leavingCb) {
                    const leavingRoot = $0645c946e5db1562$var$getTransitionRoot(leavingVNode);
                    leavingCb = leavingRoot && leavingRoot.el[$0645c946e5db1562$var$leaveCbKey];
                }
                if (leavingCb) leavingCb();
            }
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            if (!$0645c946e5db1562$var$isHmrUpdating && leavingVNodesCache[key] === vnode) return;
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            el[$0645c946e5db1562$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0645c946e5db1562$var$enterCbKey] = void 0;
            };
            const done = el[$0645c946e5db1562$var$enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0645c946e5db1562$var$enterCbKey]) el[$0645c946e5db1562$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            el[$0645c946e5db1562$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0645c946e5db1562$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            const done = el[$0645c946e5db1562$var$leaveCbKey].bind(null, false);
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $0645c946e5db1562$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $0645c946e5db1562$var$emptyPlaceholder(vnode) {
    if ($0645c946e5db1562$var$isKeepAlive(vnode)) {
        vnode = $0645c946e5db1562$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0645c946e5db1562$var$getInnerChild$1(vnode) {
    if (!$0645c946e5db1562$var$isKeepAlive(vnode)) {
        if ($0645c946e5db1562$var$isTeleport(vnode.type) && vnode.children) return $0645c946e5db1562$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $d8ZDz.isFunction)(children.default)) return children.default();
    }
}
function $0645c946e5db1562$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        const subTree = vnode.component.subTree;
        $0645c946e5db1562$export$7770a22486565649($0645c946e5db1562$var$isTeleport(subTree.type) ? $0645c946e5db1562$var$getInnerChild$1(subTree) || subTree : subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else {
        vnode.transition = hooks;
        if (vnode.type === $0645c946e5db1562$export$ffb0004e005737fa && (0, $d8ZDz.isArray)(vnode.children)) {
            const child = $0645c946e5db1562$var$filterSingleRoot(vnode.children, false);
            if (child) $0645c946e5db1562$export$7770a22486565649(child, hooks);
        }
    }
}
function $0645c946e5db1562$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0645c946e5db1562$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0645c946e5db1562$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0645c946e5db1562$export$4d299b491347818a) ret.push(key != null ? $0645c946e5db1562$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
function $0645c946e5db1562$var$getTransitionRoot(vnode) {
    if (vnode.component) return $0645c946e5db1562$var$getTransitionRoot(vnode.component.subTree);
    if (vnode.type === $0645c946e5db1562$export$ffb0004e005737fa) {
        const child = (0, $d8ZDz.isArray)(vnode.children) && $0645c946e5db1562$var$filterSingleRoot(vnode.children, false);
        return child ? $0645c946e5db1562$var$getTransitionRoot(child) : void 0;
    }
    if (vnode.type !== $0645c946e5db1562$export$4d299b491347818a) return vnode;
}
// @__NO_SIDE_EFFECTS__
function $0645c946e5db1562$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $d8ZDz.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $d8ZDz.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $0645c946e5db1562$export$f680877a34711e37() {
    const i = $0645c946e5db1562$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $0645c946e5db1562$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $0645c946e5db1562$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $0645c946e5db1562$export$83a5dbc1f35517ca(key) {
    const i = $0645c946e5db1562$export$f13e630aa3915748();
    const r = (0, $gIp2w.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $d8ZDz.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $0645c946e5db1562$var$isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
const $0645c946e5db1562$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function $0645c946e5db1562$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $d8ZDz.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0645c946e5db1562$var$setRef(r, oldRawRef && ((0, $d8ZDz.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0645c946e5db1562$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $0645c946e5db1562$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $0645c946e5db1562$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $d8ZDz.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $gIp2w.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $d8ZDz.EMPTY_OBJ) ? (0, $d8ZDz.NO) : (key)=>{
        if ($0645c946e5db1562$var$isTemplateRefKey(refs, key)) return false;
        return (0, $d8ZDz.hasOwn)(rawSetupState, key);
    };
    const canSetRef = (ref2, key)=>{
        if (key && $0645c946e5db1562$var$isTemplateRefKey(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $0645c946e5db1562$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $d8ZDz.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $gIp2w.isRef)(oldRef)) {
            const oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $d8ZDz.isFunction)(ref)) $0645c946e5db1562$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $d8ZDz.isString)(ref);
        const _isRef = (0, $gIp2w.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $d8ZDz.isArray)(existing) && (0, $d8ZDz.remove)(existing, refValue);
                    else {
                        if (!(0, $d8ZDz.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                const newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                const job = ()=>{
                    doSet();
                    $0645c946e5db1562$var$pendingSetRefMap.delete(rawRef);
                };
                job.id = -1;
                $0645c946e5db1562$var$pendingSetRefMap.set(rawRef, job);
                $0645c946e5db1562$var$queuePostRenderEffect(job, parentSuspense);
            } else {
                $0645c946e5db1562$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $0645c946e5db1562$var$invalidatePendingSetRef(rawRef) {
    const pendingSetRef = $0645c946e5db1562$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 8;
        $0645c946e5db1562$var$pendingSetRefMap.delete(rawRef);
    }
}
let $0645c946e5db1562$var$hasLoggedMismatchError = false;
const $0645c946e5db1562$var$logMismatchError = ()=>{
    if ($0645c946e5db1562$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $0645c946e5db1562$var$hasLoggedMismatchError = true;
};
const $0645c946e5db1562$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0645c946e5db1562$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0645c946e5db1562$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($0645c946e5db1562$var$isSVGContainer(container)) return "svg";
    if ($0645c946e5db1562$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0645c946e5db1562$var$isComment = (node)=>node.nodeType === 8;
function $0645c946e5db1562$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0645c946e5db1562$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0645c946e5db1562$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0645c946e5db1562$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0645c946e5db1562$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $d8ZDz.def)(node, "__vnode", vnode, true);
            (0, $d8ZDz.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0645c946e5db1562$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0645c946e5db1562$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $0645c946e5db1562$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0645c946e5db1562$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0645c946e5db1562$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0645c946e5db1562$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0645c946e5db1562$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0645c946e5db1562$var$getContainerType(container), optimized);
                    if (($0645c946e5db1562$var$isAsyncWrapper(vnode) || vnode.component.asyncDep) && !vnode.component.subTree) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0645c946e5db1562$export$bf5c4cf060303d58($0645c946e5db1562$export$c1b9a1d3af45b7b6);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0645c946e5db1562$export$22f9b5ffd89dac9("") : $0645c946e5db1562$export$bf5c4cf060303d58(node.nodeType === 8 ? $0645c946e5db1562$export$4d299b491347818a : "div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0645c946e5db1562$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $0645c946e5db1562$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0645c946e5db1562$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, dynamicProps: dynamicProps, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        const hasDynamicProps = !!dynamicProps;
        if (forcePatch || hasDynamicProps || patchFlag !== -1) {
            if (dirs) $0645c946e5db1562$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0645c946e5db1562$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                if (next && !$0645c946e5db1562$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                    __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0645c946e5db1562$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                    $0645c946e5db1562$var$logMismatchError();
                }
                while(next){
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                const { textContent: textContent } = el;
                if (textContent !== clientText && // innerHTML normalize \r\n or \r into a single \n in the DOM
                textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!$0645c946e5db1562$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0645c946e5db1562$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${textContent}
  - expected on client: ${clientText}`);
                        $0645c946e5db1562$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || hasDynamicProps || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    const namespace = el.namespaceURI.includes("svg") ? "svg" : el.namespaceURI.includes("MathML") ? "mathml" : void 0;
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $0645c946e5db1562$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0645c946e5db1562$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $d8ZDz.isOn)(key) && !(0, $d8ZDz.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement && !(0, $d8ZDz.isReservedProp)(key) || dynamicProps && dynamicProps.includes(key)) {
                            if ($0645c946e5db1562$var$isUnchangedResourceProp(el, key, props[key])) continue;
                            patchProp(el, key, null, props[key], namespace, parentComponent);
                        }
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $gIp2w.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0645c946e5db1562$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0645c946e5db1562$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0645c946e5db1562$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0645c946e5db1562$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0645c946e5db1562$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasCheckedMismatch = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0645c946e5db1562$var$normalizeVNode(children[i]);
            const isText = vnode.type === $0645c946e5db1562$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $0645c946e5db1562$var$normalizeVNode(children[i + 1]).type === $0645c946e5db1562$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!hasCheckedMismatch) {
                    hasCheckedMismatch = true;
                    if (!$0645c946e5db1562$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0645c946e5db1562$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        $0645c946e5db1562$var$logMismatchError();
                    }
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0645c946e5db1562$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0645c946e5db1562$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0645c946e5db1562$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$0645c946e5db1562$var$isNodeMismatchAllowed(node, vnode)) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0645c946e5db1562$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $0645c946e5db1562$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $0645c946e5db1562$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0645c946e5db1562$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $0645c946e5db1562$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0645c946e5db1562$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
const $0645c946e5db1562$var$resourceProps = /* @__PURE__ */ new Set([
    "src",
    "srcset",
    "href",
    "poster"
]);
function $0645c946e5db1562$var$isUnchangedResourceProp(el, key, clientValue) {
    if (!$0645c946e5db1562$var$resourceProps.has(key)) return false;
    return el.getAttribute(key) === (clientValue == null ? null : `${clientValue}`);
}
function $0645c946e5db1562$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $d8ZDz.normalizeClass)(clientValue);
        if (!$0645c946e5db1562$var$isSetEqual($0645c946e5db1562$var$toClassSet(actual || ""), $0645c946e5db1562$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $d8ZDz.isString)(clientValue) ? clientValue : (0, $d8ZDz.stringifyStyle)((0, $d8ZDz.normalizeStyle)(clientValue));
        const actualMap = $0645c946e5db1562$var$toStyleMap(actual);
        const expectedMap = $0645c946e5db1562$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $0645c946e5db1562$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$0645c946e5db1562$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $d8ZDz.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $d8ZDz.isBooleanAttr)(key) || (0, $d8ZDz.isKnownHtmlAttr)(key))) {
        if (key === "hidden") {
            actual = $0645c946e5db1562$var$normalizeHiddenValue(el.getAttribute(key));
            expected = $0645c946e5db1562$var$normalizeHiddenValue(clientValue);
        } else if ((0, $d8ZDz.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $d8ZDz.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $d8ZDz.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$0645c946e5db1562$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$0645c946e5db1562$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0645c946e5db1562$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0645c946e5db1562$var$normalizeHiddenValue(value) {
    if (!(0, $d8ZDz.isRenderableAttrValue)(value)) return false;
    if ((0, $d8ZDz.isString)(value)) return value.toLowerCase() === "until-found" ? "until-found" : "";
    return (0, $d8ZDz.includeBooleanAttr)(value) ? "" : false;
}
function $0645c946e5db1562$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0645c946e5db1562$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0645c946e5db1562$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0645c946e5db1562$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $0645c946e5db1562$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $0645c946e5db1562$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $d8ZDz.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $d8ZDz.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $0645c946e5db1562$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $0645c946e5db1562$var$allowMismatchAttr = "data-allow-mismatch";
const $0645c946e5db1562$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $0645c946e5db1562$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($0645c946e5db1562$var$allowMismatchAttr))el = el.parentElement;
    return $0645c946e5db1562$var$isMismatchAllowedByAttr(el && el.getAttribute($0645c946e5db1562$var$allowMismatchAttr), allowedType);
}
function $0645c946e5db1562$var$isMismatchAllowedByAttr(allowedAttr, allowedType) {
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($0645c946e5db1562$var$MismatchTypeString[allowedType]);
    }
}
function $0645c946e5db1562$var$isNodeMismatchAllowed(node, vnode) {
    return $0645c946e5db1562$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ ) || $0645c946e5db1562$var$isMismatchAllowedByNode(node) || $0645c946e5db1562$var$isMismatchAllowedByVNode(vnode);
}
function $0645c946e5db1562$var$isMismatchAllowedByNode(node) {
    return node.nodeType === 1 && $0645c946e5db1562$var$isMismatchAllowedByAttr(node.getAttribute($0645c946e5db1562$var$allowMismatchAttr), 1 /* CHILDREN */ );
}
function $0645c946e5db1562$var$isMismatchAllowedByVNode({ props: props }) {
    const allowedAttr = props && props[$0645c946e5db1562$var$allowMismatchAttr];
    return typeof allowedAttr === "string" && $0645c946e5db1562$var$isMismatchAllowedByAttr(allowedAttr, 1 /* CHILDREN */ );
}
const $0645c946e5db1562$var$requestIdleCallback = (0, $d8ZDz.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $0645c946e5db1562$var$cancelIdleCallback = (0, $d8ZDz.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $0645c946e5db1562$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $0645c946e5db1562$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$0645c946e5db1562$var$cancelIdleCallback(id);
    };
function $0645c946e5db1562$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $0645c946e5db1562$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        const observe = (el)=>{
            if ($0645c946e5db1562$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            if (getComputedStyle(el).display === "contents") for(let i = 0; i < el.children.length; i++){
                if (observe(el.children[i]) === false) return false;
            }
            ob.observe(el);
        };
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            return observe(el);
        });
        return ()=>ob.disconnect();
    };
const $0645c946e5db1562$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $0645c946e5db1562$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $d8ZDz.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $0645c946e5db1562$var$forEachElement(node, cb) {
    if ($0645c946e5db1562$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($0645c946e5db1562$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $0645c946e5db1562$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function $0645c946e5db1562$export$d75d499b4c16cf21(source) {
    if ((0, $d8ZDz.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0645c946e5db1562$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            const wasConnected = el.isConnected;
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                if (!el.parentNode || wasConnected && !el.isConnected) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$0645c946e5db1562$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0645c946e5db1562$var$currentInstance;
            $0645c946e5db1562$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$0645c946e5db1562$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0645c946e5db1562$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0645c946e5db1562$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0645c946e5db1562$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0645c946e5db1562$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $gIp2w.ref)(false);
            const error = (0, $gIp2w.ref)();
            const delayed = (0, $gIp2w.ref)(!!delay);
            let timeoutTimer;
            let delayTimer;
            $0645c946e5db1562$export$13348a43ccacfe58(()=>{
                if (timeoutTimer != null) clearTimeout(timeoutTimer);
                if (delayTimer != null) clearTimeout(delayTimer);
            });
            if (delay) delayTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                delayed.value = false;
            }, delay);
            if (timeout != null) timeoutTimer = setTimeout(()=>{
                if (instance.isUnmounted) return;
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                if (instance.isUnmounted) return;
                loaded.value = true;
                if (instance.parent && $0645c946e5db1562$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                if (instance.isUnmounted) {
                    pendingRequest = null;
                    return;
                }
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0645c946e5db1562$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0645c946e5db1562$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0645c946e5db1562$var$createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function $0645c946e5db1562$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0645c946e5db1562$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0645c946e5db1562$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0645c946e5db1562$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0645c946e5db1562$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0645c946e5db1562$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $d8ZDz.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0645c946e5db1562$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0645c946e5db1562$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $0645c946e5db1562$var$invalidateMount(instance2.m);
            $0645c946e5db1562$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0645c946e5db1562$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $d8ZDz.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0645c946e5db1562$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0645c946e5db1562$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0645c946e5db1562$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0645c946e5db1562$var$getComponentName($0645c946e5db1562$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$0645c946e5db1562$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) {
                $0645c946e5db1562$var$resetShapeFlag(current);
                if (cached) $0645c946e5db1562$var$resetShapeFlag(cached);
            }
            cache.delete(key);
            keys.delete(key);
        }
        $0645c946e5db1562$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0645c946e5db1562$var$matches(include, name));
            exclude && pruneCache((name)=>!$0645c946e5db1562$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($0645c946e5db1562$var$isSuspense(instance.subTree.type)) $0645c946e5db1562$var$queuePostRenderEffect(()=>{
                    const vnode = $0645c946e5db1562$var$getInnerChild(instance.subTree);
                    if (vnode.component) cache.set(pendingCacheKey, vnode);
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $0645c946e5db1562$var$getInnerChild(instance.subTree));
            }
        };
        $0645c946e5db1562$export$6d1641039221b5cb(cacheSubtree);
        $0645c946e5db1562$export$5876c47052fb88b1(cacheSubtree);
        $0645c946e5db1562$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0645c946e5db1562$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0645c946e5db1562$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0645c946e5db1562$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0645c946e5db1562$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0645c946e5db1562$var$getInnerChild(rawVNode);
            if (vnode.type === $0645c946e5db1562$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $0645c946e5db1562$var$getComponentName($0645c946e5db1562$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0645c946e5db1562$var$matches(include, name)) || exclude && name && $0645c946e5db1562$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0645c946e5db1562$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0645c946e5db1562$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0645c946e5db1562$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0645c946e5db1562$export$70eb8a58709972df = $0645c946e5db1562$var$KeepAliveImpl;
function $0645c946e5db1562$var$matches(pattern, name) {
    if ((0, $d8ZDz.isArray)(pattern)) return pattern.some((p)=>$0645c946e5db1562$var$matches(p, name));
    else if ((0, $d8ZDz.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $d8ZDz.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $0645c946e5db1562$export$ba52d824b95a2154(hook, target) {
    $0645c946e5db1562$var$registerKeepAliveHook(hook, "a", target);
}
function $0645c946e5db1562$export$bf1440eeaf5fa709(hook, target) {
    $0645c946e5db1562$var$registerKeepAliveHook(hook, "da", target);
}
function $0645c946e5db1562$var$registerKeepAliveHook(hook, type, target = $0645c946e5db1562$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0645c946e5db1562$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0645c946e5db1562$var$isKeepAlive(current.parent.vnode)) $0645c946e5db1562$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0645c946e5db1562$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0645c946e5db1562$var$injectHook(type, hook, keepAliveRoot, true);
    $0645c946e5db1562$export$13348a43ccacfe58(()=>{
        (0, $d8ZDz.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0645c946e5db1562$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0645c946e5db1562$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0645c946e5db1562$var$injectHook(type, hook, target = $0645c946e5db1562$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $gIp2w.pauseTracking)();
            const reset = $0645c946e5db1562$var$setCurrentInstance(target);
            const res = $0645c946e5db1562$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $gIp2w.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0645c946e5db1562$var$createHook = (lifecycle)=>(hook, target = $0645c946e5db1562$var$currentInstance)=>{
        if (!$0645c946e5db1562$var$isInSSRComponentSetup || lifecycle === "sp") $0645c946e5db1562$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $0645c946e5db1562$export$23b7aeb0d671f804 = $0645c946e5db1562$var$createHook("bm");
const $0645c946e5db1562$export$6d1641039221b5cb = $0645c946e5db1562$var$createHook("m");
const $0645c946e5db1562$export$ab91988a13872e4c = $0645c946e5db1562$var$createHook("bu");
const $0645c946e5db1562$export$5876c47052fb88b1 = $0645c946e5db1562$var$createHook("u");
const $0645c946e5db1562$export$40c420df62d2614 = $0645c946e5db1562$var$createHook("bum");
const $0645c946e5db1562$export$13348a43ccacfe58 = $0645c946e5db1562$var$createHook("um");
const $0645c946e5db1562$export$ebf0c601f267bceb = $0645c946e5db1562$var$createHook("sp");
const $0645c946e5db1562$export$898295a813d662eb = $0645c946e5db1562$var$createHook("rtg");
const $0645c946e5db1562$export$2b41f4235363e921 = $0645c946e5db1562$var$createHook("rtc");
function $0645c946e5db1562$export$6a3a15856e50ad19(hook, target = $0645c946e5db1562$var$currentInstance) {
    $0645c946e5db1562$var$injectHook("ec", hook, target);
}
const $0645c946e5db1562$var$COMPONENTS = "components";
const $0645c946e5db1562$var$DIRECTIVES = "directives";
function $0645c946e5db1562$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0645c946e5db1562$var$resolveAsset($0645c946e5db1562$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0645c946e5db1562$var$NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function $0645c946e5db1562$export$b44c564a05ca975(component) {
    if ((0, $d8ZDz.isString)(component)) return $0645c946e5db1562$var$resolveAsset($0645c946e5db1562$var$COMPONENTS, component, false) || component;
    else return component || $0645c946e5db1562$var$NULL_DYNAMIC_COMPONENT;
}
function $0645c946e5db1562$export$a1989e995cd481be(name) {
    return $0645c946e5db1562$var$resolveAsset($0645c946e5db1562$var$DIRECTIVES, name);
}
function $0645c946e5db1562$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0645c946e5db1562$var$currentRenderingInstance || $0645c946e5db1562$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0645c946e5db1562$var$COMPONENTS) {
            const selfName = $0645c946e5db1562$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $d8ZDz.camelize)(name) || selfName === (0, $d8ZDz.capitalize)((0, $d8ZDz.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0645c946e5db1562$var$resolve(instance[type] || Component[type], name) || // global registration
        $0645c946e5db1562$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0645c946e5db1562$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $d8ZDz.camelize)(name)] || registry[(0, $d8ZDz.capitalize)((0, $d8ZDz.camelize)(name))]);
}
function $0645c946e5db1562$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $d8ZDz.isArray)(source);
    if (sourceIsArray || (0, $d8ZDz.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $gIp2w.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $gIp2w.isShallow)(source);
            isReadonlySource = (0, $gIp2w.isReadonly)(source);
            source = (0, $gIp2w.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $gIp2w.toReadonly)((0, $gIp2w.toReactive)(source[i])) : (0, $gIp2w.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        if (!Number.isInteger(source) || source < 0) ret = [];
        else {
            ret = new Array(source);
            for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
        }
    } else if ((0, $d8ZDz.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0645c946e5db1562$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $d8ZDz.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0645c946e5db1562$export$4abee4c34694ada1(slots, name, props, fallback, noSlotted, branchKey) {
    if (props == null) props = {};
    if ($0645c946e5db1562$var$currentRenderingInstance.ce || $0645c946e5db1562$var$currentRenderingInstance.parent && $0645c946e5db1562$var$isAsyncWrapper($0645c946e5db1562$var$currentRenderingInstance.parent) && $0645c946e5db1562$var$currentRenderingInstance.parent.ce) {
        const slotProps = branchKey != null && props.key == null ? (0, $d8ZDz.extend)({}, props, {
            key: branchKey
        }) : props;
        const hasProps = Object.keys(slotProps).length > 0;
        if (name !== "default") slotProps.name = name;
        return $0645c946e5db1562$export$e7eaa45e502fe5cc(), $0645c946e5db1562$export$9f2dfe8048dfb22b($0645c946e5db1562$export$ffb0004e005737fa, null, [
            $0645c946e5db1562$export$bf5c4cf060303d58("slot", slotProps, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    const prevStackSize = $0645c946e5db1562$var$blockStack.length;
    $0645c946e5db1562$export$e7eaa45e502fe5cc();
    let rendered;
    try {
        const validSlotContent = slot && $0645c946e5db1562$var$ensureValidVNode(slot(props));
        const slotKey = props.key || branchKey || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key;
        rendered = $0645c946e5db1562$export$9f2dfe8048dfb22b($0645c946e5db1562$export$ffb0004e005737fa, {
            key: (slotKey && !(0, $d8ZDz.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
            (!validSlotContent && fallback ? "_fb" : "")
        }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    } catch (err) {
        for(let i = $0645c946e5db1562$var$blockStack.length; i > prevStackSize; i--)$0645c946e5db1562$var$closeBlock();
        throw err;
    } finally{
        if (slot && slot._c) slot._d = true;
    }
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    return rendered;
}
function $0645c946e5db1562$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0645c946e5db1562$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0645c946e5db1562$export$4d299b491347818a) return false;
        if (child.type === $0645c946e5db1562$export$ffb0004e005737fa && !$0645c946e5db1562$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0645c946e5db1562$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $d8ZDz.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0645c946e5db1562$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0645c946e5db1562$var$isStatefulComponent(i)) return $0645c946e5db1562$var$getComponentPublicInstance(i);
    return $0645c946e5db1562$var$getPublicInstance(i.parent);
};
const $0645c946e5db1562$var$resolveDevRootEl = (vnode)=>{
    let found = false;
    while(true){
        if (vnode.patchFlag > 0 && vnode.patchFlag & 2048) {
            const root = $0645c946e5db1562$var$filterSingleRoot(vnode.children);
            if (!root) return;
            vnode = root;
            found = true;
            continue;
        }
        const component = vnode.component;
        if (component && component.subTree) {
            vnode = component.subTree;
            continue;
        }
        const suspense = vnode.suspense;
        if (suspense && suspense.activeBranch) {
            vnode = suspense.activeBranch;
            continue;
        }
        return found ? vnode.el : void 0;
    }
};
const $0645c946e5db1562$var$getDevRootFragmentEl = (i)=>{
    const el = i.subTree && $0645c946e5db1562$var$resolveDevRootEl(i.subTree);
    return el === void 0 ? i.vnode.el : el;
};
const $0645c946e5db1562$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $d8ZDz.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>(0, i.vnode.el),
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0645c946e5db1562$var$getPublicInstance(i.parent),
    $root: (i)=>$0645c946e5db1562$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0645c946e5db1562$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $0645c946e5db1562$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0645c946e5db1562$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0645c946e5db1562$var$instanceWatch.bind(i) : (0, $d8ZDz.NOOP)
});
const $0645c946e5db1562$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0645c946e5db1562$var$hasSetupBinding = (state, key)=>state !== (0, $d8ZDz.EMPTY_OBJ) && !state.__isScriptSetup && (0, $d8ZDz.hasOwn)(state, key);
const $0645c946e5db1562$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0645c946e5db1562$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, $d8ZDz.EMPTY_OBJ) && (0, $d8ZDz.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if ((0, $d8ZDz.hasOwn)(props, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $d8ZDz.EMPTY_OBJ) && (0, $d8ZDz.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0645c946e5db1562$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0645c946e5db1562$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $gIp2w.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $d8ZDz.EMPTY_OBJ) && (0, $d8ZDz.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $d8ZDz.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0645c946e5db1562$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, $d8ZDz.EMPTY_OBJ) && (0, $d8ZDz.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $d8ZDz.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, props: props, type: type } }, key) {
        let cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, $d8ZDz.EMPTY_OBJ) && key[0] !== "$" && (0, $d8ZDz.hasOwn)(data, key) || $0645c946e5db1562$var$hasSetupBinding(setupState, key) || (0, $d8ZDz.hasOwn)(props, key) || (0, $d8ZDz.hasOwn)(ctx, key) || (0, $d8ZDz.hasOwn)($0645c946e5db1562$var$publicPropertiesMap, key) || (0, $d8ZDz.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $d8ZDz.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0645c946e5db1562$var$target;
const $0645c946e5db1562$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $d8ZDz.extend)({}, $0645c946e5db1562$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0645c946e5db1562$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $d8ZDz.isGloballyAllowed)(key);
        return has;
    }
});
function $0645c946e5db1562$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0645c946e5db1562$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0645c946e5db1562$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $d8ZDz.NOOP)
        });
    });
    return target;
}
function $0645c946e5db1562$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $d8ZDz.NOOP)
        });
    });
}
function $0645c946e5db1562$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $gIp2w.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0645c946e5db1562$var$isReservedPrefix(key[0])) {
                $0645c946e5db1562$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $d8ZDz.NOOP)
            });
        }
    });
}
const $0645c946e5db1562$var$warnRuntimeUsage = (method)=>$0645c946e5db1562$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0645c946e5db1562$export$80b33eababae110e() {
    return null;
}
function $0645c946e5db1562$export$51ecece22fc17ddc() {
    return null;
}
function $0645c946e5db1562$export$da25b65ca24b518a(exposed) {}
function $0645c946e5db1562$export$77e79129327f3d0d(options) {}
function $0645c946e5db1562$export$1b3acd4bb805b712() {
    return null;
}
function $0645c946e5db1562$export$acd55aa037e791bb() {}
function $0645c946e5db1562$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0645c946e5db1562$export$9203a8e84125433c() {
    return $0645c946e5db1562$var$getContext("useSlots").slots;
}
function $0645c946e5db1562$export$75e29435042cd2ea() {
    return $0645c946e5db1562$var$getContext("useAttrs").attrs;
}
function $0645c946e5db1562$var$getContext(calledFunctionName) {
    const i = $0645c946e5db1562$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0645c946e5db1562$var$createSetupContext(i));
}
function $0645c946e5db1562$var$normalizePropsOrEmits(props) {
    return (0, $d8ZDz.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0645c946e5db1562$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0645c946e5db1562$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $d8ZDz.isArray)(opt) || (0, $d8ZDz.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0645c946e5db1562$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $d8ZDz.isArray)(a) && (0, $d8ZDz.isArray)(b)) return a.concat(b);
    return (0, $d8ZDz.extend)({}, $0645c946e5db1562$var$normalizePropsOrEmits(a), $0645c946e5db1562$var$normalizePropsOrEmits(b));
}
function $0645c946e5db1562$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0645c946e5db1562$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0645c946e5db1562$export$f13e630aa3915748();
    const inSSRSetup = $0645c946e5db1562$var$isInSSRComponentSetup;
    let awaitable = getAwaitable();
    $0645c946e5db1562$var$unsetCurrentInstance();
    if (inSSRSetup) $0645c946e5db1562$var$setInSSRSetupState(false);
    const restore = ()=>{
        $0645c946e5db1562$var$setCurrentInstance(ctx);
        if (inSSRSetup) $0645c946e5db1562$var$setInSSRSetupState(true);
    };
    const cleanup = ()=>{
        if ($0645c946e5db1562$export$f13e630aa3915748() !== ctx) ctx.scope.off();
        $0645c946e5db1562$var$unsetCurrentInstance();
        if (inSSRSetup) $0645c946e5db1562$var$setInSSRSetupState(false);
    };
    if ((0, $d8ZDz.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        restore();
        Promise.resolve().then(()=>Promise.resolve().then(cleanup));
        throw e;
    });
    return [
        awaitable,
        ()=>{
            restore();
            Promise.resolve().then(cleanup);
        }
    ];
}
function $0645c946e5db1562$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0645c946e5db1562$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0645c946e5db1562$var$shouldCacheAccess = true;
function $0645c946e5db1562$var$applyOptions(instance) {
    const options = $0645c946e5db1562$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0645c946e5db1562$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0645c946e5db1562$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0645c946e5db1562$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $d8ZDz.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $d8ZDz.isObject)(data)) ;
        else instance.data = (0, $gIp2w.reactive)(data);
    }
    $0645c946e5db1562$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $d8ZDz.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $d8ZDz.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $d8ZDz.NOOP);
        const set = !(0, $d8ZDz.isFunction)(opt) && (0, $d8ZDz.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $d8ZDz.NOOP);
        const c = $0645c946e5db1562$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0645c946e5db1562$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $d8ZDz.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0645c946e5db1562$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0645c946e5db1562$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $d8ZDz.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0645c946e5db1562$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0645c946e5db1562$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0645c946e5db1562$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0645c946e5db1562$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0645c946e5db1562$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0645c946e5db1562$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0645c946e5db1562$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0645c946e5db1562$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0645c946e5db1562$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0645c946e5db1562$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0645c946e5db1562$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0645c946e5db1562$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $d8ZDz.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $d8ZDz.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $0645c946e5db1562$var$markAsyncBoundary(instance);
}
function $0645c946e5db1562$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $d8ZDz.NOOP)) {
    if ((0, $d8ZDz.isArray)(injectOptions)) injectOptions = $0645c946e5db1562$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $d8ZDz.isObject)(opt)) {
            if ("default" in opt) injected = $0645c946e5db1562$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0645c946e5db1562$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0645c946e5db1562$export$a976684a0efeb93f(opt);
        if ((0, $gIp2w.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0645c946e5db1562$var$callHook(hook, instance, type) {
    $0645c946e5db1562$export$dae85862a8d94378((0, $d8ZDz.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0645c946e5db1562$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $0645c946e5db1562$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $d8ZDz.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $d8ZDz.isFunction)(handler)) $0645c946e5db1562$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $d8ZDz.isFunction)(raw)) $0645c946e5db1562$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $d8ZDz.isObject)(raw)) {
        if ((0, $d8ZDz.isArray)(raw)) raw.forEach((r)=>$0645c946e5db1562$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $d8ZDz.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $d8ZDz.isFunction)(handler)) $0645c946e5db1562$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0645c946e5db1562$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0645c946e5db1562$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0645c946e5db1562$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $d8ZDz.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0645c946e5db1562$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0645c946e5db1562$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0645c946e5db1562$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0645c946e5db1562$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0645c946e5db1562$var$internalOptionMergeStrats = {
    data: $0645c946e5db1562$var$mergeDataFn,
    props: $0645c946e5db1562$var$mergeEmitsOrPropsOptions,
    emits: $0645c946e5db1562$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0645c946e5db1562$var$mergeObjectOptions,
    computed: $0645c946e5db1562$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0645c946e5db1562$var$mergeAsArray,
    created: $0645c946e5db1562$var$mergeAsArray,
    beforeMount: $0645c946e5db1562$var$mergeAsArray,
    mounted: $0645c946e5db1562$var$mergeAsArray,
    beforeUpdate: $0645c946e5db1562$var$mergeAsArray,
    updated: $0645c946e5db1562$var$mergeAsArray,
    beforeDestroy: $0645c946e5db1562$var$mergeAsArray,
    beforeUnmount: $0645c946e5db1562$var$mergeAsArray,
    destroyed: $0645c946e5db1562$var$mergeAsArray,
    unmounted: $0645c946e5db1562$var$mergeAsArray,
    activated: $0645c946e5db1562$var$mergeAsArray,
    deactivated: $0645c946e5db1562$var$mergeAsArray,
    errorCaptured: $0645c946e5db1562$var$mergeAsArray,
    serverPrefetch: $0645c946e5db1562$var$mergeAsArray,
    // assets
    components: $0645c946e5db1562$var$mergeObjectOptions,
    directives: $0645c946e5db1562$var$mergeObjectOptions,
    // watch
    watch: $0645c946e5db1562$var$mergeWatchOptions,
    // provide / inject
    provide: $0645c946e5db1562$var$mergeDataFn,
    inject: $0645c946e5db1562$var$mergeInject
};
function $0645c946e5db1562$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $d8ZDz.extend)((0, $d8ZDz.isFunction)(to) ? to.call(this, this) : to, (0, $d8ZDz.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0645c946e5db1562$var$mergeInject(to, from) {
    return $0645c946e5db1562$var$mergeObjectOptions($0645c946e5db1562$var$normalizeInject(to), $0645c946e5db1562$var$normalizeInject(from));
}
function $0645c946e5db1562$var$normalizeInject(raw) {
    if ((0, $d8ZDz.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0645c946e5db1562$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0645c946e5db1562$var$mergeObjectOptions(to, from) {
    return to ? (0, $d8ZDz.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0645c946e5db1562$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $d8ZDz.isArray)(to) && (0, $d8ZDz.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $d8ZDz.extend)(/* @__PURE__ */ Object.create(null), $0645c946e5db1562$var$normalizePropsOrEmits(to), $0645c946e5db1562$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0645c946e5db1562$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $d8ZDz.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0645c946e5db1562$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0645c946e5db1562$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $d8ZDz.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0645c946e5db1562$var$uid$1 = 0;
function $0645c946e5db1562$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $d8ZDz.isFunction)(rootComponent)) rootComponent = (0, $d8ZDz.extend)({}, rootComponent);
        if (rootProps != null && !(0, $d8ZDz.isObject)(rootProps)) rootProps = null;
        const context = $0645c946e5db1562$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $0645c946e5db1562$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0645c946e5db1562$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $d8ZDz.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $d8ZDz.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $0645c946e5db1562$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0645c946e5db1562$var$devtoolsInitApp(app, $0645c946e5db1562$export$83d89fbfd8236492);
                    }
                    return $0645c946e5db1562$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $0645c946e5db1562$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0645c946e5db1562$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0645c946e5db1562$var$currentApp;
                $0645c946e5db1562$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0645c946e5db1562$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0645c946e5db1562$var$currentApp = null;
function $0645c946e5db1562$export$fb78bd113157f1a1(props, name, options = (0, $d8ZDz.EMPTY_OBJ)) {
    const i = $0645c946e5db1562$export$f13e630aa3915748();
    const camelizedName = (0, $d8ZDz.camelize)(name);
    const hyphenatedName = (0, $d8ZDz.hyphenate)(name);
    const modifiers = $0645c946e5db1562$var$getModelModifiers(props, camelizedName);
    const res = (0, $gIp2w.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $d8ZDz.EMPTY_OBJ);
        let prevEmittedValue;
        $0645c946e5db1562$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $d8ZDz.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $d8ZDz.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $d8ZDz.EMPTY_OBJ) && (0, $d8ZDz.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                const hasVModel = !!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps));
                if (!hasVModel) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $d8ZDz.hasChanged)(value, prevSetValue) && ((0, $d8ZDz.hasChanged)(value, emittedValue) && !(0, $d8ZDz.hasChanged)(emittedValue, prevEmittedValue) || // #13524: browsers differ in when they flush microtasks between
                // event listeners. If a v-model listener emits an intermediate value
                // and a following listener restores the model to its previous prop
                // value before parent updates are flushed, the parent render can be
                // deduped as having no prop change. Force a local update so DOM state
                // such as an input's value is synchronized back to the current model.
                hasVModel && prevSetValue !== (0, $d8ZDz.EMPTY_OBJ) && !(0, $d8ZDz.hasChanged)(emittedValue, localValue))) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $d8ZDz.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $0645c946e5db1562$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $d8ZDz.camelize)(modelName)}Modifiers`] || props[`${(0, $d8ZDz.hyphenate)(modelName)}Modifiers`];
};
function $0645c946e5db1562$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $d8ZDz.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $0645c946e5db1562$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $d8ZDz.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = args.map((0, $d8ZDz.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0645c946e5db1562$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $d8ZDz.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $d8ZDz.toHandlerKey)((0, $d8ZDz.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $d8ZDz.toHandlerKey)((0, $d8ZDz.hyphenate)(event))];
    if (handler) $0645c946e5db1562$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0645c946e5db1562$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
const $0645c946e5db1562$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $0645c946e5db1562$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0645c946e5db1562$var$mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $d8ZDz.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0645c946e5db1562$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $d8ZDz.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $d8ZDz.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $d8ZDz.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $d8ZDz.extend)(normalized, raw);
    if ((0, $d8ZDz.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0645c946e5db1562$var$isEmitListener(options, key) {
    if (!options || !(0, $d8ZDz.isOn)(key)) return false;
    key = key.slice(2);
    key = key === "Once" ? key : key.replace(/Once$/, "");
    return (0, $d8ZDz.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $d8ZDz.hasOwn)(options, (0, $d8ZDz.hyphenate)(key)) || (0, $d8ZDz.hasOwn)(options, key);
}
let $0645c946e5db1562$var$accessedAttrs = false;
function $0645c946e5db1562$var$markAttrsAccessed() {
    $0645c946e5db1562$var$accessedAttrs = true;
}
function $0645c946e5db1562$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0645c946e5db1562$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $0645c946e5db1562$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0645c946e5db1562$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0645c946e5db1562$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0645c946e5db1562$var$blockStack.length = 0;
        $0645c946e5db1562$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0645c946e5db1562$export$bf5c4cf060303d58($0645c946e5db1562$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $d8ZDz.isModelListener))) fallthroughAttrs = $0645c946e5db1562$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0645c946e5db1562$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $0645c946e5db1562$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) {
        const child = $0645c946e5db1562$var$isTeleport(root.type) ? $0645c946e5db1562$var$getInnerChild$1(root) || root : root;
        $0645c946e5db1562$export$7770a22486565649(child, vnode.transition);
    }
    result = root;
    $0645c946e5db1562$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0645c946e5db1562$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0645c946e5db1562$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0645c946e5db1562$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0645c946e5db1562$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0645c946e5db1562$export$3868d13f8734ae81(child)) {
            if (child.type !== $0645c946e5db1562$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0645c946e5db1562$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $d8ZDz.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0645c946e5db1562$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $d8ZDz.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0645c946e5db1562$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0645c946e5db1562$export$4d299b491347818a;
};
function $0645c946e5db1562$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0645c946e5db1562$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if ($0645c946e5db1562$var$hasPropValueChanged(nextProps, prevProps, key) && !$0645c946e5db1562$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0645c946e5db1562$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0645c946e5db1562$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if (!(0, $d8ZDz.hasOwn)(prevProps, key) || $0645c946e5db1562$var$hasPropValueChanged(nextProps, prevProps, key) && !$0645c946e5db1562$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0645c946e5db1562$var$hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && (0, $d8ZDz.isObject)(nextProp) && (0, $d8ZDz.isObject)(prevProp)) return !(0, $d8ZDz.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function $0645c946e5db1562$var$updateHOCHostEl({ vnode: vnode, parent: parent, suspense: suspense }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) {
            root.suspense.vnode.el = root.el = el;
            vnode = root;
        }
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
    if (suspense && suspense.activeBranch === vnode) suspense.vnode.el = el;
}
const $0645c946e5db1562$var$internalObjectProto = {};
const $0645c946e5db1562$var$createInternalObject = ()=>Object.create($0645c946e5db1562$var$internalObjectProto);
const $0645c946e5db1562$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0645c946e5db1562$var$internalObjectProto;
function $0645c946e5db1562$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0645c946e5db1562$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0645c946e5db1562$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $gIp2w.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0645c946e5db1562$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0645c946e5db1562$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $gIp2w.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0645c946e5db1562$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $d8ZDz.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $d8ZDz.camelize)(key);
                        props[camelizedKey] = $0645c946e5db1562$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0645c946e5db1562$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $d8ZDz.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $d8ZDz.hyphenate)(key)) === key || !(0, $d8ZDz.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0645c946e5db1562$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $d8ZDz.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $gIp2w.trigger)(instance.attrs, "set", "");
}
function $0645c946e5db1562$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $d8ZDz.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $d8ZDz.hasOwn)(options, camelKey = (0, $d8ZDz.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0645c946e5db1562$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $gIp2w.toRaw)(props);
        const castValues = rawCastValues || (0, $d8ZDz.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0645c946e5db1562$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $d8ZDz.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0645c946e5db1562$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $d8ZDz.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $d8ZDz.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0645c946e5db1562$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $d8ZDz.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $0645c946e5db1562$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $0645c946e5db1562$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0645c946e5db1562$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $d8ZDz.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0645c946e5db1562$var$normalizePropsOptions(raw2, appContext, true);
            (0, $d8ZDz.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $d8ZDz.isObject)(comp)) cache.set(comp, (0, $d8ZDz.EMPTY_ARR));
        return 0, $d8ZDz.EMPTY_ARR;
    }
    if ((0, $d8ZDz.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $d8ZDz.camelize)(raw[i]);
        if ($0645c946e5db1562$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $d8ZDz.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $d8ZDz.camelize)(key);
        if ($0645c946e5db1562$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $d8ZDz.isArray)(opt) || (0, $d8ZDz.isFunction)(opt) ? {
                type: opt
            } : (0, $d8ZDz.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $d8ZDz.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $d8ZDz.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $d8ZDz.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $d8ZDz.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $d8ZDz.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0645c946e5db1562$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $d8ZDz.isReservedProp)(key)) return true;
    return false;
}
function $0645c946e5db1562$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0645c946e5db1562$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $gIp2w.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $d8ZDz.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0645c946e5db1562$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $0645c946e5db1562$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0645c946e5db1562$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $d8ZDz.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0645c946e5db1562$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0645c946e5db1562$var$warn$1($0645c946e5db1562$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0645c946e5db1562$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0645c946e5db1562$var$isSimpleType = /* @__PURE__ */ (0, $d8ZDz.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0645c946e5db1562$var$assertType(value, type) {
    let valid;
    const expectedType = $0645c946e5db1562$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($0645c946e5db1562$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $d8ZDz.isObject)(value);
    else if (expectedType === "Array") valid = (0, $d8ZDz.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0645c946e5db1562$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $d8ZDz.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $d8ZDz.toRawType)(value);
    const expectedValue = $0645c946e5db1562$var$styleValue(value, expectedType);
    const receivedValue = $0645c946e5db1562$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0645c946e5db1562$var$isExplicable(expectedType) && $0645c946e5db1562$var$isCoercible(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0645c946e5db1562$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0645c946e5db1562$var$styleValue(value, type) {
    if ((0, $d8ZDz.isSymbol)(value)) return value.toString();
    else if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0645c946e5db1562$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0645c946e5db1562$var$isCoercible(...args) {
    return args.every((elem)=>{
        const value = elem.toLowerCase();
        return value !== "boolean" && value !== "symbol";
    });
}
const $0645c946e5db1562$var$isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const $0645c946e5db1562$var$normalizeSlotValue = (value)=>(0, $d8ZDz.isArray)(value) ? value.map($0645c946e5db1562$var$normalizeVNode) : [
        $0645c946e5db1562$var$normalizeVNode(value)
    ];
const $0645c946e5db1562$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0645c946e5db1562$export$694b237e827a3d23((...args)=>{
        return $0645c946e5db1562$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0645c946e5db1562$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0645c946e5db1562$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $d8ZDz.isFunction)(value)) slots[key] = $0645c946e5db1562$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0645c946e5db1562$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0645c946e5db1562$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0645c946e5db1562$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0645c946e5db1562$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$0645c946e5db1562$var$isInternalKey(key)) slots[key] = children[key];
};
const $0645c946e5db1562$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $0645c946e5db1562$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $0645c946e5db1562$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $d8ZDz.def)(slots, "_", type, true);
        } else $0645c946e5db1562$var$normalizeObjectSlots(children, slots);
    } else if (children) $0645c946e5db1562$var$normalizeVNodeSlots(instance, children);
};
const $0645c946e5db1562$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $d8ZDz.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $0645c946e5db1562$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $0645c946e5db1562$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0645c946e5db1562$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0645c946e5db1562$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $0645c946e5db1562$var$supported;
let $0645c946e5db1562$var$perf;
function $0645c946e5db1562$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0645c946e5db1562$var$isSupported()) $0645c946e5db1562$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0645c946e5db1562$var$devtoolsPerfStart(instance, type, $0645c946e5db1562$var$isSupported() ? $0645c946e5db1562$var$perf.now() : Date.now());
}
function $0645c946e5db1562$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0645c946e5db1562$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${$0645c946e5db1562$var$formatComponentName(instance, instance.type)}> ${type}`;
        $0645c946e5db1562$var$perf.mark(endTag);
        $0645c946e5db1562$var$perf.measure(measureName, startTag, endTag);
        $0645c946e5db1562$var$perf.clearMeasures(measureName);
        $0645c946e5db1562$var$perf.clearMarks(startTag);
        $0645c946e5db1562$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0645c946e5db1562$var$devtoolsPerfEnd(instance, type, $0645c946e5db1562$var$isSupported() ? $0645c946e5db1562$var$perf.now() : Date.now());
}
function $0645c946e5db1562$var$isSupported() {
    if ($0645c946e5db1562$var$supported !== void 0) return $0645c946e5db1562$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0645c946e5db1562$var$supported = true;
        $0645c946e5db1562$var$perf = window.performance;
    } else $0645c946e5db1562$var$supported = false;
    return $0645c946e5db1562$var$supported;
}
function $0645c946e5db1562$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $d8ZDz.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $d8ZDz.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $d8ZDz.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $0645c946e5db1562$var$queuePostRenderEffect = $0645c946e5db1562$var$queueEffectWithSuspense;
function $0645c946e5db1562$export$53ae2f996c64e9a(options) {
    return $0645c946e5db1562$var$baseCreateRenderer(options);
}
function $0645c946e5db1562$export$200524cf0d997ff0(options) {
    return $0645c946e5db1562$var$baseCreateRenderer(options, $0645c946e5db1562$var$createHydrationFunctions);
}
function $0645c946e5db1562$var$baseCreateRenderer(options, createHydrationFns) {
    $0645c946e5db1562$var$initFeatureFlags();
    const target = (0, $d8ZDz.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0645c946e5db1562$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $d8ZDz.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0645c946e5db1562$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        if (n2.dynamicChildren && n1 && n1.dynamicChildren && n1.dynamicChildren.hasOnce) {
            if (n2.dynamicChildren === (0, $d8ZDz.EMPTY_ARR)) n2.dynamicChildren = [];
            n2.dynamicChildren.hasOnce = true;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0645c946e5db1562$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0645c946e5db1562$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0645c946e5db1562$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $0645c946e5db1562$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0645c946e5db1562$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $0645c946e5db1562$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0645c946e5db1562$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0645c946e5db1562$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $d8ZDz.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0645c946e5db1562$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $d8ZDz.def)(el, "__vnode", vnode, true);
            (0, $d8ZDz.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $0645c946e5db1562$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0645c946e5db1562$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) {
            const isHmr = false;
            $0645c946e5db1562$var$queuePostRenderEffect(()=>{
                let prev;
                vnodeHook && $0645c946e5db1562$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0645c946e5db1562$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $0645c946e5db1562$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0645c946e5db1562$var$cloneIfMounted(children[i]) : $0645c946e5db1562$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $d8ZDz.EMPTY_OBJ);
        const newProps = n2.props || (0, $d8ZDz.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0645c946e5db1562$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0645c946e5db1562$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0645c946e5db1562$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0645c946e5db1562$var$toggleRecurse(parentComponent, true);
        if (// #6385 the old vnode may be a user-wrapped non-isomorphic block
        // Force full diff when block metadata is unstable.
        dynamicChildren && (!n1.dynamicChildren || n1.dynamicChildren.length !== dynamicChildren.length)) {
            patchFlag = 0;
            optimized = false;
            dynamicChildren = null;
        }
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0645c946e5db1562$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0645c946e5db1562$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0645c946e5db1562$var$queuePostRenderEffect(()=>{
            vnodeHook && $0645c946e5db1562$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0645c946e5db1562$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const oldEl = oldVNode.el || $0645c946e5db1562$var$resolveAsyncComponentPlaceholder(oldVNode);
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldEl && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0645c946e5db1562$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0645c946e5db1562$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldEl) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $d8ZDz.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $d8ZDz.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $d8ZDz.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0645c946e5db1562$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0645c946e5db1562$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0645c946e5db1562$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0645c946e5db1562$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized, namespace);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0645c946e5db1562$export$bf5c4cf060303d58($0645c946e5db1562$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0645c946e5db1562$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                n2.el = n1.el;
                n2.placeholder = n1.placeholder;
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            n2.placeholder = n1.placeholder;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $0645c946e5db1562$var$isAsyncWrapper(initialVNode);
                $0645c946e5db1562$var$toggleRecurse(instance, false);
                if (bm) (0, $d8ZDz.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0645c946e5db1562$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0645c946e5db1562$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0645c946e5db1562$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type, instance.parent ? instance.parent.type : void 0);
                    const subTree = instance.subTree = $0645c946e5db1562$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $0645c946e5db1562$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0645c946e5db1562$var$queuePostRenderEffect(()=>$0645c946e5db1562$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0645c946e5db1562$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0645c946e5db1562$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0645c946e5db1562$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0645c946e5db1562$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            $0645c946e5db1562$var$queuePostRenderEffect(()=>{
                                if (!instance.isUnmounted) update();
                            }, parentSuspense);
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0645c946e5db1562$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $d8ZDz.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0645c946e5db1562$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0645c946e5db1562$var$toggleRecurse(instance, true);
                const nextTree = $0645c946e5db1562$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $0645c946e5db1562$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0645c946e5db1562$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0645c946e5db1562$var$queuePostRenderEffect(()=>$0645c946e5db1562$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0645c946e5db1562$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $gIp2w.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$0645c946e5db1562$var$queueJob(job);
        $0645c946e5db1562$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0645c946e5db1562$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0645c946e5db1562$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $gIp2w.pauseTracking)();
        $0645c946e5db1562$var$flushPreFlushCbs(instance);
        (0, $gIp2w.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $d8ZDz.EMPTY_ARR);
        c2 = c2 || (0, $d8ZDz.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0645c946e5db1562$var$cloneIfMounted(c2[i]) : $0645c946e5db1562$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0645c946e5db1562$var$cloneIfMounted(c2[i]) : $0645c946e5db1562$var$normalizeVNode(c2[i]);
            if ($0645c946e5db1562$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0645c946e5db1562$var$cloneIfMounted(c2[e2]) : $0645c946e5db1562$var$normalizeVNode(c2[e2]);
            if ($0645c946e5db1562$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0645c946e5db1562$var$cloneIfMounted(c2[i]) : $0645c946e5db1562$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0645c946e5db1562$var$cloneIfMounted(c2[i]) : $0645c946e5db1562$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0645c946e5db1562$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0645c946e5db1562$var$getSequence(newIndexToOldIndexMap) : (0, $d8ZDz.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, #14173 fallback to el placeholder for unresolved async component
                anchorVNode.el || $0645c946e5db1562$var$resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0645c946e5db1562$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0645c946e5db1562$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                if (transition.persisted && !el[$0645c946e5db1562$var$leaveCbKey]) hostInsert(el, container, anchor);
                else {
                    transition.beforeEnter(el);
                    hostInsert(el, container, anchor);
                    $0645c946e5db1562$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
                }
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    const wasLeaving = el._isLeaving || !!el[$0645c946e5db1562$var$leaveCbKey];
                    if (el._isLeaving) el[$0645c946e5db1562$var$leaveCbKey](true);
                    if (transition.persisted && !wasLeaving) remove2();
                    else leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex, memo: memo } = vnode;
        if (patchFlag === -2 || dynamicChildren && dynamicChildren.hasOnce) optimized = false;
        if (ref != null) {
            (0, $gIp2w.pauseTracking)();
            $0645c946e5db1562$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $gIp2w.resetTracking)();
        }
        if (cacheIndex != null && (!vnode.ctx || vnode.ctx === parentComponent)) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0645c946e5db1562$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0645c946e5db1562$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0645c946e5db1562$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0645c946e5db1562$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0645c946e5db1562$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        const shouldInvalidateMemo = memo != null && cacheIndex == null;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs || shouldInvalidateMemo) $0645c946e5db1562$var$queuePostRenderEffect(()=>{
            vnodeHook && $0645c946e5db1562$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0645c946e5db1562$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
            if (shouldInvalidateMemo) vnode.el = null;
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        const isFragment = type === $0645c946e5db1562$export$ffb0004e005737fa;
        if (isFragment && !transition) {
            removeFragment(el, anchor);
            return;
        }
        if (type === $0645c946e5db1562$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
            return;
        }
        const leavingNode = isFragment ? $0645c946e5db1562$var$getTransitionRoot(vnode) : vnode;
        const performRemove = ()=>{
            if (isFragment) {
                if (hostParentNode(el)) removeFragment(el, anchor);
            } else hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (leavingNode && leavingNode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const leavingEl = leavingNode.el;
            const performLeave = ()=>leave(leavingEl, performRemove);
            if (delayLeave) delayLeave(leavingEl, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $0645c946e5db1562$var$invalidateMount(m);
        $0645c946e5db1562$var$invalidateMount(a);
        if (bum) (0, $d8ZDz.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        } else if (instance.vnode.el && subTree) {
            subTree.transition = instance.vnode.transition;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0645c946e5db1562$var$queuePostRenderEffect(um, parentSuspense);
        $0645c946e5db1562$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $0645c946e5db1562$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$0645c946e5db1562$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    const render = (vnode, container, namespace)=>{
        const minUid = vnode && container._vnode ? void 0 : vnode && vnode.component ? vnode.component.uid : $0645c946e5db1562$var$getNextUid();
        $0645c946e5db1562$var$flushOnAppMount(()=>{
            if (vnode == null) {
                if (container._vnode) unmount(container._vnode, null, null, true);
            } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
            container._vnode = vnode;
        }, minUid);
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0645c946e5db1562$var$createAppAPI(render, hydrate)
    };
}
function $0645c946e5db1562$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0645c946e5db1562$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $0645c946e5db1562$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0645c946e5db1562$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $d8ZDz.isArray)(ch1) && (0, $d8ZDz.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0645c946e5db1562$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $0645c946e5db1562$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0645c946e5db1562$export$5f1af8db9871e1d6) {
            if (c2.patchFlag === -1) c2 = ch2[i] = $0645c946e5db1562$var$cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === $0645c946e5db1562$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $0645c946e5db1562$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0645c946e5db1562$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0645c946e5db1562$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $0645c946e5db1562$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
function $0645c946e5db1562$var$resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    const instance = anchorVnode.component;
    if (instance) return $0645c946e5db1562$var$resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
const $0645c946e5db1562$var$isSuspense = (type)=>type.__isSuspense;
let $0645c946e5db1562$var$suspenseId = 0;
const $0645c946e5db1562$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0645c946e5db1562$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback && !parentSuspense.isHydrating) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0645c946e5db1562$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0645c946e5db1562$var$hydrateSuspense,
    normalize: $0645c946e5db1562$var$normalizeSuspenseChildren
};
const $0645c946e5db1562$export$74bf444e3cd11ea5 = $0645c946e5db1562$var$SuspenseImpl;
function $0645c946e5db1562$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $d8ZDz.isFunction)(eventListener)) eventListener();
}
function $0645c946e5db1562$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0645c946e5db1562$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0645c946e5db1562$var$triggerEvent(vnode, "onPending");
        $0645c946e5db1562$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0645c946e5db1562$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0645c946e5db1562$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0645c946e5db1562$var$isSameVNodeType(pendingBranch, newBranch)) {
            suspense.deps++;
            patch(pendingBranch, newBranch, // a hydrating pending branch is adopted SSR DOM, already in place
            isHydrating ? container : suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            suspense.deps--;
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating && !suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0645c946e5db1562$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0645c946e5db1562$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else if (!suspense.isFallbackMountPending) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0645c946e5db1562$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0645c946e5db1562$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0645c946e5db1562$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0645c946e5db1562$var$setActiveBranch(suspense, newBranch);
    } else {
        $0645c946e5db1562$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0645c946e5db1562$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0645c946e5db1562$var$hasWarned = false;
function $0645c946e5db1562$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0645c946e5db1562$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $d8ZDz.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0645c946e5db1562$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        isFallbackMountPending: false,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2, isInFallback: isInFallback } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                let hasUpdatedAnchor = false;
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor && !hasUpdatedAnchor ? next(activeBranch) : anchor, 0);
                        $0645c946e5db1562$export$59536a0199721cab(effects);
                        if (isInFallback && vnode2.ssFallback) vnode2.ssFallback.el = null;
                    }
                };
                if (activeBranch && !suspense.isFallbackMountPending) {
                    if (parentNode(activeBranch.el) === container2) {
                        anchor = next(activeBranch);
                        hasUpdatedAnchor = true;
                    }
                    unmount(activeBranch, parentComponent2, suspense, true);
                    if (!delayEnter && isInFallback && vnode2.ssFallback) $0645c946e5db1562$var$queuePostRenderEffect(()=>vnode2.ssFallback.el = null, suspense);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            suspense.isFallbackMountPending = false;
            $0645c946e5db1562$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    for(let i = 0; i < effects.length; i++)parent.effects.push(effects[i]);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0645c946e5db1562$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspenseId = void 0;
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0645c946e5db1562$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0645c946e5db1562$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                suspense.isFallbackMountPending = false;
                if (!suspense.isInFallback) return;
                const latestFallback = suspense.vnode.ssFallback;
                patch(null, latestFallback, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0645c946e5db1562$var$setActiveBranch(suspense, latestFallback);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) {
                suspense.isFallbackMountPending = true;
                activeBranch.transition.afterLeave = mountFallback;
            }
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        // `namespace` intentionally shadows the boundary's own: the dep must be
        // mounted with the namespace of the position it was rendered at, which can
        // differ from the boundary's (e.g. a component nested inside an <svg>).
        registerDep (instance, setupRenderEffect, optimized2, namespace2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0645c946e5db1562$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                $0645c946e5db1562$var$unsetCurrentInstance();
                if (!instance.scope.active) {
                    if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
                    return;
                }
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0645c946e5db1562$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace2, optimized2);
                if (placeholder) {
                    vnode2.placeholder = null;
                    remove(placeholder);
                }
                $0645c946e5db1562$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0645c946e5db1562$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0645c946e5db1562$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0645c946e5db1562$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0645c946e5db1562$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0645c946e5db1562$var$normalizeSuspenseSlot(children.fallback) : $0645c946e5db1562$export$bf5c4cf060303d58($0645c946e5db1562$export$4d299b491347818a);
}
function $0645c946e5db1562$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $d8ZDz.isFunction)(s)) {
        const trackBlock = $0645c946e5db1562$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0645c946e5db1562$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0645c946e5db1562$var$currentBlock;
            $0645c946e5db1562$var$closeBlock();
        }
    }
    if ((0, $d8ZDz.isArray)(s)) {
        const singleChild = $0645c946e5db1562$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0645c946e5db1562$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0645c946e5db1562$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $d8ZDz.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0645c946e5db1562$export$59536a0199721cab(fn);
}
function $0645c946e5db1562$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0645c946e5db1562$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0645c946e5db1562$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0645c946e5db1562$export$ffb0004e005737fa = /* @__PURE__ */ Symbol.for("v-fgt");
const $0645c946e5db1562$export$5f1af8db9871e1d6 = /* @__PURE__ */ Symbol.for("v-txt");
const $0645c946e5db1562$export$4d299b491347818a = /* @__PURE__ */ Symbol.for("v-cmt");
const $0645c946e5db1562$export$c1b9a1d3af45b7b6 = /* @__PURE__ */ Symbol.for("v-stc");
const $0645c946e5db1562$var$blockStack = [];
let $0645c946e5db1562$var$currentBlock = null;
function $0645c946e5db1562$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0645c946e5db1562$var$blockStack.push($0645c946e5db1562$var$currentBlock = disableTracking ? null : []);
}
function $0645c946e5db1562$var$closeBlock() {
    $0645c946e5db1562$var$blockStack.pop();
    $0645c946e5db1562$var$currentBlock = $0645c946e5db1562$var$blockStack[$0645c946e5db1562$var$blockStack.length - 1] || null;
}
let $0645c946e5db1562$var$isBlockTreeEnabled = 1;
function $0645c946e5db1562$export$c20bee82f26f1e27(value, inVOnce = false) {
    $0645c946e5db1562$var$isBlockTreeEnabled += value;
    if (value < 0 && $0645c946e5db1562$var$currentBlock && inVOnce) $0645c946e5db1562$var$currentBlock.hasOnce = true;
}
function $0645c946e5db1562$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0645c946e5db1562$var$isBlockTreeEnabled > 0 ? $0645c946e5db1562$var$currentBlock || (0, $d8ZDz.EMPTY_ARR) : null;
    $0645c946e5db1562$var$closeBlock();
    if ($0645c946e5db1562$var$isBlockTreeEnabled > 0 && $0645c946e5db1562$var$currentBlock) $0645c946e5db1562$var$currentBlock.push(vnode);
    return vnode;
}
function $0645c946e5db1562$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0645c946e5db1562$var$setupBlock($0645c946e5db1562$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0645c946e5db1562$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0645c946e5db1562$var$setupBlock($0645c946e5db1562$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0645c946e5db1562$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0645c946e5db1562$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0645c946e5db1562$var$vnodeArgsTransformer;
function $0645c946e5db1562$export$83beccd3afeeb809(transformer) {
    $0645c946e5db1562$var$vnodeArgsTransformer = transformer;
}
const $0645c946e5db1562$var$createVNodeWithArgsTransform = (...args)=>{
    return $0645c946e5db1562$var$_createVNode(...$0645c946e5db1562$var$vnodeArgsTransformer ? $0645c946e5db1562$var$vnodeArgsTransformer(args, $0645c946e5db1562$var$currentRenderingInstance) : args);
};
const $0645c946e5db1562$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0645c946e5db1562$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $d8ZDz.isString)(ref) || (0, $gIp2w.isRef)(ref) || (0, $d8ZDz.isFunction)(ref) ? {
        i: $0645c946e5db1562$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0645c946e5db1562$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0645c946e5db1562$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0645c946e5db1562$var$normalizeKey(props),
        ref: props && $0645c946e5db1562$var$normalizeRef(props),
        scopeId: $0645c946e5db1562$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0645c946e5db1562$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0645c946e5db1562$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $d8ZDz.isString)(children) ? 8 : 16;
    if ($0645c946e5db1562$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0645c946e5db1562$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0645c946e5db1562$var$currentBlock.push(vnode);
    return vnode;
}
function $0645c946e5db1562$var$hasContentChildren(children) {
    if ((0, $d8ZDz.isString)(children)) return children !== "";
    if ((0, $d8ZDz.isArray)(children)) return children.length > 0;
    return false;
}
const $0645c946e5db1562$export$bf5c4cf060303d58 = $0645c946e5db1562$var$_createVNode;
function $0645c946e5db1562$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0645c946e5db1562$var$NULL_DYNAMIC_COMPONENT) type = $0645c946e5db1562$export$4d299b491347818a;
    if ($0645c946e5db1562$export$3868d13f8734ae81(type)) {
        const cloned = $0645c946e5db1562$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0645c946e5db1562$var$normalizeChildren(cloned, children);
        if ($0645c946e5db1562$var$isBlockTreeEnabled > 0 && !isBlockNode && $0645c946e5db1562$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0645c946e5db1562$var$currentBlock[$0645c946e5db1562$var$currentBlock.indexOf(type)] = cloned;
            else $0645c946e5db1562$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($0645c946e5db1562$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0645c946e5db1562$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $d8ZDz.isString)(klass)) props.class = (0, $d8ZDz.normalizeClass)(klass);
        if ((0, $d8ZDz.isObject)(style)) {
            if ((0, $gIp2w.isProxy)(style) && !(0, $d8ZDz.isArray)(style)) style = (0, $d8ZDz.extend)({}, style);
            props.style = (0, $d8ZDz.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $d8ZDz.isString)(type) ? 1 : $0645c946e5db1562$var$isSuspense(type) ? 128 : $0645c946e5db1562$var$isTeleport(type) ? 64 : (0, $d8ZDz.isObject)(type) ? 4 : (0, $d8ZDz.isFunction)(type) ? 2 : 0;
    return $0645c946e5db1562$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0645c946e5db1562$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $gIp2w.isProxy)(props) || $0645c946e5db1562$var$isInternalObject(props) ? (0, $d8ZDz.extend)({}, props) : props;
}
function $0645c946e5db1562$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0645c946e5db1562$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0645c946e5db1562$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $d8ZDz.isArray)(ref) ? ref.concat($0645c946e5db1562$var$normalizeRef(extraProps)) : [
            ref,
            $0645c946e5db1562$var$normalizeRef(extraProps)
        ] : $0645c946e5db1562$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0645c946e5db1562$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0645c946e5db1562$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0645c946e5db1562$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce,
        cacheIndex: vnode.cacheIndex
    };
    if (transition && cloneTransition) $0645c946e5db1562$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $0645c946e5db1562$var$deepCloneVNode(vnode) {
    const cloned = $0645c946e5db1562$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $d8ZDz.isArray)(vnode.children)) cloned.children = vnode.children.map($0645c946e5db1562$var$deepCloneVNode);
    return cloned;
}
function $0645c946e5db1562$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0645c946e5db1562$export$bf5c4cf060303d58($0645c946e5db1562$export$5f1af8db9871e1d6, null, text, flag);
}
function $0645c946e5db1562$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0645c946e5db1562$export$bf5c4cf060303d58($0645c946e5db1562$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0645c946e5db1562$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0645c946e5db1562$export$e7eaa45e502fe5cc(), $0645c946e5db1562$export$9f2dfe8048dfb22b($0645c946e5db1562$export$4d299b491347818a, null, text)) : $0645c946e5db1562$export$bf5c4cf060303d58($0645c946e5db1562$export$4d299b491347818a, null, text);
}
function $0645c946e5db1562$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0645c946e5db1562$export$bf5c4cf060303d58($0645c946e5db1562$export$4d299b491347818a);
    else if ((0, $d8ZDz.isArray)(child)) return $0645c946e5db1562$export$bf5c4cf060303d58($0645c946e5db1562$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($0645c946e5db1562$export$3868d13f8734ae81(child)) return $0645c946e5db1562$var$cloneIfMounted(child);
    else return $0645c946e5db1562$export$bf5c4cf060303d58($0645c946e5db1562$export$5f1af8db9871e1d6, null, String(child));
}
function $0645c946e5db1562$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0645c946e5db1562$export$ee4f9e12c0a92a1a(child);
}
function $0645c946e5db1562$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $d8ZDz.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0645c946e5db1562$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0645c946e5db1562$var$isInternalObject(children)) children._ctx = $0645c946e5db1562$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0645c946e5db1562$var$currentRenderingInstance) {
                if ($0645c946e5db1562$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $d8ZDz.isFunction)(children)) {
        if (shapeFlag & 65) {
            $0645c946e5db1562$var$normalizeChildren(vnode, {
                default: children
            });
            return;
        }
        children = {
            default: children,
            _ctx: $0645c946e5db1562$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0645c946e5db1562$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0645c946e5db1562$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $d8ZDz.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $d8ZDz.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $d8ZDz.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $d8ZDz.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
                else if (incoming == null && existing == null && // mergeProps({ 'onUpdate:modelValue': undefined }) should not retain
                // the model listener.
                !(0, $d8ZDz.isModelListener)(key)) ret[key] = incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0645c946e5db1562$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0645c946e5db1562$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0645c946e5db1562$var$emptyAppContext = $0645c946e5db1562$var$createAppContext();
let $0645c946e5db1562$var$uid = 0;
function $0645c946e5db1562$var$getNextUid() {
    return $0645c946e5db1562$var$uid;
}
function $0645c946e5db1562$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0645c946e5db1562$var$emptyAppContext;
    const instance = {
        uid: $0645c946e5db1562$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $gIp2w.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0645c946e5db1562$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0645c946e5db1562$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $d8ZDz.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $d8ZDz.EMPTY_OBJ),
        data: (0, $d8ZDz.EMPTY_OBJ),
        props: (0, $d8ZDz.EMPTY_OBJ),
        attrs: (0, $d8ZDz.EMPTY_OBJ),
        slots: (0, $d8ZDz.EMPTY_OBJ),
        refs: (0, $d8ZDz.EMPTY_OBJ),
        setupState: (0, $d8ZDz.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0645c946e5db1562$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0645c946e5db1562$var$currentInstance = null;
const $0645c946e5db1562$export$f13e630aa3915748 = ()=>$0645c946e5db1562$var$currentInstance || $0645c946e5db1562$var$currentRenderingInstance;
let $0645c946e5db1562$var$internalSetCurrentInstance;
let $0645c946e5db1562$var$setInSSRSetupState;
{
    const g = (0, $d8ZDz.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0645c946e5db1562$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0645c946e5db1562$var$currentInstance = v1);
    $0645c946e5db1562$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0645c946e5db1562$var$isInSSRComponentSetup = v1);
}const $0645c946e5db1562$var$setCurrentInstance = (instance)=>{
    const prev = $0645c946e5db1562$var$currentInstance;
    $0645c946e5db1562$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0645c946e5db1562$var$internalSetCurrentInstance(prev);
    };
};
const $0645c946e5db1562$var$unsetCurrentInstance = ()=>{
    $0645c946e5db1562$var$currentInstance && $0645c946e5db1562$var$currentInstance.scope.off();
    $0645c946e5db1562$var$internalSetCurrentInstance(null);
};
const $0645c946e5db1562$var$isBuiltInTag = /* @__PURE__ */ (0, $d8ZDz.makeMap)("slot,component");
function $0645c946e5db1562$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0645c946e5db1562$var$isBuiltInTag(name) || isNativeTag(name)) $0645c946e5db1562$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0645c946e5db1562$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0645c946e5db1562$var$isInSSRComponentSetup = false;
function $0645c946e5db1562$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $0645c946e5db1562$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0645c946e5db1562$var$isStatefulComponent(instance);
    $0645c946e5db1562$var$initProps(instance, props, isStateful, isSSR);
    $0645c946e5db1562$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $0645c946e5db1562$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0645c946e5db1562$var$setInSSRSetupState(false);
    return setupResult;
}
function $0645c946e5db1562$var$setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0645c946e5db1562$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $gIp2w.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $0645c946e5db1562$var$createSetupContext(instance) : null;
        const reset = $0645c946e5db1562$var$setCurrentInstance(instance);
        const setupResult = $0645c946e5db1562$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $d8ZDz.isPromise)(setupResult);
        (0, $gIp2w.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$0645c946e5db1562$var$isAsyncWrapper(instance)) $0645c946e5db1562$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($0645c946e5db1562$var$unsetCurrentInstance, $0645c946e5db1562$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0645c946e5db1562$var$setInSSRSetupState(true);
                try {
                    $0645c946e5db1562$var$handleSetupResult(instance, resolvedResult, isSSR);
                } finally{
                    $0645c946e5db1562$var$setInSSRSetupState(false);
                }
            }).catch((e)=>{
                $0645c946e5db1562$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0645c946e5db1562$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0645c946e5db1562$var$finishComponentSetup(instance, isSSR);
}
function $0645c946e5db1562$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $d8ZDz.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $d8ZDz.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $gIp2w.proxyRefs)(setupResult);
    }
    $0645c946e5db1562$var$finishComponentSetup(instance, isSSR);
}
let $0645c946e5db1562$var$compile;
let $0645c946e5db1562$var$installWithProxy;
function $0645c946e5db1562$export$667bb5a67822b941(_compile) {
    $0645c946e5db1562$var$compile = _compile;
    $0645c946e5db1562$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0645c946e5db1562$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0645c946e5db1562$export$c93a9c496c5211fa = ()=>!$0645c946e5db1562$var$compile;
function $0645c946e5db1562$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0645c946e5db1562$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $0645c946e5db1562$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $d8ZDz.extend)((0, $d8ZDz.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0645c946e5db1562$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $d8ZDz.NOOP);
        if ($0645c946e5db1562$var$installWithProxy) $0645c946e5db1562$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0645c946e5db1562$var$setCurrentInstance(instance);
        (0, $gIp2w.pauseTracking)();
        try {
            $0645c946e5db1562$var$applyOptions(instance);
        } finally{
            (0, $gIp2w.resetTracking)();
            reset();
        }
    }
}
const $0645c946e5db1562$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $gIp2w.track)(target, "get", "");
        return target[key];
    }
};
function $0645c946e5db1562$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $gIp2w.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $0645c946e5db1562$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $0645c946e5db1562$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0645c946e5db1562$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $gIp2w.proxyRefs)((0, $gIp2w.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0645c946e5db1562$var$publicPropertiesMap) return $0645c946e5db1562$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0645c946e5db1562$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $0645c946e5db1562$var$classifyRE = /(?:^|[-_])\w/g;
const $0645c946e5db1562$var$classify = (str)=>str.replace($0645c946e5db1562$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0645c946e5db1562$var$getComponentName(Component, includeInferred = true) {
    return (0, $d8ZDz.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0645c946e5db1562$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0645c946e5db1562$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0645c946e5db1562$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0645c946e5db1562$var$isClassComponent(value) {
    return (0, $d8ZDz.isFunction)(value) && "__vccOpts" in value;
}
const $0645c946e5db1562$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $gIp2w.computed)(getterOrOptions, debugOptions, $0645c946e5db1562$var$isInSSRComponentSetup);
    return c;
};
function $0645c946e5db1562$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $0645c946e5db1562$export$c20bee82f26f1e27(-1);
        const l = arguments.length;
        if (l === 2) {
            if ((0, $d8ZDz.isObject)(propsOrChildren) && !(0, $d8ZDz.isArray)(propsOrChildren)) {
                if ($0645c946e5db1562$export$3868d13f8734ae81(propsOrChildren)) return $0645c946e5db1562$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $0645c946e5db1562$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $0645c946e5db1562$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $0645c946e5db1562$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $0645c946e5db1562$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $0645c946e5db1562$export$c20bee82f26f1e27(1);
    }
}
function $0645c946e5db1562$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $gIp2w.toRaw)(instance.props)));
        if (instance.setupState !== (0, $d8ZDz.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $d8ZDz.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $gIp2w.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $d8ZDz.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $d8ZDz.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $gIp2w.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $d8ZDz.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $d8ZDz.isArray)(opts) && opts.includes(key) || (0, $d8ZDz.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $gIp2w.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0645c946e5db1562$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0645c946e5db1562$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $0645c946e5db1562$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $d8ZDz.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0645c946e5db1562$var$isBlockTreeEnabled > 0 && $0645c946e5db1562$var$currentBlock) $0645c946e5db1562$var$currentBlock.push(cached);
    return true;
}
const $0645c946e5db1562$export$83d89fbfd8236492 = "3.5.44";
const $0645c946e5db1562$export$c106dd0671a0fc2d = (0, $d8ZDz.NOOP);
const $0645c946e5db1562$export$795e0ad4a0e2ed30 = $0645c946e5db1562$var$ErrorTypeStrings$1;
const $0645c946e5db1562$export$6922d3b3a607469e = $0645c946e5db1562$var$devtools$1;
const $0645c946e5db1562$export$b0c258b32c26c785 = $0645c946e5db1562$var$setDevtoolsHook$1;
const $0645c946e5db1562$var$_ssrUtils = {
    createComponentInstance: $0645c946e5db1562$var$createComponentInstance,
    setupComponent: $0645c946e5db1562$var$setupComponent,
    renderComponentRoot: $0645c946e5db1562$var$renderComponentRoot,
    setCurrentRenderingInstance: $0645c946e5db1562$var$setCurrentRenderingInstance,
    isVNode: $0645c946e5db1562$export$3868d13f8734ae81,
    normalizeVNode: $0645c946e5db1562$var$normalizeVNode,
    getComponentPublicInstance: $0645c946e5db1562$var$getComponentPublicInstance,
    ensureValidVNode: $0645c946e5db1562$var$ensureValidVNode,
    pushWarningContext: $0645c946e5db1562$var$pushWarningContext,
    popWarningContext: $0645c946e5db1562$var$popWarningContext
};
const $0645c946e5db1562$export$a9679033567b336d = $0645c946e5db1562$var$_ssrUtils;
const $0645c946e5db1562$export$83cf26e06ea620e1 = null;
const $0645c946e5db1562$export$dc678eddf276286e = null;
const $0645c946e5db1562$export$22072a82865312f6 = null;

});
parcelRegister("gIp2w", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $c2b42dbd3dc3871c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $c2b42dbd3dc3871c$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $c2b42dbd3dc3871c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $c2b42dbd3dc3871c$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $c2b42dbd3dc3871c$export$28352bb4dd362521);
$parcel$export(module.exports, "effect", () => $c2b42dbd3dc3871c$export$dc573d8a6576cdb3);
$parcel$export(module.exports, "stop", () => $c2b42dbd3dc3871c$export$fa6813432f753b0d);
$parcel$export(module.exports, "pauseTracking", () => $c2b42dbd3dc3871c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $c2b42dbd3dc3871c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $c2b42dbd3dc3871c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $c2b42dbd3dc3871c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $c2b42dbd3dc3871c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $c2b42dbd3dc3871c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "isReadonly", () => $c2b42dbd3dc3871c$export$92d09b48637741e7);
$parcel$export(module.exports, "toReactive", () => $c2b42dbd3dc3871c$export$45c769cf449a508c);
$parcel$export(module.exports, "isReactive", () => $c2b42dbd3dc3871c$export$352205f445242f02);
$parcel$export(module.exports, "toReadonly", () => $c2b42dbd3dc3871c$export$4a78e7a2a4fb689f);
$parcel$export(module.exports, "shallowReadArray", () => $c2b42dbd3dc3871c$export$5eb48af14254449e);
$parcel$export(module.exports, "isProxy", () => $c2b42dbd3dc3871c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $c2b42dbd3dc3871c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "readonly", () => $c2b42dbd3dc3871c$export$6ec456bd5b7b3c51);
$parcel$export(module.exports, "reactive", () => $c2b42dbd3dc3871c$export$90a44edba14e47be);
$parcel$export(module.exports, "shallowReactive", () => $c2b42dbd3dc3871c$export$8d81cefd22d22260);
$parcel$export(module.exports, "shallowReadonly", () => $c2b42dbd3dc3871c$export$7c4b5f2b50f09f6b);
$parcel$export(module.exports, "markRaw", () => $c2b42dbd3dc3871c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $c2b42dbd3dc3871c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $c2b42dbd3dc3871c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "triggerRef", () => $c2b42dbd3dc3871c$export$f402f86588575ccc);
$parcel$export(module.exports, "unref", () => $c2b42dbd3dc3871c$export$a239a76781616204);
$parcel$export(module.exports, "toValue", () => $c2b42dbd3dc3871c$export$30bdcc2218aa9458);
$parcel$export(module.exports, "proxyRefs", () => $c2b42dbd3dc3871c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $c2b42dbd3dc3871c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $c2b42dbd3dc3871c$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $c2b42dbd3dc3871c$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "computed", () => $c2b42dbd3dc3871c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "TrackOpTypes", () => $c2b42dbd3dc3871c$export$2ac2bd0a56e04551);
$parcel$export(module.exports, "TriggerOpTypes", () => $c2b42dbd3dc3871c$export$1e8941c92696a26);
$parcel$export(module.exports, "getCurrentWatcher", () => $c2b42dbd3dc3871c$export$2532f7acfca7c82d);
$parcel$export(module.exports, "onWatcherCleanup", () => $c2b42dbd3dc3871c$export$8ddeeb083684a9d0);
$parcel$export(module.exports, "watch", () => $c2b42dbd3dc3871c$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $c2b42dbd3dc3871c$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $d8ZDz = parcelRequire("d8ZDz");
function $c2b42dbd3dc3871c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $c2b42dbd3dc3871c$var$activeEffectScope;
class $c2b42dbd3dc3871c$export$1168ed9dbc71ddbd {
    // TODO isolatedDeclarations "__v_skip"
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this._warnOnRun = true;
        this.__v_skip = true;
        if (!detached && $c2b42dbd3dc3871c$var$activeEffectScope) {
            if ($c2b42dbd3dc3871c$var$activeEffectScope.active) {
                this.parent = $c2b42dbd3dc3871c$var$activeEffectScope;
                this.index = ($c2b42dbd3dc3871c$var$activeEffectScope.scopes || ($c2b42dbd3dc3871c$var$activeEffectScope.scopes = [])).push(this) - 1;
            } else {
                this._active = false;
                this._warnOnRun = false;
            }
        }
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].pause();
            }
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) {
                    const scopes = this.scopes.slice();
                    for(i = 0, l = scopes.length; i < l; i++)scopes[i].resume();
                }
                const effects = this.effects.slice();
                for(i = 0, l = effects.length; i < l; i++)effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $c2b42dbd3dc3871c$var$activeEffectScope;
            try {
                $c2b42dbd3dc3871c$var$activeEffectScope = this;
                return fn();
            } finally{
                $c2b42dbd3dc3871c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $c2b42dbd3dc3871c$var$activeEffectScope;
            $c2b42dbd3dc3871c$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            if ($c2b42dbd3dc3871c$var$activeEffectScope === this) $c2b42dbd3dc3871c$var$activeEffectScope = this.prevScope;
            else {
                let current = $c2b42dbd3dc3871c$var$activeEffectScope;
                while(current){
                    if (current.prevScope === this) {
                        current.prevScope = this.prevScope;
                        break;
                    }
                    current = current.prevScope;
                }
            }
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                const scopes = this.scopes.slice();
                for(i = 0, l = scopes.length; i < l; i++)scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $c2b42dbd3dc3871c$export$7056603ea81600be(detached) {
    return new $c2b42dbd3dc3871c$export$1168ed9dbc71ddbd(detached);
}
function $c2b42dbd3dc3871c$export$c7be4b0125a10cba() {
    return $c2b42dbd3dc3871c$var$activeEffectScope;
}
function $c2b42dbd3dc3871c$export$a780418acd4762da(fn, failSilently = false) {
    if ($c2b42dbd3dc3871c$var$activeEffectScope) $c2b42dbd3dc3871c$var$activeEffectScope.cleanups.push(fn);
}
let $c2b42dbd3dc3871c$var$activeSub;
const $c2b42dbd3dc3871c$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $c2b42dbd3dc3871c$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $c2b42dbd3dc3871c$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($c2b42dbd3dc3871c$var$activeEffectScope) {
            if ($c2b42dbd3dc3871c$var$activeEffectScope.active) $c2b42dbd3dc3871c$var$activeEffectScope.effects.push(this);
            else this.flags &= -2;
        }
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($c2b42dbd3dc3871c$var$pausedQueueEffects.has(this)) {
                $c2b42dbd3dc3871c$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $c2b42dbd3dc3871c$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $c2b42dbd3dc3871c$var$cleanupEffect(this);
        $c2b42dbd3dc3871c$var$prepareDeps(this);
        const prevEffect = $c2b42dbd3dc3871c$var$activeSub;
        const prevShouldTrack = $c2b42dbd3dc3871c$var$shouldTrack;
        $c2b42dbd3dc3871c$var$activeSub = this;
        $c2b42dbd3dc3871c$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $c2b42dbd3dc3871c$var$cleanupDeps(this);
            $c2b42dbd3dc3871c$var$activeSub = prevEffect;
            $c2b42dbd3dc3871c$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$c2b42dbd3dc3871c$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $c2b42dbd3dc3871c$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $c2b42dbd3dc3871c$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($c2b42dbd3dc3871c$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $c2b42dbd3dc3871c$var$isDirty(this);
    }
}
let $c2b42dbd3dc3871c$var$batchDepth = 0;
let $c2b42dbd3dc3871c$var$batchedSub;
let $c2b42dbd3dc3871c$var$batchedComputed;
function $c2b42dbd3dc3871c$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $c2b42dbd3dc3871c$var$batchedComputed;
        $c2b42dbd3dc3871c$var$batchedComputed = sub;
        return;
    }
    sub.next = $c2b42dbd3dc3871c$var$batchedSub;
    $c2b42dbd3dc3871c$var$batchedSub = sub;
}
function $c2b42dbd3dc3871c$var$startBatch() {
    $c2b42dbd3dc3871c$var$batchDepth++;
}
function $c2b42dbd3dc3871c$var$endBatch() {
    if (--$c2b42dbd3dc3871c$var$batchDepth > 0) return;
    if ($c2b42dbd3dc3871c$var$batchedComputed) {
        let e = $c2b42dbd3dc3871c$var$batchedComputed;
        $c2b42dbd3dc3871c$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($c2b42dbd3dc3871c$var$batchedSub){
        let e = $c2b42dbd3dc3871c$var$batchedSub;
        $c2b42dbd3dc3871c$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $c2b42dbd3dc3871c$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $c2b42dbd3dc3871c$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $c2b42dbd3dc3871c$var$removeSub(link);
            $c2b42dbd3dc3871c$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $c2b42dbd3dc3871c$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($c2b42dbd3dc3871c$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $c2b42dbd3dc3871c$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $c2b42dbd3dc3871c$var$globalVersion) return;
    computed.globalVersion = $c2b42dbd3dc3871c$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$c2b42dbd3dc3871c$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $c2b42dbd3dc3871c$var$activeSub;
    const prevShouldTrack = $c2b42dbd3dc3871c$var$shouldTrack;
    $c2b42dbd3dc3871c$var$activeSub = computed;
    $c2b42dbd3dc3871c$var$shouldTrack = true;
    try {
        $c2b42dbd3dc3871c$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $d8ZDz.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $c2b42dbd3dc3871c$var$activeSub = prevSub;
        $c2b42dbd3dc3871c$var$shouldTrack = prevShouldTrack;
        $c2b42dbd3dc3871c$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $c2b42dbd3dc3871c$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$c2b42dbd3dc3871c$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $c2b42dbd3dc3871c$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $c2b42dbd3dc3871c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $c2b42dbd3dc3871c$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $c2b42dbd3dc3871c$export$28352bb4dd362521(fn);
    if (options) (0, $d8ZDz.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $c2b42dbd3dc3871c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $c2b42dbd3dc3871c$var$shouldTrack = true;
const $c2b42dbd3dc3871c$var$trackStack = [];
function $c2b42dbd3dc3871c$export$938a971395fef855() {
    $c2b42dbd3dc3871c$var$trackStack.push($c2b42dbd3dc3871c$var$shouldTrack);
    $c2b42dbd3dc3871c$var$shouldTrack = false;
}
function $c2b42dbd3dc3871c$export$1f8ffc6fd33b1d16() {
    $c2b42dbd3dc3871c$var$trackStack.push($c2b42dbd3dc3871c$var$shouldTrack);
    $c2b42dbd3dc3871c$var$shouldTrack = true;
}
function $c2b42dbd3dc3871c$export$c39176b1babaa8b8() {
    const last = $c2b42dbd3dc3871c$var$trackStack.pop();
    $c2b42dbd3dc3871c$var$shouldTrack = last === void 0 ? true : last;
}
function $c2b42dbd3dc3871c$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($c2b42dbd3dc3871c$var$activeSub instanceof $c2b42dbd3dc3871c$export$28352bb4dd362521) $c2b42dbd3dc3871c$var$activeSub.cleanup = fn;
}
function $c2b42dbd3dc3871c$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $c2b42dbd3dc3871c$var$activeSub;
        $c2b42dbd3dc3871c$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $c2b42dbd3dc3871c$var$activeSub = prevSub;
        }
    }
}
let $c2b42dbd3dc3871c$var$globalVersion = 0;
class $c2b42dbd3dc3871c$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $c2b42dbd3dc3871c$var$Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!$c2b42dbd3dc3871c$var$activeSub || !$c2b42dbd3dc3871c$var$shouldTrack || $c2b42dbd3dc3871c$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $c2b42dbd3dc3871c$var$activeSub) {
            link = this.activeLink = new $c2b42dbd3dc3871c$var$Link($c2b42dbd3dc3871c$var$activeSub, this);
            if (!$c2b42dbd3dc3871c$var$activeSub.deps) $c2b42dbd3dc3871c$var$activeSub.deps = $c2b42dbd3dc3871c$var$activeSub.depsTail = link;
            else {
                link.prevDep = $c2b42dbd3dc3871c$var$activeSub.depsTail;
                $c2b42dbd3dc3871c$var$activeSub.depsTail.nextDep = link;
                $c2b42dbd3dc3871c$var$activeSub.depsTail = link;
            }
            $c2b42dbd3dc3871c$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $c2b42dbd3dc3871c$var$activeSub.depsTail;
                link.nextDep = void 0;
                $c2b42dbd3dc3871c$var$activeSub.depsTail.nextDep = link;
                $c2b42dbd3dc3871c$var$activeSub.depsTail = link;
                if ($c2b42dbd3dc3871c$var$activeSub.deps === link) $c2b42dbd3dc3871c$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $c2b42dbd3dc3871c$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $c2b42dbd3dc3871c$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $c2b42dbd3dc3871c$var$endBatch();
        }
    }
}
function $c2b42dbd3dc3871c$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$c2b42dbd3dc3871c$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $c2b42dbd3dc3871c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $c2b42dbd3dc3871c$export$3c41b1a4e06acc14 = /* @__PURE__ */ Symbol("");
const $c2b42dbd3dc3871c$export$49093fa1cddcb78d = /* @__PURE__ */ Symbol("");
const $c2b42dbd3dc3871c$export$4f926f0baab682cd = /* @__PURE__ */ Symbol("");
function $c2b42dbd3dc3871c$export$6b2a7d5132615086(target, type, key) {
    if ($c2b42dbd3dc3871c$var$shouldTrack && $c2b42dbd3dc3871c$var$activeSub) {
        let depsMap = $c2b42dbd3dc3871c$var$targetMap.get(target);
        if (!depsMap) $c2b42dbd3dc3871c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $c2b42dbd3dc3871c$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $c2b42dbd3dc3871c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $c2b42dbd3dc3871c$var$targetMap.get(target);
    if (!depsMap) {
        $c2b42dbd3dc3871c$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $c2b42dbd3dc3871c$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $d8ZDz.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $d8ZDz.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $c2b42dbd3dc3871c$export$4f926f0baab682cd || !(0, $d8ZDz.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($c2b42dbd3dc3871c$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($c2b42dbd3dc3871c$export$3c41b1a4e06acc14));
                        if ((0, $d8ZDz.isMap)(target)) run(depsMap.get($c2b42dbd3dc3871c$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($c2b42dbd3dc3871c$export$3c41b1a4e06acc14));
                        if ((0, $d8ZDz.isMap)(target)) run(depsMap.get($c2b42dbd3dc3871c$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $d8ZDz.isMap)(target)) run(depsMap.get($c2b42dbd3dc3871c$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $c2b42dbd3dc3871c$var$endBatch();
}
function $c2b42dbd3dc3871c$var$getDepFromReactive(object, key) {
    const depMap = $c2b42dbd3dc3871c$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $c2b42dbd3dc3871c$export$1544eab4943788e4(array) {
    const raw = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $c2b42dbd3dc3871c$export$6b2a7d5132615086(raw, "iterate", $c2b42dbd3dc3871c$export$4f926f0baab682cd);
    if ($c2b42dbd3dc3871c$export$7f3fe6025abfa26e(array)) return raw;
    if (!$c2b42dbd3dc3871c$export$92d09b48637741e7(array)) return raw.map($c2b42dbd3dc3871c$export$45c769cf449a508c);
    return $c2b42dbd3dc3871c$export$352205f445242f02(array) ? raw.map((item)=>$c2b42dbd3dc3871c$export$4a78e7a2a4fb689f($c2b42dbd3dc3871c$export$45c769cf449a508c(item))) : raw.map($c2b42dbd3dc3871c$export$4a78e7a2a4fb689f);
}
function $c2b42dbd3dc3871c$export$5eb48af14254449e(arr) {
    $c2b42dbd3dc3871c$export$6b2a7d5132615086(arr = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(arr), "iterate", $c2b42dbd3dc3871c$export$4f926f0baab682cd);
    return arr;
}
function $c2b42dbd3dc3871c$var$toWrapped(target, item) {
    if ($c2b42dbd3dc3871c$export$92d09b48637741e7(target)) return $c2b42dbd3dc3871c$export$352205f445242f02(target) ? $c2b42dbd3dc3871c$export$4a78e7a2a4fb689f($c2b42dbd3dc3871c$export$45c769cf449a508c(item)) : $c2b42dbd3dc3871c$export$4a78e7a2a4fb689f(item);
    return $c2b42dbd3dc3871c$export$45c769cf449a508c(item);
}
const $c2b42dbd3dc3871c$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $c2b42dbd3dc3871c$var$iterator(this, Symbol.iterator, (item)=>$c2b42dbd3dc3871c$var$toWrapped(this, item));
    },
    concat (...args) {
        return $c2b42dbd3dc3871c$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $d8ZDz.isArray)(x) ? $c2b42dbd3dc3871c$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $c2b42dbd3dc3871c$var$iterator(this, "entries", (value)=>{
            value[1] = $c2b42dbd3dc3871c$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $c2b42dbd3dc3871c$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $c2b42dbd3dc3871c$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$c2b42dbd3dc3871c$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $c2b42dbd3dc3871c$var$apply(this, "find", fn, thisArg, (item)=>$c2b42dbd3dc3871c$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $c2b42dbd3dc3871c$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $c2b42dbd3dc3871c$var$apply(this, "findLast", fn, thisArg, (item)=>$c2b42dbd3dc3871c$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $c2b42dbd3dc3871c$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $c2b42dbd3dc3871c$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $c2b42dbd3dc3871c$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $c2b42dbd3dc3871c$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $c2b42dbd3dc3871c$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $c2b42dbd3dc3871c$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $c2b42dbd3dc3871c$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $c2b42dbd3dc3871c$var$noTracking(this, "pop");
    },
    push (...args) {
        return $c2b42dbd3dc3871c$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $c2b42dbd3dc3871c$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $c2b42dbd3dc3871c$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $c2b42dbd3dc3871c$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $c2b42dbd3dc3871c$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $c2b42dbd3dc3871c$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $c2b42dbd3dc3871c$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $c2b42dbd3dc3871c$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $c2b42dbd3dc3871c$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $c2b42dbd3dc3871c$var$noTracking(this, "unshift", args);
    },
    values () {
        return $c2b42dbd3dc3871c$var$iterator(this, "values", (item)=>$c2b42dbd3dc3871c$var$toWrapped(this, item));
    }
};
function $c2b42dbd3dc3871c$var$iterator(self, method, wrapValue) {
    const arr = $c2b42dbd3dc3871c$export$5eb48af14254449e(self);
    const methodFn = arr[method];
    const iter = methodFn.call(arr);
    if (arr !== self && !$c2b42dbd3dc3871c$export$7f3fe6025abfa26e(self)) {
        if (iter[Symbol.toStringTag] === "Array Iterator") {
            const wrapped = Object.create(Object.getPrototypeOf(iter));
            wrapped.next = ()=>$c2b42dbd3dc3871c$var$wrapResult(iter.next(), wrapValue);
            if (methodFn !== $c2b42dbd3dc3871c$var$arrayProto[method]) Object.defineProperties(wrapped, {
                return: {
                    get () {
                        const fn = iter.return;
                        return typeof fn === "function" ? fn.bind(iter) : fn;
                    }
                },
                throw: {
                    get () {
                        const fn = iter.throw;
                        return typeof fn === "function" ? fn.bind(iter) : fn;
                    }
                }
            });
            return wrapped;
        }
        iter._next = iter.next;
        iter.next = ()=>$c2b42dbd3dc3871c$var$wrapResult(iter._next(), wrapValue);
    }
    return iter;
}
function $c2b42dbd3dc3871c$var$wrapResult(result, wrapValue) {
    if (!result.done) result.value = wrapValue(result.value);
    return result;
}
const $c2b42dbd3dc3871c$var$arrayProto = Array.prototype;
function $c2b42dbd3dc3871c$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $c2b42dbd3dc3871c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$c2b42dbd3dc3871c$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $c2b42dbd3dc3871c$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $c2b42dbd3dc3871c$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $c2b42dbd3dc3871c$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $c2b42dbd3dc3871c$var$reduce(self, method, fn, args) {
    const arr = $c2b42dbd3dc3871c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$c2b42dbd3dc3871c$export$7f3fe6025abfa26e(self);
    let wrappedFn = fn;
    let wrapInitialAccumulator = false;
    if (arr !== self) {
        if (needsWrap) {
            wrapInitialAccumulator = args.length === 0;
            wrappedFn = function(acc, item, index) {
                if (wrapInitialAccumulator) {
                    wrapInitialAccumulator = false;
                    acc = $c2b42dbd3dc3871c$var$toWrapped(self, acc);
                }
                return fn.call(this, acc, $c2b42dbd3dc3871c$var$toWrapped(self, item), index, self);
            };
        } else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    const result = arr[method](wrappedFn, ...args);
    return wrapInitialAccumulator ? $c2b42dbd3dc3871c$var$toWrapped(self, result) : result;
}
function $c2b42dbd3dc3871c$var$searchProxy(self, method, args) {
    const arr = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(self);
    $c2b42dbd3dc3871c$export$6b2a7d5132615086(arr, "iterate", $c2b42dbd3dc3871c$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $c2b42dbd3dc3871c$export$5f3ca29d057519b3(args[0])) {
        args[0] = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $c2b42dbd3dc3871c$var$noTracking(self, method, args = []) {
    $c2b42dbd3dc3871c$export$938a971395fef855();
    $c2b42dbd3dc3871c$var$startBatch();
    const res = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $c2b42dbd3dc3871c$var$endBatch();
    $c2b42dbd3dc3871c$export$c39176b1babaa8b8();
    return res;
}
const $c2b42dbd3dc3871c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $d8ZDz.makeMap)(`__proto__,__v_isRef,__isVue`);
const $c2b42dbd3dc3871c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $d8ZDz.isSymbol)));
function $c2b42dbd3dc3871c$var$hasOwnProperty(key) {
    if (!(0, $d8ZDz.isSymbol)(key)) key = String(key);
    const obj = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(this);
    $c2b42dbd3dc3871c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $c2b42dbd3dc3871c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $c2b42dbd3dc3871c$var$shallowReadonlyMap : $c2b42dbd3dc3871c$var$readonlyMap : isShallow2 ? $c2b42dbd3dc3871c$var$shallowReactiveMap : $c2b42dbd3dc3871c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $d8ZDz.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $c2b42dbd3dc3871c$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $c2b42dbd3dc3871c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $c2b42dbd3dc3871c$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $d8ZDz.isSymbol)(key) ? $c2b42dbd3dc3871c$var$builtInSymbols.has(key) : $c2b42dbd3dc3871c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $c2b42dbd3dc3871c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($c2b42dbd3dc3871c$export$4f9f5282de18fc69(res)) {
            const value = targetIsArray && (0, $d8ZDz.isIntegerKey)(key) ? res : res.value;
            return isReadonly2 && (0, $d8ZDz.isObject)(value) ? $c2b42dbd3dc3871c$export$6ec456bd5b7b3c51(value) : value;
        }
        if ((0, $d8ZDz.isObject)(res)) return isReadonly2 ? $c2b42dbd3dc3871c$export$6ec456bd5b7b3c51(res) : $c2b42dbd3dc3871c$export$90a44edba14e47be(res);
        return res;
    }
}
class $c2b42dbd3dc3871c$var$MutableReactiveHandler extends $c2b42dbd3dc3871c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = (0, $d8ZDz.isArray)(target) && (0, $d8ZDz.isIntegerKey)(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $c2b42dbd3dc3871c$export$92d09b48637741e7(oldValue);
            if (!$c2b42dbd3dc3871c$export$7f3fe6025abfa26e(value) && !$c2b42dbd3dc3871c$export$92d09b48637741e7(value)) {
                oldValue = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(oldValue);
                value = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(value);
            }
            if (!isArrayWithIntegerKey && $c2b42dbd3dc3871c$export$4f9f5282de18fc69(oldValue) && !$c2b42dbd3dc3871c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, $d8ZDz.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $c2b42dbd3dc3871c$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(receiver) && result) {
            if (!hadKey) $c2b42dbd3dc3871c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $d8ZDz.hasChanged)(value, oldValue)) $c2b42dbd3dc3871c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $d8ZDz.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $c2b42dbd3dc3871c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $d8ZDz.isSymbol)(key) || !$c2b42dbd3dc3871c$var$builtInSymbols.has(key)) $c2b42dbd3dc3871c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $c2b42dbd3dc3871c$export$6b2a7d5132615086(target, "iterate", (0, $d8ZDz.isArray)(target) ? "length" : $c2b42dbd3dc3871c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $c2b42dbd3dc3871c$var$ReadonlyReactiveHandler extends $c2b42dbd3dc3871c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $c2b42dbd3dc3871c$var$mutableHandlers = /* @__PURE__ */ new $c2b42dbd3dc3871c$var$MutableReactiveHandler();
const $c2b42dbd3dc3871c$var$readonlyHandlers = /* @__PURE__ */ new $c2b42dbd3dc3871c$var$ReadonlyReactiveHandler();
const $c2b42dbd3dc3871c$var$shallowReactiveHandlers = /* @__PURE__ */ new $c2b42dbd3dc3871c$var$MutableReactiveHandler(true);
const $c2b42dbd3dc3871c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $c2b42dbd3dc3871c$var$ReadonlyReactiveHandler(true);
const $c2b42dbd3dc3871c$var$toShallow = (value)=>value;
const $c2b42dbd3dc3871c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $c2b42dbd3dc3871c$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $d8ZDz.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $c2b42dbd3dc3871c$var$toShallow : isReadonly2 ? $c2b42dbd3dc3871c$export$4a78e7a2a4fb689f : $c2b42dbd3dc3871c$export$45c769cf449a508c;
        !isReadonly2 && $c2b42dbd3dc3871c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $c2b42dbd3dc3871c$export$49093fa1cddcb78d : $c2b42dbd3dc3871c$export$3c41b1a4e06acc14);
        return (0, $d8ZDz.extend)(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $c2b42dbd3dc3871c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $c2b42dbd3dc3871c$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(target);
            const rawKey = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $d8ZDz.hasChanged)(key, rawKey)) $c2b42dbd3dc3871c$export$6b2a7d5132615086(rawTarget, "get", key);
                $c2b42dbd3dc3871c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $c2b42dbd3dc3871c$var$getProto(rawTarget);
            const wrap = shallow ? $c2b42dbd3dc3871c$var$toShallow : readonly ? $c2b42dbd3dc3871c$export$4a78e7a2a4fb689f : $c2b42dbd3dc3871c$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $c2b42dbd3dc3871c$export$6b2a7d5132615086($c2b42dbd3dc3871c$export$ab18938b9fc5f28e(target), "iterate", $c2b42dbd3dc3871c$export$3c41b1a4e06acc14);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(target);
            const rawKey = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $d8ZDz.hasChanged)(key, rawKey)) $c2b42dbd3dc3871c$export$6b2a7d5132615086(rawTarget, "has", key);
                $c2b42dbd3dc3871c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $c2b42dbd3dc3871c$var$toShallow : readonly ? $c2b42dbd3dc3871c$export$4a78e7a2a4fb689f : $c2b42dbd3dc3871c$export$45c769cf449a508c;
            !readonly && $c2b42dbd3dc3871c$export$6b2a7d5132615086(rawTarget, "iterate", $c2b42dbd3dc3871c$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $d8ZDz.extend)(instrumentations, readonly ? {
        add: $c2b42dbd3dc3871c$var$createReadonlyMethod("add"),
        set: $c2b42dbd3dc3871c$var$createReadonlyMethod("set"),
        delete: $c2b42dbd3dc3871c$var$createReadonlyMethod("delete"),
        clear: $c2b42dbd3dc3871c$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            const target = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(this);
            const proto = $c2b42dbd3dc3871c$var$getProto(target);
            const rawValue = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(value);
            const valueToAdd = !shallow && !$c2b42dbd3dc3871c$export$7f3fe6025abfa26e(value) && !$c2b42dbd3dc3871c$export$92d09b48637741e7(value) ? rawValue : value;
            const hadKey = proto.has.call(target, valueToAdd) || (0, $d8ZDz.hasChanged)(value, valueToAdd) && proto.has.call(target, value) || (0, $d8ZDz.hasChanged)(rawValue, valueToAdd) && proto.has.call(target, rawValue);
            if (!hadKey) {
                target.add(valueToAdd);
                $c2b42dbd3dc3871c$export$e614dc9140f7ae71(target, "add", valueToAdd, valueToAdd);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$c2b42dbd3dc3871c$export$7f3fe6025abfa26e(value) && !$c2b42dbd3dc3871c$export$92d09b48637741e7(value)) value = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(value);
            const target = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $c2b42dbd3dc3871c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $c2b42dbd3dc3871c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $d8ZDz.hasChanged)(value, oldValue)) $c2b42dbd3dc3871c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $c2b42dbd3dc3871c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $c2b42dbd3dc3871c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $c2b42dbd3dc3871c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $c2b42dbd3dc3871c$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $c2b42dbd3dc3871c$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $c2b42dbd3dc3871c$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return shallow;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $d8ZDz.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $c2b42dbd3dc3871c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $c2b42dbd3dc3871c$var$createInstrumentationGetter(false, false)
};
const $c2b42dbd3dc3871c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $c2b42dbd3dc3871c$var$createInstrumentationGetter(false, true)
};
const $c2b42dbd3dc3871c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $c2b42dbd3dc3871c$var$createInstrumentationGetter(true, false)
};
const $c2b42dbd3dc3871c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $c2b42dbd3dc3871c$var$createInstrumentationGetter(true, true)
};
function $c2b42dbd3dc3871c$var$checkIdentityKeys(target, has, key) {
    const rawKey = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $d8ZDz.toRawType)(target);
        $c2b42dbd3dc3871c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $c2b42dbd3dc3871c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $c2b42dbd3dc3871c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $c2b42dbd3dc3871c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $c2b42dbd3dc3871c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $c2b42dbd3dc3871c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$90a44edba14e47be(target) {
    if (/* @__PURE__ */ $c2b42dbd3dc3871c$export$92d09b48637741e7(target)) return target;
    return $c2b42dbd3dc3871c$var$createReactiveObject(target, false, $c2b42dbd3dc3871c$var$mutableHandlers, $c2b42dbd3dc3871c$var$mutableCollectionHandlers, $c2b42dbd3dc3871c$var$reactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$8d81cefd22d22260(target) {
    return $c2b42dbd3dc3871c$var$createReactiveObject(target, false, $c2b42dbd3dc3871c$var$shallowReactiveHandlers, $c2b42dbd3dc3871c$var$shallowCollectionHandlers, $c2b42dbd3dc3871c$var$shallowReactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$6ec456bd5b7b3c51(target) {
    return $c2b42dbd3dc3871c$var$createReactiveObject(target, true, $c2b42dbd3dc3871c$var$readonlyHandlers, $c2b42dbd3dc3871c$var$readonlyCollectionHandlers, $c2b42dbd3dc3871c$var$readonlyMap);
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$7c4b5f2b50f09f6b(target) {
    return $c2b42dbd3dc3871c$var$createReactiveObject(target, true, $c2b42dbd3dc3871c$var$shallowReadonlyHandlers, $c2b42dbd3dc3871c$var$shallowReadonlyCollectionHandlers, $c2b42dbd3dc3871c$var$shallowReadonlyMap);
}
function $c2b42dbd3dc3871c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $d8ZDz.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    if (target["__v_skip"] || !Object.isExtensible(target)) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $c2b42dbd3dc3871c$var$targetTypeMap((0, $d8ZDz.toRawType)(target));
    if (targetType === 0 /* INVALID */ ) return target;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$352205f445242f02(value) {
    if (/* @__PURE__ */ $c2b42dbd3dc3871c$export$92d09b48637741e7(value)) return /* @__PURE__ */ $c2b42dbd3dc3871c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(raw) : observed;
}
function $c2b42dbd3dc3871c$export$995ab8b13ad7a9d0(value) {
    if (!(0, $d8ZDz.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $d8ZDz.def)(value, "__v_skip", true);
    return value;
}
const $c2b42dbd3dc3871c$export$45c769cf449a508c = (value)=>(0, $d8ZDz.isObject)(value) ? /* @__PURE__ */ $c2b42dbd3dc3871c$export$90a44edba14e47be(value) : value;
const $c2b42dbd3dc3871c$export$4a78e7a2a4fb689f = (value)=>(0, $d8ZDz.isObject)(value) ? /* @__PURE__ */ $c2b42dbd3dc3871c$export$6ec456bd5b7b3c51(value) : value;
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$eff4d24c3ff7876e(value) {
    return $c2b42dbd3dc3871c$var$createRef(value, false);
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$9b7bc5fe3b17c8b3(value) {
    return $c2b42dbd3dc3871c$var$createRef(value, true);
}
function $c2b42dbd3dc3871c$var$createRef(rawValue, shallow) {
    if (/* @__PURE__ */ $c2b42dbd3dc3871c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $c2b42dbd3dc3871c$var$RefImpl(rawValue, shallow);
}
class $c2b42dbd3dc3871c$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $c2b42dbd3dc3871c$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $c2b42dbd3dc3871c$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $c2b42dbd3dc3871c$export$7f3fe6025abfa26e(newValue) || $c2b42dbd3dc3871c$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(newValue);
        if ((0, $d8ZDz.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $c2b42dbd3dc3871c$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $c2b42dbd3dc3871c$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $c2b42dbd3dc3871c$export$a239a76781616204(ref2) {
    return /* @__PURE__ */ $c2b42dbd3dc3871c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $c2b42dbd3dc3871c$export$30bdcc2218aa9458(source) {
    return (0, $d8ZDz.isFunction)(source) ? source() : $c2b42dbd3dc3871c$export$a239a76781616204(source);
}
const $c2b42dbd3dc3871c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $c2b42dbd3dc3871c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (/* @__PURE__ */ $c2b42dbd3dc3871c$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $c2b42dbd3dc3871c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $c2b42dbd3dc3871c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $c2b42dbd3dc3871c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $c2b42dbd3dc3871c$var$shallowUnwrapHandlers);
}
class $c2b42dbd3dc3871c$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $c2b42dbd3dc3871c$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $c2b42dbd3dc3871c$export$a20c2dd6199824cb(factory) {
    return new $c2b42dbd3dc3871c$var$CustomRefImpl(factory);
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$2e9533675e5e70e0(object) {
    const ret = (0, $d8ZDz.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $c2b42dbd3dc3871c$var$propertyToRef(object, key);
    return ret;
}
class $c2b42dbd3dc3871c$var$ObjectRefImpl {
    constructor(_object, key, _defaultValue){
        this._object = _object;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._key = (0, $d8ZDz.isSymbol)(key) ? key : String(key);
        this._raw = $c2b42dbd3dc3871c$export$ab18938b9fc5f28e(_object);
        let shallow = true;
        let obj = _object;
        if (!(0, $d8ZDz.isArray)(_object) || (0, $d8ZDz.isSymbol)(this._key) || !(0, $d8ZDz.isIntegerKey)(this._key)) do shallow = !$c2b42dbd3dc3871c$export$5f3ca29d057519b3(obj) || $c2b42dbd3dc3871c$export$7f3fe6025abfa26e(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    get value() {
        let val = this._object[this._key];
        if (this._shallow) val = $c2b42dbd3dc3871c$export$a239a76781616204(val);
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        if (this._shallow && /* @__PURE__ */ $c2b42dbd3dc3871c$export$4f9f5282de18fc69(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ $c2b42dbd3dc3871c$export$4f9f5282de18fc69(nestedRef)) {
                nestedRef.value = newVal;
                return;
            }
        }
        this._object[this._key] = newVal;
    }
    get dep() {
        return $c2b42dbd3dc3871c$var$getDepFromReactive(this._raw, this._key);
    }
}
class $c2b42dbd3dc3871c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if (/* @__PURE__ */ $c2b42dbd3dc3871c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $d8ZDz.isFunction)(source)) return new $c2b42dbd3dc3871c$var$GetterRefImpl(source);
    else if ((0, $d8ZDz.isObject)(source) && arguments.length > 1) return $c2b42dbd3dc3871c$var$propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ $c2b42dbd3dc3871c$export$eff4d24c3ff7876e(source);
}
function $c2b42dbd3dc3871c$var$propertyToRef(source, key, defaultValue) {
    return new $c2b42dbd3dc3871c$var$ObjectRefImpl(source, key, defaultValue);
}
class $c2b42dbd3dc3871c$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $c2b42dbd3dc3871c$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $c2b42dbd3dc3871c$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $c2b42dbd3dc3871c$var$activeSub !== this) {
            $c2b42dbd3dc3871c$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $c2b42dbd3dc3871c$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
// @__NO_SIDE_EFFECTS__
function $c2b42dbd3dc3871c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $d8ZDz.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $c2b42dbd3dc3871c$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $c2b42dbd3dc3871c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $c2b42dbd3dc3871c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $c2b42dbd3dc3871c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $c2b42dbd3dc3871c$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $c2b42dbd3dc3871c$var$INITIAL_WATCHER_VALUE = {};
const $c2b42dbd3dc3871c$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $c2b42dbd3dc3871c$var$activeWatcher = void 0;
function $c2b42dbd3dc3871c$export$2532f7acfca7c82d() {
    return $c2b42dbd3dc3871c$var$activeWatcher;
}
function $c2b42dbd3dc3871c$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $c2b42dbd3dc3871c$var$activeWatcher) {
    if (owner) {
        let cleanups = $c2b42dbd3dc3871c$var$cleanupMap.get(owner);
        if (!cleanups) $c2b42dbd3dc3871c$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $c2b42dbd3dc3871c$export$3db5d71bdb2d5499(source, cb, options = (0, $d8ZDz.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $c2b42dbd3dc3871c$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($c2b42dbd3dc3871c$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $c2b42dbd3dc3871c$export$df3f009e3d155b20(source2, 1);
        return $c2b42dbd3dc3871c$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($c2b42dbd3dc3871c$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $c2b42dbd3dc3871c$export$7f3fe6025abfa26e(source);
    } else if ($c2b42dbd3dc3871c$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $d8ZDz.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$c2b42dbd3dc3871c$export$352205f445242f02(s) || $c2b42dbd3dc3871c$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($c2b42dbd3dc3871c$export$4f9f5282de18fc69(s)) return s.value;
                else if ($c2b42dbd3dc3871c$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $d8ZDz.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $d8ZDz.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $c2b42dbd3dc3871c$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $c2b42dbd3dc3871c$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $c2b42dbd3dc3871c$var$activeWatcher;
            $c2b42dbd3dc3871c$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $c2b42dbd3dc3871c$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $d8ZDz.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$c2b42dbd3dc3871c$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $c2b42dbd3dc3871c$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $d8ZDz.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            try {
                return _cb(...args);
            } finally{
                watchHandle();
            }
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($c2b42dbd3dc3871c$var$INITIAL_WATCHER_VALUE) : $c2b42dbd3dc3871c$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (immediateFirstRun || deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $d8ZDz.hasChanged)(v, oldValue[i])) : (0, $d8ZDz.hasChanged)(newValue, oldValue))) {
                const currentWatcher = $c2b42dbd3dc3871c$var$activeWatcher;
                $c2b42dbd3dc3871c$export$938a971395fef855();
                try {
                    if (cleanup) cleanup();
                    $c2b42dbd3dc3871c$var$activeWatcher = effect;
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $c2b42dbd3dc3871c$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $c2b42dbd3dc3871c$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $c2b42dbd3dc3871c$var$activeWatcher = currentWatcher;
                    $c2b42dbd3dc3871c$export$c39176b1babaa8b8();
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $c2b42dbd3dc3871c$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$c2b42dbd3dc3871c$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $c2b42dbd3dc3871c$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $c2b42dbd3dc3871c$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $c2b42dbd3dc3871c$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $d8ZDz.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if ($c2b42dbd3dc3871c$export$4f9f5282de18fc69(value)) $c2b42dbd3dc3871c$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $d8ZDz.isArray)(value)) for(let i = 0; i < value.length; i++)$c2b42dbd3dc3871c$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $d8ZDz.isSet)(value) || (0, $d8ZDz.isMap)(value)) value.forEach((v)=>{
        $c2b42dbd3dc3871c$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $d8ZDz.isPlainObject)(value)) {
        for(const key in value)$c2b42dbd3dc3871c$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $c2b42dbd3dc3871c$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("d8ZDz", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $991bd59ba433ba6f$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $991bd59ba433ba6f$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $991bd59ba433ba6f$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $991bd59ba433ba6f$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $991bd59ba433ba6f$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $991bd59ba433ba6f$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $991bd59ba433ba6f$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $991bd59ba433ba6f$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $991bd59ba433ba6f$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $991bd59ba433ba6f$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $991bd59ba433ba6f$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $991bd59ba433ba6f$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $991bd59ba433ba6f$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $991bd59ba433ba6f$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $991bd59ba433ba6f$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $991bd59ba433ba6f$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $991bd59ba433ba6f$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $991bd59ba433ba6f$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $991bd59ba433ba6f$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $991bd59ba433ba6f$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $991bd59ba433ba6f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $991bd59ba433ba6f$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $991bd59ba433ba6f$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $991bd59ba433ba6f$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $991bd59ba433ba6f$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $991bd59ba433ba6f$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $991bd59ba433ba6f$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $991bd59ba433ba6f$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $991bd59ba433ba6f$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $991bd59ba433ba6f$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $991bd59ba433ba6f$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $991bd59ba433ba6f$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $991bd59ba433ba6f$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $991bd59ba433ba6f$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $991bd59ba433ba6f$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $991bd59ba433ba6f$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $991bd59ba433ba6f$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $991bd59ba433ba6f$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "normalizeProps", () => $991bd59ba433ba6f$export$601abcd8103db5e4);
$parcel$export(module.exports, "isHTMLTag", () => $991bd59ba433ba6f$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $991bd59ba433ba6f$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $991bd59ba433ba6f$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $991bd59ba433ba6f$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $991bd59ba433ba6f$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $991bd59ba433ba6f$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $991bd59ba433ba6f$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $991bd59ba433ba6f$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $991bd59ba433ba6f$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $991bd59ba433ba6f$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $991bd59ba433ba6f$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $991bd59ba433ba6f$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $991bd59ba433ba6f$export$b5b1545233b45293);
$parcel$export(module.exports, "normalizeCssVarValue", () => $991bd59ba433ba6f$export$97fe3d6453ee2f5e);
/**
* @vue/shared v3.5.44
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__
function $991bd59ba433ba6f$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $991bd59ba433ba6f$export$cf583d23ab39677c = {};
const $991bd59ba433ba6f$export$6bd8558f433f1cc1 = [];
const $991bd59ba433ba6f$export$5702a91a6f42969f = ()=>{};
const $991bd59ba433ba6f$export$c01351c0af048e39 = ()=>false;
const $991bd59ba433ba6f$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $991bd59ba433ba6f$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $991bd59ba433ba6f$export$8b58be045bf06082 = Object.assign;
const $991bd59ba433ba6f$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $991bd59ba433ba6f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $991bd59ba433ba6f$export$b5a638e9b3fff9f3 = (val, key)=>$991bd59ba433ba6f$var$hasOwnProperty.call(val, key);
const $991bd59ba433ba6f$export$43bee75e5e14138e = Array.isArray;
const $991bd59ba433ba6f$export$5c90113a285f2241 = (val)=>$991bd59ba433ba6f$export$1dccc787cc36538b(val) === "[object Map]";
const $991bd59ba433ba6f$export$6750766a7c7ec627 = (val)=>$991bd59ba433ba6f$export$1dccc787cc36538b(val) === "[object Set]";
const $991bd59ba433ba6f$export$871608497c498473 = (val)=>$991bd59ba433ba6f$export$1dccc787cc36538b(val) === "[object Date]";
const $991bd59ba433ba6f$export$49841c62b9eff15 = (val)=>$991bd59ba433ba6f$export$1dccc787cc36538b(val) === "[object RegExp]";
const $991bd59ba433ba6f$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $991bd59ba433ba6f$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $991bd59ba433ba6f$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $991bd59ba433ba6f$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $991bd59ba433ba6f$export$4369c812aac99591 = (val)=>{
    return ($991bd59ba433ba6f$export$a6cdc56e425d0d0a(val) || $991bd59ba433ba6f$export$f6e2535fb5126e54(val)) && $991bd59ba433ba6f$export$f6e2535fb5126e54(val.then) && $991bd59ba433ba6f$export$f6e2535fb5126e54(val.catch);
};
const $991bd59ba433ba6f$export$830c053460e5ddf6 = Object.prototype.toString;
const $991bd59ba433ba6f$export$1dccc787cc36538b = (value)=>$991bd59ba433ba6f$export$830c053460e5ddf6.call(value);
const $991bd59ba433ba6f$export$5ad0a3c360b8fbb5 = (value)=>{
    return $991bd59ba433ba6f$export$1dccc787cc36538b(value).slice(8, -1);
};
const $991bd59ba433ba6f$export$53b83ca8eaab0383 = (val)=>$991bd59ba433ba6f$export$1dccc787cc36538b(val) === "[object Object]";
const $991bd59ba433ba6f$export$e2a2b93446ec9fe = (key)=>$991bd59ba433ba6f$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $991bd59ba433ba6f$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $991bd59ba433ba6f$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $991bd59ba433ba6f$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $991bd59ba433ba6f$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $991bd59ba433ba6f$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $991bd59ba433ba6f$var$camelizeRE = /-\w/g;
const $991bd59ba433ba6f$export$161d051f5dd25de7 = $991bd59ba433ba6f$var$cacheStringFunction((str)=>{
    return str.replace($991bd59ba433ba6f$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
const $991bd59ba433ba6f$var$hyphenateRE = /\B([A-Z])/g;
const $991bd59ba433ba6f$export$6e6a0a3676c4b8bb = $991bd59ba433ba6f$var$cacheStringFunction((str)=>str.replace($991bd59ba433ba6f$var$hyphenateRE, "-$1").toLowerCase());
const $991bd59ba433ba6f$export$9a00dee1beb8f576 = $991bd59ba433ba6f$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $991bd59ba433ba6f$export$8c022799eeaaefcd = $991bd59ba433ba6f$var$cacheStringFunction((str)=>{
    const s = str ? `on${$991bd59ba433ba6f$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $991bd59ba433ba6f$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $991bd59ba433ba6f$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $991bd59ba433ba6f$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $991bd59ba433ba6f$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $991bd59ba433ba6f$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $991bd59ba433ba6f$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $991bd59ba433ba6f$var$_globalThis;
const $991bd59ba433ba6f$export$ff5f2eeb11fc7e14 = ()=>{
    return $991bd59ba433ba6f$var$_globalThis || ($991bd59ba433ba6f$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $991bd59ba433ba6f$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $991bd59ba433ba6f$export$53d5e12f9a1d3cde(name) {
    return $991bd59ba433ba6f$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $991bd59ba433ba6f$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $991bd59ba433ba6f$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $991bd59ba433ba6f$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $991bd59ba433ba6f$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $991bd59ba433ba6f$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $991bd59ba433ba6f$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $991bd59ba433ba6f$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $991bd59ba433ba6f$export$f73b8c13b7f97ebf = /* @__PURE__ */ $991bd59ba433ba6f$export$b41394a5437791c8($991bd59ba433ba6f$var$GLOBALS_ALLOWED);
const $991bd59ba433ba6f$export$d6571a1911e4f27e = $991bd59ba433ba6f$export$f73b8c13b7f97ebf;
const $991bd59ba433ba6f$var$range = 2;
function $991bd59ba433ba6f$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $991bd59ba433ba6f$var$range; j <= i + $991bd59ba433ba6f$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $991bd59ba433ba6f$export$8756898546458274(value) {
    if ($991bd59ba433ba6f$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $991bd59ba433ba6f$export$844ec244b1367d54(item) ? $991bd59ba433ba6f$export$76a205ce979d066a(item) : $991bd59ba433ba6f$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($991bd59ba433ba6f$export$844ec244b1367d54(value) || $991bd59ba433ba6f$export$a6cdc56e425d0d0a(value)) return value;
}
const $991bd59ba433ba6f$var$listDelimiterRE = /;(?![^(]*\))/g;
const $991bd59ba433ba6f$var$propertyDelimiterRE = /:([^]+)/;
const $991bd59ba433ba6f$var$styleCommentRE = /"(?:[^"\\]|\\[^])*"|'(?:[^'\\]|\\[^])*'|\\[^]|\/\*[^]*?\*\//g;
function $991bd59ba433ba6f$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($991bd59ba433ba6f$var$styleCommentRE, (match)=>match.startsWith("/*") ? "" : match).split($991bd59ba433ba6f$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($991bd59ba433ba6f$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $991bd59ba433ba6f$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($991bd59ba433ba6f$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($991bd59ba433ba6f$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $991bd59ba433ba6f$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $991bd59ba433ba6f$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($991bd59ba433ba6f$export$844ec244b1367d54(value)) res = value;
    else if ($991bd59ba433ba6f$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $991bd59ba433ba6f$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($991bd59ba433ba6f$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $991bd59ba433ba6f$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$991bd59ba433ba6f$export$844ec244b1367d54(klass)) props.class = $991bd59ba433ba6f$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $991bd59ba433ba6f$export$8756898546458274(style);
    return props;
}
const $991bd59ba433ba6f$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $991bd59ba433ba6f$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $991bd59ba433ba6f$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $991bd59ba433ba6f$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $991bd59ba433ba6f$export$1ccf854a0984f890 = /* @__PURE__ */ $991bd59ba433ba6f$export$b41394a5437791c8($991bd59ba433ba6f$var$HTML_TAGS);
const $991bd59ba433ba6f$export$6328ce7565ea1049 = /* @__PURE__ */ $991bd59ba433ba6f$export$b41394a5437791c8($991bd59ba433ba6f$var$SVG_TAGS);
const $991bd59ba433ba6f$export$4a46ca4c5be17b20 = /* @__PURE__ */ $991bd59ba433ba6f$export$b41394a5437791c8($991bd59ba433ba6f$var$MATH_TAGS);
const $991bd59ba433ba6f$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $991bd59ba433ba6f$export$b41394a5437791c8($991bd59ba433ba6f$var$VOID_TAGS);
const $991bd59ba433ba6f$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,playsinline,readonly`;
const $991bd59ba433ba6f$export$d186f5eb2e810715 = /* @__PURE__ */ $991bd59ba433ba6f$export$b41394a5437791c8($991bd59ba433ba6f$var$specialBooleanAttrs);
const $991bd59ba433ba6f$export$f763ba3b84e9cd8c = /* @__PURE__ */ $991bd59ba433ba6f$export$b41394a5437791c8($991bd59ba433ba6f$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $991bd59ba433ba6f$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $991bd59ba433ba6f$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u000d\u0020]/;
const $991bd59ba433ba6f$var$attrValidationCache = {};
function $991bd59ba433ba6f$export$d55ef77660f30d12(name) {
    if ($991bd59ba433ba6f$var$attrValidationCache.hasOwnProperty(name)) return $991bd59ba433ba6f$var$attrValidationCache[name];
    const isUnsafe = $991bd59ba433ba6f$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $991bd59ba433ba6f$var$attrValidationCache[name] = !isUnsafe;
}
const $991bd59ba433ba6f$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $991bd59ba433ba6f$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $991bd59ba433ba6f$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $991bd59ba433ba6f$export$80da416f43933831 = /* @__PURE__ */ $991bd59ba433ba6f$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $991bd59ba433ba6f$export$fc0748a8e0014066 = /* @__PURE__ */ $991bd59ba433ba6f$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $991bd59ba433ba6f$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $991bd59ba433ba6f$var$escapeRE = /["'&<>]/;
function $991bd59ba433ba6f$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $991bd59ba433ba6f$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $991bd59ba433ba6f$var$commentStripRE = /^(?:-?>)+|<!--|-->|--!>|<!-$/g;
function $991bd59ba433ba6f$export$7b105034a53bde5f(src) {
    let prev;
    do {
        prev = src;
        src = src.replace($991bd59ba433ba6f$var$commentStripRE, "");
    }while (src !== prev);
    return src;
}
const $991bd59ba433ba6f$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $991bd59ba433ba6f$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($991bd59ba433ba6f$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $991bd59ba433ba6f$var$looseCompareArrays(a, b, seen) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $991bd59ba433ba6f$export$ae8015769846262c(a[i], b[i], seen);
    return equal;
}
function $991bd59ba433ba6f$var$looseCompareCollections(a, b, seen) {
    if (a.size !== b.size) return false;
    const candidates = Array.from(b);
    const matched = new Uint8Array(candidates.length);
    for (const item of a){
        let index = -1;
        for(let i = 0; i < candidates.length; i++)if (!matched[i] && $991bd59ba433ba6f$export$ae8015769846262c(item, candidates[i], seen)) {
            index = i;
            break;
        }
        if (index < 0) return false;
        matched[index] = 1;
    }
    return true;
}
function $991bd59ba433ba6f$var$looseCompareObjects(a, b, seen) {
    let aValidType = $991bd59ba433ba6f$export$5c90113a285f2241(a);
    let bValidType = $991bd59ba433ba6f$export$5c90113a285f2241(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $991bd59ba433ba6f$var$looseCompareCollections(a, b, seen) : false;
    aValidType = $991bd59ba433ba6f$export$6750766a7c7ec627(a);
    bValidType = $991bd59ba433ba6f$export$6750766a7c7ec627(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $991bd59ba433ba6f$var$looseCompareCollections(a, b, seen) : false;
    const aKeysCount = Object.keys(a).length;
    const bKeysCount = Object.keys(b).length;
    if (aKeysCount !== bKeysCount) return false;
    for(const key in a){
        const aHasKey = a.hasOwnProperty(key);
        const bHasKey = b.hasOwnProperty(key);
        if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$991bd59ba433ba6f$export$ae8015769846262c(a[key], b[key], seen)) return false;
    }
    return String(a) === String(b);
}
function $991bd59ba433ba6f$var$looseCompareNested(a, b, seen, compare) {
    if (!seen) seen = [
        /* @__PURE__ */ new Map(),
        /* @__PURE__ */ new Map()
    ];
    const [seenA, seenB] = seen;
    if (seenA.has(a) || seenB.has(b)) return seenA.get(a) === b && seenB.get(b) === a;
    seenA.set(a, b);
    seenB.set(b, a);
    const equal = compare(a, b, seen);
    seenA.delete(a);
    seenB.delete(b);
    return equal;
}
function $991bd59ba433ba6f$export$ae8015769846262c(a, b, seen) {
    if (a === b) return true;
    let aValidType = $991bd59ba433ba6f$export$871608497c498473(a);
    let bValidType = $991bd59ba433ba6f$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $991bd59ba433ba6f$export$a244864fd9645c7f(a);
    bValidType = $991bd59ba433ba6f$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $991bd59ba433ba6f$export$43bee75e5e14138e(a);
    bValidType = $991bd59ba433ba6f$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $991bd59ba433ba6f$var$looseCompareNested(a, b, seen, $991bd59ba433ba6f$var$looseCompareArrays) : false;
    aValidType = $991bd59ba433ba6f$export$a6cdc56e425d0d0a(a);
    bValidType = $991bd59ba433ba6f$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        return $991bd59ba433ba6f$var$looseCompareNested(a, b, seen, $991bd59ba433ba6f$var$looseCompareObjects);
    }
    return String(a) === String(b);
}
function $991bd59ba433ba6f$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$991bd59ba433ba6f$export$ae8015769846262c(item, val));
}
const $991bd59ba433ba6f$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $991bd59ba433ba6f$export$b5b1545233b45293 = (val)=>{
    return $991bd59ba433ba6f$export$844ec244b1367d54(val) ? val : val == null ? "" : $991bd59ba433ba6f$export$43bee75e5e14138e(val) || $991bd59ba433ba6f$export$a6cdc56e425d0d0a(val) && (val.toString === $991bd59ba433ba6f$export$830c053460e5ddf6 || !$991bd59ba433ba6f$export$f6e2535fb5126e54(val.toString)) ? $991bd59ba433ba6f$var$isRef(val) ? $991bd59ba433ba6f$export$b5b1545233b45293(val.value) : JSON.stringify(val, $991bd59ba433ba6f$var$replacer, 2) : String(val);
};
const $991bd59ba433ba6f$var$replacer = (_key, val)=>{
    if ($991bd59ba433ba6f$var$isRef(val)) return $991bd59ba433ba6f$var$replacer(_key, val.value);
    else if ($991bd59ba433ba6f$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$991bd59ba433ba6f$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($991bd59ba433ba6f$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$991bd59ba433ba6f$var$stringifySymbol(v))
    };
    else if ($991bd59ba433ba6f$export$a244864fd9645c7f(val)) return $991bd59ba433ba6f$var$stringifySymbol(val);
    else if ($991bd59ba433ba6f$export$a6cdc56e425d0d0a(val) && !$991bd59ba433ba6f$export$43bee75e5e14138e(val) && !$991bd59ba433ba6f$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $991bd59ba433ba6f$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $991bd59ba433ba6f$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $991bd59ba433ba6f$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});





parcelRegister("82SML", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5db901e9595904aa$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $fGXCZ = parcelRequire("fGXCZ");

var $9SOcs = parcelRequire("9SOcs");

var $kLbI9 = parcelRequire("kLbI9");

var $87yQO = parcelRequire("87yQO");

var $QlUa3 = parcelRequire("QlUa3");
var $5db901e9595904aa$export$2e2bcd8739ae039 = {
    name: "App",
    components: {
        BoxGeneric: $kLbI9.default,
        IntroPopup: $87yQO.default,
        RouterView: $fGXCZ.RouterView,
        TransitionFade: // RouterLink,
        $QlUa3.default
    },
    data () {
        return {
            loading: false
        };
    },
    computed: {
        ...(0, $aofyc.mapState)([
            "container",
            "route"
        ]),
        ...(0, $aofyc.mapGetters)([
            "containerLoaded",
            "routedSchoolLevel"
        ]),
        schoolLevelContainerClass () {
            return `school-level-${this.routedSchoolLevel?.slug || "none"}`;
        },
        footerMenu () {
            return document.getElementById("footerMenu").innerHTML;
        }
    },
    async created () {
        // Fetch the container in a global beforeEach router guard:
        // This guard is called after Sentry's (setting up the transaction
        // from the `sentry-trace` meta tag), but before components'
        // `beforeRouteEnter` guards, which *wait* for the container to
        // have finished loading before they can reason about route params.
        (0, $9SOcs.default).beforeEach(async (to, from)=>{
            if (!this.containerLoaded && !this.loading) {
                this.loading = true;
                await this.fetchContainer();
                this.loading = false;
            }
        });
    },
    methods: {
        ...(0, $aofyc.mapActions)([
            "fetchContainer"
        ])
    }
};

});
parcelRegister("aofyc", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $79083547052feab2$export$6ccbb43953eebf8);
$parcel$export(module.exports, "createStore", () => $79083547052feab2$export$f51a9068ac82ea43);
$parcel$export(module.exports, "mapState", () => $79083547052feab2$export$a337c713bdba072);
$parcel$export(module.exports, "mapGetters", () => $79083547052feab2$export$74d9085e6d5a97cb);
$parcel$export(module.exports, "mapActions", () => $79083547052feab2$export$1d73b9b98821f6dc);
/*!
 * vuex v4.1.0
 * (c) 2022 Evan You
 * @license MIT
 */ parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $gIp2w = parcelRequire("gIp2w");

var $7RVFN = parcelRequire("7RVFN");
var $79083547052feab2$export$67bdc3ac2df6c0d1 = 'store';
function $79083547052feab2$export$6ccbb43953eebf8(key) {
    if (key === void 0) key = null;
    return (0, $xo6Zx.inject)(key !== null ? key : $79083547052feab2$export$67bdc3ac2df6c0d1);
}
/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */ function $79083547052feab2$var$find(list, f) {
    return list.filter(f)[0];
}
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */ function $79083547052feab2$var$deepCopy(obj, cache) {
    if (cache === void 0) cache = [];
    // just return if obj is immutable value
    if (obj === null || typeof obj !== 'object') return obj;
    // if obj is hit, it is in circular structure
    var hit = $79083547052feab2$var$find(cache, function(c) {
        return c.original === obj;
    });
    if (hit) return hit.copy;
    var copy = Array.isArray(obj) ? [] : {};
    // put the copy into cache at first
    // because we want to refer it in recursive deepCopy
    cache.push({
        original: obj,
        copy: copy
    });
    Object.keys(obj).forEach(function(key) {
        copy[key] = $79083547052feab2$var$deepCopy(obj[key], cache);
    });
    return copy;
}
/**
 * forEach for object
 */ function $79083547052feab2$var$forEachValue(obj, fn) {
    Object.keys(obj).forEach(function(key) {
        return fn(obj[key], key);
    });
}
function $79083547052feab2$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $79083547052feab2$var$isPromise(val) {
    return val && typeof val.then === 'function';
}
function $79083547052feab2$var$assert(condition, msg) {
    if (!condition) throw new Error("[vuex] " + msg);
}
function $79083547052feab2$var$partial(fn, arg) {
    return function() {
        return fn(arg);
    };
}
function $79083547052feab2$var$genericSubscribe(fn, subs, options) {
    if (subs.indexOf(fn) < 0) options && options.prepend ? subs.unshift(fn) : subs.push(fn);
    return function() {
        var i = subs.indexOf(fn);
        if (i > -1) subs.splice(i, 1);
    };
}
function $79083547052feab2$var$resetStore(store, hot) {
    store._actions = Object.create(null);
    store._mutations = Object.create(null);
    store._wrappedGetters = Object.create(null);
    store._modulesNamespaceMap = Object.create(null);
    var state = store.state;
    // init all modules
    $79083547052feab2$var$installModule(store, state, [], store._modules.root, true);
    // reset state
    $79083547052feab2$var$resetStoreState(store, state, hot);
}
function $79083547052feab2$var$resetStoreState(store, state, hot) {
    var oldState = store._state;
    var oldScope = store._scope;
    // bind store public getters
    store.getters = {};
    // reset local getters cache
    store._makeLocalGettersCache = Object.create(null);
    var wrappedGetters = store._wrappedGetters;
    var computedObj = {};
    var computedCache = {};
    // create a new effect scope and create computed object inside it to avoid
    // getters (computed) getting destroyed on component unmount.
    var scope = (0, $gIp2w.effectScope)(true);
    scope.run(function() {
        $79083547052feab2$var$forEachValue(wrappedGetters, function(fn, key) {
            // use computed to leverage its lazy-caching mechanism
            // direct inline function use will lead to closure preserving oldState.
            // using partial to return function with only arguments preserved in closure environment.
            computedObj[key] = $79083547052feab2$var$partial(fn, store);
            computedCache[key] = (0, $xo6Zx.computed)(function() {
                return computedObj[key]();
            });
            Object.defineProperty(store.getters, key, {
                get: function() {
                    return computedCache[key].value;
                },
                enumerable: true // for local getters
            });
        });
    });
    store._state = (0, $gIp2w.reactive)({
        data: state
    });
    // register the newly created effect scope to the store so that we can
    // dispose the effects when this method runs again in the future.
    store._scope = scope;
    // enable strict mode for new state
    if (store.strict) $79083547052feab2$var$enableStrictMode(store);
    if (oldState) {
        if (hot) // dispatch changes in all subscribed watchers
        // to force getter re-evaluation for hot reloading.
        store._withCommit(function() {
            oldState.data = null;
        });
    }
    // dispose previously registered effect scope if there is one.
    if (oldScope) oldScope.stop();
}
function $79083547052feab2$var$installModule(store, rootState, path, module, hot) {
    var isRoot = !path.length;
    var namespace = store._modules.getNamespace(path);
    // register in namespace map
    if (module.namespaced) {
        if (store._modulesNamespaceMap[namespace] && true) console.error("[vuex] duplicate namespace " + namespace + " for the namespaced module " + path.join('/'));
        store._modulesNamespaceMap[namespace] = module;
    }
    // set state
    if (!isRoot && !hot) {
        var parentState = $79083547052feab2$var$getNestedState(rootState, path.slice(0, -1));
        var moduleName = path[path.length - 1];
        store._withCommit(function() {
            if (moduleName in parentState) console.warn("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + path.join('.') + "\"");
            parentState[moduleName] = module.state;
        });
    }
    var local = module.context = $79083547052feab2$var$makeLocalContext(store, namespace, path);
    module.forEachMutation(function(mutation, key) {
        var namespacedType = namespace + key;
        $79083547052feab2$var$registerMutation(store, namespacedType, mutation, local);
    });
    module.forEachAction(function(action, key) {
        var type = action.root ? key : namespace + key;
        var handler = action.handler || action;
        $79083547052feab2$var$registerAction(store, type, handler, local);
    });
    module.forEachGetter(function(getter, key) {
        var namespacedType = namespace + key;
        $79083547052feab2$var$registerGetter(store, namespacedType, getter, local);
    });
    module.forEachChild(function(child, key) {
        $79083547052feab2$var$installModule(store, rootState, path.concat(key), child, hot);
    });
}
/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */ function $79083547052feab2$var$makeLocalContext(store, namespace, path) {
    var noNamespace = namespace === '';
    var local = {
        dispatch: noNamespace ? store.dispatch : function(_type, _payload, _options) {
            var args = $79083547052feab2$var$unifyObjectStyle(_type, _payload, _options);
            var payload = args.payload;
            var options = args.options;
            var type = args.type;
            if (!options || !options.root) {
                type = namespace + type;
                if (!store._actions[type]) {
                    console.error("[vuex] unknown local action type: " + args.type + ", global type: " + type);
                    return;
                }
            }
            return store.dispatch(type, payload);
        },
        commit: noNamespace ? store.commit : function(_type, _payload, _options) {
            var args = $79083547052feab2$var$unifyObjectStyle(_type, _payload, _options);
            var payload = args.payload;
            var options = args.options;
            var type = args.type;
            if (!options || !options.root) {
                type = namespace + type;
                if (!store._mutations[type]) {
                    console.error("[vuex] unknown local mutation type: " + args.type + ", global type: " + type);
                    return;
                }
            }
            store.commit(type, payload, options);
        }
    };
    // getters and state object must be gotten lazily
    // because they will be changed by state update
    Object.defineProperties(local, {
        getters: {
            get: noNamespace ? function() {
                return store.getters;
            } : function() {
                return $79083547052feab2$var$makeLocalGetters(store, namespace);
            }
        },
        state: {
            get: function() {
                return $79083547052feab2$var$getNestedState(store.state, path);
            }
        }
    });
    return local;
}
function $79083547052feab2$var$makeLocalGetters(store, namespace) {
    if (!store._makeLocalGettersCache[namespace]) {
        var gettersProxy = {};
        var splitPos = namespace.length;
        Object.keys(store.getters).forEach(function(type) {
            // skip if the target getter is not match this namespace
            if (type.slice(0, splitPos) !== namespace) return;
            // extract local getter type
            var localType = type.slice(splitPos);
            // Add a port to the getters proxy.
            // Define as getter property because
            // we do not want to evaluate the getters in this time.
            Object.defineProperty(gettersProxy, localType, {
                get: function() {
                    return store.getters[type];
                },
                enumerable: true
            });
        });
        store._makeLocalGettersCache[namespace] = gettersProxy;
    }
    return store._makeLocalGettersCache[namespace];
}
function $79083547052feab2$var$registerMutation(store, type, handler, local) {
    var entry = store._mutations[type] || (store._mutations[type] = []);
    entry.push(function wrappedMutationHandler(payload) {
        handler.call(store, local.state, payload);
    });
}
function $79083547052feab2$var$registerAction(store, type, handler, local) {
    var entry = store._actions[type] || (store._actions[type] = []);
    entry.push(function wrappedActionHandler(payload) {
        var res = handler.call(store, {
            dispatch: local.dispatch,
            commit: local.commit,
            getters: local.getters,
            state: local.state,
            rootGetters: store.getters,
            rootState: store.state
        }, payload);
        if (!$79083547052feab2$var$isPromise(res)) res = Promise.resolve(res);
        if (store._devtoolHook) return res.catch(function(err) {
            store._devtoolHook.emit('vuex:error', err);
            throw err;
        });
        else return res;
    });
}
function $79083547052feab2$var$registerGetter(store, type, rawGetter, local) {
    if (store._wrappedGetters[type]) {
        console.error("[vuex] duplicate getter key: " + type);
        return;
    }
    store._wrappedGetters[type] = function wrappedGetter(store) {
        return rawGetter(local.state, local.getters, store.state, store.getters // root getters
        );
    };
}
function $79083547052feab2$var$enableStrictMode(store) {
    (0, $xo6Zx.watch)(function() {
        return store._state.data;
    }, function() {
        $79083547052feab2$var$assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }, {
        deep: true,
        flush: 'sync'
    });
}
function $79083547052feab2$var$getNestedState(state, path) {
    return path.reduce(function(state, key) {
        return state[key];
    }, state);
}
function $79083547052feab2$var$unifyObjectStyle(type, payload, options) {
    if ($79083547052feab2$var$isObject(type) && type.type) {
        options = payload;
        payload = type;
        type = type.type;
    }
    $79083547052feab2$var$assert(typeof type === 'string', "expects string as the type, but found " + typeof type + ".");
    return {
        type: type,
        payload: payload,
        options: options
    };
}
var $79083547052feab2$var$LABEL_VUEX_BINDINGS = 'vuex bindings';
var $79083547052feab2$var$MUTATIONS_LAYER_ID = 'vuex:mutations';
var $79083547052feab2$var$ACTIONS_LAYER_ID = 'vuex:actions';
var $79083547052feab2$var$INSPECTOR_ID = 'vuex';
var $79083547052feab2$var$actionId = 0;
function $79083547052feab2$var$addDevtools(app, store) {
    (0, $7RVFN.setupDevtoolsPlugin)({
        id: 'org.vuejs.vuex',
        app: app,
        label: 'Vuex',
        homepage: 'https://next.vuex.vuejs.org/',
        logo: 'https://vuejs.org/images/icons/favicon-96x96.png',
        packageName: 'vuex',
        componentStateTypes: [
            $79083547052feab2$var$LABEL_VUEX_BINDINGS
        ]
    }, function(api) {
        api.addTimelineLayer({
            id: $79083547052feab2$var$MUTATIONS_LAYER_ID,
            label: 'Vuex Mutations',
            color: $79083547052feab2$var$COLOR_LIME_500
        });
        api.addTimelineLayer({
            id: $79083547052feab2$var$ACTIONS_LAYER_ID,
            label: 'Vuex Actions',
            color: $79083547052feab2$var$COLOR_LIME_500
        });
        api.addInspector({
            id: $79083547052feab2$var$INSPECTOR_ID,
            label: 'Vuex',
            icon: 'storage',
            treeFilterPlaceholder: 'Filter stores...'
        });
        api.on.getInspectorTree(function(payload) {
            if (payload.app === app && payload.inspectorId === $79083547052feab2$var$INSPECTOR_ID) {
                if (payload.filter) {
                    var nodes = [];
                    $79083547052feab2$var$flattenStoreForInspectorTree(nodes, store._modules.root, payload.filter, '');
                    payload.rootNodes = nodes;
                } else payload.rootNodes = [
                    $79083547052feab2$var$formatStoreForInspectorTree(store._modules.root, '')
                ];
            }
        });
        api.on.getInspectorState(function(payload) {
            if (payload.app === app && payload.inspectorId === $79083547052feab2$var$INSPECTOR_ID) {
                var modulePath = payload.nodeId;
                $79083547052feab2$var$makeLocalGetters(store, modulePath);
                payload.state = $79083547052feab2$var$formatStoreForInspectorState($79083547052feab2$var$getStoreModule(store._modules, modulePath), modulePath === 'root' ? store.getters : store._makeLocalGettersCache, modulePath);
            }
        });
        api.on.editInspectorState(function(payload) {
            if (payload.app === app && payload.inspectorId === $79083547052feab2$var$INSPECTOR_ID) {
                var modulePath = payload.nodeId;
                var path = payload.path;
                if (modulePath !== 'root') path = modulePath.split('/').filter(Boolean).concat(path);
                store._withCommit(function() {
                    payload.set(store._state.data, path, payload.state.value);
                });
            }
        });
        store.subscribe(function(mutation, state) {
            var data = {};
            if (mutation.payload) data.payload = mutation.payload;
            data.state = state;
            api.notifyComponentUpdate();
            api.sendInspectorTree($79083547052feab2$var$INSPECTOR_ID);
            api.sendInspectorState($79083547052feab2$var$INSPECTOR_ID);
            api.addTimelineEvent({
                layerId: $79083547052feab2$var$MUTATIONS_LAYER_ID,
                event: {
                    time: Date.now(),
                    title: mutation.type,
                    data: data
                }
            });
        });
        store.subscribeAction({
            before: function(action, state) {
                var data = {};
                if (action.payload) data.payload = action.payload;
                action._id = $79083547052feab2$var$actionId++;
                action._time = Date.now();
                data.state = state;
                api.addTimelineEvent({
                    layerId: $79083547052feab2$var$ACTIONS_LAYER_ID,
                    event: {
                        time: action._time,
                        title: action.type,
                        groupId: action._id,
                        subtitle: 'start',
                        data: data
                    }
                });
            },
            after: function(action, state) {
                var data = {};
                var duration = Date.now() - action._time;
                data.duration = {
                    _custom: {
                        type: 'duration',
                        display: duration + "ms",
                        tooltip: 'Action duration',
                        value: duration
                    }
                };
                if (action.payload) data.payload = action.payload;
                data.state = state;
                api.addTimelineEvent({
                    layerId: $79083547052feab2$var$ACTIONS_LAYER_ID,
                    event: {
                        time: Date.now(),
                        title: action.type,
                        groupId: action._id,
                        subtitle: 'end',
                        data: data
                    }
                });
            }
        });
    });
}
// extracted from tailwind palette
var $79083547052feab2$var$COLOR_LIME_500 = 0x84cc16;
var $79083547052feab2$var$COLOR_DARK = 0x666666;
var $79083547052feab2$var$COLOR_WHITE = 0xffffff;
var $79083547052feab2$var$TAG_NAMESPACED = {
    label: 'namespaced',
    textColor: $79083547052feab2$var$COLOR_WHITE,
    backgroundColor: $79083547052feab2$var$COLOR_DARK
};
/**
 * @param {string} path
 */ function $79083547052feab2$var$extractNameFromPath(path) {
    return path && path !== 'root' ? path.split('/').slice(-2, -1)[0] : 'Root';
}
/**
 * @param {*} module
 * @return {import('@vue/devtools-api').CustomInspectorNode}
 */ function $79083547052feab2$var$formatStoreForInspectorTree(module, path) {
    return {
        id: path || 'root',
        // all modules end with a `/`, we want the last segment only
        // cart/ -> cart
        // nested/cart/ -> cart
        label: $79083547052feab2$var$extractNameFromPath(path),
        tags: module.namespaced ? [
            $79083547052feab2$var$TAG_NAMESPACED
        ] : [],
        children: Object.keys(module._children).map(function(moduleName) {
            return $79083547052feab2$var$formatStoreForInspectorTree(module._children[moduleName], path + moduleName + '/');
        })
    };
}
/**
 * @param {import('@vue/devtools-api').CustomInspectorNode[]} result
 * @param {*} module
 * @param {string} filter
 * @param {string} path
 */ function $79083547052feab2$var$flattenStoreForInspectorTree(result, module, filter, path) {
    if (path.includes(filter)) result.push({
        id: path || 'root',
        label: path.endsWith('/') ? path.slice(0, path.length - 1) : path || 'Root',
        tags: module.namespaced ? [
            $79083547052feab2$var$TAG_NAMESPACED
        ] : []
    });
    Object.keys(module._children).forEach(function(moduleName) {
        $79083547052feab2$var$flattenStoreForInspectorTree(result, module._children[moduleName], filter, path + moduleName + '/');
    });
}
/**
 * @param {*} module
 * @return {import('@vue/devtools-api').CustomInspectorState}
 */ function $79083547052feab2$var$formatStoreForInspectorState(module, getters, path) {
    getters = path === 'root' ? getters : getters[path];
    var gettersKeys = Object.keys(getters);
    var storeState = {
        state: Object.keys(module.state).map(function(key) {
            return {
                key: key,
                editable: true,
                value: module.state[key]
            };
        })
    };
    if (gettersKeys.length) {
        var tree = $79083547052feab2$var$transformPathsToObjectTree(getters);
        storeState.getters = Object.keys(tree).map(function(key) {
            return {
                key: key.endsWith('/') ? $79083547052feab2$var$extractNameFromPath(key) : key,
                editable: false,
                value: $79083547052feab2$var$canThrow(function() {
                    return tree[key];
                })
            };
        });
    }
    return storeState;
}
function $79083547052feab2$var$transformPathsToObjectTree(getters) {
    var result = {};
    Object.keys(getters).forEach(function(key) {
        var path = key.split('/');
        if (path.length > 1) {
            var target = result;
            var leafKey = path.pop();
            path.forEach(function(p) {
                if (!target[p]) target[p] = {
                    _custom: {
                        value: {},
                        display: p,
                        tooltip: 'Module',
                        abstract: true
                    }
                };
                target = target[p]._custom.value;
            });
            target[leafKey] = $79083547052feab2$var$canThrow(function() {
                return getters[key];
            });
        } else result[key] = $79083547052feab2$var$canThrow(function() {
            return getters[key];
        });
    });
    return result;
}
function $79083547052feab2$var$getStoreModule(moduleMap, path) {
    var names = path.split('/').filter(function(n) {
        return n;
    });
    return names.reduce(function(module, moduleName, i) {
        var child = module[moduleName];
        if (!child) throw new Error("Missing module \"" + moduleName + "\" for path \"" + path + "\".");
        return i === names.length - 1 ? child : child._children;
    }, path === 'root' ? moduleMap : moduleMap.root._children);
}
function $79083547052feab2$var$canThrow(cb) {
    try {
        return cb();
    } catch (e) {
        return e;
    }
}
// Base data struct for store's module, package with some attribute and method
var $79083547052feab2$var$Module = function Module(rawModule, runtime) {
    this.runtime = runtime;
    // Store some children item
    this._children = Object.create(null);
    // Store the origin module object which passed by programmer
    this._rawModule = rawModule;
    var rawState = rawModule.state;
    // Store the origin module's state
    this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};
var $79083547052feab2$var$prototypeAccessors$1 = {
    namespaced: {
        configurable: true
    }
};
$79083547052feab2$var$prototypeAccessors$1.namespaced.get = function() {
    return !!this._rawModule.namespaced;
};
$79083547052feab2$var$Module.prototype.addChild = function addChild(key, module) {
    this._children[key] = module;
};
$79083547052feab2$var$Module.prototype.removeChild = function removeChild(key) {
    delete this._children[key];
};
$79083547052feab2$var$Module.prototype.getChild = function getChild(key) {
    return this._children[key];
};
$79083547052feab2$var$Module.prototype.hasChild = function hasChild(key) {
    return key in this._children;
};
$79083547052feab2$var$Module.prototype.update = function update(rawModule) {
    this._rawModule.namespaced = rawModule.namespaced;
    if (rawModule.actions) this._rawModule.actions = rawModule.actions;
    if (rawModule.mutations) this._rawModule.mutations = rawModule.mutations;
    if (rawModule.getters) this._rawModule.getters = rawModule.getters;
};
$79083547052feab2$var$Module.prototype.forEachChild = function forEachChild(fn) {
    $79083547052feab2$var$forEachValue(this._children, fn);
};
$79083547052feab2$var$Module.prototype.forEachGetter = function forEachGetter(fn) {
    if (this._rawModule.getters) $79083547052feab2$var$forEachValue(this._rawModule.getters, fn);
};
$79083547052feab2$var$Module.prototype.forEachAction = function forEachAction(fn) {
    if (this._rawModule.actions) $79083547052feab2$var$forEachValue(this._rawModule.actions, fn);
};
$79083547052feab2$var$Module.prototype.forEachMutation = function forEachMutation(fn) {
    if (this._rawModule.mutations) $79083547052feab2$var$forEachValue(this._rawModule.mutations, fn);
};
Object.defineProperties($79083547052feab2$var$Module.prototype, $79083547052feab2$var$prototypeAccessors$1);
var $79083547052feab2$var$ModuleCollection = function ModuleCollection(rawRootModule) {
    // register root module (Vuex.Store options)
    this.register([], rawRootModule, false);
};
$79083547052feab2$var$ModuleCollection.prototype.get = function get(path) {
    return path.reduce(function(module, key) {
        return module.getChild(key);
    }, this.root);
};
$79083547052feab2$var$ModuleCollection.prototype.getNamespace = function getNamespace(path) {
    var module = this.root;
    return path.reduce(function(namespace, key) {
        module = module.getChild(key);
        return namespace + (module.namespaced ? key + '/' : '');
    }, '');
};
$79083547052feab2$var$ModuleCollection.prototype.update = function update$1(rawRootModule) {
    $79083547052feab2$var$update([], this.root, rawRootModule);
};
$79083547052feab2$var$ModuleCollection.prototype.register = function register(path, rawModule, runtime) {
    var this$1$1 = this;
    if (runtime === void 0) runtime = true;
    $79083547052feab2$var$assertRawModule(path, rawModule);
    var newModule = new $79083547052feab2$var$Module(rawModule, runtime);
    if (path.length === 0) this.root = newModule;
    else {
        var parent = this.get(path.slice(0, -1));
        parent.addChild(path[path.length - 1], newModule);
    }
    // register nested modules
    if (rawModule.modules) $79083547052feab2$var$forEachValue(rawModule.modules, function(rawChildModule, key) {
        this$1$1.register(path.concat(key), rawChildModule, runtime);
    });
};
$79083547052feab2$var$ModuleCollection.prototype.unregister = function unregister(path) {
    var parent = this.get(path.slice(0, -1));
    var key = path[path.length - 1];
    var child = parent.getChild(key);
    if (!child) {
        console.warn("[vuex] trying to unregister module '" + key + "', which is " + "not registered");
        return;
    }
    if (!child.runtime) return;
    parent.removeChild(key);
};
$79083547052feab2$var$ModuleCollection.prototype.isRegistered = function isRegistered(path) {
    var parent = this.get(path.slice(0, -1));
    var key = path[path.length - 1];
    if (parent) return parent.hasChild(key);
    return false;
};
function $79083547052feab2$var$update(path, targetModule, newModule) {
    $79083547052feab2$var$assertRawModule(path, newModule);
    // update target module
    targetModule.update(newModule);
    // update nested modules
    if (newModule.modules) for(var key in newModule.modules){
        if (!targetModule.getChild(key)) {
            console.warn("[vuex] trying to add a new module '" + key + "' on hot reloading, " + 'manual reload is needed');
            return;
        }
        $79083547052feab2$var$update(path.concat(key), targetModule.getChild(key), newModule.modules[key]);
    }
}
var $79083547052feab2$var$functionAssert = {
    assert: function(value) {
        return typeof value === 'function';
    },
    expected: 'function'
};
var $79083547052feab2$var$objectAssert = {
    assert: function(value) {
        return typeof value === 'function' || typeof value === 'object' && typeof value.handler === 'function';
    },
    expected: 'function or object with "handler" function'
};
var $79083547052feab2$var$assertTypes = {
    getters: $79083547052feab2$var$functionAssert,
    mutations: $79083547052feab2$var$functionAssert,
    actions: $79083547052feab2$var$objectAssert
};
function $79083547052feab2$var$assertRawModule(path, rawModule) {
    Object.keys($79083547052feab2$var$assertTypes).forEach(function(key) {
        if (!rawModule[key]) return;
        var assertOptions = $79083547052feab2$var$assertTypes[key];
        $79083547052feab2$var$forEachValue(rawModule[key], function(value, type) {
            $79083547052feab2$var$assert(assertOptions.assert(value), $79083547052feab2$var$makeAssertionMessage(path, key, type, value, assertOptions.expected));
        });
    });
}
function $79083547052feab2$var$makeAssertionMessage(path, key, type, value, expected) {
    var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
    if (path.length > 0) buf += " in module \"" + path.join('.') + "\"";
    buf += " is " + JSON.stringify(value) + ".";
    return buf;
}
function $79083547052feab2$export$f51a9068ac82ea43(options) {
    return new $79083547052feab2$export$390f32400eaf98c9(options);
}
var $79083547052feab2$export$390f32400eaf98c9 = function Store(options) {
    var this$1$1 = this;
    if (options === void 0) options = {};
    $79083547052feab2$var$assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    $79083547052feab2$var$assert(this instanceof Store, "store must be called with the new operator.");
    var plugins = options.plugins;
    if (plugins === void 0) plugins = [];
    var strict = options.strict;
    if (strict === void 0) strict = false;
    var devtools = options.devtools;
    // store internal state
    this._committing = false;
    this._actions = Object.create(null);
    this._actionSubscribers = [];
    this._mutations = Object.create(null);
    this._wrappedGetters = Object.create(null);
    this._modules = new $79083547052feab2$var$ModuleCollection(options);
    this._modulesNamespaceMap = Object.create(null);
    this._subscribers = [];
    this._makeLocalGettersCache = Object.create(null);
    // EffectScope instance. when registering new getters, we wrap them inside
    // EffectScope so that getters (computed) would not be destroyed on
    // component unmount.
    this._scope = null;
    this._devtools = devtools;
    // bind commit and dispatch to self
    var store = this;
    var ref = this;
    var dispatch = ref.dispatch;
    var commit = ref.commit;
    this.dispatch = function boundDispatch(type, payload) {
        return dispatch.call(store, type, payload);
    };
    this.commit = function boundCommit(type, payload, options) {
        return commit.call(store, type, payload, options);
    };
    // strict mode
    this.strict = strict;
    var state = this._modules.root.state;
    // init root module.
    // this also recursively registers all sub-modules
    // and collects all module getters inside this._wrappedGetters
    $79083547052feab2$var$installModule(this, state, [], this._modules.root);
    // initialize the store state, which is responsible for the reactivity
    // (also registers _wrappedGetters as computed properties)
    $79083547052feab2$var$resetStoreState(this, state);
    // apply plugins
    plugins.forEach(function(plugin) {
        return plugin(this$1$1);
    });
};
var $79083547052feab2$var$prototypeAccessors = {
    state: {
        configurable: true
    }
};
$79083547052feab2$export$390f32400eaf98c9.prototype.install = function install(app, injectKey) {
    app.provide(injectKey || $79083547052feab2$export$67bdc3ac2df6c0d1, this);
    app.config.globalProperties.$store = this;
    var useDevtools = this._devtools !== undefined ? this._devtools : true;
    if (useDevtools) $79083547052feab2$var$addDevtools(app, this);
};
$79083547052feab2$var$prototypeAccessors.state.get = function() {
    return this._state.data;
};
$79083547052feab2$var$prototypeAccessors.state.set = function(v) {
    $79083547052feab2$var$assert(false, "use store.replaceState() to explicit replace store state.");
};
$79083547052feab2$export$390f32400eaf98c9.prototype.commit = function commit(_type, _payload, _options) {
    var this$1$1 = this;
    // check object-style commit
    var ref = $79083547052feab2$var$unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;
    var mutation = {
        type: type,
        payload: payload
    };
    var entry = this._mutations[type];
    if (!entry) {
        console.error("[vuex] unknown mutation type: " + type);
        return;
    }
    this._withCommit(function() {
        entry.forEach(function commitIterator(handler) {
            handler(payload);
        });
    });
    this._subscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function(sub) {
        return sub(mutation, this$1$1.state);
    });
    if (options && options.silent) console.warn("[vuex] mutation type: " + type + ". Silent option has been removed. " + 'Use the filter functionality in the vue-devtools');
};
$79083547052feab2$export$390f32400eaf98c9.prototype.dispatch = function dispatch(_type, _payload) {
    var this$1$1 = this;
    // check object-style dispatch
    var ref = $79083547052feab2$var$unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;
    var action = {
        type: type,
        payload: payload
    };
    var entry = this._actions[type];
    if (!entry) {
        console.error("[vuex] unknown action type: " + type);
        return;
    }
    try {
        this._actionSubscribers.slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
        .filter(function(sub) {
            return sub.before;
        }).forEach(function(sub) {
            return sub.before(action, this$1$1.state);
        });
    } catch (e) {
        console.warn("[vuex] error in before action subscribers: ");
        console.error(e);
    }
    var result = entry.length > 1 ? Promise.all(entry.map(function(handler) {
        return handler(payload);
    })) : entry[0](payload);
    return new Promise(function(resolve, reject) {
        result.then(function(res) {
            try {
                this$1$1._actionSubscribers.filter(function(sub) {
                    return sub.after;
                }).forEach(function(sub) {
                    return sub.after(action, this$1$1.state);
                });
            } catch (e) {
                console.warn("[vuex] error in after action subscribers: ");
                console.error(e);
            }
            resolve(res);
        }, function(error) {
            try {
                this$1$1._actionSubscribers.filter(function(sub) {
                    return sub.error;
                }).forEach(function(sub) {
                    return sub.error(action, this$1$1.state, error);
                });
            } catch (e) {
                console.warn("[vuex] error in error action subscribers: ");
                console.error(e);
            }
            reject(error);
        });
    });
};
$79083547052feab2$export$390f32400eaf98c9.prototype.subscribe = function subscribe(fn, options) {
    return $79083547052feab2$var$genericSubscribe(fn, this._subscribers, options);
};
$79083547052feab2$export$390f32400eaf98c9.prototype.subscribeAction = function subscribeAction(fn, options) {
    var subs = typeof fn === 'function' ? {
        before: fn
    } : fn;
    return $79083547052feab2$var$genericSubscribe(subs, this._actionSubscribers, options);
};
$79083547052feab2$export$390f32400eaf98c9.prototype.watch = function watch$1(getter, cb, options) {
    var this$1$1 = this;
    $79083547052feab2$var$assert(typeof getter === 'function', "store.watch only accepts a function.");
    return (0, $xo6Zx.watch)(function() {
        return getter(this$1$1.state, this$1$1.getters);
    }, cb, Object.assign({}, options));
};
$79083547052feab2$export$390f32400eaf98c9.prototype.replaceState = function replaceState(state) {
    var this$1$1 = this;
    this._withCommit(function() {
        this$1$1._state.data = state;
    });
};
$79083547052feab2$export$390f32400eaf98c9.prototype.registerModule = function registerModule(path, rawModule, options) {
    if (options === void 0) options = {};
    if (typeof path === 'string') path = [
        path
    ];
    $79083547052feab2$var$assert(Array.isArray(path), "module path must be a string or an Array.");
    $79083547052feab2$var$assert(path.length > 0, 'cannot register the root module by using registerModule.');
    this._modules.register(path, rawModule);
    $79083547052feab2$var$installModule(this, this.state, path, this._modules.get(path), options.preserveState);
    // reset store to update getters...
    $79083547052feab2$var$resetStoreState(this, this.state);
};
$79083547052feab2$export$390f32400eaf98c9.prototype.unregisterModule = function unregisterModule(path) {
    var this$1$1 = this;
    if (typeof path === 'string') path = [
        path
    ];
    $79083547052feab2$var$assert(Array.isArray(path), "module path must be a string or an Array.");
    this._modules.unregister(path);
    this._withCommit(function() {
        var parentState = $79083547052feab2$var$getNestedState(this$1$1.state, path.slice(0, -1));
        delete parentState[path[path.length - 1]];
    });
    $79083547052feab2$var$resetStore(this);
};
$79083547052feab2$export$390f32400eaf98c9.prototype.hasModule = function hasModule(path) {
    if (typeof path === 'string') path = [
        path
    ];
    $79083547052feab2$var$assert(Array.isArray(path), "module path must be a string or an Array.");
    return this._modules.isRegistered(path);
};
$79083547052feab2$export$390f32400eaf98c9.prototype.hotUpdate = function hotUpdate(newOptions) {
    this._modules.update(newOptions);
    $79083547052feab2$var$resetStore(this, true);
};
$79083547052feab2$export$390f32400eaf98c9.prototype._withCommit = function _withCommit(fn) {
    var committing = this._committing;
    this._committing = true;
    fn();
    this._committing = committing;
};
Object.defineProperties($79083547052feab2$export$390f32400eaf98c9.prototype, $79083547052feab2$var$prototypeAccessors);
/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */ var $79083547052feab2$export$a337c713bdba072 = $79083547052feab2$var$normalizeNamespace(function(namespace, states) {
    var res = {};
    if (!$79083547052feab2$var$isValidMap(states)) console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
    $79083547052feab2$var$normalizeMap(states).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        res[key] = function mappedState() {
            var state = this.$store.state;
            var getters = this.$store.getters;
            if (namespace) {
                var module = $79083547052feab2$var$getModuleByNamespace(this.$store, 'mapState', namespace);
                if (!module) return;
                state = module.context.state;
                getters = module.context.getters;
            }
            return typeof val === 'function' ? val.call(this, state, getters) : state[val];
        };
        // mark vuex getter for devtools
        res[key].vuex = true;
    });
    return res;
});
/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */ var $79083547052feab2$export$6763e3aa6121e797 = $79083547052feab2$var$normalizeNamespace(function(namespace, mutations) {
    var res = {};
    if (!$79083547052feab2$var$isValidMap(mutations)) console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
    $79083547052feab2$var$normalizeMap(mutations).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        res[key] = function mappedMutation() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            // Get the commit method from store
            var commit = this.$store.commit;
            if (namespace) {
                var module = $79083547052feab2$var$getModuleByNamespace(this.$store, 'mapMutations', namespace);
                if (!module) return;
                commit = module.context.commit;
            }
            return typeof val === 'function' ? val.apply(this, [
                commit
            ].concat(args)) : commit.apply(this.$store, [
                val
            ].concat(args));
        };
    });
    return res;
});
/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */ var $79083547052feab2$export$74d9085e6d5a97cb = $79083547052feab2$var$normalizeNamespace(function(namespace, getters) {
    var res = {};
    if (!$79083547052feab2$var$isValidMap(getters)) console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
    $79083547052feab2$var$normalizeMap(getters).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        // The namespace has been mutated by normalizeNamespace
        val = namespace + val;
        res[key] = function mappedGetter() {
            if (namespace && !$79083547052feab2$var$getModuleByNamespace(this.$store, 'mapGetters', namespace)) return;
            if (!(val in this.$store.getters)) {
                console.error("[vuex] unknown getter: " + val);
                return;
            }
            return this.$store.getters[val];
        };
        // mark vuex getter for devtools
        res[key].vuex = true;
    });
    return res;
});
/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */ var $79083547052feab2$export$1d73b9b98821f6dc = $79083547052feab2$var$normalizeNamespace(function(namespace, actions) {
    var res = {};
    if (!$79083547052feab2$var$isValidMap(actions)) console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
    $79083547052feab2$var$normalizeMap(actions).forEach(function(ref) {
        var key = ref.key;
        var val = ref.val;
        res[key] = function mappedAction() {
            var args = [], len = arguments.length;
            while(len--)args[len] = arguments[len];
            // get dispatch function from store
            var dispatch = this.$store.dispatch;
            if (namespace) {
                var module = $79083547052feab2$var$getModuleByNamespace(this.$store, 'mapActions', namespace);
                if (!module) return;
                dispatch = module.context.dispatch;
            }
            return typeof val === 'function' ? val.apply(this, [
                dispatch
            ].concat(args)) : dispatch.apply(this.$store, [
                val
            ].concat(args));
        };
    });
    return res;
});
/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */ var $79083547052feab2$export$22ea1818d73549dc = function(namespace) {
    return {
        mapState: $79083547052feab2$export$a337c713bdba072.bind(null, namespace),
        mapGetters: $79083547052feab2$export$74d9085e6d5a97cb.bind(null, namespace),
        mapMutations: $79083547052feab2$export$6763e3aa6121e797.bind(null, namespace),
        mapActions: $79083547052feab2$export$1d73b9b98821f6dc.bind(null, namespace)
    };
};
/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */ function $79083547052feab2$var$normalizeMap(map) {
    if (!$79083547052feab2$var$isValidMap(map)) return [];
    return Array.isArray(map) ? map.map(function(key) {
        return {
            key: key,
            val: key
        };
    }) : Object.keys(map).map(function(key) {
        return {
            key: key,
            val: map[key]
        };
    });
}
/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */ function $79083547052feab2$var$isValidMap(map) {
    return Array.isArray(map) || $79083547052feab2$var$isObject(map);
}
/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */ function $79083547052feab2$var$normalizeNamespace(fn) {
    return function(namespace, map) {
        if (typeof namespace !== 'string') {
            map = namespace;
            namespace = '';
        } else if (namespace.charAt(namespace.length - 1) !== '/') namespace += '/';
        return fn(namespace, map);
    };
}
/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */ function $79083547052feab2$var$getModuleByNamespace(store, helper, namespace) {
    var module = store._modulesNamespaceMap[namespace];
    if (!module) console.error("[vuex] module namespace not found in " + helper + "(): " + namespace);
    return module;
}
// Credits: borrowed code from fcomb/redux-logger
function $79083547052feab2$export$fe2e61603b61130d(ref) {
    if (ref === void 0) ref = {};
    var collapsed = ref.collapsed;
    if (collapsed === void 0) collapsed = true;
    var filter = ref.filter;
    if (filter === void 0) filter = function(mutation, stateBefore, stateAfter) {
        return true;
    };
    var transformer = ref.transformer;
    if (transformer === void 0) transformer = function(state) {
        return state;
    };
    var mutationTransformer = ref.mutationTransformer;
    if (mutationTransformer === void 0) mutationTransformer = function(mut) {
        return mut;
    };
    var actionFilter = ref.actionFilter;
    if (actionFilter === void 0) actionFilter = function(action, state) {
        return true;
    };
    var actionTransformer = ref.actionTransformer;
    if (actionTransformer === void 0) actionTransformer = function(act) {
        return act;
    };
    var logMutations = ref.logMutations;
    if (logMutations === void 0) logMutations = true;
    var logActions = ref.logActions;
    if (logActions === void 0) logActions = true;
    var logger = ref.logger;
    if (logger === void 0) logger = console;
    return function(store) {
        var prevState = $79083547052feab2$var$deepCopy(store.state);
        if (typeof logger === 'undefined') return;
        if (logMutations) store.subscribe(function(mutation, state) {
            var nextState = $79083547052feab2$var$deepCopy(state);
            if (filter(mutation, prevState, nextState)) {
                var formattedTime = $79083547052feab2$var$getFormattedTime();
                var formattedMutation = mutationTransformer(mutation);
                var message = "mutation " + mutation.type + formattedTime;
                $79083547052feab2$var$startMessage(logger, message, collapsed);
                logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
                logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
                logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
                $79083547052feab2$var$endMessage(logger);
            }
            prevState = nextState;
        });
        if (logActions) store.subscribeAction(function(action, state) {
            if (actionFilter(action, state)) {
                var formattedTime = $79083547052feab2$var$getFormattedTime();
                var formattedAction = actionTransformer(action);
                var message = "action " + action.type + formattedTime;
                $79083547052feab2$var$startMessage(logger, message, collapsed);
                logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
                $79083547052feab2$var$endMessage(logger);
            }
        });
    };
}
function $79083547052feab2$var$startMessage(logger, message, collapsed) {
    var startMessage = collapsed ? logger.groupCollapsed : logger.group;
    // render
    try {
        startMessage.call(logger, message);
    } catch (e) {
        logger.log(message);
    }
}
function $79083547052feab2$var$endMessage(logger) {
    try {
        logger.groupEnd();
    } catch (e) {
        logger.log("\u2014\u2014 log end \u2014\u2014");
    }
}
function $79083547052feab2$var$getFormattedTime() {
    var time = new Date();
    return " @ " + $79083547052feab2$var$pad(time.getHours(), 2) + ":" + $79083547052feab2$var$pad(time.getMinutes(), 2) + ":" + $79083547052feab2$var$pad(time.getSeconds(), 2) + "." + $79083547052feab2$var$pad(time.getMilliseconds(), 3);
}
function $79083547052feab2$var$repeat(str, times) {
    return new Array(times + 1).join(str);
}
function $79083547052feab2$var$pad(num, maxLength) {
    return $79083547052feab2$var$repeat('0', maxLength - num.toString().length) + num;
}
var $79083547052feab2$var$index = {
    version: '4.1.0',
    Store: $79083547052feab2$export$390f32400eaf98c9,
    storeKey: $79083547052feab2$export$67bdc3ac2df6c0d1,
    createStore: $79083547052feab2$export$f51a9068ac82ea43,
    useStore: $79083547052feab2$export$6ccbb43953eebf8,
    mapState: $79083547052feab2$export$a337c713bdba072,
    mapMutations: $79083547052feab2$export$6763e3aa6121e797,
    mapGetters: $79083547052feab2$export$74d9085e6d5a97cb,
    mapActions: $79083547052feab2$export$1d73b9b98821f6dc,
    createNamespacedHelpers: $79083547052feab2$export$22ea1818d73549dc,
    createLogger: $79083547052feab2$export$fe2e61603b61130d
};
var $79083547052feab2$export$2e2bcd8739ae039 = $79083547052feab2$var$index;

});
parcelRegister("7RVFN", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", () => $5baa385436afa06a$export$63b9a9bba9f20f3e);

var $H3BWo = parcelRequire("H3BWo");

var $a4tpe = parcelRequire("a4tpe");

var $fbPTR = parcelRequire("fbPTR");



function $5baa385436afa06a$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $H3BWo.getTarget)();
    const hook = (0, $H3BWo.getDevtoolsGlobalHook)();
    const enableProxy = (0, $H3BWo.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $a4tpe.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $fbPTR.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("H3BWo", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", () => $0816d1538b452459$export$5a2d366b2d9f38f6);
$parcel$export(module.exports, "getTarget", () => $0816d1538b452459$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isProxyAvailable", () => $0816d1538b452459$export$bc32a04c49ed7464);
function $0816d1538b452459$export$5a2d366b2d9f38f6() {
    return $0816d1538b452459$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $0816d1538b452459$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== 'undefined' && typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : {};
}
const $0816d1538b452459$export$bc32a04c49ed7464 = typeof Proxy === 'function';

});

parcelRegister("a4tpe", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", () => $75511684e776c66d$export$b1499c3bd2a3f4df);
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", () => $75511684e776c66d$export$a0897f44accbe922);
const $75511684e776c66d$export$b1499c3bd2a3f4df = 'devtools-plugin:setup';
const $75511684e776c66d$export$a0897f44accbe922 = 'plugin:settings:set';

});

parcelRegister("fbPTR", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", () => $b0f0245913dd0367$export$5728f3776e9b2ac1);

var $a4tpe = parcelRequire("a4tpe");

var $j2mTm = parcelRequire("j2mTm");
class $b0f0245913dd0367$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $j2mTm.now)();
            }
        };
        if (hook) hook.on((0, $a4tpe.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === 'on') return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("j2mTm", function(module, exports) {

$parcel$export(module.exports, "now", () => $ddbff61346109a8c$export$461939dd4422153);
let $ddbff61346109a8c$var$supported;
let $ddbff61346109a8c$var$perf;
function $ddbff61346109a8c$export$70d26280bc1ca547() {
    var _a;
    if ($ddbff61346109a8c$var$supported !== undefined) return $ddbff61346109a8c$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $ddbff61346109a8c$var$supported = true;
        $ddbff61346109a8c$var$perf = window.performance;
    } else if (typeof globalThis !== 'undefined' && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $ddbff61346109a8c$var$supported = true;
        $ddbff61346109a8c$var$perf = globalThis.perf_hooks.performance;
    } else $ddbff61346109a8c$var$supported = false;
    return $ddbff61346109a8c$var$supported;
}
function $ddbff61346109a8c$export$461939dd4422153() {
    return $ddbff61346109a8c$export$70d26280bc1ca547() ? $ddbff61346109a8c$var$perf.now() : Date.now();
}

});




parcelRegister("fGXCZ", function(module, exports) {

$parcel$export(module.exports, "createWebHashHistory", () => $f0937cd22668fe14$export$542bc3a76486c94d);
$parcel$export(module.exports, "RouterLink", () => $f0937cd22668fe14$export$fce709ebdac448ed);
$parcel$export(module.exports, "RouterView", () => $f0937cd22668fe14$export$d941f00e9b9a537);
$parcel$export(module.exports, "createRouter", () => $f0937cd22668fe14$export$baddd0131ee8c05b);
/*!
 * vue-router v4.6.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ 
var $cnKXL = parcelRequire("cnKXL");
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $gIp2w = parcelRequire("gIp2w");
//#region src/history/html5.ts
let $f0937cd22668fe14$var$createBaseLocation = ()=>location.protocol + "//" + location.host;
/**
* Creates a normalized history location from a window.location object
* @param base - The base path
* @param location - The window.location object
*/ function $f0937cd22668fe14$var$createCurrentLocation(base, location$1) {
    const { pathname: pathname, search: search, hash: hash } = location$1;
    const hashPos = base.indexOf("#");
    if (hashPos > -1) {
        let slicePos = hash.includes(base.slice(hashPos)) ? base.slice(hashPos).length : 1;
        let pathFromHash = hash.slice(slicePos);
        if (pathFromHash[0] !== "/") pathFromHash = "/" + pathFromHash;
        return (0, $cnKXL.V)(pathFromHash, "");
    }
    return (0, $cnKXL.V)(pathname, base) + search + hash;
}
function $f0937cd22668fe14$var$useHistoryListeners(base, historyState, currentLocation, replace) {
    let listeners = [];
    let teardowns = [];
    let pauseState = null;
    const popStateHandler = ({ state: state })=>{
        const to = $f0937cd22668fe14$var$createCurrentLocation(base, location);
        const from = currentLocation.value;
        const fromState = historyState.value;
        let delta = 0;
        if (state) {
            currentLocation.value = to;
            historyState.value = state;
            if (pauseState && pauseState === from) {
                pauseState = null;
                return;
            }
            delta = fromState ? state.position - fromState.position : 0;
        } else replace(to);
        listeners.forEach((listener)=>{
            listener(currentLocation.value, from, {
                delta: delta,
                type: (0, $cnKXL.k).pop,
                direction: delta ? delta > 0 ? (0, $cnKXL.O).forward : (0, $cnKXL.O).back : (0, $cnKXL.O).unknown
            });
        });
    };
    function pauseListeners() {
        pauseState = currentLocation.value;
    }
    function listen(callback) {
        listeners.push(callback);
        const teardown = ()=>{
            const index = listeners.indexOf(callback);
            if (index > -1) listeners.splice(index, 1);
        };
        teardowns.push(teardown);
        return teardown;
    }
    function beforeUnloadListener() {
        if (document.visibilityState === "hidden") {
            const { history: history$1 } = window;
            if (!history$1.state) return;
            history$1.replaceState((0, $cnKXL.J)({}, history$1.state, {
                scroll: (0, $cnKXL.C)()
            }), "");
        }
    }
    function destroy() {
        for (const teardown of teardowns)teardown();
        teardowns = [];
        window.removeEventListener("popstate", popStateHandler);
        window.removeEventListener("pagehide", beforeUnloadListener);
        document.removeEventListener("visibilitychange", beforeUnloadListener);
    }
    window.addEventListener("popstate", popStateHandler);
    window.addEventListener("pagehide", beforeUnloadListener);
    document.addEventListener("visibilitychange", beforeUnloadListener);
    return {
        pauseListeners: pauseListeners,
        listen: listen,
        destroy: destroy
    };
}
/**
* Creates a state object
*/ function $f0937cd22668fe14$var$buildState(back, current, forward, replaced = false, computeScroll = false) {
    return {
        back: back,
        current: current,
        forward: forward,
        replaced: replaced,
        position: window.history.length,
        scroll: computeScroll ? (0, $cnKXL.C)() : null
    };
}
function $f0937cd22668fe14$var$useHistoryStateNavigation(base) {
    const { history: history$1, location: location$1 } = window;
    const currentLocation = {
        value: $f0937cd22668fe14$var$createCurrentLocation(base, location$1)
    };
    const historyState = {
        value: history$1.state
    };
    if (!historyState.value) changeLocation(currentLocation.value, {
        back: null,
        current: currentLocation.value,
        forward: null,
        position: history$1.length - 1,
        replaced: true,
        scroll: null
    }, true);
    function changeLocation(to, state, replace$1) {
        /**
		* if a base tag is provided, and we are on a normal domain, we have to
		* respect the provided `base` attribute because pushState() will use it and
		* potentially erase anything before the `#` like at
		* https://github.com/vuejs/router/issues/685 where a base of
		* `/folder/#` but a base of `/` would erase the `/folder/` section. If
		* there is no host, the `<base>` tag makes no sense and if there isn't a
		* base tag we can just use everything after the `#`.
		*/ const hashIndex = base.indexOf("#");
        const url = hashIndex > -1 ? (location$1.host && document.querySelector("base") ? base : base.slice(hashIndex)) + to : $f0937cd22668fe14$var$createBaseLocation() + base + to;
        try {
            history$1[replace$1 ? "replaceState" : "pushState"](state, "", url);
            historyState.value = state;
        } catch (err) {
            console.error(err);
            location$1[replace$1 ? "replace" : "assign"](url);
        }
    }
    function replace(to, data) {
        changeLocation(to, (0, $cnKXL.J)({}, history$1.state, $f0937cd22668fe14$var$buildState(historyState.value.back, to, historyState.value.forward, true), data, {
            position: historyState.value.position
        }), true);
        currentLocation.value = to;
    }
    function push(to, data) {
        const currentState = (0, $cnKXL.J)({}, historyState.value, history$1.state, {
            forward: to,
            scroll: (0, $cnKXL.C)()
        });
        changeLocation(currentState.current, currentState, true);
        changeLocation(to, (0, $cnKXL.J)({}, $f0937cd22668fe14$var$buildState(currentLocation.value, to, null), {
            position: currentState.position + 1
        }, data), false);
        currentLocation.value = to;
    }
    return {
        location: currentLocation,
        state: historyState,
        push: push,
        replace: replace
    };
}
/**
* Creates an HTML5 history. Most common history for single page applications.
*
* @param base -
*/ function $f0937cd22668fe14$export$7b4942f78e7b8a49(base) {
    base = (0, $cnKXL.M)(base);
    const historyNavigation = $f0937cd22668fe14$var$useHistoryStateNavigation(base);
    const historyListeners = $f0937cd22668fe14$var$useHistoryListeners(base, historyNavigation.state, historyNavigation.location, historyNavigation.replace);
    function go(delta, triggerListeners = true) {
        if (!triggerListeners) historyListeners.pauseListeners();
        history.go(delta);
    }
    const routerHistory = (0, $cnKXL.J)({
        location: "",
        base: base,
        go: go,
        createHref: (0, $cnKXL.j).bind(null, base)
    }, historyNavigation, historyListeners);
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>historyNavigation.location.value
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>historyNavigation.state.value
    });
    return routerHistory;
}
//#endregion
//#region src/history/memory.ts
/**
* Creates an in-memory based history. The main purpose of this history is to handle SSR. It starts in a special location that is nowhere.
* It's up to the user to replace that location with the starter location by either calling `router.push` or `router.replace`.
*
* @param base - Base applied to all urls, defaults to '/'
* @returns a history object that can be passed to the router constructor
*/ function $f0937cd22668fe14$export$2b76ad033c6e6d08(base = "") {
    let listeners = [];
    let queue = [
        [
            (0, $cnKXL.A),
            {}
        ]
    ];
    let position = 0;
    base = (0, $cnKXL.M)(base);
    function setLocation(location$1, state = {}) {
        position++;
        if (position !== queue.length) queue.splice(position);
        queue.push([
            location$1,
            state
        ]);
    }
    function triggerListeners(to, from, { direction: direction, delta: delta }) {
        const info = {
            direction: direction,
            delta: delta,
            type: (0, $cnKXL.k).pop
        };
        for (const callback of listeners)callback(to, from, info);
    }
    const routerHistory = {
        location: (0, $cnKXL.A),
        state: {},
        base: base,
        createHref: (0, $cnKXL.j).bind(null, base),
        replace (to, state) {
            queue.splice(position--, 1);
            setLocation(to, state);
        },
        push (to, state) {
            setLocation(to, state);
        },
        listen (callback) {
            listeners.push(callback);
            return ()=>{
                const index = listeners.indexOf(callback);
                if (index > -1) listeners.splice(index, 1);
            };
        },
        destroy () {
            listeners = [];
            queue = [
                [
                    (0, $cnKXL.A),
                    {}
                ]
            ];
            position = 0;
        },
        go (delta, shouldTrigger = true) {
            const from = this.location;
            const direction = delta < 0 ? (0, $cnKXL.O).back : (0, $cnKXL.O).forward;
            position = Math.max(0, Math.min(position + delta, queue.length - 1));
            if (shouldTrigger) triggerListeners(this.location, from, {
                direction: direction,
                delta: delta
            });
        }
    };
    Object.defineProperty(routerHistory, "location", {
        enumerable: true,
        get: ()=>queue[position][0]
    });
    Object.defineProperty(routerHistory, "state", {
        enumerable: true,
        get: ()=>queue[position][1]
    });
    return routerHistory;
}
//#endregion
//#region src/history/hash.ts
/**
* Creates a hash history. Useful for web applications with no host (e.g. `file://`) or when configuring a server to
* handle any URL is not possible.
*
* @param base - optional base to provide. Defaults to `location.pathname + location.search` If there is a `<base>` tag
* in the `head`, its value will be ignored in favor of this parameter **but note it affects all the history.pushState()
* calls**, meaning that if you use a `<base>` tag, it's `href` value **has to match this parameter** (ignoring anything
* after the `#`).
*
* @example
* ```js
* // at https://example.com/folder
* createWebHashHistory() // gives a url of `https://example.com/folder#`
* createWebHashHistory('/folder/') // gives a url of `https://example.com/folder/#`
* // if the `#` is provided in the base, it won't be added by `createWebHashHistory`
* createWebHashHistory('/folder/#/app/') // gives a url of `https://example.com/folder/#/app/`
* // you should avoid doing this because it changes the original url and breaks copying urls
* createWebHashHistory('/other-folder/') // gives a url of `https://example.com/other-folder/#`
*
* // at file:///usr/etc/folder/index.html
* // for locations with no `host`, the base is ignored
* createWebHashHistory('/iAmIgnored') // gives a url of `file:///usr/etc/folder/index.html#`
* ```
*/ function $f0937cd22668fe14$export$542bc3a76486c94d(base) {
    base = location.host ? base || location.pathname + location.search : "";
    if (!base.includes("#")) base += "#";
    return $f0937cd22668fe14$export$7b4942f78e7b8a49(base);
}
//#endregion
//#region src/matcher/pathTokenizer.ts
let $f0937cd22668fe14$var$TokenType = /* @__PURE__ */ function(TokenType$1) {
    TokenType$1[TokenType$1["Static"] = 0] = "Static";
    TokenType$1[TokenType$1["Param"] = 1] = "Param";
    TokenType$1[TokenType$1["Group"] = 2] = "Group";
    return TokenType$1;
}({});
var $f0937cd22668fe14$var$TokenizerState = /* @__PURE__ */ function(TokenizerState$1) {
    TokenizerState$1[TokenizerState$1["Static"] = 0] = "Static";
    TokenizerState$1[TokenizerState$1["Param"] = 1] = "Param";
    TokenizerState$1[TokenizerState$1["ParamRegExp"] = 2] = "ParamRegExp";
    TokenizerState$1[TokenizerState$1["ParamRegExpEnd"] = 3] = "ParamRegExpEnd";
    TokenizerState$1[TokenizerState$1["EscapeNext"] = 4] = "EscapeNext";
    return TokenizerState$1;
}($f0937cd22668fe14$var$TokenizerState || {});
const $f0937cd22668fe14$var$ROOT_TOKEN = {
    type: $f0937cd22668fe14$var$TokenType.Static,
    value: ""
};
const $f0937cd22668fe14$var$VALID_PARAM_RE = /[a-zA-Z0-9_]/;
function $f0937cd22668fe14$var$tokenizePath(path) {
    if (!path) return [
        []
    ];
    if (path === "/") return [
        [
            $f0937cd22668fe14$var$ROOT_TOKEN
        ]
    ];
    if (!path.startsWith("/")) throw new Error(`Invalid path "${path}"`);
    function crash(message) {
        throw new Error(`ERR (${state})/"${buffer}": ${message}`);
    }
    let state = $f0937cd22668fe14$var$TokenizerState.Static;
    let previousState = state;
    const tokens = [];
    let segment;
    function finalizeSegment() {
        if (segment) tokens.push(segment);
        segment = [];
    }
    let i = 0;
    let char;
    let buffer = "";
    let customRe = "";
    function consumeBuffer() {
        if (!buffer) return;
        if (state === $f0937cd22668fe14$var$TokenizerState.Static) segment.push({
            type: $f0937cd22668fe14$var$TokenType.Static,
            value: buffer
        });
        else if (state === $f0937cd22668fe14$var$TokenizerState.Param || state === $f0937cd22668fe14$var$TokenizerState.ParamRegExp || state === $f0937cd22668fe14$var$TokenizerState.ParamRegExpEnd) {
            if (segment.length > 1 && (char === "*" || char === "+")) crash(`A repeatable param (${buffer}) must be alone in its segment. eg: '/:ids+.`);
            segment.push({
                type: $f0937cd22668fe14$var$TokenType.Param,
                value: buffer,
                regexp: customRe,
                repeatable: char === "*" || char === "+",
                optional: char === "*" || char === "?"
            });
        } else crash("Invalid state to consume buffer");
        buffer = "";
    }
    function addCharToBuffer() {
        buffer += char;
    }
    while(i < path.length){
        char = path[i++];
        if (char === "\\" && state !== $f0937cd22668fe14$var$TokenizerState.ParamRegExp) {
            previousState = state;
            state = $f0937cd22668fe14$var$TokenizerState.EscapeNext;
            continue;
        }
        switch(state){
            case $f0937cd22668fe14$var$TokenizerState.Static:
                if (char === "/") {
                    if (buffer) consumeBuffer();
                    finalizeSegment();
                } else if (char === ":") {
                    consumeBuffer();
                    state = $f0937cd22668fe14$var$TokenizerState.Param;
                } else addCharToBuffer();
                break;
            case $f0937cd22668fe14$var$TokenizerState.EscapeNext:
                addCharToBuffer();
                state = previousState;
                break;
            case $f0937cd22668fe14$var$TokenizerState.Param:
                if (char === "(") state = $f0937cd22668fe14$var$TokenizerState.ParamRegExp;
                else if ($f0937cd22668fe14$var$VALID_PARAM_RE.test(char)) addCharToBuffer();
                else {
                    consumeBuffer();
                    state = $f0937cd22668fe14$var$TokenizerState.Static;
                    if (char !== "*" && char !== "?" && char !== "+") i--;
                }
                break;
            case $f0937cd22668fe14$var$TokenizerState.ParamRegExp:
                if (char === ")") {
                    if (customRe[customRe.length - 1] == "\\") customRe = customRe.slice(0, -1) + char;
                    else state = $f0937cd22668fe14$var$TokenizerState.ParamRegExpEnd;
                } else customRe += char;
                break;
            case $f0937cd22668fe14$var$TokenizerState.ParamRegExpEnd:
                consumeBuffer();
                state = $f0937cd22668fe14$var$TokenizerState.Static;
                if (char !== "*" && char !== "?" && char !== "+") i--;
                customRe = "";
                break;
            default:
                crash("Unknown state");
                break;
        }
    }
    if (state === $f0937cd22668fe14$var$TokenizerState.ParamRegExp) crash(`Unfinished custom RegExp for param "${buffer}"`);
    consumeBuffer();
    finalizeSegment();
    return tokens;
}
//#endregion
//#region src/matcher/pathParserRanker.ts
const $f0937cd22668fe14$var$BASE_PARAM_PATTERN = "[^/]+?";
const $f0937cd22668fe14$var$BASE_PATH_PARSER_OPTIONS = {
    sensitive: false,
    strict: false,
    start: true,
    end: true
};
var $f0937cd22668fe14$var$PathScore = /* @__PURE__ */ function(PathScore$1) {
    PathScore$1[PathScore$1["_multiplier"] = 10] = "_multiplier";
    PathScore$1[PathScore$1["Root"] = 90] = "Root";
    PathScore$1[PathScore$1["Segment"] = 40] = "Segment";
    PathScore$1[PathScore$1["SubSegment"] = 30] = "SubSegment";
    PathScore$1[PathScore$1["Static"] = 40] = "Static";
    PathScore$1[PathScore$1["Dynamic"] = 20] = "Dynamic";
    PathScore$1[PathScore$1["BonusCustomRegExp"] = 10] = "BonusCustomRegExp";
    PathScore$1[PathScore$1["BonusWildcard"] = -50] = "BonusWildcard";
    PathScore$1[PathScore$1["BonusRepeatable"] = -20] = "BonusRepeatable";
    PathScore$1[PathScore$1["BonusOptional"] = -8] = "BonusOptional";
    PathScore$1[PathScore$1["BonusStrict"] = .7000000000000001] = "BonusStrict";
    PathScore$1[PathScore$1["BonusCaseSensitive"] = .25] = "BonusCaseSensitive";
    return PathScore$1;
}($f0937cd22668fe14$var$PathScore || {});
const $f0937cd22668fe14$var$REGEX_CHARS_RE = /[.+*?^${}()[\]/\\]/g;
/**
* Creates a path parser from an array of Segments (a segment is an array of Tokens)
*
* @param segments - array of segments returned by tokenizePath
* @param extraOptions - optional options for the regexp
* @returns a PathParser
*/ function $f0937cd22668fe14$var$tokensToParser(segments, extraOptions) {
    const options = (0, $cnKXL.J)({}, $f0937cd22668fe14$var$BASE_PATH_PARSER_OPTIONS, extraOptions);
    const score = [];
    let pattern = options.start ? "^" : "";
    const keys = [];
    for (const segment of segments){
        const segmentScores = segment.length ? [] : [
            $f0937cd22668fe14$var$PathScore.Root
        ];
        if (options.strict && !segment.length) pattern += "/";
        for(let tokenIndex = 0; tokenIndex < segment.length; tokenIndex++){
            const token = segment[tokenIndex];
            let subSegmentScore = $f0937cd22668fe14$var$PathScore.Segment + (options.sensitive ? $f0937cd22668fe14$var$PathScore.BonusCaseSensitive : 0);
            if (token.type === $f0937cd22668fe14$var$TokenType.Static) {
                if (!tokenIndex) pattern += "/";
                pattern += token.value.replace($f0937cd22668fe14$var$REGEX_CHARS_RE, "\\$&");
                subSegmentScore += $f0937cd22668fe14$var$PathScore.Static;
            } else if (token.type === $f0937cd22668fe14$var$TokenType.Param) {
                const { value: value, repeatable: repeatable, optional: optional, regexp: regexp } = token;
                keys.push({
                    name: value,
                    repeatable: repeatable,
                    optional: optional
                });
                const re$1 = regexp ? regexp : $f0937cd22668fe14$var$BASE_PARAM_PATTERN;
                if (re$1 !== $f0937cd22668fe14$var$BASE_PARAM_PATTERN) subSegmentScore += $f0937cd22668fe14$var$PathScore.BonusCustomRegExp;
                let subPattern = repeatable ? `((?:${re$1})(?:/(?:${re$1}))*)` : `(${re$1})`;
                if (!tokenIndex) subPattern = optional && segment.length < 2 ? `(?:/${subPattern})` : "/" + subPattern;
                if (optional) subPattern += "?";
                pattern += subPattern;
                subSegmentScore += $f0937cd22668fe14$var$PathScore.Dynamic;
                if (optional) subSegmentScore += $f0937cd22668fe14$var$PathScore.BonusOptional;
                if (repeatable) subSegmentScore += $f0937cd22668fe14$var$PathScore.BonusRepeatable;
                if (re$1 === ".*") subSegmentScore += $f0937cd22668fe14$var$PathScore.BonusWildcard;
            }
            segmentScores.push(subSegmentScore);
        }
        score.push(segmentScores);
    }
    if (options.strict && options.end) {
        const i = score.length - 1;
        score[i][score[i].length - 1] += $f0937cd22668fe14$var$PathScore.BonusStrict;
    }
    if (!options.strict) pattern += "/?";
    if (options.end) pattern += "$";
    else if (options.strict && !pattern.endsWith("/")) pattern += "(?:/|$)";
    const re = new RegExp(pattern, options.sensitive ? "" : "i");
    function parse(path) {
        const match = path.match(re);
        const params = {};
        if (!match) return null;
        for(let i = 1; i < match.length; i++){
            const value = match[i] || "";
            const key = keys[i - 1];
            params[key.name] = value && key.repeatable ? value.split("/") : value;
        }
        return params;
    }
    function stringify(params) {
        let path = "";
        let avoidDuplicatedSlash = false;
        for (const segment of segments){
            if (!avoidDuplicatedSlash || !path.endsWith("/")) path += "/";
            avoidDuplicatedSlash = false;
            for (const token of segment)if (token.type === $f0937cd22668fe14$var$TokenType.Static) path += token.value;
            else if (token.type === $f0937cd22668fe14$var$TokenType.Param) {
                const { value: value, repeatable: repeatable, optional: optional } = token;
                const param = value in params ? params[value] : "";
                if ((0, $cnKXL.X)(param) && !repeatable) throw new Error(`Provided param "${value}" is an array but it is not repeatable (* or + modifiers)`);
                const text = (0, $cnKXL.X)(param) ? param.join("/") : param;
                if (!text) {
                    if (optional) {
                        if (segment.length < 2) {
                            if (path.endsWith("/")) path = path.slice(0, -1);
                            else avoidDuplicatedSlash = true;
                        }
                    } else throw new Error(`Missing required param "${value}"`);
                }
                path += text;
            }
        }
        return path || "/";
    }
    return {
        re: re,
        score: score,
        keys: keys,
        parse: parse,
        stringify: stringify
    };
}
/**
* Compares an array of numbers as used in PathParser.score and returns a
* number. This function can be used to `sort` an array
*
* @param a - first array of numbers
* @param b - second array of numbers
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
* should be sorted first
*/ function $f0937cd22668fe14$var$compareScoreArray(a, b) {
    let i = 0;
    while(i < a.length && i < b.length){
        const diff = b[i] - a[i];
        if (diff) return diff;
        i++;
    }
    if (a.length < b.length) return a.length === 1 && a[0] === $f0937cd22668fe14$var$PathScore.Static + $f0937cd22668fe14$var$PathScore.Segment ? -1 : 1;
    else if (a.length > b.length) return b.length === 1 && b[0] === $f0937cd22668fe14$var$PathScore.Static + $f0937cd22668fe14$var$PathScore.Segment ? 1 : -1;
    return 0;
}
/**
* Compare function that can be used with `sort` to sort an array of PathParser
*
* @param a - first PathParser
* @param b - second PathParser
* @returns 0 if both are equal, < 0 if a should be sorted first, > 0 if b
*/ function $f0937cd22668fe14$var$comparePathParserScore(a, b) {
    let i = 0;
    const aScore = a.score;
    const bScore = b.score;
    while(i < aScore.length && i < bScore.length){
        const comp = $f0937cd22668fe14$var$compareScoreArray(aScore[i], bScore[i]);
        if (comp) return comp;
        i++;
    }
    if (Math.abs(bScore.length - aScore.length) === 1) {
        if ($f0937cd22668fe14$var$isLastScoreNegative(aScore)) return 1;
        if ($f0937cd22668fe14$var$isLastScoreNegative(bScore)) return -1;
    }
    return bScore.length - aScore.length;
}
/**
* This allows detecting splats at the end of a path: /home/:id(.*)*
*
* @param score - score to check
* @returns true if the last entry is negative
*/ function $f0937cd22668fe14$var$isLastScoreNegative(score) {
    const last = score[score.length - 1];
    return score.length > 0 && last[last.length - 1] < 0;
}
const $f0937cd22668fe14$var$PATH_PARSER_OPTIONS_DEFAULTS = {
    strict: false,
    end: true,
    sensitive: false
};
//#endregion
//#region src/matcher/pathMatcher.ts
function $f0937cd22668fe14$var$createRouteRecordMatcher(record, parent, options) {
    const parser = $f0937cd22668fe14$var$tokensToParser($f0937cd22668fe14$var$tokenizePath(record.path), options);
    const matcher = (0, $cnKXL.J)(parser, {
        record: record,
        parent: parent,
        children: [],
        alias: []
    });
    if (parent) {
        if (!matcher.record.aliasOf === !parent.record.aliasOf) parent.children.push(matcher);
    }
    return matcher;
}
//#endregion
//#region src/matcher/index.ts
/**
* Creates a Router Matcher.
*
* @internal
* @param routes - array of initial routes
* @param globalOptions - global route options
*/ function $f0937cd22668fe14$export$36302c85fdcc95a8(routes, globalOptions) {
    const matchers = [];
    const matcherMap = /* @__PURE__ */ new Map();
    globalOptions = (0, $cnKXL.Z)($f0937cd22668fe14$var$PATH_PARSER_OPTIONS_DEFAULTS, globalOptions);
    function getRecordMatcher(name) {
        return matcherMap.get(name);
    }
    function addRoute(record, parent, originalRecord) {
        const isRootAdd = !originalRecord;
        const mainNormalizedRecord = $f0937cd22668fe14$var$normalizeRouteRecord(record);
        mainNormalizedRecord.aliasOf = originalRecord && originalRecord.record;
        const options = (0, $cnKXL.Z)(globalOptions, record);
        const normalizedRecords = [
            mainNormalizedRecord
        ];
        if ("alias" in record) {
            const aliases = typeof record.alias === "string" ? [
                record.alias
            ] : record.alias;
            for (const alias of aliases)normalizedRecords.push($f0937cd22668fe14$var$normalizeRouteRecord((0, $cnKXL.J)({}, mainNormalizedRecord, {
                components: originalRecord ? originalRecord.record.components : mainNormalizedRecord.components,
                path: alias,
                aliasOf: originalRecord ? originalRecord.record : mainNormalizedRecord
            })));
        }
        let matcher;
        let originalMatcher;
        for (const normalizedRecord of normalizedRecords){
            const { path: path } = normalizedRecord;
            if (parent && path[0] !== "/") {
                const parentPath = parent.record.path;
                const connectingSlash = parentPath[parentPath.length - 1] === "/" ? "" : "/";
                normalizedRecord.path = parent.record.path + (path && connectingSlash + path);
            }
            matcher = $f0937cd22668fe14$var$createRouteRecordMatcher(normalizedRecord, parent, options);
            if (originalRecord) originalRecord.alias.push(matcher);
            else {
                originalMatcher = originalMatcher || matcher;
                if (originalMatcher !== matcher) originalMatcher.alias.push(matcher);
                if (isRootAdd && record.name && !$f0937cd22668fe14$var$isAliasRecord(matcher)) removeRoute(record.name);
            }
            if ($f0937cd22668fe14$var$isMatchable(matcher)) insertMatcher(matcher);
            if (mainNormalizedRecord.children) {
                const children = mainNormalizedRecord.children;
                for(let i = 0; i < children.length; i++)addRoute(children[i], matcher, originalRecord && originalRecord.children[i]);
            }
            originalRecord = originalRecord || matcher;
        }
        return originalMatcher ? ()=>{
            removeRoute(originalMatcher);
        } : (0, $cnKXL.Q);
    }
    function removeRoute(matcherRef) {
        if ((0, $cnKXL.S)(matcherRef)) {
            const matcher = matcherMap.get(matcherRef);
            if (matcher) {
                matcherMap.delete(matcherRef);
                matchers.splice(matchers.indexOf(matcher), 1);
                matcher.children.forEach(removeRoute);
                matcher.alias.forEach(removeRoute);
            }
        } else {
            const index = matchers.indexOf(matcherRef);
            if (index > -1) {
                matchers.splice(index, 1);
                if (matcherRef.record.name) matcherMap.delete(matcherRef.record.name);
                matcherRef.children.forEach(removeRoute);
                matcherRef.alias.forEach(removeRoute);
            }
        }
    }
    function getRoutes() {
        return matchers;
    }
    function insertMatcher(matcher) {
        const index = $f0937cd22668fe14$var$findInsertionIndex(matcher, matchers);
        matchers.splice(index, 0, matcher);
        if (matcher.record.name && !$f0937cd22668fe14$var$isAliasRecord(matcher)) matcherMap.set(matcher.record.name, matcher);
    }
    function resolve(location$1, currentLocation) {
        let matcher;
        let params = {};
        let path;
        let name;
        if ("name" in location$1 && location$1.name) {
            matcher = matcherMap.get(location$1.name);
            if (!matcher) throw (0, $cnKXL.y)((0, $cnKXL._).MATCHER_NOT_FOUND, {
                location: location$1
            });
            name = matcher.record.name;
            params = (0, $cnKXL.J)($f0937cd22668fe14$var$pickParams(currentLocation.params, matcher.keys.filter((k)=>!k.optional).concat(matcher.parent ? matcher.parent.keys.filter((k)=>k.optional) : []).map((k)=>k.name)), location$1.params && $f0937cd22668fe14$var$pickParams(location$1.params, matcher.keys.map((k)=>k.name)));
            path = matcher.stringify(params);
        } else if (location$1.path != null) {
            path = location$1.path;
            matcher = matchers.find((m)=>m.re.test(path));
            if (matcher) {
                params = matcher.parse(path);
                name = matcher.record.name;
            }
        } else {
            matcher = currentLocation.name ? matcherMap.get(currentLocation.name) : matchers.find((m)=>m.re.test(currentLocation.path));
            if (!matcher) throw (0, $cnKXL.y)((0, $cnKXL._).MATCHER_NOT_FOUND, {
                location: location$1,
                currentLocation: currentLocation
            });
            name = matcher.record.name;
            params = (0, $cnKXL.J)({}, currentLocation.params, location$1.params);
            path = matcher.stringify(params);
        }
        const matched = [];
        let parentMatcher = matcher;
        while(parentMatcher){
            matched.unshift(parentMatcher.record);
            parentMatcher = parentMatcher.parent;
        }
        return {
            name: name,
            path: path,
            params: params,
            matched: matched,
            meta: $f0937cd22668fe14$var$mergeMetaFields(matched)
        };
    }
    routes.forEach((route)=>addRoute(route));
    function clearRoutes() {
        matchers.length = 0;
        matcherMap.clear();
    }
    return {
        addRoute: addRoute,
        resolve: resolve,
        removeRoute: removeRoute,
        clearRoutes: clearRoutes,
        getRoutes: getRoutes,
        getRecordMatcher: getRecordMatcher
    };
}
/**
* Picks an object param to contain only specified keys.
*
* @param params - params object to pick from
* @param keys - keys to pick
*/ function $f0937cd22668fe14$var$pickParams(params, keys) {
    const newParams = {};
    for (const key of keys)if (key in params) newParams[key] = params[key];
    return newParams;
}
/**
* Normalizes a RouteRecordRaw. Creates a copy
*
* @param record
* @returns the normalized version
*/ function $f0937cd22668fe14$var$normalizeRouteRecord(record) {
    const normalized = {
        path: record.path,
        redirect: record.redirect,
        name: record.name,
        meta: record.meta || {},
        aliasOf: record.aliasOf,
        beforeEnter: record.beforeEnter,
        props: $f0937cd22668fe14$var$normalizeRecordProps(record),
        children: record.children || [],
        instances: {},
        leaveGuards: /* @__PURE__ */ new Set(),
        updateGuards: /* @__PURE__ */ new Set(),
        enterCallbacks: {},
        components: "components" in record ? record.components || null : record.component && {
            default: record.component
        }
    };
    Object.defineProperty(normalized, "mods", {
        value: {}
    });
    return normalized;
}
/**
* Normalize the optional `props` in a record to always be an object similar to
* components. Also accept a boolean for components.
* @param record
*/ function $f0937cd22668fe14$var$normalizeRecordProps(record) {
    const propsObject = {};
    const props = record.props || false;
    if ("component" in record) propsObject.default = props;
    else for(const name in record.components)propsObject[name] = typeof props === "object" ? props[name] : props;
    return propsObject;
}
/**
* Checks if a record or any of its parent is an alias
* @param record
*/ function $f0937cd22668fe14$var$isAliasRecord(record) {
    while(record){
        if (record.record.aliasOf) return true;
        record = record.parent;
    }
    return false;
}
/**
* Merge meta fields of an array of records
*
* @param matched - array of matched records
*/ function $f0937cd22668fe14$var$mergeMetaFields(matched) {
    return matched.reduce((meta, record)=>(0, $cnKXL.J)(meta, record.meta), {});
}
function $f0937cd22668fe14$var$isSameParam(a, b) {
    return a.name === b.name && a.optional === b.optional && a.repeatable === b.repeatable;
}
/**
* Check if a path and its alias have the same required params
*
* @param a - original record
* @param b - alias record
*/ function $f0937cd22668fe14$var$checkSameParams(a, b) {
    for (const key of a.keys)if (!key.optional && !b.keys.find($f0937cd22668fe14$var$isSameParam.bind(null, key))) return (0, $cnKXL.K)(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
    for (const key of b.keys)if (!key.optional && !a.keys.find($f0937cd22668fe14$var$isSameParam.bind(null, key))) return (0, $cnKXL.K)(`Alias "${b.record.path}" and the original record: "${a.record.path}" must have the exact same param named "${key.name}"`);
}
/**
* A route with a name and a child with an empty path without a name should warn when adding the route
*
* @param mainNormalizedRecord - RouteRecordNormalized
* @param parent - RouteRecordMatcher
*/ function $f0937cd22668fe14$var$checkChildMissingNameWithEmptyPath(mainNormalizedRecord, parent) {
    if (parent && parent.record.name && !mainNormalizedRecord.name && !mainNormalizedRecord.path) (0, $cnKXL.K)(`The route named "${String(parent.record.name)}" has a child without a name and an empty path. Using that name won't render the empty path child so you probably want to move the name to the child instead. If this is intentional, add a name to the child route to remove the warning.`);
}
function $f0937cd22668fe14$var$checkSameNameAsAncestor(record, parent) {
    for(let ancestor = parent; ancestor; ancestor = ancestor.parent)if (ancestor.record.name === record.name) throw new Error(`A route named "${String(record.name)}" has been added as a ${parent === ancestor ? "child" : "descendant"} of a route with the same name. Route names must be unique and a nested route cannot use the same name as an ancestor.`);
}
function $f0937cd22668fe14$var$checkMissingParamsInAbsolutePath(record, parent) {
    for (const key of parent.keys)if (!record.keys.find($f0937cd22668fe14$var$isSameParam.bind(null, key))) return (0, $cnKXL.K)(`Absolute path "${record.record.path}" must have the exact same param named "${key.name}" as its parent "${parent.record.path}".`);
}
/**
* Performs a binary search to find the correct insertion index for a new matcher.
*
* Matchers are primarily sorted by their score. If scores are tied then we also consider parent/child relationships,
* with descendants coming before ancestors. If there's still a tie, new routes are inserted after existing routes.
*
* @param matcher - new matcher to be inserted
* @param matchers - existing matchers
*/ function $f0937cd22668fe14$var$findInsertionIndex(matcher, matchers) {
    let lower = 0;
    let upper = matchers.length;
    while(lower !== upper){
        const mid = lower + upper >> 1;
        if ($f0937cd22668fe14$var$comparePathParserScore(matcher, matchers[mid]) < 0) upper = mid;
        else lower = mid + 1;
    }
    const insertionAncestor = $f0937cd22668fe14$var$getInsertionAncestor(matcher);
    if (insertionAncestor) upper = matchers.lastIndexOf(insertionAncestor, upper - 1);
    return upper;
}
function $f0937cd22668fe14$var$getInsertionAncestor(matcher) {
    let ancestor = matcher;
    while(ancestor = ancestor.parent)if ($f0937cd22668fe14$var$isMatchable(ancestor) && $f0937cd22668fe14$var$comparePathParserScore(matcher, ancestor) === 0) return ancestor;
}
/**
* Checks if a matcher can be reachable. This means if it's possible to reach it as a route. For example, routes without
* a component, or name, or redirect, are just used to group other routes.
* @param matcher
* @param matcher.record record of the matcher
* @returns
*/ function $f0937cd22668fe14$var$isMatchable({ record: record }) {
    return !!(record.name || record.components && Object.keys(record.components).length || record.redirect);
}
//#endregion
//#region src/RouterLink.ts
/**
* Returns the internal behavior of a {@link RouterLink} without the rendering part.
*
* @param props - a `to` location and an optional `replace` flag
*/ function $f0937cd22668fe14$export$dcf14c9974fe2767(props) {
    const router = (0, $xo6Zx.inject)((0, $cnKXL.d));
    const currentRoute = (0, $xo6Zx.inject)((0, $cnKXL.u));
    let hasPrevious = false;
    let previousTo = null;
    const route = (0, $xo6Zx.computed)(()=>{
        const to = (0, $gIp2w.unref)(props.to);
        return router.resolve(to);
    });
    const activeRecordIndex = (0, $xo6Zx.computed)(()=>{
        const { matched: matched } = route.value;
        const { length: length } = matched;
        const routeMatched = matched[length - 1];
        const currentMatched = currentRoute.matched;
        if (!routeMatched || !currentMatched.length) return -1;
        const index = currentMatched.findIndex((0, $cnKXL.L).bind(null, routeMatched));
        if (index > -1) return index;
        const parentRecordPath = $f0937cd22668fe14$var$getOriginalPath(matched[length - 2]);
        return length > 1 && $f0937cd22668fe14$var$getOriginalPath(routeMatched) === parentRecordPath && currentMatched[currentMatched.length - 1].path !== parentRecordPath ? currentMatched.findIndex((0, $cnKXL.L).bind(null, matched[length - 2])) : index;
    });
    const isActive = (0, $xo6Zx.computed)(()=>activeRecordIndex.value > -1 && $f0937cd22668fe14$var$includesParams(currentRoute.params, route.value.params));
    const isExactActive = (0, $xo6Zx.computed)(()=>activeRecordIndex.value > -1 && activeRecordIndex.value === currentRoute.matched.length - 1 && (0, $cnKXL.I)(currentRoute.params, route.value.params));
    function navigate(e = {}) {
        if ($f0937cd22668fe14$var$guardEvent(e)) {
            const p = router[(0, $gIp2w.unref)(props.replace) ? "replace" : "push"]((0, $gIp2w.unref)(props.to)).catch((0, $cnKXL.Q));
            if (props.viewTransition && typeof document !== "undefined" && "startViewTransition" in document) document.startViewTransition(()=>p);
            return p;
        }
        return Promise.resolve();
    }
    if (__VUE_PROD_DEVTOOLS__ && (0, $cnKXL.$)) {
        const instance = (0, $xo6Zx.getCurrentInstance)();
        if (instance) {
            const linkContextDevtools = {
                route: route.value,
                isActive: isActive.value,
                isExactActive: isExactActive.value,
                error: null
            };
            instance.__vrl_devtools = instance.__vrl_devtools || [];
            instance.__vrl_devtools.push(linkContextDevtools);
            (0, $xo6Zx.watchEffect)(()=>{
                linkContextDevtools.route = route.value;
                linkContextDevtools.isActive = isActive.value;
                linkContextDevtools.isExactActive = isExactActive.value;
                linkContextDevtools.error = (0, $cnKXL.x)((0, $gIp2w.unref)(props.to)) ? null : "Invalid \"to\" value";
            }, {
                flush: "post"
            });
        }
    }
    /**
	* NOTE: update {@link _RouterLinkI}'s `$slots` type when updating this
	*/ return {
        route: route,
        href: (0, $xo6Zx.computed)(()=>route.value.href),
        isActive: isActive,
        isExactActive: isExactActive,
        navigate: navigate
    };
}
function $f0937cd22668fe14$var$preferSingleVNode(vnodes) {
    return vnodes.length === 1 ? vnodes[0] : vnodes;
}
const $f0937cd22668fe14$var$RouterLinkImpl = /* @__PURE__ */ (0, $xo6Zx.defineComponent)({
    name: "RouterLink",
    compatConfig: {
        MODE: 3
    },
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        replace: Boolean,
        activeClass: String,
        exactActiveClass: String,
        custom: Boolean,
        ariaCurrentValue: {
            type: String,
            default: "page"
        },
        viewTransition: Boolean
    },
    useLink: $f0937cd22668fe14$export$dcf14c9974fe2767,
    setup (props, { slots: slots }) {
        const link = (0, $gIp2w.reactive)($f0937cd22668fe14$export$dcf14c9974fe2767(props));
        const { options: options } = (0, $xo6Zx.inject)((0, $cnKXL.d));
        const elClass = (0, $xo6Zx.computed)(()=>({
                [$f0937cd22668fe14$var$getLinkClass(props.activeClass, options.linkActiveClass, "router-link-active")]: link.isActive,
                [$f0937cd22668fe14$var$getLinkClass(props.exactActiveClass, options.linkExactActiveClass, "router-link-exact-active")]: link.isExactActive
            }));
        return ()=>{
            const children = slots.default && $f0937cd22668fe14$var$preferSingleVNode(slots.default(link));
            return props.custom ? children : (0, $xo6Zx.h)("a", {
                "aria-current": link.isExactActive ? props.ariaCurrentValue : null,
                href: link.href,
                onClick: link.navigate,
                class: elClass.value
            }, children);
        };
    }
});
/**
* Component to render a link that triggers a navigation on click.
*/ const $f0937cd22668fe14$export$fce709ebdac448ed = $f0937cd22668fe14$var$RouterLinkImpl;
function $f0937cd22668fe14$var$guardEvent(e) {
    if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    if (e.defaultPrevented) return;
    if (e.button !== void 0 && e.button !== 0) return;
    if (e.currentTarget && e.currentTarget.getAttribute) {
        const target = e.currentTarget.getAttribute("target");
        if (/\b_blank\b/i.test(target)) return;
    }
    if (e.preventDefault) e.preventDefault();
    return true;
}
function $f0937cd22668fe14$var$includesParams(outer, inner) {
    for(const key in inner){
        const innerValue = inner[key];
        const outerValue = outer[key];
        if (typeof innerValue === "string") {
            if (innerValue !== outerValue) return false;
        } else if (!(0, $cnKXL.X)(outerValue) || outerValue.length !== innerValue.length || innerValue.some((value, i)=>value.valueOf() !== outerValue[i].valueOf())) return false;
    }
    return true;
}
/**
* Get the original path value of a record by following its aliasOf
* @param record
*/ function $f0937cd22668fe14$var$getOriginalPath(record) {
    return record ? record.aliasOf ? record.aliasOf.path : record.path : "";
}
/**
* Utility class to get the active class based on defaults.
* @param propClass
* @param globalClass
* @param defaultClass
*/ const $f0937cd22668fe14$var$getLinkClass = (propClass, globalClass, defaultClass)=>propClass != null ? propClass : globalClass != null ? globalClass : defaultClass;
//#endregion
//#region src/RouterView.ts
const $f0937cd22668fe14$var$RouterViewImpl = /* @__PURE__ */ (0, $xo6Zx.defineComponent)({
    name: "RouterView",
    inheritAttrs: false,
    props: {
        name: {
            type: String,
            default: "default"
        },
        route: Object
    },
    compatConfig: {
        MODE: 3
    },
    setup (props, { attrs: attrs, slots: slots }) {
        const injectedRoute = (0, $xo6Zx.inject)((0, $cnKXL.f));
        const routeToDisplay = (0, $xo6Zx.computed)(()=>props.route || injectedRoute.value);
        const injectedDepth = (0, $xo6Zx.inject)((0, $cnKXL.p), 0);
        const depth = (0, $xo6Zx.computed)(()=>{
            let initialDepth = (0, $gIp2w.unref)(injectedDepth);
            const { matched: matched } = routeToDisplay.value;
            let matchedRoute;
            while((matchedRoute = matched[initialDepth]) && !matchedRoute.components)initialDepth++;
            return initialDepth;
        });
        const matchedRouteRef = (0, $xo6Zx.computed)(()=>routeToDisplay.value.matched[depth.value]);
        (0, $xo6Zx.provide)((0, $cnKXL.p), (0, $xo6Zx.computed)(()=>depth.value + 1));
        (0, $xo6Zx.provide)((0, $cnKXL.l), matchedRouteRef);
        (0, $xo6Zx.provide)((0, $cnKXL.f), routeToDisplay);
        const viewRef = (0, $gIp2w.ref)();
        (0, $xo6Zx.watch)(()=>[
                viewRef.value,
                matchedRouteRef.value,
                props.name
            ], ([instance, to, name], [oldInstance, from, oldName])=>{
            if (to) {
                to.instances[name] = instance;
                if (from && from !== to && instance && instance === oldInstance) {
                    if (!to.leaveGuards.size) to.leaveGuards = from.leaveGuards;
                    if (!to.updateGuards.size) to.updateGuards = from.updateGuards;
                }
            }
            if (instance && to && (!from || !(0, $cnKXL.L)(to, from) || !oldInstance)) (to.enterCallbacks[name] || []).forEach((callback)=>callback(instance));
        }, {
            flush: "post"
        });
        return ()=>{
            const route = routeToDisplay.value;
            const currentName = props.name;
            const matchedRoute = matchedRouteRef.value;
            const ViewComponent = matchedRoute && matchedRoute.components[currentName];
            if (!ViewComponent) return $f0937cd22668fe14$var$normalizeSlot(slots.default, {
                Component: ViewComponent,
                route: route
            });
            const routePropsOption = matchedRoute.props[currentName];
            const routeProps = routePropsOption ? routePropsOption === true ? route.params : typeof routePropsOption === "function" ? routePropsOption(route) : routePropsOption : null;
            const onVnodeUnmounted = (vnode)=>{
                if (vnode.component.isUnmounted) matchedRoute.instances[currentName] = null;
            };
            const component = (0, $xo6Zx.h)(ViewComponent, (0, $cnKXL.J)({}, routeProps, attrs, {
                onVnodeUnmounted: onVnodeUnmounted,
                ref: viewRef
            }));
            if (__VUE_PROD_DEVTOOLS__ && (0, $cnKXL.$) && component.ref) {
                const info = {
                    depth: depth.value,
                    name: matchedRoute.name,
                    path: matchedRoute.path,
                    meta: matchedRoute.meta
                };
                ((0, $cnKXL.X)(component.ref) ? component.ref.map((r)=>r.i) : [
                    component.ref.i
                ]).forEach((instance)=>{
                    instance.__vrv_devtools = info;
                });
            }
            return $f0937cd22668fe14$var$normalizeSlot(slots.default, {
                Component: component,
                route: route
            }) || component;
        };
    }
});
function $f0937cd22668fe14$var$normalizeSlot(slot, data) {
    if (!slot) return null;
    const slotContent = slot(data);
    return slotContent.length === 1 ? slotContent[0] : slotContent;
}
/**
* Component to display the current route the user is at.
*/ const $f0937cd22668fe14$export$d941f00e9b9a537 = $f0937cd22668fe14$var$RouterViewImpl;
function $f0937cd22668fe14$var$warnDeprecatedUsage() {
    const instance = (0, $xo6Zx.getCurrentInstance)();
    const parentName = instance.parent && instance.parent.type.name;
    const parentSubTreeType = instance.parent && instance.parent.subTree && instance.parent.subTree.type;
    if (parentName && (parentName === "KeepAlive" || parentName.includes("Transition")) && typeof parentSubTreeType === "object" && parentSubTreeType.name === "RouterView") {
        const comp = parentName === "KeepAlive" ? "keep-alive" : "transition";
        (0, $cnKXL.K)(`<router-view> can no longer be used directly inside <transition> or <keep-alive>.
Use slot props instead:

<router-view v-slot="{ Component }">
  <${comp}>\n    <component :is="Component" />\n  </${comp}>\n</router-view>`);
    }
}
//#endregion
//#region src/router.ts
/**
* Creates a Router instance that can be used by a Vue app.
*
* @param options - {@link RouterOptions}
*/ function $f0937cd22668fe14$export$baddd0131ee8c05b(options) {
    const matcher = $f0937cd22668fe14$export$36302c85fdcc95a8(options.routes, options);
    const parseQuery$1 = options.parseQuery || (0, $cnKXL.h);
    const stringifyQuery$1 = options.stringifyQuery || (0, $cnKXL.g);
    const routerHistory = options.history;
    const beforeGuards = (0, $cnKXL.c)();
    const beforeResolveGuards = (0, $cnKXL.c)();
    const afterGuards = (0, $cnKXL.c)();
    const currentRoute = (0, $gIp2w.shallowRef)((0, $cnKXL.P));
    let pendingLocation = (0, $cnKXL.P);
    if ((0, $cnKXL.$) && options.scrollBehavior && "scrollRestoration" in history) history.scrollRestoration = "manual";
    const normalizeParams = (0, $cnKXL.q).bind(null, (paramValue)=>"" + paramValue);
    const encodeParams = (0, $cnKXL.q).bind(null, (0, $cnKXL.W));
    const decodeParams = (0, $cnKXL.q).bind(null, (0, $cnKXL.H));
    function addRoute(parentOrRoute, route) {
        let parent;
        let record;
        if ((0, $cnKXL.S)(parentOrRoute)) {
            parent = matcher.getRecordMatcher(parentOrRoute);
            record = route;
        } else record = parentOrRoute;
        return matcher.addRoute(record, parent);
    }
    function removeRoute(name) {
        const recordMatcher = matcher.getRecordMatcher(name);
        if (recordMatcher) matcher.removeRoute(recordMatcher);
    }
    function getRoutes() {
        return matcher.getRoutes().map((routeMatcher)=>routeMatcher.record);
    }
    function hasRoute(name) {
        return !!matcher.getRecordMatcher(name);
    }
    function resolve(rawLocation, currentLocation) {
        currentLocation = (0, $cnKXL.J)({}, currentLocation || currentRoute.value);
        if (typeof rawLocation === "string") {
            const locationNormalized = (0, $cnKXL.R)(parseQuery$1, rawLocation, currentLocation.path);
            const matchedRoute$1 = matcher.resolve({
                path: locationNormalized.path
            }, currentLocation);
            const href$1 = routerHistory.createHref(locationNormalized.fullPath);
            return (0, $cnKXL.J)(locationNormalized, matchedRoute$1, {
                params: decodeParams(matchedRoute$1.params),
                hash: (0, $cnKXL.H)(locationNormalized.hash),
                redirectedFrom: void 0,
                href: href$1
            });
        }
        let matcherLocation;
        if (rawLocation.path != null) matcherLocation = (0, $cnKXL.J)({}, rawLocation, {
            path: (0, $cnKXL.R)(parseQuery$1, rawLocation.path, currentLocation.path).path
        });
        else {
            const targetParams = (0, $cnKXL.J)({}, rawLocation.params);
            for(const key in targetParams)if (targetParams[key] == null) delete targetParams[key];
            matcherLocation = (0, $cnKXL.J)({}, rawLocation, {
                params: encodeParams(targetParams)
            });
            currentLocation.params = encodeParams(currentLocation.params);
        }
        const matchedRoute = matcher.resolve(matcherLocation, currentLocation);
        const hash = rawLocation.hash || "";
        matchedRoute.params = normalizeParams(decodeParams(matchedRoute.params));
        const fullPath = (0, $cnKXL.B)(stringifyQuery$1, (0, $cnKXL.J)({}, rawLocation, {
            hash: (0, $cnKXL.U)(hash),
            path: matchedRoute.path
        }));
        const href = routerHistory.createHref(fullPath);
        return (0, $cnKXL.J)({
            fullPath: fullPath,
            hash: hash,
            query: stringifyQuery$1 === (0, $cnKXL.g) ? (0, $cnKXL.m)(rawLocation.query) : rawLocation.query || {}
        }, matchedRoute, {
            redirectedFrom: void 0,
            href: href
        });
    }
    function locationAsObject(to) {
        return typeof to === "string" ? (0, $cnKXL.R)(parseQuery$1, to, currentRoute.value.path) : (0, $cnKXL.J)({}, to);
    }
    function checkCanceledNavigation(to, from) {
        if (pendingLocation !== to) return (0, $cnKXL.y)((0, $cnKXL._).NAVIGATION_CANCELLED, {
            from: from,
            to: to
        });
    }
    function push(to) {
        return pushWithRedirect(to);
    }
    function replace(to) {
        return push((0, $cnKXL.J)(locationAsObject(to), {
            replace: true
        }));
    }
    function handleRedirectRecord(to, from) {
        const lastMatched = to.matched[to.matched.length - 1];
        if (lastMatched && lastMatched.redirect) {
            const { redirect: redirect } = lastMatched;
            let newTargetLocation = typeof redirect === "function" ? redirect(to, from) : redirect;
            if (typeof newTargetLocation === "string") {
                newTargetLocation = newTargetLocation.includes("?") || newTargetLocation.includes("#") ? newTargetLocation = locationAsObject(newTargetLocation) : {
                    path: newTargetLocation
                };
                newTargetLocation.params = {};
            }
            return (0, $cnKXL.J)({
                query: to.query,
                hash: to.hash,
                params: newTargetLocation.path != null ? {} : to.params
            }, newTargetLocation);
        }
    }
    function pushWithRedirect(to, redirectedFrom) {
        const targetLocation = pendingLocation = resolve(to);
        const from = currentRoute.value;
        const data = to.state;
        const force = to.force;
        const replace$1 = to.replace === true;
        const shouldRedirect = handleRedirectRecord(targetLocation, from);
        if (shouldRedirect) return pushWithRedirect((0, $cnKXL.J)(locationAsObject(shouldRedirect), {
            state: typeof shouldRedirect === "object" ? (0, $cnKXL.J)({}, data, shouldRedirect.state) : data,
            force: force,
            replace: replace$1
        }), redirectedFrom || targetLocation);
        const toLocation = targetLocation;
        toLocation.redirectedFrom = redirectedFrom;
        let failure;
        if (!force && (0, $cnKXL.F)(stringifyQuery$1, from, targetLocation)) {
            failure = (0, $cnKXL.y)((0, $cnKXL._).NAVIGATION_DUPLICATED, {
                to: toLocation,
                from: from
            });
            handleScroll(from, from, true, false);
        }
        return (failure ? Promise.resolve(failure) : navigate(toLocation, from)).catch((error)=>(0, $cnKXL.b)(error) ? (0, $cnKXL.b)(error, (0, $cnKXL._).NAVIGATION_GUARD_REDIRECT) ? error : markAsReady(error) : triggerError(error, toLocation, from)).then((failure$1)=>{
            if (failure$1) {
                if ((0, $cnKXL.b)(failure$1, (0, $cnKXL._).NAVIGATION_GUARD_REDIRECT)) return pushWithRedirect((0, $cnKXL.J)({
                    replace: replace$1
                }, locationAsObject(failure$1.to), {
                    state: typeof failure$1.to === "object" ? (0, $cnKXL.J)({}, data, failure$1.to.state) : data,
                    force: force
                }), redirectedFrom || toLocation);
            } else failure$1 = finalizeNavigation(toLocation, from, true, replace$1, data);
            triggerAfterEach(toLocation, from, failure$1);
            return failure$1;
        });
    }
    /**
	* Helper to reject and skip all navigation guards if a new navigation happened
	* @param to
	* @param from
	*/ function checkCanceledNavigationAndReject(to, from) {
        const error = checkCanceledNavigation(to, from);
        return error ? Promise.reject(error) : Promise.resolve();
    }
    function runWithContext(fn) {
        const app = installedApps.values().next().value;
        return app && typeof app.runWithContext === "function" ? app.runWithContext(fn) : fn();
    }
    function navigate(to, from) {
        let guards;
        const [leavingRecords, updatingRecords, enteringRecords] = (0, $cnKXL.n)(to, from);
        guards = (0, $cnKXL.r)(leavingRecords.reverse(), "beforeRouteLeave", to, from);
        for (const record of leavingRecords)record.leaveGuards.forEach((guard)=>{
            guards.push((0, $cnKXL.i)(guard, to, from));
        });
        const canceledNavigationCheck = checkCanceledNavigationAndReject.bind(null, to, from);
        guards.push(canceledNavigationCheck);
        return runGuardQueue(guards).then(()=>{
            guards = [];
            for (const guard of beforeGuards.list())guards.push((0, $cnKXL.i)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = (0, $cnKXL.r)(updatingRecords, "beforeRouteUpdate", to, from);
            for (const record of updatingRecords)record.updateGuards.forEach((guard)=>{
                guards.push((0, $cnKXL.i)(guard, to, from));
            });
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const record of enteringRecords)if (record.beforeEnter) {
                if ((0, $cnKXL.X)(record.beforeEnter)) for (const beforeEnter of record.beforeEnter)guards.push((0, $cnKXL.i)(beforeEnter, to, from));
                else guards.push((0, $cnKXL.i)(record.beforeEnter, to, from));
            }
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            to.matched.forEach((record)=>record.enterCallbacks = {});
            guards = (0, $cnKXL.r)(enteringRecords, "beforeRouteEnter", to, from, runWithContext);
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).then(()=>{
            guards = [];
            for (const guard of beforeResolveGuards.list())guards.push((0, $cnKXL.i)(guard, to, from));
            guards.push(canceledNavigationCheck);
            return runGuardQueue(guards);
        }).catch((err)=>(0, $cnKXL.b)(err, (0, $cnKXL._).NAVIGATION_CANCELLED) ? err : Promise.reject(err));
    }
    function triggerAfterEach(to, from, failure) {
        afterGuards.list().forEach((guard)=>runWithContext(()=>guard(to, from, failure)));
    }
    /**
	* - Cleans up any navigation guards
	* - Changes the url if necessary
	* - Calls the scrollBehavior
	*/ function finalizeNavigation(toLocation, from, isPush, replace$1, data) {
        const error = checkCanceledNavigation(toLocation, from);
        if (error) return error;
        const isFirstNavigation = from === (0, $cnKXL.P);
        const state = !(0, $cnKXL.$) ? {} : history.state;
        if (isPush) {
            if (replace$1 || isFirstNavigation) routerHistory.replace(toLocation.fullPath, (0, $cnKXL.J)({
                scroll: isFirstNavigation && state && state.scroll
            }, data));
            else routerHistory.push(toLocation.fullPath, data);
        }
        currentRoute.value = toLocation;
        handleScroll(toLocation, from, isPush, isFirstNavigation);
        markAsReady();
    }
    let removeHistoryListener;
    function setupListeners() {
        if (removeHistoryListener) return;
        removeHistoryListener = routerHistory.listen((to, _from, info)=>{
            if (!router.listening) return;
            const toLocation = resolve(to);
            const shouldRedirect = handleRedirectRecord(toLocation, router.currentRoute.value);
            if (shouldRedirect) {
                pushWithRedirect((0, $cnKXL.J)(shouldRedirect, {
                    replace: true,
                    force: true
                }), toLocation).catch((0, $cnKXL.Q));
                return;
            }
            pendingLocation = toLocation;
            const from = currentRoute.value;
            if (0, $cnKXL.$) (0, $cnKXL.E)((0, $cnKXL.T)(from.fullPath, info.delta), (0, $cnKXL.C)());
            navigate(toLocation, from).catch((error)=>{
                if ((0, $cnKXL.b)(error, (0, $cnKXL._).NAVIGATION_ABORTED | (0, $cnKXL._).NAVIGATION_CANCELLED)) return error;
                if ((0, $cnKXL.b)(error, (0, $cnKXL._).NAVIGATION_GUARD_REDIRECT)) {
                    pushWithRedirect((0, $cnKXL.J)(locationAsObject(error.to), {
                        force: true
                    }), toLocation).then((failure)=>{
                        if ((0, $cnKXL.b)(failure, (0, $cnKXL._).NAVIGATION_ABORTED | (0, $cnKXL._).NAVIGATION_DUPLICATED) && !info.delta && info.type === (0, $cnKXL.k).pop) routerHistory.go(-1, false);
                    }).catch((0, $cnKXL.Q));
                    return Promise.reject();
                }
                if (info.delta) routerHistory.go(-info.delta, false);
                return triggerError(error, toLocation, from);
            }).then((failure)=>{
                failure = failure || finalizeNavigation(toLocation, from, false);
                if (failure) {
                    if (info.delta && !(0, $cnKXL.b)(failure, (0, $cnKXL._).NAVIGATION_CANCELLED)) routerHistory.go(-info.delta, false);
                    else if (info.type === (0, $cnKXL.k).pop && (0, $cnKXL.b)(failure, (0, $cnKXL._).NAVIGATION_ABORTED | (0, $cnKXL._).NAVIGATION_DUPLICATED)) routerHistory.go(-1, false);
                }
                triggerAfterEach(toLocation, from, failure);
            }).catch((0, $cnKXL.Q));
        });
    }
    let readyHandlers = (0, $cnKXL.c)();
    let errorListeners = (0, $cnKXL.c)();
    let ready;
    /**
	* Trigger errorListeners added via onError and throws the error as well
	*
	* @param error - error to throw
	* @param to - location we were navigating to when the error happened
	* @param from - location we were navigating from when the error happened
	* @returns the error as a rejected promise
	*/ function triggerError(error, to, from) {
        markAsReady(error);
        const list = errorListeners.list();
        if (list.length) list.forEach((handler)=>handler(error, to, from));
        else console.error(error);
        return Promise.reject(error);
    }
    function isReady() {
        if (ready && currentRoute.value !== (0, $cnKXL.P)) return Promise.resolve();
        return new Promise((resolve$1, reject)=>{
            readyHandlers.add([
                resolve$1,
                reject
            ]);
        });
    }
    function markAsReady(err) {
        if (!ready) {
            ready = !err;
            setupListeners();
            readyHandlers.list().forEach(([resolve$1, reject])=>err ? reject(err) : resolve$1());
            readyHandlers.reset();
        }
        return err;
    }
    function handleScroll(to, from, isPush, isFirstNavigation) {
        const { scrollBehavior: scrollBehavior } = options;
        if (!(0, $cnKXL.$) || !scrollBehavior) return Promise.resolve();
        const scrollPosition = !isPush && (0, $cnKXL.w)((0, $cnKXL.T)(to.fullPath, 0)) || (isFirstNavigation || !isPush) && history.state && history.state.scroll || null;
        return (0, $xo6Zx.nextTick)().then(()=>scrollBehavior(to, from, scrollPosition)).then((position)=>position && (0, $cnKXL.D)(position)).catch((err)=>triggerError(err, to, from));
    }
    const go = (delta)=>routerHistory.go(delta);
    let started;
    const installedApps = /* @__PURE__ */ new Set();
    const router = {
        currentRoute: currentRoute,
        listening: true,
        addRoute: addRoute,
        removeRoute: removeRoute,
        clearRoutes: matcher.clearRoutes,
        hasRoute: hasRoute,
        getRoutes: getRoutes,
        resolve: resolve,
        options: options,
        push: push,
        replace: replace,
        go: go,
        back: ()=>go(-1),
        forward: ()=>go(1),
        beforeEach: beforeGuards.add,
        beforeResolve: beforeResolveGuards.add,
        afterEach: afterGuards.add,
        onError: errorListeners.add,
        isReady: isReady,
        install (app) {
            app.component("RouterLink", $f0937cd22668fe14$export$fce709ebdac448ed);
            app.component("RouterView", $f0937cd22668fe14$export$d941f00e9b9a537);
            app.config.globalProperties.$router = router;
            Object.defineProperty(app.config.globalProperties, "$route", {
                enumerable: true,
                get: ()=>(0, $gIp2w.unref)(currentRoute)
            });
            if ((0, $cnKXL.$) && !started && currentRoute.value === (0, $cnKXL.P)) {
                started = true;
                push(routerHistory.location).catch((err)=>{});
            }
            const reactiveRoute = {};
            for(const key in 0, $cnKXL.P)Object.defineProperty(reactiveRoute, key, {
                get: ()=>currentRoute.value[key],
                enumerable: true
            });
            app.provide((0, $cnKXL.d), router);
            app.provide((0, $cnKXL.u), (0, $gIp2w.shallowReactive)(reactiveRoute));
            app.provide((0, $cnKXL.f), currentRoute);
            const unmountApp = app.unmount;
            installedApps.add(app);
            app.unmount = function() {
                installedApps.delete(app);
                if (installedApps.size < 1) {
                    pendingLocation = (0, $cnKXL.P);
                    removeHistoryListener && removeHistoryListener();
                    removeHistoryListener = null;
                    currentRoute.value = (0, $cnKXL.P);
                    started = false;
                    ready = false;
                }
                unmountApp();
            };
            if (__VUE_PROD_DEVTOOLS__ && (0, $cnKXL.$)) (0, $cnKXL.t)(app, router, matcher);
        }
    };
    function runGuardQueue(guards) {
        return guards.reduce((promise, guard)=>promise.then(()=>runWithContext(guard)), Promise.resolve());
    }
    return router;
}
//#endregion
//#region src/useApi.ts
/**
* Returns the router instance. Equivalent to using `$router` inside
* templates.
*/ function $f0937cd22668fe14$export$9a302a45f65d0572() {
    return (0, $xo6Zx.inject)((0, $cnKXL.d));
}
/**
* Returns the current route location. Equivalent to using `$route` inside
* templates.
*/ function $f0937cd22668fe14$export$3f79f0b98112cf57(_name) {
    return (0, $xo6Zx.inject)((0, $cnKXL.u));
}

});
parcelRegister("cnKXL", function(module, exports) {

$parcel$export(module.exports, "$", () => $8db1fcb70914244a$export$3d8c2f653ac9d0b9);
$parcel$export(module.exports, "J", () => $8db1fcb70914244a$export$b4171a6734a65d42);
$parcel$export(module.exports, "q", () => $8db1fcb70914244a$export$9e5f44173e64f162);
$parcel$export(module.exports, "X", () => $8db1fcb70914244a$export$78acf4525d8a74c4);
$parcel$export(module.exports, "Q", () => $8db1fcb70914244a$export$3722cfe417b6ed86);
$parcel$export(module.exports, "Z", () => $8db1fcb70914244a$export$dc98b0b04f4c7758);
$parcel$export(module.exports, "K", () => $8db1fcb70914244a$export$3466f893ebf79586);
$parcel$export(module.exports, "U", () => $8db1fcb70914244a$export$3a6d5c9ae78a2c08);
$parcel$export(module.exports, "W", () => $8db1fcb70914244a$export$71cec2538cb2c617);
$parcel$export(module.exports, "H", () => $8db1fcb70914244a$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "R", () => $8db1fcb70914244a$export$db202ddc8be9136);
$parcel$export(module.exports, "B", () => $8db1fcb70914244a$export$ef35774e6d314e91);
$parcel$export(module.exports, "V", () => $8db1fcb70914244a$export$e7c866399fa523f5);
$parcel$export(module.exports, "F", () => $8db1fcb70914244a$export$d66501df72047452);
$parcel$export(module.exports, "L", () => $8db1fcb70914244a$export$61196ced6d74a310);
$parcel$export(module.exports, "I", () => $8db1fcb70914244a$export$9bb611d729802a56);
$parcel$export(module.exports, "P", () => $8db1fcb70914244a$export$56c0d5a1e737357d);
$parcel$export(module.exports, "k", () => $8db1fcb70914244a$export$342063e11d6c3cad);
$parcel$export(module.exports, "O", () => $8db1fcb70914244a$export$c4ce752e73470fba);
$parcel$export(module.exports, "A", () => $8db1fcb70914244a$export$ebd11618f299a286);
$parcel$export(module.exports, "M", () => $8db1fcb70914244a$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "j", () => $8db1fcb70914244a$export$35e795649ee09318);
$parcel$export(module.exports, "C", () => $8db1fcb70914244a$export$e7094788287c5e9b);
$parcel$export(module.exports, "D", () => $8db1fcb70914244a$export$96f57966bedc81b4);
$parcel$export(module.exports, "T", () => $8db1fcb70914244a$export$971d5caa766a69d7);
$parcel$export(module.exports, "E", () => $8db1fcb70914244a$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "w", () => $8db1fcb70914244a$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $8db1fcb70914244a$export$d141bba7fdc215a3);
$parcel$export(module.exports, "S", () => $8db1fcb70914244a$export$25ce5a424b770e84);
$parcel$export(module.exports, "_", () => $8db1fcb70914244a$export$71511d61b312f219);
$parcel$export(module.exports, "y", () => $8db1fcb70914244a$export$4a5767248b18ef41);
$parcel$export(module.exports, "b", () => $8db1fcb70914244a$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "h", () => $8db1fcb70914244a$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "g", () => $8db1fcb70914244a$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $8db1fcb70914244a$export$953cecd6e717a553);
$parcel$export(module.exports, "l", () => $8db1fcb70914244a$export$882b5998b3b9117c);
$parcel$export(module.exports, "p", () => $8db1fcb70914244a$export$ffb5f4729a158638);
$parcel$export(module.exports, "d", () => $8db1fcb70914244a$export$4368d992c4eafac0);
$parcel$export(module.exports, "u", () => $8db1fcb70914244a$export$3b14a55fb2447963);
$parcel$export(module.exports, "f", () => $8db1fcb70914244a$export$2d1720544b23b823);
$parcel$export(module.exports, "c", () => $8db1fcb70914244a$export$db3b6bfb95261072);
$parcel$export(module.exports, "s", () => $8db1fcb70914244a$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "i", () => $8db1fcb70914244a$export$23f2a1d2818174ef);
$parcel$export(module.exports, "r", () => $8db1fcb70914244a$export$43caf9889c228507);
$parcel$export(module.exports, "n", () => $8db1fcb70914244a$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "t", () => $8db1fcb70914244a$export$625550452a3fa3ec);
/*!
 * vue-router v4.6.4
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");

var $7RVFN = parcelRequire("7RVFN");
//#region src/utils/env.ts
const $8db1fcb70914244a$export$3d8c2f653ac9d0b9 = typeof document !== "undefined";
//#endregion
//#region src/utils/index.ts
/**
* Identity function that returns the value as is.
*
* @param v - the value to return
*
* @internal
*/ const $8db1fcb70914244a$export$8743009a87fcb00f = (v)=>v;
/**
* Allows differentiating lazy components from functional components and vue-class-component
* @internal
*
* @param component
*/ function $8db1fcb70914244a$var$isRouteComponent(component) {
    return typeof component === "object" || "displayName" in component || "props" in component || "__vccOpts" in component;
}
function $8db1fcb70914244a$var$isESModule(obj) {
    return obj.__esModule || obj[Symbol.toStringTag] === "Module" || obj.default && $8db1fcb70914244a$var$isRouteComponent(obj.default);
}
const $8db1fcb70914244a$export$b4171a6734a65d42 = Object.assign;
function $8db1fcb70914244a$export$9e5f44173e64f162(fn, params) {
    const newParams = {};
    for(const key in params){
        const value = params[key];
        newParams[key] = $8db1fcb70914244a$export$78acf4525d8a74c4(value) ? value.map(fn) : fn(value);
    }
    return newParams;
}
const $8db1fcb70914244a$export$3722cfe417b6ed86 = ()=>{};
/**
* Typesafe alternative to Array.isArray
* https://github.com/microsoft/TypeScript/pull/48228
*
* @internal
*/ const $8db1fcb70914244a$export$78acf4525d8a74c4 = Array.isArray;
function $8db1fcb70914244a$export$dc98b0b04f4c7758(defaults, partialOptions) {
    const options = {};
    for(const key in defaults)options[key] = key in partialOptions ? partialOptions[key] : defaults[key];
    return options;
}
//#endregion
//#region src/warning.ts
function $8db1fcb70914244a$export$3466f893ebf79586(msg) {
    const args = Array.from(arguments).slice(1);
    console.warn.apply(console, [
        "[Vue Router warn]: " + msg
    ].concat(args));
}
//#endregion
//#region src/encoding.ts
/**
* Encoding Rules (␣ = Space)
* - Path: ␣ " < > # ? { }
* - Query: ␣ " < > # & =
* - Hash: ␣ " < > `
*
* On top of that, the RFC3986 (https://tools.ietf.org/html/rfc3986#section-2.2)
* defines some extra characters to be encoded. Most browsers do not encode them
* in encodeURI https://github.com/whatwg/url/issues/369, so it may be safer to
* also encode `!'()*`. Leaving un-encoded only ASCII alphanumeric(`a-zA-Z0-9`)
* plus `-._~`. This extra safety should be applied to query by patching the
* string returned by encodeURIComponent encodeURI also encodes `[\]^`. `\`
* should be encoded to avoid ambiguity. Browsers (IE, FF, C) transform a `\`
* into a `/` if directly typed in. The _backtick_ (`````) should also be
* encoded everywhere because some browsers like FF encode it when directly
* written while others don't. Safari and IE don't encode ``"<>{}``` in hash.
*/ const $8db1fcb70914244a$var$HASH_RE = /#/g;
const $8db1fcb70914244a$var$AMPERSAND_RE = /&/g;
const $8db1fcb70914244a$var$SLASH_RE = /\//g;
const $8db1fcb70914244a$var$EQUAL_RE = /=/g;
const $8db1fcb70914244a$var$IM_RE = /\?/g;
const $8db1fcb70914244a$var$PLUS_RE = /\+/g;
/**
* NOTE: It's not clear to me if we should encode the + symbol in queries, it
* seems to be less flexible than not doing so and I can't find out the legacy
* systems requiring this for regular requests like text/html. In the standard,
* the encoding of the plus character is only mentioned for
* application/x-www-form-urlencoded
* (https://url.spec.whatwg.org/#urlencoded-parsing) and most browsers seems lo
* leave the plus character as is in queries. To be more flexible, we allow the
* plus character on the query, but it can also be manually encoded by the user.
*
* Resources:
* - https://url.spec.whatwg.org/#urlencoded-parsing
* - https://stackoverflow.com/questions/1634271/url-encoding-the-space-character-or-20
*/ const $8db1fcb70914244a$var$ENC_BRACKET_OPEN_RE = /%5B/g;
const $8db1fcb70914244a$var$ENC_BRACKET_CLOSE_RE = /%5D/g;
const $8db1fcb70914244a$var$ENC_CARET_RE = /%5E/g;
const $8db1fcb70914244a$var$ENC_BACKTICK_RE = /%60/g;
const $8db1fcb70914244a$var$ENC_CURLY_OPEN_RE = /%7B/g;
const $8db1fcb70914244a$var$ENC_PIPE_RE = /%7C/g;
const $8db1fcb70914244a$var$ENC_CURLY_CLOSE_RE = /%7D/g;
const $8db1fcb70914244a$var$ENC_SPACE_RE = /%20/g;
/**
* Encode characters that need to be encoded on the path, search and hash
* sections of the URL.
*
* @internal
* @param text - string to encode
* @returns encoded string
*/ function $8db1fcb70914244a$var$commonEncode(text) {
    return text == null ? "" : encodeURI("" + text).replace($8db1fcb70914244a$var$ENC_PIPE_RE, "|").replace($8db1fcb70914244a$var$ENC_BRACKET_OPEN_RE, "[").replace($8db1fcb70914244a$var$ENC_BRACKET_CLOSE_RE, "]");
}
/**
* Encode characters that need to be encoded on the hash section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $8db1fcb70914244a$export$3a6d5c9ae78a2c08(text) {
    return $8db1fcb70914244a$var$commonEncode(text).replace($8db1fcb70914244a$var$ENC_CURLY_OPEN_RE, "{").replace($8db1fcb70914244a$var$ENC_CURLY_CLOSE_RE, "}").replace($8db1fcb70914244a$var$ENC_CARET_RE, "^");
}
/**
* Encode characters that need to be encoded query values on the query
* section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $8db1fcb70914244a$var$encodeQueryValue(text) {
    return $8db1fcb70914244a$var$commonEncode(text).replace($8db1fcb70914244a$var$PLUS_RE, "%2B").replace($8db1fcb70914244a$var$ENC_SPACE_RE, "+").replace($8db1fcb70914244a$var$HASH_RE, "%23").replace($8db1fcb70914244a$var$AMPERSAND_RE, "%26").replace($8db1fcb70914244a$var$ENC_BACKTICK_RE, "`").replace($8db1fcb70914244a$var$ENC_CURLY_OPEN_RE, "{").replace($8db1fcb70914244a$var$ENC_CURLY_CLOSE_RE, "}").replace($8db1fcb70914244a$var$ENC_CARET_RE, "^");
}
/**
* Like `encodeQueryValue` but also encodes the `=` character.
*
* @param text - string to encode
*/ function $8db1fcb70914244a$var$encodeQueryKey(text) {
    return $8db1fcb70914244a$var$encodeQueryValue(text).replace($8db1fcb70914244a$var$EQUAL_RE, "%3D");
}
/**
* Encode characters that need to be encoded on the path section of the URL.
*
* @param text - string to encode
* @returns encoded string
*/ function $8db1fcb70914244a$export$2329c99376c9d0a4(text) {
    return $8db1fcb70914244a$var$commonEncode(text).replace($8db1fcb70914244a$var$HASH_RE, "%23").replace($8db1fcb70914244a$var$IM_RE, "%3F");
}
/**
* Encode characters that need to be encoded on the path section of the URL as a
* param. This function encodes everything {@link encodePath} does plus the
* slash (`/`) character. If `text` is `null` or `undefined`, returns an empty
* string instead.
*
* @param text - string to encode
* @returns encoded string
*/ function $8db1fcb70914244a$export$71cec2538cb2c617(text) {
    return $8db1fcb70914244a$export$2329c99376c9d0a4(text).replace($8db1fcb70914244a$var$SLASH_RE, "%2F");
}
function $8db1fcb70914244a$export$7f8ddf7c7c20b3cd(text) {
    if (text == null) return null;
    try {
        return decodeURIComponent("" + text);
    } catch (err) {}
    return "" + text;
}
//#endregion
//#region src/location.ts
const $8db1fcb70914244a$var$TRAILING_SLASH_RE = /\/$/;
const $8db1fcb70914244a$var$removeTrailingSlash = (path)=>path.replace($8db1fcb70914244a$var$TRAILING_SLASH_RE, "");
/**
* Transforms a URI into a normalized history location
*
* @param parseQuery
* @param location - URI to normalize
* @param currentLocation - current absolute location. Allows resolving relative
* paths. Must start with `/`. Defaults to `/`
* @returns a normalized history location
*/ function $8db1fcb70914244a$export$db202ddc8be9136(parseQuery$1, location, currentLocation = "/") {
    let path, query = {}, searchString = "", hash = "";
    const hashPos = location.indexOf("#");
    let searchPos = location.indexOf("?");
    searchPos = hashPos >= 0 && searchPos > hashPos ? -1 : searchPos;
    if (searchPos >= 0) {
        path = location.slice(0, searchPos);
        searchString = location.slice(searchPos, hashPos > 0 ? hashPos : location.length);
        query = parseQuery$1(searchString.slice(1));
    }
    if (hashPos >= 0) {
        path = path || location.slice(0, hashPos);
        hash = location.slice(hashPos, location.length);
    }
    path = $8db1fcb70914244a$export$df995fae86a55f06(path != null ? path : location, currentLocation);
    return {
        fullPath: path + searchString + hash,
        path: path,
        query: query,
        hash: $8db1fcb70914244a$export$7f8ddf7c7c20b3cd(hash)
    };
}
function $8db1fcb70914244a$export$a07804094c3ecf2d(stringifyQuery$1, path, query, hash = "") {
    const searchText = stringifyQuery$1(query);
    return path + (searchText && "?") + searchText + $8db1fcb70914244a$export$3a6d5c9ae78a2c08(hash);
}
/**
* Stringifies a URL object
*
* @param stringifyQuery
* @param location
*/ function $8db1fcb70914244a$export$ef35774e6d314e91(stringifyQuery$1, location) {
    const query = location.query ? stringifyQuery$1(location.query) : "";
    return location.path + (query && "?") + query + (location.hash || "");
}
/**
* Strips off the base from the beginning of a location.pathname in a non-case-sensitive way.
*
* @param pathname - location.pathname
* @param base - base to strip off
*/ function $8db1fcb70914244a$export$e7c866399fa523f5(pathname, base) {
    if (!base || !pathname.toLowerCase().startsWith(base.toLowerCase())) return pathname;
    return pathname.slice(base.length) || "/";
}
/**
* Checks if two RouteLocation are equal. This means that both locations are
* pointing towards the same {@link RouteRecord} and that all `params`, `query`
* parameters and `hash` are the same
*
* @param stringifyQuery - A function that takes a query object of type LocationQueryRaw and returns a string representation of it.
* @param a - first {@link RouteLocation}
* @param b - second {@link RouteLocation}
*/ function $8db1fcb70914244a$export$d66501df72047452(stringifyQuery$1, a, b) {
    const aLastIndex = a.matched.length - 1;
    const bLastIndex = b.matched.length - 1;
    return aLastIndex > -1 && aLastIndex === bLastIndex && $8db1fcb70914244a$export$61196ced6d74a310(a.matched[aLastIndex], b.matched[bLastIndex]) && $8db1fcb70914244a$export$9bb611d729802a56(a.params, b.params) && stringifyQuery$1(a.query) === stringifyQuery$1(b.query) && a.hash === b.hash;
}
/**
* Check if two `RouteRecords` are equal. Takes into account aliases: they are
* considered equal to the `RouteRecord` they are aliasing.
*
* @param a - first {@link RouteRecord}
* @param b - second {@link RouteRecord}
*/ function $8db1fcb70914244a$export$61196ced6d74a310(a, b) {
    return (a.aliasOf || a) === (b.aliasOf || b);
}
function $8db1fcb70914244a$export$9bb611d729802a56(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) return false;
    for(var key in a)if (!$8db1fcb70914244a$var$isSameRouteLocationParamsValue(a[key], b[key])) return false;
    return true;
}
function $8db1fcb70914244a$var$isSameRouteLocationParamsValue(a, b) {
    return $8db1fcb70914244a$export$78acf4525d8a74c4(a) ? $8db1fcb70914244a$var$isEquivalentArray(a, b) : $8db1fcb70914244a$export$78acf4525d8a74c4(b) ? $8db1fcb70914244a$var$isEquivalentArray(b, a) : a?.valueOf() === b?.valueOf();
}
/**
* Check if two arrays are the same or if an array with one single entry is the
* same as another primitive value. Used to check query and parameters
*
* @param a - array of values
* @param b - array of values or a single value
*/ function $8db1fcb70914244a$var$isEquivalentArray(a, b) {
    return $8db1fcb70914244a$export$78acf4525d8a74c4(b) ? a.length === b.length && a.every((value, i)=>value === b[i]) : a.length === 1 && a[0] === b;
}
/**
* Resolves a relative path that starts with `.`.
*
* @param to - path location we are resolving
* @param from - currentLocation.path, should start with `/`
*/ function $8db1fcb70914244a$export$df995fae86a55f06(to, from) {
    if (to.startsWith("/")) return to;
    if (!to) return from;
    const fromSegments = from.split("/");
    const toSegments = to.split("/");
    const lastToSegment = toSegments[toSegments.length - 1];
    if (lastToSegment === ".." || lastToSegment === ".") toSegments.push("");
    let position = fromSegments.length - 1;
    let toPosition;
    let segment;
    for(toPosition = 0; toPosition < toSegments.length; toPosition++){
        segment = toSegments[toPosition];
        if (segment === ".") continue;
        if (segment === "..") {
            if (position > 1) position--;
        } else break;
    }
    return fromSegments.slice(0, position).join("/") + "/" + toSegments.slice(toPosition).join("/");
}
/**
* Initial route location where the router is. Can be used in navigation guards
* to differentiate the initial navigation.
*
* @example
* ```js
* import { START_LOCATION } from 'vue-router'
*
* router.beforeEach((to, from) => {
*   if (from === START_LOCATION) {
*     // initial navigation
*   }
* })
* ```
*/ const $8db1fcb70914244a$export$56c0d5a1e737357d = {
    path: "/",
    name: void 0,
    params: {},
    query: {},
    hash: "",
    fullPath: "/",
    matched: [],
    meta: {},
    redirectedFrom: void 0
};
//#endregion
//#region src/history/common.ts
let $8db1fcb70914244a$export$342063e11d6c3cad = /* @__PURE__ */ function(NavigationType$1) {
    NavigationType$1["pop"] = "pop";
    NavigationType$1["push"] = "push";
    return NavigationType$1;
}({});
let $8db1fcb70914244a$export$c4ce752e73470fba = /* @__PURE__ */ function(NavigationDirection$1) {
    NavigationDirection$1["back"] = "back";
    NavigationDirection$1["forward"] = "forward";
    NavigationDirection$1["unknown"] = "";
    return NavigationDirection$1;
}({});
/**
* Starting location for Histories
*/ const $8db1fcb70914244a$export$ebd11618f299a286 = "";
/**
* Normalizes a base by removing any trailing slash and reading the base tag if
* present.
*
* @param base - base to normalize
*/ function $8db1fcb70914244a$export$3a1a48c8f6ef640e(base) {
    if (!base) {
        if ($8db1fcb70914244a$export$3d8c2f653ac9d0b9) {
            const baseEl = document.querySelector("base");
            base = baseEl && baseEl.getAttribute("href") || "/";
            base = base.replace(/^\w+:\/\/[^\/]+/, "");
        } else base = "/";
    }
    if (base[0] !== "/" && base[0] !== "#") base = "/" + base;
    return $8db1fcb70914244a$var$removeTrailingSlash(base);
}
const $8db1fcb70914244a$var$BEFORE_HASH_RE = /^[^#]+#/;
function $8db1fcb70914244a$export$35e795649ee09318(base, location) {
    return base.replace($8db1fcb70914244a$var$BEFORE_HASH_RE, "#") + location;
}
//#endregion
//#region src/scrollBehavior.ts
function $8db1fcb70914244a$var$getElementPosition(el, offset) {
    const docRect = document.documentElement.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    return {
        behavior: offset.behavior,
        left: elRect.left - docRect.left - (offset.left || 0),
        top: elRect.top - docRect.top - (offset.top || 0)
    };
}
const $8db1fcb70914244a$export$e7094788287c5e9b = ()=>({
        left: window.scrollX,
        top: window.scrollY
    });
function $8db1fcb70914244a$export$96f57966bedc81b4(position) {
    let scrollToOptions;
    if ("el" in position) {
        const positionEl = position.el;
        const isIdSelector = typeof positionEl === "string" && positionEl.startsWith("#");
        var err;
        const el = typeof positionEl === "string" ? isIdSelector ? document.getElementById(positionEl.slice(1)) : document.querySelector(positionEl) : positionEl;
        if (!el) return;
        scrollToOptions = $8db1fcb70914244a$var$getElementPosition(el, position);
    } else scrollToOptions = position;
    if ("scrollBehavior" in document.documentElement.style) window.scrollTo(scrollToOptions);
    else window.scrollTo(scrollToOptions.left != null ? scrollToOptions.left : window.scrollX, scrollToOptions.top != null ? scrollToOptions.top : window.scrollY);
}
function $8db1fcb70914244a$export$971d5caa766a69d7(path, delta) {
    return (history.state ? history.state.position - delta : -1) + path;
}
const $8db1fcb70914244a$var$scrollPositions = /* @__PURE__ */ new Map();
function $8db1fcb70914244a$export$a9c23c6ac3fc3eca(key, scrollPosition) {
    $8db1fcb70914244a$var$scrollPositions.set(key, scrollPosition);
}
function $8db1fcb70914244a$export$efccba1c4a2ef57b(key) {
    const scroll = $8db1fcb70914244a$var$scrollPositions.get(key);
    $8db1fcb70914244a$var$scrollPositions.delete(key);
    return scroll;
}
/**
* ScrollBehavior instance used by the router to compute and restore the scroll
* position when navigating.
*/ //#endregion
//#region src/types/typeGuards.ts
function $8db1fcb70914244a$export$d141bba7fdc215a3(route) {
    return typeof route === "string" || route && typeof route === "object";
}
function $8db1fcb70914244a$export$25ce5a424b770e84(name) {
    return typeof name === "string" || typeof name === "symbol";
}
//#endregion
//#region src/errors.ts
/**
* Flags so we can combine them when checking for multiple errors. This is the internal version of
* {@link NavigationFailureType}.
*
* @internal
*/ let $8db1fcb70914244a$export$71511d61b312f219 = /* @__PURE__ */ function(ErrorTypes$1) {
    ErrorTypes$1[ErrorTypes$1["MATCHER_NOT_FOUND"] = 1] = "MATCHER_NOT_FOUND";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_GUARD_REDIRECT"] = 2] = "NAVIGATION_GUARD_REDIRECT";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_ABORTED"] = 4] = "NAVIGATION_ABORTED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_CANCELLED"] = 8] = "NAVIGATION_CANCELLED";
    ErrorTypes$1[ErrorTypes$1["NAVIGATION_DUPLICATED"] = 16] = "NAVIGATION_DUPLICATED";
    return ErrorTypes$1;
}({});
const $8db1fcb70914244a$var$NavigationFailureSymbol = Symbol("");
/**
* Enumeration with all possible types for navigation failures. Can be passed to
* {@link isNavigationFailure} to check for specific failures.
*/ let $8db1fcb70914244a$export$90a7f3efeed30595 = /* @__PURE__ */ function(NavigationFailureType$1) {
    /**
	* An aborted navigation is a navigation that failed because a navigation
	* guard returned `false` or called `next(false)`
	*/ NavigationFailureType$1[NavigationFailureType$1["aborted"] = 4] = "aborted";
    /**
	* A cancelled navigation is a navigation that failed because a more recent
	* navigation finished started (not necessarily finished).
	*/ NavigationFailureType$1[NavigationFailureType$1["cancelled"] = 8] = "cancelled";
    /**
	* A duplicated navigation is a navigation that failed because it was
	* initiated while already being at the exact same location.
	*/ NavigationFailureType$1[NavigationFailureType$1["duplicated"] = 16] = "duplicated";
    return NavigationFailureType$1;
}({});
const $8db1fcb70914244a$var$ErrorTypeMessages = {
    [$8db1fcb70914244a$export$71511d61b312f219.MATCHER_NOT_FOUND] ({ location: location, currentLocation: currentLocation }) {
        return `No match for\n ${JSON.stringify(location)}${currentLocation ? "\nwhile being at\n" + JSON.stringify(currentLocation) : ""}`;
    },
    [$8db1fcb70914244a$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT] ({ from: from, to: to }) {
        return `Redirected from "${from.fullPath}" to "${$8db1fcb70914244a$var$stringifyRoute(to)}" via a navigation guard.`;
    },
    [$8db1fcb70914244a$export$71511d61b312f219.NAVIGATION_ABORTED] ({ from: from, to: to }) {
        return `Navigation aborted from "${from.fullPath}" to "${to.fullPath}" via a navigation guard.`;
    },
    [$8db1fcb70914244a$export$71511d61b312f219.NAVIGATION_CANCELLED] ({ from: from, to: to }) {
        return `Navigation cancelled from "${from.fullPath}" to "${to.fullPath}" with a new navigation.`;
    },
    [$8db1fcb70914244a$export$71511d61b312f219.NAVIGATION_DUPLICATED] ({ from: from, to: to }) {
        return `Avoided redundant navigation to current location: "${from.fullPath}".`;
    }
};
/**
* Creates a typed NavigationFailure object.
* @internal
* @param type - NavigationFailureType
* @param params - { from, to }
*/ function $8db1fcb70914244a$export$4a5767248b18ef41(type, params) {
    return $8db1fcb70914244a$export$b4171a6734a65d42(/* @__PURE__ */ new Error(), {
        type: type,
        [$8db1fcb70914244a$var$NavigationFailureSymbol]: true
    }, params);
}
function $8db1fcb70914244a$export$8b22cf2602fb60ce(error, type) {
    return error instanceof Error && $8db1fcb70914244a$var$NavigationFailureSymbol in error && (type == null || !!(error.type & type));
}
const $8db1fcb70914244a$var$propertiesToLog = [
    "params",
    "query",
    "hash"
];
function $8db1fcb70914244a$var$stringifyRoute(to) {
    if (typeof to === "string") return to;
    if (to.path != null) return to.path;
    const location = {};
    for (const key of $8db1fcb70914244a$var$propertiesToLog)if (key in to) location[key] = to[key];
    return JSON.stringify(location, null, 2);
}
//#endregion
//#region src/query.ts
/**
* Transforms a queryString into a {@link LocationQuery} object. Accept both, a
* version with the leading `?` and without Should work as URLSearchParams

* @internal
*
* @param search - search string to parse
* @returns a query object
*/ function $8db1fcb70914244a$export$dda1d9f60106f0e9(search) {
    const query = {};
    if (search === "" || search === "?") return query;
    const searchParams = (search[0] === "?" ? search.slice(1) : search).split("&");
    for(let i = 0; i < searchParams.length; ++i){
        const searchParam = searchParams[i].replace($8db1fcb70914244a$var$PLUS_RE, " ");
        const eqPos = searchParam.indexOf("=");
        const key = $8db1fcb70914244a$export$7f8ddf7c7c20b3cd(eqPos < 0 ? searchParam : searchParam.slice(0, eqPos));
        const value = eqPos < 0 ? null : $8db1fcb70914244a$export$7f8ddf7c7c20b3cd(searchParam.slice(eqPos + 1));
        if (key in query) {
            let currentValue = query[key];
            if (!$8db1fcb70914244a$export$78acf4525d8a74c4(currentValue)) currentValue = query[key] = [
                currentValue
            ];
            currentValue.push(value);
        } else query[key] = value;
    }
    return query;
}
/**
* Stringifies a {@link LocationQueryRaw} object. Like `URLSearchParams`, it
* doesn't prepend a `?`
*
* @internal
*
* @param query - query object to stringify
* @returns string version of the query without the leading `?`
*/ function $8db1fcb70914244a$export$39b482c5e57630a8(query) {
    let search = "";
    for(let key in query){
        const value = query[key];
        key = $8db1fcb70914244a$var$encodeQueryKey(key);
        if (value == null) {
            if (value !== void 0) search += (search.length ? "&" : "") + key;
            continue;
        }
        ($8db1fcb70914244a$export$78acf4525d8a74c4(value) ? value.map((v)=>v && $8db1fcb70914244a$var$encodeQueryValue(v)) : [
            value && $8db1fcb70914244a$var$encodeQueryValue(value)
        ]).forEach((value$1)=>{
            if (value$1 !== void 0) {
                search += (search.length ? "&" : "") + key;
                if (value$1 != null) search += "=" + value$1;
            }
        });
    }
    return search;
}
/**
* Transforms a {@link LocationQueryRaw} into a {@link LocationQuery} by casting
* numbers into strings, removing keys with an undefined value and replacing
* undefined with null in arrays
*
* @param query - query object to normalize
* @returns a normalized query object
*/ function $8db1fcb70914244a$export$953cecd6e717a553(query) {
    const normalizedQuery = {};
    for(const key in query){
        const value = query[key];
        if (value !== void 0) normalizedQuery[key] = $8db1fcb70914244a$export$78acf4525d8a74c4(value) ? value.map((v)=>v == null ? null : "" + v) : value == null ? value : "" + value;
    }
    return normalizedQuery;
}
//#endregion
//#region src/injectionSymbols.ts
/**
* RouteRecord being rendered by the closest ancestor Router View. Used for
* `onBeforeRouteUpdate` and `onBeforeRouteLeave`. rvlm stands for Router View
* Location Matched
*
* @internal
*/ const $8db1fcb70914244a$export$882b5998b3b9117c = Symbol("");
/**
* Allows overriding the router view depth to control which component in
* `matched` is rendered. rvd stands for Router View Depth
*
* @internal
*/ const $8db1fcb70914244a$export$ffb5f4729a158638 = Symbol("");
/**
* Allows overriding the router instance returned by `useRouter` in tests. r
* stands for router
*
* @internal
*/ const $8db1fcb70914244a$export$4368d992c4eafac0 = Symbol("");
/**
* Allows overriding the current route returned by `useRoute` in tests. rl
* stands for route location
*
* @internal
*/ const $8db1fcb70914244a$export$3b14a55fb2447963 = Symbol("");
/**
* Allows overriding the current route used by router-view. Internally this is
* used when the `route` prop is passed.
*
* @internal
*/ const $8db1fcb70914244a$export$2d1720544b23b823 = Symbol("");
//#endregion
//#region src/utils/callbacks.ts
/**
* Create a list of callbacks that can be reset. Used to create before and after navigation guards list
*/ function $8db1fcb70914244a$export$db3b6bfb95261072() {
    let handlers = [];
    function add(handler) {
        handlers.push(handler);
        return ()=>{
            const i = handlers.indexOf(handler);
            if (i > -1) handlers.splice(i, 1);
        };
    }
    function reset() {
        handlers = [];
    }
    return {
        add: add,
        list: ()=>handlers.slice(),
        reset: reset
    };
}
//#endregion
//#region src/navigationGuards.ts
function $8db1fcb70914244a$var$registerGuard(record, name, guard) {
    const removeFromList = ()=>{
        record[name].delete(guard);
    };
    (0, $xo6Zx.onUnmounted)(removeFromList);
    (0, $xo6Zx.onDeactivated)(removeFromList);
    (0, $xo6Zx.onActivated)(()=>{
        record[name].add(guard);
    });
    record[name].add(guard);
}
/**
* Add a navigation guard that triggers whenever the component for the current
* location is about to be left. Similar to {@link beforeRouteLeave} but can be
* used in any component. The guard is removed when the component is unmounted.
*
* @param leaveGuard - {@link NavigationGuard}
*/ function $8db1fcb70914244a$export$ae1af26003f05816(leaveGuard) {
    const activeRecord = (0, $xo6Zx.inject)($8db1fcb70914244a$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $8db1fcb70914244a$var$registerGuard(activeRecord, "leaveGuards", leaveGuard);
}
/**
* Add a navigation guard that triggers whenever the current location is about
* to be updated. Similar to {@link beforeRouteUpdate} but can be used in any
* component. The guard is removed when the component is unmounted.
*
* @param updateGuard - {@link NavigationGuard}
*/ function $8db1fcb70914244a$export$2408f22a0fab9ae5(updateGuard) {
    const activeRecord = (0, $xo6Zx.inject)($8db1fcb70914244a$export$882b5998b3b9117c, {}).value;
    if (!activeRecord) return;
    $8db1fcb70914244a$var$registerGuard(activeRecord, "updateGuards", updateGuard);
}
function $8db1fcb70914244a$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext = (fn)=>fn()) {
    const enterCallbackArray = record && (record.enterCallbacks[name] = record.enterCallbacks[name] || []);
    return ()=>new Promise((resolve, reject)=>{
            const next = (valid)=>{
                if (valid === false) reject($8db1fcb70914244a$export$4a5767248b18ef41($8db1fcb70914244a$export$71511d61b312f219.NAVIGATION_ABORTED, {
                    from: from,
                    to: to
                }));
                else if (valid instanceof Error) reject(valid);
                else if ($8db1fcb70914244a$export$d141bba7fdc215a3(valid)) reject($8db1fcb70914244a$export$4a5767248b18ef41($8db1fcb70914244a$export$71511d61b312f219.NAVIGATION_GUARD_REDIRECT, {
                    from: to,
                    to: valid
                }));
                else {
                    if (enterCallbackArray && record.enterCallbacks[name] === enterCallbackArray && typeof valid === "function") enterCallbackArray.push(valid);
                    resolve();
                }
            };
            const guardReturn = runWithContext(()=>guard.call(record && record.instances[name], to, from, next));
            let guardCall = Promise.resolve(guardReturn);
            if (guard.length < 3) guardCall = guardCall.then(next);
            var resolvedValue;
            guardCall.catch((err)=>reject(err));
        });
}
function $8db1fcb70914244a$var$canOnlyBeCalledOnce(next, to, from) {
    let called = 0;
    return function() {
        if (called++ === 1) $8db1fcb70914244a$export$3466f893ebf79586(`The "next" callback was called more than once in one navigation guard when going from "${from.fullPath}" to "${to.fullPath}". It should be called exactly one time in each navigation guard. This will fail in production.`);
        next._called = true;
        if (called === 1) next.apply(null, arguments);
    };
}
function $8db1fcb70914244a$export$43caf9889c228507(matched, guardType, to, from, runWithContext = (fn)=>fn()) {
    const guards = [];
    for (const record of matched)for(const name in record.components){
        let rawComponent = record.components[name];
        if (guardType !== "beforeRouteEnter" && !record.instances[name]) continue;
        if ($8db1fcb70914244a$var$isRouteComponent(rawComponent)) {
            const guard = (rawComponent.__vccOpts || rawComponent)[guardType];
            guard && guards.push($8db1fcb70914244a$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext));
        } else {
            let componentPromise = rawComponent();
            guards.push(()=>componentPromise.then((resolved)=>{
                    if (!resolved) throw new Error(`Couldn't resolve component "${name}" at "${record.path}"`);
                    const resolvedComponent = $8db1fcb70914244a$var$isESModule(resolved) ? resolved.default : resolved;
                    record.mods[name] = resolved;
                    record.components[name] = resolvedComponent;
                    const guard = (resolvedComponent.__vccOpts || resolvedComponent)[guardType];
                    return guard && $8db1fcb70914244a$export$23f2a1d2818174ef(guard, to, from, record, name, runWithContext)();
                }));
        }
    }
    return guards;
}
/**
* Ensures a route is loaded, so it can be passed as o prop to `<RouterView>`.
*
* @param route - resolved route to load
*/ function $8db1fcb70914244a$export$407448d2b89b1813(route) {
    return route.matched.every((record)=>record.redirect) ? Promise.reject(/* @__PURE__ */ new Error("Cannot load a route that redirects.")) : Promise.all(route.matched.map((record)=>record.components && Promise.all(Object.keys(record.components).reduce((promises, name)=>{
            const rawComponent = record.components[name];
            if (typeof rawComponent === "function" && !("displayName" in rawComponent)) promises.push(rawComponent().then((resolved)=>{
                if (!resolved) return Promise.reject(/* @__PURE__ */ new Error(`Couldn't resolve component "${name}" at "${record.path}". Ensure you passed a function that returns a promise.`));
                const resolvedComponent = $8db1fcb70914244a$var$isESModule(resolved) ? resolved.default : resolved;
                record.mods[name] = resolved;
                record.components[name] = resolvedComponent;
            }));
            return promises;
        }, [])))).then(()=>route);
}
/**
* Split the leaving, updating, and entering records.
* @internal
*
* @param  to - Location we are navigating to
* @param from - Location we are navigating from
*/ function $8db1fcb70914244a$export$7ccc53e8f1e7dfc5(to, from) {
    const leavingRecords = [];
    const updatingRecords = [];
    const enteringRecords = [];
    const len = Math.max(from.matched.length, to.matched.length);
    for(let i = 0; i < len; i++){
        const recordFrom = from.matched[i];
        if (recordFrom) {
            if (to.matched.find((record)=>$8db1fcb70914244a$export$61196ced6d74a310(record, recordFrom))) updatingRecords.push(recordFrom);
            else leavingRecords.push(recordFrom);
        }
        const recordTo = to.matched[i];
        if (recordTo) {
            if (!from.matched.find((record)=>$8db1fcb70914244a$export$61196ced6d74a310(record, recordTo))) enteringRecords.push(recordTo);
        }
    }
    return [
        leavingRecords,
        updatingRecords,
        enteringRecords
    ];
}
//#endregion
//#region src/devtools.ts
/**
* Copies a route location and removes any problematic properties that cannot be shown in devtools (e.g. Vue instances).
*
* @param routeLocation - routeLocation to format
* @param tooltip - optional tooltip
* @returns a copy of the routeLocation
*/ function $8db1fcb70914244a$var$formatRouteLocation(routeLocation, tooltip) {
    const copy = $8db1fcb70914244a$export$b4171a6734a65d42({}, routeLocation, {
        matched: routeLocation.matched.map((matched)=>$8db1fcb70914244a$var$omit(matched, [
                "instances",
                "children",
                "aliasOf"
            ]))
    });
    return {
        _custom: {
            type: null,
            readOnly: true,
            display: routeLocation.fullPath,
            tooltip: tooltip,
            value: copy
        }
    };
}
function $8db1fcb70914244a$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
let $8db1fcb70914244a$var$routerId = 0;
function $8db1fcb70914244a$export$625550452a3fa3ec(app, router, matcher) {
    if (router.__hasDevtools) return;
    router.__hasDevtools = true;
    const id = $8db1fcb70914244a$var$routerId++;
    (0, $7RVFN.setupDevtoolsPlugin)({
        id: "org.vuejs.router" + (id ? "." + id : ""),
        label: "Vue Router",
        packageName: "vue-router",
        homepage: "https://router.vuejs.org",
        logo: "https://router.vuejs.org/logo.png",
        componentStateTypes: [
            "Routing"
        ],
        app: app
    }, (api)=>{
        if (typeof api.now !== "function") $8db1fcb70914244a$export$3466f893ebf79586("[Vue Router]: You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.");
        api.on.inspectComponent((payload, ctx)=>{
            if (payload.instanceData) payload.instanceData.state.push({
                type: "Routing",
                key: "$route",
                editable: false,
                value: $8db1fcb70914244a$var$formatRouteLocation(router.currentRoute.value, "Current Route")
            });
        });
        api.on.visitComponentTree(({ treeNode: node, componentInstance: componentInstance })=>{
            if (componentInstance.__vrv_devtools) {
                const info = componentInstance.__vrv_devtools;
                node.tags.push({
                    label: (info.name ? `${info.name.toString()}: ` : "") + info.path,
                    textColor: 0,
                    tooltip: "This component is rendered by &lt;router-view&gt;",
                    backgroundColor: $8db1fcb70914244a$var$PINK_500
                });
            }
            if ($8db1fcb70914244a$export$78acf4525d8a74c4(componentInstance.__vrl_devtools)) {
                componentInstance.__devtoolsApi = api;
                componentInstance.__vrl_devtools.forEach((devtoolsData)=>{
                    let label = devtoolsData.route.path;
                    let backgroundColor = $8db1fcb70914244a$var$ORANGE_400;
                    let tooltip = "";
                    let textColor = 0;
                    if (devtoolsData.error) {
                        label = devtoolsData.error;
                        backgroundColor = $8db1fcb70914244a$var$RED_100;
                        textColor = $8db1fcb70914244a$var$RED_700;
                    } else if (devtoolsData.isExactActive) {
                        backgroundColor = $8db1fcb70914244a$var$LIME_500;
                        tooltip = "This is exactly active";
                    } else if (devtoolsData.isActive) {
                        backgroundColor = $8db1fcb70914244a$var$BLUE_600;
                        tooltip = "This link is active";
                    }
                    node.tags.push({
                        label: label,
                        textColor: textColor,
                        tooltip: tooltip,
                        backgroundColor: backgroundColor
                    });
                });
            }
        });
        (0, $xo6Zx.watch)(router.currentRoute, ()=>{
            refreshRoutesView();
            api.notifyComponentUpdate();
            api.sendInspectorTree(routerInspectorId);
            api.sendInspectorState(routerInspectorId);
        });
        const navigationsLayerId = "router:navigations:" + id;
        api.addTimelineLayer({
            id: navigationsLayerId,
            label: `Router${id ? " " + id : ""} Navigations`,
            color: 4237508
        });
        router.onError((error, to)=>{
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "Error during Navigation",
                    subtitle: to.fullPath,
                    logType: "error",
                    time: api.now(),
                    data: {
                        error: error
                    },
                    groupId: to.meta.__navigationId
                }
            });
        });
        let navigationId = 0;
        router.beforeEach((to, from)=>{
            const data = {
                guard: $8db1fcb70914244a$var$formatDisplay("beforeEach"),
                from: $8db1fcb70914244a$var$formatRouteLocation(from, "Current Location during this navigation"),
                to: $8db1fcb70914244a$var$formatRouteLocation(to, "Target location")
            };
            Object.defineProperty(to.meta, "__navigationId", {
                value: navigationId++
            });
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    time: api.now(),
                    title: "Start of navigation",
                    subtitle: to.fullPath,
                    data: data,
                    groupId: to.meta.__navigationId
                }
            });
        });
        router.afterEach((to, from, failure)=>{
            const data = {
                guard: $8db1fcb70914244a$var$formatDisplay("afterEach")
            };
            if (failure) {
                data.failure = {
                    _custom: {
                        type: Error,
                        readOnly: true,
                        display: failure ? failure.message : "",
                        tooltip: "Navigation Failure",
                        value: failure
                    }
                };
                data.status = $8db1fcb70914244a$var$formatDisplay("\u274C");
            } else data.status = $8db1fcb70914244a$var$formatDisplay("\u2705");
            data.from = $8db1fcb70914244a$var$formatRouteLocation(from, "Current Location during this navigation");
            data.to = $8db1fcb70914244a$var$formatRouteLocation(to, "Target location");
            api.addTimelineEvent({
                layerId: navigationsLayerId,
                event: {
                    title: "End of navigation",
                    subtitle: to.fullPath,
                    time: api.now(),
                    data: data,
                    logType: failure ? "warning" : "default",
                    groupId: to.meta.__navigationId
                }
            });
        });
        /**
		* Inspector of Existing routes
		*/ const routerInspectorId = "router-inspector:" + id;
        api.addInspector({
            id: routerInspectorId,
            label: "Routes" + (id ? " " + id : ""),
            icon: "book",
            treeFilterPlaceholder: "Search routes"
        });
        function refreshRoutesView() {
            if (!activeRoutesPayload) return;
            const payload = activeRoutesPayload;
            let routes = matcher.getRoutes().filter((route)=>!route.parent || !route.parent.record.components);
            routes.forEach($8db1fcb70914244a$var$resetMatchStateOnRouteRecord);
            if (payload.filter) routes = routes.filter((route)=>$8db1fcb70914244a$var$isRouteMatching(route, payload.filter.toLowerCase()));
            routes.forEach((route)=>$8db1fcb70914244a$var$markRouteRecordActive(route, router.currentRoute.value));
            payload.rootNodes = routes.map($8db1fcb70914244a$var$formatRouteRecordForInspector);
        }
        let activeRoutesPayload;
        api.on.getInspectorTree((payload)=>{
            activeRoutesPayload = payload;
            if (payload.app === app && payload.inspectorId === routerInspectorId) refreshRoutesView();
        });
        /**
		* Display information about the currently selected route record
		*/ api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === routerInspectorId) {
                const route = matcher.getRoutes().find((route$1)=>route$1.record.__vd_id === payload.nodeId);
                if (route) payload.state = {
                    options: $8db1fcb70914244a$var$formatRouteRecordMatcherForStateInspector(route)
                };
            }
        });
        api.sendInspectorTree(routerInspectorId);
        api.sendInspectorState(routerInspectorId);
    });
}
function $8db1fcb70914244a$var$modifierForKey(key) {
    if (key.optional) return key.repeatable ? "*" : "?";
    else return key.repeatable ? "+" : "";
}
function $8db1fcb70914244a$var$formatRouteRecordMatcherForStateInspector(route) {
    const { record: record } = route;
    const fields = [
        {
            editable: false,
            key: "path",
            value: record.path
        }
    ];
    if (record.name != null) fields.push({
        editable: false,
        key: "name",
        value: record.name
    });
    fields.push({
        editable: false,
        key: "regexp",
        value: route.re
    });
    if (route.keys.length) fields.push({
        editable: false,
        key: "keys",
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.keys.map((key)=>`${key.name}${$8db1fcb70914244a$var$modifierForKey(key)}`).join(" "),
                tooltip: "Param keys",
                value: route.keys
            }
        }
    });
    if (record.redirect != null) fields.push({
        editable: false,
        key: "redirect",
        value: record.redirect
    });
    if (route.alias.length) fields.push({
        editable: false,
        key: "aliases",
        value: route.alias.map((alias)=>alias.record.path)
    });
    if (Object.keys(route.record.meta).length) fields.push({
        editable: false,
        key: "meta",
        value: route.record.meta
    });
    fields.push({
        key: "score",
        editable: false,
        value: {
            _custom: {
                type: null,
                readOnly: true,
                display: route.score.map((score)=>score.join(", ")).join(" | "),
                tooltip: "Score used to sort routes",
                value: route.score
            }
        }
    });
    return fields;
}
/**
* Extracted from tailwind palette
*/ const $8db1fcb70914244a$var$PINK_500 = 15485081;
const $8db1fcb70914244a$var$BLUE_600 = 2450411;
const $8db1fcb70914244a$var$LIME_500 = 8702998;
const $8db1fcb70914244a$var$CYAN_400 = 2282478;
const $8db1fcb70914244a$var$ORANGE_400 = 16486972;
const $8db1fcb70914244a$var$DARK = 6710886;
const $8db1fcb70914244a$var$RED_100 = 16704226;
const $8db1fcb70914244a$var$RED_700 = 12131356;
function $8db1fcb70914244a$var$formatRouteRecordForInspector(route) {
    const tags = [];
    const { record: record } = route;
    if (record.name != null) tags.push({
        label: String(record.name),
        textColor: 0,
        backgroundColor: $8db1fcb70914244a$var$CYAN_400
    });
    if (record.aliasOf) tags.push({
        label: "alias",
        textColor: 0,
        backgroundColor: $8db1fcb70914244a$var$ORANGE_400
    });
    if (route.__vd_match) tags.push({
        label: "matches",
        textColor: 0,
        backgroundColor: $8db1fcb70914244a$var$PINK_500
    });
    if (route.__vd_exactActive) tags.push({
        label: "exact",
        textColor: 0,
        backgroundColor: $8db1fcb70914244a$var$LIME_500
    });
    if (route.__vd_active) tags.push({
        label: "active",
        textColor: 0,
        backgroundColor: $8db1fcb70914244a$var$BLUE_600
    });
    if (record.redirect) tags.push({
        label: typeof record.redirect === "string" ? `redirect: ${record.redirect}` : "redirects",
        textColor: 16777215,
        backgroundColor: $8db1fcb70914244a$var$DARK
    });
    let id = record.__vd_id;
    if (id == null) {
        id = String($8db1fcb70914244a$var$routeRecordId++);
        record.__vd_id = id;
    }
    return {
        id: id,
        label: record.path,
        tags: tags,
        children: route.children.map($8db1fcb70914244a$var$formatRouteRecordForInspector)
    };
}
let $8db1fcb70914244a$var$routeRecordId = 0;
const $8db1fcb70914244a$var$EXTRACT_REGEXP_RE = /^\/(.*)\/([a-z]*)$/;
function $8db1fcb70914244a$var$markRouteRecordActive(route, currentRoute) {
    const isExactActive = currentRoute.matched.length && $8db1fcb70914244a$export$61196ced6d74a310(currentRoute.matched[currentRoute.matched.length - 1], route.record);
    route.__vd_exactActive = route.__vd_active = isExactActive;
    if (!isExactActive) route.__vd_active = currentRoute.matched.some((match)=>$8db1fcb70914244a$export$61196ced6d74a310(match, route.record));
    route.children.forEach((childRoute)=>$8db1fcb70914244a$var$markRouteRecordActive(childRoute, currentRoute));
}
function $8db1fcb70914244a$var$resetMatchStateOnRouteRecord(route) {
    route.__vd_match = false;
    route.children.forEach($8db1fcb70914244a$var$resetMatchStateOnRouteRecord);
}
function $8db1fcb70914244a$var$isRouteMatching(route, filter) {
    const found = String(route.re).match($8db1fcb70914244a$var$EXTRACT_REGEXP_RE);
    route.__vd_match = false;
    if (!found || found.length < 3) return false;
    if (new RegExp(found[1].replace(/\$$/, ""), found[2]).test(filter)) {
        route.children.forEach((child)=>$8db1fcb70914244a$var$isRouteMatching(child, filter));
        if (route.record.path !== "/" || filter === "/") {
            route.__vd_match = route.re.test(filter);
            return true;
        }
        return false;
    }
    const path = route.record.path.toLowerCase();
    const decodedPath = $8db1fcb70914244a$export$7f8ddf7c7c20b3cd(path);
    if (!filter.startsWith("/") && (decodedPath.includes(filter) || path.includes(filter))) return true;
    if (decodedPath.startsWith(filter) || path.startsWith(filter)) return true;
    if (route.record.name && String(route.record.name).includes(filter)) return true;
    return route.children.some((child)=>$8db1fcb70914244a$var$isRouteMatching(child, filter));
}
function $8db1fcb70914244a$var$omit(obj, keys) {
    const ret = {};
    for(const key in obj)if (!keys.includes(key)) ret[key] = obj[key];
    return ret;
}

});


parcelRegister("9SOcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $732018e0d592ebb8$export$2e2bcd8739ae039);

var $fGXCZ = parcelRequire("fGXCZ");

var $jwT2o = parcelRequire("jwT2o");

var $9sg9Z = parcelRequire("9sg9Z");
const $732018e0d592ebb8$var$routes = [
    ...(0, $jwT2o.default),
    ...(0, $9sg9Z.default)
];
const $732018e0d592ebb8$var$router = (0, $fGXCZ.createRouter)({
    history: (0, $fGXCZ.createWebHashHistory)(),
    routes: $732018e0d592ebb8$var$routes
});
var $732018e0d592ebb8$export$2e2bcd8739ae039 = $732018e0d592ebb8$var$router;

});
parcelRegister("jwT2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $03ab4913d04319eb$export$2e2bcd8739ae039);

var $hp6pw = parcelRequire("hp6pw");

var $92F19 = parcelRequire("92F19");

var $krD13 = parcelRequire("krD13");
var $03ab4913d04319eb$export$2e2bcd8739ae039 = [
    {
        path: "/",
        name: "Hub",
        components: {
            sectionNavigation: (0, $92F19.default),
            header: (0, $krD13.default),
            content: (0, $hp6pw.default)
        }
    },
    {
        path: "/:volumeSlug/",
        name: "HubWithVolume",
        components: {
            sectionNavigation: (0, $92F19.default),
            header: (0, $krD13.default),
            content: (0, $hp6pw.default)
        }
    }
];

});
parcelRegister("hp6pw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cab9be80d5804422$export$2e2bcd8739ae039);
let $cab9be80d5804422$var$script;



let $cab9be80d5804422$var$initialize = ()=>{
    $cab9be80d5804422$var$script = (parcelRequire("bJztt"));
    if ($cab9be80d5804422$var$script.__esModule) $cab9be80d5804422$var$script = $cab9be80d5804422$var$script.default;
    $cab9be80d5804422$var$script.render = (parcelRequire("kDLM7")).render;
    (parcelRequire("bfjCv")).default($cab9be80d5804422$var$script);
    $cab9be80d5804422$var$script.__scopeId = 'data-v-83e40a';
    $cab9be80d5804422$var$script.__file = "HubCtas.vue";
};
$cab9be80d5804422$var$initialize();
var $cab9be80d5804422$export$2e2bcd8739ae039 = $cab9be80d5804422$var$script;

});
parcelRegister("bJztt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $88af6a293c19082b$export$2e2bcd8739ae039);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");

var $aofyc = parcelRequire("aofyc");

var $kLbI9 = parcelRequire("kLbI9");

var $QlUa3 = parcelRequire("QlUa3");
var $88af6a293c19082b$export$2e2bcd8739ae039 = {
    name: "HubCtas",
    components: {
        BoxGeneric: $kLbI9.default,
        TransitionFade: $QlUa3.default
    },
    setup () {
        const store = (0, $aofyc.useStore)();
        const hubCtas = (0, $xo6Zx.computed)(()=>store.state.container?.hubCtas.slice(0, 3)); // show max 3 items
        return {
            hubCtas: hubCtas
        };
    }
};

});
parcelRegister("kLbI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1d14806c296c429$export$2e2bcd8739ae039);
let $f1d14806c296c429$var$script;




let $f1d14806c296c429$var$initialize = ()=>{
    $f1d14806c296c429$var$script = (parcelRequire("9imIk"));
    if ($f1d14806c296c429$var$script.__esModule) $f1d14806c296c429$var$script = $f1d14806c296c429$var$script.default;
    $f1d14806c296c429$var$script.render = (parcelRequire("ZNnls")).render;
    $f1d14806c296c429$var$script.__cssModules = {};
    (parcelRequire("3dpcx")).default($f1d14806c296c429$var$script);
    $f1d14806c296c429$var$script.__scopeId = 'data-v-1b8807';
    $f1d14806c296c429$var$script.__file = "BoxGeneric.vue";
};
$f1d14806c296c429$var$initialize();
var $f1d14806c296c429$export$2e2bcd8739ae039 = $f1d14806c296c429$var$script;

});
parcelRegister("9imIk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6c4769fee25e0490$export$2e2bcd8739ae039);
var $6c4769fee25e0490$export$2e2bcd8739ae039 = {
    name: "BoxGeneric",
    props: {
        header: {
            type: String,
            default: ""
        },
        hStretch: {
            type: Boolean,
            default: false
        },
        wStretch: {
            type: Boolean,
            default: false
        },
        headerClass: {
            type: String,
            default: "title-block"
        }
    }
};

});

parcelRegister("ZNnls", function(module, exports) {

$parcel$export(module.exports, "render", () => $0b9bff929b4bf13e$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $0b9bff929b4bf13e$var$_hoisted_1 = {
    class: "box--generic grid grid-cols-1 grid-rows-box-generic items-start"
};
function $0b9bff929b4bf13e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $0b9bff929b4bf13e$var$_hoisted_1, [
        (0, $xo6Zx.createElementVNode)("h2", {
            class: (0, $d8ZDz.normalizeClass)($props.headerClass)
        }, [
            (0, $xo6Zx.renderSlot)(_ctx.$slots, "header", {}, ()=>[
                    (0, $xo6Zx.createTextVNode)((0, $d8ZDz.toDisplayString)($props.header), 1)
                ])
        ], 2),
        (0, $xo6Zx.createElementVNode)("section", {
            class: (0, $d8ZDz.normalizeClass)([
                {
                    'h-stretch': $props.hStretch,
                    'w-stretch': $props.wStretch
                },
                "supports-bg-filter:bg-saturate-blur"
            ])
        }, [
            (0, $xo6Zx.renderSlot)(_ctx.$slots, "default")
        ], 2)
    ]);
}

});

parcelRegister("3dpcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $25762272c22c7a6e$export$2e2bcd8739ae039);
let $25762272c22c7a6e$var$NOOP = ()=>{};
var $25762272c22c7a6e$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("QlUa3", function(module, exports) {

$parcel$export(module.exports, "default", () => $09d5d948f7d0e06a$export$2e2bcd8739ae039);
let $09d5d948f7d0e06a$var$script;




let $09d5d948f7d0e06a$var$initialize = ()=>{
    $09d5d948f7d0e06a$var$script = (parcelRequire("8zXUZ"));
    if ($09d5d948f7d0e06a$var$script.__esModule) $09d5d948f7d0e06a$var$script = $09d5d948f7d0e06a$var$script.default;
    $09d5d948f7d0e06a$var$script.render = (parcelRequire("2NjK3")).render;
    $09d5d948f7d0e06a$var$script.__cssModules = {};
    (parcelRequire("6nJXE")).default($09d5d948f7d0e06a$var$script);
    $09d5d948f7d0e06a$var$script.__scopeId = 'data-v-708239';
    $09d5d948f7d0e06a$var$script.__file = "TransitionFade.vue";
};
$09d5d948f7d0e06a$var$initialize();
var $09d5d948f7d0e06a$export$2e2bcd8739ae039 = $09d5d948f7d0e06a$var$script;

});
parcelRegister("8zXUZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $63f012240177a391$export$2e2bcd8739ae039);
var $63f012240177a391$export$2e2bcd8739ae039 = {
    name: "TransitionFade",
    props: {
        mode: {
            type: String,
            default: "out-in"
        },
        duration: {
            type: Number,
            default: 200,
            validator: (duration)=>[
                    200,
                    300,
                    500
                ].includes(duration)
        },
        expand: {
            type: Boolean,
            default: false
        },
        appear: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        // https://markus.oberlehner.net/blog/transition-to-height-auto-with-vue/
        enter (element) {
            if (!this.expand) return;
            const { width: width } = getComputedStyle(element);
            element.style.width = width;
            element.style.position = "absolute";
            element.style.visibility = "hidden";
            element.style.height = "auto";
            const { height: height } = getComputedStyle(element);
            element.style.width = null;
            element.style.position = null;
            element.style.visibility = null;
            element.style.height = 0;
            // Force repaint to make sure the
            // animation is triggered correctly.
            getComputedStyle(element).height;
            // Trigger the animation.
            // We use `requestAnimationFrame` because we need
            // to make sure the browser has finished
            // painting after setting the `height`
            // to `0` in the line above.
            requestAnimationFrame(()=>{
                element.style.height = height;
            });
        },
        afterEnter (element) {
            if (!this.expand) return;
            element.style.height = "auto";
        },
        leave (element) {
            if (!this.expand) return;
            const { height: height } = getComputedStyle(element);
            element.style.height = height;
            // Force repaint to make sure the
            // animation is triggered correctly.
            getComputedStyle(element).height;
            requestAnimationFrame(()=>{
                element.style.height = 0;
            });
        }
    }
};

});

parcelRegister("2NjK3", function(module, exports) {

$parcel$export(module.exports, "render", () => $208f78aabc0b52ac$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $jH5uA = parcelRequire("jH5uA");
function $208f78aabc0b52ac$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)((0, $jH5uA.Transition), (0, $xo6Zx.mergeProps)({
        name: `fade-${$props.duration}`,
        mode: $props.mode,
        appear: $props.appear
    }, _ctx.$attrs, {
        class: [
            {
                'fade-expand': $props.expand
            }
        ],
        onEnter: $options.enter,
        onAfterEnter: $options.afterEnter,
        onLeave: $options.leave
    }), {
        default: (0, $xo6Zx.withCtx)(()=>[
                (0, $xo6Zx.renderSlot)(_ctx.$slots, "default")
            ]),
        _: 3
    }, 16, [
        "name",
        "mode",
        "appear",
        "class",
        "onEnter",
        "onAfterEnter",
        "onLeave"
    ]);
}

});

parcelRegister("6nJXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a588af8c12a2612$export$2e2bcd8739ae039);
let $4a588af8c12a2612$var$NOOP = ()=>{};
var $4a588af8c12a2612$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("kDLM7", function(module, exports) {

$parcel$export(module.exports, "render", () => $f06c825535a48029$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
const $f06c825535a48029$var$_hoisted_1 = {
    id: "content",
    class: "flex flex-col justify-end items-start mb-8"
};
const $f06c825535a48029$var$_hoisted_2 = {
    class: "grid grid-cols-1 auto-rows-fr gap-6"
};
const $f06c825535a48029$var$_hoisted_3 = [
    "innerHTML"
];
function $f06c825535a48029$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_transition_fade, {
        duration: 500,
        appear: ""
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                (0, $xo6Zx.createElementVNode)("main", $f06c825535a48029$var$_hoisted_1, [
                    $setup.hubCtas?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_box_generic, {
                        key: 0,
                        header: "UITGELICHT",
                        "header-class": "title-block",
                        class: "ml-8 max-h-full"
                    }, {
                        default: (0, $xo6Zx.withCtx)(()=>[
                                (0, $xo6Zx.createElementVNode)("section", $f06c825535a48029$var$_hoisted_2, [
                                    ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)($setup.hubCtas, (cta, index)=>{
                                        return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), {
                                            key: index
                                        }, [
                                            cta._rendered ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", {
                                                key: index,
                                                class: "contents",
                                                innerHTML: cta._rendered
                                            }, null, 8, $f06c825535a48029$var$_hoisted_3)) : (0, $xo6Zx.createCommentVNode)("", true)
                                        ], 64);
                                    }), 128))
                                ])
                            ]),
                        _: 1
                    })) : (0, $xo6Zx.createCommentVNode)("", true)
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("bfjCv", function(module, exports) {

$parcel$export(module.exports, "default", () => $83005091f06bfaf8$export$2e2bcd8739ae039);
let $83005091f06bfaf8$var$NOOP = ()=>{};
var $83005091f06bfaf8$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("92F19", function(module, exports) {

$parcel$export(module.exports, "default", () => $69541e2e77f5dd1a$export$2e2bcd8739ae039);
let $69541e2e77f5dd1a$var$script;



let $69541e2e77f5dd1a$var$initialize = ()=>{
    $69541e2e77f5dd1a$var$script = (parcelRequire("9CiwY"));
    if ($69541e2e77f5dd1a$var$script.__esModule) $69541e2e77f5dd1a$var$script = $69541e2e77f5dd1a$var$script.default;
    $69541e2e77f5dd1a$var$script.render = (parcelRequire("3tyXh")).render;
    (parcelRequire("17qDw")).default($69541e2e77f5dd1a$var$script);
    $69541e2e77f5dd1a$var$script.__scopeId = 'data-v-7be56b';
    $69541e2e77f5dd1a$var$script.__file = "HubMenu.vue";
};
$69541e2e77f5dd1a$var$initialize();
var $69541e2e77f5dd1a$export$2e2bcd8739ae039 = $69541e2e77f5dd1a$var$script;

});
parcelRegister("9CiwY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $70060986d0297289$export$2e2bcd8739ae039);
var $70060986d0297289$export$2e2bcd8739ae039 = {
    name: "HubMenu",
    setup () {
        return {
            menu: document.getElementById("hubMenu").innerHTML
        };
    }
};

});

parcelRegister("3tyXh", function(module, exports) {

$parcel$export(module.exports, "render", () => $287f31e598168f36$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
const $287f31e598168f36$var$_hoisted_1 = [
    "innerHTML"
];
function $287f31e598168f36$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("ul", {
        class: "flex items-start",
        innerHTML: $setup.menu
    }, null, 8, $287f31e598168f36$var$_hoisted_1);
}

});

parcelRegister("17qDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d0b1b5b1bab0c23$export$2e2bcd8739ae039);
let $0d0b1b5b1bab0c23$var$NOOP = ()=>{};
var $0d0b1b5b1bab0c23$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("krD13", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee2498017ae85452$export$2e2bcd8739ae039);
let $ee2498017ae85452$var$script;



let $ee2498017ae85452$var$initialize = ()=>{
    $ee2498017ae85452$var$script = (parcelRequire("fEbwA"));
    if ($ee2498017ae85452$var$script.__esModule) $ee2498017ae85452$var$script = $ee2498017ae85452$var$script.default;
    $ee2498017ae85452$var$script.render = (parcelRequire("65s2p")).render;
    (parcelRequire("gMV21")).default($ee2498017ae85452$var$script);
    $ee2498017ae85452$var$script.__scopeId = 'data-v-5d442f';
    $ee2498017ae85452$var$script.__file = "HubHeader.vue";
};
$ee2498017ae85452$var$initialize();
var $ee2498017ae85452$export$2e2bcd8739ae039 = $ee2498017ae85452$var$script;

});
parcelRegister("fEbwA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b64387f8bd678a61$export$2e2bcd8739ae039);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");

var $aofyc = parcelRequire("aofyc");

var $cnKXL = parcelRequire("cnKXL");

var $kLbI9 = parcelRequire("kLbI9");

var $gt6pA = parcelRequire("gt6pA");

var $QlUa3 = parcelRequire("QlUa3");

var $bH87A = parcelRequire("bH87A");
var $b64387f8bd678a61$export$2e2bcd8739ae039 = {
    name: "HubHeader",
    components: {
        BoxGeneric: $kLbI9.default,
        RouterLinkButton: $gt6pA.default,
        TransitionFade: $QlUa3.default
    },
    async beforeRouteEnter (to, from, next) {
        return /* (await) */ (0, $bH87A.default)(to, next);
    },
    setup () {
        const store = (0, $aofyc.useStore)();
        const activeVolume = (0, $xo6Zx.computed)(()=>store.getters.activeVolume);
        const autoSeason = (0, $xo6Zx.computed)(()=>store.getters.autoSeason);
        const schoolLevels = (0, $xo6Zx.computed)(()=>store.state.container?.schoolLevels);
        (0, $cnKXL.s)(async (to, from, next)=>/* (await) */ (0, $bH87A.default)(to, next));
        return {
            activeVolume: activeVolume,
            autoSeason: autoSeason,
            schoolLevels: schoolLevels
        };
    }
};

});
parcelRegister("gt6pA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfd453fe6126646e$export$2e2bcd8739ae039);
let $bfd453fe6126646e$var$script;



let $bfd453fe6126646e$var$initialize = ()=>{
    $bfd453fe6126646e$var$script = (parcelRequire("c7Ftd"));
    if ($bfd453fe6126646e$var$script.__esModule) $bfd453fe6126646e$var$script = $bfd453fe6126646e$var$script.default;
    $bfd453fe6126646e$var$script.render = (parcelRequire("eCihu")).render;
    (parcelRequire("6uqAq")).default($bfd453fe6126646e$var$script);
    $bfd453fe6126646e$var$script.__scopeId = 'data-v-616351';
    $bfd453fe6126646e$var$script.__file = "RouterLinkButton.vue";
};
$bfd453fe6126646e$var$initialize();
var $bfd453fe6126646e$export$2e2bcd8739ae039 = $bfd453fe6126646e$var$script;

});
parcelRegister("c7Ftd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8d364e9e026d870e$export$2e2bcd8739ae039);
var $8d364e9e026d870e$export$2e2bcd8739ae039 = {
    name: "RouterLinkButton",
    inheritAttrs: false,
    props: {
        to: {
            type: [
                String,
                Object
            ],
            required: true
        },
        variant: {
            type: String,
            default: "default"
        }
    },
    computed: {
        variantClass () {
            const variants = {
                default: "inline-block py-[8px] px-[15px] text-white rounded-md shadow-sm hover:bg-orange-600 hover:shadow scale-100 hover:scale-105 transition duration-300",
                removeAll: "inline-block py-[8px] px-[15px] bg-orange-500 rounded-full rounded-bl-none text-white shadow-none mt-[1vh] before:content-['\xd7_'] before:font-black hover:bg-orange-600",
                onderbouw: "inline-block py-[8px] px-[15px] bg-green rounded-full text-white shadow-none hover:bg-green-500",
                "midden-bovenbouw": "inline-block py-[8px] px-[15px] bg-purple rounded-full text-white shadow-none hover:bg-purple-500"
            };
            return variants[this.variant] || variants.default;
        }
    }
};

});

parcelRegister("eCihu", function(module, exports) {

$parcel$export(module.exports, "render", () => $aa42cb8c8f6132de$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
function $aa42cb8c8f6132de$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $xo6Zx.resolveComponent)("router-link");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_router_link, (0, $xo6Zx.mergeProps)(_ctx.$attrs, {
        to: $props.to,
        class: [
            $options.variantClass,
            _ctx.$attrs.class
        ]
    }), {
        default: (0, $xo6Zx.withCtx)(()=>[
                (0, $xo6Zx.renderSlot)(_ctx.$slots, "default")
            ]),
        _: 3
    }, 16, [
        "to",
        "class"
    ]);
}

});

parcelRegister("6uqAq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9a2af181114ddf$export$2e2bcd8739ae039);
let $4b9a2af181114ddf$var$NOOP = ()=>{};
var $4b9a2af181114ddf$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("bH87A", function(module, exports) {

$parcel$export(module.exports, "default", () => $883a0293ed29d77a$export$2e2bcd8739ae039);

var $14ltf = parcelRequire("14ltf");

var $8s1QA = parcelRequire("8s1QA");

var $1a39I = parcelRequire("1a39I");

var $e512K = parcelRequire("e512K");
async function $883a0293ed29d77a$export$2e2bcd8739ae039(route, next) {
    await (0, $8s1QA.default)((0, $14ltf.default));
    const routedVolume = (0, $1a39I.default)(route, (0, $14ltf.default));
    if (routedVolume) {
        // We have a volume - which is all we need. Stay here.
        next();
        return;
    }
    // We do not have a routed volume.
    // Let's see if there's any volume at all to route to.
    const volume = (0, $e512K.default)((0, $14ltf.default));
    if (!!route.volumeSlug && !volume) {
        // We came here with a volume slug,
        // but there isn't even a single volume available.
        // Neither can the volume slug match,
        // nor can we redirect to any other available volume.
        // Let's go to a parameterless '/' and stay there.
        next({
            name: "Hub"
        });
        return;
    }
    // We came here with a volume slug, which was invalid,
    // or we came here all without a volume slug.
    // However, we have found a volume in the container
    // which we will now redirect to.
    next({
        name: "HubWithVolume",
        params: {
            volumeSlug: volume.slug
        },
        // This is important. Vue router compares the redirect
        // route with the currently active route, not with
        // the one requested by the user! E.g. if the active
        // route is a valid '/jaargang-26-2020-2021/', and
        // a user enters an invalid route '/grmpf/', then
        // vue router will compare our redirect to the valid
        // '/jaargang-26-2020-2021/' with the active route
        // ('/jaargang-26-2020-2021/') and not with the one
        // we are redirecting away from ('/grmpf/') before
        // it has even become active. Without `force: true`,
        // vue router sees that our redirect is equal to the
        // active route and rejects the navigation. This,
        // however, means that '/grmpf/' stays in the address
        // bar. We don't want that, so we force push our
        // new (and possibly old) route.
        force: true
    });
}

});
parcelRegister("14ltf", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c76d1d30118ab1e$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $2P5Vj = parcelRequire("2P5Vj");

var $8g0tj = parcelRequire("8g0tj");

var $bdnrv = parcelRequire("bdnrv");

var $45fjF = parcelRequire("45fjF");
var $0c76d1d30118ab1e$export$2e2bcd8739ae039 = (0, $aofyc.createStore)({
    state: $2P5Vj.default,
    getters: $8g0tj.default,
    mutations: $bdnrv.default,
    actions: $45fjF.default
});

});
parcelRegister("2P5Vj", function(module, exports) {

$parcel$export(module.exports, "default", () => $20e4f0783435c0b2$export$2e2bcd8739ae039);
var $20e4f0783435c0b2$export$2e2bcd8739ae039 = {
    container: {}
};

});

parcelRegister("8g0tj", function(module, exports) {

$parcel$export(module.exports, "default", () => $60302f059b19192a$export$2e2bcd8739ae039);
// Resolve route parameters

var $1a39I = parcelRequire("1a39I");

var $8hAdR = parcelRequire("8hAdR");

var $5SjRy = parcelRequire("5SjRy");

var $dXqu3 = parcelRequire("dXqu3");

var $leRnd = parcelRequire("leRnd");

var $gP0zu = parcelRequire("gP0zu");

var $bp7tg = parcelRequire("bp7tg");

var $e512K = parcelRequire("e512K");

var $jqHCQ = parcelRequire("jqHCQ");

var $3UsVB = parcelRequire("3UsVB");

var $3GtVT = parcelRequire("3GtVT");
var $60302f059b19192a$export$2e2bcd8739ae039 = {
    // If any of the container's direct children is unset,
    // then the container is not done loading.
    containerLoaded: (state)=>!!Object.keys(state.container).length,
    // TODO: Reconsider: shall we at all use `active`... ? We have good router guards now.
    // Volume (child of Container)
    autoVolume: (state, getters)=>(0, $e512K.default)({
            state: state,
            getters: getters
        }),
    routedVolume: (state, getters)=>(0, $1a39I.default)(state.route, {
            state: state,
            getters: getters
        }),
    activeVolume: (state, getters)=>getters.routedVolume || getters.autoVolume,
    // School level (child of Container)
    autoSchoolLevel: (state, getters)=>(0, $jqHCQ.default)({
            state: state,
            getters: getters
        }),
    routedSchoolLevel: (state, getters)=>(0, $8hAdR.default)(state.route, {
            state: state,
            getters: getters
        }),
    activeSchoolLevel: (state, getters)=>getters.routedSchoolLevel || getters.autoSchoolLevel,
    // Season (child of Volume)
    autoSeason: (state, getters)=>(0, $3UsVB.default)(getters.activeVolume, {
            state: state,
            getters: getters
        }),
    routedSeason: (state, getters)=>(0, $5SjRy.default)(state.route, getters.activeVolume, {
            state: state,
            getters: getters
        }),
    activeSeason: (state, getters)=>getters.routedSeason || getters.autoSeason,
    // Season content for school level (child of both Season and SchoolLevel).
    // Note: No guessing here -> no `auto` / `active` getters. Only what's routed is true.
    //   Parent seasons and school levels are auto-guessing and thus routes are self-healing.
    //   If no season or school level can be guessed, or if no season content exists
    //   for the active school level (even though the season might be valid),
    //   then we simply can't answer with a different season's or school level's
    //   content. Instead, we must keep season content empty and only answer
    //   with archive content, as long as an active school level is available.
    routedSeasonContentForSchoolLevel: (state, getters)=>(0, $dXqu3.default)(state.route, {
            parentSeason: getters.routedSeason,
            parentSchoolLevel: getters.activeSchoolLevel
        }, {
            state: state,
            getters: getters
        }),
    activeSeasonContentForSchoolLevel: (state, getters)=>(0, $dXqu3.default)(state.route, {
            parentSeason: getters.activeSeason,
            parentSchoolLevel: getters.activeSchoolLevel
        }, {
            state: state,
            getters: getters
        }),
    // Day (child of Season Content For School Level)
    autoDay: (state, getters)=>(0, $3GtVT.default)(null, {
            parentVolume: getters.activeVolume,
            parentSeason: getters.activeSeason,
            parentSeasonContentForSchoolLevel: getters.activeSeasonContentForSchoolLevel
        }, {
            state: state,
            getters: getters
        }),
    routedDay: (state, getters)=>(0, $leRnd.default)(state.route, getters.activeSeasonContentForSchoolLevel, {
            state: state,
            getters: getters
        }),
    activeDay: (state, getters)=>getters.routedDay || getters.autoDay,
    // TODO: Clean out
    //
    // routedPageParent: (state, getters) => getters.routedWeek || getters.routedMagazine || getters.routedYear || state.container,
    //
    // filteredRoutedPageParentPages: (state, getters) => filterPagesByNavHide(
    //   filterPagesByAgeGroup(
    //     getters.routedPageParent?.pages,
    //     getters.activeAgeGroup,
    //   ),
    // ),
    //
    // // Page (child of Container, Year, Magazine and Week)
    // autoWeekPage: (state, getters) => autoWeekPage(state.route, getters.routedWeek || getters.autoWeek, { state, getters }),
    // routedPage:   (state, getters) => resolveRoutedPage(state.route, { state, getters }),
    // activePage:   (state, getters) => getters.routedPage || getters.autoWeekPage,
    //
    // filteredActivePageSections: (state, getters) => filterPageSectionsByNavHide(
    //   filterPageSectionsByAgeGroup(
    //     getters.activePage.sections,
    //     getters.activeAgeGroup,
    //   ),
    // ),
    //
    // // Section (child of Page)
    // autoSection:   (state, getters) => autoSection(state.route, getters.routedPage, { state, getters }),
    // routedSection: (state, getters) => resolveRoutedSection(state.route, getters.routedPage, { state, getters }),
    // activeSection: (state, getters) => getters.routedSection || getters.autoSection,
    //
    routedSong: (state, getters)=>(0, $gP0zu.default)(state.route, {
            parentSeasonContentForSchoolLevel: getters.routedSeasonContentForSchoolLevel,
            parentSchoolLevel: getters.activeSchoolLevel
        }, {
            state: state,
            getters: getters
        }),
    // TODO (inherited from Kind op Maandag): Auto song & active song - if we have a KaraokePlayer section,
    //       but not a route? Or do we hard-route that?
    routedVideo: (state, getters)=>(0, $bp7tg.default)(state.route, {
            parentDay: getters.routedDay,
            parentSeasonContentForSchoolLevel: getters.routedSeasonContentForSchoolLevel,
            parentSchoolLevel: getters.activeSchoolLevel
        }, {
            state: state,
            getters: getters
        })
};

});
parcelRegister("1a39I", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d892c4002557bf5$export$2e2bcd8739ae039);

var $dT1o1 = parcelRequire("dT1o1");
const $0d892c4002557bf5$var$findVolume = (container, route)=>(0, $dT1o1.default)(container?.volumes, route.params.volumeSlug);
function $0d892c4002557bf5$export$2e2bcd8739ae039(route, { state: state, getters: getters }) {
    if (!getters.containerLoaded) return null;
    // Once the container is loaded, we an determine if the volume slug
    // route parameter matches one of the defined volumes. However,
    // if there is no volume slug parameter, then we can only
    // return null and let the app auto-determine a fallback volume.
    if (!route.params?.volumeSlug) return null;
    // If a volume slug route parameter is defined, use the parameter to match
    // one of the defined volumes. If none matches, fall back to an auto volume.
    return $0d892c4002557bf5$var$findVolume(state.container, route);
}

});
parcelRegister("dT1o1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1c17cc21b732c24$export$2e2bcd8739ae039);
function $a1c17cc21b732c24$export$2e2bcd8739ae039(items, slug) {
    if (!slug) return undefined;
    return items?.find((item)=>item.slug === slug);
}

});


parcelRegister("8hAdR", function(module, exports) {

$parcel$export(module.exports, "default", () => $607c024f98424ff4$export$2e2bcd8739ae039);

var $dT1o1 = parcelRequire("dT1o1");
const $607c024f98424ff4$var$findSchoolLevel = (container, route)=>(0, $dT1o1.default)(container?.schoolLevels, route.params.schoolLevelSlug);
function $607c024f98424ff4$export$2e2bcd8739ae039(route, { state: state, getters: getters }) {
    if (!getters.containerLoaded) return null;
    // Once the container is loaded, we an determine if the school level slug
    // route parameter matches one of the defined school levels. However,
    // if there is no school level slug parameter, then we can only
    // return null and let the app auto-determine a fallback school level.
    if (!route.params?.schoolLevelSlug) return null;
    // If a school level slug route parameter is defined, use the parameter to match
    // one of the defined school levels. If none matches, fall back to an auto school level.
    return $607c024f98424ff4$var$findSchoolLevel(state.container, route);
}

});

parcelRegister("5SjRy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4471673e5bb947eb$export$2e2bcd8739ae039);

var $dT1o1 = parcelRequire("dT1o1");
const $4471673e5bb947eb$var$findSeason = (volume, route)=>(0, $dT1o1.default)(volume?.seasons, route.params.seasonSlug);
function $4471673e5bb947eb$export$2e2bcd8739ae039(route, parentVolume, { getters: getters }) {
    if (!getters.containerLoaded) return null;
    // If no season slug route parameter is provided, we fall back
    // to the auto season, which might be the current season
    // (if the current volume is selected and the current date
    // falls into one of this volume's seasons); might be
    // the first season of the selected volume; might
    // be null in all other cases.
    if (!route.params?.seasonSlug) return null;
    // If a season slug route parameter is provided, we use this
    // parameter to match one of the selected volume's seasons.
    // If none matches because the season slug route param
    // is invalid, then an automatic fallback is chosen.
    return $4471673e5bb947eb$var$findSeason(parentVolume, route);
}

});

parcelRegister("dXqu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a295542739c45f95$export$2e2bcd8739ae039);

var $Xc25u = parcelRequire("Xc25u");
function $a295542739c45f95$export$2e2bcd8739ae039(route, { parentSeason: parentSeason, parentSchoolLevel: parentSchoolLevel }, { getters: getters }) {
    if (!getters.containerLoaded) return null;
    // If no school level or no season is provided, we fall back
    // to the auto 'season content for school level'.
    if (!parentSeason || !parentSchoolLevel) return null;
    // If a season slug route parameter is provided, we use this
    // parameter to match one of the selected volume's seasons.
    // If none matches because the season slug route param
    // is invalid, then an automatic fallback is chosen.
    return (0, $Xc25u.default)(parentSeason, parentSchoolLevel);
}

});
parcelRegister("Xc25u", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b1ed83d97d2b51a$export$2e2bcd8739ae039);

var $lP8to = parcelRequire("lP8to");
function $0b1ed83d97d2b51a$export$2e2bcd8739ae039(season, schoolLevel) {
    return (0, $lP8to.default)(season?.seasonContentForSchoolLevel, "schoolLevel", schoolLevel?.slug);
}

});
parcelRegister("lP8to", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe34eef4e4b615e8$export$2e2bcd8739ae039);
function $fe34eef4e4b615e8$export$2e2bcd8739ae039(items, reference, slug) {
    if (!slug || !reference) return undefined;
    return items?.find((item)=>item[reference].slug === slug);
}

});



parcelRegister("leRnd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7644ea3af09b40a$export$2e2bcd8739ae039);

var $dT1o1 = parcelRequire("dT1o1");
const $f7644ea3af09b40a$var$findDay = (seasonContentForSchoolLevel, route)=>(0, $dT1o1.default)(seasonContentForSchoolLevel?.days, route.params.daySlug);
function $f7644ea3af09b40a$export$2e2bcd8739ae039(route, parentSeasonContentForSchoolLevel, { getters: getters }) {
    if (!getters.containerLoaded) return null;
    // If no day slug route parameter is provided, we fall back
    // to the auto day, which might be the current day
    // (if the current season(-content for the active school level)
    // is selected and the current date is represented as one of
    // this season's days); might be the first day of the
    // active 'season content for school level'; might
    // be null in all other cases.
    if (!route.params?.daySlug) return null;
    // If a season slug route parameter is provided, we use this
    // parameter to match one of the selected volume's seasons.
    // If none matches because the season slug route param
    // is invalid, then an automatic fallback is chosen.
    return $f7644ea3af09b40a$var$findDay(parentSeasonContentForSchoolLevel, route);
}

});

parcelRegister("gP0zu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f1da3f2939db59$export$2e2bcd8739ae039);

var $dT1o1 = parcelRequire("dT1o1");
const $c3f1da3f2939db59$var$findSong = (route, { parentSeasonContentForSchoolLevel: parentSeasonContentForSchoolLevel, parentSchoolLevel: parentSchoolLevel })=>{
    // If we have a routed seasonContentForSchoolLevel,
    // then we are looking for a season song.
    if (parentSeasonContentForSchoolLevel) return (0, $dT1o1.default)(parentSeasonContentForSchoolLevel.songs, route.params.songSlug);
    // Otherwise, we must be looking for a school level archive song.
    return (0, $dT1o1.default)(parentSchoolLevel.archivedSongs, route.params.songSlug);
};
function $c3f1da3f2939db59$export$2e2bcd8739ae039(route, parents, { getters: getters }) {
    if (!getters.containerLoaded) return null;
    // If no song slug is provided, fall back
    // to the (archive or season) song list.
    if (!route.params?.songSlug) return null;
    // Find the song by the route's song slug.
    return $c3f1da3f2939db59$var$findSong(route, parents);
}

});

parcelRegister("bp7tg", function(module, exports) {

$parcel$export(module.exports, "default", () => $84d7d315a596de6b$export$2e2bcd8739ae039);

var $dT1o1 = parcelRequire("dT1o1");
const $84d7d315a596de6b$var$findVideo = (route, { parentDay: parentDay, parentSeasonContentForSchoolLevel: parentSeasonContentForSchoolLevel, parentSchoolLevel: parentSchoolLevel })=>{
    // If we have a routed day, then we
    // are looking for a day video.
    if (parentDay) return (0, $dT1o1.default)(parentDay.videos, route.params.videoSlug);
    // If we have a routed seasonContentForSchoolLevel,
    // then we are looking for a season video.
    if (parentSeasonContentForSchoolLevel) return (0, $dT1o1.default)(parentSeasonContentForSchoolLevel.videos, route.params.videoSlug);
    // Otherwise, we must be looking for a school level archive song.
    return (0, $dT1o1.default)(parentSchoolLevel.archivedVideos, route.params.videoSlug);
};
function $84d7d315a596de6b$export$2e2bcd8739ae039(route, parents, { getters: getters }) {
    if (!getters.containerLoaded) return null;
    // If no song slug is provided, fall back
    // to the (archive or season) video list.
    if (!route.params?.videoSlug) return null;
    // Find the song by the route's video slug.
    return $84d7d315a596de6b$var$findVideo(route, parents);
}

});

parcelRegister("e512K", function(module, exports) {

$parcel$export(module.exports, "default", () => $a402577f2d3a1f5c$export$2e2bcd8739ae039);

var $kosgo = parcelRequire("kosgo");

var $6JghM = parcelRequire("6JghM");

var $hVbvF = parcelRequire("hVbvF");
function $a402577f2d3a1f5c$export$2e2bcd8739ae039({ state: state, getters: getters }) {
    if (!getters.containerLoaded) return null;
    // Once the container is loaded, there might be a volume
    // defined, which the current date falls into.
    // If that is so, return that current volume.
    return (0, $kosgo.default)({
        state: state,
        getters: getters
    }) || // Do we have a previous volume?
    (0, $6JghM.default)({
        state: state,
        getters: getters
    }) || // No previous volume in the dataset. Do we have a next volume?
    (0, $hVbvF.default)({
        state: state,
        getters: getters
    }); // Implicit ... || null.
}

});
parcelRegister("kosgo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed8bf9137815cc06$export$2e2bcd8739ae039);

var $a6D4b = parcelRequire("a6D4b");
function $ed8bf9137815cc06$export$2e2bcd8739ae039({ state: state, getters: getters }) {
    if (!getters.containerLoaded) return null;
    // Once the container is loaded, return the current volume.
    // If the current date does not fall into any of the
    // defined dates, return null.
    // Next or previous dates are auto-determined in `autoVolume`.
    return (0, $a6D4b.default)(state.container.volumes);
}

});
parcelRegister("a6D4b", function(module, exports) {

$parcel$export(module.exports, "default", () => $75b8c4b276faff5b$export$2e2bcd8739ae039);

var $aWilS = parcelRequire("aWilS");
function $75b8c4b276faff5b$export$2e2bcd8739ae039(items) {
    // Ensure chronologically ascending sort order.
    (0, $aWilS.default)(items);
    const now = new Date();
    return items.reduce((acc, cur)=>{
        // First one found is the one we want.
        if (acc) return acc;
        // Note, the following applies for the time part if these `DateTime`s are not `null` or `undefined`:
        // - `startDate` is always set to 00:00:00.000 (= first day)
        // - `endDate` is always set to 23:59:59.999 (= last day)
        // However:
        // - `frontendDisplayStartDate` is always set to 00:00:00.000 (= first visible day)
        // - `frontendDisplayEndDate` is *also* always set to 00:00:00.000! (= next day, or first invisible day)
        // => The season field `frontend_display_end_date` is used as the table's TYPO3 `endtime`.
        //    Its label is, for clarification, changed to "Invisible starting from (at midnight)".
        //    We do not want editors to have to select 23:59 in a date picker - that would be error prone.
        // Match the one (if any) which the current date falls into.
        if (new Date(cur.startDate) <= now && new Date(cur.endDate) >= now) return cur;
        // Carry either null or the matched item
        // if conditions do not apply.
        // -> Replace acc (null) with cur when the condition matches
        //    and do not change acc after the first assignment.
        return acc;
    }, null);
}

});
parcelRegister("aWilS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f6d8e7537c800a8$export$2e2bcd8739ae039);
function $7f6d8e7537c800a8$export$2e2bcd8739ae039(items) {
    items.sort((a, b)=>a.startDate - b.startDate);
}

});



parcelRegister("6JghM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e63940b48c30b53$export$2e2bcd8739ae039);

var $aHnHx = parcelRequire("aHnHx");
function $4e63940b48c30b53$export$2e2bcd8739ae039({ state: state, getters: getters }) {
    if (!getters.containerLoaded) return null;
    return (0, $aHnHx.default)(state.container.volumes);
}

});
parcelRegister("aHnHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ca04e1c6ad7bc1c$export$2e2bcd8739ae039);

var $aWilS = parcelRequire("aWilS");
function $7ca04e1c6ad7bc1c$export$2e2bcd8739ae039(items) {
    // Ensure chronologically ascending sort order.
    (0, $aWilS.default)(items);
    const now = new Date();
    return items.reduce((acc, cur)=>{
        // Note, the following applies for the time part if these `DateTime`s are not `null` or `undefined`:
        // - `startDate` is always set to 00:00:00.000 (= first day)
        // - `endDate` is always set to 23:59:59.999 (= last day)
        // However:
        // - `frontendDisplayStartDate` is always set to 00:00:00.000 (= first visible day)
        // - `frontendDisplayEndDate` is *also* always set to 00:00:00.000! (= next day, or first invisible day)
        // => The season field `frontend_display_end_date` is used as the table's TYPO3 `endtime`.
        //    Its label is, for clarification, changed to "Invisible starting from (at midnight)".
        //    We do not want editors to have to select 23:59 in a date picker - that would be error prone.
        // Keep only past items.
        if (new Date(cur.endDate) >= now) return acc;
        // Return current item without checking startDate,
        // because we have already sorted all items
        // in chronological order.
        // -> Replace acc by cur until cur does not match any more.
        return cur;
    }, null);
}

});


parcelRegister("hVbvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0c0b0270ffa84b9$export$2e2bcd8739ae039);

var $4SVOX = parcelRequire("4SVOX");
function $d0c0b0270ffa84b9$export$2e2bcd8739ae039({ state: state, getters: getters }) {
    if (!getters.containerLoaded) return null;
    return (0, $4SVOX.default)(state.container.volumes);
}

});
parcelRegister("4SVOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $38e90e9a6a49508a$export$2e2bcd8739ae039);

var $aWilS = parcelRequire("aWilS");
function $38e90e9a6a49508a$export$2e2bcd8739ae039(items) {
    // Ensure chronologically ascending sort order.
    (0, $aWilS.default)(items);
    const now = new Date();
    return items.reduce((acc, cur)=>{
        // Keep only future items.
        if (new Date(cur.startDate) <= now) return acc;
        // Keep only the closest future item.
        if (acc) return acc;
        // -> Replace acc (null) by cur as soon as the condition matches.
        //    Do not change acc after its first assignment.
        return cur;
    }, null);
}

});



parcelRegister("jqHCQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e252492add605bfe$export$2e2bcd8739ae039);
function $e252492add605bfe$export$2e2bcd8739ae039({ state: state, getters: getters }) {
    if (!getters.containerLoaded) return null;
    if (!state.container.schoolLevels?.length) return null;
    return state.container.schoolLevels[0];
}

});

parcelRegister("3UsVB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d8d0a98aeb005c2$export$2e2bcd8739ae039);

var $kosgo = parcelRequire("kosgo");

var $aWilS = parcelRequire("aWilS");

var $5RfP3 = parcelRequire("5RfP3");
function $2d8d0a98aeb005c2$export$2e2bcd8739ae039(parentVolume, { state: state, getters: getters }) {
    if (!getters.containerLoaded) return null;
    // The parent volume has no seasons, or is null.
    if (!parentVolume?.seasons.length) return null;
    const currentVolume = (0, $kosgo.default)({
        state: state,
        getters: getters
    });
    // If the parent volume is the current volume,
    // then we want the current or closest season.
    // Otherwise, we always want the first season.
    if (currentVolume && currentVolume === parentVolume) {
        const closestSeason = (0, $5RfP3.default)(parentVolume, {
            state: state,
            getters: getters
        });
        if (closestSeason) return closestSeason;
    // We found no current season, and no closest season
    // within the current volume.
    }
    // Sort the seasons to easily grab the first one.
    (0, $aWilS.default)(parentVolume.seasons);
    // Since the selected volume is not the current volume,
    // return the selected volume's first season.
    return parentVolume.seasons[0];
}

});
parcelRegister("5RfP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $443e2d02a1161cd8$export$2e2bcd8739ae039);

var $9hrk8 = parcelRequire("9hrk8");

var $4Zmiu = parcelRequire("4Zmiu");

var $lAWbz = parcelRequire("lAWbz");
function $443e2d02a1161cd8$export$2e2bcd8739ae039(parentVolume, store) {
    // Check if we have a season record for today.
    const currentSeason = (0, $9hrk8.default)(parentVolume, store);
    // If the parent volume contains a season record for today,
    // then we want to use that one.
    if (currentSeason) return currentSeason;
    // As we do not have a day record for the given date, we now check
    // for future or past day records in the given season and school level.
    const futureSeason = (0, $4Zmiu.default)(parentVolume.seasons, store);
    if (futureSeason) return futureSeason;
    const recentSeason = (0, $lAWbz.default)(parentVolume.seasons, store);
    if (recentSeason) return recentSeason;
    return null;
}

});
parcelRegister("9hrk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c1ae589eef8b47b$export$2e2bcd8739ae039);

var $a6D4b = parcelRequire("a6D4b");

var $kosgo = parcelRequire("kosgo");
function $6c1ae589eef8b47b$export$2e2bcd8739ae039(parentVolume, { state: state, getters: getters }) {
    if (!getters.containerLoaded) return null;
    const currentVolume = (0, $kosgo.default)({
        state: state,
        getters: getters
    });
    // We only want the current season if the selected volume is also
    // the current volume. If the selected volume is not the current
    // volume, then `autoSeason` fall back to the first
    // season of the selected volume.
    if (!currentVolume || currentVolume !== parentVolume) return null;
    // If the selected volume is the current volume, return the season
    // which the current date falls into.
    return (0, $a6D4b.default)(currentVolume.seasons);
}

});

parcelRegister("4Zmiu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a1e27ab6142c0ec$export$2e2bcd8739ae039);

var $4SVOX = parcelRequire("4SVOX");
function $3a1e27ab6142c0ec$export$2e2bcd8739ae039(seasons, { state: state, getters: getters }) {
    if (!getters.containerLoaded) return null;
    return (0, $4SVOX.default)(seasons);
}

});

parcelRegister("lAWbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8a183745fe34c7$export$2e2bcd8739ae039);

var $aHnHx = parcelRequire("aHnHx");
function $fb8a183745fe34c7$export$2e2bcd8739ae039(seasons, { state: state, getters: getters }) {
    if (!getters.containerLoaded) return null;
    return (0, $aHnHx.default)(seasons);
}

});



parcelRegister("3GtVT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aec83600446784d$export$2e2bcd8739ae039);

var $7T8xC = parcelRequire("7T8xC");

var $83fGH = parcelRequire("83fGH");

var $3xZ1w = parcelRequire("3xZ1w");
function $2aec83600446784d$export$2e2bcd8739ae039(date, { parentVolume: parentVolume, parentSeason: parentSeason, parentSeasonContentForSchoolLevel: parentSeasonContentForSchoolLevel }, { state: state, getters: getters }) {
    if (!getters.containerLoaded) return null;
    // The parent season content for school level has no days, or is null.
    if (!parentSeasonContentForSchoolLevel?.days.length) return null;
    // Sort the days to easily grab the next, previous, first or last one.
    (0, $83fGH.default)(parentSeasonContentForSchoolLevel.days);
    // If we are visiting a different school year (volume),
    // then we are going to *always* return the first day of each season.
    // Flipping through a non-current volume is like flipping through
    // a catalog of material, and no longer an experience bound to
    // the actual current real-time.
    if (!(0, $3xZ1w.default)(date, parentVolume)) return parentSeasonContentForSchoolLevel.days[0];
    // If the parent season is the current season, then we will be able
    // to match the next following available day.
    // Otherwise, we attempt to fall back to the most recent past day
    // in the same season.
    if ((0, $3xZ1w.default)(date, parentSeason)) {
        // If the parent 'season content for school level' contains a day record
        // for the given date or a near future or recent past date, then we want
        // to use that one.
        const closestDay = (0, $7T8xC.default)(date, parentSeasonContentForSchoolLevel, {
            state: state,
            getters: getters
        });
        if (closestDay) return closestDay;
    // No current, near future or recent past day was found.
    // We have no choice but to fall through ot the first or last
    // day of the season.
    // Note: If the `parentSeasonContentForSchoolLevel` has
    // no day records, then we already returned `null` above!
    }
    // As the parent season is not the current season, it must be
    // either a past or a future season. We take the simple route
    // and pick the last day for past seasons, and the first day
    // for future seasons.
    // If active season is in the past, then use last day of that season.
    const lastDay = parentSeasonContentForSchoolLevel.days[parentSeasonContentForSchoolLevel.days.length - 1];
    if (new Date(lastDay.date) < new Date()) return lastDay;
    // The active season must be a future season.
    // Return the selected school level's and season's first day.
    return parentSeasonContentForSchoolLevel.days[0];
}

});
parcelRegister("7T8xC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be44b8f3321c4d0$export$2e2bcd8739ae039);

var $kc9OD = parcelRequire("kc9OD");

var $8C3kQ = parcelRequire("8C3kQ");

var $3fSWm = parcelRequire("3fSWm");
function $5be44b8f3321c4d0$export$2e2bcd8739ae039(date, parentSeasonContentForSchoolLevel, store) {
    // Check if we have a day record for today.
    const currentDay = (0, $kc9OD.default)(date, parentSeasonContentForSchoolLevel, store);
    // If the parent 'season content for school level' contains a day record
    // for the given date or a near future or recent past date, then we want
    // to use that one.
    if (currentDay) return currentDay;
    // As we do not have a day record for the given date, we now check
    // for future or past day records in the given season and school level.
    const futureDay = (0, $8C3kQ.default)(date, parentSeasonContentForSchoolLevel.days);
    if (futureDay) return futureDay;
    const recentDay = (0, $3fSWm.default)(date, parentSeasonContentForSchoolLevel.days);
    if (recentDay) return recentDay;
    return null;
}

});
parcelRegister("kc9OD", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb3c8ad3eb159e8d$export$2e2bcd8739ae039);

var $kaYFn = parcelRequire("kaYFn");
function $eb3c8ad3eb159e8d$export$2e2bcd8739ae039(date, parentSeasonContentForSchoolLevel, store) {
    return (0, $kaYFn.default)(date, parentSeasonContentForSchoolLevel, store);
}

});
parcelRegister("kaYFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb03cce5c0373a20$export$2e2bcd8739ae039);

var $9OEaf = parcelRequire("9OEaf");
function $eb03cce5c0373a20$export$2e2bcd8739ae039(date, parentSeasonContentForSchoolLevel, { getters: getters }) {
    if (!getters.containerLoaded) return null;
    // Return the day record (if any) matching the given or current date.
    // Create a new `Date` object avoid side effect.
    const reference = (0, $9OEaf.default)(date);
    return parentSeasonContentForSchoolLevel.days.reduce((acc, cur)=>{
        // First one found is the one we want.
        if (acc) return acc;
        // Match the one (if any) which the current date falls into.
        if (new Date(cur.date).getTime() === reference.getTime()) return cur;
        // Carry either null or the matched item
        // if conditions do not apply.
        // -> Replace acc (null) with cur when the condition matches
        //    and do not change acc after the first assignment.
        return acc;
    }, null);
}

});
parcelRegister("9OEaf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7257f05a9f967a43$export$2e2bcd8739ae039);
function $7257f05a9f967a43$export$2e2bcd8739ae039(date) {
    // Parameter `date` may be:
    // - `null` for current date.
    // - A JSON date string.
    // - A Date object.
    const d = date ? new Date(date) : new Date();
    d.setHours(0);
    d.setMinutes(0);
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d;
}

});



parcelRegister("8C3kQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $645475a5ff09e2f6$export$2e2bcd8739ae039);

var $9OEaf = parcelRequire("9OEaf");

var $83fGH = parcelRequire("83fGH");
function $645475a5ff09e2f6$export$2e2bcd8739ae039(date, items) {
    // Ensure chronologically ascending sort order.
    (0, $83fGH.default)(items);
    const reference = (0, $9OEaf.default)(date);
    return items.reduce((acc, cur)=>{
        // Keep only future items.
        if (new Date(cur.date) <= reference) return acc;
        // Keep only the closest future item.
        if (acc) return acc;
        // -> Replace acc (null) by cur as soon as the condition matches.
        //    Do not change acc after its first assignment.
        return cur;
    }, null);
}

});
parcelRegister("83fGH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dcac5c8bc5ebf40$export$2e2bcd8739ae039);
function $5dcac5c8bc5ebf40$export$2e2bcd8739ae039(items) {
    items.sort((a, b)=>a.date - b.date);
}

});


parcelRegister("3fSWm", function(module, exports) {

$parcel$export(module.exports, "default", () => $25ed63d39f515a3b$export$2e2bcd8739ae039);

var $9OEaf = parcelRequire("9OEaf");

var $83fGH = parcelRequire("83fGH");
function $25ed63d39f515a3b$export$2e2bcd8739ae039(date, items) {
    // Ensure chronologically ascending sort order.
    (0, $83fGH.default)(items);
    const reference = (0, $9OEaf.default)(date);
    return items.reduce((acc, cur)=>{
        // Keep only past items.
        if (new Date(cur.date) >= reference) return acc;
        // Return current item. We have already
        // sorted all items in chronological order.
        // -> Replace acc by cur until cur does not match any more.
        return cur;
    }, null);
}

});


parcelRegister("3xZ1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $2953ca2c3a1de293$export$2e2bcd8739ae039);

var $9OEaf = parcelRequire("9OEaf");
function $2953ca2c3a1de293$export$2e2bcd8739ae039(date, item) {
    const reference = (0, $9OEaf.default)(date);
    // Note, the following applies for the time part if these `DateTime`s are not `null` or `undefined`:
    // - `startDate` is always set to 00:00:00.000 (= first day)
    // - `endDate` is always set to 23:59:59.999 (= last day)
    // However:
    // - `frontendDisplayStartDate` is always set to 00:00:00.000 (= first visible day)
    // - `frontendDisplayEndDate` is *also* always set to 00:00:00.000! (= next day, or first invisible day)
    // => The season field `frontend_display_end_date` is used as the table's TYPO3 `endtime`.
    //    Its label is, for clarification, changed to "Invisible starting from (at midnight)".
    //    We do not want editors to have to select 23:59 in a date picker - that would be error prone.
    const current = new Date(item.startDate) <= reference && new Date(item.endDate) >= reference;
    // Apply visibility if set. (Only set for seasons.)
    const visible = (!item.frontendDisplayStartDate || // `null` or `undefined`
    new Date(item.frontendDisplayStartDate) <= reference) && (!item.frontendDisplayEndDate || // `null` or `undefined`
    new Date(item.frontendDisplayEndDate) >= reference);
    return current && visible;
}

});



parcelRegister("bdnrv", function(module, exports) {

$parcel$export(module.exports, "default", () => $82a317cdd4e3edf5$export$2e2bcd8739ae039);
var $82a317cdd4e3edf5$export$2e2bcd8739ae039 = {
    setContainer (state, data) {
        state.container = data;
    }
};

});

parcelRegister("45fjF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f9382874a5be39b$export$2e2bcd8739ae039);
let $2f9382874a5be39b$var$numFetchAttempts = 0;
const $2f9382874a5be39b$var$maxFetchAttempts = 2;
var $2f9382874a5be39b$export$2e2bcd8739ae039 = {
    async fetchContainer ({ commit: commit, dispatch: dispatch }) {
        try {
            $2f9382874a5be39b$var$numFetchAttempts += 1;
            const response = await fetch("/digibord/data.json");
            if ([
                403,
                404
            ].includes(response.status)) {
                window.location.href = "/inloggen-aub";
                return;
            }
            if (!response.ok) throw new Error(`Response status: ${response.status}`);
            const data = await response.json();
            if (data) commit("setContainer", data);
            else if ($2f9382874a5be39b$var$numFetchAttempts < $2f9382874a5be39b$var$maxFetchAttempts) await dispatch("fetchContainer");
        } catch (error) {
            if ($2f9382874a5be39b$var$numFetchAttempts < $2f9382874a5be39b$var$maxFetchAttempts) await dispatch("fetchContainer");
        // TODO: Else: Display error, allow to trigger retry.
        }
    }
};

});


parcelRegister("8s1QA", function(module, exports) {

$parcel$export(module.exports, "default", () => $62725f1503f189dd$export$2e2bcd8739ae039);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
async function $62725f1503f189dd$export$2e2bcd8739ae039({ getters: getters }) {
    return new Promise((resolve)=>{
        if (getters.containerLoaded) resolve();
        else (0, $xo6Zx.watch)(()=>getters.containerLoaded, (loaded)=>{
            if (loaded) resolve();
        });
    });
}

});



parcelRegister("65s2p", function(module, exports) {

$parcel$export(module.exports, "render", () => $46e8f56fd077fddf$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $46e8f56fd077fddf$var$_hoisted_1 = {
    id: "header",
    class: "mt-8 header--hub"
};
const $46e8f56fd077fddf$var$_hoisted_2 = {
    key: 0
};
function $46e8f56fd077fddf$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link_button = (0, $xo6Zx.resolveComponent)("router-link-button");
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_transition_fade, {
        duration: 500,
        appear: ""
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                (0, $xo6Zx.createElementVNode)("header", $46e8f56fd077fddf$var$_hoisted_1, [
                    _cache[0] || (_cache[0] = (0, $xo6Zx.createElementVNode)("h1", {
                        class: "ml-[35px]"
                    }, [
                        (0, $xo6Zx.createElementVNode)("span", {
                            class: "header__welcome"
                        }, "Welkom bij"),
                        (0, $xo6Zx.createElementVNode)("span", {
                            class: "header__brand"
                        }, "#TREFWOORD")
                    ], -1)),
                    $setup.activeVolume ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_box_generic, {
                        key: 0,
                        id: "school-level-selector-wrapper"
                    }, {
                        header: (0, $xo6Zx.withCtx)(()=>[
                                $setup.activeVolume ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), {
                                    key: 0
                                }, [
                                    (0, $xo6Zx.createTextVNode)("Jaargang " + (0, $d8ZDz.toDisplayString)($setup.activeVolume.volumeNumber), 1)
                                ], 64)) : (0, $xo6Zx.createCommentVNode)("", true),
                                $setup.autoSeason ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), {
                                    key: 1
                                }, [
                                    (0, $xo6Zx.createTextVNode)(", Nr. " + (0, $d8ZDz.toDisplayString)($setup.autoSeason.issueNumber), 1)
                                ], 64)) : (0, $xo6Zx.createCommentVNode)("", true)
                            ]),
                        default: (0, $xo6Zx.withCtx)(()=>[
                                !!$setup.schoolLevels?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("ul", $46e8f56fd077fddf$var$_hoisted_2, [
                                    ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)($setup.schoolLevels, (schoolLevel)=>{
                                        return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("li", {
                                            key: schoolLevel.slug
                                        }, [
                                            (0, $xo6Zx.createVNode)(_component_router_link_button, {
                                                to: {
                                                    name: 'CalendarSheet',
                                                    params: {
                                                        volumeSlug: $setup.activeVolume.slug,
                                                        schoolLevelSlug: schoolLevel.slug,
                                                        seasonSlug: $setup.autoSeason.slug
                                                    }
                                                },
                                                variant: schoolLevel.title === 'Onderbouw' ? 'onderbouw' : 'midden-bovenbouw'
                                            }, {
                                                default: (0, $xo6Zx.withCtx)(()=>[
                                                        (0, $xo6Zx.createTextVNode)((0, $d8ZDz.toDisplayString)(schoolLevel.title), 1)
                                                    ]),
                                                _: 2
                                            }, 1032, [
                                                "to",
                                                "variant"
                                            ])
                                        ]);
                                    }), 128))
                                ])) : (0, $xo6Zx.createCommentVNode)("", true)
                            ]),
                        _: 1
                    })) : (0, $xo6Zx.createCommentVNode)("", true)
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("gMV21", function(module, exports) {

$parcel$export(module.exports, "default", () => $c38d5e4e9f737d12$export$2e2bcd8739ae039);
let $c38d5e4e9f737d12$var$NOOP = ()=>{};
var $c38d5e4e9f737d12$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("9sg9Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e2343ab39f5be2a$export$2e2bcd8739ae039);

var $ktPZO = parcelRequire("ktPZO");

var $ktTN4 = parcelRequire("ktTN4");

var $6IbKC = parcelRequire("6IbKC");

var $2H8kg = parcelRequire("2H8kg");

var $h99AO = parcelRequire("h99AO");

var $nXq8Y = parcelRequire("nXq8Y");

var $dUbz5 = parcelRequire("dUbz5");

var $2wysN = parcelRequire("2wysN");

var $7sqjz = parcelRequire("7sqjz");

var $iqLfq = parcelRequire("iqLfq");
var $6e2343ab39f5be2a$export$2e2bcd8739ae039 = [
    {
        path: "/:volumeSlug/:schoolLevelSlug/",
        name: "Digibord",
        components: {
            sectionNavigation: (0, $2wysN.default),
            schoolLevelNavigation: (0, $7sqjz.default),
            content: (0, $iqLfq.default)
        },
        children: [
            // Archive routes
            ...(0, $ktPZO.default),
            ...(0, $ktTN4.default),
            // Season routes
            ...(0, $6IbKC.default),
            ...(0, $2H8kg.default),
            ...(0, $h99AO.default),
            ...(0, $nXq8Y.default),
            ...(0, $dUbz5.default)
        ]
    }
];

});
parcelRegister("ktPZO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee8ed96c1eab5992$export$2e2bcd8739ae039);

var $3z7M5 = parcelRequire("3z7M5");

var $htdSJ = parcelRequire("htdSJ");
var $ee8ed96c1eab5992$export$2e2bcd8739ae039 = [
    {
        path: "filmarchief/",
        name: "FilmArchive",
        component: (0, $htdSJ.default),
        meta: {
            containerClass: "showVideoSearch"
        },
        children: [
            ...(0, $3z7M5.default)("FilmArchiveVideoPlayer")
        ]
    }
];

});
parcelRegister("3z7M5", function(module, exports) {

$parcel$export(module.exports, "default", () => $298aabd67e3ea104$export$2e2bcd8739ae039);

var $1Wr8i = parcelRequire("1Wr8i");
function $298aabd67e3ea104$export$2e2bcd8739ae039(name) {
    return [
        {
            path: "video/:videoSlug?/",
            name: name,
            component: (0, $1Wr8i.default),
            meta: {
                containerClass: "showVideoPlayer"
            }
        }
    ];
}

});
parcelRegister("1Wr8i", function(module, exports) {

$parcel$export(module.exports, "default", () => $16a0413c0e49faa1$export$2e2bcd8739ae039);
let $16a0413c0e49faa1$var$script;



let $16a0413c0e49faa1$var$initialize = ()=>{
    $16a0413c0e49faa1$var$script = (parcelRequire("2XxLR"));
    if ($16a0413c0e49faa1$var$script.__esModule) $16a0413c0e49faa1$var$script = $16a0413c0e49faa1$var$script.default;
    $16a0413c0e49faa1$var$script.render = (parcelRequire("4g2wu")).render;
    (parcelRequire("bd7tr")).default($16a0413c0e49faa1$var$script);
    $16a0413c0e49faa1$var$script.__scopeId = 'data-v-b21123';
    $16a0413c0e49faa1$var$script.__file = "VideoPlayer.vue";
};
$16a0413c0e49faa1$var$initialize();
var $16a0413c0e49faa1$export$2e2bcd8739ae039 = $16a0413c0e49faa1$var$script;

});
parcelRegister("2XxLR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $227b49afa4f4150d$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $kLbI9 = parcelRequire("kLbI9");

var $QlUa3 = parcelRequire("QlUa3");

var $g3bhh = parcelRequire("g3bhh");
var $227b49afa4f4150d$export$2e2bcd8739ae039 = {
    name: "VideoPlayer",
    components: {
        TransitionFade: $QlUa3.default,
        BoxGeneric: $kLbI9.default,
        MediaFilmCircle: $g3bhh.default
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "activeSeasonContentForSchoolLevel",
            "routedVideo"
        ]),
        computedHeaderClass () {
            const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
            return slug ? `title-block title-block-${slug}` : "title-block";
        }
    }
};

});
parcelRegister("g3bhh", function(module, exports) {

$parcel$export(module.exports, "default", () => $baf5aca65c612486$export$2e2bcd8739ae039);
let $baf5aca65c612486$var$script;



let $baf5aca65c612486$var$initialize = ()=>{
    $baf5aca65c612486$var$script = (parcelRequire("3xkap"));
    if ($baf5aca65c612486$var$script.__esModule) $baf5aca65c612486$var$script = $baf5aca65c612486$var$script.default;
    $baf5aca65c612486$var$script.render = (parcelRequire("dwHlt")).render;
    (parcelRequire("fJA9k")).default($baf5aca65c612486$var$script);
    $baf5aca65c612486$var$script.__scopeId = 'data-v-5bb311';
    $baf5aca65c612486$var$script.__file = "MediaFilmCircle.vue";
};
$baf5aca65c612486$var$initialize();
var $baf5aca65c612486$export$2e2bcd8739ae039 = $baf5aca65c612486$var$script;

});
parcelRegister("3xkap", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $293418e417ec200a$export$2e2bcd8739ae039);
var $293418e417ec200a$export$2e2bcd8739ae039 = {
    props: {
        color: {
            type: String,
            default: "#137b5d"
        }
    }
};

});

parcelRegister("dwHlt", function(module, exports) {

$parcel$export(module.exports, "render", () => $9d8fe2ff7cf2fd3c$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $9d8fe2ff7cf2fd3c$var$_hoisted_1 = [
    "fill"
];
function $9d8fe2ff7cf2fd3c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("svg", {
        "aria-hidden": "true",
        width: "90px",
        height: "90px",
        viewBox: "0 0 100.11 100.11",
        class: (0, $d8ZDz.normalizeClass)(_ctx.$attrs.class)
    }, [
        (0, $xo6Zx.createElementVNode)("path", {
            fill: $props.color,
            d: "M50.05,99.97C22.41,99.97,0,77.56,0,49.92S22.41-.13,50.05-.13s50.05,22.41,50.05,50.05-22.41,50.05-50.05,50.05"
        }, null, 8, $9d8fe2ff7cf2fd3c$var$_hoisted_1),
        _cache[0] || (_cache[0] = (0, $xo6Zx.createElementVNode)("path", {
            fill: "#fff",
            d: "M43.55,40.14l16.97,9.79-16.97,9.75v-19.55ZM50.03,27.09s-20.39,0-25.51,1.33c-2.74.77-5,3.02-5.76,5.8-1.33,5.12-1.33,15.72-1.33,15.72,0,0,0,10.64,1.33,15.68.77,2.78,2.98,5,5.76,5.76,5.16,1.37,25.51,1.37,25.51,1.37,0,0,20.44,0,25.55-1.33,2.78-.77,5-2.94,5.72-5.76,1.37-5.08,1.37-15.68,1.37-15.68,0,0,.04-10.64-1.37-15.76-.73-2.78-2.94-5-5.72-5.72-5.12-1.41-25.55-1.41-25.55-1.41"
        }, null, -1))
    ], 2);
}

});

parcelRegister("fJA9k", function(module, exports) {

$parcel$export(module.exports, "default", () => $b74719848402c809$export$2e2bcd8739ae039);
let $b74719848402c809$var$NOOP = ()=>{};
var $b74719848402c809$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("4g2wu", function(module, exports) {

$parcel$export(module.exports, "render", () => $319a9d179c4c7d46$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
const $319a9d179c4c7d46$var$_hoisted_1 = {
    key: 0,
    id: "video-player",
    class: "flex flex-col items-start h-full justify-stretch p-[15px]"
};
const $319a9d179c4c7d46$var$_hoisted_2 = [
    "innerHTML"
];
function $319a9d179c4c7d46$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    const _component_MediaFilmCircle = (0, $xo6Zx.resolveComponent)("MediaFilmCircle");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, [
        (0, $xo6Zx.createVNode)(_component_box_generic, {
            class: "w-full h-full",
            hStretch: true,
            wStretch: true,
            header: _ctx.routedVideo.title,
            "header-class": $options.computedHeaderClass
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    (0, $xo6Zx.createVNode)(_component_transition_fade, {
                        duration: 500,
                        appear: ""
                    }, {
                        default: (0, $xo6Zx.withCtx)(()=>[
                                _ctx.routedVideo?.videoFile?._rendered ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $319a9d179c4c7d46$var$_hoisted_1, [
                                    (0, $xo6Zx.createElementVNode)("div", {
                                        class: "grid items-stretch justify-items-stretch self-stretch grow",
                                        innerHTML: _ctx.routedVideo.videoFile._rendered
                                    }, null, 8, $319a9d179c4c7d46$var$_hoisted_2)
                                ])) : (0, $xo6Zx.createCommentVNode)("", true)
                            ]),
                        _: 1
                    })
                ]),
            _: 1
        }, 8, [
            "header",
            "header-class"
        ]),
        (0, $xo6Zx.createVNode)(_component_MediaFilmCircle, {
            class: "pointer-events-none absolute top-0 right-0 translate-x-[-20%] translate-y-[20%]",
            color: _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw' ? '#127b5d' : '#6c44a5'
        }, null, 8, [
            "color"
        ])
    ], 64);
}

});

parcelRegister("bd7tr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8296b4bfe3cbbfa2$export$2e2bcd8739ae039);
let $8296b4bfe3cbbfa2$var$NOOP = ()=>{};
var $8296b4bfe3cbbfa2$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("htdSJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7fe9bb36e6e102$export$2e2bcd8739ae039);
let $cb7fe9bb36e6e102$var$script;




let $cb7fe9bb36e6e102$var$initialize = ()=>{
    $cb7fe9bb36e6e102$var$script = (parcelRequire("cJIU9"));
    if ($cb7fe9bb36e6e102$var$script.__esModule) $cb7fe9bb36e6e102$var$script = $cb7fe9bb36e6e102$var$script.default;
    $cb7fe9bb36e6e102$var$script.render = (parcelRequire("9UhPb")).render;
    $cb7fe9bb36e6e102$var$script.__cssModules = {};
    (parcelRequire("c989s")).default($cb7fe9bb36e6e102$var$script);
    $cb7fe9bb36e6e102$var$script.__scopeId = 'data-v-821712';
    $cb7fe9bb36e6e102$var$script.__file = "FilmArchive.vue";
};
$cb7fe9bb36e6e102$var$initialize();
var $cb7fe9bb36e6e102$export$2e2bcd8739ae039 = $cb7fe9bb36e6e102$var$script;

});
parcelRegister("cJIU9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $945c852407f597b7$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $kLbI9 = parcelRequire("kLbI9");

var $fEFug = parcelRequire("fEFug");

var $3MWve = parcelRequire("3MWve");

var $QlUa3 = parcelRequire("QlUa3");
var $945c852407f597b7$export$2e2bcd8739ae039 = {
    name: "FilmArchive",
    components: {
        BoxGeneric: $kLbI9.default,
        MediaArchive: $fEFug.default,
        TransitionFade: $QlUa3.default,
        VideoPreview: $3MWve.default
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "activeSchoolLevel",
            "activeVolume",
            "routedVideo"
        ])
    },
    methods: {
        // Fix for list transitions in a flex layout.
        // Need to memorize the position on leave,
        // otherwise items fly enthusiastically into the corner.
        mediaItemBeforeLeave (el) {
            el.style.left = `${el.offsetLeft}px`;
            el.style.top = `${el.offsetTop}px`;
        }
    }
};

});
parcelRegister("fEFug", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65ac5ed10ab060f$export$2e2bcd8739ae039);
let $b65ac5ed10ab060f$var$script;




let $b65ac5ed10ab060f$var$initialize = ()=>{
    $b65ac5ed10ab060f$var$script = (parcelRequire("6dTjz"));
    if ($b65ac5ed10ab060f$var$script.__esModule) $b65ac5ed10ab060f$var$script = $b65ac5ed10ab060f$var$script.default;
    $b65ac5ed10ab060f$var$script.render = (parcelRequire("aJ5ln")).render;
    $b65ac5ed10ab060f$var$script.__cssModules = {};
    (parcelRequire("ggyqH")).default($b65ac5ed10ab060f$var$script);
    $b65ac5ed10ab060f$var$script.__scopeId = 'data-v-2e1a7a';
    $b65ac5ed10ab060f$var$script.__file = "MediaArchive.vue";
};
$b65ac5ed10ab060f$var$initialize();
var $b65ac5ed10ab060f$export$2e2bcd8739ae039 = $b65ac5ed10ab060f$var$script;

});
parcelRegister("6dTjz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $487edd521c996bc3$export$2e2bcd8739ae039);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $gIp2w = parcelRequire("gIp2w");

var $aofyc = parcelRequire("aofyc");

var $kLbI9 = parcelRequire("kLbI9");

var $aUGso = parcelRequire("aUGso");

var $b5VZP = parcelRequire("b5VZP");

var $LXGYU = parcelRequire("LXGYU");

var $QlUa3 = parcelRequire("QlUa3");

var $5KPKG = parcelRequire("5KPKG");

var $iG6cs = parcelRequire("iG6cs");

var $g3bhh = parcelRequire("g3bhh");

var $71EKI = parcelRequire("71EKI");

var $dT1o1 = parcelRequire("dT1o1");
var $487edd521c996bc3$export$2e2bcd8739ae039 = {
    name: "MediaArchive",
    components: {
        BoxGeneric: $kLbI9.default,
        MediaArchiveFacetsApplied: $aUGso.default,
        MediaArchiveFacetsAvailable: $b5VZP.default,
        MediaArchiveSearchBox: $LXGYU.default,
        TransitionFade: $QlUa3.default,
        MediaMusicCircle: $5KPKG.default,
        MediaMusicLine: $iG6cs.default,
        MediaFilmCircle: $g3bhh.default,
        MediaFilmLine: $71EKI.default
    },
    props: {
        items: {
            type: Array,
            default: ()=>[]
        },
        fadeOut: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            scrollPosition: undefined,
            isScrollable: undefined
        };
    },
    computed: {
        ...(0, $aofyc.mapState)([
            "container"
        ]),
        ...(0, $aofyc.mapGetters)([
            "activeSeasonContentForSchoolLevel"
        ]),
        /**
     * Computes the header class for the BoxGeneric component.
     * Always includes the base "title-block" class.
     * If a school level is active, adds a modifier class based on its slug,
     * e.g., "title-block-onderbouw", "title-block-middenbouw", etc.
     */ computedHeaderClass () {
            const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
            return slug ? `title-block title-block-${slug}` : "title-block";
        },
        isMuziekArchiveRoute () {
            return this.$route.name === "MusicArchive";
        },
        isFilmArchiveRoute () {
            return this.$route.name === "FilmArchive";
        },
        // Single source of truth for types and query keys
        facetTypes () {
            // These facet types can be applied to the list of media archive items.
            // Each facet type is named by the media item property it filters by.
            return [
                "tags",
                "volumes",
                "seasons"
            ];
        },
        queryKeys () {
            // Here we map the above defined facet types
            // onto localized URL query string keys.
            return {
                tags: "tag",
                volumes: "jaargang",
                seasons: "aflevering"
            };
        },
        // Normalizing and filtering items
        normalizedItems () {
            // Normalize items to make them searchable.
            // Implemented as a getter to leverage caching.
            // Normalization lower-cases all characters
            // and removes diacritics and accents.
            return this.items.map((item)=>({
                    ...item,
                    // Normalize title
                    normalizedTitle: this.normalizeString(item.title),
                    // Normalize cuePoints if the item has any (currently: songs only).
                    ...Object.prototype.hasOwnProperty.call(item, "cuePoints") ? {
                        cuePoints: item.cuePoints.map((cuePoint)=>({
                                ...cuePoint,
                                // For each cuePoint, normalize its lyrics.
                                normalizedLyrics: this.normalizeString(cuePoint.lyrics)
                            }))
                    } : {}
                }));
        },
        filteredItems () {
            let items = this.normalizedItems;
            // Apply search query filters on title and,
            // if exists (currently not for video items), cue points.
            if (this.normalizedQuery) items = items.filter((item)=>this.matchesTitleSearch(item) || this.matchesCuePointsSearch(item));
            // Apply facet filters. For each of the facet types,
            // check if any facet item of that type has been applied,
            // and use the applied facet items to filter out all
            // non-matching media items.
            this.facetTypes.forEach((facetType)=>{
                if (this.appliedFacetSlugs[facetType].length) items = items.filter((item)=>this.matchesFacet(facetType, item));
            });
            return items;
        },
        // Handling the query string
        query: {
            // The query is taken straight from the URL.
            get () {
                return this.$route.query.zoek || "";
            },
            // When setting the query, it is set straight into the URL
            // by replacing the current route in-place.
            set (search) {
                this.$router.replace({
                    ...this.$route,
                    query: {
                        // Facets remain untouched.
                        ...this.$route.query,
                        // But the search query is updated.
                        zoek: search
                    }
                });
            }
        },
        normalizedQuery () {
            return this.normalizeString(this.query);
        },
        // Available facets
        availableFacetSlugs () {
            return (0, $gIp2w.reactive)(Object.fromEntries(// For each facet type, create a map onto the available facet items.
            // Available facet items are such that are present in the current
            // filtered list of media items, but not currently applied as filters.
            this.facetTypes.map((type)=>[
                    type,
                    (0, $xo6Zx.computed)(()=>this.makeAvailableFacetSlugs(type))
                ])));
        },
        availableFacetsRenderable () {
            // For each facet type, collect the available facet items,
            // and prepare their data for rendering, by resolving
            // data needed to render the facet item label,
            // and creating a computed route object.
            return this.facetTypes.map((type)=>({
                    type: type,
                    items: this.makeAvailableFacetRenderable(type)
                }))// Facet types without any facet items are left out.
            // Vue's list transition makes sure facet boxes
            // are nicely faded and moved out and in, depending
            // on which facet types have facet items available.
            .filter((facet)=>facet.items.length);
        },
        // Applied facets
        appliedFacetSlugs () {
            // For each facet type, get the applied facet slugs.
            // These applied facet slugs can be resolved
            // into applied facet items.
            return (0, $gIp2w.reactive)(Object.fromEntries(this.facetTypes.map((type)=>[
                    type,
                    (0, $xo6Zx.computed)(()=>this.makeAppliedFacetSlugs(type))
                ])));
        },
        appliedFacets () {
            return (0, $gIp2w.reactive)(Object.fromEntries(// For each facet type, traverse the applied
            // facet slug for that type and resolve
            // the corresponding facet item.
            this.facetTypes.map((type)=>[
                    type,
                    (0, $xo6Zx.computed)(()=>this.makeAppliedFacet(type))
                ])));
        },
        appliedFacetsRenderable () {
            // For each facet type, create renderables for its applied
            // facet items, by mapping data needed to render the label
            // and creating a computed route object. This route is used
            // to remove the given applied facet from the URL's query
            // string. The list is flattened, because all available
            // facets are rendered as one single list above the media.
            return this.facetTypes.flatMap((type)=>this.makeAppliedFacetRenderable(type));
        },
        // Data sources for resolving slugs into facet items
        resolveSources () {
            // This computed getter maps each facet type to the
            // data source of corresponding items. This means
            // that the resulting array per type can be used
            // to find a facet item for any given facet slug.
            return {
                tags: this.container?.tags,
                volumes: this.container?.volumes,
                seasons: [].concat(...this.container?.volumes?.map((volume)=>volume.seasons))
            };
        },
        // Fade out top/bottom of scrollable list into white.
        fadeOutTop () {
            if (!this.fadeOut || this.scrollPosition === undefined) return false;
            return this.scrollPosition > 0;
        },
        fadeOutBottom () {
            if (!this.fadeOut || this.scrollPosition === undefined || !this.isScrollable) return false;
            const scrollMax = this.$refs.scrollContainer?.scrollHeight - this.$refs.scrollContainer?.clientHeight;
            return this.scrollPosition / scrollMax * 100 < 100;
        }
    },
    watch: {
        filteredItems () {
            this.$nextTick(()=>{
                this.checkIsScrollable();
                this.onScroll();
            });
        }
    },
    mounted () {
        this.$nextTick(()=>{
            this.checkIsScrollable();
            this.onScroll();
        });
    },
    methods: {
        // String normalization
        normalizeString (s) {
            // Normalizing Unicode characters (e.g. ë -> e)
            // to prepare for search.
            return s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        },
        // Search string matching
        matchesTitleSearch (item) {
            // Checking a media item's normalized title
            // against the current normalized search string.
            return item.normalizedTitle.includes(this.normalizedQuery);
        },
        matchesCuePointsSearch (item) {
            // Checking a song's cue points' normalized lyrics lines
            // against the current normalized search string.
            return item.cuePoints?.some((cuePoint)=>cuePoint.normalizedLyrics.includes(this.normalizedQuery));
        },
        // Facets matching
        matchesFacet (facetType, item) {
            // Checking a media item's facetable property
            // against the given facet type's applied facets.
            // The media item may only pass the test if all
            // (`Array.prototype.every()`) of the type's facet items
            // match one of the facetable propertys.
            return this.appliedFacetSlugs[facetType].every(// Before checking for a match, the facetable property
            // is mapped to its own slug property, because the
            // facetable properties are rendered as references.
            // E.g. each of a video's volumes is a reference
            // object. The object's only key, `slug`, can
            // be used to resolve the actual volume from the container.
            // To understand this better, have a look at the JSON
            // data rendered by the controller and loaded into the app.
            (slug)=>item[facetType].map((facetItem)=>facetItem.slug).includes(slug));
        },
        // Resolving slug references to target items.
        resolve (type, slug) {
            // Resolve a given facet slug into the corresponding fact item.
            // E.g. the volume slug 'jaargang-26-2020-2021' is resolved
            // to the corresponding container's volume object
            // having the same slug string. All facetable properties
            // are only such reference objects, containing merely a `slug` key.
            return (0, $dT1o1.default)(this.resolveSources[type], slug);
        },
        // Available facets
        makeAvailableFacetSlugs (type) {
            // Collect unique facet type slugs of all items matching the currently applied filter.
            // `Set` is used to remove duplicates.
            // Each of the filtered media items gets all their reference slugs
            // for the given facet type extracted.
            // Then, slugs of already applied facets are removed.
            // The remaining facet slugs are 'available' to be applied,
            // reducing the set of filtered media items further.
            return [
                ...new Set([].concat(...this.filteredItems.map((item)=>item[type])).map(// Extract slug.
                (reference)=>reference.slug))
            ].filter(// Exclude items that are already applied.
            (slug)=>!this.appliedFacetSlugs[type].includes(slug));
        },
        makeAvailableFacetRenderable (type) {
            // For the given facet type, traverse all available facet slugs,
            // resolve their related facet items, to obtain the data
            // necessary for rendering a facet item label.
            // Then, create a computed route used to add the facet slug
            // to the set of applied facets.
            return this.availableFacetSlugs[type].map(// Resolve slug into full facet item.
            (slug)=>({
                    key: slug,
                    item: this.resolve(type, slug),
                    route: this.makeAvailableFacetRoute(type, slug)
                }));
        },
        makeAvailableFacetRoute (type, slug) {
            // Make a route for adding a specific facet item to the current set of filters.
            return (0, $xo6Zx.computed)(()=>({
                    // Keep route
                    ...this.$route,
                    // Modify query
                    query: {
                        // Re-use query (if any)
                        ...this.$route.query ?? {},
                        // But adding a new slug to the given facet type.
                        // E.g. for the "jaargang 26: 2020-2021" volume facet item,
                        // this adds 'jaargang=jaargang-26-2020-2021'
                        // to the query string of the new route.
                        [this.queryKeys[type]]: [
                            ...this.appliedFacetSlugs[type],
                            slug
                        ]
                    }
                }));
        },
        // Applied facets
        makeAppliedFacetSlugs (type) {
            // For the given facet type, extract all facet slugs from the
            // current route URL's query string.
            // A single route query item is a string, while multiple are an array.
            // Let's normalize that.
            const query = this.$route.query[this.queryKeys[type]] ?? [];
            // Remove duplicates.
            return [
                ...new Set(// Ensure array. (Might be string if only one item.)
                Array.isArray(query) ? query : [
                    query
                ])
            ].filter(// Remove empty items.
            (slug)=>!!slug.length);
        },
        makeAppliedFacet (type) {
            // For the given facet type, resolve all applied facet slugs
            // to the corresponding facet items.
            //
            // E.g. for the query segment 'aflevering=1e-kwartaal',
            // `type` would be 'seasons', and `slug` would be '1e-kwartaal'.
            // This slug would be resolved to the first season
            // found in all of the container's volumes' seasons.
            //
            // Note that anyway *any* first season of a volume would be
            // matched in the filtering stage, because filtering is done
            // based on the *reference slug* only! The resolved data
            // is merely used to render the facet label.
            // In this case, the season's `issueNumber`.
            return this.appliedFacetSlugs[type].map(// Resolve slug into full facet item.
            // E.g. if 'type' is 'volumes',
            // then resolve the given volume slug
            // into a volume object.
            (slug)=>this.resolve(type, slug));
        },
        makeAppliedFacetRenderable (type) {
            // For the given facet type, prepare all applied facets for rendering.
            // A route is created
            return this.appliedFacets[type].map((facetItem)=>({
                    type: // Prepare a single applied facet item for rendering.
                    type,
                    item: facetItem,
                    key: facetItem.slug,
                    route: this.makeAppliedFacetRoute(type, facetItem)
                }));
        },
        // Make a route for removing a specific facet item from the current set of filters.
        makeAppliedFacetRoute (type, facetItem) {
            return (0, $xo6Zx.computed)(()=>({
                    // Keep route
                    ...this.$route,
                    // Modify query
                    query: {
                        // Re-use query
                        ...this.$route.query,
                        // But modify the given facet type,
                        // removing the slug responsible for the facet item.
                        // E.g. for the "x tag: pasen" tag, this removes
                        // 'tag=pasen' from the query string of the new route.
                        [this.queryKeys[type]]: this.appliedFacetSlugs[type].filter((slug)=>facetItem.slug !== slug)
                    }
                }));
        },
        checkIsScrollable () {
            this.isScrollable = this.$refs.scrollContainer ? this.$refs.scrollContainer.scrollHeight > this.$refs.scrollContainer.clientHeight : undefined;
        },
        onScroll () {
            this.scrollPosition = this.$refs.scrollContainer ? Math.ceil(this.$refs.scrollContainer.scrollTop) : undefined;
        }
    }
};

});
parcelRegister("aUGso", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f2011653b1ec35e$export$2e2bcd8739ae039);
let $7f2011653b1ec35e$var$script;




let $7f2011653b1ec35e$var$initialize = ()=>{
    $7f2011653b1ec35e$var$script = (parcelRequire("izM0j"));
    if ($7f2011653b1ec35e$var$script.__esModule) $7f2011653b1ec35e$var$script = $7f2011653b1ec35e$var$script.default;
    $7f2011653b1ec35e$var$script.render = (parcelRequire("6t54f")).render;
    $7f2011653b1ec35e$var$script.__cssModules = {};
    (parcelRequire("3R37z")).default($7f2011653b1ec35e$var$script);
    $7f2011653b1ec35e$var$script.__scopeId = 'data-v-4e7af9';
    $7f2011653b1ec35e$var$script.__file = "MediaArchiveFacetsApplied.vue";
};
$7f2011653b1ec35e$var$initialize();
var $7f2011653b1ec35e$export$2e2bcd8739ae039 = $7f2011653b1ec35e$var$script;

});
parcelRegister("izM0j", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d860bb80c736e9e8$export$2e2bcd8739ae039);

var $gt6pA = parcelRequire("gt6pA");

var $QlUa3 = parcelRequire("QlUa3");

var $aofyc = parcelRequire("aofyc");
var $d860bb80c736e9e8$export$2e2bcd8739ae039 = {
    name: "MediaArchiveFacetsApplied",
    components: {
        RouterLinkButton: $gt6pA.default,
        TransitionFade: $QlUa3.default
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "activeSeasonContentForSchoolLevel"
        ]),
        computedSchoolLevelRouterLinkClass () {
            const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
            if (!slug) return "";
            const bgMap = {
                onderbouw: "bg-yellow-200 hover:bg-yellow",
                "midden-bovenbouw": "bg-yellowGreen-200 hover:bg-yellowGreen"
            };
            return bgMap[slug] || "";
        }
    },
    props: {
        items: {
            type: Array
        },
        query: {
            type: String
        }
    }
};

});

parcelRegister("6t54f", function(module, exports) {

$parcel$export(module.exports, "render", () => $4b5961d02e1514f0$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
var $jH5uA = parcelRequire("jH5uA");
const $4b5961d02e1514f0$var$_hoisted_1 = {
    key: 0,
    id: "facets-in-use",
    class: "w-full"
};
const $4b5961d02e1514f0$var$_hoisted_2 = {
    class: "wrap mt-[-1vh] pb-[30px]"
};
function $4b5961d02e1514f0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $xo6Zx.resolveComponent)("router-link");
    const _component_router_link_button = (0, $xo6Zx.resolveComponent)("router-link-button");
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_transition_fade, {
        duration: 500,
        appear: "",
        expand: ""
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                $props.items.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $4b5961d02e1514f0$var$_hoisted_1, [
                    (0, $xo6Zx.createElementVNode)("div", $4b5961d02e1514f0$var$_hoisted_2, [
                        _cache[1] || (_cache[1] = (0, $xo6Zx.createTextVNode)(" Resultaat verfijnd op: ", -1)),
                        (0, $xo6Zx.createVNode)((0, $jH5uA.TransitionGroup), {
                            name: "list-facets-applied",
                            tag: "div",
                            class: "contents"
                        }, {
                            default: (0, $xo6Zx.withCtx)(()=>[
                                    ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)($props.items, (facet)=>{
                                        return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_router_link, {
                                            key: facet.key,
                                            to: facet.route,
                                            class: (0, $d8ZDz.normalizeClass)([
                                                "facet-link rounded-full rounded-bl-none btn btn-circle before:content-['\xd7_'] before:font-black first:ml-[.4vw]",
                                                $options.computedSchoolLevelRouterLinkClass
                                            ])
                                        }, {
                                            default: (0, $xo6Zx.withCtx)(()=>[
                                                    (0, $xo6Zx.renderSlot)(_ctx.$slots, facet.type, {
                                                        item: facet.item
                                                    })
                                                ]),
                                            _: 2
                                        }, 1032, [
                                            "to",
                                            "class"
                                        ]);
                                    }), 128)),
                                    (0, $xo6Zx.createVNode)(_component_router_link_button, {
                                        key: "remove-all",
                                        to: {
                                            ..._ctx.$route,
                                            query: {
                                                zoek: $props.query
                                            }
                                        },
                                        variant: "removeAll"
                                    }, {
                                        default: (0, $xo6Zx.withCtx)(()=>[
                                                ..._cache[0] || (_cache[0] = [
                                                    (0, $xo6Zx.createTextVNode)(" Verwijder alle filters ", -1)
                                                ])
                                            ]),
                                        _: 1
                                    }, 8, [
                                        "to"
                                    ])
                                ]),
                            _: 3
                        })
                    ])
                ])) : (0, $xo6Zx.createCommentVNode)("", true)
            ]),
        _: 3
    });
}

});

parcelRegister("3R37z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ce8be1b56eb1244$export$2e2bcd8739ae039);
let $2ce8be1b56eb1244$var$NOOP = ()=>{};
var $2ce8be1b56eb1244$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("b5VZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $813d262a1a64b94f$export$2e2bcd8739ae039);
let $813d262a1a64b94f$var$script;




let $813d262a1a64b94f$var$initialize = ()=>{
    $813d262a1a64b94f$var$script = (parcelRequire("s8dKO"));
    if ($813d262a1a64b94f$var$script.__esModule) $813d262a1a64b94f$var$script = $813d262a1a64b94f$var$script.default;
    $813d262a1a64b94f$var$script.render = (parcelRequire("6w0fg")).render;
    $813d262a1a64b94f$var$script.__cssModules = {};
    (parcelRequire("9Gth8")).default($813d262a1a64b94f$var$script);
    $813d262a1a64b94f$var$script.__scopeId = 'data-v-1565df';
    $813d262a1a64b94f$var$script.__file = "MediaArchiveFacetsAvailable.vue";
};
$813d262a1a64b94f$var$initialize();
var $813d262a1a64b94f$export$2e2bcd8739ae039 = $813d262a1a64b94f$var$script;

});
parcelRegister("s8dKO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0548fe20978b0fc2$export$2e2bcd8739ae039);

var $4rzjj = parcelRequire("4rzjj");
var $0548fe20978b0fc2$export$2e2bcd8739ae039 = {
    name: "MediaArchiveFacetsAvailable",
    components: {
        MediaArchiveFacet: $4rzjj.default
    },
    props: {
        facets: {
            type: Array,
            default: ()=>[]
        }
    }
};

});
parcelRegister("4rzjj", function(module, exports) {

$parcel$export(module.exports, "default", () => $33c512f8b7f9c10e$export$2e2bcd8739ae039);
let $33c512f8b7f9c10e$var$script;



let $33c512f8b7f9c10e$var$initialize = ()=>{
    $33c512f8b7f9c10e$var$script = (parcelRequire("aD3Ko"));
    if ($33c512f8b7f9c10e$var$script.__esModule) $33c512f8b7f9c10e$var$script = $33c512f8b7f9c10e$var$script.default;
    $33c512f8b7f9c10e$var$script.render = (parcelRequire("5JsZx")).render;
    (parcelRequire("btAAn")).default($33c512f8b7f9c10e$var$script);
    $33c512f8b7f9c10e$var$script.__scopeId = 'data-v-5fd38b';
    $33c512f8b7f9c10e$var$script.__file = "MediaArchiveFacet.vue";
};
$33c512f8b7f9c10e$var$initialize();
var $33c512f8b7f9c10e$export$2e2bcd8739ae039 = $33c512f8b7f9c10e$var$script;

});
parcelRegister("aD3Ko", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7bd07409c5f29d5f$export$2e2bcd8739ae039);

var $kLbI9 = parcelRequire("kLbI9");

var $aofyc = parcelRequire("aofyc");
var $7bd07409c5f29d5f$export$2e2bcd8739ae039 = {
    name: "MediaArchiveFacet",
    components: {
        BoxGeneric: $kLbI9.default
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "routedSong"
        ]),
        ...(0, $aofyc.mapGetters)([
            "activeSeasonContentForSchoolLevel"
        ]),
        /**
     * Computes the header class for the BoxGeneric component.
     * Always includes the base "title-block" class.
     * If a school level is active, adds a modifier class based on its slug,
     * e.g., "title-block-onderbouw", "title-block-middenbouw", etc.
     */ computedHeaderClass () {
            const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
            return slug ? `title-block title-block-${slug}` : "title-block";
        },
        computedSchoolLevelBg () {
            const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
            if (!slug) return "";
            const bgMap = {
                onderbouw: "bg-yellow-200 hover:bg-yellow",
                "midden-bovenbouw": "bg-yellowGreen-200 hover:bg-yellowGreen"
            };
            return bgMap[slug] || "";
        }
    },
    props: {
        type: {
            type: String
        },
        label: {
            type: String
        },
        items: {
            type: Array,
            default: ()=>[]
        }
    }
};

});

parcelRegister("5JsZx", function(module, exports) {

$parcel$export(module.exports, "render", () => $42c7a4d554d2aee4$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $42c7a4d554d2aee4$var$_hoisted_1 = {
    class: "facet my-[2vh] mx-0"
};
const $42c7a4d554d2aee4$var$_hoisted_2 = {
    class: "facet-link-wrapper"
};
function $42c7a4d554d2aee4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $xo6Zx.resolveComponent)("router-link");
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $42c7a4d554d2aee4$var$_hoisted_1, [
        (0, $xo6Zx.createVNode)(_component_box_generic, {
            "w-stretch": "",
            "header-class": $options.computedHeaderClass
        }, {
            header: (0, $xo6Zx.withCtx)(()=>[
                    (0, $xo6Zx.renderSlot)(_ctx.$slots, $props.type + 'Label')
                ]),
            default: (0, $xo6Zx.withCtx)(()=>[
                    (0, $xo6Zx.createElementVNode)("div", $42c7a4d554d2aee4$var$_hoisted_2, [
                        ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)($props.items, (facetItem)=>{
                            return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_router_link, {
                                key: facetItem.key,
                                to: facetItem.route,
                                class: (0, $d8ZDz.normalizeClass)([
                                    "facet-link",
                                    $options.computedSchoolLevelBg
                                ])
                            }, {
                                default: (0, $xo6Zx.withCtx)(()=>[
                                        (0, $xo6Zx.renderSlot)(_ctx.$slots, $props.type, {
                                            item: facetItem.item
                                        })
                                    ]),
                                _: 2
                            }, 1032, [
                                "to",
                                "class"
                            ]);
                        }), 128))
                    ])
                ]),
            _: 3
        }, 8, [
            "header-class"
        ])
    ]);
}

});

parcelRegister("btAAn", function(module, exports) {

$parcel$export(module.exports, "default", () => $85aec84ce48ea856$export$2e2bcd8739ae039);
let $85aec84ce48ea856$var$NOOP = ()=>{};
var $85aec84ce48ea856$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("6w0fg", function(module, exports) {

$parcel$export(module.exports, "render", () => $4be5ebecfd6073b1$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
var $jH5uA = parcelRequire("jH5uA");
function $4be5ebecfd6073b1$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_media_archive_facet = (0, $xo6Zx.resolveComponent)("media-archive-facet");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)((0, $jH5uA.TransitionGroup), {
        name: "list-facets-available",
        tag: "div",
        class: "contents"
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)($props.facets, (facet)=>{
                    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_media_archive_facet, (0, $xo6Zx.mergeProps)({
                        key: facet.type
                    }, {
                        ref_for: true
                    }, facet), {
                        tagsLabel: (0, $xo6Zx.withCtx)(()=>[
                                ..._cache[0] || (_cache[0] = [
                                    (0, $xo6Zx.createTextVNode)("Zoek op domein", -1)
                                ])
                            ]),
                        tags: (0, $xo6Zx.withCtx)(({ item: tag })=>[
                                (0, $xo6Zx.createTextVNode)((0, $d8ZDz.toDisplayString)(tag.title), 1)
                            ]),
                        volumesLabel: (0, $xo6Zx.withCtx)(()=>[
                                ..._cache[1] || (_cache[1] = [
                                    (0, $xo6Zx.createTextVNode)("Jaargang", -1)
                                ])
                            ]),
                        volumes: (0, $xo6Zx.withCtx)(({ item: volume })=>[
                                (0, $xo6Zx.createTextVNode)(" jaargang " + (0, $d8ZDz.toDisplayString)(volume.volumeNumber) + ": " + (0, $d8ZDz.toDisplayString)(volume.title), 1)
                            ]),
                        seasonsLabel: (0, $xo6Zx.withCtx)(()=>[
                                ..._cache[2] || (_cache[2] = [
                                    (0, $xo6Zx.createTextVNode)("Aflevering", -1)
                                ])
                            ]),
                        seasons: (0, $xo6Zx.withCtx)(({ item: season })=>[
                                (0, $xo6Zx.createTextVNode)(" nummer " + (0, $d8ZDz.toDisplayString)(season.issueNumber), 1)
                            ]),
                        _: 1
                    }, 16);
                }), 128))
            ]),
        _: 1
    });
}

});

parcelRegister("9Gth8", function(module, exports) {

$parcel$export(module.exports, "default", () => $70cebec971ba9bfe$export$2e2bcd8739ae039);
let $70cebec971ba9bfe$var$NOOP = ()=>{};
var $70cebec971ba9bfe$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("LXGYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0902b189c8fa7a21$export$2e2bcd8739ae039);
let $0902b189c8fa7a21$var$script;



let $0902b189c8fa7a21$var$initialize = ()=>{
    $0902b189c8fa7a21$var$script = (parcelRequire("bczc9"));
    if ($0902b189c8fa7a21$var$script.__esModule) $0902b189c8fa7a21$var$script = $0902b189c8fa7a21$var$script.default;
    $0902b189c8fa7a21$var$script.render = (parcelRequire("02KHI")).render;
    (parcelRequire("cJ8dh")).default($0902b189c8fa7a21$var$script);
    $0902b189c8fa7a21$var$script.__scopeId = 'data-v-0b7b08';
    $0902b189c8fa7a21$var$script.__file = "MediaArchiveSearchBox.vue";
};
$0902b189c8fa7a21$var$initialize();
var $0902b189c8fa7a21$export$2e2bcd8739ae039 = $0902b189c8fa7a21$var$script;

});
parcelRegister("bczc9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $827c1db1813ac503$export$2e2bcd8739ae039);

var $kLbI9 = parcelRequire("kLbI9");

var $QlUa3 = parcelRequire("QlUa3");

var $aofyc = parcelRequire("aofyc");
var $827c1db1813ac503$export$2e2bcd8739ae039 = {
    name: "MediaArchiveSearchBox",
    components: {
        TransitionFade: $QlUa3.default,
        BoxGeneric: $kLbI9.default
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "routedSong"
        ]),
        ...(0, $aofyc.mapGetters)([
            "activeSeasonContentForSchoolLevel"
        ]),
        /**
     * Computes the header class for the BoxGeneric component.
     * Always includes the base "title-block" class.
     * If a school level is active, adds a modifier class based on its slug,
     * e.g., "title-block-onderbouw", "title-block-middenbouw", etc.
     */ computedHeaderClass () {
            const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
            return slug ? `title-block title-block-${slug}` : "title-block";
        },
        computedInputClass () {
            const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
            if (!slug) return "";
            const bgMap = {
                onderbouw: "border-b-green border-l-green",
                "midden-bovenbouw": "border-b-purple border-l-purple"
            };
            return bgMap[slug] || "";
        }
    },
    props: {
        label: {
            type: String
        },
        modelValue: {
            type: String
        }
    },
    emits: [
        "update:modelValue"
    ],
    mounted () {
        this.$refs.query.focus();
    }
};

});

parcelRegister("02KHI", function(module, exports) {

$parcel$export(module.exports, "render", () => $000222bff8a358bb$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
var $jH5uA = parcelRequire("jH5uA");
const $000222bff8a358bb$var$_hoisted_1 = {
    class: "grow"
};
const $000222bff8a358bb$var$_hoisted_2 = {
    class: "relative"
};
const $000222bff8a358bb$var$_hoisted_3 = [
    "value"
];
const $000222bff8a358bb$var$_hoisted_4 = {
    key: 1,
    width: "20",
    height: "21",
    fill: "none",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    class: "absolute right-0 inset-y-0 w-8 h-full py-2 text-almostBlack text-opacity-25 stroke-current stroke-2 pointer-events-none"
};
function $000222bff8a358bb$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_box_generic, {
        "w-stretch": "",
        header: $props.label,
        "header-class": $options.computedHeaderClass
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                (0, $xo6Zx.createElementVNode)("div", $000222bff8a358bb$var$_hoisted_1, [
                    (0, $xo6Zx.createElementVNode)("form", $000222bff8a358bb$var$_hoisted_2, [
                        (0, $xo6Zx.createElementVNode)("input", {
                            type: "text",
                            ref: "query",
                            value: $props.modelValue,
                            onKeydown: [
                                _cache[0] || (_cache[0] = (0, $jH5uA.withKeys)(($event)=>_ctx.$emit('update:modelValue', ''), [
                                    "esc"
                                ])),
                                _cache[1] || (_cache[1] = (0, $jH5uA.withKeys)((0, $jH5uA.withModifiers)(()=>{}, [
                                    "prevent"
                                ]), [
                                    "enter"
                                ]))
                            ],
                            onInput: _cache[2] || (_cache[2] = ($event)=>_ctx.$emit('update:modelValue', $event.target.value)),
                            class: (0, $d8ZDz.normalizeClass)([
                                "w-full focus:outline-none border border-solid border-t-white border-r-white box-border font-light p-[7px] pr-[36px]",
                                $options.computedInputClass
                            ])
                        }, null, 42, $000222bff8a358bb$var$_hoisted_3),
                        (0, $xo6Zx.createVNode)(_component_transition_fade, {
                            duration: 200
                        }, {
                            default: (0, $xo6Zx.withCtx)(()=>[
                                    $props.modelValue.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("input", {
                                        key: 0,
                                        type: "button",
                                        value: "\xd7",
                                        onClick: _cache[3] || (_cache[3] = (0, $jH5uA.withModifiers)(($event)=>_ctx.$emit('update:modelValue', ''), [
                                            "prevent"
                                        ])),
                                        class: "absolute right-0 py-1 px-3 text-2xl bg-transparent cursor-pointer opacity-75 hover:opacity-100 transition-opacity duration-200"
                                    })) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("svg", $000222bff8a358bb$var$_hoisted_4, [
                                        ..._cache[4] || (_cache[4] = [
                                            (0, $xo6Zx.createElementVNode)("circle", {
                                                cx: "7",
                                                cy: "7",
                                                r: "6"
                                            }, null, -1),
                                            (0, $xo6Zx.createElementVNode)("line", {
                                                x1: "11.4512",
                                                y1: "11.537",
                                                x2: "19.2294",
                                                y2: "19.3152"
                                            }, null, -1)
                                        ])
                                    ]))
                                ]),
                            _: 1
                        })
                    ])
                ])
            ]),
        _: 1
    }, 8, [
        "header",
        "header-class"
    ]);
}

});

parcelRegister("cJ8dh", function(module, exports) {

$parcel$export(module.exports, "default", () => $94400efb66ac9fea$export$2e2bcd8739ae039);
let $94400efb66ac9fea$var$NOOP = ()=>{};
var $94400efb66ac9fea$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("5KPKG", function(module, exports) {

$parcel$export(module.exports, "default", () => $4309647c12532768$export$2e2bcd8739ae039);
let $4309647c12532768$var$script;



let $4309647c12532768$var$initialize = ()=>{
    $4309647c12532768$var$script = (parcelRequire("4ZGCE"));
    if ($4309647c12532768$var$script.__esModule) $4309647c12532768$var$script = $4309647c12532768$var$script.default;
    $4309647c12532768$var$script.render = (parcelRequire("7Lgjt")).render;
    (parcelRequire("6sHos")).default($4309647c12532768$var$script);
    $4309647c12532768$var$script.__scopeId = 'data-v-0680cc';
    $4309647c12532768$var$script.__file = "MediaMusicCircle.vue";
};
$4309647c12532768$var$initialize();
var $4309647c12532768$export$2e2bcd8739ae039 = $4309647c12532768$var$script;

});
parcelRegister("4ZGCE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3a2debd577abc82f$export$2e2bcd8739ae039);
var $3a2debd577abc82f$export$2e2bcd8739ae039 = {
    props: {
        color: {
            type: String,
            default: "#127b5d"
        }
    }
};

});

parcelRegister("7Lgjt", function(module, exports) {

$parcel$export(module.exports, "render", () => $5a6993a5301ff22a$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $5a6993a5301ff22a$var$_hoisted_1 = [
    "fill"
];
function $5a6993a5301ff22a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("svg", {
        "aria-hidden": "true",
        width: "90px",
        height: "90px",
        viewBox: "0 0 100.11 100.11",
        class: (0, $d8ZDz.normalizeClass)(_ctx.$attrs.class)
    }, [
        (0, $xo6Zx.createElementVNode)("path", {
            fill: $props.color,
            d: "M50.05,100.17C22.41,100.17,0,77.76,0,50.12S22.41.07,50.05.07s50.05,22.41,50.05,50.05-22.41,50.05-50.05,50.05"
        }, null, 8, $5a6993a5301ff22a$var$_hoisted_1),
        _cache[0] || (_cache[0] = (0, $xo6Zx.createElementVNode)("path", {
            fill: "#fff",
            d: "M33.22,64.61h-.1c-6.11,0-11.08,3.95-11.12,8.84-.03,4.92,4.94,8.96,11.09,9.01h.1\n         c6.11,0,11.08-3.95,11.12-8.84,0-.02,0-.03,0-.05,0-.01,0-.02,0-.03v-36.55l22.32-11.16v27.24\n         c-1.85-1.13-4.13-1.83-6.63-1.84h-.1\n         c-6.1,0-11.08,3.95-11.12,8.84-.03,4.92,4.94,8.96,11.09,9.01h.1\n         c6.11,0,11.08-3.95,11.12-8.84,0-.02,0-.03,0-.05,0-.01,0-.02,0-.03V22.22\n         c0-.77-.4-1.49-1.06-1.9-.66-.4-1.48-.44-2.17-.1l-26.78,13.39\n         c-.76.38-1.23,1.15-1.23,1.99v30.85\n         c-1.85-1.13-4.13-1.83-6.63-1.84"
        }, null, -1))
    ], 2);
}

});

parcelRegister("6sHos", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b4704a5ab4ba53d$export$2e2bcd8739ae039);
let $4b4704a5ab4ba53d$var$NOOP = ()=>{};
var $4b4704a5ab4ba53d$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("iG6cs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d990f56b17bc95fd$export$2e2bcd8739ae039);
let $d990f56b17bc95fd$var$script;



let $d990f56b17bc95fd$var$initialize = ()=>{
    $d990f56b17bc95fd$var$script = (parcelRequire("g8FnQ"));
    if ($d990f56b17bc95fd$var$script.__esModule) $d990f56b17bc95fd$var$script = $d990f56b17bc95fd$var$script.default;
    $d990f56b17bc95fd$var$script.render = (parcelRequire("ccC06")).render;
    (parcelRequire("6JVVc")).default($d990f56b17bc95fd$var$script);
    $d990f56b17bc95fd$var$script.__scopeId = 'data-v-973c12';
    $d990f56b17bc95fd$var$script.__file = "MediaMusicLine.vue";
};
$d990f56b17bc95fd$var$initialize();
var $d990f56b17bc95fd$export$2e2bcd8739ae039 = $d990f56b17bc95fd$var$script;

});
parcelRegister("g8FnQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bbfd7ea0eed16583$export$2e2bcd8739ae039);
var $bbfd7ea0eed16583$export$2e2bcd8739ae039 = {
    props: {
        color: {
            type: String,
            default: "#127b5d"
        }
    }
};

});

parcelRegister("ccC06", function(module, exports) {

$parcel$export(module.exports, "render", () => $8e24152850ef1440$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $8e24152850ef1440$var$_hoisted_1 = [
    "fill"
];
function $8e24152850ef1440$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("svg", {
        "aria-hidden": "true",
        width: "350px",
        height: "166px",
        viewBox: "0 0 935.01 442.84",
        class: (0, $d8ZDz.normalizeClass)(_ctx.$attrs.class)
    }, [
        (0, $xo6Zx.createElementVNode)("path", {
            fill: $props.color,
            d: "M185.64 381.65c.36.47.52.63 1.13.65 1.8.06 5.05-1.22 7.13-1.39 27.95-2.33 46.15 10.59 70.77 19.72 51.9 19.24 122.52 25.68 166.98-13.47 18.44-16.24 33.46-48.25 32.02-73.03-.11-1.81-.65-6.87-1.1-8.4-.11-.36-.42-.57-.68-.81-2.28 2.66-4.79 4.43-7.73 6.26-2.63 1.64-3.8 2.46-6.28 4.22-17.55 12.39-58.64 5.01-55.68-22.18 1.13-10.36 10.63-16.6 19.93-19.07 19.06-5.05 40.66 1.99 49.51 20.25l1.77-1.47c1.92-12.01.99-24.17 1.2-36.3.24-14.07.48-28.39 1.04-42.46 1.72-28.33-2.37-59.55-.04-87.54.1-1.2.2-3.06 1.36-3.64l119.45-22.64c1.13.92.77 8.83.73 10.82-.63 27.07-.68 54.39-1.04 81.46s.47 54.76-3.46 81.56c-.5 3.44 3.78 7.53 6.22 9.73 32.89 29.7 102.53 20.21 137.92-1.11 31.79-19.15 58.67-59.2 53.85-97.66-.12-.93-1.12-4.96-1.76-5.24-1.63 2.4-3.87 4.49-6 6.5-1.8 1.7-4.37 4.16-6.24 5.76-16.19 13.77-64.7 3.41-54.75-23.75 8.48-23.14 49.73-19.93 64.23-2.75.82.97 3.1 5.96 4.26 4.24 2.07-4.94 1.92-9.62 2.26-14.74 3.05-46.57.4-95.06 2.02-141.98.15-4.29-.54-8.96.45-13.05.91-.64 11.68 1.49 13.65 1.92 17.22 3.72 38.84 14.36 40.82 34.18 1.48 14.82-6.05 53.24 17.81 53.24 17.18 0 29.64-23.53 43.88-21.43 9.11 1.35 17.97 12.47 26.56 12.32 1.96-.03 4.38-1.21 6.47-.97 2.84 3.3-3.68 4.37-6 4.49-14.15.73-21.32-18.98-37.13-9.67-12.36 7.27-22.56 22.41-39.46 17.88-20.82-5.58-13.65-37.69-15.14-53.36-2.21-23.12-28.79-33.58-48.94-34.81-.17 21.91.23 43.85.02 65.77-.13 14.22-.83 28.74-1.04 42.96-.24 16.15 1.54 35.79-1.1 51.4-.51 2.99-3.81 10.12-3.84 11.61-.02 1.34 1.54 4.96 1.83 6.63 7.47 43.41-25.56 89.5-63.19 108.06-36.55 18.04-104.46 25.31-135.65-5.84-.8-.8-3.51-4.66-4.3-4.57-1.46 1.88-3.16 3.97-5 5.46-2.49 2.02-5.19 2.79-7.61 4.39-1.99 1.31-3.56 3.42-5.78 4.72-13.82 8.08-49.45 3.01-52.31-15.88-3.82-25.2 27.33-31.1 45.96-25.46 12.42 3.76 14.95 9.39 23.1 17.4.44.43.42 1.1 1.4.84 1.56-8.53 1.1-17.17 1.48-25.77 1.45-32.97 1.71-66.43 2.04-99.46.14-14.09-.15-28.19-.02-42.27l-114.01 22.24-.52 1.48c-.22 42.99-.15 86.09-.99 129.01-.24 12.13.89 26.56-1.71 38.29-.37 1.67-1.73 3.72-1.8 5.24-.1 2.2 1.79 6.74 2.03 9.5 2.34 27.36-10.95 59.99-30.98 78.5-43.9 40.56-114.21 35.8-166.98 17.47-25.19-8.75-51.39-26.5-79.15-20.61-.88.19-3.54.91-3.8 1.7-.35 5.8.22 11.66-.05 17.45-.53 11.38-2.45 32.4-14.53 37.47-9.2 3.87-18.62-2.14-21.25-11.23-4.95-17.07 7.45-34.22 21.75-42.27 3.38-1.9 7.1-3.1 10.44-5.06l.35-32.21c-.63-1.91-5.67-2.6-7.62-3.38-5.6-2.24-9.67-4.5-14.62-7.88-1.13-.77-3.09-2.97-4.07-3.43-1.84-.87-5.49-.86-7.59-1.41-15.99-4.25-28.58-12.8-33.41-29.34h-1.44c-6.96 14.54-13.2 31.69-23.78 43.99-27.62 32.09-61.09-16.45-84.51 8.49-.99 1.05-2.79 5.29-4.7 3.96-3.22-2.25 5.81-9.71 7.8-10.86 19.21-11.1 38.76 5.44 57.41 6.89 25.15 1.96 37.18-41.61 47.53-58.49-4.54-28.41 11.85-56.24 28.72-77.74 9.91-12.62 22.02-24.23 31.74-36.76 3.41-4.4 3.05-6.15 2.76-11.78-1.03-19.86-6.7-57.43 3.48-74.48 8.95-15 27-10.1 31.47 5.53 4.74 16.53-7.59 43.88-16.46 57.98-4.48 7.12-10.01 13.41-14.49 20.51-.52 3.89.67 7.67.97 11.48 1.25 15.83 2.2 31.63 2.98 47.52.12 2.37.86 4.88.59 7.4.17.61.57.8 1.17.84 2.2.15 7.87-1.66 10.57-1.95 29.47-3.15 65.94 7.58 73.45 39.93 6.56 28.25-12.09 50.07-37.51 59.02-15.36 5.41-31.17 6.1-47.26 3.99v30.75Zm-5.49-205.25c.39.29 3.78-4 4.2-4.54 11.68-15.27 26.61-43.08 24.79-62.7-1.12-12.02-13.95-22.71-23.75-11.76-12.14 13.56-7 52.17-5.75 69.76.22 3.08-.46 6.27.51 9.24Zm578.99 15.5c-11.11 1.57-30.36-1.82-36.62-12.13-3.95-6.51-1.87-13.04 4.62-16.63 12.63-6.99 40.84-3.65 44.29 13.23.28 1.36-.27 5.89 1.46 5.53 4.26-4.89 6.16-5.46 2.47-11.46-10.18-16.55-40.69-20.5-55.21-7.8-9.53 8.33-7.13 20.55 3.16 26.85 8.38 5.13 25.56 7.03 34.66 3.45.71-.28 1.46.49 1.18-1.04Zm-19.1-28.85c-8.16.68-21.41 5.43-14.12 15.82 6.32 9 27.42 11.94 37.21 8.77 7.44-2.41 6.63-8.77 3.02-14.5-5.17-8.22-17.01-10.85-26.11-10.09Zm-562.4 23.85c-.49-.58-2.86 2.07-3.25 2.49-18.89 19.77-44.46 49.69-53.62 75.38-3.34 9.37-5.54 19.15-4.62 29.12.99.26.97-.41 1.4-.84 1.69-1.65 3.22-4.32 4.84-6.16 15.47-17.63 36.52-29.57 59.03-35.97.6-21.44-2.9-42.68-3.77-64.02Zm8 66.5v12.25c0 .3.74.7 1.2.73 1.63.1 5.1-.91 7.03-1 19.98-.91 53.69 5.2 49.74 32.24-2.53 17.31-28.15 28.65-42.87 33.13-4.82 1.47-9.93 2.4-14.65 3.85v12.1c3.45 1.37 8.94 2.01 12.78 2.23 28.31 1.6 67.27-14.42 69.29-46.75 2.32-37.08-35.23-53.95-67.26-51.26l-15.26 2.49Zm385 23.25c.39 2.05-.28 5.07 0 7.25 2.42-.06 7.57-5.53 7.37-7.68-.37-3.88-10.73-13.47-14.3-15.64-14.02-8.51-46.38-9.87-50.72 10.42-4.43 20.77 28.14 27.03 42.63 22.63.91-.28 2.6-.8 3.01-1.73-12.57.66-39.87-1.77-39.54-19.25.24-12.88 20.49-14.26 29.75-12.71 8.17 1.36 20.1 7.82 21.79 16.71Zm-391.13-21.64c-19.53 3.95-50.47 25.07-60.78 42.23-2.23 3.71-1.18 5.25.18 9.14 4.54 12.92 17.73 23.4 31.34 25.18.37.05 1.42.43 1.38-.4-.01-.25-2.59-3.08-3.1-3.89-14.64-23.14-4.55-44.7 19.02-55.21 2.24-1 14.16-4.75 14.64-5.36 1.08-1.39-.01-2.67-.04-4.05-.05-2.31.1-4.62-.07-6.92l-.75-.77c-.62-.18-1.2-.07-1.81.05Zm356 8.01c-2.9.39-9.15 2.69-11.14 4.86-2.57 2.79-2.13 6.94-.58 10.13 4.84 9.95 28.06 11.65 37.54 9.83 6.49-1.24 7.4-6.4 5.19-12.07-4.31-11.06-20.54-14.15-31.01-12.75Zm-349.87 7.63v59.5c0 .36 1.09.99 1.62.67 17.33-4.05 53.41-15.49 53.4-37.67 0-21.6-32.85-25.57-48.77-24.24-1.12.09-5.96.8-6.26 1.74Zm-3 59.5v-58.5c0-.52-1.11-.77-1.69-.74-1.61.09-6.9 2.13-8.7 2.84-20.42 8.1-34.18 24.89-23.46 47.25 1.6 3.34 6.83 11.46 10.59 11.91 6.9.82 15.03-.45 21.93-1.09.46-.15 1.25-1.26 1.33-1.67Zm271-30.5c.34 2.16-.24 5 0 7.25 2.69-.29 7.49-5.42 6.78-8.01-2.68-9.82-16.17-19.51-25.66-21.87-15.7-3.91-41.83 1.7-39.08 22.58 1.88 14.3 23.88 19.18 35.7 18.28 3.02-.23 7.97-.93 10.26-2.99-11.52.32-35.08-1.22-38.85-14.9-4.7-17.05 18.91-19.14 30.38-16.88 7.66 1.51 19.15 8.06 20.48 16.52Zm-43.8 5.03c7.62 6.11 25.63 7.92 35.02 6.19 6.37-1.17 6.67-7.37 4.52-12.46-5.42-12.88-27.59-15.64-38.76-9.78-6.98 3.67-6.43 11.52-.78 16.05Zm-227.2 40.47v-9.5c0-1.43-4.69.14-5.76.24-4.7.45-9.56.3-14.25.76.02.96 2.71 2.43 3.54 2.96 2.46 1.56 13.36 6.96 15.63 6.23.28-.09.75-.45.83-.69Zm-.5 42.25c-16.42 4.61-33.26 22.48-29.38 40.63 2.16 10.12 13.39 15.9 21.14 7.37 8.44-9.29 7.94-27.81 8.22-39.78.06-2.7 1.16-5.31.02-8.23Z"
        }, null, 8, $8e24152850ef1440$var$_hoisted_1)
    ], 2);
}

});

parcelRegister("6JVVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e83e00ec64326a8$export$2e2bcd8739ae039);
let $4e83e00ec64326a8$var$NOOP = ()=>{};
var $4e83e00ec64326a8$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("71EKI", function(module, exports) {

$parcel$export(module.exports, "default", () => $51d83d0197baa1d8$export$2e2bcd8739ae039);
let $51d83d0197baa1d8$var$script;



let $51d83d0197baa1d8$var$initialize = ()=>{
    $51d83d0197baa1d8$var$script = (parcelRequire("a6HWm"));
    if ($51d83d0197baa1d8$var$script.__esModule) $51d83d0197baa1d8$var$script = $51d83d0197baa1d8$var$script.default;
    $51d83d0197baa1d8$var$script.render = (parcelRequire("bxCpO")).render;
    (parcelRequire("ipJFg")).default($51d83d0197baa1d8$var$script);
    $51d83d0197baa1d8$var$script.__scopeId = 'data-v-23b9fc';
    $51d83d0197baa1d8$var$script.__file = "MediaFilmLine.vue";
};
$51d83d0197baa1d8$var$initialize();
var $51d83d0197baa1d8$export$2e2bcd8739ae039 = $51d83d0197baa1d8$var$script;

});
parcelRegister("a6HWm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $75bc8c8a72a4b9ac$export$2e2bcd8739ae039);
var $75bc8c8a72a4b9ac$export$2e2bcd8739ae039 = {
    props: {
        color: {
            type: String,
            default: "#38795f"
        }
    }
};

});

parcelRegister("bxCpO", function(module, exports) {

$parcel$export(module.exports, "render", () => $867093479b92afee$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $867093479b92afee$var$_hoisted_1 = {
    transform: 'rotate(-5, 463.355, 221.42)'
};
const $867093479b92afee$var$_hoisted_2 = [
    "fill"
];
function $867093479b92afee$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("svg", {
        "aria-hidden": "true",
        width: "350px",
        height: "166px",
        viewBox: "0 0 926.71 442.84",
        class: (0, $d8ZDz.normalizeClass)(_ctx.$attrs.class)
    }, [
        (0, $xo6Zx.createElementVNode)("g", $867093479b92afee$var$_hoisted_1, [
            (0, $xo6Zx.createElementVNode)("path", {
                fill: $props.color,
                d: "M118.33,370.22c-21.83,0-41.21-8.29-54.57-23.35-3.28-3.7-6.09-7.83-8.8-11.83-5.14-7.57-10.45-15.39-19.04-20.19-10.11-5.65-21.79-6.42-31.87-6.42-1.29,0-2.57.01-3.85.04h-.2s0-2.89,0-2.89h.09c2.27-.08,4.22-.12,6.08-.12,9.38,0,21.53.82,32.26,7.23,8.47,5.06,13.38,12.27,18.58,19.91,2.56,3.76,5.21,7.66,8.32,11.25,13.02,15.03,31.82,23.31,52.94,23.31,23.1,0,45.7-10.11,60.44-27.04.84-.96,1.91-2.43,3.16-4.14,3.46-4.74,7.76-10.64,11.06-11.31.38-.08.84-.11,1.47-.11.41,0,.85.02,1.29.03.52.02.98.04,1.4.04.98,0,1.57-.09,1.91-.3.56-.34,1.35-1.73,2.18-3.2,1.07-1.89,2.28-4.04,3.55-5.02,2.41-1.86,5.57-2.1,8.05-2.11l1.38-2.19-65.22,14.17c-11.39,5.54-26.66,12.03-43.54,12.96l-.53.03c-1.36.08-2.76.16-4.17.16-2.7,0-6.5-.27-8.33-2.57-1.18-1.48-1.45-3.66-.81-6.49,1.01-4.42,15.11-9.04,19.41-10.35,10.35-3.16,21.73-4.72,34.77-4.78l69.17-15.33c.06-.49.02-.58.02-.59l-.24.02c-.1,0-.25,0-.42-.08-.43-.17-.87-.29-1.33-.42-.93-.25-1.85-.5-2.71-1.1-1.05-.73-1.93-2.01-2.78-3.26-.92-1.35-1.79-2.62-2.8-3.12-1.01-.5-3.25-.78-5.62-1.08-3.77-.48-7.66-.98-8.05-2.47l.48-1.65h.06c5.12-.89,10.93-1.44,18.32-1.77h.02c.21,0,.36.01.52.03.21.02.38.04.54.04.28,0,.39-.06.43-.1.02-.02.03-.04.03-.07l-44.97-.5v-16.48h-10.55c-.38,0-.71-.15-.99-.43-1.26-1.31-1.09-5.43-.95-8.74.06-1.42.11-2.65.03-3.32h-.45c-.45.03-1.02.05-1.63.05-1.23,0-2.17-.08-2.89-.24-1.04-.23-1.56-.66-1.56-1.26v-40.54c-3.94-.4-8.29-.59-13.66-.59-2.63,0-5.22.04-7.4.08-.78.01-1.69.15-2.65.3-1.11.17-2.26.35-3.35.35-2.31,0-3.65-.84-4.19-2.65l-14.77.04c-1.2.45-3.13,2.37-5,4.23-2.37,2.35-4.81,4.78-6.35,4.78-.05,0-.1,0-.15,0-8.63-5.23-8.82-19.73-5.67-27.75.46-1.18,2.9-5.89,4.67-6.15l1.77.27c1.15.72,2.78,2.3,4.51,3.96,2.68,2.58,5.72,5.5,7.27,5.75.54.09,2.64.14,5.36.14,4.79,0,8.01-.16,8.24-.31.17-.12.23-.43.3-.75.08-.4.16-.82.48-1.06.58-.44,2.93-.63,7.62-.63,2.98,0,6.41.08,9.72.15,3.02.07,5.87.13,8.1.13,1.73,0,2.9-.04,3.59-.12l.23-.02c.61-.06,1.01-.1,1.35-.66l-.03-7.39c1.25-1.35,2.79-1.52,4.13-1.52.54,0,1.08.03,1.63.06.54.03,1.07.06,1.58.06.36,0,.72-.02,1.07-.06,5.17-.6,10.75-2.58,16.6-5.88l-11.57-.72c-22.28-1.36-42.7-11.46-54.61-27-10.06-13.11-13.53-29.08-10.05-46.18,2.87-14.1,10.27-25.96,21.38-34.3,10.19-7.65,23.01-11.86,36.1-11.86,21.91,0,41.04,11.51,51.17,30.8,3.86,7.34,6.27,16.93,6.61,26.3.38,10.3-1.78,19.55-6.09,26.06-3.26,4.92-3.95,6.32-6.53,11.5l-.14.28c-4.44,8.91-9.09,15.35-15.55,21.46.13,0,.26,0,.4,0,.52,0,1.08.04,1.65.07.59.04,1.18.07,1.73.07.92,0,1.58-.1,2.07-.33.53-.24,5.34-5.21,6.2-6.18,6.82-7.7,12.04-17.09,16.68-26.09.4-.59,1.28-.94,1.87-.94h.11c1.17.1,4.02,3.8,6.31,6.78.76.99,1.42,1.84,1.8,2.27,4.52,5.08,9.44,9.95,14.19,14.67,2.9,2.88,5.9,5.84,8.77,8.83l.98.42,9.89-.5c-.17-.34-.58-.55-.98-.74-.12-.06-.23-.11-.32-.16-1.5-.82-3.04-1.52-4.54-2.21-2.11-.97-4.29-1.96-6.45-3.31-23.45-14.61-33.63-41.44-25.93-68.35,7.49-26.2,29.33-43.12,55.63-43.12,2.65,0,5.38.17,8.11.5,15.32,1.87,28.92,9.92,38.3,22.66,10.54,14.32,14.73,32.77,11.48,50.63-2.94,16.14-17.67,39.5-36.64,39.5-.53,0-1.07-.02-1.61-.06-.85-.06-2.09-.38-3.28-.68-1.28-.33-2.6-.67-3.38-.67-.09,0-.18,0-.25.02-.62.08-2.79,1.16-4.7,2.11-1.43.71-2.74,1.36-3.48,1.65-2.72,1.07-5.74,1.99-8.51,2.61-.02.2-.05.55-.02.62h0s.18-.03.18-.03c.1,0,.25,0,.44.05,10.81,2.46,22.21,3.76,34.85,3.98.48.14,1.04,1.26,1.04,1.46v9.82l1.12-5.35c.14-.55.41-1.32,1.08-1.66.5-.25,2.26-.42,4.38-.42,1.62,0,6.91.12,6.91,1.6v8.49l.69.61,14.85-.06c.14,0,.23.11.32.22.02.03.05.06.08.09l1.52-3.71,69.09-31.97c.17-.04.31-.06.44-.06,1.14,0,1.78,1.1,2.22,2.06.33,30.57.59,66.11-.26,101.53v.09s-.09.1-.09.1c-.31.03-.53.04-.74.04-.63,0-1.26-.09-1.93-.28-1.89-.53-5.22-2.17-7.9-3.49-1.08-.53-2.03-1-2.79-1.35-19.38-8.98-37.15-17.61-52.81-25.65-.54-.28-1.07-.52-1.59-.76-2.2-1.02-4.08-1.9-5.25-4.41l-11.72-.14-2.13-2.56v10.69c0,.19-1.26,1.45-1.45,1.45h-11.49c-.45.31-.49.71-.55,1.31l-.02.23c-.38,3.28-.2,7.02-.02,10.64.16,3.3.33,6.7.07,9.78v.08s-.09.09-.09.09l-4.43.82v8.08l-.81.89-60.77.06,4.69.6,41.96,2c1.04.11,1.66.91,1.9,2.45.22,1.44.34,11.4-.66,12.27-.37.32-1.7.46-4.45.46-2.24,0-5.14-.09-7.94-.18h-.15c-3.23-.11-6.58-.21-9.49-.21-3.83,0-6.21.19-7.25.58l-.48,5.13c-.41.37-1.02.49-2.13.49-.67,0-1.43-.04-2.2-.08-.78-.04-1.56-.08-2.26-.08-.78,0-1.34.05-1.72.17-.37.15-5.49,5.06-5.77,5.53-.72,1.22-.26,2.28.22,3.39.23.54.48,1.11.6,1.72,1.05,5.02.08,7.96-1.38,12.42l-.29.89c.7-.09,1.39-.13,2.06-.13,3.33,0,6.14,1.09,7.9,3.07,1.62,1.83,2.3,4.36,1.95,7.33v.09s-.11.09-.11.09h-4.83s-3.74.6-3.74.6h12.73c1.81,0,5.35,3.17,5.75,5.14.23,1.13-.52,2.55-1.23,3.42-.68.83-1.44,1.33-2.02,1.33h-29.82l4.37.6h.55c3.13,0,6.23.15,9.23.3,2.92.14,5.94.29,8.91.29,4.95,0,11.48-.36,18.11-3.14,6.36-2.67,12.16-5.65,17.77-8.53,13.38-6.87,26.01-13.37,43.81-14.42,1.25-.08,2.53-.11,3.8-.11,22.59,0,41.77,12.05,60.31,23.69,18.06,11.35,36.74,23.08,58.17,23.08,9.47,0,18.8-2.2,28.52-6.73,12.55-5.85,22.25-15.97,31.63-25.76,10.83-11.3,21.06-21.98,35.19-26.38,6.67-2.08,13.65-2.98,19.83-3.76.17-6.73.09-13.54.01-20.11-.13-10.92-.26-22.19.73-33.19,2.04-9.49,8.7-10.64,17.19-11.16,5.74-.35,12.24-.52,19.86-.52,6.82,0,14.01.14,20.35.26,6.51.12,13.24.25,19.64.25,1.04,0,2.07,0,3.09-.01,9.35-.06,19.18-.32,28.68-.56,11.49-.3,23.38-.6,34.95-.6,9.94,0,18.58.23,26.41.7,15.33.91,20.85,6.2,21.9,20.94.93,13.01,1.27,50.59-3.42,62.12-5.33,13.12-22.75,14.22-38.65,14.22l-5.83-.02c-1.42,0-2.77,0-4.03.04-26.15.68-57.04,1.39-87.96,1.5-1.76,0-3.53.04-5.29.08h-.15c-1.98.05-3.96.09-5.93.09-5.86,0-12.74-.35-19.4-2.93-12.78-4.96-15.31-16.45-16.12-28.14l-3.12.74c.42,3.28.43,6.57.44,9.74.02,5.41.04,10.49,1.81,15.67,3.86,11.28,16.06,13.35,26.27,13.9,5.71.3,11.83.45,18.71.45,11.25,0,22.89-.4,34.14-.79h.17c8.27-.29,16.81-.58,24.92-.7,5.23-.08,10.45-.12,15.67-.16,8.12-.07,16.52-.14,24.81-.34,2.6-.06,5.19-.08,7.7-.09h.21c20.87-.1,38.89-.18,40.66-27.91l-.02-85.47c-1.65.16-3.36.42-5.03.67-2.32.35-4.71.71-6.99.83-11.05.6-23.21.88-38.24.88-9.52,0-19.24-.11-28.63-.22-9.35-.11-18.93-.22-28.26-.22-2.13,0-4.25,0-6.36.02-2.16.01-4.44.14-6.65.27-2.28.13-4.6.26-6.81.27-2.33.01-4.65.01-6.98.01-5.01,0-10.02-.02-15.03-.04-5.13-.02-10.17-.04-15.2-.04-11.04,0-19.54.1-27.55.33-1.82-.29-3.48-2.3-4.35-3.94-4.38-8.24-5.33-34.17-2.46-42.48,1.21-3.5,3.16-3.77,5.78-3.77h.56c1.63,0,3.22-.08,4.74-1.08-.58-1.09-1.96-2.41-3.41-3.79-2.43-2.32-5.18-4.94-5-7.33.08-1.02.68-1.93,1.8-2.71,5.77-4.02,20.58-8.8,28.53-11.36l1.55-.5c5.84-1.89,19.5-6.31,25.89-6.31.86,0,1.56.08,2.1.24.3.09.68.31.86.67.11.22.12.45.04.68-.17,2-5.61,4.57-9.58,6.44-1.51.71-2.79,1.32-3.44,1.73-.01.25.16.37.49.57.13.08.27.16.38.28.54.52,5.8,4.65,6.12,4.8.36.17.64.24.91.24.17,0,.35-.03.54-.09l16.59-5.56c-.82-.89-2.78-2.42-4.84-4.03-3.72-2.91-7.22-5.65-7.31-6.85-.03-.38.21-.99.49-1.27,1.23-1.21,14.88-5.65,17.07-6.3,3.89-1.17,13.42-3.89,17.79-3.89,1.22,0,1.96.21,2.25.65.54,2.42-1.79,3.85-3.49,4.9l-.38.23c-.58.36-1.89.98-3.41,1.71-2.11,1-4.95,2.35-5.56,2.94l7.83,6.35,18.2-5.24c.06-.54-.26-.83-.67-1.2-.1-.09-.19-.17-.28-.25-.59-.57-2.18-1.79-4.02-3.21-4.57-3.51-7.77-6.03-7.89-6.88l.49-1.24c2.19-.88,4.26-1.7,6.33-2.51,3.72-1.46,7.56-2.97,11.4-4.22.38-.12,1.48-.49,1.48-.49,3.3-1.11,8.83-2.97,11.65-2.97.32,0,.61.02.85.07.93.19,1.54.55,1.81,1.08.23.44.21.97-.06,1.58-.9,2.06-4.47,4.2-7.61,6.09-1.67,1.01-3.25,1.95-4.18,2.75.13.37,5.2,4.78,6.27,5.35.69.36.99.48,1.53.48.18,0,.4-.01.65-.04,2.41-.21,5.2-1.27,8.16-2.38,2.92-1.1,5.93-2.24,8.58-2.51.08-.46-.09-.57-.4-.76-.13-.08-.28-.18-.42-.32-.91-.92-2.51-2.15-4.2-3.47-2.56-1.99-5.2-4.04-6.01-5.38-.47-.78-.73-1.49-.45-2.39,2.75-.97,5.45-1.99,8.31-3.06,6.26-2.36,12.73-4.79,18.68-5.47l.38-.04c.79-.09,1.86-.22,2.86-.22,1.56,0,2.51.31,2.92.94.31.49.28,1.14-.09,1.96-.8,1.74-5.48,3.97-9.25,5.76-1.45.69-2.7,1.29-3.43,1.72-.11.06-.23.09-.34.11-.12.03-.25.06-.28.11-.01.02-.04.11.07.38.17.34,5.21,4.82,5.72,5.09.6.32.86.44,1.23.44.21,0,.45-.03.82-.09,2.48-.39,12.72-3.59,15.22-4.75.1-.05.2-.09.3-.13.35-.14.62-.24.82-.58-.1-.21-2.5-2.29-4.25-3.81-2.62-2.27-5.59-4.85-6.26-5.95l-.15-.24c-.33-.51-.61-.95-.1-1.76.68-1.07,15.27-4.97,16.68-5.06.37-.02.71-.03,1.04-.03,4.22,0,5.7,1.95,7.26,6.04.59,1.54,3.79,13.09,3.58,13.87-.14.49-.51.92-1.06,1.21-18.19,5.34-36.72,10.47-54.63,15.44-29.14,8.08-59.28,16.43-88.56,25.8-1.65.53-3.34,1.06-5.06,1.6-6.02,1.89-12.24,3.84-17.78,6.03-.15.06-.33.1-.51.14-.45.09-.67.17-.73.34l121.45-4.01c2.7.28,5.6.41,8.88.41,5.29,0,10.83-.36,16.2-.71,5.32-.35,10.83-.7,16.04-.7,3.53,0,6.62.16,9.44.49l.23.02c.62.06,1.2.13,1.64.84l.03,22.58c-1.13,1.36-2.93,1.4-4.51,1.43-.31,0-.6.01-.89.03-2.61.13-5.41.2-8.57.2-3.63,0-7.31-.08-10.86-.17-3.56-.08-7.23-.17-10.84-.17-2.36,0-4.48.04-6.48.11h-.09s-.1-.08-.1-.08c-.19-1,.07-1.81.38-2.54.82-1.96,2.44-4.15,4.01-6.27,1.51-2.04,3.07-4.13,3.97-6.08h-18.43l-10.59,15.15c-.99.58-5.33.92-8.81.92-2.88,0-4.49-.21-4.79-.62-.42-.58-.31-1.32-.14-1.84l9.21-13.6h-18.87l-10.72,15.76c-.97.64-5.97.86-9.11.86-1.54,0-2.7-.05-3.19-.14-.9-.17-1.38-.43-1.45-1.44l8.38-14.04c-.78,0-2.57-.02-2.57-.02-1.09,0-2.19-.01-3.28-.01-4.21,0-8.72.09-13.25.78l-9.51,14.01c-.79.62-6.34.84-9.66.84-1.57,0-2.71-.05-3.13-.13-.93-.18-1.35-.42-1.44-1.43-.08-1,2.28-4.65,4.37-7.88.93-1.43,1.73-2.67,2.07-3.32.05-.09.13-.24.23-.4.99-1.67.95-1.95.91-1.99l-22.5.54-11.47,17.09,168.73-1.99v21.93c20.46-4.87,39.61-16.92,55.38-34.84,3.59-4.08,7.55-8.87,11.75-13.94,20.94-25.31,49.61-59.96,78.33-62.56.47-.04.98-.06,1.57-.06s1.19.02,1.79.04c.64.02,1.22.04,1.8.04.36,0,.72,0,1.08-.03h.21s0,3.41,0,3.41h-.21c-.72-.05-1.44-.07-2.17-.07-14.08,0-26.18,7.4-32.14,11.81-16.7,12.36-30.15,28.63-43.16,44.37-6.3,7.62-12.8,15.48-19.56,22.77-15.54,16.74-35.46,28.4-54.67,32l.02,87.53c-1.68,29.01-19.41,29.34-41.85,29.76-1.84.03-3.72.07-5.62.12-19.31.53-38.96.69-57.96.85-5.73.05-11.37.09-17,.15-5.41.05-10.91.23-16.23.4-6.49.21-13.21.42-19.81.42-4.34,0-8.25-.09-11.94-.28-22.25-1.14-29.76-8.65-30.92-30.92-.11-2.01-.05-4.07,0-6.06.05-1.81.1-3.67.03-5.5-16.68.92-29.92,6.54-41.66,17.67-4.05,3.84-7.84,7.78-11.5,11.59-13.37,13.91-25.97,27.03-47.95,31.54-4.7.96-9.42,1.45-14.02,1.45-22.56,0-41.15-11.68-59.12-22.98-18.26-11.47-37.13-23.33-60.39-23.33-5.75,0-11.66.73-17.59,2.18-9.54,2.32-18.6,6.95-27.36,11.43-12.45,6.36-24.2,12.37-37.3,12.45h-1.24c-13.7,0-29.53-1.44-43.5-2.71l-3.75-.34c-1.96-.18-3.96-.42-5.89-.67l-.12-.02c-2.54-.32-5.16-.65-7.73-.82h-.08s-.09-.09-.09-.09c-.1-.94-.12-1.81.36-2.33.3-.33.75-.49,1.37-.49h.19c3.48-.21,7.23-.31,11.47-.31,6.23,0,12.65.23,18.86.45,6.23.22,12.65.45,18.84.45,5.57,0,10.4-.18,14.79-.56.66-.06,1.35-.23,2.06-.42.15-.04.32-.06.49-.06.08,0,.39.02.39.02.1-.02.15-.11.12-.55-.1-1.3-2.68-3.08-3.54-3.08h-53.47c-.9-.96-1.19-1.71-.94-2.33.44-1.11,2.52-1.34,4.19-1.53l.24-.03c8.87-1.02,18.65-1.53,28.1-2.02,3.06-.16,6.02-.31,8.89-.48.56-.03,1.11-.04,1.67-.04.64,0,1.28.01,1.92.03h.12c.6.02,1.19.03,1.78.03.36,0,.71,0,1.07-.02.04-.93-.26-1.76-.91-2.46-1.63-1.77-4.97-2.41-7.55-2.41-1.14,0-2.19.12-2.94.35-.37.11-.72.48-1.08.87-.33.35-.66.71-1.06.94-3.89,2.19-8.35,3.4-12.55,3.4-2.67,0-5.17-.48-7.42-1.42-.92-.39-1.97-1.21-2.9-1.94-.88-.69-1.71-1.34-2.19-1.43-.14-.03-.35-.04-.6-.04-1.65,0-5.17.46-6.06.75-1.74.56-3.06,2.85-4.33,5.07-1.26,2.19-2.44,4.25-4.01,4.6-.46.11-.97.15-1.6.15-.43,0-.86-.02-1.29-.05-.48-.03-.91-.05-1.34-.05s-.81.03-1.15.08c-2.76.43-7.4,6.73-10.78,11.33-1.28,1.73-2.34,3.18-3.12,4.07-14.95,17.12-38.19,27.35-62.18,27.35ZM203.93,287.45c.16.14.45.18.92.22.5.04,1.07.09,1.62.4.89.51,1.78,1.79,2.72,3.15,1.05,1.52,2.14,3.09,3.33,3.8,1.83,1.08,4.48,1.85,7.04,2.59,1.68.48,3.26.94,4.6,1.48l.22.09-.97,1.59-76.11,17.05c-25.83,1.21-43.55,5.21-51.26,11.58-1.46,1.21-2.06,2.67-1.65,4.02.44,1.44,1.98,2.46,4.01,2.65,1.01.09,2.1.14,3.23.14,11.01,0,25.42-4.26,34.41-7.91,1.59-.64,3.25-1.49,4.86-2.31,2.14-1.09,4.36-2.22,6.44-2.89,12.18-3.94,25.89-6.43,39.14-8.85,12.43-2.26,25.26-4.6,36.85-8.11l2.13.82-7.81,6.59c.42,0,.86-.01,1.31-.01,0,0,2.42.01,2.94.01,4.47,0,9.47-.23,12.28-2.92,2.03-1.95,3.03-5.03,2.74-8.47-.33-3.95-2.25-7.56-4.99-9.42-.36-.24-.93-.48-1.53-.73-1.29-.54-2.76-1.16-3-2.16-.11-.46.05-.96.48-1.47.47-.57,1.37-.85,2.66-.85,2.67,0,6.7,1.29,8.3,2.18.72.4,1.39,1,2.05,1.59.77.7,1.57,1.41,2.44,1.79.34-.09,1.84-1.79,3.06-3.15,1.41-1.58,2.86-3.21,3.61-3.55.47-.21,1.32-.32,2.6-.32.79,0,1.63.04,2.36.07.58.03,1.09.05,1.46.05.44,0,.52-.04.53-.04l.43-5.54h29.47v-8.54c-.77-.42-1.9-.66-3.53-.66-.65,0-1.31.04-1.97.07-.69.04-1.33.07-1.93.07-.22,0-.44,0-.65-.02-7.41-.38-14.96-.9-22.26-1.39l-.28-.02c-5.55-.38-11.3-.77-16.92-1.1-4.77-.28-9.59-.51-14.25-.73-11.3-.54-22.98-1.1-34.39-2.34h-.06s-.08-.07-.08-.07l-.54-1.31.72-1.39,109.09-.05.61-.69-.06-8.28,4.68-.52c.22-.33.02-6.46-.11-10.52-.14-4.24-.27-8.23-.09-9.57.09-.68.67-2.4,1.47-2.4h11.56c.19-2.4.06-5.03-.06-7.58-.14-2.87-.28-5.84.03-8.49.1-.9.32-2.76,1.86-2.84,1.31.03,2.2,2.51,2.92,4.5.26.72.48,1.33.67,1.71.09.18.2.4.31.65.39.83.97,2.07,1.52,2.33.51.2,1.38.29,2.73.29.88,0,1.85-.04,2.84-.08,1.05-.04,2.1-.08,3.08-.08,2.79,0,4.23.38,4.67,1.23.33.65.48,1.08.58,1.39.24.73.28.86,2.4,1.93,9.11,4.62,18.53,9.05,27.63,13.33,11.21,5.27,22.78,10.71,33.91,16.57l2.35.37-.03-95.66-66.42,30.98.67.67,59.25-26.06c.34-.04.59-.06.82-.06,2.16,0,2.43,1.33,2.6,3.36,1.08,12.82.59,26.64.12,40.01-.44,12.32-.89,25.05-.11,36.97-.08,2.32-.84,3.44-2.33,3.44-1.28,0-2.9-.88-4.33-1.65-.4-.22-.79-.43-1.16-.61-9.69-4.85-19.31-10.27-28.62-15.52-9.43-5.31-19.15-10.79-28.97-15.69-.36-.27-.9-1.01-.97-1.42v-19.57h-17.54c-.62,0-1.95-1.33-1.95-1.95v-8.55l-6.09-.32-.52.56-3.74,24.59-1.59,1.67-.19.04c-.49,0-.99-.54-1.25-.86-.25-.31-.62-.86-.62-1.13v-29.03h-.89c-8.72,0-18.22-1.03-29.03-3.16-1.26-.25-2.61-.67-3.92-1.07-1.77-.55-3.6-1.12-5.21-1.26-.47-.04-.95-.06-1.42-.06-1.86,0-3.79.29-5.66.57-1.9.29-3.87.58-5.8.58-.6,0-1.16-.03-1.71-.08.07.81,2.94,3.77,4.18,5.04.41.42.72.74.83.87,3.71,4.44,7.23,8.86,9.52,14.05.15.06.35.11.53.11.6,0,1.16-.62,1.7-1.22.35-.39.68-.76,1.04-.98,2.42-1.5,4.88-2.26,7.31-2.26,4.8,0,9.16,3.19,10.84,7.93,1.67,4.7.24,9.62-3.72,12.85-2.06,1.68-4.69,2.6-7.38,2.6-4.42,0-8.38-2.38-10.35-6.2-1.02-1.99-1.18-3.84-1.35-5.79-.1-1.13-.2-2.31-.49-3.52-.57-.12-1.26-.17-2.17-.17-.6,0-1.22.02-1.85.05-.65.02-1.32.05-1.97.05-2.13,0-4.47-.24-5.69-2.04-.42-.62-.67-1.18-.87-1.64-.42-.96-.64-1.44-1.75-1.44-.57,0-1.35.13-2.45.41-.25.18-.4.82-.54,1.45-.18.76-.36,1.55-.85,2.02-.76.72-2.42,1.17-4.35,1.17s-3.47-.4-4.27-1.05c-.55-.45-.79-1.29-1.03-2.09-.23-.78-.44-1.51-.86-1.66h-.04c-.24,0-.55-.03-.87-.06-.4-.04-.81-.08-1.21-.08-1.12,0-1.66.35-1.81,1.17-.78,4.23.49,5.09,2.59,6.52.71.48,1.51,1.03,2.35,1.79,11.93,10.8,18.24,25.33,17.77,40.91.07.05.97.36,5.91,1.11l.52.08c3.43.54,7.39.95,11.59,1.38,7.78.8,15.81,1.63,21.63,3.42,1.18.36,2.8.86,2.61,2.72l-.8.88-135.62.06v9.09h10.55c.19,0,1.45,1.26,1.45,1.45v15.54h77.01c.5,0,1.18.65,1.28,1.46.07.52-.07,1.45-1.76,1.9l-41.92,3.51ZM583.85,242.62c-.52,0-1.06,2.12-1.27,4.94-1.04,13.85-.71,34.3.02,47.45,1.16,20.64,8.62,28.37,28.52,29.57,4.54.27,9.38.4,14.81.4,9.22,0,18.76-.39,27.98-.76,6.92-.28,13.97-.57,20.66-.68,1.92-.03,3.89-.05,5.92-.05,4.35,0,8.8.06,13.5.12,4.84.07,9.85.13,14.85.13,10.66,0,24.33-.27,35.46-2.41,17.56-3.37,18-13.97,18.62-28.64.05-1.21.1-2.44.17-3.69l.15-2.89c.67-12.69,1.91-36.31-1.47-45.62-2.73-7.51-10.4-8.54-18.69-8.99-4.94-.27-10.21-.4-16.11-.4-8.01,0-16.17.24-24.06.47-7.37.22-14.93.44-22.29.47h-2.18c-9.27,0-19-.2-28.42-.4h-.14c-9.65-.21-19.63-.41-29.32-.41-10.69,0-19.82.26-27.89.79-6.16.41-12.15,1.47-14.23,6.47-.82,1.98-1.65,5.9-1.83,8.09v47s3.1,0,3.1,0c-.02-5.82,0-11.64,0-17.47.01-4.75.02-9.42.01-14.08,0-1.77-.07-3.52-.13-5.22-.13-3.46-.27-7.03.12-10.76.63-6.03,2.62-6.93,3.74-6.93,2.84,0,5.96,5.4,6.09,10.5.08,3.35,0,6.76-.07,10.05-.1,4.72-.21,9.59.12,14.36.51,7.35,1.71,14.24,3.56,20.47,7.82,1.65,15.07,3.69,21.55,6.08,1.97.73,4.31,1.81,6.79,2.97,5.63,2.62,12.02,5.58,16.65,5.58.33,0,.64-.01.95-.04,2.7-.27,7.32-3.96,9.13-5.7l.25-.23c1.67-1.53,1.86-2.07,1.72-2.26-7.7-3.57-11.38-11-13.11-16.6-3.32-10.76-2.17-23.66,2.84-32.09,6.11-10.26,18.3-16.39,32.62-16.39,19.31,0,40.59,11.46,41.99,32.7.91,13.79-3.63,25.53-13.14,33.96-8.42,7.47-20.78,12.26-34.79,13.48-6.79.59-15.38.92-24.21.92-5.89,0-11.7-.14-16.78-.42-31.43-1.67-37.22-14.89-38.93-45.89-.03-.45-.13-.9-.24-1.36-.12-.52-.25-1.05-.27-1.62-.07-1.76,0-4.01.08-6.4.21-6.45.48-14.45-1.91-18.1-.19-.29-.37-.45-.5-.45ZM221.33,316.45c-.27,0-.9.29-.96.52-.03.13.15.26.31.35,1.53.85,3.76,1.3,6.45,1.3,1.27,0,2.63-.1,3.94-.29,6.71-.98,11.64-5.73,12.56-12.11.86-6-2.2-11.66-7.83-14.5l3.42,6.23c1.6,3.61,1.34,8-.71,11.76-2.01,3.69-5.35,6.14-9.15,6.74-.64.1-1.47.15-2.53.15-.96,0-1.99-.04-2.97-.08-.92-.04-1.78-.07-2.53-.07ZM594.73,298.07c2.77,6.5,8.54,11.07,16.7,13.24,6.22,1.65,17.19,2.6,30.1,2.6,15.76,0,30.97-1.41,38.76-3.6,18.13-5.09,29.83-17.93,31.28-34.36.85-9.66-1.86-18.21-7.84-24.74-7.06-7.72-18.53-12.32-30.67-12.32-16.12,0-33.04,8.4-34.51,27.15-.48,6.15-.87,26.67,14.23,32.98l4.32-6.23c-1.82-11.5-2.14-23.7-.93-34.26l.06-.5c.55-4.89,1.18-10.42,6.73-10.42.48,0,1.01.04,1.56.13,4.74.74,31.57,17.09,35.46,20.65,2.65,2.44,3.86,4.73,3.69,7-.3,4.05-4.89,7.14-9.33,10.13l-1.23.83c-15.25,10.4-25.86,15.97-31.54,16.55-.25.03-.55.04-.87.04-1.1,0-2.53-.14-3.8-.25-1.02-.1-2.04-.19-2.65-.19-.28,0-.42.02-.48.04-.77.21-1.95,1.38-3.44,2.88-2.75,2.75-6.52,6.51-10.74,7.01-.46.05-.95.08-1.44.08-5.3,0-11.86-3.09-17.65-5.81-2.71-1.27-5.21-2.45-7.41-3.25-4.46-1.62-9.18-2.89-13.74-4.11l-.22-.06c-1.47-.39-2.93-.79-4.38-1.19ZM662.57,250.46c-1.5,0-2.26,1.11-2.9,4.26-.77,3.79-1.01,10.24-1.12,13.33-.11,3.06-.07,20.6,1.08,22.51.04.06.3.15.43.19.28.09.57.19.71.39.92,1.34-1.47,4.42-3.05,6.46-.42.55-.76.97-.95,1.27-.12.19-.28.31-.42.42-.08.07-.22.17-.22.21,0,0,0,.11.33.35.31.17.89.26,1.69.26,1.93,0,4.52-.53,5.27-.69,7.05-1.52,24.64-13.07,30.25-17.11l.82-.58c3.52-2.52,6.06-4.34,6.11-6.54.04-1.66-1.37-3.55-4.43-5.96-5.99-4.72-22.67-14.84-29.72-17.67-1.69-.68-2.93-1.1-3.88-1.1ZM152.8,209.1c3.08,0,4.52.48,4.52,1.5v40.47l.69.61,115.76-.05-4.58-1.02-20.2-3.28c-.81-.92-.72-3.59-.64-5.94.04-1.1.07-2.13.02-2.77-1.04-11.79-7.99-25.09-16.9-32.35l-.3-.25c-.69-.57-1.54-1.28-2.38-1.43v13.52c0,.24-.93,1.08-1.12,1.17l-57.21.19c-.66-.21-.93-.68-1.14-1.15-.74-1.58-.62-19.16-.41-21.74l.02-.33c.06-.81.12-1.65.65-2.38.86-.63,1.78-.66,2.66-.69.23,0,.41-.02.59-.03,5.44-.37,12.62-.58,19.7-.58,9.79,0,18.43.39,24.35,1.09,2.08.25,4.54,1.89,6.72,3.33.68.45,1.29.86,1.84,1.19.26-.03.31-.65.36-1.67.08-1.76.2-4.18,2.81-5,.93-.29,1.84-.44,2.7-.44,3.11,0,5.17,1.88,5.52,5.04l3.77.09c.47-3.55,3.47-5.17,6.08-5.17s5.39,1.59,5.59,5.14h7.52c-.75-1.92-2.06-3.81-3.22-5.48-1.61-2.32-10.65-13.49-12.39-14.01l-53.3-.08c-13.4,11.49-26.67,17.71-40.51,18.98l-.03,13.59c.24,0,.49,0,.78-.02.52-.02,1.1-.03,1.7-.03ZM150.25,212.74l.07,38.32c.12.19,1.04.45,2.06.45.46,0,.86-.05,1.15-.15.12-.04.39-.15.39-.3v-38.55l-2.95-.41-.72.63ZM339.08,195.76c-.31.22-.33.55-.35.97,0,.12-.01.25-.03.37-.24,1.87-.13,15.86.25,16.65l59.84,32.72v-76.3l-59.72,25.59ZM629.57,144.6c-17.8,3.95-34.67,9.76-50.13,17.28-.29,1.7,1.74,3.39,3.89,5.18,2.05,1.71,4.17,3.48,4.3,5.55.22,3.56-4.12,4.06-7.61,4.45-1.35.15-2.63.3-3.44.6-2.79,2.91-1.26,28.14-.34,33.24l.04.22c.46,2.59,1.7,9.48,4.42,10l58.94.03c9.59-.57,19.9-.84,32.44-.84,9.02,0,18.22.14,27.12.27,8.95.14,18.13.27,27.2.27,11.6,0,21.18-.23,30.15-.71,3.09-.17,6.37-.67,9.54-1.16,1.97-.3,4.02-.62,5.99-.84v-19.36l-169.61,1.76-.18-2.32,13.5-20.38,28.55-.69c1.06.98-1.23,4.51-3.88,8.58-1.65,2.55-3.92,6.03-3.48,6.45l8.35-.79,9.69-14.06c3.14-.29,12.49-.94,18.77-.94,3.27,0,5.07.17,5.65.52.94.58.43,1.45.06,2.09-.1.17-.18.31-.24.44-.72,1.58-2.12,3.47-3.6,5.47-1.79,2.42-3.64,4.93-4.13,6.74-.08.31-.04.42-.01.46.04.05.15.08.32.08.11,0,.22,0,.34-.02.15-.01.28-.02.4-.02,1.03,0,6.36-.61,6.64-.74.54-.32,3.01-4.19,5-7.3,1.79-2.8,3.46-5.42,4.24-6.35l.23-.28c.52-.64,1.23-1.52,1.93-1.72,1.77-.1,3.64-.14,5.91-.14,1.58,0,3.15.02,4.73.04,1.58.02,3.15.04,4.73.04,1.03,0,2.06,0,3.09-.03.49-.01,1.03-.13,1.59-.26.64-.15,1.29-.29,1.91-.29.82,0,1.45.27,1.93.82l.3,1.38-9.1,14.27,7.86-.92,10.42-14.95c1.08-.1,2-.11,2.85-.11,1.6,0,3.2.02,4.8.04,1.6.02,3.2.04,4.8.04,1.04,0,2.08,0,3.12-.03.27,0,.77-.08,1.41-.17,1.18-.17,2.8-.39,4.22-.39,1.52,0,2.49.26,2.95.8.26.3.35.68.28,1.12l-8.26,13.6,34.92-.49v-18.09c-1.02.02-2.05.02-3.07.02-1.71,0-3.42-.02-5.13-.04h-.16c-1.76-.02-3.52-.04-5.29-.04-1.14,0-2.27,0-3.41.03-23.34.43-47.13,1.21-70.13,1.97h-.11c-24.64.82-50.11,1.66-75.13,2.06-.65.01-1.59.04-2.69.07-2.3.07-5.14.16-7.7.16-2.94,0-4.76-.12-5.59-.36-1.05-.32-1.57-.73-1.59-1.27-.03-1.1,2.27-2.46,7.01-4.15l.23-.08c13.97-5.06,28.82-9.55,43.18-13.9l5.68-1.72c23.48-7.12,47.53-13.79,70.78-20.23l.26-.07c15.26-4.23,31.05-8.6,46.52-13.07l.33-.46c-.33-.71-.64-2.06-1-3.62-.93-4.03-2.2-9.53-4.12-10.82-.69-.47-1.57-.69-2.7-.69-2.22,0-4.93.89-7.55,1.76-2.15.71-4.18,1.38-5.75,1.48-.12.51-.01.54.21.6.12.03.28.08.41.19l.42.37c9.29,8.21,10.44,9.87,10.4,10.4l-1.27,1.3-21.44,6.48-10.33-8.04-.73-1.79,11.85-6.48c-5.03.55-22.33,6.2-22.44,7.01.81,1.26,3.52,3.29,6.14,5.25,2.6,1.95,5.06,3.79,5.58,4.91.27.59.49,1.05.01,1.72-.87,1.22-21.86,6.69-23.02,6.97-.18-.06-11.14-7.66-11.14-9.37,0-.92,2.26-2.26,5.12-3.95,2.25-1.33,4.77-2.82,5.65-3.93l-23.92,7.81c-.04.45.16.63.5.93.09.08.18.15.27.24,1.74,1.69,3.96,3.32,6.1,4.89,2.04,1.49,4.13,3.03,5.86,4.65l.62,1.26-.68,1.44c-2.07.29-5.88,1.59-9.91,2.97-5.1,1.74-10.37,3.53-12.99,3.53-.38,0-.71-.04-.96-.12-.68-.21-7.74-6.3-8.57-7.08-.13-.13-.28-.26-.43-.4-.85-.77-1.81-1.64-2.12-2.68.1-.56,2.47-1.77,7.74-4.28,1.42-.68,2.75-1.31,3.23-1.58,0,0,.32-.18.42-.24-.11,0-.23.02-.37.04-5.4.64-11.01,2.65-16.44,4.59-3.38,1.21-6.85,2.45-10.17,3.32l.09,1.23.17.05c11.96,9.27,12.13,10.04,12.19,10.29.18.81-.53,1.18-1.01,1.42l-.21.11c-1.41.79-4.07,1.57-6.41,2.25-.97.28-1.87.55-2.59.79-3.34,1.11-6.78,2.08-10.11,3.03l-2.46.7c-.88-.09-10.09-7.15-10.77-7.9-.06-.07-.12-.13-.18-.19-.32-.32-.63-.65-.63-1.22l.25-1.3c2.78-1.28,5.4-2.6,7.94-3.87l.95-.48c.1-.05.25-.09.41-.13.25-.07.41-.12.47-.16-.02,0-.05-.04-.11-.08ZM172.36,196.55c-.22,0-.55,1.52-.55,2.55v16.99l.69.61,52.83-.06.61-.69-.06-13.85c-1.25-1.08-8.86-5.55-9.55-5.55h-43.98ZM89.43,188.68c-5.64,7.69-5.41,19.7.52,26.88l10.43-8.76,18.08-.17.83,2.52h28.14v-13.04l-.69-.61-26.85.06c-.11,0-.32.56-.42.83-.28.75-.64,1.69-1.43,1.69-.05,0-.11,0-.17-.01l-17.37-.11-11.07-9.27ZM264.3,199.53c.18.9.3,1.78.42,2.63.43,3.14.8,5.86,3.72,8.01,1.61,1.19,3.33,1.79,5.13,1.79,3.5,0,6.85-2.42,8.14-5.88,1.23-3.3.31-6.61-2.54-9.08-1.62-1.41-3.53-2.13-5.68-2.13-.92,0-1.89.13-2.89.39-1.21.31-2.1,1.2-2.96,2.06-.95.94-1.93,1.92-3.33,2.18ZM150.32,192.15c9.9-.58,20.95-4.78,30.33-11.54l.26-.18c3.71-2.6,4.44-3.51,4.55-3.82-.67-.18-1.38-.27-2.18-.27-3.53,0-6.3,1.72-9.22,3.53-1.58.98-3.2,1.99-5.01,2.77-5.86,2.53-12.46,3.92-18.58,3.92h-.13s0,5.59,0,5.59ZM152.33,60.57c-20.15,0-44.48,10.59-52.35,40.3-4.58,17.29-1.68,33.33,8.37,46.39,12.71,16.51,35.86,26.77,60.42,26.77,3,0,6.01-.16,8.95-.47,7.3-5.34,16.5-16.16,19.17-24.99.1-.33.05-.45.02-.48-.04-.05-.12-.06-.18-.06-.09,0-.2.02-.32.06-.59.18-1.25.52-1.95.88-.89.46-1.89.97-2.92,1.25-1.52.41-2.98.6-4.62.6-.96,0-1.86-.06-2.73-.13-.87-.06-1.66-.12-2.47-.12-.62,0-1.19.04-1.73.11-.96.13-4.25,1.89-7.43,3.59-2.96,1.59-5.98,3.2-7.62,3.8-5.78,2.11-10.82,3.13-15.43,3.13-9.52,0-17.71-4.45-26.54-14.42-10.38-11.73-15.41-24.09-14.54-35.76.83-11.17,6.83-21.5,17.83-30.72,7.78-6.52,16.43-9.82,25.71-9.82,11.83,0,24.52,5.39,36.7,15.59,12.76,10.69,17.3,35,14.25,51.61,3.37-4.24,5.04-12.32,5.45-18.05,1.15-16.2-3.55-30.46-13.61-41.26-10.55-11.32-26.02-17.82-42.45-17.82ZM213.88,144.72c-1.17,1.91-2.32,3.88-3.43,5.79-2.27,3.9-4.61,7.92-7.28,11.64-1.51,2.1-3.19,3.99-4.83,5.82-1.29,1.45-2.63,2.95-3.83,4.51-.11.15-.24.26-.36.37-.27.25-.44.4-.38.8l46.86-.5-10.86-11.48-15.88-16.97ZM274.02,58c-17.86,0-34.68,8.45-44.99,22.61-8.95,12.29-12.59,28.29-10,43.9,2.55,15.33,10.61,28.45,22.69,36.93,3.79,2.66,16.19,9.52,20.79,9.97.05,0,.11,0,.17,0,1.12,0,4.12-.73,8.7-2.1,2.39-.72,4.72-1.64,6.98-2.54,1.24-.49,2.51-1,3.79-1.47l-9.75-7.97c-32.1-3.64-43.9-17.15-42.05-48.19,1.52-25.46,18.06-40.07,45.38-40.07,1.66,0,3.38.06,5.1.16,10.83.69,26.31,8.56,34.27,28.49,3.07,7.69,6.24,16.62,4.99,25.33-2.24,15.58-13.3,30.9-29.59,41.03,1.52.55,3.14.84,4.79.84,6.06,0,11.69-3.65,15.35-6.7,11.09-9.27,17.57-23.18,18.23-39.18.72-17.34-5.69-34.45-17.16-45.76-9.98-9.85-23.37-15.27-37.7-15.27ZM277.42,157.56c1.45,1.77,7.32,5.53,8.68,5.53,17.94-10.18,29.58-26.26,31.17-43.05l-5.62,6.72c-2.69,1.79-5.71,2.72-8.77,2.72-4.09,0-8.11-1.67-11.02-4.59-2.94-2.94-4.55-6.93-4.55-11.21.02-9.6,8.26-15.33,16.21-15.33,3.39,0,6.62,1.01,9.36,2.92l.05-.02-.08-.05c.08-.13-.03-.51-.09-.71l-.04-.12c-1.46-5.2-7.65-14.4-11.81-18.54-.65-.65-4-3.57-4.22-3.68-.06-.03-.17-.05-.26-.05-.07,0-.13.01-.17.02,2.5,4.99,2.35,10.46-.43,15.02-2.84,4.67-7.97,7.57-13.39,7.57-2.17,0-4.35-.45-6.47-1.34-5.18-2.18-8.57-6.95-9.05-12.76-.48-5.68,2.01-11.09,6.49-14.22-.28,0-.55,0-.83,0-8.96,0-18.18,2.94-25.36,8.09.25,0,.49-.01.74-.01,7.34,0,15.42,4.41,16.65,12.84.94,6.41-1.36,10.65-3.45,13.07-2.95,3.42-7.32,5.38-11.97,5.38-5.85,0-11.04-3.09-14.25-8.49-.1-.18-.12-.36-.12-.49q-.01-.2-.19-.2c-.1,0-.22.01-.38.04-1,7.73-1.81,15.92.12,23.73,3.34-6.75,8.49-10.47,14.54-10.47,6.72,0,13.34,4.85,15.39,11.28,2.06,6.46-.78,13.03-7.79,18.01l-8.38,2.29c7.77,3.65,15.18,5.67,22.04,5.99-3.66-5.77-4-13.27-.85-19.14,2.73-5.1,7.48-8.02,13.01-8.02,1.67,0,3.41.27,5.17.8,8.54,2.57,11.04,10.15,10.59,15.86-.51,6.44-4.97,13.47-13.77,14.66-.49.06-1.03.1-1.68.1-.7,0-1.43-.04-2.15-.08-.73-.04-1.44-.08-2.14-.08-.32,0-.63,0-.93.03ZM145.6,129.05c4.68,0,8.92,2.03,11.93,5.72,2.65,3.25,3.82,7.32,3.29,11.47-.56,4.38-2.93,8.51-6.54,11.38,6.5-.65,12.56-3.64,18.43-6.54l.12-.06c.9-.44,1.8-.89,2.69-1.32,0,0,.04-.08.02-.16-.08-.42-1.26-.95-2.03-1.29-.41-.19-.77-.35-.97-.48-8-5.42-11.33-12.66-9.12-19.85,2-6.52,8.3-11.26,14.97-11.26,3.18,0,6.32,1.07,9.08,3.1,3.56,2.61,5.78,6.36,6.24,10.56.49,4.45-1.04,9.09-4.2,12.72l-5.4,5.15c3.59-.08,8.92-1.05,12.54-3.54,2.11-1.45,2.38-2.75,2.84-4.92l.18-.85c3.01-13.57.69-28.52-6.7-43.24-.11,0-.21-.02-.3-.02-.12-.01-.2-.02-.26-.02-.1.02-.13.11-.07.52.62,4.36-.59,8.55-3.41,11.81-2.98,3.44-7.5,5.49-12.1,5.49-3.47,0-6.79-1.15-9.58-3.33-6.27-4.88-6.64-12.03-4.9-17.1,2.24-6.52,7.98-10.74,14.62-10.74h.25s.17-.69.17-.69c-9.54-5.34-18.07-7.94-26.06-7.94-.37,0-.74,0-1.11.02l4.3,3.13c4.29,4.59,5.49,11.05,3.15,16.88-2.26,5.62-7.21,9.17-13.25,9.49-.32.02-.64.03-.95.03-5.11,0-9.74-2.29-12.69-6.27-2.92-3.95-3.82-9.01-2.5-13.92-7.9,6.19-13.48,14.26-15.75,22.8,3.05-2.9,7.22-4.56,11.49-4.56,6.08,0,11.22,3.15,13.74,8.43,2.49,5.22,2.28,10.6-.59,15.15-2.99,4.74-8.44,7.69-14.22,7.69-2.18,0-4.34-.41-6.43-1.22,3.26,7.62,8.97,13.7,14.18,18.66-.01-.95-.19-1.8-.37-2.69-.23-1.09-.46-2.22-.38-3.59.55-9.48,8.48-14.6,15.66-14.6ZM145.78,132.01c-4.55,0-8.95,2.56-11.21,6.51-2.22,3.88-2.03,8.4.52,12.72,2.96,5.02,6.89,6.07,9.67,6.07,4.96,0,10.12-3.49,12.28-8.3,1.15-2.55,2.38-7.61-2.25-12.81-3.08-3.47-6.61-4.2-9.02-4.2ZM274.24,153.99c.6,0,1.28.05,1.89.09,1.57.11,3.17.22,4.74.22,3.91,0,6.7-.73,9.03-2.36,3.06-2.14,4.97-5.54,5.23-9.31.26-3.76-1.16-7.38-3.89-9.91-2.22-2.05-5.24-3.19-8.51-3.19-3.82,0-7.29,1.55-9.52,4.24-6.33,7.66-.83,17.44,1.01,20.26l.02-.05ZM178.26,119.99c-.89,0-1.81.08-2.75.24-2.51.43-5.45,2.34-7.15,4.64-2.58,3.48-3.27,7.32-2.01,11.1,1.67,5.03,6.61,9.43,12.58,11.21,3.89-2.17,10.66-6.71,11.44-12.6.55-4.14-.45-7.91-2.83-10.62-2.24-2.56-5.53-3.97-9.27-3.97ZM249.62,118.89c-4.64,0-9.29,2.86-11.57,7.12-2.13,3.98-1.85,8.51.77,12.44,3.07,4.61,6.95,5.58,9.67,5.58,5.35,0,10.7-3.71,12.72-8.82,1.05-2.65,1.99-7.86-3.47-12.97-2.33-2.19-5.14-3.35-8.13-3.35ZM124.17,104.15c-.53,0-1.08.03-1.63.1-7.86.94-11.06,7.65-10.71,13.49.33,5.6,3.96,11.62,11.15,11.62,1.6,0,3.3-.3,5.08-.9,7.19-2.43,8.83-8.85,8.05-13.6-.85-5.15-4.94-10.7-11.93-10.7ZM303.38,101.51c-.95,0-1.94.08-2.94.24-5.7.91-10.69,7.48-10.08,13.26.77,7.32,7.15,11.27,12.76,11.27,4.23,0,7.92-2.12,10.14-5.82,2.78-4.63,3.14-9.47.99-13.27-2.04-3.61-6.01-5.68-10.87-5.68ZM177.49,85.11c-.65,0-1.32.05-1.99.16-4.34.68-8.59,4.09-10.1,8.11-1.48,3.93-.98,8.12,1.35,11.49,2.37,3.42,6.19,5.46,10.23,5.46,2.12,0,4.2-.56,6.17-1.66,6.09-3.41,6.92-9.72,5.78-14.1-1.23-4.71-5.24-9.45-11.45-9.45ZM249.51,83.74c-.18,0-.35,0-.52.01-5.25.29-10.08,4.31-11.74,9.8-1.46,4.8-.08,9.37,3.7,12.21,2.51,1.88,5.34,2.88,8.2,2.88,4.51,0,8.75-2.43,11.05-6.34,2.22-3.76,2.21-8.25-.04-12.3-2.01-3.63-6.49-6.27-10.66-6.27ZM143.07,75.24c-.34,0-.69.02-1.02.05-5.09.49-9.17,3.88-10.65,8.86-1.46,4.9.12,9.93,4.13,13.12,2.35,1.87,5.05,2.86,7.8,2.86,4.14,0,8.16-2.25,10.49-5.87,2.32-3.61,2.58-8.01.73-12.07-1.84-4.03-6.66-6.95-11.46-6.95ZM282.57,72.77c-1.42,0-2.87.26-4.3.77-3.5,1.25-6.24,3.93-7.5,7.35-1.29,3.5-.95,7.41.95,10.72,2.14,3.73,6.14,5.96,10.69,5.96,3.57,0,6.97-1.44,9.32-3.94,3.36-3.58,4.18-8.47,2.19-13.07-2.05-4.73-6.5-7.79-11.35-7.79Z"
            }, null, 8, $867093479b92afee$var$_hoisted_2),
            _cache[0] || (_cache[0] = (0, $xo6Zx.createTextVNode)(" /> ", -1))
        ])
    ], 2);
}

});

parcelRegister("ipJFg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d67dfbce7e11f77e$export$2e2bcd8739ae039);
let $d67dfbce7e11f77e$var$NOOP = ()=>{};
var $d67dfbce7e11f77e$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("aJ5ln", function(module, exports) {

$parcel$export(module.exports, "render", () => $7cf24085f56a97de$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $7cf24085f56a97de$var$_hoisted_1 = {
    class: "flex h-full"
};
const $7cf24085f56a97de$var$_hoisted_2 = {
    id: "search-tools",
    class: "grow-0 flex-shink"
};
const $7cf24085f56a97de$var$_hoisted_3 = {
    class: "column grow shrink basis-[60%]",
    id: "search-results"
};
const $7cf24085f56a97de$var$_hoisted_4 = {
    class: "results-container flex flex-col w-full grow max-h-[calc(65vh_-_6rem)]"
};
const $7cf24085f56a97de$var$_hoisted_5 = {
    class: "relative grow flex flex-col pb-1 overflow-y-hidden"
};
const $7cf24085f56a97de$var$_hoisted_6 = {
    key: 0,
    class: "absolute inset-x-0 top-0 h-12 fade-out-top pointer-events-none"
};
const $7cf24085f56a97de$var$_hoisted_7 = {
    key: 0,
    class: "absolute inset-x-0 bottom-0 h-12 fade-out-bottom pointer-events-none"
};
function $7cf24085f56a97de$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_media_archive_search_box = (0, $xo6Zx.resolveComponent)("media-archive-search-box");
    const _component_media_archive_facets_available = (0, $xo6Zx.resolveComponent)("media-archive-facets-available");
    const _component_media_archive_facets_applied = (0, $xo6Zx.resolveComponent)("media-archive-facets-applied");
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    const _component_MediaMusicCircle = (0, $xo6Zx.resolveComponent)("MediaMusicCircle");
    const _component_MediaMusicLine = (0, $xo6Zx.resolveComponent)("MediaMusicLine");
    const _component_MediaFilmCircle = (0, $xo6Zx.resolveComponent)("MediaFilmCircle");
    const _component_MediaFilmLine = (0, $xo6Zx.resolveComponent)("MediaFilmLine");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $7cf24085f56a97de$var$_hoisted_1, [
        (0, $xo6Zx.createElementVNode)("div", $7cf24085f56a97de$var$_hoisted_2, [
            (0, $xo6Zx.createVNode)(_component_media_archive_search_box, {
                label: "Zoek op trefwoord",
                modelValue: $options.query,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$options.query = $event)
            }, null, 8, [
                "modelValue"
            ]),
            (0, $xo6Zx.createVNode)(_component_media_archive_facets_available, {
                facets: $options.availableFacetsRenderable
            }, null, 8, [
                "facets"
            ])
        ]),
        (0, $xo6Zx.createElementVNode)("div", $7cf24085f56a97de$var$_hoisted_3, [
            (0, $xo6Zx.createVNode)(_component_box_generic, {
                "h-stretch": "",
                "w-stretch": "",
                header: "Archief",
                class: "results-list-box h-full pl-[3vw] flex flex-col max-h-[65vh]",
                "header-class": $options.computedHeaderClass
            }, {
                default: (0, $xo6Zx.withCtx)(()=>[
                        (0, $xo6Zx.createElementVNode)("div", $7cf24085f56a97de$var$_hoisted_4, [
                            (0, $xo6Zx.createVNode)(_component_media_archive_facets_applied, {
                                items: $options.appliedFacetsRenderable,
                                query: $options.query
                            }, {
                                tags: (0, $xo6Zx.withCtx)(({ item: tag })=>[
                                        (0, $xo6Zx.createTextVNode)(" tag: " + (0, $d8ZDz.toDisplayString)(tag.title), 1)
                                    ]),
                                volumes: (0, $xo6Zx.withCtx)(({ item: volume })=>[
                                        (0, $xo6Zx.createTextVNode)(" jaargang: " + (0, $d8ZDz.toDisplayString)(volume.volumeNumber) + ", " + (0, $d8ZDz.toDisplayString)(volume.title), 1)
                                    ]),
                                seasons: (0, $xo6Zx.withCtx)(({ item: season })=>[
                                        (0, $xo6Zx.createTextVNode)(" aflevering: nummer " + (0, $d8ZDz.toDisplayString)(season.issueNumber), 1)
                                    ]),
                                _: 1
                            }, 8, [
                                "items",
                                "query"
                            ]),
                            (0, $xo6Zx.createElementVNode)("div", $7cf24085f56a97de$var$_hoisted_5, [
                                (0, $xo6Zx.createElementVNode)("div", {
                                    ref: "scrollContainer",
                                    onScroll: _cache[1] || (_cache[1] = (...args)=>$options.onScroll && $options.onScroll(...args)),
                                    class: (0, $d8ZDz.normalizeClass)([
                                        [
                                            {
                                                'bg-white': $props.fadeOut
                                            }
                                        ],
                                        "scroll-container h-full overflow-x-hidden overflow-y-auto"
                                    ])
                                }, [
                                    (0, $xo6Zx.renderSlot)(_ctx.$slots, "default", {
                                        items: $options.filteredItems
                                    })
                                ], 34),
                                (0, $xo6Zx.createVNode)(_component_transition_fade, {
                                    duration: 200
                                }, {
                                    default: (0, $xo6Zx.withCtx)(()=>[
                                            $options.fadeOutTop ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $7cf24085f56a97de$var$_hoisted_6)) : (0, $xo6Zx.createCommentVNode)("", true)
                                        ]),
                                    _: 1
                                }),
                                (0, $xo6Zx.createVNode)(_component_transition_fade, {
                                    duration: 200
                                }, {
                                    default: (0, $xo6Zx.withCtx)(()=>[
                                            $options.fadeOutBottom ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $7cf24085f56a97de$var$_hoisted_7)) : (0, $xo6Zx.createCommentVNode)("", true)
                                        ]),
                                    _: 1
                                })
                            ])
                        ])
                    ]),
                _: 3
            }, 8, [
                "header-class"
            ]),
            $options.isMuziekArchiveRoute ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), {
                key: 0
            }, [
                (0, $xo6Zx.createVNode)(_component_MediaMusicCircle, {
                    class: "pointer-events-none absolute top-0 right-0 translate-x-[-20%] translate-y-[20%]",
                    color: _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw' ? '#127b5d' : '#6c44a5'
                }, null, 8, [
                    "color"
                ]),
                (0, $xo6Zx.createVNode)(_component_MediaMusicLine, {
                    class: "pointer-events-none absolute bottom-0 right-0 translate-x-[0%] translate-y-[-5%]",
                    color: _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw' ? '#127b5d' : '#6c44a5'
                }, null, 8, [
                    "color"
                ])
            ], 64)) : (0, $xo6Zx.createCommentVNode)("", true),
            $options.isFilmArchiveRoute ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), {
                key: 1
            }, [
                (0, $xo6Zx.createVNode)(_component_MediaFilmCircle, {
                    class: "pointer-events-none absolute top-0 right-0 translate-x-[-20%] translate-y-[20%]",
                    color: _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw' ? '#127b5d' : '#6c44a5'
                }, null, 8, [
                    "color"
                ]),
                (0, $xo6Zx.createVNode)(_component_MediaFilmLine, {
                    class: "pointer-events-none absolute bottom-0 right-0 translate-x-[2%] translate-y-[-5%]",
                    color: _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw' ? '#127b5d' : '#6c44a5'
                }, null, 8, [
                    "color"
                ])
            ], 64)) : (0, $xo6Zx.createCommentVNode)("", true)
        ])
    ]);
}

});

parcelRegister("ggyqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd78d8fe973c3105$export$2e2bcd8739ae039);
let $bd78d8fe973c3105$var$NOOP = ()=>{};
var $bd78d8fe973c3105$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("3MWve", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c233c3b45da3c07$export$2e2bcd8739ae039);
let $2c233c3b45da3c07$var$script;



let $2c233c3b45da3c07$var$initialize = ()=>{
    $2c233c3b45da3c07$var$script = (parcelRequire("lHsaR"));
    if ($2c233c3b45da3c07$var$script.__esModule) $2c233c3b45da3c07$var$script = $2c233c3b45da3c07$var$script.default;
    $2c233c3b45da3c07$var$script.render = (parcelRequire("d72cP")).render;
    (parcelRequire("cTZSv")).default($2c233c3b45da3c07$var$script);
    $2c233c3b45da3c07$var$script.__scopeId = 'data-v-51bcb7';
    $2c233c3b45da3c07$var$script.__file = "VideoPreview.vue";
};
$2c233c3b45da3c07$var$initialize();
var $2c233c3b45da3c07$export$2e2bcd8739ae039 = $2c233c3b45da3c07$var$script;

});
parcelRegister("lHsaR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fcc377e9a5ef0a5d$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $dT1o1 = parcelRequire("dT1o1");
var $fcc377e9a5ef0a5d$export$2e2bcd8739ae039 = {
    name: "VideoPreview",
    props: {
        to: {
            type: Object,
            required: true
        },
        video: {
            type: Object,
            required: true
        },
        is: {
            type: String,
            default: "div"
        }
    },
    computed: {
        ...(0, $aofyc.mapState)([
            "container"
        ]),
        tags () {
            return this.video.tags?.map((tag)=>(0, $dT1o1.default)(this.container?.tags, tag.slug));
        },
        splitTitle () {
            const parts = this.video.title.split(":");
            return parts.length > 1 ? [
                parts[0].trim(),
                parts[1].trim()
            ] : [
                this.video.title
            ];
        },
        computedSchoolLevel () {
            const slug = this.$route.params.schoolLevelSlug;
            return (0, $dT1o1.default)(this.container?.schoolLevels, slug);
        },
        computedSchoolLevelBackgroundColor () {
            const slug = this.computedSchoolLevel?.slug;
            if (!slug) return "";
            const bgMap = {
                onderbouw: "bg-yellow-200 hover:bg-yellow",
                "midden-bovenbouw": "bg-yellowGreen-200 hover:bg-yellowGreen"
            };
            return bgMap[slug] || "";
        }
    },
    methods: {
        transformPublicUrl: (url)=>url?.includes("://") ? url : `/${url}`
    }
};

});

parcelRegister("d72cP", function(module, exports) {

$parcel$export(module.exports, "render", () => $98bda3d631771377$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $98bda3d631771377$var$_hoisted_1 = [
    "src",
    "alt",
    "title"
];
const $98bda3d631771377$var$_hoisted_2 = {
    class: "video-list__video-item__title video-preview-box__title text-almostBlack self-stretch grow pl-[13px] pt-[8px] pb-[15px] text-left"
};
const $98bda3d631771377$var$_hoisted_3 = {
    class: "font-sans pb-[2px] text-[14px]"
};
const $98bda3d631771377$var$_hoisted_4 = {
    class: "font-bree text-[14px]"
};
function $98bda3d631771377$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $xo6Zx.resolveComponent)("router-link");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)((0, $xo6Zx.resolveDynamicComponent)($props.is), {
        class: "video-list__video-item m-[1.5vw] video-preview-box rounded-bl-none"
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                (0, $xo6Zx.createVNode)(_component_router_link, {
                    to: $props.to,
                    class: (0, $d8ZDz.normalizeClass)([
                        "video-list__video-item__link relative items-center flex flex-col h-full",
                        $options.computedSchoolLevelBackgroundColor
                    ])
                }, {
                    default: (0, $xo6Zx.withCtx)(()=>[
                            (0, $xo6Zx.createElementVNode)("img", {
                                src: $options.transformPublicUrl($props.video.previewImage?.publicUrl),
                                alt: $props.video.title,
                                title: $props.video.title,
                                class: "max-w-[21vw]"
                            }, null, 8, $98bda3d631771377$var$_hoisted_1),
                            (0, $xo6Zx.createElementVNode)("div", $98bda3d631771377$var$_hoisted_2, [
                                (0, $xo6Zx.createElementVNode)("div", $98bda3d631771377$var$_hoisted_3, (0, $d8ZDz.toDisplayString)($options.splitTitle[0]), 1),
                                (0, $xo6Zx.createElementVNode)("div", $98bda3d631771377$var$_hoisted_4, (0, $d8ZDz.toDisplayString)($options.splitTitle[1]), 1)
                            ])
                        ]),
                    _: 1
                }, 8, [
                    "to",
                    "class"
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("cTZSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $964a9ecfe8499a12$export$2e2bcd8739ae039);
let $964a9ecfe8499a12$var$NOOP = ()=>{};
var $964a9ecfe8499a12$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("9UhPb", function(module, exports) {

$parcel$export(module.exports, "render", () => $73672b9771f26f11$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $jH5uA = parcelRequire("jH5uA");
const $73672b9771f26f11$var$_hoisted_1 = {
    key: 1,
    class: "flex h-full justify-center items-center"
};
function $73672b9771f26f11$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_view = (0, $xo6Zx.resolveComponent)("router-view");
    const _component_video_preview = (0, $xo6Zx.resolveComponent)("video-preview");
    const _component_media_archive = (0, $xo6Zx.resolveComponent)("media-archive");
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    return _ctx.routedVideo ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_router_view, {
        key: 0
    })) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_transition_fade, {
        key: 1,
        duration: 500,
        appear: ""
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                _ctx.activeSchoolLevel?.archivedVideos.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_media_archive, {
                    key: 0,
                    items: _ctx.activeSchoolLevel?.archivedVideos
                }, {
                    default: (0, $xo6Zx.withCtx)(({ items: items })=>[
                            (0, $xo6Zx.createVNode)((0, $jH5uA.TransitionGroup), {
                                name: "media",
                                tag: "div",
                                class: "contents media",
                                onBeforeLeave: $options.mediaItemBeforeLeave
                            }, {
                                default: (0, $xo6Zx.withCtx)(()=>[
                                        ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)(items, (item)=>{
                                            return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", {
                                                key: item.slug
                                            }, [
                                                ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_video_preview, {
                                                    key: item.slug,
                                                    video: item,
                                                    to: {
                                                        name: 'FilmArchiveVideoPlayer',
                                                        params: {
                                                            volumeSlug: _ctx.activeVolume.slug,
                                                            schoolLevelSlug: _ctx.activeSchoolLevel.slug,
                                                            videoSlug: item.slug
                                                        }
                                                    },
                                                    small: "",
                                                    class: "video-list__video-item--search-result rounded-[2.5rem]"
                                                }, null, 8, [
                                                    "video",
                                                    "to"
                                                ]))
                                            ]);
                                        }), 128))
                                    ]),
                                _: 2
                            }, 1032, [
                                "onBeforeLeave"
                            ])
                        ]),
                    _: 1
                }, 8, [
                    "items"
                ])) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $73672b9771f26f11$var$_hoisted_1, [
                    (0, $xo6Zx.createVNode)(_component_box_generic, {
                        header: "Geen materiaal"
                    }, {
                        default: (0, $xo6Zx.withCtx)(()=>[
                                ..._cache[0] || (_cache[0] = [
                                    (0, $xo6Zx.createElementVNode)("p", {
                                        class: "mt-3 leading-relaxed"
                                    }, "Er zijn geen filmpjes beschikbaar.", -1)
                                ])
                            ]),
                        _: 1
                    })
                ]))
            ]),
        _: 1
    }));
}

});

parcelRegister("c989s", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d7ca6074c663586$export$2e2bcd8739ae039);
let $8d7ca6074c663586$var$NOOP = ()=>{};
var $8d7ca6074c663586$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("ktTN4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee91caebd79d6cef$export$2e2bcd8739ae039);

var $ivPjW = parcelRequire("ivPjW");

var $PWMme = parcelRequire("PWMme");
var $ee91caebd79d6cef$export$2e2bcd8739ae039 = [
    {
        path: "muziekarchief/",
        name: "MusicArchive",
        component: (0, $PWMme.default),
        meta: {
            containerClass: "showSongSearch"
        },
        children: [
            ...(0, $ivPjW.default)("MusicArchiveKaraokePlayer")
        ]
    }
];

});
parcelRegister("ivPjW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7a2ee7845ee8d89$export$2e2bcd8739ae039);

var $bDKe2 = parcelRequire("bDKe2");
function $d7a2ee7845ee8d89$export$2e2bcd8739ae039(name) {
    return [
        {
            path: "lied/:songSlug?/",
            name: name,
            component: (0, $bDKe2.default),
            meta: {
                containerClass: "showSongPlayer"
            }
        }
    ];
}

});
parcelRegister("bDKe2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8797319dc06f5aa2$export$2e2bcd8739ae039);
let $8797319dc06f5aa2$var$script;



let $8797319dc06f5aa2$var$initialize = ()=>{
    $8797319dc06f5aa2$var$script = (parcelRequire("2hnlF"));
    if ($8797319dc06f5aa2$var$script.__esModule) $8797319dc06f5aa2$var$script = $8797319dc06f5aa2$var$script.default;
    $8797319dc06f5aa2$var$script.render = (parcelRequire("5AEsP")).render;
    (parcelRequire("bA9X9")).default($8797319dc06f5aa2$var$script);
    $8797319dc06f5aa2$var$script.__scopeId = 'data-v-2bf2a1';
    $8797319dc06f5aa2$var$script.__file = "KaraokePlayer.vue";
};
$8797319dc06f5aa2$var$initialize();
var $8797319dc06f5aa2$export$2e2bcd8739ae039 = $8797319dc06f5aa2$var$script;

});
parcelRegister("2hnlF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1a8f47d736622fa2$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $9LnAR = parcelRequire("9LnAR");

var $9SSpS = parcelRequire("9SSpS");

var $QlUa3 = parcelRequire("QlUa3");
var $1a8f47d736622fa2$export$2e2bcd8739ae039 = {
    name: "KaraokePlayer",
    components: {
        KaraokeLyrics: $9LnAR.default,
        SongPlayer: $9SSpS.default,
        TransitionFade: $QlUa3.default
    },
    data () {
        return {
            vocalMixPlayerPlaying: false,
            vocalMixPlaybackTracked: false,
            karaokeSoundMixPlayerPlaying: false,
            karaokeSoundMixPlaybackTracked: false,
            currentTime: 0,
            muted: false,
            volume: 75
        };
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "routedSong"
        ]),
        ...(0, $aofyc.mapGetters)([
            "activeSeasonContentForSchoolLevel"
        ])
    },
    watch: {
        routedSong () {
            // Reset the instance data - except muted & volume.
            this.vocalMixPlayerPlaying = false;
            this.vocalMixPlaybackTracked = false;
            this.karaokeSoundMixPlayerPlaying = false;
            this.karaokeSoundMixPlaybackTracked = false;
            this.currentTime = 0;
        },
        vocalMixPlayerPlaying (playing) {
            if (playing) this.karaokeSoundMixPlayerPlaying = false;
            if (!this.vocalMixPlaybackTracked && this.routedSong?.vocalMix?.trackingUrl) {
                // Track song playback.
                navigator.sendBeacon(this.routedSong.vocalMix.trackingUrl);
                this.vocalMixPlaybackTracked = true;
            }
        },
        karaokeSoundMixPlayerPlaying (playing) {
            if (playing) this.vocalMixPlayerPlaying = false;
            if (!this.karaokeSoundMixPlaybackTracked && this.routedSong?.karaokeSoundMix?.trackingUrl) {
                // Track karaoke soundmix playback.
                navigator.sendBeacon(this.routedSong.karaokeSoundMix.trackingUrl);
                this.karaokeSoundMixPlaybackTracked = true;
            }
        },
        volume (volume) {
            window.localStorage.setItem("volume", volume);
        }
    },
    mounted () {
        this.applyMemorizedVolume();
    },
    updated () {
        this.applyMemorizedVolume();
    },
    methods: {
        applyMemorizedVolume () {
            this.volume = Number(window.localStorage.getItem("volume") ?? 75);
        }
    }
};

});
parcelRegister("9LnAR", function(module, exports) {

$parcel$export(module.exports, "default", () => $71bace0b18f5e793$export$2e2bcd8739ae039);
let $71bace0b18f5e793$var$script;



let $71bace0b18f5e793$var$initialize = ()=>{
    $71bace0b18f5e793$var$script = (parcelRequire("gBZbF"));
    if ($71bace0b18f5e793$var$script.__esModule) $71bace0b18f5e793$var$script = $71bace0b18f5e793$var$script.default;
    $71bace0b18f5e793$var$script.render = (parcelRequire("8z0Bm")).render;
    (parcelRequire("7yBFG")).default($71bace0b18f5e793$var$script);
    $71bace0b18f5e793$var$script.__scopeId = 'data-v-63e1c1';
    $71bace0b18f5e793$var$script.__file = "KaraokeLyrics.vue";
};
$71bace0b18f5e793$var$initialize();
var $71bace0b18f5e793$export$2e2bcd8739ae039 = $71bace0b18f5e793$var$script;

});
parcelRegister("gBZbF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c17f908cfa0249a2$export$2e2bcd8739ae039);

var $QlUa3 = parcelRequire("QlUa3");
var // Note `.min-h-[calc(100vh_-_20rem)]`: Safari workaround for "height: 100% in flex-item's child" bug
$c17f908cfa0249a2$export$2e2bcd8739ae039 = {
    name: "KaraokeLyrics",
    components: {
        TransitionFade: $QlUa3.default
    },
    data () {
        return {
            autoSize: undefined
        };
    },
    props: {
        cuePoints: {
            type: Array,
            default: ()=>[]
        },
        currentTime: {
            type: Number,
            default: 0
        }
    },
    computed: {
        lyrics () {
            const currentCuePoint = this.cuePoints?.filter((item)=>this.currentTime * 1000 >= item.time).pop();
            return currentCuePoint?.lyrics;
        }
    },
    watch: {
        cuePoints () {
            // Reset the instance data.
            Object.assign(this.$data, this.$options.data.call(this));
        }
    },
    mounted () {
        window.addEventListener("resize", ()=>{
            this.autoSize = undefined;
            this.determineAutoSize();
        });
    },
    methods: {
        pollContainerExpanded () {
            const container = this.$refs.container;
            if (!container) return Promise.reject();
            // When opening a song in a new tab or reloading a song page,
            // then the container height is `0` for a quick moment.
            // We need to wait for Vue to initialize fully and all classes to be applied.
            // Only once the container height has expanded to its actual `auto` height
            // can we measure the font size.
            return new Promise((resolve)=>{
                const interval = window.setInterval(()=>{
                    const boundingBox = container.getBoundingClientRect();
                    if (boundingBox.height > 0) {
                        window.clearInterval(interval);
                        resolve();
                    }
                }, 50);
            });
        },
        async determineAutoSize () {
            // Measure only if necessary.
            // This allows us to link this to the fade transition's @after-enter hook;
            // making sure we are not surprised by a missing `this.$refs.container`
            // due to DOM patching and transition.
            if (this.autoSize !== undefined) return;
            if (!this.cuePoints?.length) return;
            const container = this.$refs.container;
            if (!container) return;
            const initialInnerText = container.innerText;
            container.innerText = "";
            // Fix width and height to the stretched auto-values.
            container.style.width = "";
            container.style.height = "";
            // When opening a song in a new tab or reloading a song page,
            // the lyrics container has an initial height of `0`.
            // Here, we wait for the container to inflate (re-layouting),
            // so we can fix its size final and measure the maximum font size.
            await this.pollContainerExpanded();
            const boundingBox = container.getBoundingClientRect();
            container.style.width = `${boundingBox.width}px`;
            container.style.height = `${boundingBox.height}px`;
            // Temporarily set overflow to scroll to measure the amount of overflow.
            container.style.overflow = "scroll";
            container.style.visibility = "hidden";
            let size = 8;
            for(; size <= container.clientHeight; size++){
                // Set font size to measure text overflow.
                container.style.fontSize = `${size}px`;
                // Try all of the song's cue points.
                // If none overflow, advance to the next size.
                const overflows = this.cuePoints?.some((cuePoint)=>{
                    container.innerText = cuePoint?.lyrics;
                    return container.scrollWidth > container.offsetWidth || container.scrollHeight > container.offsetHeight;
                });
                if (overflows) break;
            }
            // Set the last size as measured auto size and stop measuring.
            // We subtract 2 instead of 1 to work around inconsistent scaling
            // due to the rounding error involved between the integer values
            // of offsetWidth/Height and scrollWidth/Height versus the double
            // values of the actual bounding box.
            this.autoSize = size - 2;
            // Reset temporary styles.
            container.style.overflow = "hidden";
            container.style.visibility = "visible";
            container.innerText = initialInnerText;
        }
    }
};

});

parcelRegister("8z0Bm", function(module, exports) {

$parcel$export(module.exports, "render", () => $63c20f18bec94f4d$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
function $63c20f18bec94f4d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_transition_fade, {
        appear: "",
        onAfterEnter: $options.determineAutoSize
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", (0, $xo6Zx.mergeProps)({
                    key: $options.lyrics,
                    ref: "container",
                    class: "karaokePlayer-lyrics leading-snug whitespace-pre overflow-hidden box-border grow shrink-0 font-bree text-almostBlack min-h-[calc(100vh_-_20rem)] h-[unset] w-[90%]"
                }, _ctx.$attrs, {
                    style: {
                        fontSize: `${$data.autoSize}px`
                    }
                }), (0, $d8ZDz.toDisplayString)($options.lyrics), 17))
            ]),
        _: 1
    }, 8, [
        "onAfterEnter"
    ]);
}

});

parcelRegister("7yBFG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5808ee23042bb859$export$2e2bcd8739ae039);
let $5808ee23042bb859$var$NOOP = ()=>{};
var $5808ee23042bb859$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("9SSpS", function(module, exports) {

$parcel$export(module.exports, "default", () => $73235e28fa480f12$export$2e2bcd8739ae039);
let $73235e28fa480f12$var$script;



let $73235e28fa480f12$var$initialize = ()=>{
    $73235e28fa480f12$var$script = (parcelRequire("lgdJI"));
    if ($73235e28fa480f12$var$script.__esModule) $73235e28fa480f12$var$script = $73235e28fa480f12$var$script.default;
    $73235e28fa480f12$var$script.render = (parcelRequire("eprsd")).render;
    (parcelRequire("fAZr6")).default($73235e28fa480f12$var$script);
    $73235e28fa480f12$var$script.__scopeId = 'data-v-351297';
    $73235e28fa480f12$var$script.__file = "SongPlayer.vue";
};
$73235e28fa480f12$var$initialize();
var $73235e28fa480f12$export$2e2bcd8739ae039 = $73235e28fa480f12$var$script;

});
parcelRegister("lgdJI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f7a5bf5bfbfa6e7c$export$2e2bcd8739ae039);

var $QlUa3 = parcelRequire("QlUa3");

var $gXsVv = parcelRequire("gXsVv");

var $f8WJF = parcelRequire("f8WJF");
var $f7a5bf5bfbfa6e7c$export$2e2bcd8739ae039 = {
    name: "SongPlayer",
    components: {
        TransitionFade: $QlUa3.default,
        ProgressControl: $gXsVv.default,
        VolumeControl: $f8WJF.default
    },
    data () {
        return {
            currentTime: 0,
            duration: undefined
        };
    },
    props: {
        song: {
            type: Object,
            default: null,
            validator: (song)=>!song || Object.keys(song).includes("publicUrl")
        },
        playing: {
            type: Boolean,
            default: false
        },
        muted: {
            type: Boolean,
            default: false
        },
        volume: {
            type: Number,
            default: 75,
            validator: (volume)=>volume >= 0 && volume <= 100
        }
    },
    watch: {
        async playing (playing) {
            if (playing) try {
                await this.$refs.audio?.play();
            } catch (e) {
                if (e instanceof DOMException && e.name === "AbortError") // Ignore. Happens when either `pause()` is triggered or navigation
                // occurs while the `play()` Promise has not yet been fulfilled.
                return;
                throw e;
            }
            else this.$refs.audio?.pause();
        },
        song () {
            // Reset the instance data.
            Object.assign(this.$data, this.$options.data.call(this));
        },
        currentTime () {
            this.$emit("update:currentTime", this.currentTime);
        }
    },
    mounted () {
        this.duration = this.$refs.audio.duration;
    },
    updated () {
        this.duration = this.$refs.audio.duration;
    },
    methods: {
        seek (currentTime) {
            this.$refs.audio && (this.$refs.audio.currentTime = currentTime);
        },
        onEnded () {
            this.seek(0);
            this.$emit("update:playing", false);
        }
    }
};

});
parcelRegister("gXsVv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c58898383e235414$export$2e2bcd8739ae039);
let $c58898383e235414$var$script;



let $c58898383e235414$var$initialize = ()=>{
    $c58898383e235414$var$script = (parcelRequire("f0ZC5"));
    if ($c58898383e235414$var$script.__esModule) $c58898383e235414$var$script = $c58898383e235414$var$script.default;
    $c58898383e235414$var$script.render = (parcelRequire("7wLYm")).render;
    (parcelRequire("kRPE4")).default($c58898383e235414$var$script);
    $c58898383e235414$var$script.__scopeId = 'data-v-019b56';
    $c58898383e235414$var$script.__file = "ProgressControl.vue";
};
$c58898383e235414$var$initialize();
var $c58898383e235414$export$2e2bcd8739ae039 = $c58898383e235414$var$script;

});
parcelRegister("f0ZC5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $aee6a6339dd455e1$export$2e2bcd8739ae039);
// TODO: Consider refactoring ProgressControl & VolumeControl to use a common Slider,
//       with orientation (horizontal / vertical) option.

var $QlUa3 = parcelRequire("QlUa3");
const $aee6a6339dd455e1$var$timeFormatter = new Intl.DateTimeFormat("nl-NL", {
    minute: "2-digit",
    second: "2-digit"
});
var $aee6a6339dd455e1$export$2e2bcd8739ae039 = {
    name: "ProgressControl",
    components: {
        TransitionFade: $QlUa3.default
    },
    data () {
        return {
            dragging: false,
            popupLabel: "Laden...",
            popupPositionX: 0,
            popupInTransition: false,
            popupVisible: false,
            closeDelay: 50,
            closeTimeout: null
        };
    },
    props: {
        duration: {
            type: Number
        },
        currentTime: {
            type: Number
        },
        muted: {
            type: Boolean
        }
    },
    computed: {
        progress () {
            if (!this.duration) return 0;
            return this.currentTime / this.duration * 100;
        }
    },
    methods: {
        onWheel (event) {
            if (!this.duration) return;
            // Change volume by mouse wheel while hovering the volume control.
            // Clamp the volume to values from 0 to song duration.
            const currentTime = Math.max(0, Math.min(this.currentTime + event.deltaY / 10, this.duration));
            this.$emit("update:currentTime", currentTime);
        },
        seek (event) {
            this.$emit("update:currentTime", this.getTime(event));
        },
        dragStart () {
            // Start mouse down + move dragging to freely adjust the playback progress.
            this.dragging = true;
            document.addEventListener("mousemove", this.drag);
            document.addEventListener("mouseup", this.dragEnd, {
                once: true
            });
        },
        touchStart (event) {
            if (event.touches.length > 1) return;
            // Start touch + move dragging to freely adjust the playback progress.
            this.dragging = true;
            this.showPopup();
            document.addEventListener("touchmove", this.drag);
            document.addEventListener("touchend", this.dragEnd, {
                once: true
            });
        },
        drag (event) {
            // Use the mouse move event to set the playback progress,
            // if we are currently dragging (= after mouse down).
            if (!this.dragging) return;
            this.seek(event);
        },
        dragEnd () {
            // End dragging with the mouse up event.
            // Cancel the mouse move listener and stop drag-mode.
            document.removeEventListener("mousemove", this.drag);
            document.removeEventListener("touchmove", this.drag);
            this.dragging = false;
        },
        hover (event) {
            if (!this.duration) // Song has not finished loading.
            // Popup position and label are as initially defined in `data()`.
            return;
            const time = this.getTime(event);
            this.popupPositionX = time / this.duration * 100;
            this.popupLabel = $aee6a6339dd455e1$var$timeFormatter.format(new Date(time * 1000));
        },
        getTime (event) {
            if (!this.duration) return 0;
            const clientX = event.type === "touchmove" ? event.touches[0].clientX : event.clientX;
            // Set the progress via a click or mouse move (if currently dragging) event,
            // by inspecting the event's coordinates in respect to the slider's bounding rect.
            const boundingBox = this.$refs.slider.getBoundingClientRect();
            let progressFactor = (clientX - boundingBox.x) / boundingBox.width;
            // Clamp the progress to values from 0 to almost 1.
            // Why almost 1? Because setting an audio element's currentTime
            // to its duration makes it jump to the start. We want to stay at the end.
            progressFactor = Math.max(0, Math.min(progressFactor, 0.99));
            // Map the calculated progress onto an absolute time.
            return this.duration * progressFactor;
        },
        showPopup () {
            // Show the popup. If it is currently waiting to close, cancel the wait.
            if (this.closeTimeout) window.clearTimeout(this.closeTimeout);
            this.popupVisible = true;
        },
        hidePopup () {
            // Hide the popup after waiting for a moment,
            // for improved UX and flicker-free display.
            const vm = this;
            this.closeTimeout = window.setTimeout(()=>{
                vm.popupVisible = false;
            }, this.closeDelay);
        }
    }
};

});

parcelRegister("7wLYm", function(module, exports) {

$parcel$export(module.exports, "render", () => $57b0bbe8a3f0e8fe$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
var $jH5uA = parcelRequire("jH5uA");
const $57b0bbe8a3f0e8fe$var$_hoisted_1 = {
    ref: "slider",
    class: "flex justify-start h-px w-full bg-player-control-default group-hover:bg-player-control-darkened transition-colors duration-200"
};
const $57b0bbe8a3f0e8fe$var$_hoisted_2 = {
    key: 0,
    class: "absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/2 block w-4 h-4 bg-player-control-default rounded-full"
};
function $57b0bbe8a3f0e8fe$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", {
        class: "group relative grow flex items-center h-full cursor-pointer",
        onWheel: _cache[0] || (_cache[0] = (...args)=>$options.onWheel && $options.onWheel(...args)),
        onClick: _cache[1] || (_cache[1] = (...args)=>$options.seek && $options.seek(...args)),
        onMousedown: _cache[2] || (_cache[2] = (...args)=>$options.dragStart && $options.dragStart(...args)),
        onTouchstart: _cache[3] || (_cache[3] = (...args)=>$options.touchStart && $options.touchStart(...args)),
        onMousemove: _cache[4] || (_cache[4] = (...args)=>$options.hover && $options.hover(...args)),
        onTouchmove: _cache[5] || (_cache[5] = (...args)=>$options.hover && $options.hover(...args)),
        onMouseover: _cache[6] || (_cache[6] = (...args)=>$options.showPopup && $options.showPopup(...args)),
        onMouseout: _cache[7] || (_cache[7] = (...args)=>$options.hidePopup && $options.hidePopup(...args)),
        onTouchend: _cache[8] || (_cache[8] = (...args)=>$options.hidePopup && $options.hidePopup(...args))
    }, [
        (0, $xo6Zx.createElementVNode)("div", $57b0bbe8a3f0e8fe$var$_hoisted_1, [
            (0, $xo6Zx.createElementVNode)("div", {
                class: (0, $d8ZDz.normalizeClass)([
                    "relative h-full bg-player-control-lightened duration-200",
                    [
                        {
                            'bg-opacity-25': $props.muted
                        },
                        // Transition `width` only on click, but not while dragging.
                        // A `width` transition while dragging creates an undesirable lagging effect.
                        $data.dragging ? 'transition-colors' : 'transition-all'
                    ]
                ]),
                style: (0, $d8ZDz.normalizeStyle)({
                    width: `${$options.progress}%`
                })
            }, [
                (0, $xo6Zx.createVNode)(_component_transition_fade, {
                    duration: 500
                }, {
                    default: (0, $xo6Zx.withCtx)(()=>[
                            $props.currentTime > 0 ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("span", $57b0bbe8a3f0e8fe$var$_hoisted_2)) : (0, $xo6Zx.createCommentVNode)("", true)
                        ]),
                    _: 1
                })
            ], 6)
        ], 512),
        (0, $xo6Zx.createVNode)(_component_transition_fade, {
            duration: 300
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    (0, $xo6Zx.withDirectives)((0, $xo6Zx.createElementVNode)("div", {
                        class: "absolute bg-black text-white rounded-md p-1 -translate-x-1/2 -translate-y-full",
                        style: (0, $d8ZDz.normalizeStyle)({
                            left: `${$data.popupPositionX}%`
                        })
                    }, (0, $d8ZDz.toDisplayString)($data.popupLabel), 5), [
                        [
                            (0, $jH5uA.vShow),
                            $data.popupVisible
                        ]
                    ])
                ]),
            _: 1
        })
    ], 32);
}

});

parcelRegister("kRPE4", function(module, exports) {

$parcel$export(module.exports, "default", () => $f310d18bd4500792$export$2e2bcd8739ae039);
let $f310d18bd4500792$var$NOOP = ()=>{};
var $f310d18bd4500792$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("f8WJF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0652a0869008f02$export$2e2bcd8739ae039);
let $b0652a0869008f02$var$script;



let $b0652a0869008f02$var$initialize = ()=>{
    $b0652a0869008f02$var$script = (parcelRequire("kcBdo"));
    if ($b0652a0869008f02$var$script.__esModule) $b0652a0869008f02$var$script = $b0652a0869008f02$var$script.default;
    $b0652a0869008f02$var$script.render = (parcelRequire("kJoay")).render;
    (parcelRequire("aWs9t")).default($b0652a0869008f02$var$script);
    $b0652a0869008f02$var$script.__scopeId = 'data-v-79b75b';
    $b0652a0869008f02$var$script.__file = "VolumeControl.vue";
};
$b0652a0869008f02$var$initialize();
var $b0652a0869008f02$export$2e2bcd8739ae039 = $b0652a0869008f02$var$script;

});
parcelRegister("kcBdo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $eb51cbc27663d3c5$export$2e2bcd8739ae039);

var $6voCs = parcelRequire("6voCs");

var $QlUa3 = parcelRequire("QlUa3");
var $eb51cbc27663d3c5$export$2e2bcd8739ae039 = {
    name: "VolumeControl",
    components: {
        InlineSvg: (/*@__PURE__*/$parcel$interopDefault($6voCs)),
        TransitionFade: $QlUa3.default
    },
    inheritAttrs: false,
    data () {
        return {
            popupVisible: false,
            dragging: false,
            closeDelay: 100,
            closeTimeout: null,
            allowMuteDelay: 50,
            allowMuteTimeout: null
        };
    },
    props: {
        volume: {
            type: Number,
            default: 75,
            validator: (volume)=>volume >= 0 && volume <= 100
        },
        muted: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        toggleMuted () {
            this.$emit("update:muted", !this.muted);
        },
        onWheel (event) {
            // Change volume by mouse wheel while hovering the volume control.
            // Clamp the volume to values from 0 to 100.
            const volume = Math.max(0, Math.min(this.volume + event.deltaY / 5, 100));
            this.$emit("update:volume", volume);
        },
        showPopup ({ type: type }) {
            const touch = type === "touchstart";
            // Show the popup. If it is currently waiting to close, cancel the wait.
            if (this.closeTimeout) window.clearTimeout(this.closeTimeout);
            if (!this.popupVisible) // Enable click to toggle mute only after a delay.
            // This way we can allow touch devices (digibord
            // screens) to open and close the popup via
            // touch, without accidentally muting.
            this.allowMuteTimeout = window.setTimeout(// Note: `this.$refs.mute` is null when navigating away while timeout passes.
            ()=>this.$refs.mute?.addEventListener(touch ? "touchstart" : "click", this.toggleMuted), this.allowMuteDelay);
            this.popupVisible = true;
        },
        hidePopup () {
            // Hide the popup after waiting for a moment,
            // for improved UX and flicker-free display.
            const vm = this;
            this.closeTimeout = window.setTimeout(()=>{
                // Note: `this.$refs.mute` is null when navigating away while timeout passes.
                this.$refs.mute?.removeEventListener("click", this.toggleMuted);
                this.$refs.mute?.removeEventListener("touchstart", this.toggleMuted);
                if (this.allowMuteTimeout) window.clearTimeout(this.allowMuteTimeout);
                vm.popupVisible = false;
            }, this.closeDelay);
        },
        set (event) {
            const clientY = event.type === "touchmove" ? event.touches[0].clientY : event.clientY;
            // Set the volume via a click or mouse move (if currently dragging) event,
            // by inspecting the event's coordinates in respect to the slider's bounding rect.
            const boundingBox = this.$refs.slider.getBoundingClientRect();
            let volume = 100 - (clientY - boundingBox.y) / boundingBox.height * 100;
            // Clamp the volume to values from 0 to 100.
            volume = Math.max(0, Math.min(volume, 100));
            this.$emit("update:volume", volume);
        },
        dragStart () {
            // Start mouse down + move dragging to freely adjust the volume.
            this.dragging = true;
            document.addEventListener("mousemove", this.drag);
            document.addEventListener("mouseup", this.dragEnd, {
                once: true
            });
        },
        touchStart (event) {
            if (event.touches.length > 1) return;
            // Start mouse down + move dragging to freely adjust the volume.
            this.dragging = true;
            document.addEventListener("touchmove", this.drag);
            document.addEventListener("touchend", this.dragEnd, {
                once: true
            });
        },
        drag (event) {
            // Use the mouse move event to set the volume,
            // if we are currently dragging (= after mouse down).
            if (!this.dragging) return;
            this.set(event);
        },
        dragEnd () {
            // End dragging with the mouse up event.
            // Cancel the mouse move listener and stop drag-mode.
            document.removeEventListener("mousemove", this.drag);
            document.removeEventListener("touchmove", this.drag);
            this.dragging = false;
        }
    }
};

});
parcelRegister("6voCs", function(module, exports) {

(function(global, factory) {
    module.exports = factory((parcelRequire("6r9FW")));
})(module.exports, function(vue) {
    'use strict';
    // peer dep is not installed during test
    // eslint-disable-next-line import/no-unresolved
    /** @type {Record<string, PromiseWithState<Element>>} */ var cache = {};
    /**
     * Remove false attrs
     * @param {Object} attrs
     */ function filterAttrs(attrs) {
        return Object.keys(attrs).reduce(function(result, key) {
            if (attrs[key] !== false && attrs[key] !== null && attrs[key] !== undefined) result[key] = attrs[key];
            return result;
        }, {});
    }
    var InlineSvg = {
        name: 'InlineSvg',
        inheritAttrs: false,
        render: function render() {
            if (!this.svgElSource) return null;
            return vue.h('svg', Object.assign({}, // source attrs
            this.getSvgAttrs(this.svgElSource), // component attrs and listeners
            filterAttrs(this.$attrs), // content
            {
                innerHTML: this.getSvgContent(this.svgElSource)
            }));
        },
        props: {
            src: {
                type: String,
                required: true
            },
            title: {
                type: String
            },
            transformSource: {
                type: Function,
                "default": function _default(svg) {
                    return svg;
                }
            },
            keepDuringLoading: {
                type: Boolean,
                "default": true
            }
        },
        emits: [
            'loaded',
            'unloaded',
            'error'
        ],
        data: function data() {
            return {
                /** @type {SVGElement} */ svgElSource: null,
                /** @type {XMLHttpRequest} */ request: undefined
            };
        },
        watch: {
            src: function src(newValue) {
                // re-generate cached svg (`svgElSource`)
                this.getSource(newValue);
            }
        },
        mounted: function mounted() {
            // generate `svgElSource`
            this.getSource(this.src);
        },
        methods: {
            getSvgAttrs: function getSvgAttrs(svgEl) {
                // copy attrs
                var svgAttrs = {};
                var attrs = svgEl.attributes;
                if (!attrs) return svgAttrs;
                for(var i = attrs.length - 1; i >= 0; i--)svgAttrs[attrs[i].name] = attrs[i].value;
                return svgAttrs;
            },
            getSvgContent: function getSvgContent(svgEl) {
                svgEl = svgEl.cloneNode(true);
                svgEl = this.transformSource(svgEl);
                if (this.title) setTitle(svgEl, this.title);
                // copy inner html
                return svgEl.innerHTML;
            },
            /**
         * Get svgElSource
         * @param {string} src
         */ getSource: function getSource(src) {
                var _this = this;
                // fill cache by src with promise
                if (!cache[src]) // download
                cache[src] = this.download(src);
                // notify svg is unloaded
                if (this.svgElSource && cache[src].getIsPending() && !this.keepDuringLoading) {
                    this.svgElSource = null;
                    this.$emit('unloaded');
                }
                // inline svg when cached promise resolves
                cache[src].then(function(svg) {
                    _this.svgElSource = svg;
                    // wait to render
                    _this.$nextTick(function() {
                        // notify
                        _this.$emit('loaded', _this.$el);
                    });
                })["catch"](function(err) {
                    // notify svg is unloaded
                    if (_this.svgElSource) {
                        _this.svgElSource = null;
                        _this.$emit('unloaded');
                    }
                    // remove cached rejected promise so next image can try load again
                    delete cache[src];
                    _this.$emit('error', err);
                });
            },
            /**
         * Get the contents of the SVG
         * @param {string} url
         * @returns {PromiseWithState<Element>}
         */ download: function download(url) {
                var _this2 = this;
                return makePromiseState(new Promise(function(resolve, reject) {
                    var request = new XMLHttpRequest();
                    request.open('GET', url, true);
                    _this2.request = request;
                    request.onload = function() {
                        if (request.status >= 200 && request.status < 400) try {
                            // Setup a parser to convert the response to text/xml in order for it to be manipulated and changed
                            var parser = new DOMParser();
                            var result = parser.parseFromString(request.responseText, 'text/xml');
                            var svgEl = result.getElementsByTagName('svg')[0];
                            if (svgEl) // svgEl = this.transformSource(svgEl);
                            resolve(svgEl);
                            else reject(new Error('Loaded file is not valid SVG"'));
                        } catch (e) {
                            reject(e);
                        }
                        else reject(new Error('Error loading SVG'));
                    };
                    request.onerror = reject;
                    request.send();
                }));
            }
        }
    };
    /**
     * Create or edit the <title> element of a SVG
     * @param {SVGElement} svg
     * @param {string} title
     */ function setTitle(svg, title) {
        var titleTags = svg.getElementsByTagName('title');
        if (titleTags.length) // overwrite existing title
        titleTags[0].textContent = title;
        else {
            // create a title element if one doesn't already exist
            var titleEl = document.createElementNS('http://www.w3.org/2000/svg', 'title');
            titleEl.textContent = title;
            // svg.prepend(titleEl);
            svg.insertBefore(titleEl, svg.firstChild);
        }
    }
    /**
     * @typedef {Promise & object} PromiseWithState
     * @property {function: boolean} getIsPending
     * @template T
     */ /**
     * This function allow you to modify a JS Promise by adding some status properties.
     * @template {any} T
     * @param {Promise<T>|PromiseWithState<T>} promise
     * @return {PromiseWithState<T>}
     */ function makePromiseState(promise) {
        // Don't modify any promise that has been already modified.
        if (promise.getIsPending) return promise;
        // Set initial state
        var isPending = true;
        // Observe the promise, saving the fulfillment in a closure scope.
        var result = promise.then(function(v) {
            isPending = false;
            return v;
        }, function(e) {
            isPending = false;
            throw e;
        });
        result.getIsPending = function getIsPending() {
            return isPending;
        };
        return result;
    }
    return InlineSvg;
});

});


parcelRegister("kJoay", function(module, exports) {

$parcel$export(module.exports, "render", () => $f17ac22533a47de4$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
var $jH5uA = parcelRequire("jH5uA");
const $f17ac22533a47de4$var$_hoisted_1 = {
    class: "group absolute bottom-0 left-10 block w-10 h-48 pb-12 -translate-x-[38px] z-10"
};
const $f17ac22533a47de4$var$_hoisted_2 = {
    ref: "slider",
    class: "flex flex-col justify-end w-[1px] h-full bg-player-volume-line-control-default transition-colors duration-200"
};
const $f17ac22533a47de4$var$_hoisted_3 = {
    class: "absolute inset-0 block z-10",
    ref: "mute"
};
const $f17ac22533a47de4$var$_hoisted_4 = {
    class: "sr-only"
};










function $f17ac22533a47de4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    const _component_inline_svg = (0, $xo6Zx.resolveComponent)("inline-svg");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, [
        (0, $xo6Zx.createElementVNode)("button", (0, $xo6Zx.mergeProps)({
            class: "relative h-10 w-10 ml-1 focus:outline-none"
        }, _ctx.$attrs, {
            onWheel: _cache[3] || (_cache[3] = (...args)=>$options.onWheel && $options.onWheel(...args)),
            onMouseover: _cache[4] || (_cache[4] = (...args)=>$options.showPopup && $options.showPopup(...args)),
            onTouchstart: _cache[5] || (_cache[5] = (...args)=>$options.showPopup && $options.showPopup(...args)),
            onMouseout: _cache[6] || (_cache[6] = (...args)=>$options.hidePopup && $options.hidePopup(...args)),
            onBlur: _cache[7] || (_cache[7] = (...args)=>$options.hidePopup && $options.hidePopup(...args))
        }), [
            (0, $xo6Zx.createVNode)(_component_transition_fade, null, {
                default: (0, $xo6Zx.withCtx)(()=>[
                        (0, $xo6Zx.withDirectives)((0, $xo6Zx.createElementVNode)("span", $f17ac22533a47de4$var$_hoisted_1, [
                            (0, $xo6Zx.createElementVNode)("span", {
                                onClick: _cache[0] || (_cache[0] = (...args)=>$options.set && $options.set(...args)),
                                onMousedown: _cache[1] || (_cache[1] = (...args)=>$options.dragStart && $options.dragStart(...args)),
                                onTouchstart: _cache[2] || (_cache[2] = (...args)=>$options.touchStart && $options.touchStart(...args)),
                                class: "flex flex-col items-center h-full w-full px-2 py-[1.125rem] rounded-full rounded-bl-none bg-school-level-volume text-player-control-default"
                            }, [
                                (0, $xo6Zx.createElementVNode)("span", $f17ac22533a47de4$var$_hoisted_2, [
                                    (0, $xo6Zx.createElementVNode)("span", {
                                        class: (0, $d8ZDz.normalizeClass)([
                                            "relative block w-full duration-200",
                                            [
                                                {
                                                    'bg-opacity-25': $props.muted
                                                },
                                                // Transition `height` only on click, but not while dragging.
                                                // A `height` transition while dragging creates an undesirable lagging effect.
                                                $data.dragging ? 'transition-colors' : 'transition-all'
                                            ]
                                        ]),
                                        style: (0, $d8ZDz.normalizeStyle)({
                                            height: `${$props.volume}%`
                                        })
                                    }, [
                                        ..._cache[8] || (_cache[8] = [
                                            (0, $xo6Zx.createElementVNode)("span", {
                                                class: "absolute top-0 left-1/2 -translate-y-1/2 -translate-x-1/2 block w-4 h-4 bg-player-volume-control-default rounded-full"
                                            }, null, -1)
                                        ])
                                    ], 6)
                                ], 512)
                            ], 32)
                        ], 512), [
                            [
                                (0, $jH5uA.vShow),
                                $data.popupVisible || $data.dragging
                            ]
                        ])
                    ]),
                _: 1
            }),
            (0, $xo6Zx.createElementVNode)("span", $f17ac22533a47de4$var$_hoisted_3, [
                $props.muted ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_inline_svg, {
                    key: 0,
                    src: (parcelRequire("2IRGO")),
                    class: "w-full h-full p-[0.65rem]"
                }, null, 8, [
                    "src"
                ])) : $props.volume < 25 ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_inline_svg, {
                    key: 1,
                    src: (parcelRequire("fx0VT")),
                    class: "w-full h-full p-[0.65rem]"
                }, null, 8, [
                    "src"
                ])) : $props.volume < 50 ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_inline_svg, {
                    key: 2,
                    src: (parcelRequire("4rDKd")),
                    class: "w-full h-full p-[0.65rem]"
                }, null, 8, [
                    "src"
                ])) : $props.volume < 75 ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_inline_svg, {
                    key: 3,
                    src: (parcelRequire("5Fkfv")),
                    class: "w-full h-full p-[0.65rem]"
                }, null, 8, [
                    "src"
                ])) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_inline_svg, {
                    key: 4,
                    src: (parcelRequire("80BBp")),
                    class: "w-full h-full p-[0.65rem]"
                }, null, 8, [
                    "src"
                ]))
            ], 512)
        ], 16),
        (0, $xo6Zx.createElementVNode)("ul", $f17ac22533a47de4$var$_hoisted_4, [
            (0, $xo6Zx.createElementVNode)("li", null, [
                (0, $xo6Zx.createVNode)(_component_inline_svg, {
                    src: (parcelRequire("2IRGO"))
                }, null, 8, [
                    "src"
                ])
            ]),
            (0, $xo6Zx.createElementVNode)("li", null, [
                (0, $xo6Zx.createVNode)(_component_inline_svg, {
                    src: (parcelRequire("fx0VT"))
                }, null, 8, [
                    "src"
                ])
            ]),
            (0, $xo6Zx.createElementVNode)("li", null, [
                (0, $xo6Zx.createVNode)(_component_inline_svg, {
                    src: (parcelRequire("4rDKd"))
                }, null, 8, [
                    "src"
                ])
            ]),
            (0, $xo6Zx.createElementVNode)("li", null, [
                (0, $xo6Zx.createVNode)(_component_inline_svg, {
                    src: (parcelRequire("5Fkfv"))
                }, null, 8, [
                    "src"
                ])
            ]),
            (0, $xo6Zx.createElementVNode)("li", null, [
                (0, $xo6Zx.createVNode)(_component_inline_svg, {
                    src: (parcelRequire("80BBp"))
                }, null, 8, [
                    "src"
                ])
            ])
        ])
    ], 64);
}

});
parcelRegister("2IRGO", function(module, exports) {
module.exports = $parcel$resolve("3JQe2");

});

parcelRegister("fx0VT", function(module, exports) {
module.exports = $parcel$resolve("1JoNs");

});

parcelRegister("4rDKd", function(module, exports) {
module.exports = $parcel$resolve("3RnMD");

});

parcelRegister("5Fkfv", function(module, exports) {
module.exports = $parcel$resolve("f94EK");

});

parcelRegister("80BBp", function(module, exports) {
module.exports = $parcel$resolve("5pRAy");

});


parcelRegister("aWs9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f7528849ca46536$export$2e2bcd8739ae039);
let $7f7528849ca46536$var$NOOP = ()=>{};
var $7f7528849ca46536$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("eprsd", function(module, exports) {

$parcel$export(module.exports, "render", () => $a7d8b246c55dbbb0$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
const $a7d8b246c55dbbb0$var$_hoisted_1 = {
    key: 0,
    class: "flex items-center h-4 w-full text-player-control-default fill-current"
};
const $a7d8b246c55dbbb0$var$_hoisted_2 = [
    "title"
];
const $a7d8b246c55dbbb0$var$_hoisted_3 = {
    key: 0,
    xmlns: "http://www.w3.org/2000/svg",
    width: "17",
    height: "19",
    viewBox: "0 0 17 19",
    class: "w-4 h-4 p-[2px] fill-current"
};
const $a7d8b246c55dbbb0$var$_hoisted_4 = {
    key: 1,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.81 11.81",
    class: "w-10 h-10 fill-current"
};
const $a7d8b246c55dbbb0$var$_hoisted_5 = [
    "src",
    "muted",
    "volume"
];
function $a7d8b246c55dbbb0$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    const _component_progress_control = (0, $xo6Zx.resolveComponent)("progress-control");
    const _component_volume_control = (0, $xo6Zx.resolveComponent)("volume-control");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_transition_fade, {
        appear: ""
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                $props.song && $props.song.publicUrl ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $a7d8b246c55dbbb0$var$_hoisted_1, [
                    (0, $xo6Zx.createElementVNode)("button", {
                        onClick: _cache[0] || (_cache[0] = ($event)=>_ctx.$emit('update:playing', !$props.playing)),
                        title: $props.playing ? "\u25AE\u25AE Pauze" : "\u25B6 Afspelen",
                        class: "w-7 h-7 flex justify-center items-center rounded-full focus:outline-none text-player-icon bg-player-control-default hover:bg-player-control-darkened transition-colors duration-100"
                    }, [
                        (0, $xo6Zx.createVNode)(_component_transition_fade, {
                            appear: ""
                        }, {
                            default: (0, $xo6Zx.withCtx)(()=>[
                                    $props.playing ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("svg", $a7d8b246c55dbbb0$var$_hoisted_3, [
                                        ..._cache[6] || (_cache[6] = [
                                            (0, $xo6Zx.createElementVNode)("path", {
                                                d: "M0 0h6v19H0zM11 0h6v19h-6z"
                                            }, null, -1)
                                        ])
                                    ])) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("svg", $a7d8b246c55dbbb0$var$_hoisted_4, [
                                        ..._cache[7] || (_cache[7] = [
                                            (0, $xo6Zx.createElementVNode)("path", {
                                                d: "M4.61,7.99c-.36.17-.65-.02-.65-.41v-3.35c0-.4.29-.58.65-.41l3.82,1.8c.36.17.36.44,0,.61l-3.81,1.77Z"
                                            }, null, -1)
                                        ])
                                    ]))
                                ]),
                            _: 1
                        })
                    ], 8, $a7d8b246c55dbbb0$var$_hoisted_2),
                    (0, $xo6Zx.createVNode)(_component_progress_control, {
                        duration: $data.duration,
                        currentTime: $data.currentTime,
                        "onUpdate:currentTime": $options.seek,
                        muted: $props.muted
                    }, null, 8, [
                        "duration",
                        "currentTime",
                        "onUpdate:currentTime",
                        "muted"
                    ]),
                    (0, $xo6Zx.createVNode)(_component_volume_control, {
                        volume: $props.volume,
                        "onUpdate:volume": _cache[1] || (_cache[1] = ($event)=>_ctx.$emit('update:volume', $event)),
                        muted: $props.muted,
                        "onUpdate:muted": _cache[2] || (_cache[2] = ($event)=>_ctx.$emit('update:muted', $event))
                    }, null, 8, [
                        "volume",
                        "muted"
                    ]),
                    (0, $xo6Zx.createElementVNode)("audio", {
                        ref: "audio",
                        src: $props.song.publicUrl,
                        muted: $props.muted,
                        volume: $props.volume / 100,
                        onDurationchange: _cache[3] || (_cache[3] = ($event)=>$data.duration = _ctx.$refs.audio?.duration),
                        onTimeupdate: _cache[4] || (_cache[4] = ($event)=>$data.currentTime = _ctx.$refs.audio?.currentTime),
                        onEnded: _cache[5] || (_cache[5] = (...args)=>$options.onEnded && $options.onEnded(...args)),
                        class: "hidden"
                    }, null, 40, $a7d8b246c55dbbb0$var$_hoisted_5)
                ])) : (0, $xo6Zx.createCommentVNode)("", true)
            ]),
        _: 1
    });
}

});

parcelRegister("fAZr6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5a9dfc476fef91a$export$2e2bcd8739ae039);
let $b5a9dfc476fef91a$var$NOOP = ()=>{};
var $b5a9dfc476fef91a$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("5AEsP", function(module, exports) {

$parcel$export(module.exports, "render", () => $411fb3db05cb3538$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $411fb3db05cb3538$var$_hoisted_1 = {
    key: 0,
    class: "karaokePlayer-view flex h-full flex-col"
};
const $411fb3db05cb3538$var$_hoisted_2 = {
    class: "grow-0 shrink-0"
};
const $411fb3db05cb3538$var$_hoisted_3 = {
    class: "title text-[30px] text-almostBlack font-bree"
};
const $411fb3db05cb3538$var$_hoisted_4 = {
    class: "karaokePlayer-toolbox flex justify-between w-full grow-0 shrink-0"
};
const $411fb3db05cb3538$var$_hoisted_5 = {
    class: "bg-white rounded-3xl grow-0 shrink basis-[32%]"
};
const $411fb3db05cb3538$var$_hoisted_6 = {
    class: "songMetaDetails text-white items-center bg-white rounded-full rounded-bl-none flex justify-between h-[45px] pr-[7px] pl-[15px]"
};
const $411fb3db05cb3538$var$_hoisted_7 = {
    class: "title grow text-[17px] pl-[6px] font-bree"
};
const $411fb3db05cb3538$var$_hoisted_8 = {
    class: "duration text-[16px] pr-[11px] font-bree"
};
const $411fb3db05cb3538$var$_hoisted_9 = {
    class: "musicDownload"
};
const $411fb3db05cb3538$var$_hoisted_10 = [
    "href"
];
const $411fb3db05cb3538$var$_hoisted_11 = {
    key: 0,
    class: "bg-white rounded-3xl grow-0 shrink basis-[32%]"
};
const $411fb3db05cb3538$var$_hoisted_12 = {
    class: "audioPlayer-karaoke rounded-full rounded-bl-none flex items-center h-[45px] min-w-[200px] pr-[7px] pl-[15px]"
};
const $411fb3db05cb3538$var$_hoisted_13 = {
    class: "musicDownload"
};
const $411fb3db05cb3538$var$_hoisted_14 = [
    "href"
];
const $411fb3db05cb3538$var$_hoisted_15 = {
    key: 1,
    class: "bg-white rounded-3xl grow-0 shrink basis-[32%]"
};
const $411fb3db05cb3538$var$_hoisted_16 = {
    class: "audioPlayer-karaoke rounded-full rounded-bl-none flex items-center h-[45px] min-w-[200px] pr-[7px] pl-[15px]"
};
const $411fb3db05cb3538$var$_hoisted_17 = {
    class: "musicDownload"
};
const $411fb3db05cb3538$var$_hoisted_18 = [
    "href"
];
const $411fb3db05cb3538$var$_hoisted_19 = {
    class: "pointer-events-none absolute top-0 right-0 translate-x-[-20%] translate-y-[20%]",
    "aria-hidden": "true",
    width: "112px",
    height: "112px",
    viewBox: "0 0 100.11 100.11"
};
const $411fb3db05cb3538$var$_hoisted_20 = [
    "fill"
];
function $411fb3db05cb3538$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_karaoke_lyrics = (0, $xo6Zx.resolveComponent)("karaoke-lyrics");
    const _component_song_player = (0, $xo6Zx.resolveComponent)("song-player");
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", {
        id: "song-player",
        class: (0, $d8ZDz.normalizeClass)([
            "h-full",
            _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug
        ])
    }, [
        (0, $xo6Zx.createVNode)(_component_transition_fade, {
            duration: 500,
            appear: ""
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    _ctx.routedSong.vocalMix || _ctx.routedSong.karaokeSoundMix ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $411fb3db05cb3538$var$_hoisted_1, [
                        (0, $xo6Zx.createElementVNode)("div", $411fb3db05cb3538$var$_hoisted_2, [
                            (0, $xo6Zx.createElementVNode)("span", $411fb3db05cb3538$var$_hoisted_3, (0, $d8ZDz.toDisplayString)(_ctx.routedSong.title), 1)
                        ]),
                        (0, $xo6Zx.createVNode)(_component_karaoke_lyrics, {
                            cuePoints: _ctx.routedSong?.cuePoints,
                            currentTime: $data.currentTime
                        }, null, 8, [
                            "cuePoints",
                            "currentTime"
                        ]),
                        (0, $xo6Zx.createElementVNode)("ul", $411fb3db05cb3538$var$_hoisted_4, [
                            (0, $xo6Zx.createElementVNode)("li", $411fb3db05cb3538$var$_hoisted_5, [
                                (0, $xo6Zx.createElementVNode)("div", $411fb3db05cb3538$var$_hoisted_6, [
                                    (0, $xo6Zx.createElementVNode)("span", $411fb3db05cb3538$var$_hoisted_7, (0, $d8ZDz.toDisplayString)(_ctx.routedSong.title), 1),
                                    (0, $xo6Zx.createElementVNode)("span", $411fb3db05cb3538$var$_hoisted_8, (0, $d8ZDz.toDisplayString)((_ctx.routedSong.vocalMix || _ctx.routedSong.karaokeSoundMix)?.durationFormatted), 1)
                                ]),
                                (0, $xo6Zx.createElementVNode)("div", $411fb3db05cb3538$var$_hoisted_9, [
                                    _ctx.routedSong.sheetNotes?.publicUrl ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("a", {
                                        key: 0,
                                        href: _ctx.routedSong.sheetNotes.publicUrl,
                                        target: "_blank",
                                        class: "text-almostBlack flex text-[17px] justify-between pb-[26px] pt-[22px] pl-[23px] pr-[17px]"
                                    }, [
                                        ..._cache[8] || (_cache[8] = [
                                            (0, $xo6Zx.createElementVNode)("span", {
                                                class: "download-label--primary"
                                            }, "Bladmuziek", -1),
                                            (0, $xo6Zx.createElementVNode)("span", {
                                                class: "flex items-center gap-[0.4rem] download-label--secondary text-right"
                                            }, [
                                                (0, $xo6Zx.createTextVNode)(" pdf "),
                                                (0, $xo6Zx.createElementVNode)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 100.11 87.6",
                                                    class: "download-icon w-[1.4rem] h-[1.4rem]"
                                                }, [
                                                    (0, $xo6Zx.createElementVNode)("path", {
                                                        d: "M6.53 47.51c3.73-.3 7.44 2.48 7.74 6.31.38 4.77-.37 10.06 0 14.84.16 2.11 1.34 3.82 3.39 4.44 21.56.19 43.21.24 64.76-.03 1.57-.55 2.79-1.87 3.15-3.5.28-4.82-.27-9.9.03-14.69.57-9.29 13.01-9.7 14.35-.81-.19 5.14.31 10.54.02 15.66-.55 9.62-8.37 17.35-17.98 17.86H18C8.5 87.15.54 79.39.02 69.85c-.28-5.21.23-10.68 0-15.91.35-3.38 3.1-6.16 6.51-6.43Z"
                                                    }),
                                                    (0, $xo6Zx.createElementVNode)("path", {
                                                        d: "M42.63 6.23c.82-8.12 13.8-8.89 14.37 1.18v28.43l6.7-6.64c6.84-5.2 15.28 3.25 10.09 10.09-6.27 6.07-12.25 12.46-18.45 18.58-2.79 2.75-6.26 3.38-9.77 1.46A435.31 435.31 0 0 1 24.74 38.5c-4.03-7.28 4.64-14.46 11.08-8.94 2.36 2.03 4.42 4.74 6.82 6.77V6.23Z"
                                                    })
                                                ])
                                            ], -1)
                                        ])
                                    ], 8, $411fb3db05cb3538$var$_hoisted_10)) : (0, $xo6Zx.createCommentVNode)("", true)
                                ])
                            ]),
                            _ctx.routedSong.vocalMix?.publicUrl ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("li", $411fb3db05cb3538$var$_hoisted_11, [
                                (0, $xo6Zx.createElementVNode)("div", $411fb3db05cb3538$var$_hoisted_12, [
                                    (0, $xo6Zx.createVNode)(_component_song_player, {
                                        song: _ctx.routedSong.vocalMix,
                                        playing: $data.vocalMixPlayerPlaying,
                                        "onUpdate:playing": _cache[0] || (_cache[0] = ($event)=>$data.vocalMixPlayerPlaying = $event),
                                        "onUpdate:currentTime": _cache[1] || (_cache[1] = ($event)=>$data.currentTime = $event),
                                        volume: $data.volume,
                                        "onUpdate:volume": _cache[2] || (_cache[2] = ($event)=>$data.volume = $event),
                                        muted: $data.muted,
                                        "onUpdate:muted": _cache[3] || (_cache[3] = ($event)=>$data.muted = $event)
                                    }, null, 8, [
                                        "song",
                                        "playing",
                                        "volume",
                                        "muted"
                                    ])
                                ]),
                                (0, $xo6Zx.createElementVNode)("div", $411fb3db05cb3538$var$_hoisted_13, [
                                    (0, $xo6Zx.createElementVNode)("a", {
                                        href: _ctx.routedSong.vocalMix.publicUrl,
                                        target: "_blank",
                                        class: "text-almostBlack flex text-[17px] justify-between pb-[26px] pt-[22px] pl-[23px] pr-[17px]"
                                    }, [
                                        ..._cache[9] || (_cache[9] = [
                                            (0, $xo6Zx.createElementVNode)("span", {
                                                class: "download-label--primary"
                                            }, "Ingezongen", -1),
                                            (0, $xo6Zx.createElementVNode)("span", {
                                                class: "flex items-center gap-[0.4rem] download-label--secondary text-right"
                                            }, [
                                                (0, $xo6Zx.createTextVNode)(" mp3 "),
                                                (0, $xo6Zx.createElementVNode)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 100.11 87.6",
                                                    class: "download-icon w-[1.4rem] h-[1.4rem]"
                                                }, [
                                                    (0, $xo6Zx.createElementVNode)("path", {
                                                        d: "M6.53 47.51c3.73-.3 7.44 2.48 7.74 6.31.38 4.77-.37 10.06 0 14.84.16 2.11 1.34 3.82 3.39 4.44 21.56.19 43.21.24 64.76-.03 1.57-.55 2.79-1.87 3.15-3.5.28-4.82-.27-9.9.03-14.69.57-9.29 13.01-9.7 14.35-.81-.19 5.14.31 10.54.02 15.66-.55 9.62-8.37 17.35-17.98 17.86H18C8.5 87.15.54 79.39.02 69.85c-.28-5.21.23-10.68 0-15.91.35-3.38 3.1-6.16 6.51-6.43Z"
                                                    }),
                                                    (0, $xo6Zx.createElementVNode)("path", {
                                                        d: "M42.63 6.23c.82-8.12 13.8-8.89 14.37 1.18v28.43l6.7-6.64c6.84-5.2 15.28 3.25 10.09 10.09-6.27 6.07-12.25 12.46-18.45 18.58-2.79 2.75-6.26 3.38-9.77 1.46A435.31 435.31 0 0 1 24.74 38.5c-4.03-7.28 4.64-14.46 11.08-8.94 2.36 2.03 4.42 4.74 6.82 6.77V6.23Z"
                                                    })
                                                ])
                                            ], -1)
                                        ])
                                    ], 8, $411fb3db05cb3538$var$_hoisted_14)
                                ])
                            ])) : (0, $xo6Zx.createCommentVNode)("", true),
                            _ctx.routedSong.karaokeSoundMix?.publicUrl ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("li", $411fb3db05cb3538$var$_hoisted_15, [
                                (0, $xo6Zx.createElementVNode)("div", $411fb3db05cb3538$var$_hoisted_16, [
                                    (0, $xo6Zx.createVNode)(_component_song_player, {
                                        song: _ctx.routedSong.karaokeSoundMix,
                                        playing: $data.karaokeSoundMixPlayerPlaying,
                                        "onUpdate:playing": _cache[4] || (_cache[4] = ($event)=>$data.karaokeSoundMixPlayerPlaying = $event),
                                        "onUpdate:currentTime": _cache[5] || (_cache[5] = ($event)=>$data.currentTime = $event),
                                        volume: $data.volume,
                                        "onUpdate:volume": _cache[6] || (_cache[6] = ($event)=>$data.volume = $event),
                                        muted: $data.muted,
                                        "onUpdate:muted": _cache[7] || (_cache[7] = ($event)=>$data.muted = $event),
                                        class: "text-blue-500"
                                    }, null, 8, [
                                        "song",
                                        "playing",
                                        "volume",
                                        "muted"
                                    ])
                                ]),
                                (0, $xo6Zx.createElementVNode)("div", $411fb3db05cb3538$var$_hoisted_17, [
                                    (0, $xo6Zx.createElementVNode)("a", {
                                        href: _ctx.routedSong.karaokeSoundMix.publicUrl,
                                        target: "_blank",
                                        class: "text-almostBlack flex text-[17px] justify-between pb-[26px] pt-[22px] pl-[23px] pr-[17px]"
                                    }, [
                                        ..._cache[10] || (_cache[10] = [
                                            (0, $xo6Zx.createElementVNode)("span", {
                                                class: "download-label--primary"
                                            }, "Soundmix", -1),
                                            (0, $xo6Zx.createElementVNode)("span", {
                                                class: "flex items-center gap-[0.4rem] download-label--secondary text-right"
                                            }, [
                                                (0, $xo6Zx.createTextVNode)(" mp3 "),
                                                (0, $xo6Zx.createElementVNode)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    viewBox: "0 0 100.11 87.6",
                                                    class: "download-icon w-[1.4rem] h-[1.4rem]"
                                                }, [
                                                    (0, $xo6Zx.createElementVNode)("path", {
                                                        d: "M6.53 47.51c3.73-.3 7.44 2.48 7.74 6.31.38 4.77-.37 10.06 0 14.84.16 2.11 1.34 3.82 3.39 4.44 21.56.19 43.21.24 64.76-.03 1.57-.55 2.79-1.87 3.15-3.5.28-4.82-.27-9.9.03-14.69.57-9.29 13.01-9.7 14.35-.81-.19 5.14.31 10.54.02 15.66-.55 9.62-8.37 17.35-17.98 17.86H18C8.5 87.15.54 79.39.02 69.85c-.28-5.21.23-10.68 0-15.91.35-3.38 3.1-6.16 6.51-6.43Z"
                                                    }),
                                                    (0, $xo6Zx.createElementVNode)("path", {
                                                        d: "M42.63 6.23c.82-8.12 13.8-8.89 14.37 1.18v28.43l6.7-6.64c6.84-5.2 15.28 3.25 10.09 10.09-6.27 6.07-12.25 12.46-18.45 18.58-2.79 2.75-6.26 3.38-9.77 1.46A435.31 435.31 0 0 1 24.74 38.5c-4.03-7.28 4.64-14.46 11.08-8.94 2.36 2.03 4.42 4.74 6.82 6.77V6.23Z"
                                                    })
                                                ])
                                            ], -1)
                                        ])
                                    ], 8, $411fb3db05cb3538$var$_hoisted_18)
                                ])
                            ])) : (0, $xo6Zx.createCommentVNode)("", true)
                        ]),
                        ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("svg", $411fb3db05cb3538$var$_hoisted_19, [
                            (0, $xo6Zx.createElementVNode)("path", {
                                fill: _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw' ? '#127b5d' : '#6c44a5',
                                d: "M50.05,100.17C22.41,100.17,0,77.76,0,50.12S22.41.07,50.05.07s50.05,22.41,50.05,50.05-22.41,50.05-50.05,50.05"
                            }, null, 8, $411fb3db05cb3538$var$_hoisted_20),
                            _cache[11] || (_cache[11] = (0, $xo6Zx.createElementVNode)("path", {
                                fill: "#fff",
                                d: "M33.22,64.61h-.1c-6.11,0-11.08,3.95-11.12,8.84-.03,4.92,4.94,8.96,11.09,9.01h.1\n       c6.11,0,11.08-3.95,11.12-8.84,0-.02,0-.03,0-.05,0-.01,0-.02,0-.03v-36.55l22.32-11.16v27.24\n       c-1.85-1.13-4.13-1.83-6.63-1.84h-.1\n       c-6.1,0-11.08,3.95-11.12,8.84-.03,4.92,4.94,8.96,11.09,9.01h.1\n       c6.11,0,11.08-3.95,11.12-8.84,0-.02,0-.03,0-.05,0-.01,0-.02,0-.03V22.22\n       c0-.77-.4-1.49-1.06-1.9-.66-.4-1.48-.44-2.17-.1l-26.78,13.39\n       c-.76.38-1.23,1.15-1.23,1.99v30.85\n       c-1.85-1.13-4.13-1.83-6.63-1.84"
                            }, null, -1))
                        ]))
                    ])) : (0, $xo6Zx.createCommentVNode)("", true)
                ]),
            _: 1
        })
    ], 2);
}

});

parcelRegister("bA9X9", function(module, exports) {

$parcel$export(module.exports, "default", () => $86eac6f68c3f4032$export$2e2bcd8739ae039);
let $86eac6f68c3f4032$var$NOOP = ()=>{};
var $86eac6f68c3f4032$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("PWMme", function(module, exports) {

$parcel$export(module.exports, "default", () => $09c25bcfee424d7c$export$2e2bcd8739ae039);
let $09c25bcfee424d7c$var$script;



let $09c25bcfee424d7c$var$initialize = ()=>{
    $09c25bcfee424d7c$var$script = (parcelRequire("e67ko"));
    if ($09c25bcfee424d7c$var$script.__esModule) $09c25bcfee424d7c$var$script = $09c25bcfee424d7c$var$script.default;
    $09c25bcfee424d7c$var$script.render = (parcelRequire("lAWLP")).render;
    (parcelRequire("eTUCg")).default($09c25bcfee424d7c$var$script);
    $09c25bcfee424d7c$var$script.__scopeId = 'data-v-0affa2';
    $09c25bcfee424d7c$var$script.__file = "MusicArchive.vue";
};
$09c25bcfee424d7c$var$initialize();
var $09c25bcfee424d7c$export$2e2bcd8739ae039 = $09c25bcfee424d7c$var$script;

});
parcelRegister("e67ko", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a4374f6ac17082dd$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $fGXCZ = parcelRequire("fGXCZ");

var $kLbI9 = parcelRequire("kLbI9");

var $fEFug = parcelRequire("fEFug");

var $QlUa3 = parcelRequire("QlUa3");
var $a4374f6ac17082dd$export$2e2bcd8739ae039 = {
    name: "MusicArchive",
    components: {
        BoxGeneric: $kLbI9.default,
        MediaArchive: $fEFug.default,
        RouterLink: $fGXCZ.RouterLink,
        TransitionFade: $QlUa3.default
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "activeSchoolLevel",
            "activeVolume",
            "routedSong"
        ]),
        computedSchoolLevelBorderColor () {
            const slug = this.activeSchoolLevel?.slug;
            if (!slug) return "";
            const bgMap = {
                onderbouw: "border-b-green",
                "midden-bovenbouw": "border-b-purple"
            };
            return bgMap[slug] || "";
        },
        computedSchoolLevelDurationTextColor () {
            const slug = this.activeSchoolLevel?.slug;
            if (!slug) return "";
            const bgMap = {
                onderbouw: "text-green",
                "midden-bovenbouw": "text-purple"
            };
            return bgMap[slug] || "";
        }
    }
};

});

parcelRegister("lAWLP", function(module, exports) {

$parcel$export(module.exports, "render", () => $fb8a8c5aff047436$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $fb8a8c5aff047436$var$_hoisted_1 = {
    class: "song-list__song-item__title grow text-[17px] font-light py-0 pr-[20px] pl-[20px]"
};
const $fb8a8c5aff047436$var$_hoisted_2 = {
    key: 1,
    class: "flex h-full justify-center items-center"
};
function $fb8a8c5aff047436$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_view = (0, $xo6Zx.resolveComponent)("router-view");
    const _component_router_link = (0, $xo6Zx.resolveComponent)("router-link");
    const _component_media_archive = (0, $xo6Zx.resolveComponent)("media-archive");
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    return _ctx.routedSong ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_router_view, {
        key: 0
    })) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_transition_fade, {
        key: 1,
        duration: 500,
        appear: ""
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                _ctx.activeSchoolLevel?.archivedSongs.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_media_archive, {
                    key: 0,
                    items: _ctx.activeSchoolLevel?.archivedSongs,
                    "fade-out": ""
                }, {
                    default: (0, $xo6Zx.withCtx)(({ items: items })=>[
                            ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)(items, (item)=>{
                                return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", {
                                    key: item.slug
                                }, [
                                    ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", {
                                        key: item.slug,
                                        class: "song-list__song-item song-list__song-item--search-result border-0 border-r-2 border-solid border-r-black/20 max-w-none px-[10px]"
                                    }, [
                                        (0, $xo6Zx.createVNode)(_component_router_link, {
                                            to: {
                                                name: 'MusicArchiveKaraokePlayer',
                                                params: {
                                                    volumeSlug: _ctx.activeVolume.slug,
                                                    schoolLevelSlug: _ctx.activeSchoolLevel.slug,
                                                    songSlug: item.slug
                                                }
                                            },
                                            class: (0, $d8ZDz.normalizeClass)([
                                                "song-list__song-item__link items-center bg-white border-0 border-b border-solid text-almostBlack flex justify-between py-[7px] px-[10px] no-underline scale-100 transition-all duration-300 ease-[cubic-bezier(.25,.8,.25,1)] hover:bg-hover hover:scale-[1.02] hover:ease-[ease]",
                                                $options.computedSchoolLevelBorderColor
                                            ])
                                        }, {
                                            default: (0, $xo6Zx.withCtx)(()=>[
                                                    (0, $xo6Zx.createElementVNode)("div", $fb8a8c5aff047436$var$_hoisted_1, (0, $d8ZDz.toDisplayString)(item.title), 1),
                                                    (0, $xo6Zx.createElementVNode)("div", {
                                                        class: (0, $d8ZDz.normalizeClass)([
                                                            "song-list__song-item__duration text-[11px] tracking-[-0.4px] py-0 px-[20px]",
                                                            $options.computedSchoolLevelDurationTextColor
                                                        ])
                                                    }, (0, $d8ZDz.toDisplayString)((item.vocalMix ?? item.karaokeSoundMix)?.durationFormatted || "00:00"), 3)
                                                ]),
                                            _: 2
                                        }, 1032, [
                                            "to",
                                            "class"
                                        ])
                                    ]))
                                ]);
                            }), 128))
                        ]),
                    _: 1
                }, 8, [
                    "items"
                ])) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $fb8a8c5aff047436$var$_hoisted_2, [
                    (0, $xo6Zx.createVNode)(_component_box_generic, {
                        header: "Geen materiaal"
                    }, {
                        default: (0, $xo6Zx.withCtx)(()=>[
                                ..._cache[0] || (_cache[0] = [
                                    (0, $xo6Zx.createElementVNode)("p", {
                                        class: "mt-3 leading-relaxed"
                                    }, "Er zijn geen liedjes beschikbaar.", -1)
                                ])
                            ]),
                        _: 1
                    })
                ]))
            ]),
        _: 1
    }));
}

});

parcelRegister("eTUCg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad921e8b143363f3$export$2e2bcd8739ae039);
let $ad921e8b143363f3$var$NOOP = ()=>{};
var $ad921e8b143363f3$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("6IbKC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e2ff79d7414f140$export$2e2bcd8739ae039);

var $4RVbP = parcelRequire("4RVbP");

var $3z7M5 = parcelRequire("3z7M5");
var $4e2ff79d7414f140$export$2e2bcd8739ae039 = [
    {
        path: "kalender/:seasonSlug?/:daySlug?/",
        name: "CalendarSheet",
        component: (0, $4RVbP.default),
        meta: {
            containerClass: "showCalendarSheet"
        },
        children: [
            ...(0, $3z7M5.default)("CalendarSheetVideoPlayer")
        ]
    }
];

});
parcelRegister("4RVbP", function(module, exports) {

$parcel$export(module.exports, "default", () => $38b87957faeef7dd$export$2e2bcd8739ae039);
let $38b87957faeef7dd$var$script;




let $38b87957faeef7dd$var$initialize = ()=>{
    $38b87957faeef7dd$var$script = (parcelRequire("dHrNR"));
    if ($38b87957faeef7dd$var$script.__esModule) $38b87957faeef7dd$var$script = $38b87957faeef7dd$var$script.default;
    $38b87957faeef7dd$var$script.render = (parcelRequire("d1A70")).render;
    $38b87957faeef7dd$var$script.__cssModules = {};
    (parcelRequire("1A2G2")).default($38b87957faeef7dd$var$script);
    $38b87957faeef7dd$var$script.__scopeId = 'data-v-a36500';
    $38b87957faeef7dd$var$script.__file = "CalendarSheet.vue";
};
$38b87957faeef7dd$var$initialize();
var $38b87957faeef7dd$export$2e2bcd8739ae039 = $38b87957faeef7dd$var$script;

});
parcelRegister("dHrNR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9f94dbacf0fc5b2a$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $5YKGu = parcelRequire("5YKGu");

var $kLbI9 = parcelRequire("kLbI9");

var $iHQaY = parcelRequire("iHQaY");

var $64Amo = parcelRequire("64Amo");

var $9M4Ig = parcelRequire("9M4Ig");

var $cBPpl = parcelRequire("cBPpl");

var $QlUa3 = parcelRequire("QlUa3");
var $9f94dbacf0fc5b2a$export$2e2bcd8739ae039 = {
    name: "CalendarSheet",
    components: {
        BoxGeneric: $kLbI9.default,
        TransitionFade: $QlUa3.default,
        CalendarSheetMedia: $cBPpl.default,
        CalendarSheetMeta: $9M4Ig.default,
        CalendarSheetImage: $64Amo.default,
        CalendarWidget: $iHQaY.default
    },
    async beforeRouteEnter (to, from, next) {
        await (0, $5YKGu.default)(to, next);
    },
    async beforeRouteUpdate (to, from, next) {
        await (0, $5YKGu.default)(to, next);
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "routedDay",
            "routedVideo"
        ])
    }
};

});
parcelRegister("5YKGu", function(module, exports) {

$parcel$export(module.exports, "default", () => $45a6c4e68e2105f6$export$2e2bcd8739ae039);

var $14ltf = parcelRequire("14ltf");

var $8s1QA = parcelRequire("8s1QA");

var $1a39I = parcelRequire("1a39I");

var $8hAdR = parcelRequire("8hAdR");

var $5SjRy = parcelRequire("5SjRy");

var $e512K = parcelRequire("e512K");

var $jqHCQ = parcelRequire("jqHCQ");

var $3UsVB = parcelRequire("3UsVB");

var $dXqu3 = parcelRequire("dXqu3");

var $leRnd = parcelRequire("leRnd");

var $3GtVT = parcelRequire("3GtVT");
// To be used when day is an auto value.
const $45a6c4e68e2105f6$var$redirectToAutoDay = (route, { parentVolume: parentVolume, parentSeason: parentSeason, parentSeasonContentForSchoolLevel: parentSeasonContentForSchoolLevel }, next)=>{
    const day = (0, $3GtVT.default)(null, {
        parentVolume: parentVolume,
        parentSeason: parentSeason,
        parentSeasonContentForSchoolLevel: parentSeasonContentForSchoolLevel
    }, (0, $14ltf.default));
    if (day) {
        // There is a day available in the parent season content for school level
        // (be it routed or auto). We can use that to redirect to the auto day.
        next({
            name: "CalendarSheet",
            params: {
                ...route.params,
                seasonSlug: parentSeason.slug,
                daySlug: day.slug
            },
            force: true
        });
        return;
    }
    // We do not have a day to route to.
    // All we can do is display the CalendarSheet component without a matched day.
    next();
};
async function $45a6c4e68e2105f6$export$2e2bcd8739ae039(route, next) {
    await (0, $8s1QA.default)((0, $14ltf.default));
    const activeVolume = (0, $1a39I.default)(route, (0, $14ltf.default)) || (0, $e512K.default)((0, $14ltf.default));
    const activeSchoolLevel = (0, $8hAdR.default)(route, (0, $14ltf.default)) || (0, $jqHCQ.default)((0, $14ltf.default));
    const activeSeason = (0, $5SjRy.default)(route, activeVolume, (0, $14ltf.default)) || (0, $3UsVB.default)(activeVolume, (0, $14ltf.default));
    const activeSeasonContentForSchoolLevel = (0, $dXqu3.default)(route, {
        parentSeason: activeSeason,
        parentSchoolLevel: activeSchoolLevel
    }, (0, $14ltf.default));
    const routedDay = (0, $leRnd.default)(route, activeSeasonContentForSchoolLevel, (0, $14ltf.default));
    if (routedDay) {
        // We have a routed day - which is all we need. Stay here.
        next();
        return;
    }
    // Let's try an auto day, or fail.
    $45a6c4e68e2105f6$var$redirectToAutoDay(route, {
        parentVolume: activeVolume,
        parentSeason: activeSeason,
        parentSeasonContentForSchoolLevel: activeSeasonContentForSchoolLevel
    }, next);
}

});

parcelRegister("iHQaY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9e4b7370ca0ba4f$export$2e2bcd8739ae039);
let $d9e4b7370ca0ba4f$var$script;




let $d9e4b7370ca0ba4f$var$initialize = ()=>{
    $d9e4b7370ca0ba4f$var$script = (parcelRequire("2LOQI"));
    if ($d9e4b7370ca0ba4f$var$script.__esModule) $d9e4b7370ca0ba4f$var$script = $d9e4b7370ca0ba4f$var$script.default;
    $d9e4b7370ca0ba4f$var$script.render = (parcelRequire("5HtSr")).render;
    $d9e4b7370ca0ba4f$var$script.__cssModules = {};
    (parcelRequire("12UMQ")).default($d9e4b7370ca0ba4f$var$script);
    $d9e4b7370ca0ba4f$var$script.__scopeId = 'data-v-4a3bd2';
    $d9e4b7370ca0ba4f$var$script.__file = "CalendarWidget.vue";
};
$d9e4b7370ca0ba4f$var$initialize();
var $d9e4b7370ca0ba4f$export$2e2bcd8739ae039 = $d9e4b7370ca0ba4f$var$script;

});
parcelRegister("2LOQI", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $20476a282a4a2551$export$2e2bcd8739ae039);

var $fGXCZ = parcelRequire("fGXCZ");

var $aofyc = parcelRequire("aofyc");

var $5p2hN = parcelRequire("5p2hN");

var $kaYFn = parcelRequire("kaYFn");

var $14ltf = parcelRequire("14ltf");
var $20476a282a4a2551$export$2e2bcd8739ae039 = {
    name: "CalendarWidget",
    components: {
        RouterLink: $fGXCZ.RouterLink
    },
    data () {
        return {
            monthIndex: 0,
            tweenedTranslateX: 0
        };
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "activeSeason",
            "activeSeasonContentForSchoolLevel",
            "routedDay"
        ]),
        months () {
            /**
       * Generate the calendar widget days - month per month - for the season.
       * - Start month is month of season start date.
       * - End month is month of season end date.
       * - Query for days and add links.
       *
       *
       * Our algorithm for generating the calendar widget:
       *
       * - Go through months
       * - If day 1 of month is not a monday: reverse iterator until monday
       *     (backward into the previous month).
       * - Render the week into a container; (render days of foreign month disabled)
       * - Advance to the next day = next week
       * - Render the week into a container - repeat...
       * - If last day of month is not a sunday: iterate iterator until sunday
       *     (forward into the next month).
       * - Render the week into a container; (render days of foreign month disabled)
       * - Go to next month - repeat...
       */ // Set month iterator to start at the first day of the season's start date's month.
            const monthPointer = new Date(this.activeSeason.startDate);
            this.setMidnight(monthPointer);
            // Set to first of the month.
            monthPointer.setDate(1);
            // Set end month to midnight of first day of month after season's last month.
            // We iterate the month pointer until < endMonth.
            const endMonth = new Date(this.activeSeason.endDate);
            this.setMidnight(endMonth);
            // Set to following month, first day.
            endMonth.setMonth(endMonth.getMonth() + 1);
            endMonth.setDate(1);
            const months = {};
            while(monthPointer < endMonth){
                const monthKey = this.getMonthKey(monthPointer);
                // Prepare a month result object for the month at `monthPointer` if necessary.
                if (!Object.prototype.hasOwnProperty.call(months, monthKey)) months[monthKey] = {
                    title: monthPointer.toLocaleDateString("nl-NL", {
                        month: "long",
                        year: "numeric"
                    }),
                    weeks: {}
                };
                // Each month we start by copying the month pointer for a new day pointer,
                // and reversing it into the previous month, until we reach the Monday
                // of the current month's start week.
                const dayPointer = new Date(monthPointer.getTime());
                // Backtrack to Monday of the current week
                // (this intentionally backtracks into the previous month).
                // Note: While PHP's `DateTime::format('N')` counts from 1=Monday to 7=Sunday,
                // Javascript's `Date.prototype.getDay()` counts from 0=Sunday to 6=Saturday.
                // To make arithmetics easier, we map a Sunday `0` value back to `7`.
                const dayPointerDayOfWeek = dayPointer.getDay() || 7;
                if (dayPointerDayOfWeek !== 1) dayPointer.setDate(dayPointer.getDate() - dayPointerDayOfWeek + 1);
                // Now we "render" (in this case: collect data) the days in week-batches.
                // Break at the first Monday of the next month.
                // Note: Next month might lie in the following year.
                while(!(dayPointer.getDay() === 1 && // Monday
                this.getMonthKey(dayPointer) > monthKey // Next month
                )){
                    const weekNumber = this.getYearWeekNumber(dayPointer); // YYYY-MM
                    if (!Object.prototype.hasOwnProperty.call(months[monthKey].weeks, weekNumber)) months[monthKey].weeks[weekNumber] = [];
                    // Add a day to the week.
                    months[monthKey].weeks[weekNumber].push({
                        isForeignMonth: dayPointer.getMonth() !== monthPointer.getMonth(),
                        dayOfMonth: dayPointer.getDate(),
                        slug: (0, $kaYFn.default)(dayPointer, this.activeSeasonContentForSchoolLevel, (0, $14ltf.default))?.slug
                    });
                    // `Date` knows to advance ot the next year or month when increasing
                    // the date beyond the current month's bounds.
                    // (32 August = 1 September.)
                    dayPointer.setDate(dayPointer.getDate() + 1);
                }
                // `Date` knows to advance ot the next year when increasing
                // the month beyond the year's bounds.
                // (0 = January, 11 = December, 12 = January of the following year.)
                monthPointer.setMonth(monthPointer.getMonth() + 1);
            }
            return months;
        },
        translateX () {
            // Moving the widget horizontally.
            // We want to center the month of the `routedDay` by default.
            // Users can navigate the widget, selecting the next or previous month to be centered.
            // To avoid having to use `$refs`, we use %-based CSS `translateX()`,
            // rather than `px` values.
            const monthWidth = -100 / Object.keys(this.months).length;
            const base = monthWidth / 2;
            return base + this.monthIndex * monthWidth;
        },
        transform () {
            return `translateX(${this.translateX}%)`;
        }
    },
    watch: {
        routedDay () {
            // Center the day's month on day change.
            this.setMonthByDay(this.routedDay);
        }
    },
    mounted () {
        this.setMonthByDay(this.routedDay);
    },
    methods: {
        setMidnight (date) {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
        },
        getYearWeekNumber (date) {
            // Format as PHP `W`.
            const [weekYear, weekNum] = (0, $5p2hN.default)(date);
            return `${weekYear}-${String(weekNum).padStart(2, "0")}`;
        },
        getMonthKey (date) {
            // Format as PHP `Y-m`.
            return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
        },
        previousMonth () {
            if (this.monthIndex === 0) return;
            this.monthIndex -= 1;
        },
        nextMonth () {
            if (this.monthIndex >= Object.keys(this.months).length - 1) return;
            this.monthIndex += 1;
        },
        setMonthByDay (day) {
            const monthKey = this.getMonthKey(new Date(day?.date));
            const monthIndex = Object.keys(this.months).indexOf(monthKey);
            this.monthIndex = monthIndex === -1 ? 0 : monthIndex;
        }
    }
};

});
parcelRegister("5p2hN", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef10f82c7f15155$export$2e2bcd8739ae039);
/* For a given date, get the ISO week number
 *
 * Based on information at:
 *
 *    http://www.merlyn.demon.co.uk/weekcalc.htm#WNR
 *
 * Algorithm is to find nearest thursday, it's year
 * is the year of the week number. Then get weeks
 * between that date and the first day of that year.
 *
 * Note that dates in one year can be weeks of previous
 * or next year, overlap is up to 3 days.
 *
 * e.g. 2014/12/29 is Monday in week  1 of 2015
 *      2012/1/1   is Sunday in week 52 of 2011
 */ function $3ef10f82c7f15155$export$2e2bcd8739ae039(of) {
    // Copy date so don't modify original
    const d = new Date(Date.UTC(of.getFullYear(), of.getMonth(), of.getDate()));
    // Set to nearest Thursday: current date + 4 - current day number
    // Make Sunday's day number 7
    d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
    // Get first day of year
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    // Calculate full weeks to nearest Thursday
    const weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
    // Return array of year and week number
    return [
        d.getUTCFullYear(),
        weekNo
    ];
} // See also: https://stackoverflow.com/questions/6117814/get-week-of-year-in-javascript-like-in-php

});


parcelRegister("5HtSr", function(module, exports) {

$parcel$export(module.exports, "render", () => $426824e33fc21e3e$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $426824e33fc21e3e$var$_hoisted_1 = {
    id: "calendar-widget",
    class: "h-[218px] overflow-hidden relative w-[45vw]"
};
const $426824e33fc21e3e$var$_hoisted_2 = {
    class: "text-base p-[10px] text-center"
};
const $426824e33fc21e3e$var$_hoisted_3 = {
    class: "calendar-widget__month__table"
};
const $426824e33fc21e3e$var$_hoisted_4 = {
    class: "flex justify-center items-center w-full h-full"
};
const $426824e33fc21e3e$var$_hoisted_5 = {
    key: 1,
    class: "calendar-widget__day__inner calendar-widget__day__inner--no-link block font-medium text-center no-underline"
};
function $426824e33fc21e3e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $xo6Zx.resolveComponent)("router-link");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $426824e33fc21e3e$var$_hoisted_1, [
        (0, $xo6Zx.createElementVNode)("div", {
            id: "calendar-widget__navigation--earlier",
            onClick: _cache[0] || (_cache[0] = (...args)=>$options.previousMonth && $options.previousMonth(...args)),
            class: (0, $d8ZDz.normalizeClass)([
                "calendar-widget__navigation",
                [
                    {
                        'cursor-pointer': $data.monthIndex > 0
                    }
                ]
            ])
        }, null, 2),
        (0, $xo6Zx.createElementVNode)("div", {
            id: "calendar-widget__scroll-container",
            style: (0, $d8ZDz.normalizeStyle)({
                transform: $options.transform
            }),
            class: "transition-transform duration-300 ease-in-out"
        }, [
            ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)($options.months, (month, key)=>{
                return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", {
                    key: key,
                    class: "calendar-widget__month inline-block my-0 mx-[20px] font-medium"
                }, [
                    (0, $xo6Zx.createElementVNode)("h1", $426824e33fc21e3e$var$_hoisted_2, (0, $d8ZDz.toDisplayString)(month.title), 1),
                    (0, $xo6Zx.createElementVNode)("table", $426824e33fc21e3e$var$_hoisted_3, [
                        (0, $xo6Zx.createElementVNode)("tr", null, [
                            ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)([
                                'ma',
                                'di',
                                'wo',
                                'do',
                                'vr',
                                'za',
                                'zo'
                            ], (weekDayName)=>{
                                return (0, $xo6Zx.createElementVNode)("th", {
                                    key: weekDayName
                                }, (0, $d8ZDz.toDisplayString)(weekDayName), 1);
                            }), 64))
                        ]),
                        ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)(month.weeks, (week)=>{
                            return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("tr", {
                                key: week,
                                class: "calendar-widget__week"
                            }, [
                                ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)(week, (day)=>{
                                    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("td", {
                                        key: day.dayOfMonth,
                                        class: (0, $d8ZDz.normalizeClass)([
                                            "calendar-widget__day",
                                            [
                                                {
                                                    'calendar-widget__day--foreign-month': day.isForeignMonth,
                                                    'calendar-widget__day--available': !!day.slug,
                                                    'calendar-widget__day--current': day.slug === _ctx.routedDay.slug
                                                }
                                            ]
                                        ])
                                    }, [
                                        (0, $xo6Zx.createElementVNode)("div", $426824e33fc21e3e$var$_hoisted_4, [
                                            day.slug ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_router_link, {
                                                key: 0,
                                                to: {
                                                    name: 'CalendarSheet',
                                                    params: {
                                                        ..._ctx.$route.params,
                                                        daySlug: day.slug
                                                    }
                                                },
                                                class: "calendar-widget__day__inner calendar-widget__day__inner--link block font-medium text-center no-underline"
                                            }, {
                                                default: (0, $xo6Zx.withCtx)(()=>[
                                                        (0, $xo6Zx.createTextVNode)((0, $d8ZDz.toDisplayString)(day.dayOfMonth), 1)
                                                    ]),
                                                _: 2
                                            }, 1032, [
                                                "to"
                                            ])) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("span", $426824e33fc21e3e$var$_hoisted_5, (0, $d8ZDz.toDisplayString)(day.dayOfMonth), 1))
                                        ])
                                    ], 2);
                                }), 128))
                            ]);
                        }), 128))
                    ])
                ]);
            }), 128))
        ], 4),
        (0, $xo6Zx.createElementVNode)("div", {
            id: "calendar-widget__navigation--later",
            onClick: _cache[1] || (_cache[1] = (...args)=>$options.nextMonth && $options.nextMonth(...args)),
            class: (0, $d8ZDz.normalizeClass)([
                "calendar-widget__navigation",
                [
                    {
                        'cursor-pointer': $data.monthIndex < Object.keys($options.months).length - 1
                    }
                ]
            ])
        }, null, 2)
    ]);
}

});

parcelRegister("12UMQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c32070c8176f725$export$2e2bcd8739ae039);
let $0c32070c8176f725$var$NOOP = ()=>{};
var $0c32070c8176f725$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("64Amo", function(module, exports) {

$parcel$export(module.exports, "default", () => $46bf5227f0e6b9d7$export$2e2bcd8739ae039);
let $46bf5227f0e6b9d7$var$script;



let $46bf5227f0e6b9d7$var$initialize = ()=>{
    $46bf5227f0e6b9d7$var$script = (parcelRequire("gmB6O"));
    if ($46bf5227f0e6b9d7$var$script.__esModule) $46bf5227f0e6b9d7$var$script = $46bf5227f0e6b9d7$var$script.default;
    $46bf5227f0e6b9d7$var$script.render = (parcelRequire("l6XOh")).render;
    (parcelRequire("fONZy")).default($46bf5227f0e6b9d7$var$script);
    $46bf5227f0e6b9d7$var$script.__scopeId = 'data-v-0d0ca5';
    $46bf5227f0e6b9d7$var$script.__file = "CalendarSheetImage.vue";
};
$46bf5227f0e6b9d7$var$initialize();
var $46bf5227f0e6b9d7$export$2e2bcd8739ae039 = $46bf5227f0e6b9d7$var$script;

});
parcelRegister("gmB6O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $be9b7c760a2fdfc3$export$2e2bcd8739ae039);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");

var $aofyc = parcelRequire("aofyc");
var $be9b7c760a2fdfc3$export$2e2bcd8739ae039 = {
    name: "CalendarSheetImage",
    components: {
        Teleport: $xo6Zx.Teleport
    },
    data () {
        return {
            state: "offscreen",
            offscreenToIdleTimeout: null
        };
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "routedDay"
        ])
    },
    mounted () {
        this.offscreenToIdleTimeout = window.setTimeout(()=>{
            this.state = "idle";
        }, 100);
    },
    beforeUnmount () {
        window.clearTimeout(this.offscreenToIdleTimeout);
    },
    methods: {
        toggleActive () {
            this.state = this.state === "active" ? "idle" : "active";
        }
    }
};

});

parcelRegister("l6XOh", function(module, exports) {

$parcel$export(module.exports, "render", () => $f5e88d83d21aa09c$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
var $jH5uA = parcelRequire("jH5uA");
const $f5e88d83d21aa09c$var$_hoisted_1 = {
    id: "calendar-sheet__section--image"
};
const $f5e88d83d21aa09c$var$_hoisted_2 = {
    id: "calendar-sheet__section--image-teleport",
    class: "absolute top-0 left-0 w-full h-full z-10 pointer-events-none"
};
const $f5e88d83d21aa09c$var$_hoisted_3 = [
    "href"
];
const $f5e88d83d21aa09c$var$_hoisted_4 = [
    "href"
];
const $f5e88d83d21aa09c$var$_hoisted_5 = [
    "src",
    "alt"
];
function $f5e88d83d21aa09c$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("section", $f5e88d83d21aa09c$var$_hoisted_1, [
        ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)((0, $xo6Zx.Teleport), {
            to: "body"
        }, [
            (0, $xo6Zx.createElementVNode)("div", $f5e88d83d21aa09c$var$_hoisted_2, [
                _ctx.routedDay.calendarSheetDownload?.publicUrl ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("a", {
                    key: 0,
                    id: "calendar-sheet__download",
                    href: _ctx.routedDay.calendarSheetDownload.publicUrl,
                    target: "_blank",
                    class: "absolute bottom-0 right-0 mb-5 pointer-events-auto button--rounded-full bg-orange-500 hover:bg-orange-600 text-white z-10 scale-100 translate-x-1/2 mr-[25%] px-[16px] py-[12px]"
                }, "Download", 8, $f5e88d83d21aa09c$var$_hoisted_3)) : (0, $xo6Zx.createCommentVNode)("", true),
                (0, $xo6Zx.createElementVNode)("div", {
                    id: "calendar-sheet__backdrop",
                    onClick: _cache[0] || (_cache[0] = (...args)=>$options.toggleActive && $options.toggleActive(...args)),
                    class: (0, $d8ZDz.normalizeClass)([
                        "absolute inset-0 bg-black z-10 transition-all duration-300 will-change-[opacity]",
                        [
                            $data.state === 'active' ? [
                                'bg-opacity-50',
                                'pointer-events-auto',
                                'supports-bg-filter:bg-saturate-blur-full'
                            ] : [
                                'bg-opacity-0',
                                'pointer-events-none',
                                'supports-bg-filter:bg-saturate-blur-0'
                            ]
                        ]
                    ])
                }, null, 2),
                _ctx.routedDay.calendarSheet?.publicUrl ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("a", {
                    key: 1,
                    id: "calendar-sheet__image",
                    href: _ctx.routedDay.calendarSheet.publicUrl,
                    onClick: _cache[1] || (_cache[1] = (0, $jH5uA.withModifiers)((...args)=>$options.toggleActive && $options.toggleActive(...args), [
                        "prevent"
                    ])),
                    class: (0, $d8ZDz.normalizeClass)([
                        "group absolute inline-block z-20 transition-transform duration-300 pointer-events-auto will-change-transform",
                        [
                            {
                                [$data.state]: true
                            }
                        ]
                    ])
                }, [
                    (0, $xo6Zx.createElementVNode)("img", {
                        src: _ctx.routedDay.calendarSheet.publicUrl,
                        alt: _ctx.routedDay.title,
                        class: "h-[82vh] w-auto rounded-3xl transition-shadow duration-300"
                    }, null, 8, $f5e88d83d21aa09c$var$_hoisted_5)
                ], 10, $f5e88d83d21aa09c$var$_hoisted_4)) : (0, $xo6Zx.createCommentVNode)("", true)
            ])
        ]))
    ]);
}

});

parcelRegister("fONZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8424ddb83f038f0$export$2e2bcd8739ae039);
let $b8424ddb83f038f0$var$NOOP = ()=>{};
var $b8424ddb83f038f0$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("9M4Ig", function(module, exports) {

$parcel$export(module.exports, "default", () => $71dc409fa5d8d76d$export$2e2bcd8739ae039);
let $71dc409fa5d8d76d$var$script;




let $71dc409fa5d8d76d$var$initialize = ()=>{
    $71dc409fa5d8d76d$var$script = (parcelRequire("9nioE"));
    if ($71dc409fa5d8d76d$var$script.__esModule) $71dc409fa5d8d76d$var$script = $71dc409fa5d8d76d$var$script.default;
    $71dc409fa5d8d76d$var$script.render = (parcelRequire("6kqm4")).render;
    $71dc409fa5d8d76d$var$script.__cssModules = {};
    (parcelRequire("iEB8k")).default($71dc409fa5d8d76d$var$script);
    $71dc409fa5d8d76d$var$script.__scopeId = 'data-v-b24bfd';
    $71dc409fa5d8d76d$var$script.__file = "CalendarSheetMeta.vue";
};
$71dc409fa5d8d76d$var$initialize();
var $71dc409fa5d8d76d$export$2e2bcd8739ae039 = $71dc409fa5d8d76d$var$script;

});
parcelRegister("9nioE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6d34883614d1bf27$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");
var $6d34883614d1bf27$export$2e2bcd8739ae039 = {
    name: "CalendarSheetMeta",
    computed: {
        ...(0, $aofyc.mapGetters)([
            "routedDay"
        ]),
        routedDate () {
            if (!this.routedDay) return null;
            return new Date(this.routedDay.date);
        }
    }
};

});

parcelRegister("6kqm4", function(module, exports) {

$parcel$export(module.exports, "render", () => $49b90de24a505150$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $49b90de24a505150$var$_hoisted_1 = {
    id: "calendar-sheet__section--meta"
};
const $49b90de24a505150$var$_hoisted_2 = {
    id: "calendar-sheet__date",
    class: "text-black inline-block text-base font-normal tracking-[1.5px] mt-[1vh] py-[2px] px-[16px] uppercase"
};
function $49b90de24a505150$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("section", $49b90de24a505150$var$_hoisted_1, [
        (0, $xo6Zx.createElementVNode)("div", $49b90de24a505150$var$_hoisted_2, (0, $d8ZDz.toDisplayString)($options.routedDate.toLocaleDateString("nl-NL", {
            weekday: "long"
        })) + ", " + (0, $d8ZDz.toDisplayString)($options.routedDate.toLocaleDateString("nl-NL", {
            day: "numeric",
            month: "long",
            year: "numeric"
        })), 1),
        ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("h1", {
            id: "calendar-sheet__title",
            class: "inline-block font-bree font-[900] text-[25px] tracking-[-0.6px] text-center",
            key: _ctx.routedDay.title
        }, (0, $d8ZDz.toDisplayString)(_ctx.routedDay.title), 1)),
        ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("h2", {
            id: "calendar-sheet__theme",
            class: "solid inline-block text-[21px] pt-[2px] px-[16px] pb-[4px] tracking-[.5px]",
            key: _ctx.routedDay.theme
        }, " thema: " + (0, $d8ZDz.toDisplayString)(_ctx.routedDay.theme), 1))
    ]);
}

});

parcelRegister("iEB8k", function(module, exports) {

$parcel$export(module.exports, "default", () => $d948c44f30336bc1$export$2e2bcd8739ae039);
let $d948c44f30336bc1$var$NOOP = ()=>{};
var $d948c44f30336bc1$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("cBPpl", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e0d13e642ae067$export$2e2bcd8739ae039);
let $92e0d13e642ae067$var$script;



let $92e0d13e642ae067$var$initialize = ()=>{
    $92e0d13e642ae067$var$script = (parcelRequire("2FyX7"));
    if ($92e0d13e642ae067$var$script.__esModule) $92e0d13e642ae067$var$script = $92e0d13e642ae067$var$script.default;
    $92e0d13e642ae067$var$script.render = (parcelRequire("hcLzV")).render;
    (parcelRequire("Lp3bQ")).default($92e0d13e642ae067$var$script);
    $92e0d13e642ae067$var$script.__scopeId = 'data-v-056856';
    $92e0d13e642ae067$var$script.__file = "CalendarSheetMedia.vue";
};
$92e0d13e642ae067$var$initialize();
var $92e0d13e642ae067$export$2e2bcd8739ae039 = $92e0d13e642ae067$var$script;

});
parcelRegister("2FyX7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1f1a85f565d812a7$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $lDadK = parcelRequire("lDadK");

var $lOOqj = parcelRequire("lOOqj");

var $NnXzi = parcelRequire("NnXzi");
var $1f1a85f565d812a7$export$2e2bcd8739ae039 = {
    name: "CalendarSheetMedia",
    components: {
        CalendarSheetVideo: $NnXzi.default,
        CalendarSheetLinks: $lDadK.default,
        CalendarSheetSongs: $lOOqj.default
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "routedDay"
        ])
    }
};

});
parcelRegister("lDadK", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbf52b1a383ac5d9$export$2e2bcd8739ae039);
let $fbf52b1a383ac5d9$var$script;



let $fbf52b1a383ac5d9$var$initialize = ()=>{
    $fbf52b1a383ac5d9$var$script = (parcelRequire("fHu7M"));
    if ($fbf52b1a383ac5d9$var$script.__esModule) $fbf52b1a383ac5d9$var$script = $fbf52b1a383ac5d9$var$script.default;
    $fbf52b1a383ac5d9$var$script.render = (parcelRequire("iMx7l")).render;
    (parcelRequire("fqzDE")).default($fbf52b1a383ac5d9$var$script);
    $fbf52b1a383ac5d9$var$script.__scopeId = 'data-v-be3e32';
    $fbf52b1a383ac5d9$var$script.__file = "CalendarSheetLinks.vue";
};
$fbf52b1a383ac5d9$var$initialize();
var $fbf52b1a383ac5d9$export$2e2bcd8739ae039 = $fbf52b1a383ac5d9$var$script;

});
parcelRegister("fHu7M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b6e23d3fce66b5ab$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $1UYcK = parcelRequire("1UYcK");

var $cCNWR = parcelRequire("cCNWR");
var $b6e23d3fce66b5ab$export$2e2bcd8739ae039 = {
    name: "CalendarSheetLinks",
    computed: {
        ...(0, $aofyc.mapGetters)([
            "routedDay"
        ])
    },
    watch: {
        routedDay (newDay) {
            if (!newDay) return;
            this.$nextTick(()=>{
                (0, $cCNWR.default)();
                (0, $1UYcK.default)();
            });
        }
    },
    mounted () {
        (0, $1UYcK.default)();
    },
    beforeUnmount () {
        (0, $cCNWR.default)();
    }
};

});
parcelRegister("1UYcK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1659b8c674dc7b40$export$2e2bcd8739ae039);


var $989Sa = parcelRequire("989Sa");
function $1659b8c674dc7b40$export$2e2bcd8739ae039() {
    if (document.querySelector(".ce-gallery")) (0, (/*@__PURE__*/$parcel$interopDefault($989Sa))).run(".ce-gallery", {
        // Options documented at https://www.npmjs.com/package/baguettebox.js
        filter: /(^(?!https:\/\/commons\.wikimedia\.).+\.(gif|jpe?g|png|webp)$)|(\/index\.php\?eID=dumpFile&t=([pf])&\4=\d+&token=[a-z0-9]+)/i,
        ignoreClass: "no-lightbox",
        overlayBackgroundColor: "rgba(0, 0, 0, .5)"
    });
}

});
parcelRegister("989Sa", function(module, exports) {
/*!
 * baguetteBox.js
 * @author  feimosi
 * @version 1.13.0
 * @url https://github.com/feimosi/baguetteBox.js
 */ !function(e, t) {
    "use strict";
    "function" == typeof define && define.amd ? define(t) : module.exports = t();
}(module.exports, function() {
    "use strict";
    var s, l, u, c, d, f = '<svg width="44" height="60"><polyline points="30 10 10 30 30 50" stroke="rgba(255,255,255,0.5)" stroke-width="4"stroke-linecap="butt" fill="none" stroke-linejoin="round"/></svg>', g = '<svg width="44" height="60"><polyline points="14 10 34 30 14 50" stroke="rgba(255,255,255,0.5)" stroke-width="4"stroke-linecap="butt" fill="none" stroke-linejoin="round"/></svg>', p = '<svg width="30" height="30"><g stroke="rgb(160,160,160)" stroke-width="4"><line x1="5" y1="5" x2="25" y2="25"/><line x1="5" y1="25" x2="25" y2="5"/></g></svg>', b = {}, m = {
        captions: !0,
        buttons: "auto",
        fullScreen: !1,
        noScrollbars: !1,
        bodyClass: "baguetteBox-open",
        titleTag: !1,
        async: !1,
        preload: 2,
        animation: "slideIn",
        afterShow: null,
        afterHide: null,
        onChange: null,
        overlayBackgroundColor: "rgba(0,0,0,.8)",
        closeX: p,
        leftArrow: f,
        rightArrow: g
    }, v = {}, h = [], o = 0, n = !1, i = {}, a = !1, y = /.+\.(gif|jpe?g|png|webp|avif)/i, w = {}, k = [], r = null, x = function(e) {
        -1 !== e.target.id.indexOf("baguette-img") && M();
    }, E = function(e) {
        e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0, j();
    }, C = function(e) {
        e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0, Y();
    }, B = function(e) {
        e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0, M();
    }, T = function(e) {
        i.count++, 1 < i.count && (i.multitouch = !0), i.startX = e.changedTouches[0].pageX, i.startY = e.changedTouches[0].pageY;
    }, A = function(e) {
        if (!a && !i.multitouch) {
            e.preventDefault ? e.preventDefault() : e.returnValue = !1;
            var t = e.touches[0] || e.changedTouches[0];
            40 < t.pageX - i.startX ? (a = !0, j()) : t.pageX - i.startX < -40 ? (a = !0, Y()) : 100 < i.startY - t.pageY && M();
        }
    }, L = function() {
        i.count--, i.count <= 0 && (i.multitouch = !1), a = !1;
    }, N = function() {
        L();
    }, S = function(e) {
        "block" === s.style.display && s.contains && !s.contains(e.target) && (e.stopPropagation(), I());
    };
    function H(e) {
        if (w.hasOwnProperty(e)) {
            var t = w[e].galleries;
            [].forEach.call(t, function(e) {
                [].forEach.call(e, function(e) {
                    W(e.imageElement, "click", e.eventHandler);
                }), h === e && (h = []);
            }), delete w[e];
        }
    }
    function P(e) {
        switch(e.keyCode){
            case 37:
                j();
                break;
            case 39:
                Y();
                break;
            case 27:
                M();
                break;
            case 36:
                !function t(e) {
                    e && e.preventDefault();
                    return D(0);
                }(e);
                break;
            case 35:
                !function n(e) {
                    e && e.preventDefault();
                    return D(h.length - 1);
                }(e);
        }
    }
    function F(e, t) {
        if (h !== e) {
            for(h = e, function r(e) {
                e = e || {};
                for(var t in m)b[t] = m[t], "undefined" != typeof e[t] && (b[t] = e[t]);
                l.style.transition = l.style.webkitTransition = "fadeIn" === b.animation ? "opacity .4s ease" : "slideIn" === b.animation ? "" : "none", "auto" === b.buttons && ("ontouchstart" in window || 1 === h.length) && (b.buttons = !1);
                u.style.display = c.style.display = b.buttons ? "" : "none", d.innerHTML = b.closeX, b.buttons && (u.innerHTML = b.leftArrow, c.innerHTML = b.rightArrow);
                try {
                    s.style.backgroundColor = b.overlayBackgroundColor;
                } catch (n) {}
            }(t); l.firstChild;)l.removeChild(l.firstChild);
            for(var n, o = [], i = [], a = k.length = 0; a < e.length; a++)(n = J("div")).className = "full-image", n.id = "baguette-img-" + a, k.push(n), o.push("baguetteBox-figure-" + a), i.push("baguetteBox-figcaption-" + a), l.appendChild(k[a]);
            s.setAttribute("aria-labelledby", o.join(" ")), s.setAttribute("aria-describedby", i.join(" "));
        }
    }
    function q(e) {
        b.noScrollbars && (document.documentElement.style.overflowY = "hidden", document.body.style.overflowY = "scroll"), "block" !== s.style.display && (U(document, "keydown", P), i = {
            count: 0,
            startX: null,
            startY: null
        }, X(o = e, function() {
            z(o), V(o);
        }), R(), s.style.display = "block", b.fullScreen && function t() {
            s.requestFullscreen ? s.requestFullscreen() : s.webkitRequestFullscreen ? s.webkitRequestFullscreen() : s.mozRequestFullScreen && s.mozRequestFullScreen();
        }(), setTimeout(function() {
            s.className = "visible", b.bodyClass && document.body.classList && document.body.classList.add(b.bodyClass), b.afterShow && b.afterShow();
        }, 50), b.onChange && b.onChange(o, k.length), r = document.activeElement, I(), n = !0);
    }
    function I() {
        b.buttons ? u.focus() : d.focus();
    }
    function M() {
        b.noScrollbars && (document.documentElement.style.overflowY = "auto", document.body.style.overflowY = "auto"), "none" !== s.style.display && (W(document, "keydown", P), s.className = "", setTimeout(function() {
            s.style.display = "none", document.fullscreen && function e() {
                document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen && document.webkitExitFullscreen();
            }(), b.bodyClass && document.body.classList && document.body.classList.remove(b.bodyClass), b.afterHide && b.afterHide(), r && r.focus(), n = !1;
        }, 500));
    }
    function X(t, n) {
        var e = k[t], o = h[t];
        if (void 0 !== e && void 0 !== o) {
            if (e.getElementsByTagName("img")[0]) n && n();
            else {
                var i = o.imageElement, a = i.getElementsByTagName("img")[0], r = "function" == typeof b.captions ? b.captions.call(h, i) : i.getAttribute("data-caption") || i.title, s = function d(e) {
                    var t = e.href;
                    if (e.dataset) {
                        var n = [];
                        for(var o in e.dataset)"at-" !== o.substring(0, 3) || isNaN(o.substring(3)) || (n[o.replace("at-", "")] = e.dataset[o]);
                        for(var i = Object.keys(n).sort(function(e, t) {
                            return parseInt(e, 10) < parseInt(t, 10) ? -1 : 1;
                        }), a = window.innerWidth * window.devicePixelRatio, r = 0; r < i.length - 1 && i[r] < a;)r++;
                        t = n[i[r]] || t;
                    }
                    return t;
                }(i), l = J("figure");
                if (l.id = "baguetteBox-figure-" + t, l.innerHTML = '<div class="baguetteBox-spinner"><div class="baguetteBox-double-bounce1"></div><div class="baguetteBox-double-bounce2"></div></div>', b.captions && r) {
                    var u = J("figcaption");
                    u.id = "baguetteBox-figcaption-" + t, u.innerHTML = r, l.appendChild(u);
                }
                e.appendChild(l);
                var c = J("img");
                c.onload = function() {
                    var e = document.querySelector("#baguette-img-" + t + " .baguetteBox-spinner");
                    l.removeChild(e), !b.async && n && n();
                }, c.setAttribute("src", s), c.alt = a && a.alt || "", b.titleTag && r && (c.title = r), l.appendChild(c), b.async && n && n();
            }
        }
    }
    function Y() {
        return D(o + 1);
    }
    function j() {
        return D(o - 1);
    }
    function D(e, t) {
        return !n && 0 <= e && e < t.length ? (F(t, b), q(e), !0) : e < 0 ? (b.animation && O("left"), !1) : e >= k.length ? (b.animation && O("right"), !1) : (X(o = e, function() {
            z(o), V(o);
        }), R(), b.onChange && b.onChange(o, k.length), !0);
    }
    function O(e) {
        l.className = "bounce-from-" + e, setTimeout(function() {
            l.className = "";
        }, 400);
    }
    function R() {
        var e = "rtl" === document.querySelectorAll("html")[0].getAttribute("dir"), t = -o * (e ? -100 : 100) + "%";
        "fadeIn" === b.animation ? (l.style.opacity = 0, setTimeout(function() {
            v.transforms ? l.style.transform = l.style.webkitTransform = "translate3d(" + t + ",0,0)" : l.style.left = t, l.style.opacity = 1;
        }, 400)) : v.transforms ? l.style.transform = l.style.webkitTransform = "translate3d(" + t + ",0,0)" : l.style.left = t;
    }
    function z(e) {
        e - o >= b.preload || X(e + 1, function() {
            z(e + 1);
        });
    }
    function V(e) {
        o - e >= b.preload || X(e - 1, function() {
            V(e - 1);
        });
    }
    function U(e, t, n, o) {
        e.addEventListener ? e.addEventListener(t, n, o) : e.attachEvent("on" + t, function(e) {
            (e = e || window.event).target = e.target || e.srcElement, n(e);
        });
    }
    function W(e, t, n, o) {
        e.removeEventListener ? e.removeEventListener(t, n, o) : e.detachEvent("on" + t, n);
    }
    function G(e) {
        return document.getElementById(e);
    }
    function J(e) {
        return document.createElement(e);
    }
    return [].forEach || (Array.prototype.forEach = function(e, t) {
        for(var n = 0; n < this.length; n++)e.call(t, this[n], n, this);
    }), [].filter || (Array.prototype.filter = function(e, t, n, o, i) {
        for(n = this, o = [], i = 0; i < n.length; i++)e.call(t, n[i], i, n) && o.push(n[i]);
        return o;
    }), {
        run: function K(e, t) {
            return v.transforms = function n() {
                var e = J("div");
                return "undefined" != typeof e.style.perspective || "undefined" != typeof e.style.webkitPerspective;
            }(), v.svg = function o() {
                var e = J("div");
                return e.innerHTML = "<svg/>", "http://www.w3.org/2000/svg" === (e.firstChild && e.firstChild.namespaceURI);
            }(), v.passiveEvents = function i() {
                var e = !1;
                try {
                    var t = Object.defineProperty({}, "passive", {
                        get: function() {
                            e = !0;
                        }
                    });
                    window.addEventListener("test", null, t);
                } catch (n) {}
                return e;
            }(), function a() {
                if (s = G("baguetteBox-overlay")) return l = G("baguetteBox-slider"), u = G("previous-button"), c = G("next-button"), void (d = G("close-button"));
                (s = J("div")).setAttribute("role", "dialog"), s.id = "baguetteBox-overlay", document.getElementsByTagName("body")[0].appendChild(s), (l = J("div")).id = "baguetteBox-slider", s.appendChild(l), (u = J("button")).setAttribute("type", "button"), u.id = "previous-button", u.setAttribute("aria-label", "Previous"), u.innerHTML = v.svg ? f : "&lt;", s.appendChild(u), (c = J("button")).setAttribute("type", "button"), c.id = "next-button", c.setAttribute("aria-label", "Next"), c.innerHTML = v.svg ? g : "&gt;", s.appendChild(c), (d = J("button")).setAttribute("type", "button"), d.id = "close-button", d.setAttribute("aria-label", "Close"), d.innerHTML = v.svg ? p : "&times;", s.appendChild(d), u.className = c.className = d.className = "baguetteBox-button", function n() {
                    var e = v.passiveEvents ? {
                        passive: !1
                    } : null, t = v.passiveEvents ? {
                        passive: !0
                    } : null;
                    U(s, "click", x), U(u, "click", E), U(c, "click", C), U(d, "click", B), U(l, "contextmenu", N), U(s, "touchstart", T, t), U(s, "touchmove", A, e), U(s, "touchend", L), U(document, "focus", S, !0);
                }();
            }(), H(e), function r(e, a) {
                var t = document.querySelectorAll(e), n = {
                    galleries: [],
                    nodeList: t
                };
                return w[e] = n, [].forEach.call(t, function(e) {
                    a && a.filter && (y = a.filter);
                    var t = [];
                    if (t = "A" === e.tagName ? [
                        e
                    ] : e.getElementsByTagName("a"), 0 !== (t = [].filter.call(t, function(e) {
                        if (-1 === e.className.indexOf(a && a.ignoreClass)) return y.test(e.href);
                    })).length) {
                        var i = [];
                        [].forEach.call(t, function(e, t) {
                            var n = function(e) {
                                e.preventDefault ? e.preventDefault() : e.returnValue = !1, F(i, a), q(t);
                            }, o = {
                                eventHandler: n,
                                imageElement: e
                            };
                            U(e, "click", n), i.push(o);
                        }), n.galleries.push(i);
                    }
                }), n.galleries;
            }(e, t);
        },
        show: D,
        showNext: Y,
        showPrevious: j,
        hide: M,
        destroy: function e() {
            !function n() {
                var e = v.passiveEvents ? {
                    passive: !1
                } : null, t = v.passiveEvents ? {
                    passive: !0
                } : null;
                W(s, "click", x), W(u, "click", E), W(c, "click", C), W(d, "click", B), W(l, "contextmenu", N), W(s, "touchstart", T, t), W(s, "touchmove", A, e), W(s, "touchend", L), W(document, "focus", S, !0);
            }(), function t() {
                for(var e in w)w.hasOwnProperty(e) && H(e);
            }(), W(document, "keydown", P), document.getElementsByTagName("body")[0].removeChild(document.getElementById("baguetteBox-overlay")), w = {}, h = [], o = 0;
        }
    };
});

});


parcelRegister("cCNWR", function(module, exports) {

$parcel$export(module.exports, "default", () => $930fc75db8c45c55$export$2e2bcd8739ae039);

var $989Sa = parcelRequire("989Sa");
function $930fc75db8c45c55$export$2e2bcd8739ae039() {
    if (document.getElementById("baguetteBox-overlay")) (0, (/*@__PURE__*/$parcel$interopDefault($989Sa))).destroy();
}

});


parcelRegister("iMx7l", function(module, exports) {

$parcel$export(module.exports, "render", () => $dac666207c628621$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $dac666207c628621$var$_hoisted_1 = {
    id: "calendar-sheet__links",
    class: "ce-gallery flex justify-center mt-[35px] overflow-visible"
};
const $dac666207c628621$var$_hoisted_2 = {
    class: "calendar-sheet__link--video flex flex-col justify-center m-[6px] text-center"
};
const $dac666207c628621$var$_hoisted_3 = [
    "href"
];
function $dac666207c628621$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $xo6Zx.resolveComponent)("router-link");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $dac666207c628621$var$_hoisted_1, [
        ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)(_ctx.routedDay.videos, (video)=>{
            return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_router_link, {
                key: video.slug,
                to: {
                    name: 'CalendarSheetVideoPlayer',
                    params: {
                        ..._ctx.$route.params,
                        videoSlug: video.slug
                    }
                },
                class: "basis-[130px] text-center"
            }, {
                default: (0, $xo6Zx.withCtx)(()=>[
                        (0, $xo6Zx.createElementVNode)("section", $dac666207c628621$var$_hoisted_2, (0, $d8ZDz.toDisplayString)(video.title), 1)
                    ]),
                _: 2
            }, 1032, [
                "to"
            ]);
        }), 128)),
        ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)(_ctx.routedDay.calendarSheetLinks, (link)=>{
            return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("a", {
                key: link,
                href: link.url,
                target: "_blank",
                class: (0, $d8ZDz.normalizeClass)([
                    [
                        {
                            'no-lightbox': link.type !== 'lightbox_image'
                        }
                    ],
                    "basis-[130px] text-center mx-3"
                ])
            }, [
                (0, $xo6Zx.createElementVNode)("section", {
                    class: (0, $d8ZDz.normalizeClass)([
                        [
                            `calendar-sheet__link--${link.type}`
                        ],
                        "flex flex-col justify-center m-[6px] text-center"
                    ])
                }, (0, $d8ZDz.toDisplayString)(link.label), 3)
            ], 10, $dac666207c628621$var$_hoisted_3);
        }), 128))
    ]);
}

});

parcelRegister("fqzDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3b4edcb8b5d4f9f$export$2e2bcd8739ae039);
let $b3b4edcb8b5d4f9f$var$NOOP = ()=>{};
var $b3b4edcb8b5d4f9f$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("lOOqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe2561840b3bb468$export$2e2bcd8739ae039);
let $fe2561840b3bb468$var$script;




let $fe2561840b3bb468$var$initialize = ()=>{
    $fe2561840b3bb468$var$script = (parcelRequire("kUzEu"));
    if ($fe2561840b3bb468$var$script.__esModule) $fe2561840b3bb468$var$script = $fe2561840b3bb468$var$script.default;
    $fe2561840b3bb468$var$script.render = (parcelRequire("4eKFq")).render;
    $fe2561840b3bb468$var$script.__cssModules = {};
    (parcelRequire("1rYcB")).default($fe2561840b3bb468$var$script);
    $fe2561840b3bb468$var$script.__scopeId = 'data-v-0fd8b4';
    $fe2561840b3bb468$var$script.__file = "CalendarSheetSongs.vue";
};
$fe2561840b3bb468$var$initialize();
var $fe2561840b3bb468$export$2e2bcd8739ae039 = $fe2561840b3bb468$var$script;

});
parcelRegister("kUzEu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f394b15c8251bda5$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $9SSpS = parcelRequire("9SSpS");
var $f394b15c8251bda5$export$2e2bcd8739ae039 = {
    name: "CalendarSheetSongs",
    components: {
        SongPlayer: $9SSpS.default
    },
    data () {
        return {
            volume: 75,
            muted: false
        };
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "activeSeasonContentForSchoolLevel",
            "routedDay"
        ])
    },
    watch: {
        routedDay (newDay, oldDay) {
            // Unset tracking markers and playing state on the old day's songs.
            oldDay.songs?.forEach((song)=>{
                song.tracked = false;
                song.playing = false;
            });
        },
        volume (volume) {
            window.localStorage.setItem("volume", volume);
        }
    },
    mounted () {
        this.applyMemorizedVolume();
    },
    updated () {
        this.applyMemorizedVolume();
    },
    methods: {
        applyMemorizedVolume () {
            this.volume = Number(window.localStorage.getItem("volume") ?? 75);
        },
        onUpdatePlaying (playing, targetSong) {
            if (!playing) // We don't care if anyone stops playing.
            return;
            // Track playback.
            if (!targetSong.tracked && targetSong.vocalMix?.trackingUrl) {
                navigator.sendBeacon(targetSong.vocalMix.trackingUrl);
                targetSong.tracked = true;
            }
            // However, if someone does *start* playing, then we stop all other players.
            this.routedDay.songs.filter((song)=>song.slug !== targetSong.slug).forEach((song)=>song.playing = false);
        }
    }
};

});

parcelRegister("4eKFq", function(module, exports) {

$parcel$export(module.exports, "render", () => $315cab583a1117ee$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $315cab583a1117ee$var$_hoisted_1 = [
    "data-tracking-url-song"
];
const $315cab583a1117ee$var$_hoisted_2 = {
    class: "calendar-sheet__song-wrapper bg-school-level rounded-full py-1 text-white flex justify-between items-center"
};
const $315cab583a1117ee$var$_hoisted_3 = {
    class: "calendar-sheet__song-label font-[300] basis-auto grow-0 shrink-0 pl-[15px] pr-[7.5px]"
};
const $315cab583a1117ee$var$_hoisted_4 = {
    class: "audioPlayer-calendar calendar-sheet__song-player flex items-center min-w-[200px] p-[5px] bg-none"
};
function $315cab583a1117ee$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_song_player = (0, $xo6Zx.resolveComponent)("song-player");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", {
        id: "song-player",
        class: (0, $d8ZDz.normalizeClass)(_ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug)
    }, [
        ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)(_ctx.routedDay.songs, (song)=>{
            return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", {
                key: song.slug,
                class: "calendar-sheet__song karaokePlayer-view mt-[1.5vh]",
                "data-tracking-url-song": song.vocalMix.trackingUrl
            }, [
                (0, $xo6Zx.createElementVNode)("div", $315cab583a1117ee$var$_hoisted_2, [
                    (0, $xo6Zx.createElementVNode)("div", $315cab583a1117ee$var$_hoisted_3, (0, $d8ZDz.toDisplayString)(song.title), 1),
                    (0, $xo6Zx.createElementVNode)("div", $315cab583a1117ee$var$_hoisted_4, [
                        (0, $xo6Zx.createVNode)(_component_song_player, {
                            song: song.vocalMix,
                            playing: song.playing,
                            "onUpdate:playing": [
                                ($event)=>song.playing = $event,
                                ($event)=>$options.onUpdatePlaying($event, song)
                            ],
                            volume: $data.volume,
                            "onUpdate:volume": _cache[0] || (_cache[0] = ($event)=>$data.volume = $event),
                            muted: $data.muted,
                            "onUpdate:muted": _cache[1] || (_cache[1] = ($event)=>$data.muted = $event)
                        }, null, 8, [
                            "song",
                            "playing",
                            "onUpdate:playing",
                            "volume",
                            "muted"
                        ])
                    ])
                ])
            ], 8, $315cab583a1117ee$var$_hoisted_1);
        }), 128))
    ], 2);
}

});

parcelRegister("1rYcB", function(module, exports) {

$parcel$export(module.exports, "default", () => $10e702f83b743404$export$2e2bcd8739ae039);
let $10e702f83b743404$var$NOOP = ()=>{};
var $10e702f83b743404$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("NnXzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $094729a183dc0cf7$export$2e2bcd8739ae039);
let $094729a183dc0cf7$var$script;




let $094729a183dc0cf7$var$initialize = ()=>{
    $094729a183dc0cf7$var$script = (parcelRequire("ighB3"));
    if ($094729a183dc0cf7$var$script.__esModule) $094729a183dc0cf7$var$script = $094729a183dc0cf7$var$script.default;
    $094729a183dc0cf7$var$script.render = (parcelRequire("dR7gr")).render;
    $094729a183dc0cf7$var$script.__cssModules = {};
    (parcelRequire("5YSiJ")).default($094729a183dc0cf7$var$script);
    $094729a183dc0cf7$var$script.__scopeId = 'data-v-0d78ad';
    $094729a183dc0cf7$var$script.__file = "CalendarSheetVideo.vue";
};
$094729a183dc0cf7$var$initialize();
var $094729a183dc0cf7$export$2e2bcd8739ae039 = $094729a183dc0cf7$var$script;

});
parcelRegister("ighB3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d4b75ef539ec83cb$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");
parcelRequire("dT1o1");
var $d4b75ef539ec83cb$export$2e2bcd8739ae039 = {
    name: "CalendarSheetVideo",
    computed: {
        ...(0, $aofyc.mapGetters)([
            "routedDay",
            "routedSchoolLevel"
        ]),
        splitTitle () {
            const parts = this.routedDay.videos[0].title.split(":");
            return parts.length > 1 ? [
                parts[0].trim(),
                parts[1].trim()
            ] : [
                this.routedDay.videos[0].title
            ];
        },
        computedSchoolLevelBackgroundColor () {
            const slug = this.routedSchoolLevel?.slug;
            if (!slug) return "";
            const bgMap = {
                onderbouw: "bg-yellow-200",
                "midden-bovenbouw": "bg-yellowGreen-200"
            };
            return bgMap[slug] || "";
        }
    }
};

});

parcelRegister("dR7gr", function(module, exports) {

$parcel$export(module.exports, "render", () => $a165dc1b22812885$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $a165dc1b22812885$var$_hoisted_1 = {
    id: "calendar-sheet__video"
};
const $a165dc1b22812885$var$_hoisted_2 = [
    "innerHTML"
];
const $a165dc1b22812885$var$_hoisted_3 = {
    class: "font-sans pb-[2px] text-[14px]"
};
const $a165dc1b22812885$var$_hoisted_4 = {
    class: "font-bree text-[15px]"
};
function $a165dc1b22812885$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $a165dc1b22812885$var$_hoisted_1, [
        (0, $xo6Zx.createElementVNode)("div", {
            class: "",
            innerHTML: _ctx.routedDay.videos[0].videoFile?._rendered
        }, null, 8, $a165dc1b22812885$var$_hoisted_2),
        (0, $xo6Zx.createElementVNode)("div", {
            id: "calendar-sheet__video__title",
            class: (0, $d8ZDz.normalizeClass)([
                "video-preview-box__title text-almostBlack self-stretch grow pb-[15px] pt-[8px] pl-[13px] text-left rounded-br-[2rem]",
                $options.computedSchoolLevelBackgroundColor
            ])
        }, [
            (0, $xo6Zx.createElementVNode)("div", $a165dc1b22812885$var$_hoisted_3, (0, $d8ZDz.toDisplayString)($options.splitTitle[0]), 1),
            (0, $xo6Zx.createElementVNode)("div", $a165dc1b22812885$var$_hoisted_4, (0, $d8ZDz.toDisplayString)($options.splitTitle[1]), 1)
        ], 2)
    ]);
}

});

parcelRegister("5YSiJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $45acad682b57ce73$export$2e2bcd8739ae039);
let $45acad682b57ce73$var$NOOP = ()=>{};
var $45acad682b57ce73$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("hcLzV", function(module, exports) {

$parcel$export(module.exports, "render", () => $c86876c3d24361bb$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
const $c86876c3d24361bb$var$_hoisted_1 = {
    id: "calendar-sheet__section--media"
};
function $c86876c3d24361bb$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_calendar_sheet_links = (0, $xo6Zx.resolveComponent)("calendar-sheet-links");
    const _component_calendar_sheet_songs = (0, $xo6Zx.resolveComponent)("calendar-sheet-songs");
    const _component_calendar_sheet_video = (0, $xo6Zx.resolveComponent)("calendar-sheet-video");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("section", $c86876c3d24361bb$var$_hoisted_1, [
        _ctx.routedDay.calendarSheetLinks.length || _ctx.routedDay.songs.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), {
            key: 0
        }, [
            (0, $xo6Zx.createVNode)(_component_calendar_sheet_links),
            (0, $xo6Zx.createVNode)(_component_calendar_sheet_songs)
        ], 64)) : _ctx.routedDay.videos.length && _ctx.routedDay.videos[0].videoFile?._rendered ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_calendar_sheet_video, {
            key: 1
        })) : (0, $xo6Zx.createCommentVNode)("", true)
    ]);
}

});

parcelRegister("Lp3bQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $08e7d26627d912f6$export$2e2bcd8739ae039);
let $08e7d26627d912f6$var$NOOP = ()=>{};
var $08e7d26627d912f6$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("d1A70", function(module, exports) {

$parcel$export(module.exports, "render", () => $97b7617417e10e16$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
const $97b7617417e10e16$var$_hoisted_1 = {
    key: 0,
    id: "calendar-sheet"
};
const $97b7617417e10e16$var$_hoisted_2 = {
    id: "calendar-sheet__section--details",
    class: "flex flex-col grow shrink basis-[150px] justify-between items-center"
};
const $97b7617417e10e16$var$_hoisted_3 = {
    key: 1,
    class: "flex h-full justify-center items-center"
};
function $97b7617417e10e16$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_view = (0, $xo6Zx.resolveComponent)("router-view");
    const _component_calendar_sheet_meta = (0, $xo6Zx.resolveComponent)("calendar-sheet-meta");
    const _component_calendar_sheet_media = (0, $xo6Zx.resolveComponent)("calendar-sheet-media");
    const _component_calendar_widget = (0, $xo6Zx.resolveComponent)("calendar-widget");
    const _component_calendar_sheet_image = (0, $xo6Zx.resolveComponent)("calendar-sheet-image");
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    return _ctx.routedVideo ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_router_view, {
        key: 0
    })) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_transition_fade, {
        key: 1,
        duration: 500,
        appear: ""
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                _ctx.routedDay ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $97b7617417e10e16$var$_hoisted_1, [
                    (0, $xo6Zx.createElementVNode)("section", $97b7617417e10e16$var$_hoisted_2, [
                        (0, $xo6Zx.createVNode)(_component_calendar_sheet_meta),
                        (0, $xo6Zx.createVNode)(_component_calendar_sheet_media),
                        (0, $xo6Zx.createVNode)(_component_calendar_widget)
                    ]),
                    (0, $xo6Zx.createVNode)(_component_calendar_sheet_image, {
                        class: "flex flex-col grow shrink basis-[150px] justify-between items-center"
                    })
                ])) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $97b7617417e10e16$var$_hoisted_3, [
                    (0, $xo6Zx.createVNode)(_component_box_generic, {
                        header: "Geen materiaal"
                    }, {
                        default: (0, $xo6Zx.withCtx)(()=>[
                                ..._cache[0] || (_cache[0] = [
                                    (0, $xo6Zx.createElementVNode)("p", {
                                        class: "leading-relaxed"
                                    }, [
                                        (0, $xo6Zx.createTextVNode)(" In deze aflevering zijn er geen materialen"),
                                        (0, $xo6Zx.createElementVNode)("br"),
                                        (0, $xo6Zx.createTextVNode)(" voor het onderdeel \u201CKalender\u201D beschikbaar. ")
                                    ], -1)
                                ])
                            ]),
                        _: 1
                    })
                ]))
            ]),
        _: 1
    }));
}

});

parcelRegister("1A2G2", function(module, exports) {

$parcel$export(module.exports, "default", () => $126b3ad415006218$export$2e2bcd8739ae039);
let $126b3ad415006218$var$NOOP = ()=>{};
var $126b3ad415006218$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("2H8kg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f660e418afee776$export$2e2bcd8739ae039);

var $3z7M5 = parcelRequire("3z7M5");

var $9WzQp = parcelRequire("9WzQp");
var $1f660e418afee776$export$2e2bcd8739ae039 = [
    {
        path: "film/:seasonSlug?/",
        name: "FilmList",
        component: (0, $9WzQp.default),
        meta: {
            containerClass: "showVideoList"
        },
        children: [
            ...(0, $3z7M5.default)("FilmListVideoPlayer")
        ]
    }
];

});
parcelRegister("9WzQp", function(module, exports) {

$parcel$export(module.exports, "default", () => $73d555bf5c75aa62$export$2e2bcd8739ae039);
let $73d555bf5c75aa62$var$script;



let $73d555bf5c75aa62$var$initialize = ()=>{
    $73d555bf5c75aa62$var$script = (parcelRequire("fl50l"));
    if ($73d555bf5c75aa62$var$script.__esModule) $73d555bf5c75aa62$var$script = $73d555bf5c75aa62$var$script.default;
    $73d555bf5c75aa62$var$script.render = (parcelRequire("76ndY")).render;
    (parcelRequire("86Al8")).default($73d555bf5c75aa62$var$script);
    $73d555bf5c75aa62$var$script.__scopeId = 'data-v-69aa60';
    $73d555bf5c75aa62$var$script.__file = "FilmList.vue";
};
$73d555bf5c75aa62$var$initialize();
var $73d555bf5c75aa62$export$2e2bcd8739ae039 = $73d555bf5c75aa62$var$script;

});
parcelRegister("fl50l", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b2acb2f5784a865e$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $fGXCZ = parcelRequire("fGXCZ");

var $kLbI9 = parcelRequire("kLbI9");

var $gt6pA = parcelRequire("gt6pA");

var $3MWve = parcelRequire("3MWve");

var $QlUa3 = parcelRequire("QlUa3");

var $g3bhh = parcelRequire("g3bhh");

var $71EKI = parcelRequire("71EKI");
parcelRequire("dT1o1");
var $b2acb2f5784a865e$export$2e2bcd8739ae039 = {
    name: "FilmList",
    components: {
        BoxGeneric: $kLbI9.default,
        RouterView: $fGXCZ.RouterView,
        RouterLinkButton: $gt6pA.default,
        TransitionFade: $QlUa3.default,
        VideoPreview: $3MWve.default,
        MediaFilmLine: $71EKI.default,
        MediaFilmCircle: $g3bhh.default
    },
    computed: {
        ...(0, $aofyc.mapState)([
            "route"
        ]),
        ...(0, $aofyc.mapGetters)([
            "activeVolume",
            "activeSeason",
            "activeSeasonContentForSchoolLevel",
            "routedVideo"
        ]),
        computedHeaderClass () {
            const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
            return slug ? `title-block title-block-${slug}` : "title-block";
        }
    }
};

});

parcelRegister("76ndY", function(module, exports) {

$parcel$export(module.exports, "render", () => $52bb1bd2046fdc92$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
const $52bb1bd2046fdc92$var$_hoisted_1 = {
    key: 0,
    id: "video-list",
    class: "flex flex-wrap justify-center max-h-[calc(100vh_-_209px)] overflow-y-auto"
};
const $52bb1bd2046fdc92$var$_hoisted_2 = {
    key: 1,
    class: "flex h-full justify-center items-center"
};
const $52bb1bd2046fdc92$var$_hoisted_3 = {
    class: "mt-3 leading-relaxed"
};
function $52bb1bd2046fdc92$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_view = (0, $xo6Zx.resolveComponent)("router-view");
    const _component_video_preview = (0, $xo6Zx.resolveComponent)("video-preview");
    const _component_router_link_button = (0, $xo6Zx.resolveComponent)("router-link-button");
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    const _component_MediaFilmCircle = (0, $xo6Zx.resolveComponent)("MediaFilmCircle");
    const _component_MediaFilmLine = (0, $xo6Zx.resolveComponent)("MediaFilmLine");
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    return _ctx.routedVideo ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_router_view, {
        key: 0
    })) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_transition_fade, {
        key: 1,
        duration: 500,
        appear: ""
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                (0, $xo6Zx.createElementVNode)("div", null, [
                    (0, $xo6Zx.createVNode)(_component_box_generic, {
                        header: `${_ctx.activeVolume?.title} / ${_ctx.activeSeason?.issueNumber}`,
                        "header-class": $options.computedHeaderClass,
                        wStretch: true
                    }, {
                        default: (0, $xo6Zx.withCtx)(()=>[
                                _ctx.activeSeasonContentForSchoolLevel?.videos?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("ul", $52bb1bd2046fdc92$var$_hoisted_1, [
                                    ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)(_ctx.activeSeasonContentForSchoolLevel.videos, (video)=>{
                                        return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_video_preview, {
                                            key: video.slug,
                                            is: "li",
                                            video: video,
                                            to: {
                                                name: 'FilmListVideoPlayer',
                                                params: {
                                                    ..._ctx.route.params,
                                                    videoSlug: video.slug
                                                }
                                            },
                                            class: "rounded-[3.5rem]"
                                        }, null, 8, [
                                            "video",
                                            "to"
                                        ]);
                                    }), 128))
                                ])) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $52bb1bd2046fdc92$var$_hoisted_2, [
                                    (0, $xo6Zx.createVNode)(_component_box_generic, {
                                        header: "Geen materiaal"
                                    }, {
                                        default: (0, $xo6Zx.withCtx)(()=>[
                                                (0, $xo6Zx.createElementVNode)("p", $52bb1bd2046fdc92$var$_hoisted_3, [
                                                    _cache[1] || (_cache[1] = (0, $xo6Zx.createTextVNode)(" In deze aflevering zijn er geen filmpjes beschikbaar.", -1)),
                                                    _cache[2] || (_cache[2] = (0, $xo6Zx.createElementVNode)("br", null, null, -1)),
                                                    _cache[3] || (_cache[3] = (0, $xo6Zx.createTextVNode)(" U kunt altijd filmpjes vinden in het ", -1)),
                                                    (0, $xo6Zx.createVNode)(_component_router_link_button, {
                                                        to: {
                                                            name: 'FilmArchive'
                                                        },
                                                        class: "my-1"
                                                    }, {
                                                        default: (0, $xo6Zx.withCtx)(()=>[
                                                                ..._cache[0] || (_cache[0] = [
                                                                    (0, $xo6Zx.createTextVNode)(" Filmarchief", -1)
                                                                ])
                                                            ]),
                                                        _: 1
                                                    }),
                                                    _cache[4] || (_cache[4] = (0, $xo6Zx.createTextVNode)(". ", -1))
                                                ])
                                            ]),
                                        _: 1
                                    })
                                ]))
                            ]),
                        _: 1
                    }, 8, [
                        "header",
                        "header-class"
                    ]),
                    (0, $xo6Zx.createVNode)(_component_MediaFilmCircle, {
                        class: "pointer-events-none absolute top-0 right-0 translate-x-[-20%] translate-y-[20%]",
                        color: _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw' ? '#127b5d' : '#6c44a5'
                    }, null, 8, [
                        "color"
                    ]),
                    (0, $xo6Zx.createVNode)(_component_MediaFilmLine, {
                        class: "pointer-events-none absolute bottom-0 right-0 translate-x-[2%] translate-y-[-5%]",
                        color: _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw' ? '#127b5d' : '#6c44a5'
                    }, null, 8, [
                        "color"
                    ])
                ])
            ]),
        _: 1
    }));
}

});

parcelRegister("86Al8", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e6b129fe1bcd361$export$2e2bcd8739ae039);
let $5e6b129fe1bcd361$var$NOOP = ()=>{};
var $5e6b129fe1bcd361$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("h99AO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7bab7dead517f6f$export$2e2bcd8739ae039);

var $ivPjW = parcelRequire("ivPjW");

var $4g8wY = parcelRequire("4g8wY");
var $c7bab7dead517f6f$export$2e2bcd8739ae039 = [
    {
        path: "muziek/:seasonSlug?/",
        name: "SongList",
        component: (0, $4g8wY.default),
        meta: {
            containerClass: "showSongList"
        },
        children: [
            ...(0, $ivPjW.default)("SongListKaraokePlayer")
        ]
    }
];

});
parcelRegister("4g8wY", function(module, exports) {

$parcel$export(module.exports, "default", () => $319f461a58f44588$export$2e2bcd8739ae039);
let $319f461a58f44588$var$script;




let $319f461a58f44588$var$initialize = ()=>{
    $319f461a58f44588$var$script = (parcelRequire("exoCx"));
    if ($319f461a58f44588$var$script.__esModule) $319f461a58f44588$var$script = $319f461a58f44588$var$script.default;
    $319f461a58f44588$var$script.render = (parcelRequire("bnKaa")).render;
    $319f461a58f44588$var$script.__cssModules = {};
    (parcelRequire("heU44")).default($319f461a58f44588$var$script);
    $319f461a58f44588$var$script.__scopeId = 'data-v-8a4e9c';
    $319f461a58f44588$var$script.__file = "SongList.vue";
};
$319f461a58f44588$var$initialize();
var $319f461a58f44588$export$2e2bcd8739ae039 = $319f461a58f44588$var$script;

});
parcelRegister("exoCx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a9573ee868250f3a$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $fGXCZ = parcelRequire("fGXCZ");

var $kLbI9 = parcelRequire("kLbI9");

var $gt6pA = parcelRequire("gt6pA");

var $QlUa3 = parcelRequire("QlUa3");

var $5KPKG = parcelRequire("5KPKG");

var $iG6cs = parcelRequire("iG6cs");
var $a9573ee868250f3a$export$2e2bcd8739ae039 = {
    name: "SongList",
    components: {
        BoxGeneric: $kLbI9.default,
        RouterView: $fGXCZ.RouterView,
        RouterLink: $fGXCZ.RouterLink,
        RouterLinkButton: $gt6pA.default,
        TransitionFade: $QlUa3.default,
        MediaMusicCircle: $5KPKG.default,
        MediaMusicLine: $iG6cs.default
    },
    data () {
        return {
            scrollPosition: undefined,
            scrollMax: undefined
        };
    },
    computed: {
        ...(0, $aofyc.mapState)([
            "route"
        ]),
        ...(0, $aofyc.mapGetters)([
            "activeVolume",
            "activeSeason",
            "activeSeasonContentForSchoolLevel",
            "routedSong"
        ]),
        scrollPercent () {
            // Only available after mounted.
            this.scrollPosition;
            return this.scrollPosition / this.scrollMax * 100;
        },
        fadeOutLeft () {
            return this.scrollPercent > 0;
        },
        fadeOutRight () {
            return this.scrollPercent < 100;
        }
    },
    watch: {
        activeSeasonContentForSchoolLevel () {
            // Make sure to re-set `scrollMax`: The number of songs has probably changed.
            // The width might thus have changed. The `scrollPercent` must be re-calculated.
            // What is a 100% scroll to the side on a short list of songs, will be only
            // a 60% scroll on a much longer list of songs.
            this.$nextTick(()=>{
                this.onScroll();
            });
        }
    },
    mounted () {
        this.onScroll();
    },
    methods: {
        onScroll () {
            // Only if list view is shown (= if no routed song). Otherwise return.
            if (!this.$refs.songList) return;
            this.scrollPosition = Math.ceil(this.$refs.songList.scrollLeft);
            this.scrollMax = this.$refs.songList?.scrollWidth - this.$refs.songList?.clientWidth;
        }
    }
};

});

parcelRegister("bnKaa", function(module, exports) {

$parcel$export(module.exports, "render", () => $8495a6b0838b4e2a$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $8495a6b0838b4e2a$var$_hoisted_1 = {
    key: 0,
    id: "song-list-header"
};
const $8495a6b0838b4e2a$var$_hoisted_2 = {
    key: 0
};
const $8495a6b0838b4e2a$var$_hoisted_3 = {
    class: "song-list__song-item__title grow text-[17px] font-light py-0 pr-[20px] pl-[10px]"
};
const $8495a6b0838b4e2a$var$_hoisted_4 = {
    key: 0,
    class: "absolute inset-y-0 left-0 w-16 fade-out-left pointer-events-none"
};
const $8495a6b0838b4e2a$var$_hoisted_5 = {
    key: 0,
    class: "absolute inset-y-0 right-0 w-16 fade-out-right pointer-events-none"
};
const $8495a6b0838b4e2a$var$_hoisted_6 = {
    key: 1,
    class: "flex h-full justify-center items-center"
};
const $8495a6b0838b4e2a$var$_hoisted_7 = {
    class: "mt-3 leading-relaxed"
};
function $8495a6b0838b4e2a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_view = (0, $xo6Zx.resolveComponent)("router-view");
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    const _component_router_link = (0, $xo6Zx.resolveComponent)("router-link");
    const _component_MediaMusicCircle = (0, $xo6Zx.resolveComponent)("MediaMusicCircle");
    const _component_MediaMusicLine = (0, $xo6Zx.resolveComponent)("MediaMusicLine");
    const _component_router_link_button = (0, $xo6Zx.resolveComponent)("router-link-button");
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    return _ctx.routedSong ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_router_view, {
        key: 0
    })) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), {
        key: 1
    }, [
        (0, $xo6Zx.createVNode)(_component_transition_fade, {
            duration: 500,
            appear: ""
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    _ctx.activeSeasonContentForSchoolLevel ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $8495a6b0838b4e2a$var$_hoisted_1, [
                        (0, $xo6Zx.createElementVNode)("h1", {
                            class: (0, $d8ZDz.normalizeClass)([
                                "title-block",
                                {
                                    'title-block-onderbouw': _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw',
                                    'title-block-midden-bovenbouw': _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug === 'midden-bovenbouw'
                                }
                            ])
                        }, (0, $d8ZDz.toDisplayString)(_ctx.activeVolume.title) + " / " + (0, $d8ZDz.toDisplayString)(_ctx.activeSeason.issueNumber), 3)
                    ])) : (0, $xo6Zx.createCommentVNode)("", true)
                ]),
            _: 1
        }),
        (0, $xo6Zx.createVNode)(_component_transition_fade, {
            duration: 500,
            appear: ""
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    _ctx.activeSeasonContentForSchoolLevel?.songs?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $8495a6b0838b4e2a$var$_hoisted_2, [
                        (0, $xo6Zx.createElementVNode)("ul", {
                            ref: "songList",
                            id: "song-list",
                            class: "content-start bg-white rounded-3xl flex flex-wrap flex-col max-h-[calc(100vh_-_240px)] justify-start mb-[-20px] overflow-x-auto py-[29px] pr-[28px] pl-[9px]",
                            onScroll: _cache[0] || (_cache[0] = (...args)=>$options.onScroll && $options.onScroll(...args))
                        }, [
                            ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)(_ctx.activeSeasonContentForSchoolLevel.songs, (song)=>{
                                return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("li", {
                                    key: song.slug,
                                    class: "song-list__song-item border-0 border-r-2 border-solid border-r-black/20 max-w-[398px] px-[10px]"
                                }, [
                                    (0, $xo6Zx.createVNode)(_component_router_link, {
                                        to: {
                                            name: 'SongListKaraokePlayer',
                                            params: {
                                                ..._ctx.route.params,
                                                songSlug: song.slug
                                            }
                                        },
                                        class: "song-list__song-item__link items-center bg-white border-0 border-b border-solid border-b-green text-almostBlack flex justify-between py-[7px] px-[10px] no-underline scale-100 transition-all duration-300 ease-[cubic-bezier(.25,.8,.25,1)] hover:bg-hover hover:scale-x-105 hover:ease-[ease]"
                                    }, {
                                        default: (0, $xo6Zx.withCtx)(()=>[
                                                (0, $xo6Zx.createElementVNode)("div", $8495a6b0838b4e2a$var$_hoisted_3, (0, $d8ZDz.toDisplayString)(song.title), 1),
                                                (0, $xo6Zx.createElementVNode)("div", {
                                                    class: (0, $d8ZDz.normalizeClass)([
                                                        "song-list__song-item__duration text-green text-[11px] tracking-[-0.4px]",
                                                        _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw' ? 'text-green' : 'text-purple'
                                                    ])
                                                }, (0, $d8ZDz.toDisplayString)((song.vocalMix ?? song.karaokeSoundMix)?.durationFormatted || "00:00"), 3)
                                            ]),
                                        _: 2
                                    }, 1032, [
                                        "to"
                                    ])
                                ]);
                            }), 128))
                        ], 544),
                        (0, $xo6Zx.createVNode)(_component_MediaMusicCircle, {
                            class: "pointer-events-none absolute top-0 right-0 translate-x-[-20%] translate-y-[20%]",
                            color: _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw' ? '#127b5d' : '#6c44a5'
                        }, null, 8, [
                            "color"
                        ]),
                        (0, $xo6Zx.createVNode)(_component_MediaMusicLine, {
                            class: "pointer-events-none absolute bottom-0 right-0 translate-x-[0%] translate-y-[-5%]",
                            color: _ctx.activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw' ? '#127b5d' : '#6c44a5'
                        }, null, 8, [
                            "color"
                        ]),
                        (0, $xo6Zx.createVNode)(_component_transition_fade, {
                            duration: 200
                        }, {
                            default: (0, $xo6Zx.withCtx)(()=>[
                                    $options.fadeOutLeft ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $8495a6b0838b4e2a$var$_hoisted_4)) : (0, $xo6Zx.createCommentVNode)("", true)
                                ]),
                            _: 1
                        }),
                        (0, $xo6Zx.createVNode)(_component_transition_fade, {
                            duration: 200
                        }, {
                            default: (0, $xo6Zx.withCtx)(()=>[
                                    $options.fadeOutRight ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $8495a6b0838b4e2a$var$_hoisted_5)) : (0, $xo6Zx.createCommentVNode)("", true)
                                ]),
                            _: 1
                        })
                    ])) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $8495a6b0838b4e2a$var$_hoisted_6, [
                        (0, $xo6Zx.createVNode)(_component_box_generic, {
                            header: "Geen materiaal"
                        }, {
                            default: (0, $xo6Zx.withCtx)(()=>[
                                    (0, $xo6Zx.createElementVNode)("p", $8495a6b0838b4e2a$var$_hoisted_7, [
                                        _cache[2] || (_cache[2] = (0, $xo6Zx.createTextVNode)(" In deze aflevering zijn er geen liedjes beschikbaar.", -1)),
                                        _cache[3] || (_cache[3] = (0, $xo6Zx.createElementVNode)("br", null, null, -1)),
                                        _cache[4] || (_cache[4] = (0, $xo6Zx.createTextVNode)(" U kunt altijd liedjes vinden in het ", -1)),
                                        (0, $xo6Zx.createVNode)(_component_router_link_button, {
                                            to: {
                                                name: 'MusicArchive'
                                            },
                                            class: "my-1"
                                        }, {
                                            default: (0, $xo6Zx.withCtx)(()=>[
                                                    ..._cache[1] || (_cache[1] = [
                                                        (0, $xo6Zx.createTextVNode)(" Muziekarchief", -1)
                                                    ])
                                                ]),
                                            _: 1
                                        }),
                                        _cache[5] || (_cache[5] = (0, $xo6Zx.createTextVNode)(". ", -1))
                                    ])
                                ]),
                            _: 1
                        })
                    ]))
                ]),
            _: 1
        })
    ], 64));
}

});

parcelRegister("heU44", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8cf3bc48fd5f8ae$export$2e2bcd8739ae039);
let $c8cf3bc48fd5f8ae$var$NOOP = ()=>{};
var $c8cf3bc48fd5f8ae$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("nXq8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $04803dce2b9e9721$export$2e2bcd8739ae039);

var $39xD6 = parcelRequire("39xD6");
var $04803dce2b9e9721$export$2e2bcd8739ae039 = [
    {
        path: "materiaal/",
        name: "MaterialContent",
        component: (0, $39xD6.default),
        meta: {
            containerClass: "showMaterialContent"
        },
        children: [
            {
                path: ":seasonSlug/",
                name: "MaterialContentWithSeason",
                component: (0, $39xD6.default)
            }
        ]
    }
];

});
parcelRegister("39xD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $24bc4c8057ea6bcf$export$2e2bcd8739ae039);
let $24bc4c8057ea6bcf$var$script;




let $24bc4c8057ea6bcf$var$initialize = ()=>{
    $24bc4c8057ea6bcf$var$script = (parcelRequire("3DaYA"));
    if ($24bc4c8057ea6bcf$var$script.__esModule) $24bc4c8057ea6bcf$var$script = $24bc4c8057ea6bcf$var$script.default;
    $24bc4c8057ea6bcf$var$script.render = (parcelRequire("h623p")).render;
    $24bc4c8057ea6bcf$var$script.__cssModules = {};
    (parcelRequire("cAE1f")).default($24bc4c8057ea6bcf$var$script);
    $24bc4c8057ea6bcf$var$script.__scopeId = 'data-v-dc62df';
    $24bc4c8057ea6bcf$var$script.__file = "MaterialContent.vue";
};
$24bc4c8057ea6bcf$var$initialize();
var $24bc4c8057ea6bcf$export$2e2bcd8739ae039 = $24bc4c8057ea6bcf$var$script;

});
parcelRegister("3DaYA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2a4d8747da5fd0bd$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $kLbI9 = parcelRequire("kLbI9");

var $2XQKT = parcelRequire("2XQKT");

var $QlUa3 = parcelRequire("QlUa3");

var $1UYcK = parcelRequire("1UYcK");

var $cCNWR = parcelRequire("cCNWR");
var $2a4d8747da5fd0bd$export$2e2bcd8739ae039 = {
    name: "MaterialContent",
    components: {
        BoxGeneric: $kLbI9.default,
        MaterialBox: $2XQKT.default,
        TransitionFade: $QlUa3.default
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "activeSeasonContentForSchoolLevel"
        ]),
        hasContent () {
            return [
                "materialTitleYear",
                "materialContentYear",
                "materialTitleHoliday",
                "materialContentHoliday",
                "materialTitleIssue",
                "materialContentIssue"
            ].some((key)=>this.activeSeasonContentForSchoolLevel?.[key].length);
        }
    },
    watch: {
        activeSeasonContentForSchoolLevel () {
            this.$nextTick(()=>{
                (0, $cCNWR.default)();
                (0, $1UYcK.default)();
            });
        }
    },
    mounted () {
        (0, $1UYcK.default)();
    },
    beforeUnmount () {
        (0, $cCNWR.default)();
    }
};

});
parcelRegister("2XQKT", function(module, exports) {

$parcel$export(module.exports, "default", () => $228a038def79f40a$export$2e2bcd8739ae039);
let $228a038def79f40a$var$script;




let $228a038def79f40a$var$initialize = ()=>{
    $228a038def79f40a$var$script = (parcelRequire("8vjYt"));
    if ($228a038def79f40a$var$script.__esModule) $228a038def79f40a$var$script = $228a038def79f40a$var$script.default;
    $228a038def79f40a$var$script.render = (parcelRequire("1OudG")).render;
    $228a038def79f40a$var$script.__cssModules = {};
    (parcelRequire("gqqiF")).default($228a038def79f40a$var$script);
    $228a038def79f40a$var$script.__scopeId = 'data-v-7a2199';
    $228a038def79f40a$var$script.__file = "MaterialBox.vue";
};
$228a038def79f40a$var$initialize();
var $228a038def79f40a$export$2e2bcd8739ae039 = $228a038def79f40a$var$script;

});
parcelRegister("8vjYt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6310b67a14335d2f$export$2e2bcd8739ae039);

var $kLbI9 = parcelRequire("kLbI9");

var $aofyc = parcelRequire("aofyc");
var $6310b67a14335d2f$export$2e2bcd8739ae039 = {
    name: "MaterialBox",
    components: {
        BoxGeneric: $kLbI9.default
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "activeSeasonContentForSchoolLevel"
        ]),
        computedHeaderClass () {
            const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
            return slug ? `title-block title-block-${slug}` : "title-block";
        }
    },
    props: {
        title: {
            type: String
        },
        content: {
            type: Array
        }
    }
};

});

parcelRegister("1OudG", function(module, exports) {

$parcel$export(module.exports, "render", () => $1521e6f7bd7d01fa$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
const $1521e6f7bd7d01fa$var$_hoisted_1 = [
    "innerHTML"
];
function $1521e6f7bd7d01fa$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    return $props.title && $props.content?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_box_generic, {
        key: 0,
        header: $props.title,
        class: "material-box",
        "header-class": $options.computedHeaderClass,
        "h-stretch": ""
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)($props.content, (contentItem, index)=>{
                    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), {
                        key: index
                    }, [
                        contentItem._rendered ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", {
                            key: 0,
                            class: "font-bree",
                            innerHTML: contentItem._rendered
                        }, null, 8, $1521e6f7bd7d01fa$var$_hoisted_1)) : (0, $xo6Zx.createCommentVNode)("", true)
                    ], 64);
                }), 128))
            ]),
        _: 1
    }, 8, [
        "header",
        "header-class"
    ])) : (0, $xo6Zx.createCommentVNode)("", true);
}

});

parcelRegister("gqqiF", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5379b1a93216b0$export$2e2bcd8739ae039);
let $bf5379b1a93216b0$var$NOOP = ()=>{};
var $bf5379b1a93216b0$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("h623p", function(module, exports) {

$parcel$export(module.exports, "render", () => $c7249716595b0954$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
const $c7249716595b0954$var$_hoisted_1 = {
    key: 1,
    class: "flex h-full justify-center items-center"
};
function $c7249716595b0954$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_material_box = (0, $xo6Zx.resolveComponent)("material-box");
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    return $options.hasContent ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), {
        key: 0
    }, [
        (0, $xo6Zx.createVNode)(_component_transition_fade, {
            duration: 500,
            appear: ""
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    (0, $xo6Zx.createVNode)(_component_material_box, {
                        id: "material-box-year",
                        title: _ctx.activeSeasonContentForSchoolLevel?.materialTitleYear,
                        content: _ctx.activeSeasonContentForSchoolLevel?.materialContentYear
                    }, null, 8, [
                        "title",
                        "content"
                    ])
                ]),
            _: 1
        }),
        (0, $xo6Zx.createVNode)(_component_transition_fade, {
            duration: 500,
            appear: ""
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    (0, $xo6Zx.createVNode)(_component_material_box, {
                        id: "material-box-holiday",
                        title: _ctx.activeSeasonContentForSchoolLevel?.materialTitleHoliday,
                        content: _ctx.activeSeasonContentForSchoolLevel?.materialContentHoliday
                    }, null, 8, [
                        "title",
                        "content"
                    ])
                ]),
            _: 1
        }),
        (0, $xo6Zx.createVNode)(_component_transition_fade, {
            duration: 500,
            appear: ""
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    (0, $xo6Zx.createVNode)(_component_material_box, {
                        id: "material-box-issue",
                        title: _ctx.activeSeasonContentForSchoolLevel?.materialTitleIssue,
                        content: _ctx.activeSeasonContentForSchoolLevel?.materialContentIssue
                    }, null, 8, [
                        "title",
                        "content"
                    ])
                ]),
            _: 1
        })
    ], 64)) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $c7249716595b0954$var$_hoisted_1, [
        (0, $xo6Zx.createVNode)(_component_box_generic, {
            header: "Geen materiaal",
            "h-stretch": ""
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    ..._cache[0] || (_cache[0] = [
                        (0, $xo6Zx.createElementVNode)("p", {
                            class: "leading-relaxed"
                        }, [
                            (0, $xo6Zx.createTextVNode)(" In deze aflevering zijn er geen materialen"),
                            (0, $xo6Zx.createElementVNode)("br"),
                            (0, $xo6Zx.createTextVNode)(" voor het onderdeel \u201CMateriaal\u201D beschikbaar. ")
                        ], -1)
                    ])
                ]),
            _: 1
        })
    ]));
}

});

parcelRegister("cAE1f", function(module, exports) {

$parcel$export(module.exports, "default", () => $92a7e3cd17dc5d85$export$2e2bcd8739ae039);
let $92a7e3cd17dc5d85$var$NOOP = ()=>{};
var $92a7e3cd17dc5d85$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("dUbz5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1f979df8ff51a45$export$2e2bcd8739ae039);

var $8893T = parcelRequire("8893T");
var $a1f979df8ff51a45$export$2e2bcd8739ae039 = [
    {
        path: "leerkracht/",
        name: "TeacherContent",
        component: (0, $8893T.default),
        meta: {
            containerClass: "showTeacherContent"
        },
        children: [
            {
                path: ":seasonSlug/",
                name: "TeacherContentWithSeason",
                component: (0, $8893T.default)
            }
        ]
    }
];

});
parcelRegister("8893T", function(module, exports) {

$parcel$export(module.exports, "default", () => $5eb61990320c1d31$export$2e2bcd8739ae039);
let $5eb61990320c1d31$var$script;




let $5eb61990320c1d31$var$initialize = ()=>{
    $5eb61990320c1d31$var$script = (parcelRequire("7vlmn"));
    if ($5eb61990320c1d31$var$script.__esModule) $5eb61990320c1d31$var$script = $5eb61990320c1d31$var$script.default;
    $5eb61990320c1d31$var$script.render = (parcelRequire("vbdQS")).render;
    $5eb61990320c1d31$var$script.__cssModules = {};
    (parcelRequire("5gElz")).default($5eb61990320c1d31$var$script);
    $5eb61990320c1d31$var$script.__scopeId = 'data-v-b721e0';
    $5eb61990320c1d31$var$script.__file = "TeacherContent.vue";
};
$5eb61990320c1d31$var$initialize();
var $5eb61990320c1d31$export$2e2bcd8739ae039 = $5eb61990320c1d31$var$script;

});
parcelRegister("7vlmn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $576bff4afa1128d1$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $kLbI9 = parcelRequire("kLbI9");

var $SR5YW = parcelRequire("SR5YW");

var $QlUa3 = parcelRequire("QlUa3");

var $1UYcK = parcelRequire("1UYcK");

var $cCNWR = parcelRequire("cCNWR");
var $576bff4afa1128d1$export$2e2bcd8739ae039 = {
    name: "TeacherContent",
    components: {
        BoxGeneric: $kLbI9.default,
        TeacherBox: $SR5YW.default,
        TransitionFade: $QlUa3.default
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "activeSeasonContentForSchoolLevel"
        ]),
        hasContent () {
            return [
                "teacherTitle1",
                "teacherContent1",
                "teacherTitle2",
                "teacherContent2",
                "teacherTitle3",
                "teacherContent3"
            ].some((key)=>this.activeSeasonContentForSchoolLevel?.[key].length);
        }
    },
    watch: {
        activeSeasonContentForSchoolLevel () {
            this.$nextTick(()=>{
                (0, $cCNWR.default)();
                (0, $1UYcK.default)();
            });
        }
    },
    mounted () {
        (0, $1UYcK.default)();
    },
    beforeUnmount () {
        (0, $cCNWR.default)();
    }
};

});
parcelRegister("SR5YW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a4e3aeac3aefb4b$export$2e2bcd8739ae039);
let $0a4e3aeac3aefb4b$var$script;




let $0a4e3aeac3aefb4b$var$initialize = ()=>{
    $0a4e3aeac3aefb4b$var$script = (parcelRequire("lsJcX"));
    if ($0a4e3aeac3aefb4b$var$script.__esModule) $0a4e3aeac3aefb4b$var$script = $0a4e3aeac3aefb4b$var$script.default;
    $0a4e3aeac3aefb4b$var$script.render = (parcelRequire("6fCrf")).render;
    $0a4e3aeac3aefb4b$var$script.__cssModules = {};
    (parcelRequire("aQCuE")).default($0a4e3aeac3aefb4b$var$script);
    $0a4e3aeac3aefb4b$var$script.__scopeId = 'data-v-4c292f';
    $0a4e3aeac3aefb4b$var$script.__file = "TeacherBox.vue";
};
$0a4e3aeac3aefb4b$var$initialize();
var $0a4e3aeac3aefb4b$export$2e2bcd8739ae039 = $0a4e3aeac3aefb4b$var$script;

});
parcelRegister("lsJcX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f9ff47d6e0b6cf17$export$2e2bcd8739ae039);

var $kLbI9 = parcelRequire("kLbI9");

var $aofyc = parcelRequire("aofyc");
var $f9ff47d6e0b6cf17$export$2e2bcd8739ae039 = {
    name: "MaterialBox",
    components: {
        BoxGeneric: $kLbI9.default
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "activeSeasonContentForSchoolLevel"
        ]),
        computedHeaderClass () {
            const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
            return slug ? `title-block title-block-${slug}` : "title-block";
        }
    },
    props: {
        title: {
            type: String
        },
        content: {
            type: Array
        }
    }
};

});

parcelRegister("6fCrf", function(module, exports) {

$parcel$export(module.exports, "render", () => $48d1f5e239677b99$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
const $48d1f5e239677b99$var$_hoisted_1 = [
    "innerHTML"
];
function $48d1f5e239677b99$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    return $props.title && $props.content?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_box_generic, {
        key: 0,
        header: $props.title,
        class: "teacher-box",
        "header-class": $options.computedHeaderClass,
        "h-stretch": ""
    }, {
        default: (0, $xo6Zx.withCtx)(()=>[
                ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)($props.content, (contentItem, index)=>{
                    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), {
                        key: index
                    }, [
                        contentItem._rendered ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", {
                            key: 0,
                            class: "font-bree",
                            innerHTML: contentItem._rendered
                        }, null, 8, $48d1f5e239677b99$var$_hoisted_1)) : (0, $xo6Zx.createCommentVNode)("", true)
                    ], 64);
                }), 128))
            ]),
        _: 1
    }, 8, [
        "header",
        "header-class"
    ])) : (0, $xo6Zx.createCommentVNode)("", true);
}

});

parcelRegister("aQCuE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e5c9eb3b32cf596$export$2e2bcd8739ae039);
let $7e5c9eb3b32cf596$var$NOOP = ()=>{};
var $7e5c9eb3b32cf596$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("vbdQS", function(module, exports) {

$parcel$export(module.exports, "render", () => $05db99e74d162f43$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
const $05db99e74d162f43$var$_hoisted_1 = {
    key: 1,
    class: "flex h-full justify-center items-center"
};
function $05db99e74d162f43$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_teacher_box = (0, $xo6Zx.resolveComponent)("teacher-box");
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    return $options.hasContent ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), {
        key: 0
    }, [
        (0, $xo6Zx.createVNode)(_component_transition_fade, {
            duration: 500,
            appear: ""
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    (0, $xo6Zx.createVNode)(_component_teacher_box, {
                        id: "teacher-box-1",
                        title: _ctx.activeSeasonContentForSchoolLevel?.teacherTitle1,
                        content: _ctx.activeSeasonContentForSchoolLevel?.teacherContent1
                    }, null, 8, [
                        "title",
                        "content"
                    ])
                ]),
            _: 1
        }),
        (0, $xo6Zx.createVNode)(_component_transition_fade, {
            duration: 500,
            appear: ""
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    (0, $xo6Zx.createVNode)(_component_teacher_box, {
                        id: "teacher-box-2",
                        title: _ctx.activeSeasonContentForSchoolLevel?.teacherTitle2,
                        content: _ctx.activeSeasonContentForSchoolLevel?.teacherContent2
                    }, null, 8, [
                        "title",
                        "content"
                    ])
                ]),
            _: 1
        }),
        (0, $xo6Zx.createVNode)(_component_transition_fade, {
            duration: 500,
            appear: ""
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    (0, $xo6Zx.createVNode)(_component_teacher_box, {
                        id: "teacher-box-3",
                        title: _ctx.activeSeasonContentForSchoolLevel?.teacherTitle3,
                        content: _ctx.activeSeasonContentForSchoolLevel?.teacherContent3
                    }, null, 8, [
                        "title",
                        "content"
                    ])
                ]),
            _: 1
        })
    ], 64)) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $05db99e74d162f43$var$_hoisted_1, [
        (0, $xo6Zx.createVNode)(_component_box_generic, {
            header: "Geen materiaal",
            "h-stretch": ""
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    ..._cache[0] || (_cache[0] = [
                        (0, $xo6Zx.createElementVNode)("p", {
                            class: "leading-relaxed"
                        }, [
                            (0, $xo6Zx.createTextVNode)(" In deze aflevering zijn er geen materialen"),
                            (0, $xo6Zx.createElementVNode)("br"),
                            (0, $xo6Zx.createTextVNode)(" voor het onderdeel \u201CLeerkracht\u201D beschikbaar. ")
                        ], -1)
                    ])
                ]),
            _: 1
        })
    ]));
}

});

parcelRegister("5gElz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d5dbe716acd2746$export$2e2bcd8739ae039);
let $3d5dbe716acd2746$var$NOOP = ()=>{};
var $3d5dbe716acd2746$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("2wysN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d694da38298cb10$export$2e2bcd8739ae039);
let $1d694da38298cb10$var$script;



let $1d694da38298cb10$var$initialize = ()=>{
    $1d694da38298cb10$var$script = (parcelRequire("ftvjb"));
    if ($1d694da38298cb10$var$script.__esModule) $1d694da38298cb10$var$script = $1d694da38298cb10$var$script.default;
    $1d694da38298cb10$var$script.render = (parcelRequire("9gEGh")).render;
    (parcelRequire("hrmU7")).default($1d694da38298cb10$var$script);
    $1d694da38298cb10$var$script.__scopeId = 'data-v-6ccd31';
    $1d694da38298cb10$var$script.__file = "SectionMenu.vue";
};
$1d694da38298cb10$var$initialize();
var $1d694da38298cb10$export$2e2bcd8739ae039 = $1d694da38298cb10$var$script;

});
parcelRegister("ftvjb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b441d99fb0f3a83b$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $fGXCZ = parcelRequire("fGXCZ");

var $lP8to = parcelRequire("lP8to");

var $iTCXQ = parcelRequire("iTCXQ");
const $b441d99fb0f3a83b$var$findSeasonContentForSchoolLevel = (season, schoolLevel)=>(0, $lP8to.default)(season.seasonContentForSchoolLevel, "schoolLevel", schoolLevel.slug);
var $b441d99fb0f3a83b$export$2e2bcd8739ae039 = {
    name: "SectionMenu",
    components: {
        MenuSection: $iTCXQ.default,
        RouterLink: $fGXCZ.RouterLink
    },
    computed: {
        ...(0, $aofyc.mapGetters)([
            "activeVolume",
            "activeSchoolLevel",
            "activeSeason"
        ]),
        calendarItems () {
            return this.getSectionItems("days", "CalendarSheet");
        },
        filmItems () {
            return this.getSectionItems("videos", "FilmList");
        },
        musicItems () {
            return this.getSectionItems("songs", "SongList");
        },
        materialItems () {
            return this.getSectionItems((seasonContentForSchoolLevel)=>seasonContentForSchoolLevel?.materialTitleYear && seasonContentForSchoolLevel?.materialContentYear.length || seasonContentForSchoolLevel?.materialTitleIssue && seasonContentForSchoolLevel?.materialContentIssue.length || seasonContentForSchoolLevel?.materialTitleHoliday && seasonContentForSchoolLevel?.materialContentHoliday.length, "MaterialContentWithSeason");
        },
        teacherItems () {
            return this.getSectionItems((seasonContentForSchoolLevel)=>seasonContentForSchoolLevel?.teacherTitle1 && seasonContentForSchoolLevel?.teacherContent1.length || seasonContentForSchoolLevel?.teacherTitle2 && seasonContentForSchoolLevel?.teacherContent2.length || seasonContentForSchoolLevel?.teacherTitle3 && seasonContentForSchoolLevel?.teacherContent3.length, "TeacherContentWithSeason");
        }
    },
    methods: {
        getSectionItems (section, itemRoute) {
            if (!this.activeSchoolLevel) return null;
            const now = new Date();
            return this.activeVolume?.seasons.filter((season)=>{
                // Only visible seasons.
                if (season.frontendDisplayStartDate && new Date(season.frontendDisplayStartDate) > now) return false;
                if (season.frontendDisplayEndDate && new Date(season.frontendDisplayEndDate) < now) return false;
                const seasonContentForSchoolLevel = $b441d99fb0f3a83b$var$findSeasonContentForSchoolLevel(season, this.activeSchoolLevel);
                // Allow section to be a callback ot evaluate
                // the `seasonContentForSchoolLevel` properties.
                return section instanceof Function ? section(seasonContentForSchoolLevel) : !!seasonContentForSchoolLevel?.[section].length;
            }).map((season)=>({
                    key: season.slug,
                    title: `${this.activeVolume.title} / ${season.issueNumber}`,
                    to: {
                        name: itemRoute,
                        params: {
                            seasonSlug: season.slug
                        }
                    }
                }));
        }
    }
};

});
parcelRegister("iTCXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc1b968aa13856b6$export$2e2bcd8739ae039);
let $dc1b968aa13856b6$var$script;



let $dc1b968aa13856b6$var$initialize = ()=>{
    $dc1b968aa13856b6$var$script = (parcelRequire("fQDnE"));
    if ($dc1b968aa13856b6$var$script.__esModule) $dc1b968aa13856b6$var$script = $dc1b968aa13856b6$var$script.default;
    $dc1b968aa13856b6$var$script.render = (parcelRequire("cPwiZ")).render;
    (parcelRequire("1D9f6")).default($dc1b968aa13856b6$var$script);
    $dc1b968aa13856b6$var$script.__scopeId = 'data-v-0fd646';
    $dc1b968aa13856b6$var$script.__file = "MenuSection.vue";
};
$dc1b968aa13856b6$var$initialize();
var $dc1b968aa13856b6$export$2e2bcd8739ae039 = $dc1b968aa13856b6$var$script;

});
parcelRegister("fQDnE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b89a427b0aa9cbef$export$2e2bcd8739ae039);

var $fGXCZ = parcelRequire("fGXCZ");
var $b89a427b0aa9cbef$export$2e2bcd8739ae039 = {
    name: "MenuSection",
    components: {
        RouterLink: $fGXCZ.RouterLink
    },
    props: {
        to: {
            type: Object
        },
        title: {
            type: String,
            required: true
        },
        items: {
            type: Array
        }
    },
    methods: {
        onTouchStart (e) {
            if (e.target.classList.contains("has-nested-list")) {
                e.preventDefault();
                const nestedList = e.currentTarget.querySelector("ul");
                nestedList.classList.remove("hidden");
                document.addEventListener("click", ()=>{
                    nestedList.classList.add("hidden");
                }, {
                    once: true,
                    passive: true
                });
            }
        }
    }
};

});

parcelRegister("cPwiZ", function(module, exports) {

$parcel$export(module.exports, "render", () => $95734ea2f87f4b8f$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $95734ea2f87f4b8f$var$_hoisted_1 = [
    "href",
    "onClick"
];
const $95734ea2f87f4b8f$var$_hoisted_2 = {
    class: /*@__PURE__*/ (0, $d8ZDz.normalizeClass)([
        'seasons-list absolute top-[40px] hidden group-hover/menu-section:block z-11 translate-x-0',
        'group-[&:nth-child(2)]/menu-section:right-[-1px] left-auto'
    ])
};
const $95734ea2f87f4b8f$var$_hoisted_3 = [
    "href",
    "onClick"
];
function $95734ea2f87f4b8f$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $xo6Zx.resolveComponent)("router-link");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("li", {
        onTouchstart: _cache[0] || (_cache[0] = (...args)=>$options.onTouchStart && $options.onTouchStart(...args)),
        class: "group/menu-section inline-block relative"
    }, [
        $props.to ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_router_link, {
            key: 0,
            to: $props.to,
            custom: ""
        }, {
            default: (0, $xo6Zx.withCtx)(({ href: href, route: route, navigate: navigate, isActive: isActive, isExactActive: isExactActive })=>[
                    (0, $xo6Zx.createElementVNode)("a", {
                        href: href,
                        class: (0, $d8ZDz.normalizeClass)([
                            [
                                {
                                    'has-nested-list': $props.items?.length
                                },
                                isActive ? 'bg-blush-500 hover:bg-blush-600 text-orange-500' : 'bg-orange-500 hover:bg-orange-600 text-white',
                                'px-[16px]',
                                'group-[&:nth-child(2)]/menu-section:rounded-l-full',
                                'group-last/menu-section:rounded-r-full',
                                'transition-none',
                                'transform-none'
                            ],
                            "button block py-[12px] z-10"
                        ]),
                        onClick: navigate
                    }, (0, $d8ZDz.toDisplayString)($props.title), 11, $95734ea2f87f4b8f$var$_hoisted_1)
                ]),
            _: 1
        }, 8, [
            "to"
        ])) : ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), {
            key: 1
        }, [
            (0, $xo6Zx.createTextVNode)((0, $d8ZDz.toDisplayString)($props.title), 1)
        ], 64)),
        (0, $xo6Zx.createElementVNode)("ul", $95734ea2f87f4b8f$var$_hoisted_2, [
            ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)($props.items, (item, index)=>{
                return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("li", {
                    key: item.key
                }, [
                    (0, $xo6Zx.createVNode)(_component_router_link, {
                        to: item.to,
                        custom: ""
                    }, {
                        default: (0, $xo6Zx.withCtx)(({ href: href, navigate: navigate, isActive: isActive })=>[
                                (0, $xo6Zx.createElementVNode)("a", {
                                    href: href,
                                    onClick: navigate,
                                    class: (0, $d8ZDz.normalizeClass)([
                                        "block py-3 px-4 text-white whitespace-nowrap hover:bg-orange-600 bg-orange-500",
                                        [
                                            isActive ? 'bg-blush-500 hover:bg-blush-600' : '',
                                            index === 0 ? [
                                                'group-[&:nth-child(2)]/menu-section:rounded-tl-[20px]',
                                                'group-[&:not(:nth-child(2))]/menu-section:rounded-tr-[20px]'
                                            ] : '',
                                            index === $props.items.length - 1 ? 'rounded-bl-[20px] rounded-br-[20px]' : ''
                                        ]
                                    ])
                                }, (0, $d8ZDz.toDisplayString)(item.title), 11, $95734ea2f87f4b8f$var$_hoisted_3)
                            ]),
                        _: 2
                    }, 1032, [
                        "to"
                    ])
                ]);
            }), 128))
        ])
    ], 32);
}

});

parcelRegister("1D9f6", function(module, exports) {

$parcel$export(module.exports, "default", () => $13009a576ae61a7d$export$2e2bcd8739ae039);
let $13009a576ae61a7d$var$NOOP = ()=>{};
var $13009a576ae61a7d$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("9gEGh", function(module, exports) {

$parcel$export(module.exports, "render", () => $6bf52a171d80ec6d$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
const $6bf52a171d80ec6d$var$_hoisted_1 = {
    key: 0,
    class: "flex items-start"
};
const $6bf52a171d80ec6d$var$_hoisted_2 = {
    class: "group inline-block mr-[8px] relative"
};
function $6bf52a171d80ec6d$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $xo6Zx.resolveComponent)("router-link");
    const _component_menu_section = (0, $xo6Zx.resolveComponent)("menu-section");
    return _ctx.activeVolume ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("ul", $6bf52a171d80ec6d$var$_hoisted_1, [
        (0, $xo6Zx.createElementVNode)("li", $6bf52a171d80ec6d$var$_hoisted_2, [
            (0, $xo6Zx.createVNode)(_component_router_link, {
                to: {
                    name: 'HubWithVolume',
                    params: {
                        volumeSlug: _ctx.activeVolume.slug
                    }
                },
                class: "button--rounded-full bg-white hover:bg-hover text-orange-500 block px-[15px] py-[12px] z-10"
            }, {
                default: (0, $xo6Zx.withCtx)(()=>[
                        ..._cache[0] || (_cache[0] = [
                            (0, $xo6Zx.createTextVNode)("X", -1)
                        ])
                    ]),
                _: 1
            }, 8, [
                "to"
            ])
        ]),
        $options.calendarItems?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_menu_section, {
            key: 0,
            title: "Kalender",
            items: $options.calendarItems,
            to: {
                name: 'CalendarSheet',
                params: {
                    seasonSlug: _ctx.activeSeason.slug
                }
            }
        }, null, 8, [
            "items",
            "to"
        ])) : (0, $xo6Zx.createCommentVNode)("", true),
        $options.filmItems?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_menu_section, {
            key: 1,
            title: "Film",
            items: $options.filmItems,
            to: {
                name: 'FilmList',
                params: {
                    seasonSlug: _ctx.activeSeason.slug
                }
            }
        }, null, 8, [
            "items",
            "to"
        ])) : (0, $xo6Zx.createCommentVNode)("", true),
        _ctx.activeSchoolLevel?.archivedVideos?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_menu_section, {
            key: 2,
            title: "Filmarchief",
            to: {
                name: 'FilmArchive'
            }
        })) : (0, $xo6Zx.createCommentVNode)("", true),
        $options.musicItems?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_menu_section, {
            key: 3,
            title: "Muziek",
            items: $options.musicItems,
            to: {
                name: 'SongList',
                params: {
                    seasonSlug: _ctx.activeSeason.slug
                }
            }
        }, null, 8, [
            "items",
            "to"
        ])) : (0, $xo6Zx.createCommentVNode)("", true),
        _ctx.activeSchoolLevel?.archivedSongs?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_menu_section, {
            key: 4,
            title: "Muziekarchief",
            to: {
                name: 'MusicArchive'
            }
        })) : (0, $xo6Zx.createCommentVNode)("", true),
        $options.materialItems?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_menu_section, {
            key: 5,
            title: "Materiaal",
            items: $options.materialItems,
            to: {
                name: 'MaterialContentWithSeason',
                params: {
                    seasonSlug: _ctx.activeSeason.slug
                }
            }
        }, null, 8, [
            "items",
            "to"
        ])) : (0, $xo6Zx.createCommentVNode)("", true),
        $options.teacherItems?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)(_component_menu_section, {
            key: 6,
            title: "Leerkracht",
            items: $options.teacherItems,
            to: {
                name: 'TeacherContentWithSeason',
                params: {
                    seasonSlug: _ctx.activeSeason.slug
                }
            }
        }, null, 8, [
            "items",
            "to"
        ])) : (0, $xo6Zx.createCommentVNode)("", true)
    ])) : (0, $xo6Zx.createCommentVNode)("", true);
}

});

parcelRegister("hrmU7", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb26b996bc22e990$export$2e2bcd8739ae039);
let $cb26b996bc22e990$var$NOOP = ()=>{};
var $cb26b996bc22e990$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("7sqjz", function(module, exports) {

$parcel$export(module.exports, "default", () => $56df8f7a87f6807c$export$2e2bcd8739ae039);
let $56df8f7a87f6807c$var$script;



let $56df8f7a87f6807c$var$initialize = ()=>{
    $56df8f7a87f6807c$var$script = (parcelRequire("fG3qC"));
    if ($56df8f7a87f6807c$var$script.__esModule) $56df8f7a87f6807c$var$script = $56df8f7a87f6807c$var$script.default;
    $56df8f7a87f6807c$var$script.render = (parcelRequire("1PWnb")).render;
    (parcelRequire("gFF11")).default($56df8f7a87f6807c$var$script);
    $56df8f7a87f6807c$var$script.__scopeId = 'data-v-604b9a';
    $56df8f7a87f6807c$var$script.__file = "SchoolLevelMenu.vue";
};
$56df8f7a87f6807c$var$initialize();
var $56df8f7a87f6807c$export$2e2bcd8739ae039 = $56df8f7a87f6807c$var$script;

});
parcelRegister("fG3qC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b69d700d87121811$export$2e2bcd8739ae039);

var $aofyc = parcelRequire("aofyc");

var $fGXCZ = parcelRequire("fGXCZ");

var $14ltf = parcelRequire("14ltf");

var $7T8xC = parcelRequire("7T8xC");

var $Xc25u = parcelRequire("Xc25u");
var $b69d700d87121811$export$2e2bcd8739ae039 = {
    name: "SchoolLevelMenu",
    components: {
        RouterLink: $fGXCZ.RouterLink
    },
    computed: {
        ...(0, $aofyc.mapState)([
            "container"
        ]),
        ...(0, $aofyc.mapGetters)([
            "activeVolume",
            "activeSchoolLevel",
            "activeSeason",
            "routedDay"
        ]),
        routes () {
            return Object.fromEntries(this.container?.schoolLevels.map((schoolLevel)=>[
                    schoolLevel.slug,
                    this.route(schoolLevel)
                ]));
        }
    },
    methods: {
        route (schoolLevel) {
            // For routed schoolLevel, simply return the current route.
            if (schoolLevel.slug === this.$route.params.schoolLevelSlug) return this.$route;
            // For the other school level, it depends on the current route:
            // If the current route is a calendar route, then we need to
            // find the other school level's matching day by date (current, future or recent).
            // Otherwise - if the current route is not a calendar route,
            // then we can simply use the same route, replacing the
            // schoolLevelSlug parameter.
            if ([
                "CalendarSheet",
                "CalendarSheetVideoPlayer"
            ].includes(this.$route.name) && this.routedDay) {
                // Find the seasonContentForSchoolLevel of the other (route target) schoolLevel.
                const seasonContentForSchoolLevel = (0, $Xc25u.default)(this.activeSeason, schoolLevel);
                // In there, try to find the day matching the same date
                // or a near future or recent past date.
                const date = new Date(this.routedDay.date);
                const closestDay = (0, $7T8xC.default)(date, seasonContentForSchoolLevel, (0, $14ltf.default));
                // If we have found a (near) matching day, then make the route lead there.
                if (closestDay) return {
                    name: this.$route.name,
                    params: {
                        ...this.$route.params,
                        schoolLevelSlug: schoolLevel.slug,
                        daySlug: closestDay.slug
                    }
                };
            // We have not found a day at or around the given date.
            // At looks like the other school level might not have any days in the active season!
            // We will need to fall through to only replacing the school level slug.
            // The CalendarSheet component will find its way, using `ensureValidDay()`
            // and `autoDay()`.
            }
            // The current route is not a calendar route. We can simply use
            // the same route, replacing the schoolLevelSlug parameter.
            return {
                name: this.$route.name,
                params: {
                    ...this.$route.params,
                    schoolLevelSlug: schoolLevel.slug
                }
            };
        },
        getButtonClass (title, isActive) {
            switch(title){
                case "Onderbouw":
                    return isActive ? "bg-green text-white" : "bg-green-200 text-green hover:bg-green-500";
                case "Midden/bovenbouw":
                    return isActive ? "bg-purple text-white" : "bg-purple-200 text-purple hover:bg-purple-500";
                default:
                    return isActive ? "bg-orange text-white" : "bg-orange-600 text-white hover:bg-orange";
            }
        }
    }
};

});

parcelRegister("1PWnb", function(module, exports) {

$parcel$export(module.exports, "render", () => $1567d58480cacd47$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $1567d58480cacd47$var$_hoisted_1 = {
    key: 0,
    class: "flex items-start"
};
const $1567d58480cacd47$var$_hoisted_2 = [
    "href",
    "onClick"
];
function $1567d58480cacd47$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_link = (0, $xo6Zx.resolveComponent)("router-link");
    return !!_ctx.container?.schoolLevels?.length ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("ul", $1567d58480cacd47$var$_hoisted_1, [
        ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)(_ctx.container?.schoolLevels, (schoolLevel, index)=>{
            return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("li", {
                key: schoolLevel.slug,
                class: "inline-block relative"
            }, [
                (0, $xo6Zx.createVNode)(_component_router_link, {
                    to: $options.routes[schoolLevel.slug],
                    custom: ""
                }, {
                    default: (0, $xo6Zx.withCtx)(({ href: href, route: route, navigate: navigate, isActive: isActive, isExactActive: isExactActive })=>[
                            (0, $xo6Zx.createElementVNode)("a", {
                                href: href,
                                class: (0, $d8ZDz.normalizeClass)([
                                    [
                                        _ctx.text - _ctx.white,
                                        $options.getButtonClass(schoolLevel.title, isActive),
                                        index === 0 ? 'button--rounded-left' : '',
                                        index === _ctx.container.schoolLevels.length - 1 ? 'button--rounded-right' : ''
                                    ],
                                    "button block py-[12px] z-10"
                                ]),
                                onClick: navigate
                            }, (0, $d8ZDz.toDisplayString)(schoolLevel.title), 11, $1567d58480cacd47$var$_hoisted_2)
                        ]),
                    _: 2
                }, 1032, [
                    "to"
                ])
            ]);
        }), 128))
    ])) : (0, $xo6Zx.createCommentVNode)("", true);
}

});

parcelRegister("gFF11", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2304a7be007a982$export$2e2bcd8739ae039);
let $c2304a7be007a982$var$NOOP = ()=>{};
var $c2304a7be007a982$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRegister("iqLfq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6af4e1d77af4849$export$2e2bcd8739ae039);
let $d6af4e1d77af4849$var$script;



let $d6af4e1d77af4849$var$initialize = ()=>{
    $d6af4e1d77af4849$var$script = (parcelRequire("9uGK8"));
    if ($d6af4e1d77af4849$var$script.__esModule) $d6af4e1d77af4849$var$script = $d6af4e1d77af4849$var$script.default;
    $d6af4e1d77af4849$var$script.render = (parcelRequire("eOEOR")).render;
    (parcelRequire("lWmy4")).default($d6af4e1d77af4849$var$script);
    $d6af4e1d77af4849$var$script.__scopeId = 'data-v-d270fe';
    $d6af4e1d77af4849$var$script.__file = "DigibordContent.vue";
};
$d6af4e1d77af4849$var$initialize();
var $d6af4e1d77af4849$export$2e2bcd8739ae039 = $d6af4e1d77af4849$var$script;

});
parcelRegister("9uGK8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6e98124f14d7d4f2$export$2e2bcd8739ae039);

var $fGXCZ = parcelRequire("fGXCZ");

var $8BYZ6 = parcelRequire("8BYZ6");
var // Note `.scale-100`:
// bugfix for mobile safari where menu-subitems (expand) is cut
// halfway by the perspective image when it's directly behind it.
// Adds 'stacking context'.
$6e98124f14d7d4f2$export$2e2bcd8739ae039 = {
    name: "DigibordContent",
    components: {
        RouterView: $fGXCZ.RouterView
    },
    async beforeRouteEnter (to, from, next) {
        await (0, $8BYZ6.default)(to, next);
    },
    async beforeRouteUpdate (to, from, next) {
        await (0, $8BYZ6.default)(to, next);
    }
};

});
parcelRegister("8BYZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $645115b3ae9a828d$export$2e2bcd8739ae039);

var $14ltf = parcelRequire("14ltf");

var $8s1QA = parcelRequire("8s1QA");

var $1a39I = parcelRequire("1a39I");

var $8hAdR = parcelRequire("8hAdR");

var $e512K = parcelRequire("e512K");

var $jqHCQ = parcelRequire("jqHCQ");
// To be used when both volume and school level are auto values.
const $645115b3ae9a828d$var$redirectToAutoVolumeAndSchoolLevel = (route, next)=>{
    const volume = (0, $e512K.default)((0, $14ltf.default));
    const schoolLevel = (0, $jqHCQ.default)((0, $14ltf.default));
    if (volume && schoolLevel) {
        // There is a volume and school level available in the container.
        // We can use that to redirect to the current route.
        next({
            name: route.name,
            params: {
                ...route.params,
                volumeSlug: volume.slug,
                schoolLevelSlug: schoolLevel.slug
            },
            force: true
        });
        return;
    }
    if (volume && !schoolLevel) {
        // We have a volume but there is no school level available.
        // Redirect to the hub.
        next({
            name: "HubWithVolume",
            params: {
                volumeSlug: volume.slug
            }
        });
        return;
    }
    // We might have a school level but there is no volume available.
    // We can only go to the root route.
    // (At this point it is irrelevant if there is or isn't
    // a schoolLevel available in the container, because there is
    // no route requiring only a school level but not a volume.)
    next({
        name: "Hub"
    });
};
async function $645115b3ae9a828d$export$2e2bcd8739ae039(route, next) {
    await (0, $8s1QA.default)((0, $14ltf.default));
    const routedVolume = (0, $1a39I.default)(route, (0, $14ltf.default));
    const routedSchoolLevel = (0, $8hAdR.default)(route, (0, $14ltf.default));
    if (routedVolume && routedSchoolLevel) {
        // We have a volume and a school level - which is all we need. Stay here.
        next();
        return;
    }
    if (!routedVolume && !routedSchoolLevel) {
        // We have neither. Let's try to use auto values, or fall back to the hub.
        $645115b3ae9a828d$var$redirectToAutoVolumeAndSchoolLevel(route, next);
        return;
    }
    // We have covered cases where both slugs (volume and school level slug)
    // were valid or both were invalid. Now we need to handle situations
    // where only one of them is valid, and the other one invalid.
    // Case 1) The routed volume is valid, the routed school level is invalid.
    //         Now we might or might not be able to find a fallback school level.
    if (routedVolume && !routedSchoolLevel) {
        // First, let's see if we can have an auto school level.
        const schoolLevel = (0, $jqHCQ.default)((0, $14ltf.default));
        if (schoolLevel) {
            // We had a school level available which we can apply to the route.
            next({
                name: route.name,
                params: {
                    ...route.params,
                    volumeSlug: routedVolume.slug,
                    schoolLevelSlug: schoolLevel.slug
                },
                force: true
            });
            return;
        }
        // We have a volume but there is no school level available in the container.
        // Redirect to the hub.
        next({
            name: "HubWithVolume",
            params: {
                volumeSlug: routedVolume.slug
            }
        });
        return;
    }
    // Case 2) The routed volume is invalid, the routed school level is valid.
    //         Now we might or might not be able to find a fallback volume.
    // First, let's see if we can have an auto volume.
    const volume = (0, $e512K.default)((0, $14ltf.default));
    if (volume) {
        // We had a volume available which we can apply to the route.
        next({
            name: route.name,
            params: {
                ...route.params,
                volumeSlug: volume.slug,
                schoolLevelSlug: routedSchoolLevel.slug
            },
            force: true
        });
        return;
    }
    // We have a volume but there is no school level available in the container.
    // Redirect to the hub.
    next({
        name: "HubWithVolume",
        params: {
            volumeSlug: routedVolume.slug
        }
    });
}

});


parcelRegister("eOEOR", function(module, exports) {

$parcel$export(module.exports, "render", () => $ac9566116a3e28b4$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
const $ac9566116a3e28b4$var$_hoisted_1 = {
    id: "content",
    class: "grow p-[50px] scale-100 relative"
};
function $ac9566116a3e28b4$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_router_view = (0, $xo6Zx.resolveComponent)("router-view");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("main", $ac9566116a3e28b4$var$_hoisted_1, [
        (0, $xo6Zx.createVNode)(_component_router_view)
    ]);
}

});

parcelRegister("lWmy4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff90816f8f67d246$export$2e2bcd8739ae039);
let $ff90816f8f67d246$var$NOOP = ()=>{};
var $ff90816f8f67d246$export$2e2bcd8739ae039 = (script)=>{};

});




parcelRegister("87yQO", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e9a02d27d74e581$export$2e2bcd8739ae039);
let $5e9a02d27d74e581$var$script;




let $5e9a02d27d74e581$var$initialize = ()=>{
    $5e9a02d27d74e581$var$script = (parcelRequire("8QIJj"));
    if ($5e9a02d27d74e581$var$script.__esModule) $5e9a02d27d74e581$var$script = $5e9a02d27d74e581$var$script.default;
    $5e9a02d27d74e581$var$script.render = (parcelRequire("1lNuc")).render;
    $5e9a02d27d74e581$var$script.__cssModules = {};
    (parcelRequire("ffglF")).default($5e9a02d27d74e581$var$script);
    $5e9a02d27d74e581$var$script.__scopeId = 'data-v-a3cd8b';
    $5e9a02d27d74e581$var$script.__file = "IntroPopup.vue";
};
$5e9a02d27d74e581$var$initialize();
var $5e9a02d27d74e581$export$2e2bcd8739ae039 = $5e9a02d27d74e581$var$script;

});
parcelRegister("8QIJj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6715e0790dcc3f19$export$2e2bcd8739ae039);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $gIp2w = parcelRequire("gIp2w");

var $aofyc = parcelRequire("aofyc");

var $1UYcK = parcelRequire("1UYcK");

var $5Vvfe = parcelRequire("5Vvfe");
let $6715e0790dcc3f19$var$uuid = 0;
var $6715e0790dcc3f19$export$2e2bcd8739ae039 = {
    name: "IntroPopup",
    components: {
        Teleport: $xo6Zx.Teleport
    },
    setup () {
        $6715e0790dcc3f19$var$uuid += 1;
        // Store
        const store = (0, $aofyc.useStore)();
        const container = (0, $xo6Zx.computed)(()=>store.state.container);
        const containerLoaded = (0, $xo6Zx.computed)(()=>!!Object.keys(container.value).length);
        const introContent = (0, $xo6Zx.computed)(()=>container.value.introContent);
        // Util
        const checkboxId = `intro-popup--${$6715e0790dcc3f19$var$uuid}__meta__control--dismiss`;
        const readStorage = (key)=>JSON.parse(window.localStorage.getItem(key));
        const writeStorage = (key, value)=>window.localStorage.setItem(key, JSON.stringify(value));
        // Note: `container.value.intro*` depends on `container` having finished loading!
        // Therefore, we only call `readStorage`, using `storageKey`, after
        // having watched `container.value.introContent` change from undefined to an array.
        const storageKey = (0, $xo6Zx.computed)(()=>`intro[${container.value.introStartDate}].dismissed`);
        // State
        const introPopupClosed = (0, $gIp2w.ref)(false);
        // Handle for the localStorage dismissed state at load time.
        const introPopupPreviouslyDismissed = (0, $gIp2w.ref)(undefined);
        // Handle for the runtime dismissed state, persistable via computed setter.
        const introPopupDismissed = (0, $gIp2w.ref)(undefined);
        // "Do not show this again" checkbox model.
        // Writes to local storage on change, for persistence.
        const introPopupDismissedPersistable = (0, $xo6Zx.computed)({
            get () {
                return introPopupDismissed.value;
            },
            set (value) {
                introPopupDismissed.value = value;
                writeStorage(storageKey.value, value);
            }
        });
        (0, $xo6Zx.watchEffect)(()=>{
            // Wait for `introContent`, `introStartDate` and `introEndDate` to appear.
            // Requires store `container` to have finished loading.
            if (!containerLoaded.value) return;
            // Read previous popup dismissal from local storage.
            introPopupPreviouslyDismissed.value = readStorage(storageKey.value) || false;
            // If the popup has been dismissed and the dismissal persisted before,
            // then definitely do not show the popup now.
            introPopupDismissed.value = introPopupPreviouslyDismissed.value;
        });
        // Decide to show or not to show the popup - depending on everything defined above.
        const showIntroPopup = (0, $xo6Zx.computed)(()=>{
            // Getter dependency => Wait for `container` to load...
            if (!containerLoaded.value) return false;
            // Do not show if there is no intro content (possibly even after loading).
            if (!introContent.value.length) return false;
            // Do not show if intro period has not yet started.
            // Note `introStartDate` is *not* a required field in TCA.
            if (container.value.introStartDate && new Date(Date.now()) < new Date(container.value.introStartDate)) return false;
            // Do not show if intro period has passed.
            // (`introEndDate` is *not* a required field in TCA.)
            if (container.value.introEndDate && new Date(Date.now()) > new Date(container.value.introEndDate)) return false;
            // Do not show if user has dismissed the intro popup.
            if (introPopupPreviouslyDismissed.value) return false;
            // Do not show if the user has closed the intro popup (possibly without dismissing).
            return !introPopupClosed.value;
        });
        return {
            showIntroPopup: showIntroPopup,
            introContent: introContent,
            checkboxId: checkboxId,
            introPopupDismissedPersistable: introPopupDismissedPersistable,
            close: ()=>introPopupClosed.value = true,
            lightboxInitialize: $1UYcK.default,
            lightboxSafeDestroy: $5Vvfe.default
        };
    }
};

});
parcelRegister("5Vvfe", function(module, exports) {

$parcel$export(module.exports, "default", () => $450a83288fb47c41$export$2e2bcd8739ae039);

var $cCNWR = parcelRequire("cCNWR");
function $450a83288fb47c41$export$2e2bcd8739ae039() {
    if (!document.querySelector(".ce-gallery")) (0, $cCNWR.default)();
}

});


parcelRegister("1lNuc", function(module, exports) {

$parcel$export(module.exports, "render", () => $0fbe23831be218da$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
var $jH5uA = parcelRequire("jH5uA");
const $0fbe23831be218da$var$_hoisted_1 = {
    class: "absolute inset-0 z-20 overflow-hidden pointer-events-none"
};
const $0fbe23831be218da$var$_hoisted_2 = {
    key: 0,
    class: "intro-popup absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2 bg-orange-500 border-20 border-solid border-orange-500 rounded-2xl shadow-xl pointer-events-auto"
};
const $0fbe23831be218da$var$_hoisted_3 = {
    class: "bg-white w-full h-full flex flex-col py-8 rounded-md"
};
const $0fbe23831be218da$var$_hoisted_4 = {
    class: "flex flex-col justify-start grow p-8 pt-4 divide-y divide-orange-500 divide-solid overflow-y-auto"
};
const $0fbe23831be218da$var$_hoisted_5 = [
    "innerHTML"
];
const $0fbe23831be218da$var$_hoisted_6 = {
    class: "absolute inset-x-0 top-0 flex justify-between w-full"
};
const $0fbe23831be218da$var$_hoisted_7 = [
    "id"
];
const $0fbe23831be218da$var$_hoisted_8 = [
    "for"
];
function $0fbe23831be218da$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)((0, $xo6Zx.Teleport), {
        to: "body"
    }, [
        (0, $xo6Zx.createElementVNode)("div", $0fbe23831be218da$var$_hoisted_1, [
            (0, $xo6Zx.createVNode)((0, $jH5uA.Transition), {
                name: "intro-popup-backdrop",
                appear: ""
            }, {
                default: (0, $xo6Zx.withCtx)(()=>[
                        (0, $xo6Zx.createElementVNode)("div", {
                            class: (0, $d8ZDz.normalizeClass)([
                                "absolute inset-0 z-10 duration-300 bg-black will-change-[opacity] transition-al",
                                [
                                    $setup.showIntroPopup ? [
                                        'bg-opacity-50',
                                        'pointer-events-auto',
                                        'supports-bg-filter:bg-saturate-blur-full'
                                    ] : [
                                        'bg-opacity-0',
                                        'pointer-events-none',
                                        'supports-bg-filter:bg-saturate-blur-0'
                                    ]
                                ]
                            ]),
                            onClick: _cache[0] || (_cache[0] = (...args)=>$setup.close && $setup.close(...args))
                        }, null, 2)
                    ]),
                _: 1
            }),
            (0, $xo6Zx.createVNode)((0, $jH5uA.Transition), {
                name: "intro-popup",
                appear: "",
                onAfterEnter: _cache[3] || (_cache[3] = ()=>$setup.lightboxInitialize()),
                onAfterLeave: _cache[4] || (_cache[4] = ()=>$setup.lightboxSafeDestroy())
            }, {
                default: (0, $xo6Zx.withCtx)(()=>[
                        $setup.showIntroPopup ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $0fbe23831be218da$var$_hoisted_2, [
                            (0, $xo6Zx.createElementVNode)("div", $0fbe23831be218da$var$_hoisted_3, [
                                _cache[5] || (_cache[5] = (0, $xo6Zx.createElementVNode)("h1", {
                                    class: "px-8 pb-4 text-2xl leading-8 font-medium text-orange-500"
                                }, " Mededelingenbord ", -1)),
                                (0, $xo6Zx.createElementVNode)("div", $0fbe23831be218da$var$_hoisted_4, [
                                    ((0, $xo6Zx.openBlock)(true), (0, $xo6Zx.createElementBlock)((0, $xo6Zx.Fragment), null, (0, $xo6Zx.renderList)($setup.introContent, (contentElement, index)=>{
                                        return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", {
                                            key: contentElement,
                                            class: (0, $d8ZDz.normalizeClass)([
                                                "py-5",
                                                [
                                                    {
                                                        grow: !!contentElement.flexGrow,
                                                        'pb-0': index === $setup.introContent.length - 1,
                                                        'pt-0': index === 0
                                                    }
                                                ]
                                            ]),
                                            innerHTML: contentElement._rendered
                                        }, null, 10, $0fbe23831be218da$var$_hoisted_5);
                                    }), 128))
                                ])
                            ]),
                            (0, $xo6Zx.createElementVNode)("div", $0fbe23831be218da$var$_hoisted_6, [
                                (0, $xo6Zx.createElementVNode)("button", {
                                    class: "flex items-center justify-center w-8 h-8 -ml-4 -mt-4 bg-white text-orange-500 hover:text-orange-600 border-4 border-orange-500 rounded-full hover:border-orange-600 cursor-pointer focus:outline-none active:outline-none transition-colors duration-300",
                                    onClick: _cache[1] || (_cache[1] = (...args)=>$setup.close && $setup.close(...args))
                                }, [
                                    ..._cache[6] || (_cache[6] = [
                                        (0, $xo6Zx.createElementVNode)("svg", {
                                            width: "137",
                                            height: "136",
                                            viewBox: "0 0 137 136",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            class: "w-4 h-4 stroke-current"
                                        }, [
                                            (0, $xo6Zx.createElementVNode)("line", {
                                                x1: "22",
                                                y1: "113.924",
                                                x2: "113.924",
                                                y2: "22",
                                                stroke: "currentColor",
                                                "stroke-width": "30",
                                                "stroke-linecap": "round"
                                            }),
                                            (0, $xo6Zx.createElementVNode)("line", {
                                                x1: "23.2132",
                                                y1: "22",
                                                x2: "115.137",
                                                y2: "113.924",
                                                stroke: "currentColor",
                                                "stroke-width": "30",
                                                "stroke-linecap": "round"
                                            })
                                        ], -1)
                                    ])
                                ]),
                                (0, $xo6Zx.createElementVNode)("div", null, [
                                    (0, $xo6Zx.withDirectives)((0, $xo6Zx.createElementVNode)("input", {
                                        id: $setup.checkboxId,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.introPopupDismissedPersistable = $event),
                                        type: "checkbox",
                                        class: "sr-only checkbox-dismiss"
                                    }, null, 8, $0fbe23831be218da$var$_hoisted_7), [
                                        [
                                            (0, $jH5uA.vModelCheckbox),
                                            $setup.introPopupDismissedPersistable
                                        ]
                                    ]),
                                    (0, $xo6Zx.createElementVNode)("label", {
                                        for: $setup.checkboxId,
                                        class: "flex items-center pt-3 pr-3 text-orange-500 hover:text-orange-600 cursor-pointer select-none transition-colors duration-300"
                                    }, " Dit niet meer laten zien ", 8, $0fbe23831be218da$var$_hoisted_8)
                                ])
                            ])
                        ])) : (0, $xo6Zx.createCommentVNode)("", true)
                    ]),
                _: 1
            })
        ])
    ]);
}

});

parcelRegister("ffglF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b194f02c10f72e4a$export$2e2bcd8739ae039);
let $b194f02c10f72e4a$var$NOOP = ()=>{};
var $b194f02c10f72e4a$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("fVgfX", function(module, exports) {

$parcel$export(module.exports, "render", () => $b978ca14e53de841$export$b3890eb0ae9dca99);
parcelRequire("6r9FW");
var $xo6Zx = parcelRequire("xo6Zx");
var $d8ZDz = parcelRequire("d8ZDz");
const $b978ca14e53de841$var$_hoisted_1 = {
    key: 0,
    id: "canvas",
    class: "relative self-stretch flex bg-white bg-opacity-30 grow mt-[47px] mx-[47px]"
};
const $b978ca14e53de841$var$_hoisted_2 = {
    id: "school-level-navigation",
    class: "absolute left-[-150px] top-[160px] -rotate-90 z-10"
};
const $b978ca14e53de841$var$_hoisted_3 = {
    id: "section-navigation",
    class: "absolute left-[-20px] top-[-20px] z-10"
};
const $b978ca14e53de841$var$_hoisted_4 = {
    key: 0,
    class: "box-content flex justify-center items-center w-screen h-screen text-almostBlack font-sans antialiased"
};
const $b978ca14e53de841$var$_hoisted_5 = {
    id: "footer",
    class: "flex shrink-0 justify-center items-center text-xs"
};
const $b978ca14e53de841$var$_hoisted_6 = [
    "innerHTML"
];
function $b978ca14e53de841$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_transition_fade = (0, $xo6Zx.resolveComponent)("transition-fade");
    const _component_router_view = (0, $xo6Zx.resolveComponent)("router-view");
    const _component_intro_popup = (0, $xo6Zx.resolveComponent)("intro-popup");
    const _component_box_generic = (0, $xo6Zx.resolveComponent)("box-generic");
    return (0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", {
        id: "container",
        class: (0, $d8ZDz.normalizeClass)([
            [
                $options.schoolLevelContainerClass,
                _ctx.route.meta?.containerClass
            ],
            "items-stretch flex flex-col flex-grow h-screen min-h-screen bg-cover"
        ])
    }, [
        _ctx.containerLoaded ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $b978ca14e53de841$var$_hoisted_1, [
            (0, $xo6Zx.createElementVNode)("nav", $b978ca14e53de841$var$_hoisted_2, [
                (0, $xo6Zx.createVNode)(_component_router_view, {
                    name: "schoolLevelNavigation"
                }, {
                    default: (0, $xo6Zx.withCtx)(({ Component: Component })=>[
                            (0, $xo6Zx.createVNode)(_component_transition_fade, {
                                duration: 500,
                                appear: ""
                            }, {
                                default: (0, $xo6Zx.withCtx)(()=>[
                                        ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)((0, $xo6Zx.resolveDynamicComponent)(Component)))
                                    ]),
                                _: 2
                            }, 1024)
                        ]),
                    _: 1
                })
            ]),
            (0, $xo6Zx.createElementVNode)("nav", $b978ca14e53de841$var$_hoisted_3, [
                (0, $xo6Zx.createVNode)(_component_router_view, {
                    name: "sectionNavigation"
                })
            ]),
            (0, $xo6Zx.createVNode)(_component_router_view, {
                name: "header"
            }, {
                default: (0, $xo6Zx.withCtx)(({ Component: Component })=>[
                        Component ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)((0, $xo6Zx.resolveDynamicComponent)(Component), {
                            key: 0
                        })) : (0, $xo6Zx.createCommentVNode)("", true)
                    ]),
                _: 1
            }),
            (0, $xo6Zx.createVNode)(_component_router_view, {
                name: "content"
            }, {
                default: (0, $xo6Zx.withCtx)(({ Component: Component })=>[
                        ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createBlock)((0, $xo6Zx.resolveDynamicComponent)(Component), {
                            id: "content"
                        }))
                    ]),
                _: 1
            }),
            _cache[0] || (_cache[0] = (0, $xo6Zx.createElementVNode)("aside", {
                id: "sideways-logo",
                class: "flex flex-col h-full justify-around absolute top-0 right-[-18px] z-10"
            }, [
                (0, $xo6Zx.createElementVNode)("span", {
                    title: "#TREFWOORD",
                    class: "bg-[url('../../assets/images/common/trefwoord-logo.png')] bg-center bg-contain bg-no-repeat inline-block h-[110px] indent-[-8192px] w-[56px]"
                })
            ], -1))
        ])) : (0, $xo6Zx.createCommentVNode)("", true),
        (0, $xo6Zx.createVNode)(_component_intro_popup),
        (0, $xo6Zx.createVNode)(_component_transition_fade, {
            duration: 300,
            appear: ""
        }, {
            default: (0, $xo6Zx.withCtx)(()=>[
                    $data.loading ? ((0, $xo6Zx.openBlock)(), (0, $xo6Zx.createElementBlock)("div", $b978ca14e53de841$var$_hoisted_4, [
                        (0, $xo6Zx.createVNode)(_component_box_generic, {
                            header: "Laden..."
                        }, {
                            default: (0, $xo6Zx.withCtx)(()=>[
                                    ..._cache[1] || (_cache[1] = [
                                        (0, $xo6Zx.createTextVNode)(" Even geduld; de inhoud van het digibord wordt geladen. ", -1)
                                    ])
                                ]),
                            _: 1
                        })
                    ])) : (0, $xo6Zx.createCommentVNode)("", true)
                ]),
            _: 1
        }),
        (0, $xo6Zx.createElementVNode)("footer", $b978ca14e53de841$var$_hoisted_5, [
            (0, $xo6Zx.createElementVNode)("div", null, " Trefwoord is een uitgave van Kwintessens, \xa9" + (0, $d8ZDz.toDisplayString)(new Date().getFullYear()), 1),
            (0, $xo6Zx.createElementVNode)("ul", {
                innerHTML: $options.footerMenu
            }, null, 8, $b978ca14e53de841$var$_hoisted_6)
        ])
    ], 2);
}

});

parcelRegister("bqxl0", function(module, exports) {

$parcel$export(module.exports, "default", () => $851bfb99f6b1a807$export$2e2bcd8739ae039);
let $851bfb99f6b1a807$var$NOOP = ()=>{};
var $851bfb99f6b1a807$export$2e2bcd8739ae039 = (script)=>{};

});

var $de04277f1b7f93c5$exports = {};
$parcel$extendImportMap({
    "3JQe2": "volume-mute.07d829b7.svg",
    "1JoNs": "volume-off.31e43053.svg",
    "3RnMD": "volume-down.53766e5d.svg",
    "f94EK": "volume.a6b8dd5e.svg",
    "5pRAy": "volume-up.5baa8618.svg"
});

/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0acd7a1567fedcff$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $0b080c13a84f32b4$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $0b080c13a84f32b4$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $0b080c13a84f32b4$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $0b080c13a84f32b4$var$isGlobalObj(window) || typeof self == 'object' && $0b080c13a84f32b4$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $0b080c13a84f32b4$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $0b080c13a84f32b4$export$256479dc0cea61c4() {
    return $0b080c13a84f32b4$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $0b080c13a84f32b4$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $0b080c13a84f32b4$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}


/** Prefix for logging strings */ const $a517e3a601d07c96$var$PREFIX = 'Sentry Logger ';
const $a517e3a601d07c96$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $a517e3a601d07c96$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $a517e3a601d07c96$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($a517e3a601d07c96$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $a517e3a601d07c96$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $a517e3a601d07c96$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $0acd7a1567fedcff$export$16a28057038b10ef) $a517e3a601d07c96$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $a517e3a601d07c96$export$cda52e2a8927a2ca(()=>{
                (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).console[name](`${$a517e3a601d07c96$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $a517e3a601d07c96$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $a517e3a601d07c96$export$af88d00dbe7f521 = $a517e3a601d07c96$var$makeLogger();


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $83ab00052d3c52cd$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



const $84a662e1e79b3d35$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $84a662e1e79b3d35$export$7740643b9eeaf0c4() {
    return Date.now() / $84a662e1e79b3d35$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $84a662e1e79b3d35$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $84a662e1e79b3d35$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $84a662e1e79b3d35$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $84a662e1e79b3d35$export$ee52dced521e3e18 = $84a662e1e79b3d35$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $84a662e1e79b3d35$export$c5907b5a8838db13 = $84a662e1e79b3d35$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $84a662e1e79b3d35$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $84a662e1e79b3d35$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $84a662e1e79b3d35$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $84a662e1e79b3d35$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $84a662e1e79b3d35$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $84a662e1e79b3d35$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

// eslint-disable-next-line @typescript-eslint/unbound-method
const $b7010123686726b5$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$e6127cc7fe7395c3(wat) {
    switch($b7010123686726b5$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $b7010123686726b5$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$var$isBuiltin(wat, className) {
    return $b7010123686726b5$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$9f9636d330b71954(wat) {
    return $b7010123686726b5$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$ef9e2056653f0c8e(wat) {
    return $b7010123686726b5$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$12e869b2a583f783(wat) {
    return $b7010123686726b5$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$844ec244b1367d54(wat) {
    return $b7010123686726b5$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$c3825b437cbdea5c(wat) {
    return wat === null || $b7010123686726b5$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$53b83ca8eaab0383(wat) {
    return $b7010123686726b5$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $b7010123686726b5$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $b7010123686726b5$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$49841c62b9eff15(wat) {
    return $b7010123686726b5$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $b7010123686726b5$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$bc2894c7158efbac(wat) {
    return $b7010123686726b5$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $b7010123686726b5$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}



// eslint-disable-next-line deprecation/deprecation
const $af122b07f14d085e$var$WINDOW = (0, $0b080c13a84f32b4$export$256479dc0cea61c4)();
const $af122b07f14d085e$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $af122b07f14d085e$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $af122b07f14d085e$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $af122b07f14d085e$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $af122b07f14d085e$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($af122b07f14d085e$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $b7010123686726b5$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $af122b07f14d085e$export$1cfafeee2987818b() {
    try {
        return $af122b07f14d085e$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $af122b07f14d085e$export$c660c1f3ab49225c(selector) {
    if ($af122b07f14d085e$var$WINDOW.document && $af122b07f14d085e$var$WINDOW.document.querySelector) return $af122b07f14d085e$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $af122b07f14d085e$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$af122b07f14d085e$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $a1ee7577f9dd9008$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $a1ee7577f9dd9008$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a1ee7577f9dd9008$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $b7010123686726b5$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $a1ee7577f9dd9008$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $b7010123686726b5$export$844ec244b1367d54)(value)) return false;
    if ((0, $b7010123686726b5$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $b7010123686726b5$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $a1ee7577f9dd9008$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$a1ee7577f9dd9008$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $5fc8424b9a9220b6$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $5fc8424b9a9220b6$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $5fc8424b9a9220b6$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $0acd7a1567fedcff$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $5fc8424b9a9220b6$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $5fc8424b9a9220b6$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $5fc8424b9a9220b6$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $5fc8424b9a9220b6$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $5fc8424b9a9220b6$export$62ff257738bf57f5(value) {
    if ((0, $b7010123686726b5$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$5fc8424b9a9220b6$var$getOwnProperties(value)
    };
    else if ((0, $b7010123686726b5$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $5fc8424b9a9220b6$var$serializeEventTarget(value.target),
            currentTarget: $5fc8424b9a9220b6$var$serializeEventTarget(value.currentTarget),
            ...$5fc8424b9a9220b6$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $b7010123686726b5$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $5fc8424b9a9220b6$var$serializeEventTarget(target) {
    try {
        return (0, $b7010123686726b5$export$45a5e7f76e0caa8d)(target) ? (0, $af122b07f14d085e$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $5fc8424b9a9220b6$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $5fc8424b9a9220b6$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($5fc8424b9a9220b6$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $a1ee7577f9dd9008$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $a1ee7577f9dd9008$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $5fc8424b9a9220b6$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $5fc8424b9a9220b6$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $5fc8424b9a9220b6$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($5fc8424b9a9220b6$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $5fc8424b9a9220b6$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($5fc8424b9a9220b6$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $5fc8424b9a9220b6$var$isPojo(input) {
    if (!(0, $b7010123686726b5$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $5fc8424b9a9220b6$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $b7010123686726b5$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $16658314f19f2667$export$19f53698e68b2496() {
    const gbl = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $16658314f19f2667$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $16658314f19f2667$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $16658314f19f2667$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $16658314f19f2667$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $16658314f19f2667$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $16658314f19f2667$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $16658314f19f2667$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $16658314f19f2667$export$d364f2020ab30578(input) {
    const match = input.match($16658314f19f2667$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $16658314f19f2667$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $a1ee7577f9dd9008$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $a1ee7577f9dd9008$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $a1ee7577f9dd9008$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $16658314f19f2667$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $5fc8424b9a9220b6$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $16658314f19f2667$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


const $3256f5297a1553c0$export$849dbeeeda01ae98 = 'production';





/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $e9a504b129d49702$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($e9a504b129d49702$var$States || ($e9a504b129d49702$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $e9a504b129d49702$export$1fda8aa4d135f8aa(value) {
    return new $e9a504b129d49702$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $e9a504b129d49702$export$78e43115b553f358(reason) {
    return new $e9a504b129d49702$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $e9a504b129d49702$export$6f292d4960313241 {
    constructor(executor){
        $e9a504b129d49702$export$6f292d4960313241.prototype.__init.call(this);
        $e9a504b129d49702$export$6f292d4960313241.prototype.__init2.call(this);
        $e9a504b129d49702$export$6f292d4960313241.prototype.__init3.call(this);
        $e9a504b129d49702$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $e9a504b129d49702$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $e9a504b129d49702$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $e9a504b129d49702$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($e9a504b129d49702$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($e9a504b129d49702$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $e9a504b129d49702$var$States.PENDING) return;
            if ((0, $b7010123686726b5$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $e9a504b129d49702$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $e9a504b129d49702$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $e9a504b129d49702$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $6b434d742350092c$export$3c4238858b85e8ac() {
    return (0, $0b080c13a84f32b4$export$7e223ec222791509)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $6b434d742350092c$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $6b434d742350092c$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $6b434d742350092c$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $e9a504b129d49702$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && processor.id && result === null && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $b7010123686726b5$export$f5b060c2914b97c8)(result)) result.then((final)=>$6b434d742350092c$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $6b434d742350092c$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}



/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $e1dac6cf3290cee3$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $84a662e1e79b3d35$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $16658314f19f2667$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$e1dac6cf3290cee3$var$sessionToJSON(session)
    };
    if (context) $e1dac6cf3290cee3$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $e1dac6cf3290cee3$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $84a662e1e79b3d35$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $16658314f19f2667$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $e1dac6cf3290cee3$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $e1dac6cf3290cee3$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $e1dac6cf3290cee3$var$sessionToJSON(session) {
    return (0, $5fc8424b9a9220b6$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}











/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $2a9908bb95ba5149$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Does this filename look like it's part of the app code?
 */ function $5b5c594749d1569f$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $5b5c594749d1569f$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $5b5c594749d1569f$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}


const $78e6ecc0f4af74a8$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $78e6ecc0f4af74a8$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $78e6ecc0f4af74a8$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $78e6ecc0f4af74a8$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $78e6ecc0f4af74a8$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($78e6ecc0f4af74a8$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $78e6ecc0f4af74a8$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $78e6ecc0f4af74a8$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $78e6ecc0f4af74a8$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $78e6ecc0f4af74a8$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $78e6ecc0f4af74a8$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($78e6ecc0f4af74a8$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($78e6ecc0f4af74a8$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $78e6ecc0f4af74a8$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $78e6ecc0f4af74a8$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $78e6ecc0f4af74a8$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $78e6ecc0f4af74a8$var$defaultFunctionName;
        return fn.name || $78e6ecc0f4af74a8$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $78e6ecc0f4af74a8$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $78e6ecc0f4af74a8$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $5b5c594749d1569f$export$35059013cd4a06db)(getModule)
    ];
}


/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $707bc16f15b0ab27$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $707bc16f15b0ab27$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $707bc16f15b0ab27$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $707bc16f15b0ab27$export$a3295358bff77e(object, depth);
    if ($707bc16f15b0ab27$var$jsonSize(normalized) > maxSize) return $707bc16f15b0ab27$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $707bc16f15b0ab27$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $2a9908bb95ba5149$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $b7010123686726b5$export$c9f5652083b8129d)(value)) return value;
    const stringified = $707bc16f15b0ab27$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $707bc16f15b0ab27$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $5fc8424b9a9220b6$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $707bc16f15b0ab27$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $707bc16f15b0ab27$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $b7010123686726b5$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $b7010123686726b5$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $78e6ecc0f4af74a8$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $707bc16f15b0ab27$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $707bc16f15b0ab27$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $707bc16f15b0ab27$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $707bc16f15b0ab27$var$jsonSize(value) {
    return $707bc16f15b0ab27$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $707bc16f15b0ab27$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}









const $02dcec072b7c9f17$export$9ca9946bd449ac06 = 'baggage';
const $02dcec072b7c9f17$export$6e69537d67fa20f = 'sentry-';
const $02dcec072b7c9f17$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $02dcec072b7c9f17$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $02dcec072b7c9f17$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $b7010123686726b5$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $02dcec072b7c9f17$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $02dcec072b7c9f17$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($02dcec072b7c9f17$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($02dcec072b7c9f17$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $02dcec072b7c9f17$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$02dcec072b7c9f17$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $02dcec072b7c9f17$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $02dcec072b7c9f17$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $02dcec072b7c9f17$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $02dcec072b7c9f17$export$bdd844ddb2def819) {
            (0, $0acd7a1567fedcff$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $0f9ea59ec48a1e09$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $0f9ea59ec48a1e09$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($0f9ea59ec48a1e09$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $0f9ea59ec48a1e09$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $0f9ea59ec48a1e09$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $02dcec072b7c9f17$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $16658314f19f2667$export$19f53698e68b2496)(),
            spanId: (0, $16658314f19f2667$export$19f53698e68b2496)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $16658314f19f2667$export$19f53698e68b2496)(),
            parentSpanId: parentSpanId || (0, $16658314f19f2667$export$19f53698e68b2496)().substring(16),
            spanId: (0, $16658314f19f2667$export$19f53698e68b2496)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $0f9ea59ec48a1e09$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $0f9ea59ec48a1e09$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $02dcec072b7c9f17$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $16658314f19f2667$export$19f53698e68b2496)(),
        spanId: (0, $16658314f19f2667$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $16658314f19f2667$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $16658314f19f2667$export$19f53698e68b2496)().substring(16),
        spanId: (0, $16658314f19f2667$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $0f9ea59ec48a1e09$export$f35d907436da45cf(traceId = (0, $16658314f19f2667$export$19f53698e68b2496)(), spanId = (0, $16658314f19f2667$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}


// These are aligned with OpenTelemetry trace flags
const $aab2fced71923915$export$208d5b368507fb8b = 0x0;
const $aab2fced71923915$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $aab2fced71923915$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $aab2fced71923915$export$92d8c23565496537(span);
    return (0, $5fc8424b9a9220b6$export$d25f2688db1bb433)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $aab2fced71923915$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $aab2fced71923915$export$5caecac1caaf3a71(span);
    return (0, $0f9ea59ec48a1e09$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $aab2fced71923915$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $aab2fced71923915$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $aab2fced71923915$var$ensureTimestampInSeconds(input.getTime());
    return (0, $84a662e1e79b3d35$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $aab2fced71923915$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $aab2fced71923915$export$92d8c23565496537(span) {
    if ($aab2fced71923915$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $aab2fced71923915$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $aab2fced71923915$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $aab2fced71923915$export$eb571cd9b5d98de8);
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $82acf6f7315dcebb$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $16658314f19f2667$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $84a662e1e79b3d35$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $82acf6f7315dcebb$var$applyClientOptions(prepared, options);
    $82acf6f7315dcebb$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $82acf6f7315dcebb$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $82acf6f7315dcebb$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $16658314f19f2667$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $90e47a3284c74595$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $afb531194beed6b2$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $afb531194beed6b2$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $afb531194beed6b2$export$43988bc651a80216)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $6b434d742350092c$export$3c4238858b85e8ac)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $6b434d742350092c$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $82acf6f7315dcebb$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $82acf6f7315dcebb$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $82acf6f7315dcebb$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $3256f5297a1553c0$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $a1ee7577f9dd9008$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $a1ee7577f9dd9008$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $a1ee7577f9dd9008$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $82acf6f7315dcebb$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $82acf6f7315dcebb$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $82acf6f7315dcebb$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $82acf6f7315dcebb$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $82acf6f7315dcebb$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $82acf6f7315dcebb$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $82acf6f7315dcebb$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $707bc16f15b0ab27$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $707bc16f15b0ab27$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $707bc16f15b0ab27$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $707bc16f15b0ab27$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $707bc16f15b0ab27$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $aab2fced71923915$export$92d8c23565496537)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $707bc16f15b0ab27$export$a3295358bff77e)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $82acf6f7315dcebb$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $90e47a3284c74595$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $82acf6f7315dcebb$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($82acf6f7315dcebb$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($82acf6f7315dcebb$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $82acf6f7315dcebb$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $90e47a3284c74595$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $82acf6f7315dcebb$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $82acf6f7315dcebb$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$82acf6f7315dcebb$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $a083afa4ea001828$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().captureException(exception, (0, $82acf6f7315dcebb$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $a083afa4ea001828$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $a083afa4ea001828$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $a083afa4ea001828$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $a083afa4ea001828$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $a083afa4ea001828$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $a083afa4ea001828$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $a083afa4ea001828$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $a083afa4ea001828$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $a083afa4ea001828$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $a083afa4ea001828$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $a083afa4ea001828$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $a083afa4ea001828$export$9a4fed82c350c2bd(callback) {
    return (0, $4f329577679e8bfc$export$70d775fb1f267027)(()=>{
        return callback((0, $4f329577679e8bfc$export$68f3af03034c9e90)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $a083afa4ea001828$export$e57ac09b143d92a2(span, callback) {
    return $a083afa4ea001828$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $a083afa4ea001828$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $a083afa4ea001828$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $a083afa4ea001828$export$c7be4b0125a10cba();
    const client = $a083afa4ea001828$export$6bb76d6eba7e258c();
    if (!client) (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $16658314f19f2667$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $a083afa4ea001828$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $a083afa4ea001828$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $84a662e1e79b3d35$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $a083afa4ea001828$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $84a662e1e79b3d35$export$ee52dced521e3e18)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $b7010123686726b5$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $a083afa4ea001828$export$4909b86c8034bf73(timeout) {
    const client = $a083afa4ea001828$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $a083afa4ea001828$export$8360e631d277ea4d(timeout) {
    const client = $a083afa4ea001828$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $a083afa4ea001828$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $a083afa4ea001828$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $a083afa4ea001828$export$3f95c6f800b78024() {
    return !!$a083afa4ea001828$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $a083afa4ea001828$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $a083afa4ea001828$export$c0d84948cecf78d8(context) {
    const client = $a083afa4ea001828$export$6bb76d6eba7e258c();
    const isolationScope = (0, $4f329577679e8bfc$export$68f3af03034c9e90)();
    const currentScope = $a083afa4ea001828$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $3256f5297a1553c0$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $e1dac6cf3290cee3$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $e1dac6cf3290cee3$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $a083afa4ea001828$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $a083afa4ea001828$export$17a5be43989a0bc1() {
    const isolationScope = (0, $4f329577679e8bfc$export$68f3af03034c9e90)();
    const currentScope = $a083afa4ea001828$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $e1dac6cf3290cee3$export$56521d9ba90f62ee)(session);
    $a083afa4ea001828$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $a083afa4ea001828$var$_sendSessionUpdate() {
    const isolationScope = (0, $4f329577679e8bfc$export$68f3af03034c9e90)();
    const currentScope = $a083afa4ea001828$export$c7be4b0125a10cba();
    const client = $a083afa4ea001828$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $a083afa4ea001828$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $a083afa4ea001828$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $a083afa4ea001828$var$_sendSessionUpdate();
}


/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $e86f942389625a1d$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}



/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $3148374da480247a$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $5fc8424b9a9220b6$export$d25f2688db1bb433)({
        environment: options.environment || (0, $3256f5297a1553c0$export$849dbeeeda01ae98),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $3148374da480247a$export$a117f995597e25df(span) {
    const client = (0, $a083afa4ea001828$export$6bb76d6eba7e258c)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $3148374da480247a$export$366bad00d6815eed((0, $aab2fced71923915$export$92d8c23565496537)(span).trace_id || '', client, (0, $a083afa4ea001828$export$c7be4b0125a10cba)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $e86f942389625a1d$export$c4c6a79b1260ca1b)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $aab2fced71923915$export$92d8c23565496537)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $aab2fced71923915$export$5caecac1caaf3a71)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $afb531194beed6b2$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $afb531194beed6b2$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $afb531194beed6b2$var$applySpanToEvent(event, span);
    $afb531194beed6b2$var$applyFingerprintToEvent(event, fingerprint);
    $afb531194beed6b2$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $afb531194beed6b2$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $afb531194beed6b2$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $afb531194beed6b2$export$b1a120a2871faa46(data, 'extra', extra);
    $afb531194beed6b2$export$b1a120a2871faa46(data, 'tags', tags);
    $afb531194beed6b2$export$b1a120a2871faa46(data, 'user', user);
    $afb531194beed6b2$export$b1a120a2871faa46(data, 'contexts', contexts);
    $afb531194beed6b2$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $afb531194beed6b2$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $afb531194beed6b2$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $5fc8424b9a9220b6$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $5fc8424b9a9220b6$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $5fc8424b9a9220b6$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $5fc8424b9a9220b6$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $afb531194beed6b2$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $afb531194beed6b2$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $afb531194beed6b2$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $aab2fced71923915$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    const rootSpan = (0, $e86f942389625a1d$export$c4c6a79b1260ca1b)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $3148374da480247a$export$a117f995597e25df)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $aab2fced71923915$export$92d8c23565496537)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $afb531194beed6b2$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $16658314f19f2667$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $90e47a3284c74595$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $90e47a3284c74595$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $90e47a3284c74595$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $90e47a3284c74595$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $90e47a3284c74595$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $90e47a3284c74595$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $e1dac6cf3290cee3$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $90e47a3284c74595$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $b7010123686726b5$export$53b83ca8eaab0383)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $90e47a3284c74595$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $90e47a3284c74595$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $84a662e1e79b3d35$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $afb531194beed6b2$export$43988bc651a80216)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $6b434d742350092c$export$3c4238858b85e8ac)(),
            ...this._eventProcessors
        ];
        return (0, $6b434d742350092c$export$bf2a096c3e883e79)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $16658314f19f2667$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $16658314f19f2667$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $16658314f19f2667$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $90e47a3284c74595$export$aa55d5ab8e05984f() {
    if (!$90e47a3284c74595$var$globalScope) $90e47a3284c74595$var$globalScope = new $90e47a3284c74595$export$775b6bb06e53a214();
    return $90e47a3284c74595$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $90e47a3284c74595$export$c83048efd17527d6(scope) {
    $90e47a3284c74595$var$globalScope = scope;
}
function $90e47a3284c74595$var$generatePropagationContext() {
    return {
        traceId: (0, $16658314f19f2667$export$19f53698e68b2496)(),
        spanId: (0, $16658314f19f2667$export$19f53698e68b2496)().substring(16)
    };
}



const $142b56b04b94e12c$export$31499a9cd224b78c = '7.120.4';


/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $4f329577679e8bfc$export$24a86ef7798177e4 = parseFloat((0, $142b56b04b94e12c$export$31499a9cd224b78c));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $4f329577679e8bfc$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $4f329577679e8bfc$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $4f329577679e8bfc$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $90e47a3284c74595$export$775b6bb06e53a214)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $90e47a3284c74595$export$775b6bb06e53a214)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $b7010123686726b5$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $16658314f19f2667$export$19f53698e68b2496)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $16658314f19f2667$export$19f53698e68b2496)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $16658314f19f2667$export$19f53698e68b2496)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $4f329577679e8bfc$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $84a662e1e79b3d35$export$7740643b9eeaf0c4)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $a517e3a601d07c96$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $4f329577679e8bfc$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $4f329577679e8bfc$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $83ab00052d3c52cd$export$16a28057038b10ef) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $e1dac6cf3290cee3$export$56521d9ba90f62ee)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $3256f5297a1553c0$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).navigator || {};
        const session = (0, $e1dac6cf3290cee3$export$14a186326edbb264)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $e1dac6cf3290cee3$export$531818e825e774db)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $4f329577679e8bfc$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $4f329577679e8bfc$export$19eade501500c6c1() {
    (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).__SENTRY__ = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $4f329577679e8bfc$export$4188a14ad302d1bc(hub) {
    const registry = $4f329577679e8bfc$export$19eade501500c6c1();
    const oldHub = $4f329577679e8bfc$export$bfa8a924a84a76b7(registry);
    $4f329577679e8bfc$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $4f329577679e8bfc$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $4f329577679e8bfc$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $4f329577679e8bfc$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $4f329577679e8bfc$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $4f329577679e8bfc$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $4f329577679e8bfc$var$getGlobalHub(registry = $4f329577679e8bfc$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$4f329577679e8bfc$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $4f329577679e8bfc$export$bfa8a924a84a76b7(registry).isOlderThan($4f329577679e8bfc$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $4f329577679e8bfc$export$849f05434e95d2f2(registry, new $4f329577679e8bfc$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $4f329577679e8bfc$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $4f329577679e8bfc$export$236689a79f5aa020(carrier, parent = $4f329577679e8bfc$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$4f329577679e8bfc$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $4f329577679e8bfc$export$bfa8a924a84a76b7(carrier).isOlderThan($4f329577679e8bfc$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $4f329577679e8bfc$export$849f05434e95d2f2(carrier, new $4f329577679e8bfc$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $4f329577679e8bfc$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $4f329577679e8bfc$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $4f329577679e8bfc$export$70d775fb1f267027(callback, options = {}) {
    const registry = $4f329577679e8bfc$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $4f329577679e8bfc$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $4f329577679e8bfc$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $0b080c13a84f32b4$export$7e223ec222791509)('hub', ()=>new $4f329577679e8bfc$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $4f329577679e8bfc$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}







// We keep the handlers globally
const $e741ef5864ec0e99$var$handlers = {};
const $e741ef5864ec0e99$var$instrumented = {};
/** Add a handler function. */ function $e741ef5864ec0e99$export$a4e09611e30da72e(type, handler) {
    $e741ef5864ec0e99$var$handlers[type] = $e741ef5864ec0e99$var$handlers[type] || [];
    $e741ef5864ec0e99$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $e741ef5864ec0e99$export$b17eab759a1cb5fe() {
    Object.keys($e741ef5864ec0e99$var$handlers).forEach((key)=>{
        $e741ef5864ec0e99$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $e741ef5864ec0e99$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$e741ef5864ec0e99$var$instrumented[type]) {
        instrumentFn();
        $e741ef5864ec0e99$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $e741ef5864ec0e99$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $e741ef5864ec0e99$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $0acd7a1567fedcff$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $78e6ecc0f4af74a8$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


let $b7c8efd259d71395$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $b7c8efd259d71395$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $e741ef5864ec0e99$export$a4e09611e30da72e)(type, handler);
    (0, $e741ef5864ec0e99$export$e18d6c5462c01368)(type, $b7c8efd259d71395$var$instrumentError);
}
function $b7c8efd259d71395$var$instrumentError() {
    $b7c8efd259d71395$var$_oldOnErrorHandler = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).onerror;
    (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $e741ef5864ec0e99$export$b18c893e424d3127)('error', handlerData);
        if ($b7c8efd259d71395$var$_oldOnErrorHandler && !$b7c8efd259d71395$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $b7c8efd259d71395$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $e3143df0f0a958d2$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $e3143df0f0a958d2$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $e741ef5864ec0e99$export$a4e09611e30da72e)(type, handler);
    (0, $e741ef5864ec0e99$export$e18d6c5462c01368)(type, $e3143df0f0a958d2$var$instrumentUnhandledRejection);
}
function $e3143df0f0a958d2$var$instrumentUnhandledRejection() {
    $e3143df0f0a958d2$var$_oldOnUnhandledRejectionHandler = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $e741ef5864ec0e99$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($e3143df0f0a958d2$var$_oldOnUnhandledRejectionHandler && !$e3143df0f0a958d2$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $e3143df0f0a958d2$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $1893830b8c7873e3$export$a7feb32fdd923295(maybeHub) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = maybeHub || (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const scope = hub.getScope();
    // eslint-disable-next-line deprecation/deprecation
    return scope.getTransaction();
}
/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */ const $1893830b8c7873e3$export$8e9a29865c0a1226 = (0, $0f9ea59ec48a1e09$export$8e9a29865c0a1226);


let $592835fd32cb1e30$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $592835fd32cb1e30$export$637857c1d87b640c() {
    if ($592835fd32cb1e30$var$errorsInstrumented) return;
    $592835fd32cb1e30$var$errorsInstrumented = true;
    (0, $b7c8efd259d71395$export$55b5c3ba2194f0c6)($592835fd32cb1e30$var$errorCallback);
    (0, $e3143df0f0a958d2$export$8bf4fc6858821a4e)($592835fd32cb1e30$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $592835fd32cb1e30$var$errorCallback() {
    // eslint-disable-next-line deprecation/deprecation
    const activeTransaction = (0, $1893830b8c7873e3$export$a7feb32fdd923295)();
    if (activeTransaction) {
        const status = 'internal_error';
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$592835fd32cb1e30$var$errorCallback.tag = 'sentry_tracingErrorCallback';




















/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $4210c1168599ca6b$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $4210c1168599ca6b$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $4210c1168599ca6b$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $b7010123686726b5$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $94ef1ac47039d105$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $a083afa4ea001828$export$6bb76d6eba7e258c)();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */ function $289d2b5ef1bc182e$export$357889f174732d38(context, callback, // eslint-disable-next-line @typescript-eslint/no-empty-function
onError = ()=>{}, // eslint-disable-next-line @typescript-eslint/no-empty-function
afterFinish = ()=>{}) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)();
    const scope = (0, $a083afa4ea001828$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const parentSpan = scope.getSpan();
    const spanContext = $289d2b5ef1bc182e$var$normalizeContext(context);
    const activeSpan = $289d2b5ef1bc182e$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: false,
        scope: scope
    });
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(activeSpan);
    return (0, $4210c1168599ca6b$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), (error)=>{
        activeSpan && activeSpan.setStatus('internal_error');
        onError(error, activeSpan);
    }, ()=>{
        activeSpan && activeSpan.end();
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(parentSpan);
        afterFinish();
    });
}
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $289d2b5ef1bc182e$export$a1bd95187356f372(context, callback) {
    const spanContext = $289d2b5ef1bc182e$var$normalizeContext(context);
    return (0, $4f329577679e8bfc$export$70d775fb1f267027)(()=>{
        return (0, $a083afa4ea001828$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $289d2b5ef1bc182e$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            return (0, $4210c1168599ca6b$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet
                if (activeSpan) {
                    const { status: status } = (0, $aab2fced71923915$export$92d8c23565496537)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            }, ()=>activeSpan && activeSpan.end());
        });
    });
}
/**
 * @deprecated Use {@link startSpan} instead.
 */ const $289d2b5ef1bc182e$export$cb9e396e6b90b703 = $289d2b5ef1bc182e$export$a1bd95187356f372;
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $289d2b5ef1bc182e$export$c10292ad04b92aea(context, callback) {
    const spanContext = $289d2b5ef1bc182e$var$normalizeContext(context);
    return (0, $4f329577679e8bfc$export$70d775fb1f267027)(()=>{
        return (0, $a083afa4ea001828$export$ec58d9285c204497)(context.scope, (scope)=>{
            // eslint-disable-next-line deprecation/deprecation
            const hub = (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)();
            // eslint-disable-next-line deprecation/deprecation
            const parentSpan = scope.getSpan();
            const shouldSkipSpan = context.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? undefined : $289d2b5ef1bc182e$var$createChildSpanOrTransaction(hub, {
                parentSpan: parentSpan,
                spanContext: spanContext,
                forceTransaction: context.forceTransaction,
                scope: scope
            });
            function finishAndSetSpan() {
                activeSpan && activeSpan.end();
            }
            return (0, $4210c1168599ca6b$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                if (activeSpan && activeSpan.isRecording()) {
                    const { status: status } = (0, $aab2fced71923915$export$92d8c23565496537)(activeSpan);
                    if (!status || status === 'ok') activeSpan.setStatus('internal_error');
                }
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */ function $289d2b5ef1bc182e$export$63dbba021a6b4047(context) {
    if (!(0, $94ef1ac47039d105$export$5008da00b1b6dee6)()) return undefined;
    const spanContext = $289d2b5ef1bc182e$var$normalizeContext(context);
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)();
    const parentSpan = context.scope ? context.scope.getSpan() : $289d2b5ef1bc182e$export$1be426a8e585c83e();
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return undefined;
    const scope = context.scope || (0, $a083afa4ea001828$export$c7be4b0125a10cba)();
    // Even though we don't actually want to make this span active on the current scope,
    // we need to make it active on a temporary scope that we use for event processing
    // as otherwise, it won't pick the correct span for the event when processing it
    const temporaryScope = scope.clone();
    return $289d2b5ef1bc182e$var$createChildSpanOrTransaction(hub, {
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: temporaryScope
    });
}
/**
 * Returns the currently active span.
 */ function $289d2b5ef1bc182e$export$1be426a8e585c83e() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $a083afa4ea001828$export$c7be4b0125a10cba)().getSpan();
}
const $289d2b5ef1bc182e$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
    /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */ const currentScope = (0, $a083afa4ea001828$export$c7be4b0125a10cba)();
    // eslint-disable-next-line deprecation/deprecation
    const { traceparentData: traceparentData, dynamicSamplingContext: dynamicSamplingContext, propagationContext: propagationContext } = (0, $0f9ea59ec48a1e09$export$ca5c066532785b6e)(sentryTrace, baggage);
    currentScope.setPropagationContext(propagationContext);
    if ((0, $83ab00052d3c52cd$export$16a28057038b10ef) && traceparentData) (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
    const transactionContext = {
        ...traceparentData,
        metadata: (0, $5fc8424b9a9220b6$export$d25f2688db1bb433)({
            dynamicSamplingContext: dynamicSamplingContext
        })
    };
    if (!callback) return transactionContext;
    return (0, $4f329577679e8bfc$export$70d775fb1f267027)(()=>{
        return callback(transactionContext);
    });
};
function $289d2b5ef1bc182e$var$createChildSpanOrTransaction(// eslint-disable-next-line deprecation/deprecation
hub, { parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $94ef1ac47039d105$export$5008da00b1b6dee6)()) return undefined;
    const isolationScope = (0, $4f329577679e8bfc$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
    else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $3148374da480247a$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const sampled = (0, $aab2fced71923915$export$5caecac1caaf3a71)(parentSpan);
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        // eslint-disable-next-line deprecation/deprecation
        span = hub.startTransaction({
            traceId: traceId,
            parentSpanId: parentSpanId,
            parentSampled: sampled,
            ...spanContext,
            metadata: {
                dynamicSamplingContext: dsc,
                // eslint-disable-next-line deprecation/deprecation
                ...spanContext.metadata
            }
        });
    }
    // We always set this as active span on the scope
    // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
    // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    $289d2b5ef1bc182e$var$setCapturedScopesOnSpan(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $289d2b5ef1bc182e$var$normalizeContext(context) {
    if (context.startTime) {
        const ctx = {
            ...context
        };
        ctx.startTimestamp = (0, $aab2fced71923915$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return context;
}
const $289d2b5ef1bc182e$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $289d2b5ef1bc182e$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
function $289d2b5ef1bc182e$var$setCapturedScopesOnSpan(span, scope, isolationScope) {
    if (span) {
        (0, $5fc8424b9a9220b6$export$e73679ffaf56810e)(span, $289d2b5ef1bc182e$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $5fc8424b9a9220b6$export$e73679ffaf56810e)(span, $289d2b5ef1bc182e$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $289d2b5ef1bc182e$export$c08fbc656a245d03(span) {
    return {
        scope: span[$289d2b5ef1bc182e$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$289d2b5ef1bc182e$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $57adfc88e21e21bd$var$SPAN_METRIC_SUMMARY;
function $57adfc88e21e21bd$var$getMetricStorageForSpan(span) {
    return $57adfc88e21e21bd$var$SPAN_METRIC_SUMMARY ? $57adfc88e21e21bd$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $57adfc88e21e21bd$export$2e7205e45c58797d(span) {
    const storage = $57adfc88e21e21bd$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $5fc8424b9a9220b6$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on the currently active span
 */ function $57adfc88e21e21bd$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = (0, $289d2b5ef1bc182e$export$1be426a8e585c83e)();
    if (span) {
        const storage = $57adfc88e21e21bd$var$getMetricStorageForSpan(span) || new Map();
        const exportKey = `${metricType}:${sanitizedName}@${unit}`;
        const bucketItem = storage.get(bucketKey);
        if (bucketItem) {
            const [, summary] = bucketItem;
            storage.set(bucketKey, [
                exportKey,
                {
                    min: Math.min(summary.min, value),
                    max: Math.max(summary.max, value),
                    count: summary.count += 1,
                    sum: summary.sum += value,
                    tags: summary.tags
                }
            ]);
        } else storage.set(bucketKey, [
            exportKey,
            {
                min: value,
                max: value,
                count: 1,
                sum: value,
                tags: tags
            }
        ]);
        if (!$57adfc88e21e21bd$var$SPAN_METRIC_SUMMARY) $57adfc88e21e21bd$var$SPAN_METRIC_SUMMARY = new WeakMap();
        $57adfc88e21e21bd$var$SPAN_METRIC_SUMMARY.set(span, storage);
    }
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $f0df0dfa824ba468$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $f0df0dfa824ba468$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $f0df0dfa824ba468$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $f0df0dfa824ba468$export$cca8dd30f57f805e = 'sentry.origin';
/**
 * The id of the profile that this span occured in.
 */ const $f0df0dfa824ba468$export$1efec95406bbe327 = 'profile_id';




/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ var $4d92e4d4d522a7e1$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = 'ok';
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = 'deadline_exceeded';
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = 'unauthenticated';
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = 'permission_denied';
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = 'not_found';
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = 'resource_exhausted';
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = 'invalid_argument';
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = 'unimplemented';
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = 'unavailable';
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = 'internal_error';
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = 'unknown_error';
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = 'cancelled';
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = 'already_exists';
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = 'failed_precondition';
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = 'aborted';
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = 'out_of_range';
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = 'data_loss';
    SpanStatus["DataLoss"] = DataLoss;
})($4d92e4d4d522a7e1$export$beb8e6a823e89c5d || ($4d92e4d4d522a7e1$export$beb8e6a823e89c5d = {}));
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $4d92e4d4d522a7e1$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ const $4d92e4d4d522a7e1$export$ac65c70d78fcdb55 = $4d92e4d4d522a7e1$export$5fd4dc48a2131589;
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $4d92e4d4d522a7e1$export$2ad6630ec8164254(span, httpStatus) {
    // TODO (v8): Remove these calls
    // Relay does not require us to send the status code as a tag
    // For now, just because users might expect it to land as a tag we keep sending it.
    // Same with data.
    // In v8, we replace both, simply with
    // span.setAttribute('http.response.status_code', httpStatus);
    // eslint-disable-next-line deprecation/deprecation
    span.setTag('http.status_code', String(httpStatus));
    // eslint-disable-next-line deprecation/deprecation
    span.setData('http.response.status_code', httpStatus);
    const spanStatus = $4d92e4d4d522a7e1$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus !== 'unknown_error') span.setStatus(spanStatus);
}


/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $c70c081f9639c63d$export$10c95c129cd0d4fe {
    constructor(maxlen = 1000){
        this._maxlen = maxlen;
        this.spans = [];
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) // eslint-disable-next-line deprecation/deprecation
        span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $c70c081f9639c63d$export$5f1714a13ed34c01 {
    /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */ /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */ /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */ /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $16658314f19f2667$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $16658314f19f2667$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $84a662e1e79b3d35$export$ee52dced521e3e18)();
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags ? {
            ...spanContext.tags
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data ? {
            ...spanContext.data
        } : {};
        // eslint-disable-next-line deprecation/deprecation
        this.instrumenter = spanContext.instrumenter || 'sentry';
        this._attributes = {};
        this.setAttributes({
            [(0, $f0df0dfa824ba468$export$cca8dd30f57f805e)]: spanContext.origin || 'manual',
            [(0, $f0df0dfa824ba468$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.status) this._status = spanContext.status;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        if (spanContext.exclusiveTime !== undefined) this._exclusiveTime = spanContext.exclusiveTime;
        this._measurements = spanContext.measurements ? {
            ...spanContext.measurements
        } : {};
    }
    // This rule conflicts with another eslint rule :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name || '';
    }
    /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set name(name) {
        this.updateName(name);
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get description() {
        return this._name;
    }
    /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ set description(description) {
        this._name = description;
    }
    /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */ get traceId() {
        return this._traceId;
    }
    /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */ set traceId(traceId) {
        this._traceId = traceId;
    }
    /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */ get spanId() {
        return this._spanId;
    }
    /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */ set spanId(spanId) {
        this._spanId = spanId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */ set parentSpanId(string) {
        this._parentSpanId = string;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */ get parentSpanId() {
        return this._parentSpanId;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */ get sampled() {
        return this._sampled;
    }
    /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */ set sampled(sampled) {
        this._sampled = sampled;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */ get attributes() {
        return this._attributes;
    }
    /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */ set attributes(attributes) {
        this._attributes = attributes;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */ get startTimestamp() {
        return this._startTime;
    }
    /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */ set startTimestamp(startTime) {
        this._startTime = startTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */ get endTimestamp() {
        return this._endTime;
    }
    /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */ set endTimestamp(endTime) {
        this._endTime = endTime;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */ get status() {
        return this._status;
    }
    /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */ set status(status) {
        this._status = status;
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */ get op() {
        return this._attributes[0, $f0df0dfa824ba468$export$1a413bd9a88fdb09];
    }
    /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */ set op(op) {
        this.setAttribute((0, $f0df0dfa824ba468$export$1a413bd9a88fdb09), op);
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */ get origin() {
        return this._attributes[0, $f0df0dfa824ba468$export$cca8dd30f57f805e];
    }
    /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */ set origin(origin) {
        this.setAttribute((0, $f0df0dfa824ba468$export$cca8dd30f57f805e), origin);
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $aab2fced71923915$export$eb571cd9b5d98de8) : (0, $aab2fced71923915$export$208d5b368507fb8b)
        };
    }
    /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startChild(spanContext) {
        const childSpan = new $c70c081f9639c63d$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this._spanId,
            sampled: this._sampled,
            traceId: this._traceId
        });
        // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder = this.spanRecorder;
        // eslint-disable-next-line deprecation/deprecation
        if (childSpan.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        childSpan.spanRecorder.add(childSpan);
        const rootSpan = (0, $e86f942389625a1d$export$c4c6a79b1260ca1b)(this);
        // TODO: still set span.transaction here until we have a more permanent solution
        // Probably similarly to the weakmap we hold in node-experimental
        // eslint-disable-next-line deprecation/deprecation
        childSpan.transaction = rootSpan;
        if ((0, $83ab00052d3c52cd$export$16a28057038b10ef) && rootSpan) {
            const opStr = spanContext && spanContext.op || '< unknown op >';
            const nameStr = (0, $aab2fced71923915$export$92d8c23565496537)(childSpan).description || '< unknown name >';
            const idStr = rootSpan.spanContext().spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(logMessage);
            this._logMessage = logMessage;
        }
        return childSpan;
    }
    /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */ setTag(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setData(key, value) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */ setHttpStatus(httpStatus) {
        (0, $4d92e4d4d522a7e1$export$2ad6630ec8164254)(this, httpStatus);
        return this;
    }
    /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */ setName(name) {
        this.updateName(name);
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */ isSuccess() {
        return this._status === 'ok';
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */ finish(endTimestamp) {
        return this.end(endTimestamp);
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        const rootSpan = (0, $e86f942389625a1d$export$c4c6a79b1260ca1b)(this);
        if ((0, $83ab00052d3c52cd$export$16a28057038b10ef) && // Don't call this for transactions
        rootSpan && rootSpan.spanContext().spanId !== this._spanId) {
            const logMessage = this._logMessage;
            if (logMessage) (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(logMessage.replace('Starting', 'Finishing'));
        }
        this._endTime = (0, $aab2fced71923915$export$3f7581298f56c6d7)(endTimestamp);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */ toTraceparent() {
        return (0, $aab2fced71923915$export$7e9f8ae9e4a328ab)(this);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */ toContext() {
        return (0, $5fc8424b9a9220b6$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            endTimestamp: this._endTime,
            // eslint-disable-next-line deprecation/deprecation
            op: this.op,
            parentSpanId: this._parentSpanId,
            sampled: this._sampled,
            spanId: this._spanId,
            startTimestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            traceId: this._traceId
        });
    }
    /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */ updateWithContext(spanContext) {
        // eslint-disable-next-line deprecation/deprecation
        this.data = spanContext.data || {};
        // eslint-disable-next-line deprecation/deprecation
        this._name = spanContext.name || spanContext.description;
        this._endTime = spanContext.endTimestamp;
        // eslint-disable-next-line deprecation/deprecation
        this.op = spanContext.op;
        this._parentSpanId = spanContext.parentSpanId;
        this._sampled = spanContext.sampled;
        this._spanId = spanContext.spanId || this._spanId;
        this._startTime = spanContext.startTimestamp || this._startTime;
        this._status = spanContext.status;
        // eslint-disable-next-line deprecation/deprecation
        this.tags = spanContext.tags || {};
        this._traceId = spanContext.traceId || this._traceId;
        return this;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */ getTraceContext() {
        return (0, $aab2fced71923915$export$46c6fbd1d265ebf0)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $5fc8424b9a9220b6$export$d25f2688db1bb433)({
            data: this._getData(),
            description: this._name,
            op: this._attributes[0, $f0df0dfa824ba468$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: this._status,
            // eslint-disable-next-line deprecation/deprecation
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $f0df0dfa824ba468$export$cca8dd30f57f805e],
            _metrics_summary: (0, $57adfc88e21e21bd$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $f0df0dfa824ba468$export$1efec95406bbe327],
            exclusive_time: this._exclusiveTime,
            measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */ toJSON() {
        return this.getSpanJSON();
    }
    /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */ _getData() {
        // eslint-disable-next-line deprecation/deprecation
        const { data: data, _attributes: attributes } = this;
        const hasData = Object.keys(data).length > 0;
        const hasAttributes = Object.keys(attributes).length > 0;
        if (!hasData && !hasAttributes) return undefined;
        if (hasData && hasAttributes) return {
            ...data,
            ...attributes
        };
        return hasData ? data : attributes;
    }
}











/** JSDoc */ class $d2c1f82373c374da$export$febc5573c75cefb0 extends (0, $c70c081f9639c63d$export$5f1714a13ed34c01) {
    /**
   * The reference to the current hub.
   */ // eslint-disable-next-line deprecation/deprecation
    // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ // eslint-disable-next-line deprecation/deprecation
    constructor(transactionContext, hub){
        super(transactionContext);
        this._contexts = {};
        // eslint-disable-next-line deprecation/deprecation
        this._hub = hub || (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)();
        this._name = transactionContext.name || '';
        this._metadata = {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.metadata
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        // TODO (v8): Replace this with another way to set the root span
        // eslint-disable-next-line deprecation/deprecation
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    // This sadly conflicts with the getter/setter ordering :(
    /* eslint-disable @typescript-eslint/member-ordering */ /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */ get name() {
        return this._name;
    }
    /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */ set name(newName) {
        // eslint-disable-next-line deprecation/deprecation
        this.setName(newName);
    }
    /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ get metadata() {
        // We merge attributes in for backwards compatibility
        return {
            // Defaults
            // eslint-disable-next-line deprecation/deprecation
            source: 'custom',
            spanMetadata: {},
            // Legacy metadata
            ...this._metadata,
            // From attributes
            ...this._attributes[0, $f0df0dfa824ba468$export$d7a7d984b0791405] && {
                source: this._attributes[0, $f0df0dfa824ba468$export$d7a7d984b0791405]
            },
            ...this._attributes[0, $f0df0dfa824ba468$export$ccfe0a40627cc34b] && {
                sampleRate: this._attributes[0, $f0df0dfa824ba468$export$ccfe0a40627cc34b]
            }
        };
    }
    /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */ set metadata(metadata) {
        this._metadata = metadata;
    }
    /* eslint-enable @typescript-eslint/member-ordering */ /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */ setName(name, source = 'custom') {
        this._name = name;
        this.setAttribute((0, $f0df0dfa824ba468$export$d7a7d984b0791405), source);
    }
    /** @inheritdoc */ updateName(name) {
        this._name = name;
        return this;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder = new (0, $c70c081f9639c63d$export$10c95c129cd0d4fe)(maxlen);
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */ setMeasurement(name, value, unit = '') {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */ setMetadata(newMetadata) {
        this._metadata = {
            ...this._metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ end(endTimestamp) {
        const timestampInS = (0, $aab2fced71923915$export$3f7581298f56c6d7)(endTimestamp);
        const transaction = this._finishTransaction(timestampInS);
        if (!transaction) return undefined;
        // eslint-disable-next-line deprecation/deprecation
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        // eslint-disable-next-line deprecation/deprecation
        const spanContext = super.toContext();
        return (0, $5fc8424b9a9220b6$export$d25f2688db1bb433)({
            ...spanContext,
            name: this._name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        // eslint-disable-next-line deprecation/deprecation
        super.updateWithContext(transactionContext);
        this._name = transactionContext.name || '';
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */ getDynamicSamplingContext() {
        return (0, $3148374da480247a$export$a117f995597e25df)(this);
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ // eslint-disable-next-line deprecation/deprecation
    setHub(hub) {
        this._hub = hub;
    }
    /**
   * Get the profile id of the transaction.
   */ getProfileId() {
        if (this._contexts !== undefined && this._contexts['profile'] !== undefined) return this._contexts['profile'].profile_id;
        return undefined;
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _finishTransaction(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this._endTime !== undefined) return undefined;
        if (!this._name) {
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        super.end(endTimestamp);
        // eslint-disable-next-line deprecation/deprecation
        const client = this._hub.getClient();
        if (client && client.emit) client.emit('finishTransaction', this);
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        // eslint-disable-next-line deprecation/deprecation
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((span)=>span !== this && (0, $aab2fced71923915$export$92d8c23565496537)(span).timestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            const endTimes = finishedSpans.map((span)=>(0, $aab2fced71923915$export$92d8c23565496537)(span).timestamp).filter(Boolean);
            this._endTime = endTimes.reduce((prev, current)=>{
                return prev > current ? prev : current;
            });
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $289d2b5ef1bc182e$export$c08fbc656a245d03)(this);
        // eslint-disable-next-line deprecation/deprecation
        const { metadata: metadata } = this;
        // eslint-disable-next-line deprecation/deprecation
        const { source: source } = metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: (0, $aab2fced71923915$export$46c6fbd1d265ebf0)(this)
            },
            // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
            spans: finishedSpans,
            start_timestamp: this._startTime,
            // eslint-disable-next-line deprecation/deprecation
            tags: this.tags,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                ...metadata,
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $5fc8424b9a9220b6$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $3148374da480247a$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $57adfc88e21e21bd$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        // eslint-disable-next-line deprecation/deprecation
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);
        return transaction;
    }
}


const $d21b2b05e9aafd65$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $d21b2b05e9aafd65$var$FINISH_REASON_TAG = 'finishReason';
const $d21b2b05e9aafd65$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ class $d21b2b05e9aafd65$export$370d6113c18ba86c extends (0, $c70c081f9639c63d$export$10c95c129cd0d4fe) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanContext().spanId !== this.transactionSpanId) {
            // We patch span.end() to pop an activity after setting an endTimestamp.
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const originalEnd = span.end;
            span.end = (...rest)=>{
                this._popActivity(span.spanContext().spanId);
                return originalEnd.apply(span, rest);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if ((0, $aab2fced71923915$export$92d8c23565496537)(span).timestamp === undefined) this._pushActivity(span.spanContext().spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $d21b2b05e9aafd65$export$b279e6bd7040371f extends (0, $d2c1f82373c374da$export$febc5573c75cefb0) {
    // Activities store a list of active spans
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    // We should not use heartbeat if we finished a transaction
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    /**
   * Timer that tracks Transaction idleTimeout
   */ /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */ constructor(transactionContext, // eslint-disable-next-line deprecation/deprecation
    _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $d21b2b05e9aafd65$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $d21b2b05e9aafd65$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $d21b2b05e9aafd65$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false, /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */ delayAutoFinishUntilSignal = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        this.activities = {};
        this._heartbeatCounter = 0;
        this._finished = false;
        this._idleTimeoutCanceledPermanently = false;
        this._beforeFinishCallbacks = [];
        this._finishReason = $d21b2b05e9aafd65$var$IDLE_TRANSACTION_FINISH_REASONS[4];
        this._autoFinishAllowed = !delayAutoFinishUntilSignal;
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
            // eslint-disable-next-line deprecation/deprecation
            _idleHub.getScope().setSpan(this);
        }
        if (!delayAutoFinishUntilSignal) this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus('deadline_exceeded');
                this._finishReason = $d21b2b05e9aafd65$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.end();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ end(endTimestamp) {
        const endTimestampInS = (0, $aab2fced71923915$export$3f7581298f56c6d7)(endTimestamp);
        this._finished = true;
        this.activities = {};
        // eslint-disable-next-line deprecation/deprecation
        if (this.op === 'ui.action.click') this.setAttribute($d21b2b05e9aafd65$var$FINISH_REASON_TAG, this._finishReason);
        // eslint-disable-next-line deprecation/deprecation
        if (this.spanRecorder) {
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
            (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestampInS);
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanContext().spanId === this.spanContext().spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!(0, $aab2fced71923915$export$92d8c23565496537)(span).timestamp) {
                    span.setStatus('cancelled');
                    span.end(endTimestampInS);
                    (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                const { start_timestamp: startTime, timestamp: endTime } = (0, $aab2fced71923915$export$92d8c23565496537)(span);
                const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;
                // Add a delta with idle timeout so that we prevent false positives
                const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
                const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;
                if (0, $83ab00052d3c52cd$export$16a28057038b10ef) {
                    const stringifiedSpan = JSON.stringify(span, undefined, 2);
                    if (!spanStartedBeforeTransactionFinish) (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
                    else if (!spanEndedBeforeFinalTimeout) (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
                }
                return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
            });
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Tracing] flushing IdleTransaction');
        } else (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            // eslint-disable-next-line deprecation/deprecation
            const scope = this._idleHub.getScope();
            // eslint-disable-next-line deprecation/deprecation
            if (scope.getTransaction() === this) // eslint-disable-next-line deprecation/deprecation
            scope.setSpan(undefined);
        }
        return super.end(endTimestamp);
    }
    /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        // eslint-disable-next-line deprecation/deprecation
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            // eslint-disable-next-line deprecation/deprecation
            this.spanRecorder = new $d21b2b05e9aafd65$export$370d6113c18ba86c(pushActivity, popActivity, this.spanContext().spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $d21b2b05e9aafd65$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.end(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */ sendAutoFinishSignal() {
        if (!this._autoFinishAllowed) {
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Tracing] Received finish signal for idle transaction.');
            this._restartIdleTimeout();
            this._autoFinishAllowed = true;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $d21b2b05e9aafd65$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.end(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $84a662e1e79b3d35$export$ee52dced521e3e18)();
            if (this._idleTimeoutCanceledPermanently) {
                if (this._autoFinishAllowed) {
                    this._finishReason = $d21b2b05e9aafd65$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                    this.end(endTimestamp);
                }
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampInSeconds is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            if (this._autoFinishAllowed) {
                (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Tracing] Transaction finished because of no change for 3 heart beats');
                this.setStatus('deadline_exceeded');
                this._finishReason = $d21b2b05e9aafd65$var$IDLE_TRANSACTION_FINISH_REASONS[0];
                this.end();
            }
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}







/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */ function $ff99a1594b102975$export$b3258c3993bc9b71(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $94ef1ac47039d105$export$5008da00b1b6dee6)(options)) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    // eslint-disable-next-line deprecation/deprecation
    if (transaction.sampled !== undefined) {
        // eslint-disable-next-line deprecation/deprecation
        transaction.setAttribute((0, $f0df0dfa824ba468$export$ccfe0a40627cc34b), Number(transaction.sampled));
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setAttribute((0, $f0df0dfa824ba468$export$ccfe0a40627cc34b), Number(sampleRate));
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setAttribute((0, $f0df0dfa824ba468$export$ccfe0a40627cc34b), Number(sampleRate));
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setAttribute((0, $f0df0dfa824ba468$export$ccfe0a40627cc34b), sampleRate);
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$ff99a1594b102975$export$2603c8d332a51c42(sampleRate)) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        // eslint-disable-next-line deprecation/deprecation
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.sampled) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (0, $83ab00052d3c52cd$export$16a28057038b10ef) && // eslint-disable-next-line deprecation/deprecation
    (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Tracing] starting ${transaction.op} transaction - ${(0, $aab2fced71923915$export$92d8c23565496537)(transaction).description}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $ff99a1594b102975$export$2603c8d332a51c42(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $b7010123686726b5$export$c9f5652083b8129d)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}



/** Returns all trace headers that are currently on the top scope. */ // eslint-disable-next-line deprecation/deprecation
function $8f9c089cc3ec4bb0$var$traceHeaders() {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const span = scope.getSpan();
    return span ? {
        'sentry-trace': (0, $aab2fced71923915$export$7e9f8ae9e4a328ab)(span)
    } : {};
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $8f9c089cc3ec4bb0$var$_startTransaction(// eslint-disable-next-line deprecation/deprecation
transactionContext, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || 'sentry';
    const transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        // eslint-disable-next-line deprecation/deprecation
        transactionContext.sampled = false;
    }
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $d2c1f82373c374da$export$febc5573c75cefb0)(transactionContext, this);
    transaction = (0, $ff99a1594b102975$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $8f9c089cc3ec4bb0$export$479dbd817e392a4f(// eslint-disable-next-line deprecation/deprecation
hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval, delayAutoFinishUntilSignal = false) {
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    // eslint-disable-next-line deprecation/deprecation
    let transaction = new (0, $d21b2b05e9aafd65$export$b279e6bd7040371f)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope, delayAutoFinishUntilSignal);
    transaction = (0, $ff99a1594b102975$export$b3258c3993bc9b71)(transaction, options, {
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        ...customSamplingContext
    });
    if (transaction.isRecording()) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $8f9c089cc3ec4bb0$export$653d0ef2bad9cdf9() {
    const carrier = (0, $4f329577679e8bfc$export$19eade501500c6c1)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $8f9c089cc3ec4bb0$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $8f9c089cc3ec4bb0$var$traceHeaders;
    (0, $592835fd32cb1e30$export$637857c1d87b640c)();
}







// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $7eba083f2fa7f237$var$WINDOW = (0, $0b080c13a84f32b4$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $7eba083f2fa7f237$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $7eba083f2fa7f237$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $7eba083f2fa7f237$var$WINDOW && !!$7eba083f2fa7f237$var$WINDOW.history.pushState && !!$7eba083f2fa7f237$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $6a43a9849395fc81$var$WINDOW = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1);
let $6a43a9849395fc81$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $6a43a9849395fc81$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $e741ef5864ec0e99$export$a4e09611e30da72e)(type, handler);
    (0, $e741ef5864ec0e99$export$e18d6c5462c01368)(type, $6a43a9849395fc81$var$instrumentHistory);
}
function $6a43a9849395fc81$var$instrumentHistory() {
    if (!(0, $7eba083f2fa7f237$export$67fc34576016d6ec)()) return;
    const oldOnPopState = $6a43a9849395fc81$var$WINDOW.onpopstate;
    $6a43a9849395fc81$var$WINDOW.onpopstate = function(...args) {
        const to = $6a43a9849395fc81$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $6a43a9849395fc81$var$lastHref;
        $6a43a9849395fc81$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $e741ef5864ec0e99$export$b18c893e424d3127)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $6a43a9849395fc81$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $6a43a9849395fc81$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $e741ef5864ec0e99$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)($6a43a9849395fc81$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)($6a43a9849395fc81$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e0f1690b3c99f809$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;






const $78197c5127b8461c$export$56d8a8a25bd48b81 = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1);


/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $8786b8d72de7901f$export$6f18f55521af71a1() {
    if ((0, $78197c5127b8461c$export$56d8a8a25bd48b81).document) (0, $78197c5127b8461c$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $1893830b8c7873e3$export$a7feb32fdd923295)();
        if ((0, $78197c5127b8461c$export$56d8a8a25bd48b81).document.hidden && activeTransaction) {
            const statusType = 'cancelled';
            const { op: op, status: status } = (0, $aab2fced71923915$export$92d8c23565496537)(activeTransaction);
            (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) activeTransaction.setStatus(statusType);
            // TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.end();
        }
    });
    else (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}




const $063bf2023d3defa1$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $e653179aa5d12f76$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $063ba65c2b1b1c9d$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $78197c5127b8461c$export$56d8a8a25bd48b81).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $78197c5127b8461c$export$56d8a8a25bd48b81).performance.navigation.type;
    const navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(const key in timing)if (key !== 'navigationStart' && key !== 'toJSON') // eslint-disable-next-line deprecation/deprecation
    navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $063ba65c2b1b1c9d$export$6431553786c94949 = ()=>{
    if ((0, $78197c5127b8461c$export$56d8a8a25bd48b81).__WEB_VITALS_POLYFILL__) return (0, $78197c5127b8461c$export$56d8a8a25bd48b81).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $063ba65c2b1b1c9d$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $78197c5127b8461c$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4d70282f4e1e9620$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $063ba65c2b1b1c9d$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b4499a2357c93bcb$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $063ba65c2b1b1c9d$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $78197c5127b8461c$export$56d8a8a25bd48b81).document && (0, $78197c5127b8461c$export$56d8a8a25bd48b81).document.prerendering || (0, $4d70282f4e1e9620$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $e653179aa5d12f76$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $d49792974ee5e0a7$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $843b5155653c08e9$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $78197c5127b8461c$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    if ((0, $78197c5127b8461c$export$56d8a8a25bd48b81).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $f7de02275877bcde$export$a7873055838e5ad8 = (onReport, options = {})=>{
    const metric = (0, $b4499a2357c93bcb$export$3c29b44508a0612b)('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $d49792974ee5e0a7$export$d1203567a167490e)('layout-shift', handleEntries);
    if (po) {
        report = (0, $063bf2023d3defa1$export$17679dccdd551979)(onReport, metric, options.reportAllChanges);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $843b5155653c08e9$export$91ec2be6fdd8f1b4)(stopListening);
        return stopListening;
    }
    return;
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $f3255a557a3f1c49$var$firstHiddenTime = -1;
const $f3255a557a3f1c49$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    if ((0, $78197c5127b8461c$export$56d8a8a25bd48b81).document && (0, $78197c5127b8461c$export$56d8a8a25bd48b81).document.visibilityState) $f3255a557a3f1c49$var$firstHiddenTime = (0, $78197c5127b8461c$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && !(0, $78197c5127b8461c$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $f3255a557a3f1c49$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $843b5155653c08e9$export$91ec2be6fdd8f1b4)(({ timeStamp: timeStamp })=>{
        $f3255a557a3f1c49$var$firstHiddenTime = timeStamp;
    }, true);
};
const $f3255a557a3f1c49$export$443f86b2c77012c4 = ()=>{
    if ($f3255a557a3f1c49$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $f3255a557a3f1c49$var$initHiddenTime();
        $f3255a557a3f1c49$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $f3255a557a3f1c49$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $1c34b0b066d69966$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $f3255a557a3f1c49$export$443f86b2c77012c4)();
    const metric = (0, $b4499a2357c93bcb$export$3c29b44508a0612b)('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $d49792974ee5e0a7$export$d1203567a167490e)('first-input', handleEntries);
    report = (0, $063bf2023d3defa1$export$17679dccdd551979)(onReport, metric);
    if (po) (0, $843b5155653c08e9$export$91ec2be6fdd8f1b4)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};







let $6f91a0998e0bdc90$var$interactionCountEstimate = 0;
let $6f91a0998e0bdc90$var$minKnownInteractionId = Infinity;
let $6f91a0998e0bdc90$var$maxKnownInteractionId = 0;
const $6f91a0998e0bdc90$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $6f91a0998e0bdc90$var$minKnownInteractionId = Math.min($6f91a0998e0bdc90$var$minKnownInteractionId, e.interactionId);
            $6f91a0998e0bdc90$var$maxKnownInteractionId = Math.max($6f91a0998e0bdc90$var$maxKnownInteractionId, e.interactionId);
            $6f91a0998e0bdc90$var$interactionCountEstimate = $6f91a0998e0bdc90$var$maxKnownInteractionId ? ($6f91a0998e0bdc90$var$maxKnownInteractionId - $6f91a0998e0bdc90$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $6f91a0998e0bdc90$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $6f91a0998e0bdc90$export$8a962f2683a476d1 = ()=>{
    return $6f91a0998e0bdc90$var$po ? $6f91a0998e0bdc90$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $6f91a0998e0bdc90$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $6f91a0998e0bdc90$var$po) return;
    $6f91a0998e0bdc90$var$po = (0, $d49792974ee5e0a7$export$d1203567a167490e)('event', $6f91a0998e0bdc90$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $aadc57d37f9efc37$var$getInteractionCountForNavigation = ()=>{
    return (0, $6f91a0998e0bdc90$export$8a962f2683a476d1)();
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $aadc57d37f9efc37$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $aadc57d37f9efc37$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $aadc57d37f9efc37$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $aadc57d37f9efc37$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $aadc57d37f9efc37$var$longestInteractionList[$aadc57d37f9efc37$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $aadc57d37f9efc37$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $aadc57d37f9efc37$var$longestInteractionList.length < $aadc57d37f9efc37$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $aadc57d37f9efc37$var$longestInteractionMap[interaction.id] = interaction;
            $aadc57d37f9efc37$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $aadc57d37f9efc37$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $aadc57d37f9efc37$var$longestInteractionList.splice($aadc57d37f9efc37$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $aadc57d37f9efc37$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $aadc57d37f9efc37$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($aadc57d37f9efc37$var$longestInteractionList.length - 1, Math.floor($aadc57d37f9efc37$var$getInteractionCountForNavigation() / 50));
    return $aadc57d37f9efc37$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $aadc57d37f9efc37$export$7df4b36ecaed99e1 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/inp/#what's-a-%22good%22-inp-value
    // const thresholds = [200, 500];
    // TODO(philipwalton): remove once the polyfill is no longer needed.
    (0, $6f91a0998e0bdc90$export$67d90cda6b78a2eb)();
    const metric = (0, $b4499a2357c93bcb$export$3c29b44508a0612b)('INP');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            if (entry.interactionId) $aadc57d37f9efc37$var$processEntry(entry);
            // Entries of type `first-input` don't currently have an `interactionId`,
            // so to consider them in INP we have to first check that an existing
            // entry doesn't match the `duration` and `startTime`.
            // Note that this logic assumes that `event` entries are dispatched
            // before `first-input` entries. This is true in Chrome but it is not
            // true in Firefox; however, Firefox doesn't support interactionId, so
            // it's not an issue at the moment.
            // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
            if (entry.entryType === 'first-input') {
                const noMatchingEntry = !$aadc57d37f9efc37$var$longestInteractionList.some((interaction)=>{
                    return interaction.entries.some((prevEntry)=>{
                        return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                    });
                });
                if (noMatchingEntry) $aadc57d37f9efc37$var$processEntry(entry);
            }
        });
        const inp = $aadc57d37f9efc37$var$estimateP98LongestInteraction();
        if (inp && inp.latency !== metric.value) {
            metric.value = inp.latency;
            metric.entries = inp.entries;
            report();
        }
    };
    const po = (0, $d49792974ee5e0a7$export$d1203567a167490e)('event', handleEntries, {
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        durationThreshold: opts.durationThreshold || 40
    });
    report = (0, $063bf2023d3defa1$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    if (po) {
        // Also observe entries of type `first-input`. This is useful in cases
        // where the first interaction is less than the `durationThreshold`.
        po.observe({
            type: 'first-input',
            buffered: true
        });
        (0, $843b5155653c08e9$export$91ec2be6fdd8f1b4)(()=>{
            handleEntries(po.takeRecords());
            // If the interaction count shows that there were interactions but
            // none were captured by the PerformanceObserver, report a latency of 0.
            if (metric.value < 0 && $aadc57d37f9efc37$var$getInteractionCountForNavigation() > 0) {
                metric.value = 0;
                metric.entries = [];
            }
            report(true);
        });
    }
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $ce09eb83b069558c$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $ce09eb83b069558c$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $f3255a557a3f1c49$export$443f86b2c77012c4)();
    const metric = (0, $b4499a2357c93bcb$export$3c29b44508a0612b)('LCP');
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $4d70282f4e1e9620$export$d3e828b3c7b5b845)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $d49792974ee5e0a7$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $063bf2023d3defa1$export$17679dccdd551979)(onReport, metric);
        const stopListening = ()=>{
            if (!$ce09eb83b069558c$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $ce09eb83b069558c$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach((type)=>{
            if ((0, $78197c5127b8461c$export$56d8a8a25bd48b81).document) addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $843b5155653c08e9$export$91ec2be6fdd8f1b4)(stopListening, true);
        return stopListening;
    }
    return;
};








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $537f870abdf56b1d$var$whenReady = (callback)=>{
    if (!(0, $78197c5127b8461c$export$56d8a8a25bd48b81).document) return;
    if ((0, $78197c5127b8461c$export$56d8a8a25bd48b81).document.prerendering) addEventListener('prerenderingchange', ()=>$537f870abdf56b1d$var$whenReady(callback), true);
    else if ((0, $78197c5127b8461c$export$56d8a8a25bd48b81).document.readyState !== 'complete') addEventListener('load', ()=>$537f870abdf56b1d$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $537f870abdf56b1d$export$33a01e6c5f2c7e33 = (onReport, opts)=>{
    // Set defaults
    // eslint-disable-next-line no-param-reassign
    opts = opts || {};
    // https://web.dev/ttfb/#what-is-a-good-ttfb-score
    // const thresholds = [800, 1800];
    const metric = (0, $b4499a2357c93bcb$export$3c29b44508a0612b)('TTFB');
    const report = (0, $063bf2023d3defa1$export$17679dccdd551979)(onReport, metric, opts.reportAllChanges);
    $537f870abdf56b1d$var$whenReady(()=>{
        const navEntry = (0, $063ba65c2b1b1c9d$export$6431553786c94949)();
        if (navEntry) {
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(navEntry.responseStart - (0, $4d70282f4e1e9620$export$d3e828b3c7b5b845)(), 0);
            // In some cases the value reported is negative or is larger
            // than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            if (metric.value < 0 || metric.value > performance.now()) return;
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $b6037ab48997e819$var$handlers = {};
const $b6037ab48997e819$var$instrumented = {};
let $b6037ab48997e819$var$_previousCls;
let $b6037ab48997e819$var$_previousFid;
let $b6037ab48997e819$var$_previousLcp;
let $b6037ab48997e819$var$_previousTtfb;
let $b6037ab48997e819$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $b6037ab48997e819$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $b6037ab48997e819$var$addMetricObserver('cls', callback, $b6037ab48997e819$var$instrumentCls, $b6037ab48997e819$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $b6037ab48997e819$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $b6037ab48997e819$var$addMetricObserver('lcp', callback, $b6037ab48997e819$var$instrumentLcp, $b6037ab48997e819$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $b6037ab48997e819$export$699d9529c099a797(callback) {
    return $b6037ab48997e819$var$addMetricObserver('ttfb', callback, $b6037ab48997e819$var$instrumentTtfb, $b6037ab48997e819$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $b6037ab48997e819$export$2707d7471c0b918f(callback) {
    return $b6037ab48997e819$var$addMetricObserver('fid', callback, $b6037ab48997e819$var$instrumentFid, $b6037ab48997e819$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $b6037ab48997e819$export$da3b76aa2022cbd7(callback) {
    return $b6037ab48997e819$var$addMetricObserver('inp', callback, $b6037ab48997e819$var$instrumentInp, $b6037ab48997e819$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $b6037ab48997e819$export$69816c1a049f8db6(type, callback) {
    $b6037ab48997e819$var$addHandler(type, callback);
    if (!$b6037ab48997e819$var$instrumented[type]) {
        $b6037ab48997e819$var$instrumentPerformanceObserver(type);
        $b6037ab48997e819$var$instrumented[type] = true;
    }
    return $b6037ab48997e819$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $b6037ab48997e819$var$triggerHandlers(type, data) {
    const typeHandlers = $b6037ab48997e819$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $78e6ecc0f4af74a8$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $b6037ab48997e819$var$instrumentCls() {
    return (0, $f7de02275877bcde$export$a7873055838e5ad8)((metric)=>{
        $b6037ab48997e819$var$triggerHandlers('cls', {
            metric: metric
        });
        $b6037ab48997e819$var$_previousCls = metric;
    }, {
        reportAllChanges: true
    });
}
function $b6037ab48997e819$var$instrumentFid() {
    return (0, $1c34b0b066d69966$export$39705a25c49af873)((metric)=>{
        $b6037ab48997e819$var$triggerHandlers('fid', {
            metric: metric
        });
        $b6037ab48997e819$var$_previousFid = metric;
    });
}
function $b6037ab48997e819$var$instrumentLcp() {
    return (0, $ce09eb83b069558c$export$947b1626ab8d5632)((metric)=>{
        $b6037ab48997e819$var$triggerHandlers('lcp', {
            metric: metric
        });
        $b6037ab48997e819$var$_previousLcp = metric;
    });
}
function $b6037ab48997e819$var$instrumentTtfb() {
    return (0, $537f870abdf56b1d$export$33a01e6c5f2c7e33)((metric)=>{
        $b6037ab48997e819$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $b6037ab48997e819$var$_previousTtfb = metric;
    });
}
function $b6037ab48997e819$var$instrumentInp() {
    return (0, $aadc57d37f9efc37$export$7df4b36ecaed99e1)((metric)=>{
        $b6037ab48997e819$var$triggerHandlers('inp', {
            metric: metric
        });
        $b6037ab48997e819$var$_previousInp = metric;
    });
}
function $b6037ab48997e819$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $b6037ab48997e819$var$addHandler(type, callback);
    let stopListening;
    if (!$b6037ab48997e819$var$instrumented[type]) {
        stopListening = instrumentFn();
        $b6037ab48997e819$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $b6037ab48997e819$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $b6037ab48997e819$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $d49792974ee5e0a7$export$d1203567a167490e)(type, (entries)=>{
        $b6037ab48997e819$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $b6037ab48997e819$var$addHandler(type, handler) {
    $b6037ab48997e819$var$handlers[type] = $b6037ab48997e819$var$handlers[type] || [];
    $b6037ab48997e819$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $b6037ab48997e819$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $b6037ab48997e819$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}




/** Regular expression used to parse a Dsn. */ const $1e393eba7883271b$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $1e393eba7883271b$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $1e393eba7883271b$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $1e393eba7883271b$export$b892860177f70a30(str) {
    const match = $1e393eba7883271b$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $a517e3a601d07c96$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $1e393eba7883271b$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $1e393eba7883271b$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $1e393eba7883271b$var$validateDsn(dsn) {
    if (!(0, $0acd7a1567fedcff$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $a517e3a601d07c96$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $a517e3a601d07c96$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$1e393eba7883271b$var$isValidProtocol(protocol)) {
        (0, $a517e3a601d07c96$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $a517e3a601d07c96$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $1e393eba7883271b$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $1e393eba7883271b$export$b892860177f70a30(from) : $1e393eba7883271b$var$dsnFromComponents(from);
    if (!components || !$1e393eba7883271b$var$validateDsn(components)) return undefined;
    return components;
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $0d00be936a328b0c$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $0d00be936a328b0c$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $0d00be936a328b0c$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $0d00be936a328b0c$export$604a45d95a155e2b(envelope, types) {
    return $0d00be936a328b0c$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $0d00be936a328b0c$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $0d00be936a328b0c$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $0d00be936a328b0c$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $0d00be936a328b0c$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $707bc16f15b0ab27$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $0d00be936a328b0c$var$concatBuffers(parts);
}
function $0d00be936a328b0c$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $0d00be936a328b0c$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $0d00be936a328b0c$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $0d00be936a328b0c$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $5fc8424b9a9220b6$export$d25f2688db1bb433)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $0d00be936a328b0c$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $0d00be936a328b0c$export$b11169581eeaf237(type) {
    return $0d00be936a328b0c$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $0d00be936a328b0c$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $0d00be936a328b0c$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1e393eba7883271b$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $5fc8424b9a9220b6$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}


/**
 * Create envelope from Span item.
 */ function $1d96e473d01cef7e$export$19a0081d4b39d77(spans, dsn) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (dsn) headers.dsn = (0, $1e393eba7883271b$export$44d472fbb931a776)(dsn);
    const items = spans.map($1d96e473d01cef7e$var$createSpanItem);
    return (0, $0d00be936a328b0c$export$f93f7f385160c44e)(headers, items);
}
function $1d96e473d01cef7e$var$createSpanItem(span) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        span
    ];
}


/**
 * Adds a measurement to the current active transaction.
 */ function $c6a4d2384e86097f$export$7cc31b475d33a706(name, value, unit) {
    // eslint-disable-next-line deprecation/deprecation
    const transaction = (0, $1893830b8c7873e3$export$a7feb32fdd923295)();
    if (transaction) // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
}


/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $f5cc7285b77fbeb7$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $f5cc7285b77fbeb7$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $f5cc7285b77fbeb7$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $f5cc7285b77fbeb7$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}






/**
 * Checks if a given value is a valid measurement value.
 */ function $2e3e22b2d4894e38$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */ function $2e3e22b2d4894e38$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    // eslint-disable-next-line deprecation/deprecation
    if (startTimestamp && transaction.startTimestamp > startTimestamp) // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}



const $05e80831adde0142$var$MAX_INT_AS_BYTES = 2147483647;
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $05e80831adde0142$var$msToSec(time) {
    return time / 1000;
}
function $05e80831adde0142$var$getBrowserPerformanceAPI() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $78197c5127b8461c$export$56d8a8a25bd48b81) && (0, $78197c5127b8461c$export$56d8a8a25bd48b81).addEventListener && (0, $78197c5127b8461c$export$56d8a8a25bd48b81).performance;
}
let $05e80831adde0142$var$_performanceCursor = 0;
let $05e80831adde0142$var$_measurements = {};
let $05e80831adde0142$var$_lcpEntry;
let $05e80831adde0142$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $05e80831adde0142$export$7c69f0412d101b88() {
    const performance = $05e80831adde0142$var$getBrowserPerformanceAPI();
    if (performance && (0, $84a662e1e79b3d35$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $78197c5127b8461c$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        const fidCallback = $05e80831adde0142$var$_trackFID();
        const clsCallback = $05e80831adde0142$var$_trackCLS();
        const lcpCallback = $05e80831adde0142$var$_trackLCP();
        const ttfbCallback = $05e80831adde0142$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $05e80831adde0142$export$f396d19077034ad2() {
    (0, $b6037ab48997e819$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $1893830b8c7873e3$export$a7feb32fdd923295)();
            if (!transaction) return;
            const startTime = $05e80831adde0142$var$msToSec((0, $84a662e1e79b3d35$export$baf075a948ffc0bf) + entry.startTime);
            const duration = $05e80831adde0142$var$msToSec(entry.duration);
            // eslint-disable-next-line deprecation/deprecation
            transaction.startChild({
                description: 'Main UI thread blocked',
                op: 'ui.long-task',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $05e80831adde0142$export$e27543e0976315e4() {
    (0, $b6037ab48997e819$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        for (const entry of entries){
            // eslint-disable-next-line deprecation/deprecation
            const transaction = (0, $1893830b8c7873e3$export$a7feb32fdd923295)();
            if (!transaction) return;
            if (entry.name === 'click') {
                const startTime = $05e80831adde0142$var$msToSec((0, $84a662e1e79b3d35$export$baf075a948ffc0bf) + entry.startTime);
                const duration = $05e80831adde0142$var$msToSec(entry.duration);
                const span = {
                    description: (0, $af122b07f14d085e$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    origin: 'auto.ui.browser.metrics',
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                };
                const componentName = (0, $af122b07f14d085e$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) span.attributes = {
                    'ui.component_name': componentName
                };
                // eslint-disable-next-line deprecation/deprecation
                transaction.startChild(span);
            }
        }
    });
}
/**
 * Start tracking INP webvital events.
 */ function $05e80831adde0142$export$f17d06681a4744a3(interactionIdtoRouteNameMapping, interactionsSampleRate) {
    const performance = $05e80831adde0142$var$getBrowserPerformanceAPI();
    if (performance && (0, $84a662e1e79b3d35$export$baf075a948ffc0bf)) {
        const inpCallback = $05e80831adde0142$var$_trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $05e80831adde0142$var$_trackCLS() {
    return (0, $b6037ab48997e819$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Measurements] Adding CLS');
        $05e80831adde0142$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $05e80831adde0142$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $05e80831adde0142$var$_trackLCP() {
    return (0, $b6037ab48997e819$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Measurements] Adding LCP');
        $05e80831adde0142$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $05e80831adde0142$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $05e80831adde0142$var$_trackFID() {
    return (0, $b6037ab48997e819$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = $05e80831adde0142$var$msToSec((0, $84a662e1e79b3d35$export$baf075a948ffc0bf));
        const startTime = $05e80831adde0142$var$msToSec(entry.startTime);
        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Measurements] Adding FID');
        $05e80831adde0142$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $05e80831adde0142$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $05e80831adde0142$var$_trackTtfb() {
    return (0, $b6037ab48997e819$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Measurements] Adding TTFB');
        $05e80831adde0142$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
const $05e80831adde0142$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $05e80831adde0142$var$_trackINP(interactionIdToRouteNameMapping, interactionsSampleRate) {
    return (0, $b6037ab48997e819$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        if (metric.value === undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $05e80831adde0142$var$INP_ENTRY_MAP[entry.name] !== undefined);
        const client = (0, $a083afa4ea001828$export$6bb76d6eba7e258c)();
        if (!entry || !client) return;
        const interactionType = $05e80831adde0142$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = $05e80831adde0142$var$msToSec((0, $84a662e1e79b3d35$export$baf075a948ffc0bf) + entry.startTime);
        const duration = $05e80831adde0142$var$msToSec(metric.value);
        const interaction = entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
        if (interaction === undefined) return;
        const { routeName: routeName, parentContext: parentContext, activeTransaction: activeTransaction, user: user, replayId: replayId } = interaction;
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
        const span = new (0, $c70c081f9639c63d$export$5f1714a13ed34c01)({
            startTimestamp: startTime,
            endTimestamp: startTime + duration,
            op: `ui.interaction.${interactionType}`,
            name: (0, $af122b07f14d085e$export$5647df6b7814ac86)(entry.target),
            attributes: {
                release: options.release,
                environment: options.environment,
                transaction: routeName,
                ...userDisplay !== undefined && userDisplay !== '' ? {
                    user: userDisplay
                } : {},
                ...profileId !== undefined ? {
                    profile_id: profileId
                } : {},
                ...replayId !== undefined ? {
                    replay_id: replayId
                } : {}
            },
            exclusiveTime: metric.value,
            measurements: {
                inp: {
                    value: metric.value,
                    unit: 'millisecond'
                }
            }
        });
        /** Check to see if the span should be sampled */ const sampleRate = $05e80831adde0142$var$getSampleRate(parentContext, options, interactionsSampleRate);
        if (!sampleRate) return;
        if (Math.random() < sampleRate) {
            const envelope = span ? (0, $1d96e473d01cef7e$export$19a0081d4b39d77)([
                span
            ], client.getDsn()) : undefined;
            const transport = client && client.getTransport();
            if (transport && envelope) transport.send(envelope).then(null, (reason)=>{
                (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).error('Error while sending interaction:', reason);
            });
            return;
        }
    });
}
/** Add performance related spans to a transaction */ function $05e80831adde0142$export$5f8fa6b3467a7443(transaction) {
    const performance = $05e80831adde0142$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $78197c5127b8461c$export$56d8a8a25bd48b81).performance.getEntries || !(0, $84a662e1e79b3d35$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = $05e80831adde0142$var$msToSec((0, $84a662e1e79b3d35$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $aab2fced71923915$export$92d8c23565496537)(transaction);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($05e80831adde0142$var$_performanceCursor).forEach((entry)=>{
        const startTime = $05e80831adde0142$var$msToSec(entry.startTime);
        const duration = $05e80831adde0142$var$msToSec(entry.duration);
        // eslint-disable-next-line deprecation/deprecation
        if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $05e80831adde0142$var$_addNavigationSpans(transaction, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $05e80831adde0142$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $f3255a557a3f1c49$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Measurements] Adding FP');
                        $05e80831adde0142$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Measurements] Adding FCP');
                        $05e80831adde0142$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                $05e80831adde0142$export$c82fe1a70634f317(transaction, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $05e80831adde0142$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $05e80831adde0142$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $05e80831adde0142$var$_addTtfbRequestTimeToMeasurements($05e80831adde0142$var$_measurements);
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$05e80831adde0142$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $05e80831adde0142$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $05e80831adde0142$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $05e80831adde0142$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $05e80831adde0142$var$_measurements['mark.fid'];
        if (fidMark && $05e80831adde0142$var$_measurements['fid']) {
            // create span for FID
            (0, $2e3e22b2d4894e38$export$8bd469e1f37aa721)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $05e80831adde0142$var$msToSec($05e80831adde0142$var$_measurements['fid'].value),
                op: 'ui.action',
                origin: 'auto.ui.browser.metrics',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $05e80831adde0142$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $05e80831adde0142$var$_measurements)) delete $05e80831adde0142$var$_measurements.cls;
        Object.keys($05e80831adde0142$var$_measurements).forEach((measurementName)=>{
            (0, $c6a4d2384e86097f$export$7cc31b475d33a706)(measurementName, $05e80831adde0142$var$_measurements[measurementName].value, $05e80831adde0142$var$_measurements[measurementName].unit);
        });
        $05e80831adde0142$var$_tagMetricInfo(transaction);
    }
    $05e80831adde0142$var$_lcpEntry = undefined;
    $05e80831adde0142$var$_clsEntry = undefined;
    $05e80831adde0142$var$_measurements = {};
}
/** Create measure related spans */ function $05e80831adde0142$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $2e3e22b2d4894e38$export$8bd469e1f37aa721)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        origin: 'auto.resource.browser.metrics',
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $05e80831adde0142$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $05e80831adde0142$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $05e80831adde0142$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $05e80831adde0142$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $05e80831adde0142$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $05e80831adde0142$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $05e80831adde0142$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $2e3e22b2d4894e38$export$8bd469e1f37aa721)(transaction, {
        op: 'browser',
        origin: 'auto.browser.browser.metrics',
        description: description || event,
        startTimestamp: timeOrigin + $05e80831adde0142$var$msToSec(start),
        endTimestamp: timeOrigin + $05e80831adde0142$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $05e80831adde0142$var$_addRequest(transaction, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
        (0, $2e3e22b2d4894e38$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'request',
            startTimestamp: timeOrigin + $05e80831adde0142$var$msToSec(entry.requestStart),
            endTimestamp: timeOrigin + $05e80831adde0142$var$msToSec(entry.responseEnd)
        });
        (0, $2e3e22b2d4894e38$export$8bd469e1f37aa721)(transaction, {
            op: 'browser',
            origin: 'auto.browser.browser.metrics',
            description: 'response',
            startTimestamp: timeOrigin + $05e80831adde0142$var$msToSec(entry.responseStart),
            endTimestamp: timeOrigin + $05e80831adde0142$var$msToSec(entry.responseEnd)
        });
    }
}
/** Create resource-related spans */ function $05e80831adde0142$export$c82fe1a70634f317(transaction, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $f5cc7285b77fbeb7$export$7a5253c0f62e0150)(resourceUrl);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    $05e80831adde0142$var$setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
    $05e80831adde0142$var$setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
    $05e80831adde0142$var$setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) data['server.address'] = parsedUrl.host;
    data['url.same_origin'] = resourceUrl.includes((0, $78197c5127b8461c$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $2e3e22b2d4894e38$export$8bd469e1f37aa721)(transaction, {
        description: resourceUrl.replace((0, $78197c5127b8461c$export$56d8a8a25bd48b81).location.origin, ''),
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        origin: 'auto.resource.browser.metrics',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $05e80831adde0142$var$_trackNavigator(transaction) {
    const navigator = (0, $78197c5127b8461c$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('connectionType', connection.type);
        if ((0, $2e3e22b2d4894e38$export$27169ccae1b439e3)(connection.rtt)) $05e80831adde0142$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $2e3e22b2d4894e38$export$27169ccae1b439e3)(navigator.deviceMemory)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $2e3e22b2d4894e38$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $05e80831adde0142$var$_tagMetricInfo(transaction) {
    if ($05e80831adde0142$var$_lcpEntry) {
        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($05e80831adde0142$var$_lcpEntry.element) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.element', (0, $af122b07f14d085e$export$5647df6b7814ac86)($05e80831adde0142$var$_lcpEntry.element));
        if ($05e80831adde0142$var$_lcpEntry.id) // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.id', $05e80831adde0142$var$_lcpEntry.id);
        if ($05e80831adde0142$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.url', $05e80831adde0142$var$_lcpEntry.url.trim().slice(0, 200));
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        transaction.setTag('lcp.size', $05e80831adde0142$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($05e80831adde0142$var$_clsEntry && $05e80831adde0142$var$_clsEntry.sources) {
        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Measurements] Adding CLS Data');
        $05e80831adde0142$var$_clsEntry.sources.forEach((source, index)=>// TODO: Can we rewrite this to an attribute?
            // eslint-disable-next-line deprecation/deprecation
            transaction.setTag(`cls.source.${index + 1}`, (0, $af122b07f14d085e$export$5647df6b7814ac86)(source.node)));
    }
}
function $05e80831adde0142$var$setResourceEntrySizeData(data, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $05e80831adde0142$var$MAX_INT_AS_BYTES) data[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $05e80831adde0142$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $063ba65c2b1b1c9d$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('[Measurements] Adding TTFB Request Time');
        _measurements['ttfb.requestTime'] = {
            value: responseStart - requestStart,
            unit: 'millisecond'
        };
    }
}
/** Taken from @sentry/core sampling.ts */ function $05e80831adde0142$var$getSampleRate(transactionContext, options, interactionsSampleRate) {
    if (!(0, $94ef1ac47039d105$export$5008da00b1b6dee6)(options)) return false;
    let sampleRate;
    if (transactionContext !== undefined && typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler({
        transactionContext: transactionContext,
        name: transactionContext.name,
        parentSampled: transactionContext.parentSampled,
        attributes: {
            // eslint-disable-next-line deprecation/deprecation
            ...transactionContext.data,
            ...transactionContext.attributes
        },
        location: (0, $78197c5127b8461c$export$56d8a8a25bd48b81).location
    });
    else if (transactionContext !== undefined && transactionContext.sampled !== undefined) sampleRate = transactionContext.sampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else sampleRate = 1;
    if (!(0, $ff99a1594b102975$export$2603c8d332a51c42)(sampleRate)) {
        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('[Tracing] Discarding interaction span because of invalid sample rate.');
        return false;
    }
    if (sampleRate === true) return interactionsSampleRate;
    else if (sampleRate === false) return 0;
    return sampleRate * interactionsSampleRate;
}







// eslint-disable-next-line deprecation/deprecation
const $026891edde5f38fb$var$WINDOW = (0, $0b080c13a84f32b4$export$256479dc0cea61c4)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $026891edde5f38fb$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $026891edde5f38fb$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $026891edde5f38fb$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $026891edde5f38fb$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $026891edde5f38fb$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $026891edde5f38fb$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $026891edde5f38fb$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$026891edde5f38fb$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($026891edde5f38fb$export$18cf36ed71d733e7($026891edde5f38fb$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $026891edde5f38fb$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $026891edde5f38fb$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $0acd7a1567fedcff$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $026891edde5f38fb$export$531055a6c684a70a() {
    return 'ReportingObserver' in $026891edde5f38fb$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $026891edde5f38fb$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$026891edde5f38fb$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}




/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c3de2a70914e0e21$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $e741ef5864ec0e99$export$a4e09611e30da72e)(type, handler);
    (0, $e741ef5864ec0e99$export$e18d6c5462c01368)(type, $c3de2a70914e0e21$var$instrumentFetch);
}
function $c3de2a70914e0e21$var$instrumentFetch() {
    if (!(0, $026891edde5f38fb$export$c82d238e23c40b21)()) return;
    (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)((0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $c3de2a70914e0e21$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $e741ef5864ec0e99$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $e741ef5864ec0e99$export$b18c893e424d3127)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $e741ef5864ec0e99$export$b18c893e424d3127)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $c3de2a70914e0e21$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $c3de2a70914e0e21$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($c3de2a70914e0e21$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $c3de2a70914e0e21$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $c3de2a70914e0e21$var$getUrlFromResource(url),
            method: $c3de2a70914e0e21$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $c3de2a70914e0e21$var$getUrlFromResource(arg),
        method: $c3de2a70914e0e21$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}





const $863863c1afe54d74$var$WINDOW = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1);
const $863863c1afe54d74$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $863863c1afe54d74$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $e741ef5864ec0e99$export$a4e09611e30da72e)(type, handler);
    (0, $e741ef5864ec0e99$export$e18d6c5462c01368)(type, $863863c1afe54d74$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $863863c1afe54d74$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$863863c1afe54d74$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $b7010123686726b5$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $863863c1afe54d74$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$863863c1afe54d74$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$863863c1afe54d74$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $e741ef5864ec0e99$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$863863c1afe54d74$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $b7010123686726b5$export$844ec244b1367d54)(header) && (0, $b7010123686726b5$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$863863c1afe54d74$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $e741ef5864ec0e99$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $863863c1afe54d74$var$parseUrl(url) {
    if ((0, $b7010123686726b5$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}




/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $87ead381956f0fca$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!(0, $94ef1ac47039d105$export$5008da00b1b6dee6)() || !handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $87ead381956f0fca$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $a083afa4ea001828$export$c7be4b0125a10cba)();
    const client = (0, $a083afa4ea001828$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $87ead381956f0fca$var$getFullURL(url);
    const host = fullUrl ? (0, $f5cc7285b77fbeb7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $289d2b5ef1bc182e$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host,
            [(0, $f0df0dfa824ba468$export$cca8dd30f57f805e)]: spanOrigin
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        handlerData.fetchData.__span = span.spanContext().spanId;
        spans[span.spanContext().spanId] = span;
    }
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
        options.headers = $87ead381956f0fca$export$6717acf674206871(request, client, scope, options, span);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $87ead381956f0fca$export$6717acf674206871(request, client, scope, options, requestSpan) {
    // eslint-disable-next-line deprecation/deprecation
    const span = requestSpan || scope.getSpan();
    const isolationScope = (0, $4f329577679e8bfc$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $aab2fced71923915$export$7e9f8ae9e4a328ab)(span) : (0, $0f9ea59ec48a1e09$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $02dcec072b7c9f17$export$56766feef403f365)(dsc || (span ? (0, $3148374da480247a$export$a117f995597e25df)(span) : (0, $3148374da480247a$export$366bad00d6815eed)(traceId, client, scope)));
    const headers = options.headers || (typeof Request !== 'undefined' && (0, $b7010123686726b5$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $b7010123686726b5$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $02dcec072b7c9f17$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $02dcec072b7c9f17$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
function $87ead381956f0fca$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $87ead381956f0fca$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $4d92e4d4d522a7e1$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus('internal_error');
    span.end();
}




/* eslint-disable max-lines */ const $fe4bbc9fdfd38efb$export$15bd0305d05ad07b = [
    'localhost',
    /^\/(?!\/)/
];
/** Options for Request Instrumentation */ const $fe4bbc9fdfd38efb$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    // TODO (v8): Remove this property
    tracingOrigins: $fe4bbc9fdfd38efb$export$15bd0305d05ad07b,
    tracePropagationTargets: $fe4bbc9fdfd38efb$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $fe4bbc9fdfd38efb$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets, tracingOrigins: // eslint-disable-next-line deprecation/deprecation
    tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings } = {
        traceFetch: $fe4bbc9fdfd38efb$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $fe4bbc9fdfd38efb$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$fe4bbc9fdfd38efb$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $c3de2a70914e0e21$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $87ead381956f0fca$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $fe4bbc9fdfd38efb$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $f5cc7285b77fbeb7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                'http.url': fullUrl,
                'server.address': host
            });
        }
        if (enableHTTPTimings && createdSpan) $fe4bbc9fdfd38efb$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $863863c1afe54d74$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $fe4bbc9fdfd38efb$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $fe4bbc9fdfd38efb$var$addHTTPTimings(createdSpan);
    });
}
function $fe4bbc9fdfd38efb$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $fe4bbc9fdfd38efb$var$addHTTPTimings(span) {
    const { url: url } = (0, $aab2fced71923915$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $b6037ab48997e819$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($fe4bbc9fdfd38efb$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $fe4bbc9fdfd38efb$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $fe4bbc9fdfd38efb$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $fe4bbc9fdfd38efb$var$getAbsoluteTime(time = 0) {
    return (((0, $84a662e1e79b3d35$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $fe4bbc9fdfd38efb$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $fe4bbc9fdfd38efb$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $84a662e1e79b3d35$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $fe4bbc9fdfd38efb$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $fe4bbc9fdfd38efb$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $fe4bbc9fdfd38efb$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $fe4bbc9fdfd38efb$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $fe4bbc9fdfd38efb$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $fe4bbc9fdfd38efb$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $fe4bbc9fdfd38efb$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $fe4bbc9fdfd38efb$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $fe4bbc9fdfd38efb$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $fe4bbc9fdfd38efb$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $fe4bbc9fdfd38efb$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $a1ee7577f9dd9008$export$a7a5ec66062ea5d)(url, tracePropagationTargets || $fe4bbc9fdfd38efb$export$15bd0305d05ad07b);
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ // eslint-disable-next-line complexity
function $fe4bbc9fdfd38efb$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $863863c1afe54d74$export$55b6bb1e45c6cf59];
    if (!(0, $94ef1ac47039d105$export$5008da00b1b6dee6)() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $4d92e4d4d522a7e1$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $a083afa4ea001828$export$c7be4b0125a10cba)();
    const isolationScope = (0, $4f329577679e8bfc$export$68f3af03034c9e90)();
    const fullUrl = $fe4bbc9fdfd38efb$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $f5cc7285b77fbeb7$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const span = shouldCreateSpanResult ? (0, $289d2b5ef1bc182e$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host,
            [(0, $f0df0dfa824ba468$export$cca8dd30f57f805e)]: 'auto.http.browser'
        },
        op: 'http.client'
    }) : undefined;
    if (span) {
        xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
        spans[xhr.__sentry_xhr_span_id__] = span;
    }
    const client = (0, $a083afa4ea001828$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
        const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const sentryTraceHeader = span ? (0, $aab2fced71923915$export$7e9f8ae9e4a328ab)(span) : (0, $0f9ea59ec48a1e09$export$f35d907436da45cf)(traceId, spanId, sampled);
        const sentryBaggageHeader = (0, $02dcec072b7c9f17$export$56766feef403f365)(dsc || (span ? (0, $3148374da480247a$export$a117f995597e25df)(span) : (0, $3148374da480247a$export$366bad00d6815eed)(traceId, client, scope)));
        $fe4bbc9fdfd38efb$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
    }
    return span;
}
function $fe4bbc9fdfd38efb$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $02dcec072b7c9f17$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $fe4bbc9fdfd38efb$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $78197c5127b8461c$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}



const $d6a6fa6ad076011d$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $d6a6fa6ad076011d$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $d21b2b05e9aafd65$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: false,
    interactionsSampleRate: 1,
    _experiments: {},
    ...(0, $fe4bbc9fdfd38efb$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $d6a6fa6ad076011d$export$b4109253475213e9 = (_options = {})=>{
    const _hasSetTracePropagationTargets = (0, $e0f1690b3c99f809$export$16a28057038b10ef) ? !!// eslint-disable-next-line deprecation/deprecation
    (_options.tracePropagationTargets || _options.tracingOrigins) : false;
    (0, $8f9c089cc3ec4bb0$export$653d0ef2bad9cdf9)();
    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (!_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
    _options.tracePropagationTargets = _options.tracingOrigins;
    const options = {
        ...$d6a6fa6ad076011d$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $05e80831adde0142$export$7c69f0412d101b88)();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */ const interactionIdToRouteNameMapping = {};
    if (options.enableInp) (0, $05e80831adde0142$export$f17d06681a4744a3)(interactionIdToRouteNameMapping, options.interactionsSampleRate);
    if (options.enableLongTask) (0, $05e80831adde0142$export$f396d19077034ad2)();
    if (options._experiments.enableInteractions) (0, $05e80831adde0142$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        context: undefined
    };
    /** Create routing idle transaction. */ function _createRouteTransaction(context) {
        // eslint-disable-next-line deprecation/deprecation
        const hub = (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)();
        const { beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const isPageloadTransaction = context.op === 'pageload';
        let expandedContext;
        if (isPageloadTransaction) {
            const sentryTrace = isPageloadTransaction ? $d6a6fa6ad076011d$export$f147b32b03c9cf11('sentry-trace') : '';
            const baggage = isPageloadTransaction ? $d6a6fa6ad076011d$export$f147b32b03c9cf11('baggage') : undefined;
            const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: sampled } = (0, $0f9ea59ec48a1e09$export$261f383d16a93e39)(sentryTrace, baggage);
            expandedContext = {
                traceId: traceId,
                parentSpanId: parentSpanId,
                parentSampled: sampled,
                ...context,
                metadata: {
                    // eslint-disable-next-line deprecation/deprecation
                    ...context.metadata,
                    dynamicSamplingContext: dsc
                },
                trimEnd: true
            };
        } else expandedContext = {
            trimEnd: true,
            ...context
        };
        const finalContext = beforeStartSpan ? beforeStartSpan(expandedContext) : expandedContext;
        // If `beforeStartSpan` set a custom name, record that fact
        // eslint-disable-next-line deprecation/deprecation
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        latestRoute.name = finalContext.name;
        latestRoute.context = finalContext;
        if (finalContext.sampled === false) (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const { location: location } = (0, $78197c5127b8461c$export$56d8a8a25bd48b81);
        const idleTransaction = (0, $8f9c089cc3ec4bb0$export$479dbd817e392a4f)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval, isPageloadTransaction);
        if (isPageloadTransaction && (0, $78197c5127b8461c$export$56d8a8a25bd48b81).document) {
            (0, $78197c5127b8461c$export$56d8a8a25bd48b81).document.addEventListener('readystatechange', ()=>{
                if ([
                    'interactive',
                    'complete'
                ].includes((0, $78197c5127b8461c$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
            });
            if ([
                'interactive',
                'complete'
            ].includes((0, $78197c5127b8461c$export$56d8a8a25bd48b81).document.readyState)) idleTransaction.sendAutoFinishSignal();
        }
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            _collectWebVitals();
            (0, $05e80831adde0142$export$5f8fa6b3467a7443)(transaction);
        });
        return idleTransaction;
    }
    return {
        name: $d6a6fa6ad076011d$export$bbd2089f30bd3708,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        setupOnce: ()=>{},
        afterAllSetup (client) {
            const clientOptions = client.getOptions();
            const { markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, _experiments: _experiments } = options;
            const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
            // There are three ways to configure tracePropagationTargets:
            // 1. via top level client option `tracePropagationTargets`
            // 2. via BrowserTracing option `tracePropagationTargets`
            // 3. via BrowserTracing option `tracingOrigins` (deprecated)
            //
            // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
            // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
            // This is done as it minimizes bundle size (we don't have to have undefined checks).
            //
            // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
            // eslint-disable-next-line deprecation/deprecation
            const tracePropagationTargets = clientOptionsTracePropagationTargets || options.tracePropagationTargets;
            if ((0, $e0f1690b3c99f809$export$16a28057038b10ef) && _hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.');
            let activeSpan;
            let startingUrl = (0, $78197c5127b8461c$export$56d8a8a25bd48b81).location && (0, $78197c5127b8461c$export$56d8a8a25bd48b81).location.href;
            if (client.on) {
                client.on('startNavigationSpan', (context)=>{
                    if (activeSpan) {
                        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $aab2fced71923915$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: 'navigation',
                        ...context
                    });
                });
                client.on('startPageLoadSpan', (context)=>{
                    if (activeSpan) {
                        (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`[Tracing] Finishing current transaction with op: ${(0, $aab2fced71923915$export$92d8c23565496537)(activeSpan).op}`);
                        // If there's an open transaction on the scope, we need to finish it before creating an new one.
                        activeSpan.end();
                    }
                    activeSpan = _createRouteTransaction({
                        op: 'pageload',
                        ...context
                    });
                });
            }
            if (options.instrumentPageLoad && client.emit && (0, $78197c5127b8461c$export$56d8a8a25bd48b81).location) {
                const context = {
                    name: (0, $78197c5127b8461c$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTimestamp: (0, $84a662e1e79b3d35$export$baf075a948ffc0bf) ? (0, $84a662e1e79b3d35$export$baf075a948ffc0bf) / 1000 : undefined,
                    origin: 'auto.pageload.browser',
                    attributes: {
                        [(0, $f0df0dfa824ba468$export$d7a7d984b0791405)]: 'url'
                    }
                };
                $d6a6fa6ad076011d$export$aa44a07f82af519f(client, context);
            }
            if (options.instrumentNavigation && client.emit && (0, $78197c5127b8461c$export$56d8a8a25bd48b81).location) (0, $6a43a9849395fc81$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                /**
           * This early return is there to account for some cases where a navigation transaction starts right after
           * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
           * create an uneccessary navigation transaction.
           *
           * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
           * only be caused in certain development environments where the usage of a hot module reloader is causing
           * errors.
           */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                    startingUrl = undefined;
                    return;
                }
                if (from !== to) {
                    startingUrl = undefined;
                    const context = {
                        name: (0, $78197c5127b8461c$export$56d8a8a25bd48b81).location.pathname,
                        origin: 'auto.navigation.browser',
                        attributes: {
                            [(0, $f0df0dfa824ba468$export$d7a7d984b0791405)]: 'url'
                        }
                    };
                    $d6a6fa6ad076011d$export$7d159749bd9969ad(client, context);
                }
            });
            if (markBackgroundSpan) (0, $8786b8d72de7901f$export$6f18f55521af71a1)();
            if (_experiments.enableInteractions) $d6a6fa6ad076011d$var$registerInteractionListener(options, latestRoute);
            if (options.enableInp) $d6a6fa6ad076011d$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute);
            (0, $fe4bbc9fdfd38efb$export$864489cb3478db3e)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        },
        options: // TODO v8: Remove this again
        // This is private API that we use to fix converted BrowserTracing integrations in Next.js & SvelteKit
        options
    };
};
/**
 * Manually start a page load span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $d6a6fa6ad076011d$export$aa44a07f82af519f(client, spanOptions) {
    if (!client.emit) return;
    client.emit('startPageLoadSpan', spanOptions);
    const span = (0, $289d2b5ef1bc182e$export$1be426a8e585c83e)();
    const op = span && (0, $aab2fced71923915$export$92d8c23565496537)(span).op;
    return op === 'pageload' ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if the BrowserTracing integration has been setup.
 */ function $d6a6fa6ad076011d$export$7d159749bd9969ad(client, spanOptions) {
    if (!client.emit) return;
    client.emit('startNavigationSpan', spanOptions);
    const span = (0, $289d2b5ef1bc182e$export$1be426a8e585c83e)();
    const op = span && (0, $aab2fced71923915$export$92d8c23565496537)(span).op;
    return op === 'navigation' ? span : undefined;
}
/** Returns the value of a meta tag */ function $d6a6fa6ad076011d$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $af122b07f14d085e$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
/** Start listener for interaction transactions */ function $d6a6fa6ad076011d$var$registerInteractionListener(options, latestRoute) {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = ()=>{
        const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = options;
        const op = 'ui.action.click';
        // eslint-disable-next-line deprecation/deprecation
        const currentTransaction = (0, $1893830b8c7873e3$export$a7feb32fdd923295)();
        if (currentTransaction && currentTransaction.op && [
            'navigation',
            'pageload'
        ].includes(currentTransaction.op)) {
            (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
            return undefined;
        }
        if (inflightInteractionTransaction) {
            inflightInteractionTransaction.setFinishReason('interactionInterrupted');
            inflightInteractionTransaction.end();
            inflightInteractionTransaction = undefined;
        }
        if (!latestRoute.name) {
            (0, $e0f1690b3c99f809$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        const { location: location } = (0, $78197c5127b8461c$export$56d8a8a25bd48b81);
        const context = {
            name: latestRoute.name,
            op: op,
            trimEnd: true,
            data: {
                [(0, $f0df0dfa824ba468$export$d7a7d984b0791405)]: latestRoute.context ? $d6a6fa6ad076011d$var$getSource(latestRoute.context) : 'url'
            }
        };
        inflightInteractionTransaction = (0, $8f9c089cc3ec4bb0$export$479dbd817e392a4f)(// eslint-disable-next-line deprecation/deprecation
        (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)(), context, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
    };
    [
        'click'
    ].forEach((type)=>{
        if ((0, $78197c5127b8461c$export$56d8a8a25bd48b81).document) addEventListener(type, registerInteractionTransaction, {
            once: false,
            capture: true
        });
    });
}
function $d6a6fa6ad076011d$var$isPerformanceEventTiming(entry) {
    return 'duration' in entry;
}
/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */ const $d6a6fa6ad076011d$var$MAX_INTERACTIONS = 10;
/** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */ function $d6a6fa6ad076011d$var$registerInpInteractionListener(interactionIdToRouteNameMapping, latestRoute) {
    const handleEntries = ({ entries: entries })=>{
        const client = (0, $a083afa4ea001828$export$6bb76d6eba7e258c)();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client !== undefined && client.getIntegrationByName !== undefined ? client.getIntegrationByName('Replay') : undefined;
        const replayId = replay !== undefined ? replay.getReplayId() : undefined;
        // eslint-disable-next-line deprecation/deprecation
        const activeTransaction = (0, $1893830b8c7873e3$export$a7feb32fdd923295)();
        const currentScope = (0, $a083afa4ea001828$export$c7be4b0125a10cba)();
        const user = currentScope !== undefined ? currentScope.getUser() : undefined;
        entries.forEach((entry)=>{
            if ($d6a6fa6ad076011d$var$isPerformanceEventTiming(entry)) {
                const interactionId = entry.interactionId;
                if (interactionId === undefined) return;
                const existingInteraction = interactionIdToRouteNameMapping[interactionId];
                const duration = entry.duration;
                const startTime = entry.startTime;
                const keys = Object.keys(interactionIdToRouteNameMapping);
                const minInteractionId = keys.length > 0 ? keys.reduce((a, b)=>{
                    return interactionIdToRouteNameMapping[a].duration < interactionIdToRouteNameMapping[b].duration ? a : b;
                }) : undefined;
                // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
                // This is also checked in the web-vitals library.
                if (entry.entryType === 'first-input') {
                    const matchingEntry = keys.map((key)=>interactionIdToRouteNameMapping[key]).some((interaction)=>{
                        return interaction.duration === duration && interaction.startTime === startTime;
                    });
                    if (matchingEntry) return;
                }
                // Interactions with an id of 0 and are not first-input are not valid.
                if (!interactionId) return;
                // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
                if (existingInteraction) existingInteraction.duration = Math.max(existingInteraction.duration, duration);
                else if (keys.length < $d6a6fa6ad076011d$var$MAX_INTERACTIONS || minInteractionId === undefined || duration > interactionIdToRouteNameMapping[minInteractionId].duration) {
                    // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
                    const routeName = latestRoute.name;
                    const parentContext = latestRoute.context;
                    if (routeName && parentContext) {
                        if (minInteractionId && Object.keys(interactionIdToRouteNameMapping).length >= $d6a6fa6ad076011d$var$MAX_INTERACTIONS) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                        delete interactionIdToRouteNameMapping[minInteractionId];
                        interactionIdToRouteNameMapping[interactionId] = {
                            routeName: routeName,
                            duration: duration,
                            parentContext: parentContext,
                            user: user,
                            activeTransaction: activeTransaction,
                            replayId: replayId,
                            startTime: startTime
                        };
                    }
                }
            }
        });
    };
    (0, $b6037ab48997e819$export$69816c1a049f8db6)('event', handleEntries);
    (0, $b6037ab48997e819$export$69816c1a049f8db6)('first-input', handleEntries);
}
function $d6a6fa6ad076011d$var$getSource(context) {
    const sourceFromAttributes = context.attributes && context.attributes[0, $f0df0dfa824ba468$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromData = context.data && context.data[0, $f0df0dfa824ba468$export$d7a7d984b0791405];
    // eslint-disable-next-line deprecation/deprecation
    const sourceFromMetadata = context.metadata && context.metadata.source;
    return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}





















const $85c114b2d9583945$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $85c114b2d9583945$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $85c114b2d9583945$var$_getIngestEndpoint(dsn) {
    return `${$85c114b2d9583945$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $85c114b2d9583945$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $5fc8424b9a9220b6$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $85c114b2d9583945$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $85c114b2d9583945$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$85c114b2d9583945$var$_getIngestEndpoint(dsn)}?${$85c114b2d9583945$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $85c114b2d9583945$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $1e393eba7883271b$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$85c114b2d9583945$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $1e393eba7883271b$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}


/** An error emitted by Sentry SDKs and related utilities. */ class $c480c6cf67fdb869$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}





/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $5c04cfc6aa839a53$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $5c04cfc6aa839a53$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $0d00be936a328b0c$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $1e393eba7883271b$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $0d00be936a328b0c$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $5c04cfc6aa839a53$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $0d00be936a328b0c$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $5c04cfc6aa839a53$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $0d00be936a328b0c$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $0d00be936a328b0c$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}









const $d2899dae8d5c278c$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $d2899dae8d5c278c$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $d2899dae8d5c278c$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $16658314f19f2667$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $d2899dae8d5c278c$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $d2899dae8d5c278c$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $d2899dae8d5c278c$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $d2899dae8d5c278c$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $d2899dae8d5c278c$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $d2899dae8d5c278c$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($d2899dae8d5c278c$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $6b434d742350092c$export$8e4e25f54d456511), (0, $4f329577679e8bfc$export$a07cdf6544bbd7c));
        $d2899dae8d5c278c$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = (event, hint)=>callback(event, hint, client);
        processor.id = integration.name;
        client.addEventProcessor(processor);
    }
    (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $d2899dae8d5c278c$export$2d8f5188773bcddd(integration) {
    const client = (0, $a083afa4ea001828$export$6bb76d6eba7e258c)();
    if (!client || !client.addIntegration) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $d2899dae8d5c278c$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $d2899dae8d5c278c$export$afa219bf23651160(name, fn) {
    const ConvertedIntegration = function ConvertedIntegration(...args) {
        return fn(...args);
    };
    ConvertedIntegration.id = name;
    return ConvertedIntegration;
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $d2899dae8d5c278c$export$2323046b9414659f(fn) {
    return fn;
}




/**
 * Generate bucket key from metric properties.
 */ function $052e912a97c8b3bc$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $5fc8424b9a9220b6$export$d25f2688db1bb433)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $052e912a97c8b3bc$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $052e912a97c8b3bc$export$66decd709db01dc8(metricBucketItems) {
    let out = '';
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(',')}` : '';
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $052e912a97c8b3bc$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $052e912a97c8b3bc$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $052e912a97c8b3bc$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
const $052e912a97c8b3bc$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        "\\u{7c}"
    ],
    [
        ',',
        "\\u{2c}"
    ]
];
function $052e912a97c8b3bc$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $052e912a97c8b3bc$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $052e912a97c8b3bc$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $052e912a97c8b3bc$var$getCharOrReplacement(char), '');
}
/**
 * Sanitizes tags.
 */ function $052e912a97c8b3bc$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $052e912a97c8b3bc$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $052e912a97c8b3bc$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}


/**
 * Create envelope from a metric aggregate.
 */ function $ac02c0b2c43ea83f$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $1e393eba7883271b$export$44d472fbb931a776)(dsn);
    const item = $ac02c0b2c43ea83f$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $0d00be936a328b0c$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $ac02c0b2c43ea83f$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $052e912a97c8b3bc$export$66decd709db01dc8)(metricBucketItems);
    const metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}





const $5211a9243d8f7dc3$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $5211a9243d8f7dc3$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $1e393eba7883271b$export$128827c3562ec0cb)(options.dsn);
        else (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $85c114b2d9583945$export$9964600bfe84e6a3)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $16658314f19f2667$export$6de4ffac6a2f1098)(exception)) {
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log($5211a9243d8f7dc3$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $b7010123686726b5$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $b7010123686726b5$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $16658314f19f2667$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log($5211a9243d8f7dc3$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $e1dac6cf3290cee3$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $e9a504b129d49702$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $d2899dae8d5c278c$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $d2899dae8d5c278c$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $5c04cfc6aa839a53$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $0d00be936a328b0c$export$d650323442802f6f)(env, (0, $0d00be936a328b0c$export$d8fc80952cc31fa4)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $5c04cfc6aa839a53$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $ac02c0b2c43ea83f$export$f23eb96e33154901)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $d2899dae8d5c278c$export$51abed9797baa598)(this, integrations);
        (0, $d2899dae8d5c278c$export$35abcfd71227c6ca)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $e1dac6cf3290cee3$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $e9a504b129d49702$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $4f329577679e8bfc$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        return (0, $82acf6f7315dcebb$export$2d67fb380bd11267)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $3148374da480247a$export$366bad00d6815eed)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $83ab00052d3c52cd$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $5211a9243d8f7dc3$var$isTransactionEvent(event);
        const isError = $5211a9243d8f7dc3$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $e9a504b129d49702$export$78e43115b553f358)(new (0, $c480c6cf67fdb869$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $c480c6cf67fdb869$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $5211a9243d8f7dc3$var$processBeforeSend(options, prepared, hint);
            return $5211a9243d8f7dc3$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $c480c6cf67fdb869$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $c480c6cf67fdb869$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $c480c6cf67fdb869$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).error('Error while sending event:', reason);
        });
        else (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $5211a9243d8f7dc3$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $b7010123686726b5$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $b7010123686726b5$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $c480c6cf67fdb869$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $c480c6cf67fdb869$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $b7010123686726b5$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $c480c6cf67fdb869$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $5211a9243d8f7dc3$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($5211a9243d8f7dc3$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($5211a9243d8f7dc3$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $5211a9243d8f7dc3$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $5211a9243d8f7dc3$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $5211a9243d8f7dc3$export$9aac0b9f77928fbf(callback) {
    const client = (0, $a083afa4ea001828$export$6bb76d6eba7e258c)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}







/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $644de0aa83844470$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $83ab00052d3c52cd$export$16a28057038b10ef) (0, $a517e3a601d07c96$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $a517e3a601d07c96$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $a083afa4ea001828$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $644de0aa83844470$export$ecb76f41d43c0e43(client);
    $644de0aa83844470$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $644de0aa83844470$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $644de0aa83844470$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $4cc8ada279a36799$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $4cc8ada279a36799$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $4cc8ada279a36799$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $4cc8ada279a36799$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $4cc8ada279a36799$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $4cc8ada279a36799$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $4cc8ada279a36799$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $4cc8ada279a36799$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $f134c960949a1a20$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $e9a504b129d49702$export$78e43115b553f358)(new (0, $c480c6cf67fdb869$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $e9a504b129d49702$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $e9a504b129d49702$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $5d3d72553afab172$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $5d3d72553afab172$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $f134c960949a1a20$export$85a4f67f852183e6)(options.bufferSize || $5d3d72553afab172$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $0d00be936a328b0c$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $0d00be936a328b0c$export$b11169581eeaf237)(type);
            if ((0, $4cc8ada279a36799$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $5d3d72553afab172$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $e9a504b129d49702$export$1fda8aa4d135f8aa)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $0d00be936a328b0c$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $0d00be936a328b0c$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $5d3d72553afab172$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $0d00be936a328b0c$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $0d00be936a328b0c$export$32f9b428425aac85)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $4cc8ada279a36799$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $c480c6cf67fdb869$export$5949942ba2a7c0e2)) {
                (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $e9a504b129d49702$export$1fda8aa4d135f8aa)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $5d3d72553afab172$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

















/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $e2a31acd691f5e55$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $142b56b04b94e12c$export$31499a9cd224b78c)
            })),
        version: (0, $142b56b04b94e12c$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}








// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $79ec360d5c555f55$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $79ec360d5c555f55$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $79ec360d5c555f55$var$INTEGRATION_NAME = 'InboundFilters';
const $79ec360d5c555f55$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $79ec360d5c555f55$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $79ec360d5c555f55$var$_mergeOptions(options, clientOptions);
            return $79ec360d5c555f55$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $79ec360d5c555f55$export$cb3c5c2ceb9818ba = (0, $d2899dae8d5c278c$export$2323046b9414659f)($79ec360d5c555f55$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $79ec360d5c555f55$export$2ffbb5359dcc6be4 = (0, $d2899dae8d5c278c$export$afa219bf23651160)($79ec360d5c555f55$var$INTEGRATION_NAME, $79ec360d5c555f55$export$cb3c5c2ceb9818ba);
function $79ec360d5c555f55$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $79ec360d5c555f55$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $79ec360d5c555f55$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $79ec360d5c555f55$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $79ec360d5c555f55$var$_isSentryError(event)) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $16658314f19f2667$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($79ec360d5c555f55$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $16658314f19f2667$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($79ec360d5c555f55$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $16658314f19f2667$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($79ec360d5c555f55$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $16658314f19f2667$export$4157119e2b157127)(event)}.\nUrl: ${$79ec360d5c555f55$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$79ec360d5c555f55$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $16658314f19f2667$export$4157119e2b157127)(event)}.\nUrl: ${$79ec360d5c555f55$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $79ec360d5c555f55$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $79ec360d5c555f55$var$_getPossibleEventMessages(event).some((message)=>(0, $a1ee7577f9dd9008$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $79ec360d5c555f55$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $a1ee7577f9dd9008$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $79ec360d5c555f55$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $79ec360d5c555f55$var$_getEventFilterUrl(event);
    return !url ? false : (0, $a1ee7577f9dd9008$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $79ec360d5c555f55$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $79ec360d5c555f55$var$_getEventFilterUrl(event);
    return !url ? true : (0, $a1ee7577f9dd9008$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $79ec360d5c555f55$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $83ab00052d3c52cd$export$16a28057038b10ef) && possibleMessages.length === 0) (0, $a517e3a601d07c96$export$af88d00dbe7f521).error(`Could not extract message for event ${(0, $16658314f19f2667$export$4157119e2b157127)(event)}`);
    return possibleMessages;
}
function $79ec360d5c555f55$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $79ec360d5c555f55$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $79ec360d5c555f55$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $79ec360d5c555f55$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $83ab00052d3c52cd$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $16658314f19f2667$export$4157119e2b157127)(event)}`);
        return null;
    }
}





let $1d95bc9e9b34d87b$var$originalFunctionToString;
const $1d95bc9e9b34d87b$var$INTEGRATION_NAME = 'FunctionToString';
const $1d95bc9e9b34d87b$var$SETUP_CLIENTS = new WeakMap();
const $1d95bc9e9b34d87b$var$_functionToStringIntegration = ()=>{
    return {
        name: $1d95bc9e9b34d87b$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $1d95bc9e9b34d87b$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $5fc8424b9a9220b6$export$e6cc1e135e2092e5)(this);
                    const context = $1d95bc9e9b34d87b$var$SETUP_CLIENTS.has((0, $a083afa4ea001828$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $1d95bc9e9b34d87b$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $1d95bc9e9b34d87b$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $1d95bc9e9b34d87b$export$7918117e9202e4fb = (0, $d2899dae8d5c278c$export$2323046b9414659f)($1d95bc9e9b34d87b$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $1d95bc9e9b34d87b$export$da4704525c20ae79 = (0, $d2899dae8d5c278c$export$afa219bf23651160)($1d95bc9e9b34d87b$var$INTEGRATION_NAME, $1d95bc9e9b34d87b$export$7918117e9202e4fb);



var $e215e19b7fca42ab$exports = {};

$parcel$export($e215e19b7fca42ab$exports, "FunctionToString", () => $1d95bc9e9b34d87b$export$da4704525c20ae79);
$parcel$export($e215e19b7fca42ab$exports, "InboundFilters", () => $79ec360d5c555f55$export$2ffbb5359dcc6be4);
$parcel$export($e215e19b7fca42ab$exports, "LinkedErrors", () => $4aff5e732631c9ab$export$8d1e60aaf616fb4f);




/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $07ac725e31261b9e$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $b7010123686726b5$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $07ac725e31261b9e$var$truncateAggregateExceptions($07ac725e31261b9e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $07ac725e31261b9e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $b7010123686726b5$export$49034edbe6b62415)(error[key], Error)) {
        $07ac725e31261b9e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $07ac725e31261b9e$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $07ac725e31261b9e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $b7010123686726b5$export$49034edbe6b62415)(childError, Error)) {
            $07ac725e31261b9e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $07ac725e31261b9e$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $07ac725e31261b9e$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $07ac725e31261b9e$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $07ac725e31261b9e$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $07ac725e31261b9e$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $a1ee7577f9dd9008$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}





/**
 * Extracts stack frames from the error.stack string
 */ function $bda519d22c465f27$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $bda519d22c465f27$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $bda519d22c465f27$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $bda519d22c465f27$var$getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        let message = `'${exception.name}' captured as exception`;
        if ('message' in exception && typeof exception.message === 'string') message += ` with message '${exception.message}'`;
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $5fc8424b9a9220b6$export$b0244d5063c0b61b)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $bda519d22c465f27$export$9dd56ed1ef0c3420(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === 'function' ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    let extras;
    if (!(0, $b7010123686726b5$export$e6127cc7fe7395c3)(exception)) {
        if ((0, $b7010123686726b5$export$53b83ca8eaab0383)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ['__serialized__']: (0, $707bc16f15b0ab27$export$23fbbb20bed71033)(exception, normalizeDepth)
            };
            const message = $bda519d22c465f27$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $bda519d22c465f27$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $16658314f19f2667$export$f26508487bf83ee7)(event, undefined, undefined);
    (0, $16658314f19f2667$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $bda519d22c465f27$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $bda519d22c465f27$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $b7010123686726b5$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}



const $4aff5e732631c9ab$var$DEFAULT_KEY = 'cause';
const $4aff5e732631c9ab$var$DEFAULT_LIMIT = 5;
const $4aff5e732631c9ab$var$INTEGRATION_NAME = 'LinkedErrors';
const $4aff5e732631c9ab$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $4aff5e732631c9ab$var$DEFAULT_LIMIT;
    const key = options.key || $4aff5e732631c9ab$var$DEFAULT_KEY;
    return {
        name: $4aff5e732631c9ab$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $07ac725e31261b9e$export$b91c38ed7d8ae9b2)((0, $bda519d22c465f27$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $4aff5e732631c9ab$export$ebabb00eb7f3a395 = (0, $d2899dae8d5c278c$export$2323046b9414659f)($4aff5e732631c9ab$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $4aff5e732631c9ab$export$8d1e60aaf616fb4f = (0, $d2899dae8d5c278c$export$afa219bf23651160)($4aff5e732631c9ab$var$INTEGRATION_NAME, $4aff5e732631c9ab$export$ebabb00eb7f3a395);


 /* eslint-disable deprecation/deprecation */ 


/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $0a37df6e7e572621$export$99d02219d259eb94 = $e215e19b7fca42ab$exports;





const $c9afe9d8c8ac1088$export$56d8a8a25bd48b81 = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1);
let $c9afe9d8c8ac1088$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $c9afe9d8c8ac1088$export$b79738ab10c590b2() {
    return $c9afe9d8c8ac1088$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $c9afe9d8c8ac1088$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $c9afe9d8c8ac1088$var$ignoreOnError++;
    setTimeout(()=>{
        $c9afe9d8c8ac1088$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $c9afe9d8c8ac1088$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $5fc8424b9a9220b6$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$c9afe9d8c8ac1088$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $c9afe9d8c8ac1088$export$1265a142ff5ba165();
            (0, $a083afa4ea001828$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $16658314f19f2667$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $16658314f19f2667$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $a083afa4ea001828$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $5fc8424b9a9220b6$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $5fc8424b9a9220b6$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}













/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $87ebe10a9acced64$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $84a662e1e79b3d35$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $0d00be936a328b0c$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $899ff881802851dc$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $899ff881802851dc$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $f06c3b18cffc2adf$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;




/**
 * This function creates an exception from a JavaScript Error
 */ function $3f9c8056ce573ac8$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $3f9c8056ce573ac8$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $3f9c8056ce573ac8$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $3f9c8056ce573ac8$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $a083afa4ea001828$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $b7010123686726b5$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $3f9c8056ce573ac8$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $707bc16f15b0ab27$export$23fbbb20bed71033)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $3f9c8056ce573ac8$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $3f9c8056ce573ac8$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $3f9c8056ce573ac8$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $3f9c8056ce573ac8$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $3f9c8056ce573ac8$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $3f9c8056ce573ac8$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $3f9c8056ce573ac8$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($3f9c8056ce573ac8$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $3f9c8056ce573ac8$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $3f9c8056ce573ac8$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $3f9c8056ce573ac8$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $16658314f19f2667$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $e9a504b129d49702$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $3f9c8056ce573ac8$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $3f9c8056ce573ac8$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $e9a504b129d49702$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $3f9c8056ce573ac8$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $b7010123686726b5$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $3f9c8056ce573ac8$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $b7010123686726b5$export$ef9e2056653f0c8e)(exception) || (0, $b7010123686726b5$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $3f9c8056ce573ac8$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $b7010123686726b5$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $3f9c8056ce573ac8$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $16658314f19f2667$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $b7010123686726b5$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $3f9c8056ce573ac8$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $b7010123686726b5$export$53b83ca8eaab0383)(exception) || (0, $b7010123686726b5$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $3f9c8056ce573ac8$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $16658314f19f2667$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $3f9c8056ce573ac8$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $16658314f19f2667$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $16658314f19f2667$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $3f9c8056ce573ac8$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $3f9c8056ce573ac8$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $b7010123686726b5$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $3f9c8056ce573ac8$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $5fc8424b9a9220b6$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $b7010123686726b5$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $b7010123686726b5$export$9671ea99bd126ace)(exception)) {
        const className = $3f9c8056ce573ac8$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $3f9c8056ce573ac8$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}




/**
 * Creates an envelope from a user feedback.
 */ function $50a128d3babf898d$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $1e393eba7883271b$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $50a128d3babf898d$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $0d00be936a328b0c$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $50a128d3babf898d$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $13f9358651f6e3b1$export$1df9218a526d318d extends (0, $5211a9243d8f7dc3$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $899ff881802851dc$export$8ad33f488b1ab046)();
        (0, $e2a31acd691f5e55$export$b9f95b027256052c)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).document) (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $3f9c8056ce573ac8$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $3f9c8056ce573ac8$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $f06c3b18cffc2adf$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $50a128d3babf898d$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $f06c3b18cffc2adf$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $f06c3b18cffc2adf$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $f06c3b18cffc2adf$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $87ebe10a9acced64$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $1e393eba7883271b$export$44d472fbb931a776)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}









const $adc558bb2d6d5a56$var$WINDOW = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1);
const $adc558bb2d6d5a56$var$DEBOUNCE_DURATION = 1000;
let $adc558bb2d6d5a56$var$debounceTimerID;
let $adc558bb2d6d5a56$var$lastCapturedEventType;
let $adc558bb2d6d5a56$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $adc558bb2d6d5a56$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $e741ef5864ec0e99$export$a4e09611e30da72e)(type, handler);
    (0, $e741ef5864ec0e99$export$e18d6c5462c01368)(type, $adc558bb2d6d5a56$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $adc558bb2d6d5a56$export$3014bbf0af0e1d4a() {
    if (!$adc558bb2d6d5a56$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $e741ef5864ec0e99$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $adc558bb2d6d5a56$var$makeDOMEventHandler(triggerDOMHandler, true);
    $adc558bb2d6d5a56$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $adc558bb2d6d5a56$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $adc558bb2d6d5a56$var$WINDOW[target] && $adc558bb2d6d5a56$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $adc558bb2d6d5a56$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $adc558bb2d6d5a56$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $adc558bb2d6d5a56$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $adc558bb2d6d5a56$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $adc558bb2d6d5a56$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $adc558bb2d6d5a56$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $adc558bb2d6d5a56$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($adc558bb2d6d5a56$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $5fc8424b9a9220b6$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $5fc8424b9a9220b6$export$e73679ffaf56810e)(target, '_sentryId', (0, $16658314f19f2667$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$adc558bb2d6d5a56$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $adc558bb2d6d5a56$var$lastCapturedEventType = event.type;
            $adc558bb2d6d5a56$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($adc558bb2d6d5a56$var$debounceTimerID);
        $adc558bb2d6d5a56$var$debounceTimerID = $adc558bb2d6d5a56$var$WINDOW.setTimeout(()=>{
            $adc558bb2d6d5a56$var$lastCapturedEventTargetId = undefined;
            $adc558bb2d6d5a56$var$lastCapturedEventType = undefined;
        }, $adc558bb2d6d5a56$var$DEBOUNCE_DURATION);
    };
}
function $adc558bb2d6d5a56$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $83d2886f3b0af85b$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $e741ef5864ec0e99$export$a4e09611e30da72e)(type, handler);
    (0, $e741ef5864ec0e99$export$e18d6c5462c01368)(type, $83d2886f3b0af85b$var$instrumentConsole);
}
function $83d2886f3b0af85b$var$instrumentConsole() {
    if (!('console' in (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1))) return;
    (0, $a517e3a601d07c96$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).console)) return;
        (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)((0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $a517e3a601d07c96$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $e741ef5864ec0e99$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $a517e3a601d07c96$export$77c4ce905194557b)[level];
                log && log.apply((0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $ad27243b5c022272$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $ad27243b5c022272$export$e01cef29b4327697(level) {
    return $ad27243b5c022272$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $ad27243b5c022272$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $ad27243b5c022272$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}




/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $c98aa43acc50aa38$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $c98aa43acc50aa38$var$INTEGRATION_NAME = 'Breadcrumbs';
const $c98aa43acc50aa38$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $c98aa43acc50aa38$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $83d2886f3b0af85b$export$1d6e0d073f9e6723)($c98aa43acc50aa38$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $adc558bb2d6d5a56$export$5aeffd3db2cf9df7)($c98aa43acc50aa38$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $863863c1afe54d74$export$26ace48dd54c9aea)($c98aa43acc50aa38$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $c3de2a70914e0e21$export$f75d3c772c923df0)($c98aa43acc50aa38$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $6a43a9849395fc81$export$3f18c56c58114e75)($c98aa43acc50aa38$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $c98aa43acc50aa38$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $c98aa43acc50aa38$export$c079d904b326663a = (0, $d2899dae8d5c278c$export$2323046b9414659f)($c98aa43acc50aa38$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $c98aa43acc50aa38$export$2dc68d50d56fbbd = (0, $d2899dae8d5c278c$export$afa219bf23651160)($c98aa43acc50aa38$var$INTEGRATION_NAME, $c98aa43acc50aa38$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $c98aa43acc50aa38$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $a083afa4ea001828$export$6bb76d6eba7e258c)() !== client) return;
        (0, $a083afa4ea001828$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $16658314f19f2667$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $c98aa43acc50aa38$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $a083afa4ea001828$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $c98aa43acc50aa38$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $f06c3b18cffc2adf$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$c98aa43acc50aa38$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$c98aa43acc50aa38$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $c98aa43acc50aa38$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $c98aa43acc50aa38$var$_isEvent(event) ? event.target : event;
            target = (0, $af122b07f14d085e$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $af122b07f14d085e$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $a083afa4ea001828$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $c98aa43acc50aa38$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $a083afa4ea001828$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $ad27243b5c022272$export$d771ef054122c30a)(handlerData.level),
            message: (0, $a1ee7577f9dd9008$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $a1ee7577f9dd9008$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $a083afa4ea001828$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $c98aa43acc50aa38$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $a083afa4ea001828$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $863863c1afe54d74$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $a083afa4ea001828$export$efda9a273d7a036d)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $c98aa43acc50aa38$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $a083afa4ea001828$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $a083afa4ea001828$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $a083afa4ea001828$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $c98aa43acc50aa38$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $a083afa4ea001828$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $f5cc7285b77fbeb7$export$7a5253c0f62e0150)((0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $f5cc7285b77fbeb7$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $f5cc7285b77fbeb7$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $a083afa4ea001828$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $c98aa43acc50aa38$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $fe1d3eae00133340$var$INTEGRATION_NAME = 'Dedupe';
const $fe1d3eae00133340$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $fe1d3eae00133340$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($fe1d3eae00133340$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $f06c3b18cffc2adf$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $fe1d3eae00133340$export$6d39aa44cd0c7567 = (0, $d2899dae8d5c278c$export$2323046b9414659f)($fe1d3eae00133340$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $fe1d3eae00133340$export$688d98c249d31ad3 = (0, $d2899dae8d5c278c$export$afa219bf23651160)($fe1d3eae00133340$var$INTEGRATION_NAME, $fe1d3eae00133340$export$6d39aa44cd0c7567);
function $fe1d3eae00133340$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($fe1d3eae00133340$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($fe1d3eae00133340$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $fe1d3eae00133340$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$fe1d3eae00133340$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fe1d3eae00133340$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $fe1d3eae00133340$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $fe1d3eae00133340$var$_getExceptionFromEvent(previousEvent);
    const currentException = $fe1d3eae00133340$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$fe1d3eae00133340$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$fe1d3eae00133340$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $fe1d3eae00133340$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $fe1d3eae00133340$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $fe1d3eae00133340$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $fe1d3eae00133340$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $fe1d3eae00133340$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $fe1d3eae00133340$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}







/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $087d3ed193cd5eed$var$INTEGRATION_NAME = 'GlobalHandlers';
const $087d3ed193cd5eed$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $087d3ed193cd5eed$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $087d3ed193cd5eed$var$_installGlobalOnErrorHandler(client);
                $087d3ed193cd5eed$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $087d3ed193cd5eed$var$_installGlobalOnUnhandledRejectionHandler(client);
                $087d3ed193cd5eed$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $087d3ed193cd5eed$export$66acc70e8cf2b71a = (0, $d2899dae8d5c278c$export$2323046b9414659f)($087d3ed193cd5eed$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $087d3ed193cd5eed$export$204155decbc90e5a = (0, $d2899dae8d5c278c$export$afa219bf23651160)($087d3ed193cd5eed$var$INTEGRATION_NAME, $087d3ed193cd5eed$export$66acc70e8cf2b71a);
function $087d3ed193cd5eed$var$_installGlobalOnErrorHandler(client) {
    (0, $b7c8efd259d71395$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $087d3ed193cd5eed$var$getOptions();
        if ((0, $a083afa4ea001828$export$6bb76d6eba7e258c)() !== client || (0, $c9afe9d8c8ac1088$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $b7010123686726b5$export$844ec244b1367d54)(msg) ? $087d3ed193cd5eed$var$_eventFromIncompleteOnError(msg, url, line, column) : $087d3ed193cd5eed$var$_enhanceEventWithInitialFrame((0, $3f9c8056ce573ac8$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $a083afa4ea001828$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $087d3ed193cd5eed$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $e3143df0f0a958d2$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $087d3ed193cd5eed$var$getOptions();
        if ((0, $a083afa4ea001828$export$6bb76d6eba7e258c)() !== client || (0, $c9afe9d8c8ac1088$export$b79738ab10c590b2)()) return;
        const error = $087d3ed193cd5eed$var$_getUnhandledRejectionError(e);
        const event = (0, $b7010123686726b5$export$c3825b437cbdea5c)(error) ? $087d3ed193cd5eed$var$_eventFromRejectionWithPrimitive(error) : (0, $3f9c8056ce573ac8$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $a083afa4ea001828$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $087d3ed193cd5eed$var$_getUnhandledRejectionError(error) {
    if ((0, $b7010123686726b5$export$c3825b437cbdea5c)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $087d3ed193cd5eed$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $087d3ed193cd5eed$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $b7010123686726b5$export$9f9636d330b71954)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $087d3ed193cd5eed$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $087d3ed193cd5eed$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $b7010123686726b5$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $af122b07f14d085e$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $087d3ed193cd5eed$var$globalHandlerLog(type) {
    (0, $f06c3b18cffc2adf$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $087d3ed193cd5eed$var$getOptions() {
    const client = (0, $a083afa4ea001828$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




const $52f69d203ea78033$var$INTEGRATION_NAME = 'HttpContext';
const $52f69d203ea78033$var$_httpContextIntegration = ()=>{
    return {
        name: $52f69d203ea78033$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).navigator && !(0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).location && !(0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).location && (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $52f69d203ea78033$export$1378794447170364 = (0, $d2899dae8d5c278c$export$2323046b9414659f)($52f69d203ea78033$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $52f69d203ea78033$export$5d2ee9a544b09a94 = (0, $d2899dae8d5c278c$export$afa219bf23651160)($52f69d203ea78033$var$INTEGRATION_NAME, $52f69d203ea78033$export$1378794447170364);





const $6100b9754a6525a8$var$DEFAULT_KEY = 'cause';
const $6100b9754a6525a8$var$DEFAULT_LIMIT = 5;
const $6100b9754a6525a8$var$INTEGRATION_NAME = 'LinkedErrors';
const $6100b9754a6525a8$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $6100b9754a6525a8$var$DEFAULT_LIMIT;
    const key = options.key || $6100b9754a6525a8$var$DEFAULT_KEY;
    return {
        name: $6100b9754a6525a8$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $07ac725e31261b9e$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $3f9c8056ce573ac8$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $6100b9754a6525a8$export$ebabb00eb7f3a395 = (0, $d2899dae8d5c278c$export$2323046b9414659f)($6100b9754a6525a8$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $6100b9754a6525a8$export$8d1e60aaf616fb4f = (0, $d2899dae8d5c278c$export$afa219bf23651160)($6100b9754a6525a8$var$INTEGRATION_NAME, $6100b9754a6525a8$export$ebabb00eb7f3a395);





const $331ada05aa26d824$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $331ada05aa26d824$var$INTEGRATION_NAME = 'TryCatch';
const $331ada05aa26d824$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $331ada05aa26d824$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)((0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81), 'setTimeout', $331ada05aa26d824$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)((0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81), 'setInterval', $331ada05aa26d824$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)((0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81), 'requestAnimationFrame', $331ada05aa26d824$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81)) (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $331ada05aa26d824$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $331ada05aa26d824$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($331ada05aa26d824$var$_wrapEventTarget);
            }
        }
    };
};
const $331ada05aa26d824$export$59bfe9f1c76150e = (0, $d2899dae8d5c278c$export$2323046b9414659f)($331ada05aa26d824$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $331ada05aa26d824$export$f1a018517668e6d3 = (0, $d2899dae8d5c278c$export$afa219bf23651160)($331ada05aa26d824$var$INTEGRATION_NAME, $331ada05aa26d824$export$59bfe9f1c76150e);
function $331ada05aa26d824$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $c9afe9d8c8ac1088$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $78e6ecc0f4af74a8$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $331ada05aa26d824$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $c9afe9d8c8ac1088$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $78e6ecc0f4af74a8$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $331ada05aa26d824$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $78e6ecc0f4af74a8$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $5fc8424b9a9220b6$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $78e6ecc0f4af74a8$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $c9afe9d8c8ac1088$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $331ada05aa26d824$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $c9afe9d8c8ac1088$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $78e6ecc0f4af74a8$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $c9afe9d8c8ac1088$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $78e6ecc0f4af74a8$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $5fc8424b9a9220b6$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}



// global reference to slice
const $398967feca925b2b$var$UNKNOWN_FUNCTION = '?';
const $398967feca925b2b$var$OPERA10_PRIORITY = 10;
const $398967feca925b2b$var$OPERA11_PRIORITY = 20;
const $398967feca925b2b$var$CHROME_PRIORITY = 30;
const $398967feca925b2b$var$WINJS_PRIORITY = 40;
const $398967feca925b2b$var$GECKO_PRIORITY = 50;
function $398967feca925b2b$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $398967feca925b2b$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $398967feca925b2b$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $398967feca925b2b$var$chromeStackParserFn = (line)=>{
    const parts = $398967feca925b2b$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $398967feca925b2b$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $398967feca925b2b$var$extractSafariExtensionDetails(parts[1] || $398967feca925b2b$var$UNKNOWN_FUNCTION, parts[2]);
        return $398967feca925b2b$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $398967feca925b2b$export$263a749fff749872 = [
    $398967feca925b2b$var$CHROME_PRIORITY,
    $398967feca925b2b$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $398967feca925b2b$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $398967feca925b2b$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $398967feca925b2b$var$gecko = (line)=>{
    const parts = $398967feca925b2b$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $398967feca925b2b$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $398967feca925b2b$var$UNKNOWN_FUNCTION;
        [func, filename] = $398967feca925b2b$var$extractSafariExtensionDetails(func, filename);
        return $398967feca925b2b$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $398967feca925b2b$export$cdba47a5dd2804d = [
    $398967feca925b2b$var$GECKO_PRIORITY,
    $398967feca925b2b$var$gecko
];
const $398967feca925b2b$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $398967feca925b2b$var$winjs = (line)=>{
    const parts = $398967feca925b2b$var$winjsRegex.exec(line);
    return parts ? $398967feca925b2b$var$createFrame(parts[2], parts[1] || $398967feca925b2b$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $398967feca925b2b$export$179460296da408e8 = [
    $398967feca925b2b$var$WINJS_PRIORITY,
    $398967feca925b2b$var$winjs
];
const $398967feca925b2b$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $398967feca925b2b$var$opera10 = (line)=>{
    const parts = $398967feca925b2b$var$opera10Regex.exec(line);
    return parts ? $398967feca925b2b$var$createFrame(parts[2], parts[3] || $398967feca925b2b$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $398967feca925b2b$export$f892b52c880ffc7a = [
    $398967feca925b2b$var$OPERA10_PRIORITY,
    $398967feca925b2b$var$opera10
];
const $398967feca925b2b$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $398967feca925b2b$var$opera11 = (line)=>{
    const parts = $398967feca925b2b$var$opera11Regex.exec(line);
    return parts ? $398967feca925b2b$var$createFrame(parts[5], parts[3] || parts[4] || $398967feca925b2b$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $398967feca925b2b$export$af11af13f09fb0dc = [
    $398967feca925b2b$var$OPERA11_PRIORITY,
    $398967feca925b2b$var$opera11
];
const $398967feca925b2b$export$7197c0fe6554c079 = [
    $398967feca925b2b$export$263a749fff749872,
    $398967feca925b2b$export$cdba47a5dd2804d,
    $398967feca925b2b$export$179460296da408e8
];
const $398967feca925b2b$export$2b2b997d81bf3907 = (0, $78e6ecc0f4af74a8$export$a5739666fb2d03d4)(...$398967feca925b2b$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $398967feca925b2b$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $398967feca925b2b$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};







let $60ad4f24149bdf13$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $60ad4f24149bdf13$export$8be2119ce08e3379() {
    if ($60ad4f24149bdf13$var$cachedFetchImpl) return $60ad4f24149bdf13$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $026891edde5f38fb$export$18cf36ed71d733e7)((0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).fetch)) return $60ad4f24149bdf13$var$cachedFetchImpl = (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).fetch.bind((0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81));
    const document = (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).document;
    let fetchImpl = (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $f06c3b18cffc2adf$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $60ad4f24149bdf13$var$cachedFetchImpl = fetchImpl.bind((0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $60ad4f24149bdf13$export$d499686d2dd738c6() {
    $60ad4f24149bdf13$var$cachedFetchImpl = undefined;
}


/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $03bb242edee22741$export$b2311068c46d7cc8(options, nativeFetch = (0, $60ad4f24149bdf13$export$8be2119ce08e3379)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $60ad4f24149bdf13$export$d499686d2dd738c6)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $e9a504b129d49702$export$78e43115b553f358)(e);
        }
    }
    return (0, $5d3d72553afab172$export$d09f50d9ab7f7b69)(options, makeRequest);
}




/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $76fc7c39c04662fc$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $76fc7c39c04662fc$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $e9a504b129d49702$export$6f292d4960313241)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $76fc7c39c04662fc$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $5d3d72553afab172$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $f0865bfe40ae41c1$export$5ef831fccfce35e5 = [
    (0, $79ec360d5c555f55$export$cb3c5c2ceb9818ba)(),
    (0, $1d95bc9e9b34d87b$export$7918117e9202e4fb)(),
    (0, $331ada05aa26d824$export$59bfe9f1c76150e)(),
    (0, $c98aa43acc50aa38$export$c079d904b326663a)(),
    (0, $087d3ed193cd5eed$export$66acc70e8cf2b71a)(),
    (0, $6100b9754a6525a8$export$ebabb00eb7f3a395)(),
    (0, $fe1d3eae00133340$export$6d39aa44cd0c7567)(),
    (0, $52f69d203ea78033$export$1378794447170364)()
];
/** Get the default integrations for the browser SDK. */ function $f0865bfe40ae41c1$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$f0865bfe40ae41c1$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $f0865bfe40ae41c1$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $f0865bfe40ae41c1$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).SENTRY_RELEASE.id) options.release = (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $78e6ecc0f4af74a8$export$1d5cf88b347146d4)(options.stackParser || (0, $398967feca925b2b$export$2b2b997d81bf3907)),
        integrations: (0, $d2899dae8d5c278c$export$68bc4c01ab8ae766)(options),
        transport: options.transport || ((0, $026891edde5f38fb$export$edf3cb81fd7d2a3e)() ? (0, $03bb242edee22741$export$b2311068c46d7cc8) : (0, $76fc7c39c04662fc$export$5e1441cee30d5a39))
    };
    (0, $644de0aa83844470$export$5333c3f1c58d9bc1)((0, $13f9358651f6e3b1$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $f0865bfe40ae41c1$var$startSessionTracking();
}
const $f0865bfe40ae41c1$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $4f329577679e8bfc$export$a07cdf6544bbd7c)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).document) {
        (0, $f06c3b18cffc2adf$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $f06c3b18cffc2adf$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $85c114b2d9583945$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).document.head || (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $f06c3b18cffc2adf$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $f0865bfe40ae41c1$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $f0865bfe40ae41c1$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f0865bfe40ae41c1$export$4997ffc0176396a6(fn) {
    return (0, $c9afe9d8c8ac1088$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $f0865bfe40ae41c1$var$startSessionTracking() {
    if (typeof (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).document === 'undefined') {
        (0, $f06c3b18cffc2adf$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $a083afa4ea001828$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $a083afa4ea001828$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $6a43a9849395fc81$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $a083afa4ea001828$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $a083afa4ea001828$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $f0865bfe40ae41c1$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $a083afa4ea001828$export$6bb76d6eba7e258c)();
    if (client) client.captureUserFeedback(feedback);
}








var $5d365e2adfa4cb4c$exports = {};

$parcel$export($5d365e2adfa4cb4c$exports, "GlobalHandlers", () => $087d3ed193cd5eed$export$204155decbc90e5a);
$parcel$export($5d365e2adfa4cb4c$exports, "TryCatch", () => $331ada05aa26d824$export$f1a018517668e6d3);
$parcel$export($5d365e2adfa4cb4c$exports, "Breadcrumbs", () => $c98aa43acc50aa38$export$2dc68d50d56fbbd);
$parcel$export($5d365e2adfa4cb4c$exports, "LinkedErrors", () => $6100b9754a6525a8$export$8d1e60aaf616fb4f);
$parcel$export($5d365e2adfa4cb4c$exports, "HttpContext", () => $52f69d203ea78033$export$5d2ee9a544b09a94);
$parcel$export($5d365e2adfa4cb4c$exports, "Dedupe", () => $fe1d3eae00133340$export$688d98c249d31ad3);






 /* eslint-disable deprecation/deprecation */ 









let $9bfe741b66e09b2c$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
if ((0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).Sentry && (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).Sentry.Integrations) $9bfe741b66e09b2c$var$windowIntegrations = (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).Sentry.Integrations;
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $9bfe741b66e09b2c$export$99d02219d259eb94 = {
    ...$9bfe741b66e09b2c$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $0a37df6e7e572621$export$99d02219d259eb94),
    ...$5d365e2adfa4cb4c$exports
};





const $d9738e7eb584218b$export$9ee0f498807aae17 = [
    'activate',
    'mount',
    'update'
];


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $6d69947b539e4168$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;


// Vendored from https://github.com/vuejs/vue/blob/612fb89547711cacb030a3893a0065b785802860/src/core/util/debug.js
// with types only changes.
// The MIT License (MIT)
// Copyright (c) 2013-present, Yuxi (Evan) You
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
const $9104f8f83af2e0ba$var$classifyRE = /(?:^|[-_])(\w)/g;
const $9104f8f83af2e0ba$var$classify = (str)=>str.replace($9104f8f83af2e0ba$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, '');
const $9104f8f83af2e0ba$var$ROOT_COMPONENT_NAME = '<Root>';
const $9104f8f83af2e0ba$var$ANONYMOUS_COMPONENT_NAME = '<Anonymous>';
const $9104f8f83af2e0ba$var$repeat = (str, n)=>{
    // string.repeat() is not supported by IE11, we fall back to just using the string in that case
    // eslint-disable-next-line @sentry-internal/sdk/no-unsupported-es6-methods
    return str.repeat ? str.repeat(n) : str;
};
const $9104f8f83af2e0ba$export$d82a8172625b3af9 = (vm, includeFile)=>{
    if (!vm) return $9104f8f83af2e0ba$var$ANONYMOUS_COMPONENT_NAME;
    if (vm.$root === vm) return $9104f8f83af2e0ba$var$ROOT_COMPONENT_NAME;
    // https://github.com/getsentry/sentry-javascript/issues/5204 $options can be undefined
    if (!vm.$options) return $9104f8f83af2e0ba$var$ANONYMOUS_COMPONENT_NAME;
    const options = vm.$options;
    let name = options.name || options._componentTag;
    const file = options.__file;
    if (!name && file) {
        const match = file.match(/([^/\\]+)\.vue$/);
        if (match) name = match[1];
    }
    return (name ? `<${$9104f8f83af2e0ba$var$classify(name)}>` : $9104f8f83af2e0ba$var$ANONYMOUS_COMPONENT_NAME) + (file && includeFile !== false ? ` at ${file}` : '');
};
const $9104f8f83af2e0ba$export$83873098448601e3 = (vm)=>{
    if (vm && (vm._isVue || vm.__isVue) && vm.$parent) {
        const tree = [];
        let currentRecursiveSequence = 0;
        while(vm){
            if (tree.length > 0) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const last = tree[tree.length - 1];
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                if (last.constructor === vm.constructor) {
                    currentRecursiveSequence++;
                    vm = vm.$parent; // eslint-disable-line no-param-reassign
                    continue;
                } else if (currentRecursiveSequence > 0) {
                    tree[tree.length - 1] = [
                        last,
                        currentRecursiveSequence
                    ];
                    currentRecursiveSequence = 0;
                }
            }
            tree.push(vm);
            vm = vm.$parent; // eslint-disable-line no-param-reassign
        }
        const formattedTree = tree.map((vm, i)=>`${(i === 0 ? '---> ' : $9104f8f83af2e0ba$var$repeat(' ', 5 + i * 2)) + (Array.isArray(vm) ? `${$9104f8f83af2e0ba$export$d82a8172625b3af9(vm[0])}... (${vm[1]} recursive calls)` : $9104f8f83af2e0ba$export$d82a8172625b3af9(vm))}`).join('\n');
        return `\n\nfound in\n\n${formattedTree}`;
    }
    return `\n\n(found in ${$9104f8f83af2e0ba$export$d82a8172625b3af9(vm)})`;
};


const $758d1a52cf2c8172$var$VUE_OP = 'ui.vue';
// Mappings from operation to corresponding lifecycle hook.
const $758d1a52cf2c8172$var$HOOKS = {
    activate: [
        'activated',
        'deactivated'
    ],
    create: [
        'beforeCreate',
        'created'
    ],
    // Vue 3
    unmount: [
        'beforeUnmount',
        'unmounted'
    ],
    // Vue 2
    destroy: [
        'beforeDestroy',
        'destroyed'
    ],
    mount: [
        'beforeMount',
        'mounted'
    ],
    update: [
        'beforeUpdate',
        'updated'
    ]
};
/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */ function $758d1a52cf2c8172$export$a7feb32fdd923295() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $a083afa4ea001828$export$c7be4b0125a10cba)().getTransaction();
}
/** Finish top-level span and activity with a debounce configured using `timeout` option */ function $758d1a52cf2c8172$var$finishRootSpan(vm, timestamp, timeout) {
    if (vm.$_sentryRootSpanTimer) clearTimeout(vm.$_sentryRootSpanTimer);
    vm.$_sentryRootSpanTimer = setTimeout(()=>{
        if (vm.$root && vm.$root.$_sentryRootSpan) {
            vm.$root.$_sentryRootSpan.end(timestamp);
            vm.$root.$_sentryRootSpan = undefined;
        }
    }, timeout);
}
const $758d1a52cf2c8172$export$b7a7e504222a44a3 = (options)=>{
    const hooks = (options.hooks || []).concat((0, $d9738e7eb584218b$export$9ee0f498807aae17))// Removing potential duplicates
    .filter((value, index, self)=>self.indexOf(value) === index);
    const mixins = {};
    for (const operation of hooks){
        // Retrieve corresponding hooks from Vue lifecycle.
        // eg. mount => ['beforeMount', 'mounted']
        const internalHooks = $758d1a52cf2c8172$var$HOOKS[operation];
        if (!internalHooks) {
            (0, $6d69947b539e4168$export$16a28057038b10ef) && (0, $a517e3a601d07c96$export$af88d00dbe7f521).warn(`Unknown hook: ${operation}`);
            continue;
        }
        for (const internalHook of internalHooks)mixins[internalHook] = function() {
            const isRoot = this.$root === this;
            if (isRoot) {
                const activeSpan = (0, $289d2b5ef1bc182e$export$1be426a8e585c83e)();
                if (activeSpan) this.$_sentryRootSpan = this.$_sentryRootSpan || (0, $289d2b5ef1bc182e$export$63dbba021a6b4047)({
                    name: 'Application Render',
                    op: `${$758d1a52cf2c8172$var$VUE_OP}.render`,
                    origin: 'auto.ui.vue'
                });
            }
            // Skip components that we don't want to track to minimize the noise and give a more granular control to the user
            const name = (0, $9104f8f83af2e0ba$export$d82a8172625b3af9)(this, false);
            const shouldTrack = Array.isArray(options.trackComponents) ? options.trackComponents.indexOf(name) > -1 : options.trackComponents;
            // We always want to track root component
            if (!isRoot && !shouldTrack) return;
            this.$_sentrySpans = this.$_sentrySpans || {};
            // Start a new span if current hook is a 'before' hook.
            // Otherwise, retrieve the current span and finish it.
            if (internalHook == internalHooks[0]) {
                const activeSpan = this.$root && this.$root.$_sentryRootSpan || (0, $289d2b5ef1bc182e$export$1be426a8e585c83e)();
                if (activeSpan) {
                    // Cancel old span for this hook operation in case it didn't get cleaned up. We're not actually sure if it
                    // will ever be the case that cleanup hooks re not called, but we had users report that spans didn't get
                    // finished so we finish the span before starting a new one, just to be sure.
                    const oldSpan = this.$_sentrySpans[operation];
                    if (oldSpan) oldSpan.end();
                    this.$_sentrySpans[operation] = (0, $289d2b5ef1bc182e$export$63dbba021a6b4047)({
                        name: `Vue <${name}>`,
                        op: `${$758d1a52cf2c8172$var$VUE_OP}.${operation}`,
                        origin: 'auto.ui.vue'
                    });
                }
            } else {
                // The span should already be added via the first handler call (in the 'before' hook)
                const span = this.$_sentrySpans[operation];
                // The before hook did not start the tracking span, so the span was not added.
                // This is probably because it happened before there is an active transaction
                if (!span) return;
                span.end();
                $758d1a52cf2c8172$var$finishRootSpan(this, (0, $84a662e1e79b3d35$export$ee52dced521e3e18)(), options.timeout);
            }
        };
    }
    return mixins;
};


/**
 * Creates routing instrumentation for Vue Router v2, v3 and v4
 *
 * You can optionally pass in an options object with the available option:
 * * `routeLabel`: Set this to `route` to opt-out of using `route.name` for transaction names.
 *
 * @param router The Vue Router instance that is used
 *
 * @deprecated Use `browserTracingIntegration()` from `@sentry/vue` instead - this includes the vue router instrumentation.
 */ function $e4528a3ad6bc143d$export$3ad36d507c30cc8b(router, options = {}) {
    return (startTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true)=>{
        // We have to start the pageload transaction as early as possible (before the router's `beforeEach` hook
        // is called) to not miss child spans of the pageload.
        // We check that window & window.location exists in order to not run this code in SSR environments.
        if (startTransactionOnPageLoad && (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81) && (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).location) startTransaction({
            name: (0, $c9afe9d8c8ac1088$export$56d8a8a25bd48b81).location.pathname,
            op: 'pageload',
            attributes: {
                [(0, $f0df0dfa824ba468$export$cca8dd30f57f805e)]: 'auto.pageload.vue',
                [(0, $f0df0dfa824ba468$export$d7a7d984b0791405)]: 'url'
            }
        });
        $e4528a3ad6bc143d$export$1f522d947df03db2(router, {
            routeLabel: options.routeLabel || 'name',
            instrumentNavigation: startTransactionOnLocationChange,
            instrumentPageLoad: startTransactionOnPageLoad
        }, startTransaction);
    };
}
/**
 * Instrument the Vue router to create navigation spans.
 */ function $e4528a3ad6bc143d$export$1f522d947df03db2(router, options, startNavigationSpanFn) {
    router.onError((error)=>(0, $a083afa4ea001828$export$f5282963edea4a68)(error, {
            mechanism: {
                handled: false
            }
        }));
    router.beforeEach((to, from, next)=>{
        // According to docs we could use `from === VueRouter.START_LOCATION` but I couldnt get it working for Vue 2
        // https://router.vuejs.org/api/#router-start-location
        // https://next.router.vuejs.org/api/#start-location
        // from.name:
        // - Vue 2: null
        // - Vue 3: undefined
        // hence only '==' instead of '===', because `undefined == null` evaluates to `true`
        const isPageLoadNavigation = from.name == null && from.matched.length === 0;
        const attributes = {
            [(0, $f0df0dfa824ba468$export$cca8dd30f57f805e)]: 'auto.navigation.vue'
        };
        for (const key of Object.keys(to.params))attributes[`params.${key}`] = to.params[key];
        for (const key of Object.keys(to.query)){
            const value = to.query[key];
            if (value) attributes[`query.${key}`] = value;
        }
        // Determine a name for the routing transaction and where that name came from
        let transactionName = to.path;
        let transactionSource = 'url';
        if (to.name && options.routeLabel !== 'path') {
            transactionName = to.name.toString();
            transactionSource = 'custom';
        } else if (to.matched[0] && to.matched[0].path) {
            transactionName = to.matched[0].path;
            transactionSource = 'route';
        }
        if (options.instrumentPageLoad && isPageLoadNavigation) {
            // eslint-disable-next-line deprecation/deprecation
            const pageloadTransaction = (0, $758d1a52cf2c8172$export$a7feb32fdd923295)();
            if (pageloadTransaction) {
                const existingAttributes = (0, $aab2fced71923915$export$92d8c23565496537)(pageloadTransaction).data || {};
                if (existingAttributes[0, $f0df0dfa824ba468$export$d7a7d984b0791405] !== 'custom') {
                    pageloadTransaction.updateName(transactionName);
                    pageloadTransaction.setAttribute((0, $f0df0dfa824ba468$export$d7a7d984b0791405), transactionSource);
                }
                // Set router attributes on the existing pageload transaction
                // This will  the origin, and add params & query attributes
                pageloadTransaction.setAttributes({
                    ...attributes,
                    [(0, $f0df0dfa824ba468$export$cca8dd30f57f805e)]: 'auto.pageload.vue'
                });
            }
        }
        if (options.instrumentNavigation && !isPageLoadNavigation) {
            attributes[0, $f0df0dfa824ba468$export$d7a7d984b0791405] = transactionSource;
            startNavigationSpanFn({
                name: transactionName,
                op: 'navigation',
                attributes: attributes
            });
        }
        // Vue Router 4 no longer exposes the `next` function, so we need to
        // check if it's available before calling it.
        // `next` needs to be called in Vue Router 3 so that the hook is resolved.
        if (next) next();
    });
}


// The following type is an intersection of the Route type from VueRouter v2, v3, and v4.
// This is not great, but kinda necessary to make it work with all versions at the same time.
/**
 * A custom BrowserTracing integration for Vue.
 */ function $393af830587d6220$export$b4109253475213e9(options = {}) {
    // If router is not passed, we just use the normal implementation
    if (!options.router) return (0, $d6a6fa6ad076011d$export$b4109253475213e9)(options);
    const integration = (0, $d6a6fa6ad076011d$export$b4109253475213e9)({
        ...options,
        instrumentNavigation: false
    });
    const { router: router, instrumentNavigation: instrumentNavigation = true, instrumentPageLoad: instrumentPageLoad = true, routeLabel: routeLabel = 'name' } = options;
    return {
        ...integration,
        afterAllSetup (client) {
            integration.afterAllSetup(client);
            const startNavigationSpan = (options)=>{
                (0, $d6a6fa6ad076011d$export$7d159749bd9969ad)(client, options);
            };
            (0, $e4528a3ad6bc143d$export$1f522d947df03db2)(router, {
                routeLabel: routeLabel,
                instrumentNavigation: instrumentNavigation,
                instrumentPageLoad: instrumentPageLoad
            }, startNavigationSpan);
        }
    };
}








const $dcce06aa0e4a3279$export$7c9633ecb845dba0 = (app, options)=>{
    const { errorHandler: errorHandler, warnHandler: warnHandler, silent: silent } = app.config;
    app.config.errorHandler = (error, vm, lifecycleHook)=>{
        const componentName = (0, $9104f8f83af2e0ba$export$d82a8172625b3af9)(vm, false);
        const trace = vm ? (0, $9104f8f83af2e0ba$export$83873098448601e3)(vm) : '';
        const metadata = {
            componentName: componentName,
            lifecycleHook: lifecycleHook,
            trace: trace
        };
        if (options.attachProps && vm) {
            // Vue2 - $options.propsData
            // Vue3 - $props
            if (vm.$options && vm.$options.propsData) metadata.propsData = vm.$options.propsData;
            else if (vm.$props) metadata.propsData = vm.$props;
        }
        // Capture exception in the next event loop, to make sure that all breadcrumbs are recorded in time.
        setTimeout(()=>{
            (0, $a083afa4ea001828$export$f5282963edea4a68)(error, {
                captureContext: {
                    contexts: {
                        vue: metadata
                    }
                },
                mechanism: {
                    handled: false
                }
            });
        });
        if (typeof errorHandler === 'function') errorHandler.call(app, error, vm, lifecycleHook);
        if (options.logErrors) {
            const hasConsole = typeof console !== 'undefined';
            const message = `Error in ${lifecycleHook}: "${error && error.toString()}"`;
            if (warnHandler) warnHandler.call(null, message, vm, trace);
            else if (hasConsole && !silent) (0, $a517e3a601d07c96$export$cda52e2a8927a2ca)(()=>{
                // eslint-disable-next-line no-console
                console.error(`[Vue warn]: ${message}${trace}`);
            });
        }
    };
};



const $a13acc602403c325$var$globalWithVue = (0, $0b080c13a84f32b4$export$f1a6cdb1459e81d1);
const $a13acc602403c325$var$DEFAULT_CONFIG = {
    Vue: $a13acc602403c325$var$globalWithVue.Vue,
    attachProps: true,
    logErrors: true,
    hooks: (0, $d9738e7eb584218b$export$9ee0f498807aae17),
    timeout: 2000,
    trackComponents: false
};
const $a13acc602403c325$var$INTEGRATION_NAME = 'Vue';
const $a13acc602403c325$var$_vueIntegration = (integrationOptions = {})=>{
    return {
        name: $a13acc602403c325$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            $a13acc602403c325$var$_setupIntegration(client, integrationOptions);
        }
    };
};
const $a13acc602403c325$export$9a1c8cf2dd242ec3 = (0, $d2899dae8d5c278c$export$2323046b9414659f)($a13acc602403c325$var$_vueIntegration);
/**
 * Initialize Vue error & performance tracking.
 *
 * @deprecated Use `vueIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $a13acc602403c325$export$3e6359b2ac68015a = (0, $d2899dae8d5c278c$export$afa219bf23651160)($a13acc602403c325$var$INTEGRATION_NAME, $a13acc602403c325$export$9a1c8cf2dd242ec3);
function $a13acc602403c325$var$_setupIntegration(client, integrationOptions) {
    const options = {
        ...$a13acc602403c325$var$DEFAULT_CONFIG,
        ...client.getOptions(),
        ...integrationOptions
    };
    if (!options.Vue && !options.app) {
        (0, $a517e3a601d07c96$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn(`[@sentry/vue]: Misconfigured SDK. Vue specific errors will not be captured.
Update your \`Sentry.init\` call with an appropriate config option:
\`app\` (Application Instance - Vue 3) or \`Vue\` (Vue Constructor - Vue 2).`);
        });
        return;
    }
    if (options.app) {
        const apps = (0, $16658314f19f2667$export$3131421a7d01b4fb)(options.app);
        apps.forEach((app)=>$a13acc602403c325$var$vueInit(app, options));
    } else if (options.Vue) $a13acc602403c325$var$vueInit(options.Vue, options);
}
const $a13acc602403c325$var$vueInit = (app, options)=>{
    // Check app is not mounted yet - should be mounted _after_ init()!
    // This is _somewhat_ private, but in the case that this doesn't exist we simply ignore it
    // See: https://github.com/vuejs/core/blob/eb2a83283caa9de0a45881d860a3cbd9d0bdd279/packages/runtime-core/src/component.ts#L394
    const appWithInstance = app;
    const isMounted = appWithInstance._instance && appWithInstance._instance.isMounted;
    if (isMounted === true) (0, $a517e3a601d07c96$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn('[@sentry/vue]: Misconfigured SDK. Vue app is already mounted. Make sure to call `app.mount()` after `Sentry.init()`.');
    });
    (0, $dcce06aa0e4a3279$export$7c9633ecb845dba0)(app, options);
    if ((0, $94ef1ac47039d105$export$5008da00b1b6dee6)(options)) app.mixin((0, $758d1a52cf2c8172$export$b7a7e504222a44a3)({
        ...options,
        ...options.tracingOptions
    }));
};


/**
 * Inits the Vue SDK
 */ function $d1eb96ea898d2bfd$export$2cd8252107eb640b(config = {}) {
    const options = {
        _metadata: {
            sdk: {
                name: 'sentry.javascript.vue',
                packages: [
                    {
                        name: 'npm:@sentry/vue',
                        version: (0, $142b56b04b94e12c$export$31499a9cd224b78c)
                    }
                ],
                version: (0, $142b56b04b94e12c$export$31499a9cd224b78c)
            }
        },
        defaultIntegrations: [
            ...(0, $f0865bfe40ae41c1$export$5783b2920b1d62b9)(config),
            (0, $a13acc602403c325$export$9a1c8cf2dd242ec3)()
        ],
        ...config
    };
    (0, $f0865bfe40ae41c1$export$2cd8252107eb640b)(options);
}


function $621b0451e82cd884$export$2e2bcd8739ae039(app, router) {
    $d1eb96ea898d2bfd$export$2cd8252107eb640b({
        app: app,
        dsn: document.body.dataset.sentryDsn,
        environment: document.body.dataset.sentryEnvironment,
        release: document.body.dataset.sentryRelease,
        integrations: [
            $393af830587d6220$export$b4109253475213e9({
                router: router,
                routeLabel: "path",
                tracingOrigins: [
                    window.location.host,
                    /^\//
                ]
            })
        ],
        tracesSampleRate: 1.0
    });
}


parcelRequire("6r9FW");
var $jH5uA = parcelRequire("jH5uA");
/*!
 /**
  * vuex-router-sync v6.0.0-rc.1
  * (c) 2021 Evan You
  * @license MIT
  */ function $fe9b128999fdabf0$export$92d6409d68f0739a(store, router, options) {
    const moduleName = (options || {}).moduleName || 'route';
    store.registerModule(moduleName, {
        namespaced: true,
        state: $fe9b128999fdabf0$var$cloneRoute(router.currentRoute.value),
        mutations: {
            ROUTE_CHANGED (_state, transition) {
                store.state[moduleName] = $fe9b128999fdabf0$var$cloneRoute(transition.to, transition.from);
            }
        }
    });
    let isTimeTraveling = false;
    let currentPath;
    // sync router on store change
    const storeUnwatch = store.watch((state)=>state[moduleName], (route)=>{
        const { fullPath: fullPath } = route;
        if (fullPath === currentPath) return;
        if (currentPath != null) {
            isTimeTraveling = true;
            router.push(route);
        }
        currentPath = fullPath;
    }, {
        flush: 'sync'
    });
    // sync store on router navigation
    const afterEachUnHook = router.afterEach((to, from)=>{
        if (isTimeTraveling) {
            isTimeTraveling = false;
            return;
        }
        currentPath = to.fullPath;
        store.commit(moduleName + '/ROUTE_CHANGED', {
            to: to,
            from: from
        });
    });
    return function unsync() {
        // remove router hook
        afterEachUnHook();
        // remove store watch
        storeUnwatch();
        // unregister Module with store
        store.unregisterModule(moduleName);
    };
}
function $fe9b128999fdabf0$var$cloneRoute(to, from) {
    const clone = {
        name: to.name,
        path: to.path,
        hash: to.hash,
        query: to.query,
        params: to.params,
        fullPath: to.fullPath,
        meta: to.meta
    };
    if (from) clone.from = $fe9b128999fdabf0$var$cloneRoute(from);
    return Object.freeze(clone);
}




let $0f20295978ad951f$var$script;



let $0f20295978ad951f$var$initialize = ()=>{
    $0f20295978ad951f$var$script = (parcelRequire("82SML"));
    if ($0f20295978ad951f$var$script.__esModule) $0f20295978ad951f$var$script = $0f20295978ad951f$var$script.default;
    $0f20295978ad951f$var$script.render = (parcelRequire("fVgfX")).render;
    (parcelRequire("bqxl0")).default($0f20295978ad951f$var$script);
    $0f20295978ad951f$var$script.__scopeId = 'data-v-54fe08';
    $0f20295978ad951f$var$script.__file = "App.vue";
};
$0f20295978ad951f$var$initialize();
var $0f20295978ad951f$export$2e2bcd8739ae039 = $0f20295978ad951f$var$script;



var $9SOcs = parcelRequire("9SOcs");

var $14ltf = parcelRequire("14ltf");
// Auto-track `router.currentRoute` as `store.state.route`.
(0, $fe9b128999fdabf0$export$92d6409d68f0739a)((0, $14ltf.default), (0, $9SOcs.default));
const $99a4aeafe941e1a5$var$app = (0, $jH5uA.createApp)((0, $0f20295978ad951f$export$2e2bcd8739ae039));
(0, $621b0451e82cd884$export$2e2bcd8739ae039)($99a4aeafe941e1a5$var$app, (0, $9SOcs.default));
$99a4aeafe941e1a5$var$app.use((0, $9SOcs.default)).use((0, $14ltf.default)).mount("#app");

})();
//# sourceMappingURL=main.js.map
